document.portalInfo = '20.0.2505.0 | 4/23/2025 9:09:29 AM';

(function () {
    var cacheBusterHeaders = {
        'If-Modified-Since': 'Mon, 26 Jul 1997 05:00:00 GMT',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache'
    };

    function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1);
            if (c.indexOf(name) != -1) return c.substring(name.length, c.length);
        }
        return "";
    }

    function setCsrfTokenHeader() {
        var cookieValue = getCookie("XSRF-TOKEN");
        cacheBusterHeaders['X-XSRF-TOKEN'] = cookieValue;
    }

    /*jshint -W082*/
    if (!isLoginPage()) {
        setCsrfTokenHeader();

        loadCriticalData().then(function (criticalData) {
            angular.module('customer.core').value('resources', criticalData.resources);
            angular.module('customer').value('currentUser', criticalData.currentUser);

            var loadData = criticalData.currentUser.HasAdministrativeRights ? loadAdministratorData : loadCustomerData;
            var loadedData = { menuItems: [], portalModules: {}, generalSettings: {}, photoSettings: {}, toastrEnabled: false };
            var portalDown = true;

            loadData()
                .then(function (data) {
                    loadedData = data;
                    portalDown = false;
                }, function (error) {
                    console.log(error);
                })
                .always(function () {
                    angular.module('customer.core').value('portalDown', portalDown);
                    angular.module('customer.core').value('portalModules', { data: loadedData.portalModules });
                    angular.module('customer.core').value('generalSettings', loadedData.generalSettings);
                    angular.module('customer.core').value('photoSettings', loadedData.photoSettings);
                    angular.module('customer.core').value('toastrEnabled', loadedData.toastrEnabled);
                    angular.module('customer').value('menuItems', loadedData.menuItems);
                    angular.bootstrap(document, ['customer', 'angulartics', 'angulartics.google.analytics']);
                });
        }, function () {
            console.log("Unable to load critical data. The application will not be bootstrapped.");
        });
    } else {
        $.when(resourcesAjaxRequest())
         .then(function (resources) {
             angular.module('customer.core').value('resources', resources);
             angular.module('customer.core').value('toastrEnabled', false);
             angular.bootstrap(document, ['customer.core']);
         });
    }

    function loadCriticalData() {
        var deferred = $.Deferred();

        $.when(resourcesAjaxRequest(), currentUserAjaxRequest())
            .then(function (resourcesArray, currentUserArray) {
                if (!resourcesArray || !resourcesArray[0]) {
                    return deferred.reject("Unable to load the resources");
                }

                if (!currentUserArray || !currentUserArray[0] || !currentUserArray[0].data) {
                    return deferred.reject("Unable to load the current user");
                }

                deferred.resolve({ resources: resourcesArray[0], currentUser: currentUserArray[0].data });
            }, function () {
                deferred.reject("Unable to load critical data");
            });

        return deferred.promise();
    }

    function loadAdministratorData() {
        var deferred = $.Deferred();

        $.when(menuItemsAjaxRequest(), toastrEnabledAjaxRequest())
            .then(function (menuItemsArray, toastrEnabledArray) {
                if (!menuItemsArray || !menuItemsArray[0]) {
                    return deferred.reject("Unable to load the menu items");
                }

                deferred.resolve({
                    menuItems: menuItemsArray[0],
                    portalModules: {},
                    toastrEnabled: toastrEnabledArray && !toastrEnabledArray[0] ? toastrEnabledArray[0] : false,
                });
            }, function () {
                deferred.reject("Unable to load administrator data");
            });

        return deferred.promise();
    }

    function loadCustomerData() {
        var deferred = $.Deferred();

        $.when(menuItemsAjaxRequest(), customerPortalSettingsAjaxRequest(), toastrEnabledAjaxRequest())
            .then(function (menuItemsArray, customerPortalSettingsArray, toastrEnabledArray) {
                if (!menuItemsArray || !menuItemsArray[0]) {
                    return deferred.reject("Unable to load the menu items");
                }

                if (!customerPortalSettingsArray || !customerPortalSettingsArray[0] || !customerPortalSettingsArray[0].data) {
                    return deferred.reject("Unable to load the customer portal settings");
                }

                var settings = customerPortalSettingsArray[0].data;
                if (!settings.GeneralSettings) {
                    return deferred.reject("Unable to load the general settings");
                }

                if (!settings.CustomerPortalModules) {
                    return deferred.reject("Unable to load the customer portal modules");
                }

                deferred.resolve({
                    menuItems: menuItemsArray[0],
                    portalModules: settings.CustomerPortalModules,
                    generalSettings: settings.GeneralSettings,
                    photoSettings: settings.PhotoSettings,
                    toastrEnabled: toastrEnabledArray && !toastrEnabledArray[0] ? toastrEnabledArray[0] : false,
                });
            }, function () {
                deferred.reject("Unable to load customer data");
            });

        return deferred.promise();
    }

    function isLoginPage() {
        return $("[data-login]").length > 0;
    }

    function resourcesAjaxRequest() {
        return $.ajax({
            url: '/open/resources',
            type: 'GET',
            headers: cacheBusterHeaders
        });
    }

    function menuItemsAjaxRequest() {
        var cookieValue = getCookie("XSRF-TOKEN");
        return $.ajax({
            url: '/api/menu/menuitems',
            type: 'GET',
            headers: cacheBusterHeaders
        });
    }

    function customerPortalSettingsAjaxRequest() {
        return $.ajax({
            url: '/api/settings',
            type: 'GET',
            headers: cacheBusterHeaders
        });
    }

    function toastrEnabledAjaxRequest() {
        return $.ajax({
            url: '/api/settings/toastrenabled',
            type: 'GET',
            headers: cacheBusterHeaders
        });
    }

    function currentUserAjaxRequest() {
        return $.ajax({
            url: '/api/usermanagement/current',
            type: 'GET',
            headers: cacheBusterHeaders
        });
    }
})();
(function () {
    'use strict';
    angular.module("ngLocale", [], ["$provide", function($provide) {
    var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
    function getDecimals(n) {
      n = n + '';
      var i = n.indexOf('.');
      return (i == -1) ? 0 : n.length - i - 1;
    }

    function getVF(n, opt_precision) {
      var v = opt_precision;

      if (undefined === v) {
        v = Math.min(getDecimals(n), 3);
      }

      var base = Math.pow(10, v);
      var f = ((n * base) | 0) % base;
      return {v: v, f: f};
    }

    $provide.value("$locale", {
      "DATETIME_FORMATS": {
        "AMPMS": [
          "a.m.",
          "p.m."
        ],
        "DAY": [
          "zondag",
          "maandag",
          "dinsdag",
          "woensdag",
          "donderdag",
          "vrijdag",
          "zaterdag"
        ],
        "ERANAMES": [
          "voor Christus",
          "na Christus"
        ],
        "ERAS": [
          "v.Chr.",
          "n.Chr."
        ],
        "FIRSTDAYOFWEEK": 0,
        "MONTH": [
          "januari",
          "februari",
          "maart",
          "april",
          "mei",
          "juni",
          "juli",
          "augustus",
          "september",
          "oktober",
          "november",
          "december"
        ],
        "SHORTDAY": [
          "zo",
          "ma",
          "di",
          "wo",
          "do",
          "vr",
          "za"
        ],
        "SHORTMONTH": [
          "jan.",
          "feb.",
          "mrt.",
          "apr.",
          "mei",
          "jun.",
          "jul.",
          "aug.",
          "sep.",
          "okt.",
          "nov.",
          "dec."
        ],
        "WEEKENDRANGE": [
          5,
          6
        ],
        "fullDate": "EEEE d MMMM y",
        "longDate": "d MMMM y",
        "medium": "d MMM y HH:mm:ss",
        "mediumDate": "d MMM y",
        "mediumTime": "HH:mm:ss",
        "short": "dd-MM-yy HH:mm",
        "shortDate": "dd-MM-yy",
        "shortTime": "HH:mm"
      },
      "NUMBER_FORMATS": {
        "CURRENCY_SYM": "\u20ac",
        "DECIMAL_SEP": ",",
        "GROUP_SEP": ".",
        "PATTERNS": [
          {
            "gSize": 3,
            "lgSize": 3,
            "maxFrac": 3,
            "minFrac": 0,
            "minInt": 1,
            "negPre": "-",
            "negSuf": "",
            "posPre": "",
            "posSuf": ""
          },
          {
            "gSize": 3,
            "lgSize": 3,
            "maxFrac": 2,
            "minFrac": 2,
            "minInt": 1,
            "negPre": "\u00a4\u00a0-",
            "negSuf": "",
            "posPre": "\u00a4\u00a0",
            "posSuf": ""
          }
        ]
      },
      "id": "nl-nl",
      "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v === 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
    });
    }]);

})();
(function() {
    // DEDV-8694 fixes for Apple devices
    $(document).ready(function () {
        var userAgent = window.navigator.userAgent;

        if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
            $("div.container-fluid-max").on('click', 'tr.accordion-toggle', function () {
                $($(this).data('target')).collapse('toggle');
            });
        }
    });
})();
(function () {
    'use strict';

    angular
        .module('customer', [
            // Angular modules 
            'ngMessages',
            'ngSanitize',


            // Custom modules 
            'customer.core',
            'customer.contact',
            'customer.chatWrapper',
            'customer.search',
            'customer.menu',
            'customer.footer',
            'customer.myPayments',
            'customer.home',
            'customer.myDetails',
            'customer.myContracts',
            'customer.myHousehold',
            'customer.changePassword',
            'customer.myRepairments',
            'customer.newRepairment',
            'customer.news',
            'customer.newsDetails',
            'customer.myTimeline',
            'customer.newTimelineAction',
            'customer.customerQuestion',
            'customer.knowledgebase',
            'customer.userManagement',
            'customer.myDocuments',
            'customer.contractTermination',
            'customer.paymentArrangement',
            'customer.portalDown',
            'customer.styleManagement',
            'customer.resourcesManagement',
            'customer.emailTemplatesManagement',
            'customer.network',
            'customer.accountRequests',
            'customer.portalSettings',
            'customer.pageNotFound',  // !! This has to be the last module added. Everything added after this one wil result in a *page not found*.

            // 3rd Party Modules,
            'color.picker',
            'ng-showdown',
            'purplefox.numeric'
        ])
        .run(routeInterceptor)
        .run(unauthorizedHandler);

    routeInterceptor.$inject = ['$rootScope', '$state', 'localize', 'alerting', 'menuItems', 'portalModules', 'portalDown'];

    function routeInterceptor($rootScope, $state, localize, alerting, menuItems, portalModules, portalDown) {
        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            if (portalDown) {
                if (toState.name !== "portalDown") {
                    event.preventDefault();
                    $state.go('portalDown', {}, { location: false });
                }
                
                return;
            }

            if (shouldRestrictAccess(toState.name, menuItems) || portalModuleDisabled(toState.portalModule, portalModules)) {
                // restrict access
                event.preventDefault();

                if (toState.url != "/") {
                    var callback = function () {
                        redirectToTheFirstAvailablePage($state, menuItems, portalModules);
                    };
                    displayAccessUnauthorizedMessage($rootScope, localize, alerting, callback, callback);
                } else {
                    redirectToTheFirstAvailablePage($state, menuItems, portalModules);
                }
            }
        });
    }

    function portalModuleDisabled(portalModule, portalModules) {
        if (portalModule && !portalModules.data[portalModule]) {
            return true;
        }
        return false;
    }

    function shouldRestrictAccess(destinationState, menuItems) {
        for (var i = 0; i < menuItems.length; i++) {
            var element = menuItems[i];
            if (element.StateReference == destinationState)
                return false;
        }

        return true;
    }

    function getFirstAvailablePage(menuItems, portalModules) {
        for (var i = 0; i < menuItems.length; i++) {
            var element = menuItems[i];
            if (element.IsSidebarItem && !portalModuleDisabled(element.CustomerPortalModule, portalModules))
                return element;
        }

        return null;
    }

    function redirectToTheFirstAvailablePage($state, menuItems, portalModules) {
        var firstPage = getFirstAvailablePage(menuItems, portalModules);
        if (firstPage !== null) {
            $state.transitionTo(firstPage.StateReference);
        }
    }

    function displayAccessUnauthorizedMessage($rootScope, localize, alerting, successCallback, errorCallback) {
        var title = localize.getLocalizedString('Title', 'Error');
        var message = localize.getLocalizedString('AccessUnauthorized', 'Error');
        alerting
            .popError(message, title)
            .then(successCallback)
            .catch(errorCallback);
    }

    unauthorizedHandler.$inject = ['$rootScope', '$state', 'localize', 'alerting', 'menuItems', 'portalModules'];

    function unauthorizedHandler($rootScope, $state, localize, alerting, menuItems, portalModules) {
        var callback = function () {
            redirectToTheFirstAvailablePage($state, menuItems, portalModules);
        };

        $rootScope.$on('customerPortalUnauthorizedAccess', function () {
            displayAccessUnauthorizedMessage($rootScope, localize, alerting, callback, callback);
        });
    }
})();
var customer;
(function (customer) {
    var accountRequests;
    (function (accountRequests) {
        angular.module('customer.accountRequests', []);
    })(accountRequests = customer.accountRequests || (customer.accountRequests = {}));
})(customer || (customer = {}));
//# sourceMappingURL=accountRequests.module.js.map
var customer;
(function (customer) {
    var changePassword;
    (function (changePassword) {
        angular.module('customer.changePassword', []);
    })(changePassword = customer.changePassword || (customer.changePassword = {}));
})(customer || (customer = {}));
//# sourceMappingURL=changePassword.module.js.map
var customer;
(function (customer) {
    var chatWrapper;
    (function (chatWrapper) {
        angular.module('customer.chatWrapper', []);
    })(chatWrapper = customer.chatWrapper || (customer.chatWrapper = {}));
})(customer || (customer = {}));
//# sourceMappingURL=chatWrapper.module.js.map
var customer;
(function (customer) {
    var contact;
    (function (contact) {
        angular.module('customer.contact', []);
    })(contact = customer.contact || (customer.contact = {}));
})(customer || (customer = {}));
//# sourceMappingURL=contact.module.js.map
var customer;
(function (customer) {
    var contractTermination;
    (function (contractTermination) {
        angular
            .module('customer.contractTermination', []);
    })(contractTermination = customer.contractTermination || (customer.contractTermination = {}));
})(customer || (customer = {}));
//# sourceMappingURL=contractTermination.module.js.map
(function () {
    'use strict';

    angular.module('customer.core', [
        /*
         * Angular modules
         */

        /*
         * Our reusable cross app code modules
         */
        'ui.router',
        'ui.bootstrap',

        /*
         * 3rd Party modules
         */
        'ngAnimate',
        'toastr',
        'infinite-scroll',
        'angular-loading-bar'
    ]);
})();

var customer;
(function (customer) {
    var customerQuestion;
    (function (customerQuestion) {
        angular.module('customer.customerQuestion', []);
    })(customerQuestion = customer.customerQuestion || (customer.customerQuestion = {}));
})(customer || (customer = {}));
//# sourceMappingURL=customerQuestion.module.js.map
var customer;
(function (customer) {
    var emailTemplatesManagement;
    (function (emailTemplatesManagement) {
        angular.module('customer.emailTemplatesManagement', []);
    })(emailTemplatesManagement = customer.emailTemplatesManagement || (customer.emailTemplatesManagement = {}));
})(customer || (customer = {}));
//# sourceMappingURL=emailTemplatesManagement.module.js.map
var customer;
(function (customer) {
    var footer;
    (function (footer) {
        angular.module('customer.footer', []);
    })(footer = customer.footer || (customer.footer = {}));
})(customer || (customer = {}));
//# sourceMappingURL=footer.module.js.map
var customer;
(function (customer) {
    var home;
    (function (home) {
        angular.module('customer.home', [
            'ngCookies'
        ]);
    })(home = customer.home || (customer.home = {}));
})(customer || (customer = {}));
//# sourceMappingURL=home.module.js.map
var customer;
(function (customer) {
    var knowledgebase;
    (function (knowledgebase) {
        angular.module('customer.knowledgebase', []);
    })(knowledgebase = customer.knowledgebase || (customer.knowledgebase = {}));
})(customer || (customer = {}));
//# sourceMappingURL=knowledgebase.module.js.map
var customer;
(function (customer) {
    var menu;
    (function (menu) {
        angular.module('customer.menu', []);
    })(menu = customer.menu || (customer.menu = {}));
})(customer || (customer = {}));
//# sourceMappingURL=menu.module.js.map
var customer;
(function (customer) {
    var myContracts;
    (function (myContracts) {
        angular.module('customer.myContracts', [
            'ngFileSaver'
        ]);
    })(myContracts = customer.myContracts || (customer.myContracts = {}));
})(customer || (customer = {}));
//# sourceMappingURL=myContracts.module.js.map
var customer;
(function (customer) {
    var myDetails;
    (function (myDetails) {
        angular.module('customer.myDetails', []);
    })(myDetails = customer.myDetails || (customer.myDetails = {}));
})(customer || (customer = {}));
//# sourceMappingURL=myDetails.module.js.map
var customer;
(function (customer) {
    var myDocuments;
    (function (myDocuments) {
        angular.module('customer.myDocuments', []);
    })(myDocuments = customer.myDocuments || (customer.myDocuments = {}));
})(customer || (customer = {}));
//# sourceMappingURL=myDocuments.module.js.map
var customer;
(function (customer) {
    var myHousehold;
    (function (myHousehold) {
        angular.module('customer.myHousehold', []);
    })(myHousehold = customer.myHousehold || (customer.myHousehold = {}));
})(customer || (customer = {}));
//# sourceMappingURL=myHousehold.module.js.map
var customer;
(function (customer) {
    var myPayments;
    (function (myPayments) {
        angular.module('customer.myPayments', []);
    })(myPayments = customer.myPayments || (customer.myPayments = {}));
})(customer || (customer = {}));
//# sourceMappingURL=myPayments.module.js.map
var customer;
(function (customer) {
    var myRepairments;
    (function (myRepairments) {
        angular.module('customer.myRepairments', []);
    })(myRepairments = customer.myRepairments || (customer.myRepairments = {}));
})(customer || (customer = {}));
//# sourceMappingURL=myRepairments.module.js.map
var customer;
(function (customer) {
    var myTimeline;
    (function (myTimeline) {
        angular.module('customer.myTimeline', []);
    })(myTimeline = customer.myTimeline || (customer.myTimeline = {}));
})(customer || (customer = {}));
//# sourceMappingURL=myTimeline.module.js.map
var customer;
(function (customer) {
    var network;
    (function (network) {
        angular.module('customer.network', []);
    })(network = customer.network || (customer.network = {}));
})(customer || (customer = {}));
//# sourceMappingURL=network.module.js.map
var customer;
(function (customer) {
    var newRepairment;
    (function (newRepairment) {
        angular.module('customer.newRepairment', []);
    })(newRepairment = customer.newRepairment || (customer.newRepairment = {}));
})(customer || (customer = {}));
//# sourceMappingURL=newRepairment.module.js.map
var customer;
(function (customer) {
    var newTimelineAction;
    (function (newTimelineAction) {
        angular.module('customer.newTimelineAction', []);
    })(newTimelineAction = customer.newTimelineAction || (customer.newTimelineAction = {}));
})(customer || (customer = {}));
//# sourceMappingURL=newTimelineAction.module.js.map
var customer;
(function (customer) {
    var news;
    (function (news) {
        angular.module('customer.news', []);
    })(news = customer.news || (customer.news = {}));
})(customer || (customer = {}));
//# sourceMappingURL=news.module.js.map
var customer;
(function (customer) {
    var newsDetails;
    (function (newsDetails) {
        angular.module('customer.newsDetails', []);
    })(newsDetails = customer.newsDetails || (customer.newsDetails = {}));
})(customer || (customer = {}));
//# sourceMappingURL=newsDetails.module.js.map
var customer;
(function (customer) {
    var pageNotFound;
    (function (pageNotFound) {
        angular.module('customer.pageNotFound', []);
    })(pageNotFound = customer.pageNotFound || (customer.pageNotFound = {}));
})(customer || (customer = {}));
//# sourceMappingURL=pageNotFound.module.js.map
var customer;
(function (customer) {
    var paymentArrangement;
    (function (paymentArrangement) {
        angular.module('customer.paymentArrangement', []);
    })(paymentArrangement = customer.paymentArrangement || (customer.paymentArrangement = {}));
})(customer || (customer = {}));
//# sourceMappingURL=paymentArrangement.module.js.map
var customer;
(function (customer) {
    var portalDown;
    (function (portalDown) {
        angular.module('customer.portalDown', []);
    })(portalDown = customer.portalDown || (customer.portalDown = {}));
})(customer || (customer = {}));
//# sourceMappingURL=portalDown.module.js.map
var customer;
(function (customer) {
    var portalSettings;
    (function (portalSettings) {
        angular.module('customer.portalSettings', []);
    })(portalSettings = customer.portalSettings || (customer.portalSettings = {}));
})(customer || (customer = {}));
//# sourceMappingURL=portalSettings.module.js.map
var customer;
(function (customer) {
    var resourcesManagement;
    (function (resourcesManagement) {
        angular.module('customer.resourcesManagement', []);
    })(resourcesManagement = customer.resourcesManagement || (customer.resourcesManagement = {}));
})(customer || (customer = {}));
//# sourceMappingURL=resourcesManagement.module.js.map
var customer;
(function (customer) {
    var search;
    (function (search) {
        angular.module('customer.search', []);
    })(search = customer.search || (customer.search = {}));
})(customer || (customer = {}));
//# sourceMappingURL=search.module.js.map
var customer;
(function (customer) {
    var styleManagement;
    (function (styleManagement) {
        angular.module('customer.styleManagement', []);
    })(styleManagement = customer.styleManagement || (customer.styleManagement = {}));
})(customer || (customer = {}));
//# sourceMappingURL=styleManagement.module.js.map
var customer;
(function (customer) {
    var userManagement;
    (function (userManagement) {
        angular.module('customer.userManagement', []);
    })(userManagement = customer.userManagement || (customer.userManagement = {}));
})(customer || (customer = {}));
//# sourceMappingURL=userManagement.module.js.map
var core;
(function (core) {
    var services;
    (function (services) {
        var contractService = (function () {
            function contractService(dataservice, $q) {
                this.dataservice = dataservice;
                this.$q = $q;
                this.customerDetails = null;
            }
            contractService.prototype.getCustomerDetails = function () {
                var _this = this;
                if (this.customerDetails) {
                    return this.$q(function (resolve) {
                        var result = JSON.parse(JSON.stringify(_this.customerDetails));
                        resolve(result);
                    });
                }
                else {
                    return this.dataservice.getData('/api/customer/details').then(function (data) {
                        _this.customerDetails = data;
                        var result = JSON.parse(JSON.stringify(_this.customerDetails));
                        return result;
                    });
                }
            };
            contractService.prototype.refreshCustomerDetails = function () {
                this.customerDetails = null;
                return this.getCustomerDetails();
            };
            contractService.prototype.getContractDocuments = function (contract) {
                if (contract.Documents) {
                    return this.$q(function (resolve) {
                        var result = JSON.parse(JSON.stringify(contract.Documents));
                        resolve(result);
                    });
                }
                else {
                    var url = '/api/document/contract/' + contract.CompanyName + '?realtyObjectNo=' + contract.RentalUnit.No;
                    return this.dataservice.getData(url).then(function (data) {
                        if (data.success === true) {
                            contract.Documents = data;
                        }
                        var result = JSON.parse(JSON.stringify(data));
                        return result;
                    });
                }
            };
            contractService.prototype.isCustomerNumberValid = function (customerNumber) {
                var url = '/api/customer/iscustomernumbervalid/?customernumber=' + customerNumber;
                return this.dataservice.getData(url).then(function (response) {
                    return response;
                });
            };
            contractService.prototype.isWorkingDay = function (year, month, day) {
                var url = '/api/customer/isworkingday/' + year + '/' + month + '/' + day;
                return this.dataservice.getData(url).then(function (data) {
                    return data;
                });
            };
            return contractService;
        }());
        services.contractService = contractService;
        angular
            .module('customer.core')
            .service('contractService', contractService);
    })(services = core.services || (core.services = {}));
})(core || (core = {}));
//# sourceMappingURL=contract.service.js.map
var core;
(function (core) {
    var services;
    (function (services) {
        var outstandingBalanceService = (function () {
            function outstandingBalanceService(dataservice, $q) {
                this.dataservice = dataservice;
                this.$q = $q;
                this.outstandingBalance = null;
                this.$inject = ['dataservice', '$q'];
            }
            outstandingBalanceService.prototype.getOutstandingBalance = function () {
                var _this = this;
                if (this.outstandingBalance) {
                    return this.$q(function (resolve) {
                        resolve(JSON.parse(JSON.stringify(_this.outstandingBalance)));
                    });
                }
                else {
                    return this.dataservice
                        .getData('/api/invoice/outstandingbalance')
                        .then(function (response) {
                        _this.outstandingBalance = JSON.parse(JSON.stringify(response));
                        return response;
                    });
                }
            };
            outstandingBalanceService.prototype.refreshOutstandingBalance = function () {
                this.outstandingBalance = null;
                return this.getOutstandingBalance();
            };
            return outstandingBalanceService;
        }());
        services.outstandingBalanceService = outstandingBalanceService;
        angular
            .module('customer.core')
            .service('outstandingBalanceService', outstandingBalanceService);
    })(services = core.services || (core.services = {}));
})(core || (core = {}));
//# sourceMappingURL=outstandingBalance.service.js.map
var core;
(function (core) {
    var services;
    (function (services) {
        var userService = (function () {
            function userService(dataservice) {
                this.dataservice = dataservice;
            }
            userService.prototype.getCurrentUser = function () {
                return this.dataservice.getData('/api/usermanagement/current', true).then(function (response) {
                    return response.data;
                });
            };
            userService.prototype.savePassword = function (userModel) {
                return this.dataservice.postData('/api/usermanagement/changecustomerpassword', userModel);
            };
            userService.prototype.validatePassword = function (password) {
                return this.dataservice.postData('/api/usermanagement/verifypassword', '"' + password + '"').then(function (response) {
                    return response.data;
                });
            };
            userService.prototype.getAllUsers = function () {
                return this.dataservice.getData('/api/usermanagement/allusers').then(function (response) {
                    return response.data;
                });
            };
            userService.prototype.searchUsers = function (searchModel, page, count) {
                return this.dataservice.postData('/api/usermanagement/search?page=' + page + '&count=' + count, searchModel).then(function (response) {
                    return response;
                });
            };
            userService.prototype.unblockUser = function (userName) {
                return this.dataservice.putData('/api/usermanagement/unblock?username=' + this.urlEncodeValue(userName));
            };
            userService.prototype.blockUser = function (userName, blockReason) {
                return this.dataservice.putData("/api/usermanagement/block?username=" + this.urlEncodeValue(userName) + "&blockReason=" + this.urlEncodeValue(blockReason));
            };
            userService.prototype.deleteUser = function (userId) {
                return this.dataservice.deleteData('/api/usermanagement/deleteuser/?usernameOrId=' + this.urlEncodeValue(userId));
            };
            userService.prototype.getRoles = function () {
                return this.dataservice.getData('/api/usermanagement/roles').then(function (response) {
                    return response.data;
                });
            };
            userService.prototype.getUser = function (userId) {
                return this.dataservice.getData('/api/usermanagement/user/' + this.urlEncodeValue(userId)).then(function (response) {
                    return response.data;
                });
            };
            userService.prototype.getUserByCustomerId = function (customerId) {
                return this.dataservice.getData('/api/usermanagement/customer/' + this.urlEncodeValue(customerId)).then(function (response) {
                    return response;
                });
            };
            userService.prototype.createUser = function (account) {
                return this.dataservice.postData('/api/usermanagement/createcustomeruser', account).then(function (response) {
                    return response;
                });
            };
            userService.prototype.updateUser = function (account) {
                return this.dataservice.putData('/api/usermanagement/updatecustomeruser', account).then(function (response) {
                    return response;
                });
            };
            userService.prototype.urlEncodeValue = function (value) {
                return encodeURIComponent(value);
            };
            userService.prototype.getTwoFactorAuthSettings = function () {
                var url = 'api/usermanagement/twoFactorAuth';
                return this.dataservice.getData(url);
            };
            userService.prototype.setTwoFactorAuth = function (enabled) {
                var url = 'api/usermanagement/setTwoFactorAuth';
                return this.dataservice.postData(url, enabled);
            };
            userService.prototype.getUserManagementRights = function () {
                var url = "/api/usermanagement/rights";
                return this.dataservice
                    .getData(url)
                    .then(function (response) {
                    return response.data;
                });
            };
            userService.prototype.createKccUser = function (domain, userName, email, customerId) {
                var url = "/api/kccuser/create";
                return this.dataservice.postData(url, {
                    DomainName: domain,
                    UserName: userName,
                    CustomerId: customerId,
                    Email: email
                });
            };
            userService.prototype.getLastSyncDate = function () {
                var url = "/api/synchronization/date";
                return this.dataservice.getData(url);
            };
            userService.prototype.syncAccounts = function () {
                var url = "/api/synchronization";
                return this.dataservice.postData(url, null);
            };
            return userService;
        }());
        services.userService = userService;
        angular
            .module('customer.core')
            .service('userService', userService);
    })(services = core.services || (core.services = {}));
})(core || (core = {}));
//# sourceMappingURL=user.service.js.map
var core;
(function (core) {
    var services;
    (function (services) {
        var base64Service = (function () {
            function base64Service() {
            }
            base64Service.prototype.toBase64 = function (arrayBuffer) {
                var base64 = '';
                var encodings = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
                var bytes = new Uint8Array(arrayBuffer);
                var byteLength = bytes.byteLength;
                var byteRemainder = byteLength % 3;
                var mainLength = byteLength - byteRemainder;
                var a, b, c, d;
                var chunk;
                for (var i = 0; i < mainLength; i = i + 3) {
                    chunk = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
                    a = (chunk & 16515072) >> 18;
                    b = (chunk & 258048) >> 12;
                    c = (chunk & 4032) >> 6;
                    d = chunk & 63;
                    base64 += encodings[a] + encodings[b] + encodings[c] + encodings[d];
                }
                if (byteRemainder === 1) {
                    chunk = bytes[mainLength];
                    a = (chunk & 252) >> 2;
                    b = (chunk & 3) << 4;
                    base64 += encodings[a] + encodings[b] + '==';
                }
                else if (byteRemainder === 2) {
                    chunk = (bytes[mainLength] << 8) | bytes[mainLength + 1];
                    a = (chunk & 64512) >> 10;
                    b = (chunk & 1008) >> 4;
                    c = (chunk & 15) << 2;
                    base64 += encodings[a] + encodings[b] + encodings[c] + '=';
                }
                return base64;
            };
            base64Service.prototype.toArrayBuffer = function (base64String) {
                var binary_string = window.atob(base64String);
                var len = binary_string.length;
                var bytes = new Uint8Array(len);
                for (var i = 0; i < len; i++) {
                    bytes[i] = binary_string.charCodeAt(i);
                }
                return bytes.buffer;
            };
            return base64Service;
        }());
        services.base64Service = base64Service;
        angular
            .module('customer.core')
            .service('base64Service', base64Service);
    })(services = core.services || (core.services = {}));
})(core || (core = {}));
//# sourceMappingURL=base64.service.js.map
var core;
(function (core) {
    var services;
    (function (services) {
        var base64FileReader = (function () {
            function base64FileReader() {
            }
            base64FileReader.prototype.read = function (files, callback) {
                var results = new Array(files.length);
                var readsCompleted = 0;
                for (var i = 0; i < files.length; i++) {
                    (function (index) {
                        var file = files[index];
                        if (file) {
                            var fileReader = new FileReader();
                            fileReader.onload = function (fileLoadedEvent) {
                                var data = fileLoadedEvent.target.result;
                                results[index] = data.substring(data.indexOf(",") + 1);
                                if (++readsCompleted == files.length) {
                                    callback.apply(null, results);
                                }
                            };
                            fileReader.onerror = function (error) {
                                results[index] = null;
                                if (++readsCompleted == files.length) {
                                    callback.apply(null, results);
                                }
                            };
                            fileReader.readAsDataURL(file);
                        }
                        else {
                            results[index] = null;
                            if (++readsCompleted == files.length) {
                                callback.apply(null, results);
                            }
                        }
                    })(i);
                }
            };
            return base64FileReader;
        }());
        services.base64FileReader = base64FileReader;
        angular
            .module('customer.core')
            .service('base64FileReader', base64FileReader);
    })(services = core.services || (core.services = {}));
})(core || (core = {}));
//# sourceMappingURL=base64FileReader.service.js.map
var core;
(function (core) {
    var services;
    (function (services) {
        var dialogChainer = (function () {
            function dialogChainer($q, $timeout) {
                this.$q = $q;
                this.$timeout = $timeout;
                this.$inject = ['$q', '$timeout'];
            }
            dialogChainer.prototype.gatherData = function (dialogs) {
                var _this = this;
                var deferred = this.$q.defer();
                var chain = this.$q.when();
                angular.forEach(dialogs, function (dialog, index) {
                    chain = chain.then(function () {
                        var dialogDismissed = _this.$q.defer();
                        dialog.display().then(function (response) {
                            dialog.userResponse = response;
                            if (response) {
                                dialogDismissed.resolve();
                            }
                            else {
                                if (dialog.checkPassword) {
                                    dialog
                                        .checkPassword()
                                        .then(function () {
                                        dialog.userResponse = false;
                                        dialogDismissed.resolve();
                                    })
                                        .catch(function () {
                                        dialog.userResponse = true;
                                        dialogDismissed.resolve();
                                    });
                                }
                                else {
                                    dialogDismissed.resolve();
                                }
                            }
                        });
                        return dialogDismissed.promise;
                    });
                    if (index !== dialogs.length - 1) {
                        chain = chain.then(_this.delay(250));
                    }
                });
                chain.then(function () {
                    var result = {};
                    angular.forEach(dialogs, function (dialog) {
                        result[dialog.name] = dialog.userResponse;
                    });
                    deferred.resolve(result);
                });
                return deferred.promise;
            };
            dialogChainer.prototype.delay = function (milliseconds) {
                var _this = this;
                return function () {
                    return _this.$timeout(function () { }, milliseconds);
                };
            };
            return dialogChainer;
        }());
        services.dialogChainer = dialogChainer;
        angular
            .module('customer.core')
            .service('dialogChainer', dialogChainer);
    })(services = core.services || (core.services = {}));
})(core || (core = {}));
//# sourceMappingURL=dialogChainer.service.js.map
var core;
(function (core) {
    var services;
    (function (services) {
        var emailService = (function () {
            function emailService($http) {
                this.$http = $http;
                this.$inject = ['$http'];
            }
            emailService.prototype.isMailUnique = function (email) {
                return this.$http.get('/api/email/isunique?email=' + email);
            };
            return emailService;
        }());
        services.emailService = emailService;
        angular
            .module('customer.core')
            .service('emailService', emailService);
    })(services = core.services || (core.services = {}));
})(core || (core = {}));
//# sourceMappingURL=email.service.js.map
var core;
(function (core) {
    var services;
    (function (services) {
        var imageResizer = (function () {
            function imageResizer($q, photoSettings) {
                this.$q = $q;
                this.photoSettings = photoSettings;
                this.$inject = ['$q', 'photoSettings'];
                this.defaultDimensions = { width: Math.round(this.photoSettings.PhotoMaxHeight / 9 * 16), height: this.photoSettings.PhotoMaxHeight, compressionRatio: this.photoSettings.PhotoCompressionRatioJPG };
            }
            imageResizer.prototype.resizeImage = function (file, maxWidth, maxHeight, compressionRatio) {
                var _this = this;
                var deferred = this.$q.defer();
                if (!file) {
                    deferred.reject("Input not defined");
                    return deferred.promise;
                }
                if (!file.type.match(/image.*/)) {
                    deferred.reject("Input is not an image");
                    return deferred.promise;
                }
                var fileReader = new FileReader();
                fileReader.onload = function (fileLoadedEvent) {
                    var data = fileLoadedEvent.target.result;
                    _this.resizeBase64(data, maxWidth || _this.defaultDimensions.width, maxHeight || _this.defaultDimensions.height, compressionRatio || _this.defaultDimensions.compressionRatio)
                        .then(function (result) {
                        deferred.resolve(result);
                    });
                };
                fileReader.readAsDataURL(file);
                return deferred.promise;
            };
            imageResizer.prototype.resizeBase64Image = function (base64Data, maxWidth, maxHeight, compressionRatio) {
                if (base64Data.indexOf(",") === -1) {
                    base64Data = "data:image/jpeg;base64," + base64Data;
                }
                return this.resizeBase64(base64Data, maxWidth || this.defaultDimensions.width, maxHeight || this.defaultDimensions.height, compressionRatio || this.defaultDimensions.compressionRatio);
            };
            imageResizer.prototype.resizeBase64 = function (base64, maxWidth, maxHeight, compressionRatio) {
                var deferred = this.$q.defer();
                var img = $("<img/>");
                img.on("load", function () {
                    var result;
                    var ratio = 1;
                    if (this.width > maxWidth || this.height > maxHeight) {
                        ratio = Math.min(maxWidth / this.width, maxHeight / this.height);
                    }
                    var newWidth = Math.round(this.width * ratio);
                    var newHeight = Math.round(this.height * ratio);
                    var canvas = document.createElement("canvas");
                    canvas.width = newWidth;
                    canvas.height = newHeight;
                    var context = canvas.getContext("2d");
                    context.drawImage(this, 0, 0, newWidth, newHeight);
                    result = { data: canvas.toDataURL("image/jpeg", compressionRatio / 100), resized: true, width: newWidth, height: newHeight };
                    deferred.resolve(result);
                });
                img.attr("src", base64);
                return deferred.promise;
            };
            return imageResizer;
        }());
        services.imageResizer = imageResizer;
        angular
            .module("customer.core")
            .service("imageResizer", imageResizer);
    })(services = core.services || (core.services = {}));
})(core || (core = {}));
//# sourceMappingURL=imageResizer.service.js.map
var core;
(function (core) {
    var services;
    (function (services) {
        var markdownService = (function () {
            function markdownService($showdown) {
                this.$showdown = $showdown;
                this.$inject = ['$showdown'];
            }
            markdownService.prototype.toHtml = function (markdown) {
                var simpleLinkRegex = /<(.+?)>/g;
                var inlineLinkRegex = /\[(.+)\]\((.+?)\)/g;
                var result = this.convertLinksToAnchorTags(markdown, simpleLinkRegex, 1);
                result = this.convertLinksToAnchorTags(result, inlineLinkRegex, 2, 1);
                return this.$showdown.makeHtml(result);
            };
            markdownService.prototype.convertLinksToAnchorTags = function (markdown, linkRegex, urlGroupIndex, nameGroupIndex) {
                var result = markdown;
                var match = null;
                do {
                    match = linkRegex.exec(markdown);
                    if (match) {
                        var url = match[urlGroupIndex];
                        var name = nameGroupIndex ? match[nameGroupIndex] : url;
                        if (this.isAbsoluteURL(url)) {
                            if (!this.hasSchemeDefined(url)) {
                                url = this.buildURL("http://", url);
                            }
                            result = result.replace(match[0], '<a href="' + url + '" target="_blank">' + name + '</a>');
                        }
                        else {
                            url = this.buildURL(window.location.origin, url);
                            result = result.replace(match[0], '<a href="' + url + '">' + name + '</a>');
                        }
                    }
                } while (match);
                return result;
            };
            markdownService.prototype.isAbsoluteURL = function (url) {
                if (!url) {
                    return false;
                }
                url = url.trim();
                if (this.hasSchemeDefined(url)) {
                    return true;
                }
                if (this.startsWith(url, "/")) {
                    return false;
                }
                var host = url.split("/")[0];
                if (host.indexOf(".") !== -1 || host.indexOf(":") !== -1) {
                    return true;
                }
                return false;
            };
            markdownService.prototype.buildURL = function (base, relativeURL) {
                if (this.endsWith(base, "/")) {
                    base = base.substring(0, base.length - 1);
                }
                if (this.startsWith(relativeURL, "/")) {
                    relativeURL = relativeURL.substring(1);
                }
                return base + "/" + relativeURL;
            };
            markdownService.prototype.hasSchemeDefined = function (url) {
                return /^(?:[a-z]+:)?\/\//i.test(url);
            };
            markdownService.prototype.startsWith = function (str, prefix) {
                return str.lastIndexOf(prefix, 0) === 0;
            };
            markdownService.prototype.endsWith = function (str, suffix) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            };
            return markdownService;
        }());
        services.markdownService = markdownService;
        angular
            .module("customer.core")
            .service("markdownService", markdownService);
    })(services = core.services || (core.services = {}));
})(core || (core = {}));
//# sourceMappingURL=markdown.service.js.map
var core;
(function (core) {
    var directives;
    (function (directives) {
        var startValidation = (function () {
            function startValidation() {
                this.restrict = 'A';
                this.require = ['ngModel', '^form'];
                this.link = this.unboundlink.bind(this);
            }
            startValidation.prototype.unboundlink = function (scope, elm, attrs, controllers) {
                var _this = this;
                var ngModel = controllers[0];
                var form = controllers[1];
                var lastValueChecked;
                scope.$watch(function () {
                    return ngModel.$$rawModelValue;
                }, function (newValue, oldValue) {
                    lastValueChecked = newValue;
                }, true);
                elm.on("input propertychange paste", function () {
                    if (elm.val() != lastValueChecked) {
                        _this.validationInProgress(form, ngModel, attrs, true);
                    }
                    else {
                        _this.validationInProgress(form, ngModel, attrs, false);
                    }
                });
            };
            startValidation.prototype.validationInProgress = function (form, ngModel, attrs, inProgress) {
                var errorKey = attrs["startValidation"];
                form.validationInProgress = inProgress;
                ngModel.$setValidity(errorKey, !inProgress);
            };
            startValidation.factory = function () {
                var directive = function () { return new startValidation(); };
                return directive;
            };
            return startValidation;
        }());
        angular
            .module('customer.core')
            .directive('startValidation', startValidation.factory());
    })(directives = core.directives || (core.directives = {}));
})(core || (core = {}));
//# sourceMappingURL=startValidation.directive.js.map
var core;
(function (core) {
    var directives;
    (function (directives) {
        var stopPropagation = (function () {
            function stopPropagation() {
                this.restrict = 'A';
                this.link = function (scope, element, attr) {
                    element.on('click', function (event) {
                        event.stopPropagation();
                    });
                };
            }
            stopPropagation.factory = function () {
                var directive = function () { return new stopPropagation(); };
                return directive;
            };
            return stopPropagation;
        }());
        angular
            .module('customer.core')
            .directive('stopPropagation', stopPropagation.factory());
    })(directives = core.directives || (core.directives = {}));
})(core || (core = {}));
//# sourceMappingURL=stopPropagation.directive.js.map
var core;
(function (core) {
    var directives;
    (function (directives) {
        var toggleSwitch = (function () {
            function toggleSwitch() {
                this.restrict = 'A';
                this.link = function (scope, element, attr) {
                    setTimeout(function () {
                        element.bootstrapToggle();
                    }, 200);
                };
            }
            toggleSwitch.factory = function () {
                var directive = function () { return new toggleSwitch(); };
                return directive;
            };
            return toggleSwitch;
        }());
        angular
            .module('customer.core')
            .directive('toggleSwitch', toggleSwitch.factory());
    })(directives = core.directives || (core.directives = {}));
})(core || (core = {}));
//# sourceMappingURL=toggle.directive.js.map
var core;
(function (core) {
    var directives;
    (function (directives) {
        var capitalize = (function () {
            function capitalize($parse) {
                var _this = this;
                this.$parse = $parse;
                this.require = "ngModel";
                this.link = function (scope, element, attrs, modelCtrl) {
                    var capitalize = function (inputValue) {
                        if (inputValue === undefined || inputValue === null) {
                            inputValue = "";
                        }
                        var capitalized = inputValue.toUpperCase();
                        if (capitalized !== inputValue) {
                            modelCtrl.$setViewValue(capitalized);
                            modelCtrl.$render();
                        }
                        return capitalized;
                    };
                    modelCtrl.$parsers.push(capitalize);
                    capitalize(_this.$parse(attrs.ngModel)(scope));
                };
            }
            capitalize.factory = function () {
                var directive = function ($parse) { return new capitalize($parse); };
                directive.$inject = ['$parse'];
                return directive;
            };
            return capitalize;
        }());
        angular
            .module("customer.core")
            .directive("capitalize", capitalize.factory());
    })(directives = core.directives || (core.directives = {}));
})(core || (core = {}));
//# sourceMappingURL=upperCase.directive.js.map
var core;
(function (core) {
    var directives;
    (function (directives) {
        var collapsiblePanel = (function () {
            function collapsiblePanel() {
                this.restrict = 'A';
                this.transclude = true;
                this.templateUrl = '/App/core/directives/collapsiblePanel/collapsiblePanel.html';
                this.scope = {
                    panelId: '@id',
                    panelTitle: '@heading',
                    expanded: '@expanded',
                    onExpand: '&'
                };
                this.link = function (scope, element, attr) {
                    if (scope.expanded === 'true') {
                        scope.bodyClass = "in";
                        scope.collapsedClass = "";
                    }
                    else {
                        scope.expanded = 'false';
                        scope.bodyClass = "";
                        scope.collapsedClass = "collapsed";
                    }
                    scope.$watch(function () { return element.attr('heading'); }, function (val) {
                        scope.panelTitle = val;
                    });
                    scope.headerClick = function (event) {
                        if (angular.element(event.target).hasClass('collapsed')) {
                            scope.onExpand();
                        }
                    };
                    scope.$watch(function () { return element.attr('expanded'); }, function (val) {
                        angular.element('#collapse' + scope.panelId).collapse(val === 'true' ? 'show' : 'hide');
                    });
                };
            }
            collapsiblePanel.factory = function () {
                var directive = function () { return new collapsiblePanel(); };
                return directive;
            };
            return collapsiblePanel;
        }());
        angular
            .module('customer.core')
            .directive('collapsiblePanel', collapsiblePanel.factory());
    })(directives = core.directives || (core.directives = {}));
})(core || (core = {}));
//# sourceMappingURL=collapsiblePanel.directive.js.map
var core;
(function (core) {
    var directives;
    (function (directives) {
        var dateTimePicker = (function () {
            function dateTimePicker($timeout) {
                var _this = this;
                this.$timeout = $timeout;
                this.restrict = 'A';
                this.require = 'ngModel';
                this.scope = {
                    config: '=',
                    onChange: '&onChange',
                    ngModel: '='
                };
                this.link = function (scope, element, attributes, ctrl) {
                    if (scope.config.defaultDate) {
                        ctrl.$setViewValue(scope.config.defaultDate);
                    }
                    var datepickerConfig = JSON.parse(JSON.stringify(scope.config));
                    var isWeekOnly = datepickerConfig.weekOnly;
                    delete datepickerConfig.weekOnly;
                    $(element).datetimepicker(datepickerConfig);
                    element.on('dp.show', function () {
                        if (isWeekOnly) {
                            $(element.siblings('.bootstrap-datetimepicker-widget')[0]).addClass('week');
                            $(element.siblings('.bootstrap-datetimepicker-widget')[0]).find('.picker-switch').attr('colspan', '3');
                        }
                    });
                    var picker = element.data("DateTimePicker");
                    if (scope.config.inline) {
                        scope.$watch(function () { return scope.ngModel; }, function (val) {
                            if (val) {
                                _this.$timeout(function () {
                                    picker.date(val);
                                });
                            }
                        });
                        if (isWeekOnly) {
                            $(element.find('.bootstrap-datetimepicker-widget')[0]).addClass('week');
                            $(element.find('.bootstrap-datetimepicker-widget')[0]).find('.picker-switch').attr('colspan', '3');
                        }
                    }
                    scope.$watch(function () { return scope.config.minDate; }, function (val) {
                        if (val) {
                            _this.$timeout(function () {
                                picker.minDate(val);
                            });
                        }
                    });
                    scope.$watch(function () { return scope.config.maxDate; }, function (val) {
                        if (val) {
                            _this.$timeout(function () {
                                picker.maxDate(val);
                            });
                        }
                    });
                    scope.$watch(function () { return scope.config.enabledDates; }, function (val) {
                        if (val) {
                            _this.$timeout(function () {
                                picker.enabledDates(val);
                            });
                        }
                    });
                    ctrl.$formatters.push(function (value) {
                        var date = moment.parseZone(value);
                        if (value && date.isValid()) {
                            return date.format(scope.config.format);
                        }
                        return '';
                    });
                    var validate = function (viewValue) {
                        var date = moment(viewValue, 'DD-MM-YYYY');
                        if (viewValue && !date.isValid()) {
                            ctrl.$setValidity('validDate', false);
                        }
                        else {
                            ctrl.$setValidity('validDate', true);
                        }
                        return viewValue;
                    };
                    ctrl.$parsers.unshift(validate);
                    element.on('dp.change', function () {
                        var date = picker.date();
                        if (typeof scope.ngModel == "string" || scope.ngModel == undefined)
                            scope.ngModel = date;
                        if (date.format('DD-MM-YYYY') != ctrl.$viewValue) {
                            scope.$apply(function () {
                                ctrl.$setViewValue(date);
                            });
                        }
                    });
                };
            }
            dateTimePicker.factory = function () {
                var directive = function ($timeout) { return new dateTimePicker($timeout); };
                directive.$inject = ['$timeout'];
                return directive;
            };
            return dateTimePicker;
        }());
        angular.module('customer.core')
            .directive('datetimePicker', dateTimePicker.factory());
    })(directives = core.directives || (core.directives = {}));
})(core || (core = {}));
//# sourceMappingURL=dateTimePicker.directive.js.map
var core;
(function (core) {
    var directives;
    (function (directives) {
        var duration = (function () {
            function duration(localize) {
                var _this = this;
                this.localize = localize;
                this.require = 'ngModel';
                this.restrict = 'A';
                this.template = "<span>{0}</span>";
                this.scope = {
                    prefix: '@durationPrefix',
                    includeValueForSingularCase: '=durationIncludeValueForSingularCase'
                };
                this.durationDictionary = {
                    "Y": { order: 1, text: "Year" },
                    "Q": { order: 2, text: "Quarter" },
                    "M": { order: 3, text: "Month" },
                    "W": { order: 4, text: "Week" },
                    "D": { order: 5, text: "Day" },
                    "WD": { order: 6, text: "WeekDay" }
                };
                this.link = function (scope, el, attrs, ngModel) {
                    var prefix = scope.prefix || "";
                    var includeValueForSingularCase = scope.includeValueForSingularCase || false;
                    ngModel.$formatters.push(function (value) {
                        if (!value || value === "" || value.length < 2) {
                            return "";
                        }
                        var parser = /(?:(\d+)(?:([YQMWD]{1,2})))/ig;
                        var results = [];
                        var groups;
                        while ((groups = parser.exec(value)) !== null) {
                            var val = groups[1];
                            var duration = groups[2].toUpperCase();
                            results.push({
                                value: val,
                                duration: _this.durationDictionary[duration]
                            });
                        }
                        results = results.sort(function (first, second) {
                            return first.duration.order - second.duration.order;
                        });
                        if (results.length > 1) {
                            includeValueForSingularCase = true;
                        }
                        var formattedValue = prefix ? _this.getResource(prefix) + " " : "";
                        var groupIdx = 0;
                        results.forEach(function (result) {
                            var duration = result.duration.text;
                            if (groupIdx > 0) {
                                if (groupIdx === results.length - 1) {
                                    formattedValue += _this.getResource("Text_SeparatorBeforeTheLastValue");
                                }
                                else {
                                    formattedValue += _this.getResource("Text_Separator");
                                }
                            }
                            if (result.value == 1) {
                                if (includeValueForSingularCase) {
                                    formattedValue += result.value + " ";
                                }
                                formattedValue += _this.getResource("Text_Singular_" + duration);
                            }
                            else {
                                formattedValue += result.value + " " + _this.getResource("Text_Plural_" + duration);
                            }
                            groupIdx++;
                        });
                        return formattedValue;
                    });
                };
            }
            duration.prototype.getResource = function (key) {
                return this.localize.getLocalizedString(key, "Duration");
            };
            duration.factory = function () {
                var directive = function (localize) { return new duration(localize); };
                directive.$inject = ['localize'];
                return directive;
            };
            return duration;
        }());
        angular.module("customer.core")
            .directive("duration", duration.factory());
    })(directives = core.directives || (core.directives = {}));
})(core || (core = {}));
//# sourceMappingURL=duration.directive.js.map
var core;
(function (core) {
    var directives;
    (function (directives) {
        var fileDownload = (function () {
            function fileDownload($q, dataservice, localize, alerting, base64Service, viewService) {
                var _this = this;
                this.$q = $q;
                this.dataservice = dataservice;
                this.localize = localize;
                this.alerting = alerting;
                this.base64Service = base64Service;
                this.viewService = viewService;
                this.restrict = 'A';
                this.scope = {
                    url: '=downloadUrl',
                    message: '@downloadFinishedMessage',
                    failedMessage: '@downloadFailedMessage'
                };
                this.link = function ($scope, el, attrs) {
                    if (!$scope.url) {
                        return;
                    }
                    var viewName = _this.viewService.getViewName(el);
                    if (!$scope.title) {
                        $scope.title = _this.localize.getLocalizedString("Dialog_DefaultTitle", "Generic");
                    }
                    if (!$scope.message) {
                        $scope.translatedMessage = _this.localize.getLocalizedString("Message_DownloadReady", "Generic");
                    }
                    else {
                        $scope.translatedMessage = _this.localize.getLocalizedString($scope.message, viewName);
                    }
                    if (!$scope.failedMessage) {
                        $scope.translatedFailedMessage = _this.localize.getLocalizedString("Message_DownloadFailed", "Generic");
                    }
                    else {
                        $scope.translatedFailedMessage = _this.localize.getLocalizedString($scope.failedMessage, viewName);
                    }
                    el.bind('click', function (e) {
                        e.stopPropagation();
                        _this.dataservice.downloadFile($scope.url, {}, { responseType: 'arraybuffer' }).then(function (response) {
                            var fileNameRegEx = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i;
                            if (response.status === 200 && response.data.byteLength > 0) {
                                var contentDisposition = fileNameRegEx.exec(response.headers('Content-Disposition'));
                                $scope.contentDisposition = contentDisposition[1].replace(/"/g, '');
                                var contentType = response.headers("Content-Type");
                                $scope.contentType = contentType;
                                var options = {
                                    templateUrl: '/App/core/directives/fileDownload/fileDownload.html',
                                    controller: "fileDownload",
                                    controllerAs: 'model',
                                    resolve: {
                                        options: function () {
                                            return {
                                                message: $scope.translatedMessage,
                                                title: $scope.title,
                                                data: response.data,
                                                fileName: $scope.contentDisposition,
                                                contentType: $scope.contentType
                                            };
                                        }
                                    }
                                };
                                _this.alerting.showModal(options);
                            }
                            else {
                                _this.alerting.popError($scope.translatedFailedMessage, $scope.title);
                            }
                        });
                    });
                };
            }
            fileDownload.factory = function () {
                var directive = function ($q, dataservice, localize, alerting, base64Service, viewService) { return new fileDownload($q, dataservice, localize, alerting, base64Service, viewService); };
                directive.$inject = ['$q', 'dataservice', 'localize', 'alerting', 'base64Service', 'viewService'];
                return directive;
            };
            return fileDownload;
        }());
        angular.module("customer.core")
            .config(['$compileProvider', function ($compileProvider) {
                $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|data):/);
            }])
            .directive("fileDownload", fileDownload.factory());
    })(directives = core.directives || (core.directives = {}));
})(core || (core = {}));
//# sourceMappingURL=fileDownload.directive.js.map
var core;
(function (core) {
    var directives;
    (function (directives) {
        var filePicker = (function () {
            function filePicker($parse) {
                var _this = this;
                this.$parse = $parse;
                this.restrict = 'E';
                this.templateUrl = '/App/core/directives/filePicker/filePicker.html';
                this.scope = {
                    fileType: "=",
                    maxSize: "=",
                    fileModel: "@",
                    onerror: "&",
                    onsuccess: "&"
                };
                this.link = function (scope, element, attrs) {
                    var fileInput = element.find("input[type='file']");
                    var textInput = element.find("input[type='text']");
                    var acceptedExts = scope.fileType;
                    fileInput.prop("accept", acceptedExts);
                    var model = _this.$parse(scope.fileModel);
                    var modelSetter = model.assign;
                    var isValidFile = function (file) {
                        if (!acceptedExts || acceptedExts.length === 0) {
                            return true;
                        }
                        var exts = acceptedExts.toLocaleLowerCase().split(',');
                        var fileExt = file.name.substring(file.name.lastIndexOf('.')).toLocaleLowerCase();
                        if (exts.length === 1 && exts[0].indexOf("/") > -1) {
                            return file.type && file.type.split('/')[0].toLocaleLowerCase() === exts[0].substring(0, exts[0].indexOf("/"));
                        }
                        return exts.filter(function (elem) {
                            return elem.substring(elem.lastIndexOf('.')).toLocaleLowerCase() === fileExt;
                        }).length > 0;
                    };
                    fileInput.bind("change", function () {
                        var errorsFound = false;
                        var fileInputElement = fileInput[0];
                        for (var i = 0; i < fileInputElement.files.length; i++) {
                            var file = fileInputElement.files[i];
                            if (file && scope.maxSize && file.size > scope.maxSize) {
                                scope.onerror({ file: file, errorMessageCode: 1 });
                                errorsFound = true;
                                break;
                            }
                            else if (file && !isValidFile(file)) {
                                scope.onerror({ file: file, errorMessageCode: 2 });
                                errorsFound = true;
                                break;
                            }
                        }
                        if (scope.onsuccess && !errorsFound) {
                            scope.onsuccess({ files: fileInputElement.files });
                        }
                        if (!errorsFound) {
                            var files = "";
                            for (var i = 0; i < fileInputElement.files.length; i++) {
                                files += fileInputElement.files[i].name + " ";
                            }
                            textInput.val(files);
                        }
                        scope.$apply(function () {
                            modelSetter(scope.$parent, fileInputElement.files);
                        });
                    });
                };
            }
            filePicker.factory = function () {
                var directive = function ($parse) { return new filePicker($parse); };
                directive.$inject = ['$parse'];
                return directive;
            };
            return filePicker;
        }());
        angular
            .module('customer.core')
            .directive('filePicker', filePicker.factory());
    })(directives = core.directives || (core.directives = {}));
})(core || (core = {}));
//# sourceMappingURL=filePicker.directive.js.map
var core;
(function (core) {
    var directives;
    (function (directives) {
        var filePickerButton = (function () {
            function filePickerButton($parse, $uibModal) {
                var _this = this;
                this.$parse = $parse;
                this.$uibModal = $uibModal;
                this.restrict = 'E';
                this.templateUrl = '/App/core/directives/filePicker/filePickerButton.html';
                this.scope = {
                    maxSize: "=",
                    modalTitle: "@",
                    infoText: "@",
                    fileTooLargeMessage: "@",
                    viewName: "@",
                    fileModel: "@",
                    onerror: "&",
                    fileSelected: "&",
                    fileType: "=",
                    btnTitle: "=",
                    isDisabled: "=",
                    btnClass: "=",
                    btnIcon: "=",
                    autoClose: "=",
                    invalidFileExtension: "@"
                };
                this.link = function (scope, element, attrs) {
                    var fileModel = _this.$parse(scope.fileModel);
                    var fileModelSetter = fileModel.assign;
                    scope.onClick = function () {
                        var modalInstance = _this.$uibModal.open({
                            controller: 'filePickerModal',
                            controllerAs: '$ctrl',
                            templateUrl: '/App/core/directives/filePicker/filePickerModal.html',
                            scope: scope,
                            resolve: {
                                element: function () { return element; },
                                fileModelSetter: function () {
                                    return function (value) {
                                        fileModelSetter(scope.$parent, value);
                                        scope.fileSelected();
                                    };
                                }
                            }
                        });
                    };
                };
            }
            filePickerButton.factory = function () {
                var directive = function ($parse, $uibModal) { return new filePickerButton($parse, $uibModal); };
                directive.$inject = ['$parse', '$uibModal'];
                return directive;
            };
            return filePickerButton;
        }());
        angular
            .module('customer.core')
            .directive('filePickerButton', filePickerButton.factory());
    })(directives = core.directives || (core.directives = {}));
})(core || (core = {}));
//# sourceMappingURL=filePickerButton.directive.js.map
var core;
(function (core) {
    var directives;
    (function (directives) {
        var filePickerPreview = (function () {
            function filePickerPreview($parse, $uibModal) {
                var _this = this;
                this.$parse = $parse;
                this.$uibModal = $uibModal;
                this.restrict = 'E';
                this.templateUrl = '/App/core/directives/filePicker/filePickerPreview.html';
                this.scope = {
                    defaultImgSrc: "=",
                    maxSize: "=",
                    modalTitle: "@",
                    infoText: "@",
                    fileTooLargeMessage: "@",
                    viewName: "@",
                    fileModel: "@",
                    onerror: "&",
                    invalidFileExtension: "@",
                    fileType: "@",
                    autoClose: "="
                };
                this.link = function (scope, element, attrs) {
                    scope.newImageSelected = false;
                    var fileModel = _this.$parse(scope.fileModel);
                    var fileModelSetter = fileModel.assign;
                    scope.$watch(function () {
                        return scope.defaultImgSrc;
                    }, function (newValue) {
                        if (!scope.newImageSelected) {
                            element.find("img").attr('src', newValue);
                        }
                    });
                    scope.onClick = function () {
                        scope.isImagePicker = true;
                        var modalInstance = _this.$uibModal.open({
                            controller: 'filePickerModal',
                            controllerAs: '$ctrl',
                            templateUrl: '/App/core/directives/filePicker/filePickerModal.html',
                            scope: scope,
                            resolve: {
                                element: function () { return element; },
                                fileModelSetter: function () {
                                    return function (value) {
                                        fileModelSetter(scope.$parent, value);
                                    };
                                }
                            }
                        });
                    };
                    scope.clear = function () {
                        fileModelSetter(scope.$parent, null);
                        scope.newImageSelected = false;
                        element.find("img").attr('src', scope.defaultImgSrc);
                    };
                };
            }
            filePickerPreview.factory = function () {
                var directive = function ($parse, $uibModal) { return new filePickerPreview($parse, $uibModal); };
                directive.$inject = ['$parse', '$uibModal'];
                return directive;
            };
            return filePickerPreview;
        }());
        angular
            .module('customer.core')
            .directive('filePickerPreview', filePickerPreview.factory());
    })(directives = core.directives || (core.directives = {}));
})(core || (core = {}));
//# sourceMappingURL=filePickerPreview.directive.js.map
var core;
(function (core) {
    var directives;
    (function (directives) {
        var inputFocus = (function () {
            function inputFocus() {
                this.link = function (scope, elem, attr) {
                    scope.$on('focusOn', function (e, name) {
                        if (name === attr.focusOn) {
                            elem[0].focus();
                        }
                    });
                };
            }
            inputFocus.factory = function () {
                var directive = function () { return new inputFocus(); };
                return directive;
            };
            return inputFocus;
        }());
        angular
            .module('customer.core')
            .directive('focusOn', inputFocus.factory());
    })(directives = core.directives || (core.directives = {}));
})(core || (core = {}));
//# sourceMappingURL=focusOn.directive.js.map
var core;
(function (core) {
    var directives;
    (function (directives) {
        var imagePicker = (function () {
            function imagePicker($uibModal) {
                var _this = this;
                this.$uibModal = $uibModal;
                this.restrict = 'E';
                this.templateUrl = '/App/core/directives/imagePicker/imagePicker.html';
                this.scope = {
                    images: '=',
                    maxNumberOfImages: '=',
                    fileTooLargeMessage: "@",
                    viewName: "@",
                    modalTitle: "@",
                    infoText: "@",
                    invalidFileExtension: "@",
                    readonly: '=',
                    fileType: "@",
                    autoClose: "="
                };
                this.link = function (scope, element, attrs) {
                    scope.$watchCollection(function () { return scope.images; }, function (oldValue, newValue) {
                        if (scope.images.length >= scope.maxNumberOfImages)
                            element.find("#imgAdd").hide();
                        else
                            element.find("#imgAdd").show();
                    });
                    scope.clearImages = function (index) {
                        if (scope.images[index].canDelete === false)
                            return;
                        scope.images.splice(index, 1);
                    };
                    scope.getDeleteButtonClass = function (index) {
                        if (scope.images[index].canDelete === false)
                            return "btn-xs disabled";
                        return "btn-xs";
                    };
                    scope.getImageClass = function (index) {
                        if (scope.images[index].canDelete === false)
                            return "glyphicon glyphicon-lock";
                        return "glyphicon glyphicon-trash";
                    };
                    scope.onClick = function () {
                        var modalInstance = _this.$uibModal.open({
                            templateUrl: '/App/core/directives/filePicker/filePickerModal.html',
                            controllerAs: '$ctrl',
                            controller: 'imagePickerModal',
                            scope: scope
                        });
                    };
                };
            }
            imagePicker.factory = function () {
                var directive = function ($uibModal) { return new imagePicker($uibModal); };
                directive.$inject = ['$uibModal'];
                return directive;
            };
            return imagePicker;
        }());
        angular
            .module('customer.core')
            .directive('imagePicker', imagePicker.factory());
    })(directives = core.directives || (core.directives = {}));
})(core || (core = {}));
//# sourceMappingURL=imagePicker.directive.js.map
var core;
(function (core) {
    var directives;
    (function (directives) {
        var customerNumber = (function () {
            function customerNumber(contractService, $q) {
                var _this = this;
                this.contractService = contractService;
                this.$q = $q;
                this.restrict = 'A';
                this.require = ['ngModel', '^form'];
                this.link = function (scope, elm, attrs, controllers) {
                    var ngModel = controllers[0];
                    var form = controllers[1];
                    ngModel.$asyncValidators.customerNumber = function (modelValue, viewValue) {
                        if (attrs.startValidation === "false") {
                            return _this.$q.when(true);
                        }
                        if (!viewValue) {
                            _this.endValidationProcess(form, ngModel, attrs);
                            return _this.$q.when(true);
                        }
                        return _this.contractService.isCustomerNumberValid(viewValue).then(function (response) {
                            _this.endValidationProcess(form, ngModel, attrs);
                            if (response.data !== true) {
                                return _this.$q.reject(false);
                            }
                            return _this.$q.when(true);
                        });
                    };
                };
            }
            customerNumber.prototype.endValidationProcess = function (form, ngModel, attrs) {
                var errorKey = attrs["customerNumber"];
                form.validationInProgress = false;
                ngModel.$setValidity(errorKey, true);
            };
            customerNumber.factory = function () {
                var directive = function (contractService, $q) { return new customerNumber(contractService, $q); };
                directive.$inject = ['contractService', '$q'];
                return directive;
            };
            return customerNumber;
        }());
        angular
            .module('customer.core')
            .directive('customerNumber', customerNumber.factory());
    })(directives = core.directives || (core.directives = {}));
})(core || (core = {}));
//# sourceMappingURL=customerNumberValidation.directive.js.map
var core;
(function (core) {
    var directives;
    (function (directives) {
        var mailRegex = new RegExp(/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i);
        var emailDirective = (function () {
            function emailDirective(emailService, $q) {
                var _this = this;
                this.emailService = emailService;
                this.$q = $q;
                this.restrict = 'A';
                this.require = 'ngModel';
                this.link = function (scope, elm, attrs, ctrl) {
                    _this.attachValidators(scope, elm, attrs, ctrl);
                };
            }
            emailDirective.prototype.attachValidators = function (scope, elm, attrs, ctrl) {
                if (attrs.unique !== undefined) {
                    this.attachAsyncUniqueValidator(scope, elm, attrs, ctrl);
                }
                this.attachSyncValidator(scope, elm, attrs, ctrl);
            };
            emailDirective.prototype.attachSyncValidator = function (scope, elm, attrs, ctrl) {
                ctrl.$validators.email = function (modelValue, viewValue) {
                    if (!viewValue || viewValue === '') {
                        return true;
                    }
                    return mailRegex.test(viewValue);
                };
            };
            emailDirective.prototype.attachAsyncUniqueValidator = function (scope, elm, attrs, ctrl) {
                var _this = this;
                ctrl.$asyncValidators[attrs.ngModel] = function (modelValue, viewValue) {
                    var defered = _this.$q.defer();
                    if (!viewValue || viewValue === '') {
                        defered.resolve();
                    }
                    if (attrs.validate !== null) {
                        if (mailRegex.test(viewValue)) {
                            _this.emailService.isMailUnique(viewValue).then(function (result) {
                                if (!result.data) {
                                    defered.reject();
                                }
                                else {
                                    defered.resolve(result);
                                }
                            }).catch(angular.noop);
                        }
                    }
                    return defered.promise;
                };
            };
            emailDirective.factory = function () {
                var directive = function (emailService, $q) { return new emailDirective(emailService, $q); };
                directive.$inject = ['emailService', '$q'];
                return directive;
            };
            return emailDirective;
        }());
        angular
            .module('customer.core')
            .directive('email', emailDirective.factory());
    })(directives = core.directives || (core.directives = {}));
})(core || (core = {}));
//# sourceMappingURL=emailValidation.directive.js.map
var core;
(function (core) {
    var directives;
    (function (directives) {
        var password = (function () {
            function password() {
                this.restrict = 'A';
                this.scope = {
                    passMinLength: '@minLength',
                    passMaxLength: '@maxLength',
                    passMinUpper: '@minUppercase',
                    passMinLower: '@minLowercase',
                    passMinNumbers: '@minNumbers',
                    passMinSpecial: '@minSpecial'
                };
                this.require = 'ngModel';
                this.link = function (scope, elm, attrs, ctrl) {
                    var passMinLength = scope.passMinLength || core.constants.passwordValidation.minLength;
                    var passMaxLength = scope.passMaxLength || core.constants.passwordValidation.maxLength;
                    var passMinUpper = scope.passMinUpper || core.constants.passwordValidation.minUpper;
                    var passMinLower = scope.passMinLower || core.constants.passwordValidation.minLower;
                    var passMinNumbers = scope.passMinNumbers || core.constants.passwordValidation.minDigits;
                    var passMinSpecial = scope.passMinSpecial || core.constants.passwordValidation.minNonAlphanumeric;
                    ctrl.$validators["password"] = function (modelValue, viewValue) {
                        if (viewValue && viewValue.length >= passMinLength && viewValue.length <= passMaxLength) {
                            var hasUpperCase = new RegExp("^(.*?[A-Z]){" + passMinUpper + ",}", "g").test(viewValue);
                            var hasLowerCase = new RegExp("^(.*?[a-z]){" + passMinLower + ",}", "g").test(viewValue);
                            var hasNumbers = new RegExp("^(.*?[\\d]){" + passMinNumbers + ",}", "g").test(viewValue);
                            var hasNonalphas = new RegExp("^(.*?[\\W]){" + passMinSpecial + ",}", "g").test(viewValue);
                            elm.removeClass('too-long');
                            if (hasUpperCase && hasLowerCase && hasNumbers && hasNonalphas) {
                                return true;
                            }
                            else {
                                return false;
                            }
                        }
                        else {
                            if (viewValue && viewValue.length > passMaxLength) {
                                elm.addClass('too-long');
                            }
                            else {
                                elm.removeClass('too-long');
                            }
                            return false;
                        }
                    };
                };
            }
            password.factory = function () {
                var directive = function () { return new password(); };
                return directive;
            };
            return password;
        }());
        ;
        angular
            .module('customer.core')
            .directive('password', password.factory());
    })(directives = core.directives || (core.directives = {}));
})(core || (core = {}));
//# sourceMappingURL=passwordValidation.directive.js.map
var core;
(function (core) {
    var directives;
    (function (directives) {
        var phonenumber = (function () {
            function phonenumber() {
                this.restrict = 'A';
                this.require = 'ngModel';
                this.link = function (scope, elm, attrs, ctrl) {
                    ctrl.$validators[attrs.ngModel] = function (modelValue, viewValue) {
                        if (!viewValue) {
                            return false;
                        }
                        if (/[^\d+\-()\s]/g.test(viewValue)) {
                            return false;
                        }
                        var phoneWithoutSpace = viewValue.replace(" ", "");
                        var onlyDigits = phoneWithoutSpace.replace(/[^\d]/g, "");
                        if (onlyDigits.length < 10 || onlyDigits.length > 12) {
                            return false;
                        }
                        if (phoneWithoutSpace.lastIndexOf('+') > 0) {
                            return false;
                        }
                        if (phoneWithoutSpace.split('-').length > 2) {
                            return false;
                        }
                        if (phoneWithoutSpace.split(/\(/).length > 2) {
                            return false;
                        }
                        if (/[^\d]$/.test(viewValue)) {
                            return false;
                        }
                        return true;
                    };
                };
            }
            phonenumber.factory = function () {
                var directive = function () { return new phonenumber(); };
                return directive;
            };
            return phonenumber;
        }());
        ;
        angular
            .module('customer.core')
            .directive('phonenumber', phonenumber.factory());
    })(directives = core.directives || (core.directives = {}));
})(core || (core = {}));
//# sourceMappingURL=phoneValidation.directive.js.map
var core;
(function (core) {
    var directives;
    (function (directives) {
        var sameAs = (function () {
            function sameAs() {
                this.restrict = 'A';
                this.require = 'ngModel';
                this.scope = {
                    otherModelValue: "=sameAs"
                };
                this.link = function (scope, elm, attrs, ngModel) {
                    ngModel.$validators.sameAs = function (modelValue, viewValue) {
                        return viewValue === scope.otherModelValue.$viewValue;
                    };
                    scope.$watch("otherModelValue.$viewValue", function () {
                        ngModel.$validate();
                    });
                };
            }
            sameAs.factory = function () {
                var directive = function () { return new sameAs(); };
                return directive;
            };
            return sameAs;
        }());
        ;
        angular
            .module('customer.core')
            .directive('sameAs', sameAs.factory());
    })(directives = core.directives || (core.directives = {}));
})(core || (core = {}));
//# sourceMappingURL=sameAsValidation.directive.js.map
var core;
(function (core) {
    var directives;
    (function (directives) {
        var workingDay = (function () {
            function workingDay(contractService, $q) {
                var _this = this;
                this.contractService = contractService;
                this.$q = $q;
                this.restrict = 'A';
                this.require = 'ngModel';
                this.link = function (scope, elm, attrs, ngModel) {
                    ngModel.$asyncValidators.workingDay = function (modelValue, viewValue) {
                        if (!viewValue) {
                            return _this.$q.when(true);
                        }
                        var momentValue = moment(viewValue, 'DD-MM-YYYY');
                        if (momentValue.isBefore(new Date(), 'day')) {
                            return _this.$q.reject(false);
                        }
                        var year = momentValue.year();
                        var month = momentValue.month() + 1;
                        var day = momentValue.date();
                        return _this.contractService.isWorkingDay(year, month, day).then(function (response) {
                            if (response.data !== true) {
                                return _this.$q.reject(false);
                            }
                            return _this.$q.when(true);
                        });
                    };
                };
            }
            workingDay.factory = function () {
                var directive = function (contractService, $q) { return new workingDay(contractService, $q); };
                directive.$inject = ['contractService', '$q'];
                return directive;
            };
            return workingDay;
        }());
        angular
            .module('customer.core')
            .directive('workingDay', workingDay.factory());
    })(directives = core.directives || (core.directives = {}));
})(core || (core = {}));
//# sourceMappingURL=workingDayValidation.directive.js.map
var core;
(function (core) {
    var directives;
    (function (directives) {
        var keyValues = (function () {
            function keyValues() {
                this.restrict = 'A';
                this.scope = {
                    keyValuePairs: '=keyValues'
                };
                this.templateUrl = '/App/core/directives/keyValue/keyValue.html';
            }
            keyValues.factory = function () {
                var directive = function () { return new keyValues(); };
                return directive;
            };
            return keyValues;
        }());
        angular
            .module('customer.core')
            .directive('keyValues', keyValues.factory());
    })(directives = core.directives || (core.directives = {}));
})(core || (core = {}));
//# sourceMappingURL=keyValue.directive.js.map
var core;
(function (core) {
    var directives;
    (function (directives) {
        var markdown = (function () {
            function markdown(markdownService) {
                var _this = this;
                this.markdownService = markdownService;
                this.restrict = "A";
                this.scope = {
                    markdown: "="
                };
                this.template = '<span ng-bind-html="html"></span>';
                this.link = function (scope, element, attrs) {
                    scope.$watch(function () { return scope.markdown; }, function (newValue, oldValue) {
                        scope.html = _this.markdownService.toHtml(scope.markdown);
                    });
                };
            }
            markdown.factory = function () {
                var directive = function (markdownService) { return new markdown(markdownService); };
                directive.$inject = ['markdownService'];
                return directive;
            };
            return markdown;
        }());
        angular
            .module("customer.core")
            .directive("markdown", markdown.factory());
    })(directives = core.directives || (core.directives = {}));
})(core || (core = {}));
//# sourceMappingURL=markdown.directive.js.map
var core;
(function (core) {
    var directives;
    (function (directives) {
        var panel = (function () {
            function panel() {
                this.restrict = 'A';
                this.transclude = true;
                this.templateUrl = '/App/core/directives/panel/panel.html';
                this.scope = {
                    panelTitle: '@heading',
                    panelSubTitle: '@subtitle',
                    panelHeroImg: '@hero',
                    panelClass: '@class'
                };
                this.link = function (scope, element, attr) {
                    scope.$watch(function () { return element.attr('heading'); }, function (val) {
                        scope.panelTitle = val;
                    });
                    scope.$watch(function () { return element.attr('subtitle'); }, function (val) {
                        scope.panelSubTitle = val;
                    });
                    scope.panelClass = element.attr('class');
                    element.removeClass();
                };
            }
            panel.factory = function () {
                var directive = function () { return new panel(); };
                return directive;
            };
            return panel;
        }());
        angular
            .module('customer.core')
            .directive('panel', panel.factory());
    })(directives = core.directives || (core.directives = {}));
})(core || (core = {}));
//# sourceMappingURL=panel.directive.js.map
(function () {
    angular
        .module('customer.core')
        .directive('passwordStrength', passwordStrength);

    /* @ngInject */
    function passwordStrength(localize, viewService) {
        return {
            restrict: 'E',
            transclude: true,
            scope: {
            },
            link: function (scope, element, attrs) {
                // Get the localized given values
                scope.infoLabel = localize.getLocalizedString('Info_Text', 'PasswordStrength');
                scope.weakName = localize.getLocalizedString('Weak_Name', 'PasswordStrength');
                scope.fairName = localize.getLocalizedString('Fair_Name', 'PasswordStrength');
                scope.strongName = localize.getLocalizedString('Strong_Name', 'PasswordStrength');
                scope.tooLongName = localize.getLocalizedString('Too_Long_Name', 'PasswordStrength');

                // When the resources are changed, also re-set them
                scope.$on('localizeResourcesUpdated', function () {
                    scope.infoLabel = localize.getLocalizedString('Info_Text', 'PasswordStrength');
                    scope.weakName = localize.getLocalizedString('Weak_Name', 'PasswordStrength');
                    scope.fairName = localize.getLocalizedString('Fair_Name', 'PasswordStrength');
                    scope.strongName = localize.getLocalizedString('Strong_Name', 'PasswordStrength');
                    scope.tooLongName = localize.getLocalizedString('Too_Long_Name', 'PasswordStrength');

                    // We also re-set the current label based on the active class
                    if (element.find('.strength-weak').length > 0) {
                        scope.currLabel = scope.weakName;
                    } else if (element.find('.strength-fair').length > 0) {
                        scope.currLabel = scope.fairName;
                    } else if (element.find('.strength-strong').length > 0) {
                        scope.currLabel = scope.strongName;
                    } else if (element.find('.strength-too-long').length > 0) {
                        scope.currLabel = scope.tooLongName;
                    }
                });

                // Initialize the initial values (weak, we assume there hasn't been anything entered yet)
                scope.strengthClass = 'strength-weak';
                scope.currLabel = scope.weakName;

                // Retrieve the password field from the content wrapped by this directive
                var passwordField = $(element.find('input[type=password]:not(.hidden)')[0]);

                // Calculate the breakpoint where the password is considered strong (minimum length + difference between minimum length and maximum length)
                scope.strongBreak = core.constants.passwordStrength.strongLength;

                // On key up, we validate the password by calling setStrength with the current value
                passwordField.on('keyup', function () {
                    setStrength(passwordField.val());
                });
                
                function setStrength(value) {
                    if (passwordField.hasClass('too-long')) {
                        scope.strengthClass = 'strength-too-long';
                        scope.currLabel = scope.tooLongName;
                    } else if (passwordField.hasClass('ng-valid')) {
                        if (value.length < scope.strongBreak) { // When the password is below 12 characters, it is considered 'fair'
                            scope.strengthClass = 'strength-fair';
                            scope.currLabel = scope.fairName;
                        } else { // Above twelve characters, the password is considered strong
                            scope.strengthClass = 'strength-strong';
                            scope.currLabel = scope.strongName;
                        }
                    } else { // When the password is too short, it's weak
                        scope.strengthClass = 'strength-weak';
                        scope.currLabel = scope.weakName;
                    }
                    scope.$digest(); // We do a digest for an immediate update of the password-strength template
                }
            },
            templateUrl: '/App/core/directives/passwordStrength/passwordStrength.html'
        };
    }
})();
var core;
(function (core) {
    var directives;
    (function (directives) {
        var portalModule = (function () {
            function portalModule(portalModules) {
                var _this = this;
                this.portalModules = portalModules;
                this.restrict = 'A';
                this.scope = true;
                this.link = function ($scope, $element, $attr) {
                    var params = $attr.portalModule;
                    $scope.portalModule = { modulesFound: 0 };
                    if (params) {
                        var modules = [];
                        var operator = "OR";
                        if (params.indexOf(":") > -1) {
                            params = _this.trimElements(params.split(":"));
                            operator = params[0].toUpperCase();
                            modules = _this.trimElements(params[1].split(","));
                        }
                        else {
                            modules.push(params);
                        }
                        if (modules.length > 0) {
                            angular.forEach(modules, function (module) {
                                if (_this.portalModules.data[module]) {
                                    $scope.portalModule.modulesFound++;
                                }
                            });
                            if (operator === "OR" && $scope.portalModule.modulesFound === 0) {
                                $element.remove();
                            }
                            if (operator === "AND" && $scope.portalModule.modulesFound < modules.length) {
                                $element.remove();
                            }
                        }
                    }
                };
            }
            portalModule.prototype.trimElements = function (array) {
                if (!array) {
                    return;
                }
                for (var i = 0; i < array.length; i++) {
                    array[i] = array[i].trim();
                }
                return array;
            };
            portalModule.factory = function () {
                var directive = function (portalModules) { return new portalModule(portalModules); };
                directive.$inject = ['portalModules'];
                return directive;
            };
            return portalModule;
        }());
        angular
            .module('customer.core')
            .directive('portalModule', portalModule.factory());
    })(directives = core.directives || (core.directives = {}));
})(core || (core = {}));
//# sourceMappingURL=portalModule.directive.js.map
var core;
(function (core) {
    var directives;
    (function (directives) {
        var timeSlotController = (function () {
            function timeSlotController($scope) {
                this.$scope = $scope;
                this.$inject = ['$scope'];
                this.initialize();
            }
            timeSlotController.prototype.initialize = function () {
                var _this = this;
                this.$scope.planners = [];
                this.$scope.$watch(function () { return _this.$scope.minDate; }, function () {
                    angular.forEach(_this.$scope.planners, function (planner) {
                        planner.planMode = false;
                    });
                    if (_this.$scope.planners.length >= 1) {
                        _this.$scope.planners[0].initializePicker();
                    }
                });
                this.$scope.$watch(function () {
                    return _this.$scope.maxDate;
                }, function (val) {
                    angular.forEach(_this.$scope.planners, function (planner) {
                        planner.planMode = false;
                    });
                });
            };
            timeSlotController.prototype.registerTimeSlotPlanner = function (planner) {
                this.$scope.planners.push(planner);
                if (this.$scope.planners.length > 1 || this.$scope.expandToPlan) {
                    angular.forEach(this.$scope.planners, function (planner) {
                        planner.expandToPlan = true;
                    });
                }
            };
            timeSlotController.prototype.getMinDate = function (planner) {
                var prevPlanner = null;
                var index = 0;
                var minDate;
                if (this.$scope.minDate) {
                    minDate = moment(this.$scope.minDate);
                }
                else if (planner.minDate) {
                    minDate = moment(planner.minDate);
                }
                else {
                    minDate = moment().add(1, 'days');
                }
                while (planner != this.$scope.planners[index]) {
                    prevPlanner = this.$scope.planners[index];
                    index++;
                }
                if (prevPlanner) {
                    minDate = moment(prevPlanner.ngModel.Date).add(1, 'days');
                }
                if (minDate.day() === 0) {
                    minDate.add(1, 'days');
                }
                else if (minDate.day() === 6) {
                    minDate.add(2, 'days');
                }
                return minDate;
            };
            timeSlotController.prototype.getMaxDate = function (planner) {
                var maxDate;
                if (this.$scope.maxDate) {
                    maxDate = moment(this.$scope.maxDate);
                }
                else {
                    return undefined;
                }
                var index = 0;
                while (planner !== this.$scope.planners[index]) {
                    index++;
                }
                index++;
                if (index < this.$scope.planners.length) {
                    var nextPlanner = this.$scope.planners[index];
                    if (nextPlanner.ngModel && nextPlanner.ngModel.Date) {
                        maxDate = moment(nextPlanner.ngModel.Date).add(-1, 'days');
                    }
                }
                if (planner.maxDate) {
                    if (moment(planner.maxDate).isBefore(maxDate, 'day')) {
                        maxDate = moment(planner.maxDate);
                    }
                }
                return maxDate;
            };
            timeSlotController.prototype.canExpandTimeSlotPlanner = function (planner) {
                var prevPlanner = null;
                for (var index = 0; index < this.$scope.planners.length; index++) {
                    var pl = this.$scope.planners[index];
                    if (pl === planner) {
                        break;
                    }
                    if (!pl.ngModel || !pl.ngModel.Date) {
                        prevPlanner = pl;
                        break;
                    }
                }
                if (!prevPlanner) {
                    for (var index = 0; index < this.$scope.planners.length; index++) {
                        var pl = this.$scope.planners[index];
                        if (pl.planMode) {
                            prevPlanner = pl;
                            break;
                        }
                    }
                }
                if (!prevPlanner) {
                    return true;
                }
                else {
                    var message = prevPlanner.requiredMessage;
                    return message;
                }
            };
            return timeSlotController;
        }());
        directives.timeSlotController = timeSlotController;
        angular
            .module('customer.core')
            .directive('timeSlotController', function () {
            return {
                restrict: 'A',
                scope: {
                    minDate: '=',
                    maxDate: '=',
                    expandToPlan: '='
                },
                controller: timeSlotController
            };
        });
    })(directives = core.directives || (core.directives = {}));
})(core || (core = {}));
//# sourceMappingURL=timeSlotController.directive.js.map
var core;
(function (core) {
    var directives;
    (function (directives) {
        var timeSlotPlanner = (function () {
            function timeSlotPlanner(alerting) {
                var _this = this;
                this.alerting = alerting;
                this.restrict = 'A';
                this.require = '^timeSlotController';
                this.scope = {
                    initialize: '=',
                    ngModel: '=',
                    maxDate: '=',
                    timeSlots: '=',
                    timeSlotsLoading: "=",
                    loadTimeSlots: '=timeSlotLoader',
                    titleResource: '@',
                    requiredMessage: '@',
                    timeSlotDuration: '@',
                    minDate: '='
                };
                this.templateUrl = '/App/core/directives/timeSlotPlanner/timeSlotPlanner.html';
                this.link = {
                    pre: function (scope, element, attr) {
                        scope.datePickerConfig = {
                            weekOnly: true,
                            format: core.constants.dateTimePicker.format,
                            locale: core.constants.dateTimePicker.locale,
                            daysOfWeekDisabled: [0, 6],
                            inline: true
                        };
                        scope.expandToPlan = false;
                        scope.planMode = false;
                        scope.usePopup = false;
                    },
                    post: function (scope, element, attr, timeSlotController) {
                        timeSlotController.registerTimeSlotPlanner(scope);
                        if (attr.initialize !== undefined) {
                            scope.$watch(function () { return scope.initialize; }, function (val) {
                                if (val === true) {
                                    scope.initializePicker();
                                }
                            });
                        }
                        if (attr.maxDate !== undefined) {
                            scope.$watch(function () { return scope.maxDate; }, function (val) {
                                if (scope.planMode) {
                                    var minDate = timeSlotController.getMinDate(scope);
                                    var maxDate = timeSlotController.getMaxDate(scope);
                                    scope.setEnabledDates(minDate, maxDate);
                                }
                            });
                        }
                        scope.initializePicker = function () {
                            var minDate = timeSlotController.getMinDate(scope);
                            scope.selectedDate = minDate;
                            scope.datePickerConfig.minDate = minDate;
                            scope.loadTimeSlots(minDate);
                        };
                        scope.dateChanged = function () {
                            scope.loadTimeSlots(scope.selectedDate);
                        };
                        scope.selectTimeSlot = function (timeSlot) {
                            scope.ngModel = {
                                Date: scope.selectedDate,
                                TimeSlot: timeSlot.Item,
                                Description: timeSlot.Description
                            };
                            scope.planMode = false;
                            setTimeout(function () {
                                if (!$('.hidden-xs').is(':visible')) {
                                    $('#inspectionModal' + scope.$id).off('hide.bs.modal');
                                    $('#inspectionModal' + scope.$id).modal('hide');
                                    scope.calendarShown = false;
                                    scope.usePopup = false;
                                }
                            }, 500);
                        };
                        scope.setEnabledDates = function (minDate, maxDate) {
                            var dates = [];
                            var date = moment(minDate);
                            while (!date.isAfter(maxDate, 'day')) {
                                dates.push(moment(date));
                                date.add(1, 'days');
                            }
                            scope.datePickerConfig.enabledDates = dates;
                        };
                        scope.expandPlanner = function () {
                            var canExpand = timeSlotController.canExpandTimeSlotPlanner(scope);
                            if (canExpand !== true) {
                                _this.alerting.popInfo(canExpand);
                                return;
                            }
                            var minDate = timeSlotController.getMinDate(scope);
                            var maxDate = timeSlotController.getMaxDate(scope);
                            scope.selectedDate = minDate;
                            scope.datePickerConfig.minDate = minDate;
                            scope.loadTimeSlots(minDate);
                            scope.setEnabledDates(minDate, maxDate);
                            if (!$('.hidden-xs').is(':visible')) {
                                scope.usePopup = true;
                            }
                            scope.planMode = true;
                            setTimeout(function () {
                                if (!$('.hidden-xs').is(':visible')) {
                                    $('#inspectionModal' + scope.$id).modal('show');
                                    $('#inspectionModal' + scope.$id).on('hide.bs.modal', function () {
                                        scope.$apply(function () {
                                            scope.planMode = false;
                                            scope.calendarShown = false;
                                            $('#inspectionModal' + scope.$id).off('hide.bs.modal');
                                        });
                                    });
                                }
                            }, 500);
                        };
                        scope.collapsePlanner = function () {
                            scope.planMode = false;
                        };
                    }
                };
            }
            timeSlotPlanner.factory = function () {
                var directive = function (alerting) { return new timeSlotPlanner(alerting); };
                directive.$inject = ['alerting'];
                return directive;
            };
            return timeSlotPlanner;
        }());
        angular
            .module('customer.core')
            .directive('timeSlotPlanner', timeSlotPlanner.factory());
    })(directives = core.directives || (core.directives = {}));
})(core || (core = {}));
//# sourceMappingURL=timeSlotPlanner.directive.js.map
var core;
(function (core) {
    var directives;
    (function (directives) {
        var timeSlotRequired = (function () {
            function timeSlotRequired() {
                this.restrict = 'A';
                this.require = 'ngModel';
                this.link = function (scope, elm, attrs, ngModel) {
                    ngModel.$setPristine();
                    ngModel.$setUntouched();
                    ngModel.$validators[attrs.ngModel] = function (modelValue, viewValue) {
                        var isValid = true;
                        if (!modelValue) {
                            isValid = false;
                        }
                        ngModel.$setValidity('required', isValid);
                        return isValid;
                    };
                    scope.$watch(attrs.ngModel, function () {
                        if (ngModel.$touched && !ngModel.$dirty) {
                            ngModel.$setViewValue(ngModel.$modelValue);
                        }
                        if (ngModel.$modelValue) {
                            if (!ngModel.$touched) {
                                ngModel.$setTouched();
                            }
                        }
                        return ngModel;
                    });
                    ngModel.$validate();
                };
            }
            timeSlotRequired.factory = function () {
                var directive = function () { return new timeSlotRequired(); };
                return directive;
            };
            return timeSlotRequired;
        }());
        angular
            .module('customer.core')
            .directive('timeSlotRequired', timeSlotRequired.factory());
    })(directives = core.directives || (core.directives = {}));
})(core || (core = {}));
//# sourceMappingURL=timeSlotRequired.directive.js.map
var core;
(function (core) {
    var directives;
    (function (directives) {
        var tooltip = (function () {
            function tooltip() {
                this.restrict = 'E';
                this.scope = {
                    tooltipPlacement: '@placement',
                    tooltipContent: '@content',
                    tooltipType: '@type'
                };
                this.templateUrl = '/App/core/directives/tooltip/tooltip.html';
                this.link = function (scope, element, attrs) {
                    scope.tooltipType = scope.tooltipType || 'default';
                    scope.tooltipPlacement = scope.tooltipPlacement || 'top';
                    scope.$watch(function () { return element.attr('content'); }, function (val) {
                        scope.tooltipContent = val;
                    });
                    setTimeout(function () {
                        $("[data-toggle=custompopover]").custompopover();
                    }, 100);
                };
            }
            tooltip.factory = function () {
                var directive = function () { return new tooltip(); };
                return directive;
            };
            return tooltip;
        }());
        angular
            .module('customer.core')
            .directive('tooltip', tooltip.factory());
    })(directives = core.directives || (core.directives = {}));
})(core || (core = {}));
//# sourceMappingURL=tooltip.directive.js.map
var core;
(function (core) {
    var directives;
    (function (directives) {
        var tooltipInitializer = (function () {
            function tooltipInitializer() {
                this.restrict = 'A';
                this.link = function (scope, element, attrs) {
                    setTimeout(function () {
                        if (!('ontouchstart' in document.documentElement)) {
                            var options = null;
                            if (attrs.popoverClass) {
                                options = { "popoverClass": attrs.popoverClass };
                            }
                            ;
                            element.custompopover(options);
                        }
                    }, 250);
                };
            }
            tooltipInitializer.factory = function () {
                var directive = function () { return new tooltipInitializer(); };
                return directive;
            };
            return tooltipInitializer;
        }());
        angular
            .module('customer.core')
            .directive('tooltipInitializer', tooltipInitializer.factory());
    })(directives = core.directives || (core.directives = {}));
})(core || (core = {}));
//# sourceMappingURL=tooltipInitializer.directive.js.map
var core;
(function (core) {
    var constants = (function () {
        function constants() {
        }
        return constants;
    }());
    constants.passwordValidation = {
        minLength: 8,
        maxLength: 64,
        minLower: 1,
        minUpper: 1,
        minDigits: 1,
        minNonAlphanumeric: 1
    };
    constants.passwordStrength = {
        strongLength: 12
    };
    constants.paging = {
        maxPages: 5,
        itemsPerPage: 7
    };
    constants.showToasts = true;
    constants.httpStatusCodes = {
        BadRequest: "400",
        Gone: "410",
        UnauthenticatedAjaxCall: "419",
        NotFound: "404",
        Forbidden: "403"
    };
    constants.dateTimePicker = {
        locale: 'nl',
        format: 'DD-MM-YYYY'
    };
    constants.paymentArrangement = {
        remainingAmount: {
            NA: 0,
            asAnExtraTerm: 1,
            settleWithFirstTerm: 2,
            settleWithLastTerm: 3
        }
    };
    constants.gender = {
        male: "1",
        female: "2"
    };
    constants.labels = {
        unknownValue: "Value_Unkown"
    };
    core.constants = constants;
})(core || (core = {}));
//# sourceMappingURL=constants.js.map
var core;
(function (core) {
    var services;
    (function (services) {
        var dataservice = (function () {
            function dataservice($http, logger, $rootScope) {
                var _this = this;
                this.$http = $http;
                this.logger = logger;
                this.$rootScope = $rootScope;
                this.errorCallback = function (response) {
                    var error = {
                        success: false,
                        message: response.data.Message || response.data,
                        code: response.status,
                        fullMessage: response.data.ExceptionMessage || null
                    };
                    _this.logger.error(error);
                    if (response.status == 403) {
                        var url = '/account/logoff';
                        _this.postData(url, null, null);
                        _this.$rootScope.$emit("customerPortalUnauthorizedAccess");
                    }
                    return error;
                };
            }
            dataservice.prototype.getData = function (url, needsCaching) {
                var _this = this;
                return this.$http.get(url, { cache: needsCaching })
                    .then(function (data) {
                    if (data.data.success === false) {
                        _this.logger.error(data.data);
                        return data;
                    }
                    _this.logger.info('Got response from ' + data.config.url);
                    return data.data;
                })
                    .catch(this.errorCallback);
            };
            dataservice.prototype.postData = function (url, data, config) {
                var _this = this;
                this.logger.info('Post request to URL: ' + url);
                return this.$http.post(url, data, config)
                    .then(function (data) {
                    if (data.data.success === false) {
                        _this.logger.error(data.data);
                        return data;
                    }
                    _this.logger.info('Successfully posted to: ' + data.config.url);
                    return data.data;
                })
                    .catch(this.errorCallback);
            };
            dataservice.prototype.putData = function (url, data) {
                var _this = this;
                this.logger.info('Put request to URL: ' + url);
                return this.$http.put(url, data)
                    .then(function (data) {
                    if (data.data.success === false) {
                        _this.logger.error(data.data);
                        return data;
                    }
                    _this.logger.info('Successfully put to: ' + data.config.url);
                    return data.data;
                })
                    .catch(this.errorCallback);
            };
            dataservice.prototype.deleteData = function (url, data) {
                var _this = this;
                this.logger.info('Delete request to URL: ' + url);
                return this.$http.delete(url, data)
                    .then(function (data) {
                    if (data.data.success === false) {
                        _this.logger.error(data.data);
                        return data;
                    }
                    _this.logger.info('Successfully delete to: ' + data.config.url);
                    return data.data;
                })
                    .catch(this.errorCallback);
            };
            dataservice.prototype.downloadFile = function (url, data, config) {
                return this.$http.post(url, data, config);
            };
            return dataservice;
        }());
        services.dataservice = dataservice;
        angular
            .module('customer.core')
            .service('dataservice', dataservice);
    })(services = core.services || (core.services = {}));
})(core || (core = {}));
//# sourceMappingURL=dataservice.js.map
(function() {
    'use strict';

    angular
        .module('customer.core')
        .config(errorConfiguration);

    function handler($delegate, $injector) {
            return function(exception, cause) {
                $delegate(exception, cause);
                var logger = $injector.get('logger');
                logger.error(exception.message);

            };
    }

    handler.$inject = ["$delegate", "$injector"];
    /* @ngInject */
    function errorConfiguration($provide) {
        /* jshint validthis:true */
        $provide.decorator("$exceptionHandler", handler );
    }

    errorConfiguration.$inject = ["$provide"];

})();
var core;
(function (core) {
    var services;
    (function (services) {
        var logger = (function () {
            function logger($log, alerting) {
                this.$log = $log;
                this.alerting = alerting;
                this.showToasts = core.constants.showToasts;
                this.log = this.$log.log;
            }
            logger.prototype.error = function (message, data, title) {
                this.alerting.toastError(message, 'Error');
                this.$log.error('Error: ' + message, data);
            };
            logger.prototype.info = function (message, data, title) {
                this.alerting.toastInfo(message, "Info");
                this.$log.info('Info: ' + message, data);
            };
            logger.prototype.success = function (message, data, title) {
                this.alerting.toastSuccess(message, title);
                this.$log.info('Success: ' + message, data);
            };
            logger.prototype.warning = function (message, data, title) {
                this.alerting.toastWarning(message, title);
                this.$log.warn('Warning: ' + message, data);
            };
            return logger;
        }());
        services.logger = logger;
        angular
            .module('customer.core')
            .service('logger', logger);
    })(services = core.services || (core.services = {}));
})(core || (core = {}));
//# sourceMappingURL=logger.js.map
var portals = {};

portals.utils = (function () {
    return {
        getUrlParams: getUrlParams
    };

    function getUrlParams(url) {
        var re = /(?:\?|&(?:amp;)?)([^=&#]+)(?:=?([^&#]*))/g;
        var match, params = {};

        var decode = function (s) {
            return decodeURIComponent(s.replace(/\+/g, " "));
        };

        while (match = re.exec(url)) {
            params[decode(match[1])] = decode(match[2]);
        }

        return params;
    }
})();

var core;
(function (core) {
    var services;
    (function (services) {
        var alerting = (function () {
            function alerting($uibModal, toastr, toastrEnabled, $injector) {
                this.$uibModal = $uibModal;
                this.toastr = toastr;
                this.toastrEnabled = toastrEnabled;
                this.$injector = $injector;
                this.$inject = ['$uibModal', 'toastr', 'toastrEnabled', '$injector'];
            }
            alerting.prototype.popError = function (message, title) {
                if (!title) {
                    title = this.defaultTitle();
                }
                var options = {
                    templateUrl: '/App/core/alerting/error.html',
                    controller: function () {
                        this.message = message;
                        this.title = title;
                    },
                    controllerAs: 'model'
                };
                return this.$uibModal.open(options).result;
            };
            alerting.prototype.popInfo = function (message, title) {
                if (!title) {
                    title = this.defaultTitle();
                }
                var options = {
                    templateUrl: '/App/core/alerting/info.html',
                    controller: function () {
                        this.message = message;
                        this.title = title;
                    },
                    controllerAs: 'model'
                };
                return this.$uibModal.open(options).result;
            };
            alerting.prototype.popInfoMarkdown = function (message, title) {
                if (!title) {
                    title = this.defaultTitle();
                }
                var options = {
                    templateUrl: '/App/core/alerting/infoMarkdown.html',
                    controller: function () {
                        this.message = message;
                        this.title = title;
                    },
                    controllerAs: 'model'
                };
                return this.$uibModal.open(options).result;
            };
            alerting.prototype.toastError = function (message, title) {
                if (this.toastrEnabled === false) {
                    return;
                }
                this.toastr.error(message, title);
            };
            alerting.prototype.toastInfo = function (message, title) {
                if (this.toastrEnabled === false) {
                    return;
                }
                this.toastr.info(message, title);
            };
            alerting.prototype.toastSuccess = function (message, title) {
                if (this.toastrEnabled === false) {
                    return;
                }
                this.toastr.success(message, title);
            };
            alerting.prototype.toastWarning = function (message, title) {
                if (this.toastrEnabled === false) {
                    return;
                }
                this.toastr.warning(message, title);
            };
            alerting.prototype.confirm = function (message, title, buttonYes, buttonNo, modalSize, buttonsOnDifferentLinesXs) {
                if (!title) {
                    title = this.defaultTitle();
                }
                var alerting = this;
                var options = {
                    templateUrl: '/App/core/alerting/confirm.html',
                    controller: function () {
                        this.message = message;
                        this.title = title;
                        this.buttonYes = buttonYes || alerting.getResourceString("Button_Yes");
                        this.buttonNo = buttonNo || alerting.getResourceString("Button_No");
                        this.buttonsOnDifferentLinesXs = buttonsOnDifferentLinesXs;
                    },
                    controllerAs: 'model'
                };
                if (modalSize) {
                    options.size = modalSize;
                }
                return this.$uibModal.open(options).result;
            };
            alerting.prototype.showModal = function (options) {
                return this.$uibModal.open(options).result;
            };
            alerting.prototype.defaultTitle = function () {
                var localize = this.$injector.get("localize");
                return localize.getLocalizedString("Dialog_DefaultTitle", "Generic");
            };
            alerting.prototype.getResourceString = function (key, values) {
                var localize = this.$injector.get("localize");
                return localize.getLocalizedString(key, "Generic", values);
            };
            return alerting;
        }());
        services.alerting = alerting;
        angular
            .module('customer.core')
            .service('alerting', alerting);
    })(services = core.services || (core.services = {}));
})(core || (core = {}));
//# sourceMappingURL=alerting.js.map
/* ========================================================================
 * Custom datetimepicker js file which, kind of, extends the bootstrap-datetimepicker
 * The way the original plugin was set up, it was quite hard to porperly extend the original plugin.
 * This was the best I could do and it gets the job done.
 * 
 * Functionality-wise, everything works the same, styling-wise, everything is different
 * 
 * http://eonasdan.github.io/bootstrap-datetimepicker/
 * ======================================================================== */


(function () {
    'use strict';

    var extendedMethods = {
        customdatepicker: function (options) {
            this.each(function () {
                var $dateInput = $(this);
                var isWeekOnly = options.weekOnly;
                delete options.weekOnly;
                $dateInput.datetimepicker(options);
                if (isWeekOnly) {
                    $dateInput.on('dp.show', function () {
                        $($dateInput.siblings('.bootstrap-datetimepicker-widget')[0]).addClass('week');
                        $($dateInput.siblings('.bootstrap-datetimepicker-widget')[0]).find('.picker-switch').attr('colspan', '3');
                    });
                }
            });
        }
    };

    $.fn.extend(extendedMethods);
    
})();

/* ========================================================================
 * Custom popover js file which extends the default bootstrap popover
 * 
 * http://getbootstrap.com/javascript/#popovers
 * ======================================================================== */


(function () {
    'use strict';

    // POPOVER PUBLIC CLASS DEFINITION
    // ===============================

    var CustomPopover = function (element, options) {
        this.init('popover', element, options);
    };
    
    if (!$.fn.popover) throw new Error('CustomPopover requires popover.js');

    CustomPopover.VERSION = '3.3.5';

    CustomPopover.DEFAULTS = $.extend({}, $.fn.popover.Constructor.DEFAULTS, {
        placement: 'bottom',
        trigger: 'click',
        type: 'default'
    });


    // NOTE: CUSTOM POPOVER EXTENDS popover.js
    // ================================

    var _setContent = $.fn.popover.Constructor.prototype.setContent;
    var _applyPlacement = $.fn.popover.Constructor.prototype.applyPlacement;
    var _show = $.fn.popover.Constructor.prototype.show;

    CustomPopover.prototype = $.extend({}, $.fn.popover.Constructor.prototype);

    CustomPopover.prototype.constructor = CustomPopover;

    CustomPopover.prototype.getDefaults = function () {
        return CustomPopover.DEFAULTS;
    };

    CustomPopover.prototype.setContent = function () {
        _setContent.apply(this, arguments);

        var $tip = this.tip();
        var content = this.getContent();

        $tip.addClass(this.options.type);

        $tip.find('.popover-content').empty();
        switch (this.options.type) {
            case 'danger':
                $tip.find('.popover-content').prepend('<span class="glyphicon glyphicon-exclamation-sign"></span>');
                break;
            default:
                $tip.find('.popover-content').prepend('<span class="glyphicon glyphicon-info-sign"></span>');
                break;
        }

        if (typeof content == 'string') {
            $tip.find('.popover-content').append('<div class="actual_content">' + content + '</div>');
        }

        var popoverClass = this.options["bs.custompopover"].options.popoverClass;
        if (popoverClass) {
            $tip.addClass(popoverClass);
        }
    };

    CustomPopover.prototype.replaceArrow = function (delta, dimension, isVertical) {
        var $tip = this.tip();

        var $panel = $(this.getParentFromRoot($tip));
        var $tipIcon = $($tip.siblings('a')[0]);
        if (!$tipIcon || $tipIcon.length == 0) {
            $tipIcon = $($tip.siblings('button')[0]);
        }

        var tooltipWidth = $panel.innerWidth();
        var innerLeft = $tipIcon.offset().left - $panel.offset().left;

        var iconMargin = parseInt($tipIcon.css('padding-left')) + parseInt($tipIcon.css('padding-right')) + parseInt($tipIcon.css('margin-left')) + parseInt($tipIcon.css('margin-right'));

        if (innerLeft < (tooltipWidth / 2)) { // When the icon position is lower than half of the panel width, we can assume the arrow will be on the left side of the panel
            this.arrow().addClass('right');
            innerLeft += iconMargin;
        } else {
            innerLeft += (iconMargin / 2);
        }

        this.arrow().css({
            left: innerLeft + 'px'
        });
    };

    CustomPopover.prototype.getParentFromRoot = function ($childElement) {
        var parents = $childElement.parents('.panel');
        return parents[parents.length - 1];
    };

    CustomPopover.prototype.show = function () {
        _show.apply(this, arguments);

        var $tip = this.tip();
        // We detach the tooltip from it's original location...
        $tip.detach();
        // ... And we add it to the body, which allows for better positioning
        $('body').append($tip);
    };

    CustomPopover.prototype.applyPlacement = function (offset, placement) {
        _applyPlacement.apply(this, arguments);

        var $tip = this.tip();

        var $panel = $(this.getParentFromRoot($tip));
        var $tipIcon = $($tip.siblings('a')[0]);
        if (!$tipIcon || $tipIcon.length == 0) {
            $tipIcon = $($tip.siblings('button')[0]);
        }
        var tooltipWidth = $panel.innerWidth();

        $tip.css({
            width: tooltipWidth // This sets the tooltip width
        });

        if (placement === 'bottom') { // If the tooltip should be placed on the bottom...
            // Increase the top with the height of the tooltip icon and half the height of the arrow
            $tip.css({
                top: ($tipIcon.offset().top + $tipIcon.outerHeight()) + 10 + 'px'
            });
        } else { // If the tooltip should be placed on the top
            // Decrease the top with the height of the tooltip icon and the height of the arrow
            $tip.css({
                top: ($tipIcon.offset().top - $tipIcon.outerHeight()) - 20 + 'px'
            });
        }

        $tip.css({
            left: $panel.offset().left + 'px'
        });

        this.replaceArrow();
    };

    // POPOVER PLUGIN DEFINITION
    // =========================

    function Plugin(option) {
        return this.each(function () {
            var $this = $(this);
            var data = $this.data('bs.custompopover');
            var options = typeof option == 'object' && option;

            if (!data && /destroy|hide/.test(option)) return;
            if (!data) $this.data('bs.custompopover', (data = new CustomPopover(this, options)));
            if (typeof option == 'string') data[option]();
        });
    }

    var old = $.fn.custompopover;

    $.fn.custompopover = Plugin;
    $.fn.custompopover.Constructor = CustomPopover;


    // POPOVER NO CONFLICT
    // ===================

    $.fn.custompopover.noConflict = function () {
        $.fn.custompopover = old;
        return this;
    };

})();

/*! ========================================================================
 * Bootstrap Toggle: bootstrap-toggle.js v2.2.0
 * http://www.bootstraptoggle.com
 * ========================================================================
 * Copyright 2014 Min Hur, The New York Times Company
 * Licensed under MIT
 * ======================================================================== */


 (function () {
 	'use strict';

	// TOGGLE PUBLIC CLASS DEFINITION
	// ==============================

 	var Toggle = function (element, options) {
 	    this.$element = $(element);
 	    this.options = $.extend({}, this.defaults(), options);
 	    this.render();
 	};

	Toggle.VERSION = '2.2.0';

	Toggle.DEFAULTS = {
	    on: 'Ja',
	    off: 'Nee',
	    onstyle: 'primary',
	    offstyle: 'default',
	    size: 'normal',
	    style: '',
	    width: null,
	    height: null
	};

	Toggle.prototype.defaults = function () {
	    return {
	        on: this.$element.attr('data-on') || Toggle.DEFAULTS.on,
	        off: this.$element.attr('data-off') || Toggle.DEFAULTS.off,
	        onstyle: this.$element.attr('data-onstyle') || Toggle.DEFAULTS.onstyle,
	        offstyle: this.$element.attr('data-offstyle') || Toggle.DEFAULTS.offstyle,
	        size: this.$element.attr('data-size') || Toggle.DEFAULTS.size,
	        style: this.$element.attr('data-style') || Toggle.DEFAULTS.style,
	        width: this.$element.attr('data-width') || Toggle.DEFAULTS.width,
	        height: this.$element.attr('data-height') || Toggle.DEFAULTS.height
	    };
	};

	Toggle.prototype.render = function () {
	    this._onstyle = 'btn-' + this.options.onstyle;
	    this._offstyle = 'btn-' + this.options.offstyle;
	    var size = this.options.size === 'large' ? 'btn-lg'
			: this.options.size === 'small' ? 'btn-sm'
			: this.options.size === 'mini' ? 'btn-xs'
			: '';
	    var $toggleOn = $('<label class="btn">').html(this.options.on)
			.addClass(this._onstyle + ' ' + size);
	    var $toggleOff = $('<label class="btn">').html(this.options.off)
			.addClass(this._offstyle + ' ' + size + ' active');
	    var $toggleHandle = $('<span class="toggle-handle btn btn-default">')
			.addClass(size);
	    var $toggleGroup = $('<div class="toggle-group">')
			.append($toggleOn, $toggleOff, $toggleHandle);
	    var $toggle = $('<div class="toggle btn" data-toggle="toggle">')
			.addClass(this.$element.prop('checked') ? this._onstyle : this._offstyle + ' off')
			.addClass(size).addClass(this.options.style);

	    this.$element.wrap($toggle);
	    $.extend(this, {
	        $toggle: this.$element.parent(),
	        $toggleOn: $toggleOn,
	        $toggleOff: $toggleOff,
	        $toggleGroup: $toggleGroup
	    });
	    this.$toggle.append($toggleGroup);

	    var width = this.options.width || Math.max($toggleOn.outerWidth(), $toggleOff.outerWidth()) + ($toggleHandle.outerWidth() / 2);
	    var height = this.options.height || Math.max($toggleOn.outerHeight(), $toggleOff.outerHeight());
	    $toggleOn.addClass('toggle-on');
	    $toggleOff.addClass('toggle-off');
	    this.$toggle.css({ width: width, height: height });
	    if (this.options.height) {
	        $toggleOn.css('line-height', $toggleOn.height() + 'px');
	        $toggleOff.css('line-height', $toggleOff.height() + 'px');
	    }
	    this.update(true);
	    this.trigger(true);
	};

	Toggle.prototype.toggle = function () {
	    if (this.$element.prop('checked')) this.off();
	    else this.on();
	};

	Toggle.prototype.on = function (silent) {
	    if (this.$element.prop('disabled')) return false;
	    this.$toggle.removeClass(this._offstyle + ' off').addClass(this._onstyle);
	    this.$element.prop('checked', true);
	    if (!silent) this.trigger();
	};

	Toggle.prototype.off = function (silent) {
	    if (this.$element.prop('disabled')) return false;
	    this.$toggle.removeClass(this._onstyle).addClass(this._offstyle + ' off');
	    this.$element.prop('checked', false);
	    if (!silent) this.trigger();
	};

	Toggle.prototype.enable = function () {
	    this.$toggle.removeAttr('disabled');
	    this.$element.prop('disabled', false);
	};

	Toggle.prototype.disable = function () {
	    this.$toggle.attr('disabled', 'disabled');
	    this.$element.prop('disabled', true);
	};

	Toggle.prototype.update = function (silent) {
	    if (this.$element.prop('disabled')) this.disable();
	    else this.enable();
	    if (this.$element.prop('checked')) this.on(silent);
	    else this.off(silent);
	};

	Toggle.prototype.trigger = function (silent) {
	    this.$element.off('change.bs.toggle');
	    if (!silent) this.$element.change();
	    this.$element.on('change.bs.toggle', $.proxy(function () {
	        this.update();
	    }, this));
	};

	Toggle.prototype.destroy = function () {
	    this.$element.off('change.bs.toggle');
	    this.$toggleGroup.remove();
	    this.$element.removeData('bs.toggle');
	    this.$element.unwrap();
	};

	// TOGGLE PLUGIN DEFINITION
	// ========================

	function Plugin(option) {
	    return this.each(function () {
	        var $this = $(this);
	        var data = $this.data('bs.toggle');
	        var options = typeof option == 'object' && option;

	        if (!data) $this.data('bs.toggle', (data = new Toggle(this, options)));
	        if (typeof option == 'string' && data[option]) data[option]();
	    });
	}

	var old = $.fn.bootstrapToggle;

	$.fn.bootstrapToggle = Plugin;
	$.fn.bootstrapToggle.Constructor = Toggle;

	// TOGGLE NO CONFLICT
	// ==================

	$.fn.toggle.noConflict = function () {
	    $.fn.bootstrapToggle = old;
	    return this;
	};

	// TOGGLE DATA-API
	// ===============

	//$(function() {
	//	$('input[type=checkbox][data-toggle^=toggle]').bootstrapToggle()
	//})

	$(document).on('click.bs.toggle', 'div[data-toggle^=toggle]', function (e) {
	    var $checkbox = $(this).find('input[type=checkbox]');
	    $checkbox.bootstrapToggle('toggle');
	    e.preventDefault();
	});

 })();

var core;
(function (core) {
    var config;
    (function (config) {
        angular
            .module('customer.core')
            .config(['cfpLoadingBarProvider', function (cfpLoadingBarProvider) {
                cfpLoadingBarProvider.includeSpinner = false;
            }]);
    })(config = core.config || (core.config = {}));
})(core || (core = {}));
//# sourceMappingURL=angularloadingbar.config.js.map
var core;
(function (core) {
    var config;
    (function (config) {
        angular
            .module('customer')
            .config(['$httpProvider', function ($httpProvider) {
                $httpProvider.interceptors.push('statusCode');
                if (!$httpProvider.defaults.headers.get) {
                    $httpProvider.defaults.headers.get = {};
                }
                $httpProvider.defaults.headers
                    .common['X-Requested-With'] = 'XMLHttpRequest';
                $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
                $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
                $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
            }]);
    })(config = core.config || (core.config = {}));
})(core || (core = {}));
//# sourceMappingURL=httpbackend.config.js.map
var core;
(function (core) {
    var filters;
    (function (filters) {
        var capitalizeFilter = (function () {
            function capitalizeFilter() {
            }
            capitalizeFilter.factory = function () {
                var factoryFunction = function () {
                    return function (input) {
                        if (input && angular.isString(input) && input.length > 0) {
                            return input[0].toUpperCase() + input.substr(1).toLowerCase();
                        }
                        return input;
                    };
                };
                return factoryFunction;
            };
            return capitalizeFilter;
        }());
        filters.capitalizeFilter = capitalizeFilter;
        angular
            .module('customer.core')
            .filter('capitalize', capitalizeFilter.factory());
    })(filters = core.filters || (core.filters = {}));
})(core || (core = {}));
//# sourceMappingURL=capitalize.filter.js.map
var core;
(function (core) {
    var filters;
    (function (filters) {
        var groupByDateFilter = (function () {
            function groupByDateFilter() {
            }
            groupByDateFilter.factory = function () {
                var factoryFunction = function ($filter) {
                    return function (collection, property) {
                        if (!angular.isObject(collection) || angular.isUndefined(property)) {
                            return collection;
                        }
                        var result = {};
                        angular.forEach(collection, function (elm) {
                            var prop = elm[property];
                            prop = $filter('date')(prop, 'dd-MM-yyyy');
                            if (!result[prop]) {
                                result[prop] = [];
                            }
                            result[prop].push(elm);
                        });
                        return result;
                    };
                };
                factoryFunction.$inject = ['$filter'];
                return factoryFunction;
            };
            return groupByDateFilter;
        }());
        filters.groupByDateFilter = groupByDateFilter;
        angular
            .module('customer.core')
            .filter('groupByDate', groupByDateFilter.factory());
    })(filters = core.filters || (core.filters = {}));
})(core || (core = {}));
//# sourceMappingURL=groupByDate.filter.js.map
var core;
(function (core) {
    var filters;
    (function (filters) {
        var groupByElementFilter = (function () {
            function groupByElementFilter() {
            }
            groupByElementFilter.Factory = function () {
                var factoryFunction = function ($filter) {
                    return function (collection, property) {
                        if (!angular.isObject(collection) || angular.isUndefined(property)) {
                            return collection;
                        }
                        var result = {};
                        angular.forEach(collection, function (elm) {
                            var prop = elm[property];
                            if (!result[prop]) {
                                result[prop] = [];
                            }
                            result[prop].push(elm);
                        });
                        return result;
                    };
                };
                factoryFunction.$inject = ['$filter'];
                return factoryFunction;
            };
            return groupByElementFilter;
        }());
        filters.groupByElementFilter = groupByElementFilter;
        angular
            .module('customer.core')
            .filter('groupByElement', groupByElementFilter.Factory());
    })(filters = core.filters || (core.filters = {}));
})(core || (core = {}));
//# sourceMappingURL=groupByElement.filter.js.map
var core;
(function (core) {
    var filters;
    (function (filters) {
        var notAfterTodayFilter = (function () {
            function notAfterTodayFilter() {
            }
            notAfterTodayFilter.Factory = function () {
                var factoryFunction = function () {
                    return function (collection, property) {
                        if (!angular.isObject(collection) || angular.isUndefined(property)) {
                            return collection;
                        }
                        var result = [];
                        angular.forEach(collection, function (elm) {
                            var prop = elm[property];
                            prop = new moment(prop);
                            if (prop.isBefore(new moment(), 'day') || prop.isSame(new moment(), 'day')) {
                                result.push(elm);
                            }
                        });
                        return result;
                    };
                };
                return factoryFunction;
            };
            return notAfterTodayFilter;
        }());
        filters.notAfterTodayFilter = notAfterTodayFilter;
        angular
            .module('customer.core')
            .filter('notAfterToday', notAfterTodayFilter.Factory());
    })(filters = core.filters || (core.filters = {}));
})(core || (core = {}));
//# sourceMappingURL=notAfterToday.filter.js.map
var core;
(function (core) {
    var filters;
    (function (filters) {
        var rangeFilter = (function () {
            function rangeFilter() {
            }
            rangeFilter.factory = function () {
                var factoryFunction = function () {
                    return function (input, start, end) {
                        var low = parseInt(start);
                        var high = parseInt(end);
                        var result = [];
                        for (var i = low; i <= high; i++) {
                            result.push(i);
                        }
                        return result;
                    };
                };
                return factoryFunction;
            };
            ;
            return rangeFilter;
        }());
        filters.rangeFilter = rangeFilter;
        angular
            .module('customer.core')
            .filter('range', rangeFilter.factory());
    })(filters = core.filters || (core.filters = {}));
})(core || (core = {}));
//# sourceMappingURL=range.filter.js.map
var core;
(function (core) {
    var filters;
    (function (filters) {
        var utcToLocal = (function () {
            function utcToLocal() {
            }
            utcToLocal.factory = function () {
                var factoryFunction = function ($filter) {
                    return function (utcDateString, format) {
                        if (!utcDateString) {
                            return;
                        }
                        if (utcDateString.indexOf('Z') === -1 && utcDateString.indexOf('+') === -1) {
                            utcDateString += 'Z';
                        }
                        return $filter('date')(utcDateString, format);
                    };
                };
                factoryFunction.$inject = ['$filter'];
                return factoryFunction;
            };
            return utcToLocal;
        }());
        filters.utcToLocal = utcToLocal;
        angular
            .module('customer.core')
            .filter('utcToLocal', utcToLocal.factory());
    })(filters = core.filters || (core.filters = {}));
})(core || (core = {}));
//# sourceMappingURL=utcToLocal.filter.js.map
var core;
(function (core) {
    var factory;
    (function (factory_1) {
        var statusCode = (function () {
            function statusCode($q, $window) {
                var _this = this;
                this.$q = $q;
                this.$window = $window;
                this.responseError = function (rejection) {
                    var defer = _this.$q.defer();
                    if (rejection.status == core.constants.httpStatusCodes.UnauthenticatedAjaxCall) {
                        _this.$window.location.reload();
                    }
                    defer.reject(rejection);
                    return defer.promise;
                };
            }
            statusCode.factory = function () {
                var factory = function ($q, $window) { return new statusCode($q, $window); };
                factory.$inject = ['$q', '$window'];
                return factory;
            };
            return statusCode;
        }());
        angular.module('customer')
            .factory('statusCode', statusCode.factory());
    })(factory = core.factory || (core.factory = {}));
})(core || (core = {}));
//# sourceMappingURL=statusCode.interceptor.js.map
var core;
(function (core) {
    var directives;
    (function (directives) {
        var i18nAttr = (function () {
            function i18nAttr(localize, viewService) {
                var _this = this;
                this.localize = localize;
                this.viewService = viewService;
                this.restrict = "EAC";
                this.link = function (scope, elm, attrs) {
                    var deregisterOnLocalizeResourcesUpdated;
                    var deregisterObserveI18nAttr;
                    deregisterOnLocalizeResourcesUpdated = scope.$on('localizeResourcesUpdated', function () {
                        _this.updateText(elm, attrs.i18nAttr);
                    });
                    deregisterObserveI18nAttr = attrs.$observe('i18nAttr', function (value) {
                        if (!attrs.$$observers.i18nAttr || attrs.$$observers.i18nAttr.length === 0) {
                            return;
                        }
                        _this.updateText(elm, value);
                    });
                    elm.on('$destroy', function () {
                        deregisterOnLocalizeResourcesUpdated();
                        deregisterObserveI18nAttr();
                    });
                };
            }
            i18nAttr.prototype.updateText = function (elm, token) {
                var values = token.split('|');
                var viewName = this.viewService.getViewName(elm);
                var tag = this.localize.getLocalizedString(values[0], viewName);
                if ((tag !== null) && (tag !== undefined) && (tag !== '')) {
                    if (values.length > 2) {
                        for (var index = 2; index < values.length; index++) {
                            var target = '{' + (index - 2) + '}';
                            tag = tag.replace(target, values[index]);
                        }
                    }
                    elm.attr(values[1], tag);
                }
            };
            i18nAttr.factory = function () {
                var directive = function (localize, viewService) { return new i18nAttr(localize, viewService); };
                directive.$inject = ['localize', 'viewService'];
                return directive;
            };
            return i18nAttr;
        }());
        angular
            .module('customer.core')
            .directive('i18nAttr', i18nAttr.factory());
    })(directives = core.directives || (core.directives = {}));
})(core || (core = {}));
//# sourceMappingURL=i18n-attr.js.map
var core;
(function (core) {
    var directives;
    (function (directives) {
        var i18nVisibleIf = (function () {
            function i18nVisibleIf(localize, viewService) {
                var _this = this;
                this.localize = localize;
                this.viewService = viewService;
                this.restrict = "EAC";
                this.link = function (scope, elm, attrs) {
                    var deregisterOnLocalizeResourcesUpdated;
                    var deregisterObserveI18nVisibleIf;
                    deregisterOnLocalizeResourcesUpdated = scope.$on('localizeResourcesUpdated', function () {
                        _this.updateText(elm, attrs.i18nVisibleIf);
                    });
                    deregisterObserveI18nVisibleIf = attrs.$observe('i18nVisibleIf', function (value) {
                        if (!attrs.$$observers.i18nVisibleIf || attrs.$$observers.i18nVisibleIf.length === 0) {
                            return;
                        }
                        _this.updateText(elm, value);
                    });
                    elm.on('$destroy', function () {
                        deregisterOnLocalizeResourcesUpdated();
                        deregisterObserveI18nVisibleIf();
                    });
                };
            }
            i18nVisibleIf.prototype.updateText = function (elm, token) {
                var values = token.split('|');
                var visible = true;
                var viewName = this.viewService.getViewName(elm);
                var tag = this.localize.getLocalizedString(values[0], viewName);
                if ((tag !== null) && (tag !== undefined) && (tag !== '')) {
                    visible = true;
                }
                else {
                    visible = false;
                }
                elm.attr("style", "display:" + (visible ? 'block' : 'none'));
            };
            i18nVisibleIf.factory = function () {
                var directive = function (localize, viewService) { return new i18nVisibleIf(localize, viewService); };
                directive.$inject = ['localize', 'viewService'];
                return directive;
            };
            return i18nVisibleIf;
        }());
        angular
            .module('customer.core')
            .directive('i18nVisibleIf', i18nVisibleIf.factory());
    })(directives = core.directives || (core.directives = {}));
})(core || (core = {}));
//# sourceMappingURL=i18n-visible-if.js.map
var core;
(function (core) {
    var directives;
    (function (directives) {
        var i18n = (function () {
            function i18n(localize, viewService) {
                var _this = this;
                this.localize = localize;
                this.viewService = viewService;
                this.link = function (scope, elm, attrs) {
                    var deregisterOnLocalizeResourcesUpdated;
                    var deregisterObserveI18n;
                    deregisterOnLocalizeResourcesUpdated = scope.$on('localizeResourcesUpdated', function () {
                        _this.updateText(elm, attrs.i18n);
                    });
                    deregisterObserveI18n = attrs.$observe('i18n', function (value) {
                        if (!attrs.$$observers.i18n || attrs.$$observers.i18n.length === 0) {
                            return;
                        }
                        _this.updateText(elm, attrs.i18n);
                    });
                    elm.on('$destroy', function () {
                        deregisterOnLocalizeResourcesUpdated();
                        deregisterObserveI18n();
                    });
                };
            }
            i18n.prototype.updateText = function (elm, token) {
                var values = token.split('|');
                if (values.length >= 1) {
                    var viewName = this.viewService.getViewName(elm);
                    var tag = this.localize.getLocalizedString(values[0], viewName);
                    if ((tag !== null) && (tag !== undefined) && (tag !== '')) {
                        if (values.length > 1) {
                            for (var index = 1; index < values.length; index++) {
                                var target = '{' + (index - 1) + '}';
                                tag = tag.replace(target, values[index]);
                            }
                        }
                        elm['html'](tag);
                    }
                }
            };
            i18n.factory = function () {
                var directive = function (localize, viewService) { return new i18n(localize, viewService); };
                directive.$inject = ['localize', 'viewService'];
                return directive;
            };
            return i18n;
        }());
        angular
            .module('customer.core')
            .directive('i18n', i18n.factory());
    })(directives = core.directives || (core.directives = {}));
})(core || (core = {}));
//# sourceMappingURL=i18n.js.map
var core;
(function (core) {
    var services;
    (function (services) {
        var localize = (function () {
            function localize($http, $rootScope, $window, $filter, logger, resources) {
                this.$http = $http;
                this.$rootScope = $rootScope;
                this.$window = $window;
                this.$filter = $filter;
                this.logger = logger;
                this.resources = resources;
                this.language = '';
                this.viewName = null;
                this.$inject = ['$http', '$rootScope', '$window', '$filter', 'logger', 'resources'];
                this.initialize();
            }
            localize.prototype.initialize = function () {
                this.dictionary = this.resources;
                this.$rootScope.$broadcast('localizeResourcesUpdated');
            };
            localize.prototype.buildImgUrl = function (imageUrl) {
                return this.$http({ method: "GET", url: imageUrl, cache: false });
            };
            localize.prototype.getViewDictionary = function (dictionary, viewName) {
                return dictionary[viewName];
            };
            localize.prototype.getResourceByViewName = function (viewName, key) {
                var result = null;
                var dictionary = this.getViewDictionary(this.dictionary, viewName);
                if (!dictionary) {
                    return null;
                }
                var resourceItems = this.$filter('filter')(dictionary, function (element) {
                    return (element[key] !== undefined ? element : null);
                });
                if (resourceItems.length > 0) {
                    var item = resourceItems[0];
                    result = item[key];
                }
                return result;
            };
            localize.prototype.getLocalizedString = function (key, viewName, values) {
                var result = null;
                if (viewName) {
                    this.viewName = viewName;
                }
                result = this.getResourceByViewName(viewName, key);
                if (result == null) {
                    result = this.getResourceByViewName("Generic", key);
                    if (result == null) {
                        this.logger.error('Could not find resource for ' + key);
                        result = '';
                    }
                }
                if (result && values && /\{[0-9]+\}/.test(result)) {
                    var replacements = [];
                    if (!Array.isArray(values)) {
                        replacements.push(values);
                    }
                    else {
                        replacements = JSON.parse(JSON.stringify(values));
                    }
                    for (var index = 0; index < replacements.length; index++) {
                        var target = '{' + (index) + '}';
                        result = result.replace(target, replacements[index]);
                    }
                }
                return result;
            };
            return localize;
        }());
        services.localize = localize;
        angular
            .module('customer.core')
            .service('localize', localize);
    })(services = core.services || (core.services = {}));
})(core || (core = {}));
//# sourceMappingURL=localize.js.map
var core;
(function (core) {
    var services;
    (function (services) {
        var viewService = (function () {
            function viewService(logger) {
                this.logger = logger;
                this.$inject = ['logger'];
            }
            viewService.prototype.getViewName = function (elem) {
                var viewRoot = elem.closest('[data-viewname]')[0];
                if (!viewRoot) {
                    this.logger.error('Could not find a data-viewname element!');
                    return null;
                }
                return viewRoot.attributes.getNamedItem('data-viewname').value;
            };
            return viewService;
        }());
        services.viewService = viewService;
        angular
            .module('customer.core')
            .service('viewService', viewService);
    })(services = core.services || (core.services = {}));
})(core || (core = {}));
//# sourceMappingURL=viewService.js.map
var core;
(function (core) {
    var models;
    (function (models) {
        var BankAccount = (function () {
            function BankAccount() {
                this.DebtCollectionMethod = new core.models.CodeDescription();
            }
            return BankAccount;
        }());
        models.BankAccount = BankAccount;
        ;
    })(models = core.models || (core.models = {}));
})(core || (core = {}));
//# sourceMappingURL=BankAccount.js.map
var core;
(function (core) {
    var models;
    (function (models) {
        var CodeDescription = (function () {
            function CodeDescription() {
            }
            return CodeDescription;
        }());
        models.CodeDescription = CodeDescription;
        ;
    })(models = core.models || (core.models = {}));
})(core || (core = {}));
//# sourceMappingURL=CodeDescription.js.map
var core;
(function (core) {
    var models;
    (function (models) {
        var CommonArea = (function () {
            function CommonArea() {
            }
            return CommonArea;
        }());
        models.CommonArea = CommonArea;
    })(models = core.models || (core.models = {}));
})(core || (core = {}));
//# sourceMappingURL=CommonArea.js.map
var core;
(function (core) {
    var models;
    (function (models) {
        var ContractDetails = (function () {
            function ContractDetails() {
            }
            return ContractDetails;
        }());
        models.ContractDetails = ContractDetails;
    })(models = core.models || (core.models = {}));
})(core || (core = {}));
//# sourceMappingURL=ContractDetails.js.map
var core;
(function (core) {
    var models;
    (function (models) {
        var CustomerDetails = (function () {
            function CustomerDetails() {
            }
            return CustomerDetails;
        }());
        models.CustomerDetails = CustomerDetails;
    })(models = core.models || (core.models = {}));
})(core || (core = {}));
//# sourceMappingURL=CustomerDetails.js.map
var core;
(function (core) {
    var models;
    (function (models) {
        var DocumentInfo = (function () {
            function DocumentInfo() {
            }
            return DocumentInfo;
        }());
        models.DocumentInfo = DocumentInfo;
    })(models = core.models || (core.models = {}));
})(core || (core = {}));
//# sourceMappingURL=DocumentInfo.js.map
var core;
(function (core) {
    var models;
    (function (models) {
        var RelatedContact = (function () {
            function RelatedContact() {
            }
            return RelatedContact;
        }());
        models.RelatedContact = RelatedContact;
    })(models = core.models || (core.models = {}));
})(core || (core = {}));
//# sourceMappingURL=RelatedContact.js.map
var core;
(function (core) {
    var models;
    (function (models) {
        var RentalUnit = (function () {
            function RentalUnit() {
            }
            return RentalUnit;
        }());
        models.RentalUnit = RentalUnit;
    })(models = core.models || (core.models = {}));
})(core || (core = {}));
//# sourceMappingURL=RentalUnit.js.map
var core;
(function (core) {
    var models;
    (function (models) {
        var RentedItem = (function () {
            function RentedItem() {
            }
            return RentedItem;
        }());
        models.RentedItem = RentedItem;
    })(models = core.models || (core.models = {}));
})(core || (core = {}));
//# sourceMappingURL=RentedItem.js.map
var core;
(function (core) {
    var models;
    (function (models) {
        var Role = (function () {
            function Role() {
            }
            return Role;
        }());
        models.Role = Role;
    })(models = core.models || (core.models = {}));
})(core || (core = {}));
//# sourceMappingURL=Role.js.map
var core;
(function (core) {
    var models;
    (function (models) {
        var TwoFactorAuthenticaiton = (function () {
            function TwoFactorAuthenticaiton() {
            }
            return TwoFactorAuthenticaiton;
        }());
        models.TwoFactorAuthenticaiton = TwoFactorAuthenticaiton;
    })(models = core.models || (core.models = {}));
})(core || (core = {}));
//# sourceMappingURL=TwoFactorAuthentication.js.map
var core;
(function (core) {
    var services;
    (function (services) {
        var cpMath = (function () {
            function cpMath() {
            }
            cpMath.prototype.sum = function (val1, val2) {
                val1 = this.roundNumber(val1, 8);
                val2 = this.roundNumber(val2, 8);
                var sum = this.roundNumber(val1 + val2, 8);
                return sum;
            };
            cpMath.prototype.substract = function (val1, val2) {
                return this.sum(val1, -val2);
            };
            cpMath.prototype.roundNumber = function (number, decimals) {
                var newnumber = new Number(number + '').toFixed(decimals);
                return parseFloat(newnumber);
            };
            cpMath.prototype.roundNumberUp = function (number, decimals) {
                var newnumber = new Number(number + 0.00001).toFixed(decimals);
                return parseFloat(newnumber);
            };
            return cpMath;
        }());
        services.cpMath = cpMath;
        angular
            .module('customer.core')
            .service('cpMath', cpMath);
    })(services = core.services || (core.services = {}));
})(core || (core = {}));
//# sourceMappingURL=cpMath.js.map
var core;
(function (core) {
    var directives;
    (function (directives) {
        var fileDownload = (function () {
            function fileDownload(options, FileSaver) {
                this.options = options;
                this.FileSaver = FileSaver;
                this.$inject = ['options', 'FileSaver'];
                this.activate();
            }
            fileDownload.prototype.activate = function () {
                this.message = this.options.message;
                this.title = this.options.title;
                this.data = this.options.data;
                this.fileName = this.options.fileName;
                this.contentType = this.options.contentType;
            };
            fileDownload.prototype.download = function () {
                var options = new Blob([this.data], { type: this.contentType });
                this.FileSaver.saveAs(options, this.fileName);
            };
            return fileDownload;
        }());
        angular.module('customer.core')
            .controller("fileDownload", fileDownload);
    })(directives = core.directives || (core.directives = {}));
})(core || (core = {}));
//# sourceMappingURL=fileDownload.controller.js.map
var core;
(function (core) {
    var directives;
    (function (directives) {
        var controller = (function () {
            function controller($scope, localize, element, fileModelSetter) {
                this.$scope = $scope;
                this.localize = localize;
                this.element = element;
                this.fileModelSetter = fileModelSetter;
                this.MB = 1024 * 1024;
                this.$inject = ['$scope', 'localize', 'element', 'fileModelSetter'];
                this.activate();
            }
            controller.prototype.activate = function () {
                this.maxSize = this.$scope.maxSize;
                this.fileTooLarge = false;
                this.infoText = this.localize.getLocalizedString(this.$scope.infoText, this.$scope.viewName, parseFloat((this.maxSize / this.MB).toString()).toFixed(1) + " MB");
                this.title = this.localize.getLocalizedString(this.$scope.modalTitle, this.$scope.viewName);
                this.fileType = this.$scope.fileType;
                this.isImagePicker = this.$scope.isImagePicker;
                this.autoClose = this.$scope.autoClose;
            };
            controller.prototype.onerror = function (file, errorMessageCode) {
                switch (errorMessageCode) {
                    case 1:
                        this.fileTooLargeMessage = this.localize.getLocalizedString(this.$scope.fileTooLargeMessage, this.$scope.viewName, file.name);
                        break;
                    case 2:
                        this.fileTooLargeMessage = this.localize.getLocalizedString(this.$scope.invalidFileExtension, this.$scope.viewName, file.name);
                        break;
                }
                this.fileTooLarge = true;
                this.$scope.onerror({ file: file });
            };
            controller.prototype.onsuccess = function (files) {
                var _this = this;
                this.fileTooLarge = false;
                if (this.isImagePicker) {
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        _this.element.find("img").attr('src', e.target.result);
                        _this.$scope.newImageSelected = true;
                    };
                    reader.readAsDataURL(files[0]);
                }
                if (this.autoClose && this.$scope.$close) {
                    this.$scope.$close();
                }
                this.$scope.$apply(function () {
                    _this.fileModelSetter(files);
                });
            };
            controller.prototype.cancel = function () {
                this.$scope.$dismiss();
            };
            return controller;
        }());
        angular.module('customer.core')
            .controller('filePickerModal', controller);
    })(directives = core.directives || (core.directives = {}));
})(core || (core = {}));
//# sourceMappingURL=filePickerModal.controller.js.map
var core;
(function (core) {
    var factory;
    (function (factory) {
        var focus = (function () {
            function focus() {
            }
            focus.Factory = function () {
                var factoryFunction = function ($rootScope, $timeout) {
                    return function (name) {
                        $timeout(function () {
                            $rootScope.$broadcast('focusOn', name);
                        });
                    };
                };
                factoryFunction.$inject = ['$rootScope', '$timeout'];
                return factoryFunction;
            };
            return focus;
        }());
        angular
            .module('customer.core')
            .factory('focus', focus.Factory());
    })(factory = core.factory || (core.factory = {}));
})(core || (core = {}));
//# sourceMappingURL=focusOn.factory.js.map
var core;
(function (core) {
    var directives;
    (function (directives) {
        var controller = (function () {
            function controller($scope, localize, imageResizer) {
                this.$scope = $scope;
                this.localize = localize;
                this.imageResizer = imageResizer;
                this.fileTooLarge = false;
                this.currentImageData = null;
                this.$inject = ['$scope', 'localize', 'imageResizer'];
                this.activate();
            }
            controller.prototype.activate = function () {
                this.title = this.localize.getLocalizedString(this.$scope.modalTitle, this.$scope.viewName);
                this.fileType = this.$scope.fileType;
            };
            controller.prototype.onerror = function (file, errorMessageCode) {
                switch (errorMessageCode) {
                    case 1:
                        this.fileTooLargeMessage = this.localize.getLocalizedString(this.$scope.fileTooLargeMessage, this.$scope.viewName, file.name);
                        break;
                    case 2:
                        this.fileTooLargeMessage = this.localize.getLocalizedString(this.$scope.invalidFileExtension, this.$scope.viewName, file.name);
                        break;
                }
                this.fileTooLarge = true;
            };
            controller.prototype.onsuccess = function (files) {
                this.fileTooLarge = false;
                for (var i = 0; i < files.length; i++) {
                    if (this.$scope.images.length + i > this.$scope.maxNumberOfImages)
                        break;
                    this.resizeImage(files, i);
                }
            };
            controller.prototype.resizeImage = function (filest, i) {
                var _this = this;
                this.imageResizer.resizeImage(filest[i])
                    .then(function (data) {
                    if (_this.$scope.images.length === _this.$scope.maxNumberOfImages)
                        return;
                    _this.$scope.images.push({
                        data: data.data,
                        name: filest[i].name.substring(0, filest[i].name.lastIndexOf(".")),
                        ext: filest[i].name.substring(filest[i].name.lastIndexOf(".") + 1),
                        canDelete: true
                    });
                    _this.$scope.newImageSelected = true;
                    _this.$scope.$close();
                });
            };
            controller.prototype.cancel = function () {
                this.$scope.$dismiss();
            };
            return controller;
        }());
        angular.module('customer.core')
            .controller('imagePickerModal', controller);
    })(directives = core.directives || (core.directives = {}));
})(core || (core = {}));
//# sourceMappingURL=imagePickerModal.controller.js.map
var core;
(function (core) {
    var models;
    (function (models) {
        var company;
        (function (company) {
            var CompanyInfo = (function () {
                function CompanyInfo() {
                }
                return CompanyInfo;
            }());
            company.CompanyInfo = CompanyInfo;
        })(company = models.company || (models.company = {}));
    })(models = core.models || (core.models = {}));
})(core || (core = {}));
//# sourceMappingURL=CompanyInfo.js.map
//# sourceMappingURL=IKeyValueDictionary.js.map
var core;
(function (core) {
    var models;
    (function (models) {
        var keyValues;
        (function (keyValues) {
            var keyValue = (function () {
                function keyValue(content, extraClass) {
                    this.content = content;
                    this.extraClass = extraClass;
                }
                return keyValue;
            }());
            keyValues.keyValue = keyValue;
        })(keyValues = models.keyValues || (models.keyValues = {}));
    })(models = core.models || (core.models = {}));
})(core || (core = {}));
//# sourceMappingURL=keyValue.js.map
var core;
(function (core) {
    var models;
    (function (models) {
        var outstandingbalance;
        (function (outstandingbalance) {
            var AppliedEntry = (function () {
                function AppliedEntry() {
                }
                return AppliedEntry;
            }());
            outstandingbalance.AppliedEntry = AppliedEntry;
        })(outstandingbalance = models.outstandingbalance || (models.outstandingbalance = {}));
    })(models = core.models || (core.models = {}));
})(core || (core = {}));
//# sourceMappingURL=AppliedEntry.js.map
var core;
(function (core) {
    var models;
    (function (models) {
        var outstandingbalance;
        (function (outstandingbalance) {
            var Invoice = (function () {
                function Invoice() {
                }
                return Invoice;
            }());
            outstandingbalance.Invoice = Invoice;
        })(outstandingbalance = models.outstandingbalance || (models.outstandingbalance = {}));
    })(models = core.models || (core.models = {}));
})(core || (core = {}));
//# sourceMappingURL=Invoice.js.map
var core;
(function (core) {
    var models;
    (function (models) {
        var outstandingbalance;
        (function (outstandingbalance) {
            var OutstandingBalance = (function () {
                function OutstandingBalance() {
                }
                return OutstandingBalance;
            }());
            outstandingbalance.OutstandingBalance = OutstandingBalance;
        })(outstandingbalance = models.outstandingbalance || (models.outstandingbalance = {}));
    })(models = core.models || (core.models = {}));
})(core || (core = {}));
//# sourceMappingURL=OutstandingBalance.js.map
var core;
(function (core) {
    var models;
    (function (models) {
        var outstandingbalance;
        (function (outstandingbalance) {
            var Payment = (function () {
                function Payment() {
                }
                return Payment;
            }());
            outstandingbalance.Payment = Payment;
        })(outstandingbalance = models.outstandingbalance || (models.outstandingbalance = {}));
    })(models = core.models || (core.models = {}));
})(core || (core = {}));
//# sourceMappingURL=Payment.js.map
var core;
(function (core) {
    var models;
    (function (models) {
        var paymentarrangement;
        (function (paymentarrangement) {
            var PaymentArrangement = (function () {
                function PaymentArrangement() {
                }
                return PaymentArrangement;
            }());
            paymentarrangement.PaymentArrangement = PaymentArrangement;
        })(paymentarrangement = models.paymentarrangement || (models.paymentarrangement = {}));
    })(models = core.models || (core.models = {}));
})(core || (core = {}));
//# sourceMappingURL=PaymentArrangement.js.map
var core;
(function (core) {
    var models;
    (function (models) {
        var repairments;
        (function (repairments) {
            var Cause = (function () {
                function Cause() {
                }
                return Cause;
            }());
            repairments.Cause = Cause;
        })(repairments = models.repairments || (models.repairments = {}));
    })(models = core.models || (core.models = {}));
})(core || (core = {}));
//# sourceMappingURL=Cause.js.map
var core;
(function (core) {
    var models;
    (function (models) {
        var repairments;
        (function (repairments) {
            var ConstructionPart = (function () {
                function ConstructionPart() {
                }
                return ConstructionPart;
            }());
            repairments.ConstructionPart = ConstructionPart;
        })(repairments = models.repairments || (models.repairments = {}));
    })(models = core.models || (core.models = {}));
})(core || (core = {}));
//# sourceMappingURL=ConstructionPart.js.map
var core;
(function (core) {
    var models;
    (function (models) {
        var repairments;
        (function (repairments) {
            var Issue = (function () {
                function Issue() {
                }
                return Issue;
            }());
            repairments.Issue = Issue;
        })(repairments = models.repairments || (models.repairments = {}));
    })(models = core.models || (core.models = {}));
})(core || (core = {}));
//# sourceMappingURL=Issue.js.map
var core;
(function (core) {
    var models;
    (function (models) {
        var repairments;
        (function (repairments) {
            var Part = (function () {
                function Part() {
                }
                return Part;
            }());
            repairments.Part = Part;
        })(repairments = models.repairments || (models.repairments = {}));
    })(models = core.models || (core.models = {}));
})(core || (core = {}));
//# sourceMappingURL=Part.js.map
var core;
(function (core) {
    var models;
    (function (models) {
        var repairments;
        (function (repairments) {
            var RepairTemplate = (function () {
                function RepairTemplate() {
                }
                return RepairTemplate;
            }());
            repairments.RepairTemplate = RepairTemplate;
        })(repairments = models.repairments || (models.repairments = {}));
    })(models = core.models || (core.models = {}));
})(core || (core = {}));
//# sourceMappingURL=RepairTemplate.js.map
var core;
(function (core) {
    var models;
    (function (models) {
        var repairments;
        (function (repairments) {
            var RoomType = (function () {
                function RoomType() {
                }
                return RoomType;
            }());
            repairments.RoomType = RoomType;
        })(repairments = models.repairments || (models.repairments = {}));
    })(models = core.models || (core.models = {}));
})(core || (core = {}));
//# sourceMappingURL=RoomType.js.map
var core;
(function (core) {
    var models;
    (function (models) {
        var repairments;
        (function (repairments) {
            var SolutionTip = (function () {
                function SolutionTip() {
                }
                return SolutionTip;
            }());
            repairments.SolutionTip = SolutionTip;
        })(repairments = models.repairments || (models.repairments = {}));
    })(models = core.models || (core.models = {}));
})(core || (core = {}));
//# sourceMappingURL=SolutionTip.js.map
var core;
(function (core) {
    var models;
    (function (models) {
        var repairments;
        (function (repairments) {
            var Specification = (function () {
                function Specification() {
                }
                return Specification;
            }());
            repairments.Specification = Specification;
        })(repairments = models.repairments || (models.repairments = {}));
    })(models = core.models || (core.models = {}));
})(core || (core = {}));
//# sourceMappingURL=Specification.js.map
//# sourceMappingURL=PortalState.js.map
var core;
(function (core) {
    var models;
    (function (models) {
        var users;
        (function (users) {
            var Account = (function () {
                function Account() {
                }
                return Account;
            }());
            users.Account = Account;
        })(users = models.users || (models.users = {}));
    })(models = core.models || (core.models = {}));
})(core || (core = {}));
//# sourceMappingURL=Account.js.map
var core;
(function (core) {
    var models;
    (function (models) {
        var users;
        (function (users) {
            var AccountRole = (function () {
                function AccountRole() {
                }
                return AccountRole;
            }());
            users.AccountRole = AccountRole;
        })(users = models.users || (models.users = {}));
    })(models = core.models || (core.models = {}));
})(core || (core = {}));
//# sourceMappingURL=AccountRole.js.map
var core;
(function (core) {
    var models;
    (function (models) {
        var users;
        (function (users) {
            var SearchModel = (function () {
                function SearchModel() {
                }
                return SearchModel;
            }());
            users.SearchModel = SearchModel;
        })(users = models.users || (models.users = {}));
    })(models = core.models || (core.models = {}));
})(core || (core = {}));
//# sourceMappingURL=SearchModel.js.map
var core;
(function (core) {
    var directives;
    (function (directives) {
        var repairmentPhotosAndDefectDescription = (function () {
            function repairmentPhotosAndDefectDescription() {
                this.restrict = 'E';
                this.transclude = true;
                this.controllerAs = '$ctrl';
                this.templateUrl = '/App/core/components/common/repairmentPhotosAndDefectDescription/repairmentPhotosAndDefectDescription.html';
                this.scope = {
                    images: '=',
                    defectDescription: '=',
                    descriptionRequired: '=',
                    readonly: '='
                };
                this.require = '^form';
                this.link = function (scope, iElement, iAttrs, ctrls) {
                    scope.form = ctrls;
                };
            }
            repairmentPhotosAndDefectDescription.factory = function () {
                var directive = function () { return new repairmentPhotosAndDefectDescription(); };
                return directive;
            };
            return repairmentPhotosAndDefectDescription;
        }());
        angular.module('customer.core')
            .directive('repairmentPhotosAndDefectDescription', repairmentPhotosAndDefectDescription.factory());
    })(directives = core.directives || (core.directives = {}));
})(core || (core = {}));
//# sourceMappingURL=repairmentPhotosAndDefectDescription.js.map
if (window.location.hash && window.location.hash == '#_=_') {
    var cleanHref = window.location.href.split('#')[0];
    if (history.replaceState) {
        history.replaceState(null, null, cleanHref);
    }
    window.location.href = cleanHref;
}
/**
* Detect Element Resize Plugin for jQuery
*
* https://github.com/sdecima/javascript-detect-element-resize
* Sebastian Decima
*
* version: 0.5.3
**/

(function ( $ ) {
	var attachEvent = document.attachEvent,
		stylesCreated = false;
	
	var jQuery_resize = $.fn.resize;
	
	$.fn.resize = function (callback) {
	    return this.each(function () {
	        if (this == window)
	            jQuery_resize.call(jQuery(this), callback);
	        else
	            addResizeListener(this, callback);
	    });
	};

	$.fn.removeResize = function (callback) {
	    return this.each(function () {
	        removeResizeListener(this, callback);
	    });
	};

	function resetTriggers(element){
		var triggers = element.__resizeTriggers__,
			expand = triggers.firstElementChild,
			contract = triggers.lastElementChild,
			expandChild = expand.firstElementChild;
		contract.scrollLeft = contract.scrollWidth;
		contract.scrollTop = contract.scrollHeight;
		expandChild.style.width = expand.offsetWidth + 1 + 'px';
		expandChild.style.height = expand.offsetHeight + 1 + 'px';
		expand.scrollLeft = expand.scrollWidth;
		expand.scrollTop = expand.scrollHeight;
	}

	function checkTriggers(element){
		return element.offsetWidth != element.__resizeLast__.width ||
						element.offsetHeight != element.__resizeLast__.height;
	}
		
	function scrollListener(e){
		var element = this;
		resetTriggers(this);
		if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
		this.__resizeRAF__ = requestFrame(function(){
			if (checkTriggers(element)) {
				element.__resizeLast__.width = element.offsetWidth;
				element.__resizeLast__.height = element.offsetHeight;
				element.__resizeListeners__.forEach(function(fn){
					fn.call(element, e);
				});
			}
		});
	}
	
	if (!attachEvent) {
		var requestFrame = (function(){
			var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame ||
								function(fn){ return window.setTimeout(fn, 20); };
			return function(fn){ return raf(fn); };
		})();
		
		var cancelFrame = (function(){
			var cancel = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame ||
								   window.clearTimeout;
		  return function(id){ return cancel(id); };
		})();
		
		/* Detect CSS Animations support to detect element display/re-attach */
		var animation = false,
			animationstring = 'animation',
			keyframeprefix = '',
			animationstartevent = 'animationstart',
			domPrefixes = 'Webkit Moz O ms'.split(' '),
			startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
			pfx  = '';
		{
			var elm = document.createElement('fakeelement');
			if( elm.style.animationName !== undefined ) { animation = true; }    
			
			if( animation === false ) {
				for( var i = 0; i < domPrefixes.length; i++ ) {
					if( elm.style[ domPrefixes[i] + 'AnimationName' ] !== undefined ) {
						pfx = domPrefixes[ i ];
						animationstring = pfx + 'Animation';
						keyframeprefix = '-' + pfx.toLowerCase() + '-';
						animationstartevent = startEvents[ i ];
						animation = true;
						break;
					}
				}
			}
		}
		
		var animationName = 'resizeanim';
		var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
		var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
	}
	
	function createStyles() {
		if (!stylesCreated) {
			//opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
			var css = (animationKeyframes ? animationKeyframes : '') +
					'.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' +
					'.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: \" \"; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
				head = document.head || document.getElementsByTagName('head')[0],
				style = document.createElement('style');
			
			style.type = 'text/css';
			if (style.styleSheet) {
				style.styleSheet.cssText = css;
			} else {
				style.appendChild(document.createTextNode(css));
			}

			head.appendChild(style);
			stylesCreated = true;
		}
	}
	
	window.addResizeListener = function(element, fn){
		if (attachEvent) element.attachEvent('onresize', fn);
		else {
			if (!element.__resizeTriggers__) {
				if (getComputedStyle(element).position == 'static') element.style.position = 'relative';
				createStyles();
				element.__resizeLast__ = {};
				element.__resizeListeners__ = [];
				(element.__resizeTriggers__ = document.createElement('div')).className = 'resize-triggers';
				element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' +
																						'<div class="contract-trigger"></div>';
				element.appendChild(element.__resizeTriggers__);
				resetTriggers(element);
				element.addEventListener('scroll', scrollListener, true);
				
				/* Listen for a css animation to detect element display/re-attach */
				animationstartevent && element.__resizeTriggers__.addEventListener(animationstartevent, function(e) {
					if(e.animationName == animationName)
						resetTriggers(element);
				});
			}
			element.__resizeListeners__.push(fn);
		}
	};
	
	window.removeResizeListener = function (element, fn) {
	    if (attachEvent) element.detachEvent('onresize', fn);
	    else {
	        element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
	        if (!element.__resizeListeners__.length) {
	            element.removeEventListener('scroll', scrollListener);
	            element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
	        }
	    }
	};
}( jQuery ));
//! moment.js locale configuration
//! locale : dutch (nl)
//! author : Joris Röling : https://github.com/jjupiter

(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var nl = moment.defineLocale('nl', {
        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort : function (m, format) {
            if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'over %s',
            past : '%s geleden',
            s : 'een paar seconden',
            m : 'één minuut',
            mm : '%d minuten',
            h : 'één uur',
            hh : '%d uur',
            d : 'één dag',
            dd : '%d dagen',
            M : 'één maand',
            MM : '%d maanden',
            y : 'één jaar',
            yy : '%d jaar'
        },
        ordinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nl;

}));
var customer;
(function (customer) {
    var accountRequests;
    (function (accountRequests) {
        var controller = (function () {
            function controller($state, $stateParams, localize, alerting, accountRequestsService) {
                var _this = this;
                this.$state = $state;
                this.$stateParams = $stateParams;
                this.localize = localize;
                this.alerting = alerting;
                this.accountRequestsService = accountRequestsService;
                this.$inject = ['$state', '$stateParams', 'localize', 'alerting', 'accountRequestsService'];
                this.goBackToAccountRequestsOverview = function () {
                    _this.$state.go("accountRequests", { searchState: _this.$stateParams.accountRequestsSearchState });
                };
            }
            controller.prototype.removeAccountRequest = function (customerNumber) {
                var _this = this;
                var deleteUserTitle = this.getResource("Dialog_DeleteAccountRequestTitle");
                var deleteUserMessage = this.getResource("Message_ConfirmAccountRequestDelete", customerNumber);
                this.alerting.confirm(deleteUserMessage, deleteUserTitle).then(function (result) {
                    if (!result) {
                        return;
                    }
                    _this.accountRequestsService.removeAccountRequest(customerNumber).then(function (response) {
                        if (response.success && response.data) {
                            _this.alerting
                                .popInfo(_this.getResource("Message_AccountRequestDeleted"), deleteUserTitle)
                                .then(_this.goBackToAccountRequestsOverview)
                                .catch(_this.goBackToAccountRequestsOverview);
                        }
                        else {
                            _this.alerting.popError(_this.getResource("Message_AccountRequestDeleteError"), deleteUserTitle);
                        }
                    });
                });
            };
            controller.prototype.sendConfirmationEmail = function (customerNumber) {
                var _this = this;
                this.accountRequestsService.sendConfirmationEmail(customerNumber).then(function (response) {
                    if (response.success && response.data) {
                        _this.$state.reload().then(function () {
                            _this.alerting.popInfo(_this.getResource("Message_ConfirmationEmailSent"), _this.getResource("Dialog_SendConfirmationEmailTitle"));
                        });
                    }
                    else {
                        _this.alerting.popError(_this.getResource("Message_ConfirmationEmailSendingError"), _this.getResource("Dialog_SendConfirmationEmailTitle"));
                    }
                });
            };
            controller.prototype.getResource = function (key, values) {
                return this.localize.getLocalizedString(key, "AccountRequests", values);
            };
            return controller;
        }());
        angular
            .module("customer.accountRequests")
            .component("accountRequestDetails", {
            bindings: {
                accountRequest: '=',
                rights: '='
            },
            controller: controller,
            templateUrl: '/App/accountRequests/accountRequestDetails.html'
        });
    })(accountRequests = customer.accountRequests || (customer.accountRequests = {}));
})(customer || (customer = {}));
//# sourceMappingURL=accountRequestDetails.component.js.map
var customer;
(function (customer) {
    var accountRequests;
    (function (accountRequests) {
        var controller = (function () {
            function controller($state, $stateParams, accountRequestsService, alerting, localize) {
                this.$state = $state;
                this.$stateParams = $stateParams;
                this.accountRequestsService = accountRequestsService;
                this.alerting = alerting;
                this.localize = localize;
                this.searchModel = new customer.accountRequests.models.SearchModel();
                this.searchState = {};
                this.maxTotalItems = 10000000000;
                this.$inject = ['$state', '$stateParams', 'accountRequestsService', 'alerting', 'localize'];
                this.paging = {
                    currentPage: 1,
                    totalItems: this.maxTotalItems,
                    maxSize: core.constants.paging.maxPages,
                    count: core.constants.paging.itemsPerPage,
                    firstText: this.getResource('Paging_FirstText'),
                    lastText: this.getResource('Paging_LastText'),
                    nextText: this.getResource('Paging_NextText'),
                    previousText: this.getResource('Paging_PreviousText')
                };
                this.activate();
            }
            controller.prototype.activate = function () {
                this.restoreSearchState(this.$stateParams.searchState);
                this.search();
            };
            controller.prototype.search = function () {
                var _this = this;
                this.saveCurrentSearchState();
                if (this.gridSelection) {
                    this.gridSelection.selected = null;
                    this.gridSelection = null;
                }
                return this.accountRequestsService.search(this.searchModel, this.paging.currentPage, this.paging.count).then(function (response) {
                    _this.paging.totalItems = response.results;
                    _this.accountRequests = response.rows;
                });
            };
            controller.prototype.removeAccountRequest = function (accountRequest) {
                var _this = this;
                var deleteUserTitle = this.getResource("Dialog_DeleteAccountRequestTitle");
                this.alerting.confirm(this.getResource("Message_ConfirmAccountRequestDelete", accountRequest.EmpireId), deleteUserTitle).then(function (result) {
                    if (result) {
                        return _this.accountRequestsService.removeAccountRequest(accountRequest.EmpireId).then(function (response) {
                            if (response.success && response.data) {
                                _this.search();
                                _this.alerting.popInfo(_this.getResource("Message_AccountRequestDeleted"), deleteUserTitle);
                            }
                            else {
                                _this.alerting.popError(_this.getResource("Message_AccountRequestDeleteError"), deleteUserTitle);
                            }
                        });
                    }
                });
            };
            controller.prototype.viewDetails = function (accountRequest) {
                this.$state.go('accountRequestDetails', { empireId: accountRequest.EmpireId, accountRequestsSearchState: this.searchState });
            };
            controller.prototype.onCheckChange = function (selection) {
                angular.forEach(this.accountRequests, function (accountRequest) {
                    if (accountRequest.EmpireId !== selection.EmpireId) {
                        accountRequest.selected = false;
                    }
                });
                this.gridSelection = selection;
            };
            controller.prototype.getResource = function (key, values) {
                return this.localize.getLocalizedString(key, "AccountRequests", values);
            };
            controller.prototype.saveCurrentSearchState = function () {
                this.searchState = {
                    page: this.paging.currentPage,
                    searchModel: this.searchModel
                };
            };
            controller.prototype.restoreSearchState = function (searchState) {
                if (searchState) {
                    this.paging.currentPage = searchState.page;
                    this.searchModel = searchState.searchModel;
                }
            };
            controller.prototype.getTotalItems = function () {
                return this.paging.totalItems !== this.maxTotalItems ? this.paging.totalItems : 0;
            };
            return controller;
        }());
        angular.module('customer.accountRequests')
            .component('accountRequests', {
            controller: controller,
            templateUrl: '/App/accountRequests/accountRequests.html'
        });
    })(accountRequests = customer.accountRequests || (customer.accountRequests = {}));
})(customer || (customer = {}));
//# sourceMappingURL=accountRequests.component.js.map
var customer;
(function (customer) {
    var accountRequests;
    (function (accountRequests) {
        angular
            .module('customer.accountRequests')
            .config(configRoutes);
        function configRoutes($stateProvider, $locationProvider) {
            $locationProvider.html5Mode(true);
            $stateProvider
                .state('accountRequests', {
                url: '/accountRequests',
                template: '<account-requests></account-requests>',
                params: {
                    searchState: null
                }
            });
            $stateProvider
                .state('accountRequestDetails', {
                url: '/accountRequests/{empireId}',
                resolve: {
                    accountRequest: accountRequestProvider,
                    rights: rightsProvider
                },
                template: '<account-request-details account-request="$resolve.accountRequest" rights="$reslove.righs"></account-request-details>',
                params: {
                    accountRequestsSearchState: null
                }
            });
            accountRequestProvider.$inject = ['$rootScope', '$stateParams', 'accountRequestsService'];
            function accountRequestProvider($rootScope, $stateParams, accountRequestsService) {
                return accountRequestsService.getAccountRequestByCustomerId($stateParams.empireId).then(function (response) {
                    if (response.success) {
                        return response.data;
                    }
                    if (response.code === parseInt(core.constants.httpStatusCodes.Forbidden)) {
                        $rootScope.$emit("customerPortalUnauthorizedAccess");
                    }
                    return null;
                });
            }
            rightsProvider.$inject = ['userService'];
            function rightsProvider(userService) {
                return userService.getUserManagementRights();
            }
        }
    })(accountRequests = customer.accountRequests || (customer.accountRequests = {}));
})(customer || (customer = {}));
//# sourceMappingURL=accountRequests.route.js.map
var customer;
(function (customer) {
    var accountRequests;
    (function (accountRequests) {
        var accountRequestsService = (function () {
            function accountRequestsService(dataservice) {
                this.dataservice = dataservice;
            }
            accountRequestsService.prototype.getAccountRequestByCustomerId = function (empireId) {
                return this.dataservice.getData('/api/accountrequests/?empireId=' + this.urlEncodeValue(empireId));
            };
            accountRequestsService.prototype.removeAccountRequest = function (empireId) {
                return this.dataservice.deleteData('/api/accountrequests/deleteaccountrequest?empireId=' + this.urlEncodeValue(empireId)).then(function (response) {
                    return response;
                });
            };
            accountRequestsService.prototype.search = function (searchModel, page, count) {
                return this.dataservice.postData('/api/accountrequests/search?page=' + page + '&count=' + count, searchModel).then(function (response) {
                    return response;
                });
            };
            accountRequestsService.prototype.sendConfirmationEmail = function (empireId) {
                return this.dataservice.putData('/api/accountrequests?empireId=' + this.urlEncodeValue(empireId));
            };
            accountRequestsService.prototype.urlEncodeValue = function (value) {
                return encodeURIComponent(value);
            };
            return accountRequestsService;
        }());
        accountRequests.accountRequestsService = accountRequestsService;
        angular.module('customer.accountRequests')
            .service('accountRequestsService', accountRequestsService);
    })(accountRequests = customer.accountRequests || (customer.accountRequests = {}));
})(customer || (customer = {}));
//# sourceMappingURL=accountRequests.service.js.map
var customer;
(function (customer) {
    var changePassword;
    (function (changePassword) {
        var controller = (function () {
            function controller(userService, alerting, localize) {
                this.userService = userService;
                this.alerting = alerting;
                this.localize = localize;
                this.user = null;
                this.masterCopy = null;
                this.maxPasswordLength = core.constants.passwordValidation.maxLength;
                this.activate();
            }
            controller.prototype.activate = function () {
                var _this = this;
                this.userService.getCurrentUser().then(function (userModel) {
                    _this.user = userModel;
                    _this.masterCopy = JSON.parse(JSON.stringify(userModel));
                });
            };
            controller.prototype.savePassword = function (form) {
                var _this = this;
                if (form.$invalid) {
                    return;
                }
                this.userService.savePassword(this.user).then(function (response) {
                    if (response && response.success) {
                        _this.alerting.popInfo(_this.localize.getLocalizedString('Message_PasswordSaved', 'ChangePassword'));
                    }
                    else {
                        _this.alerting.popError(_this.localize.getLocalizedString('Message_Error', 'ChangePassword'));
                    }
                    form.$setPristine();
                    form.$setUntouched();
                    _this.user.Password = null;
                    _this.user.ConfirmPassword = null;
                    _this.user.OldPassword = null;
                });
            };
            return controller;
        }());
        angular
            .module('customer.changePassword')
            .component('changePassword', {
            controller: controller,
            templateUrl: '/App/changePassword/changePassword.html'
        });
    })(changePassword = customer.changePassword || (customer.changePassword = {}));
})(customer || (customer = {}));
//# sourceMappingURL=changePassword.component.js.map
var customer;
(function (customer) {
    var changePassword;
    (function (changePassword) {
        var validateHash = (function () {
            function validateHash(userService, $q) {
                var _this = this;
                this.userService = userService;
                this.$q = $q;
                this.restrict = 'A';
                this.require = 'ngModel';
                this.link = function (scope, element, attrs, ngModel) {
                    ngModel.$asyncValidators.validateHash = function (modelValue, viewValue) {
                        var value = viewValue;
                        if (!ngModel.$dirty) {
                            return _this.$q.when(true);
                        }
                        return _this.userService.validatePassword(value).then(function (response) {
                            var isValid = response === true;
                            if (!isValid) {
                                return _this.$q.reject(false);
                            }
                            return true;
                        });
                    };
                };
            }
            validateHash.factory = function () {
                var directive = function (userService, $q) { return new validateHash(userService, $q); };
                directive.$inject = ['userService', '$q'];
                return directive;
            };
            return validateHash;
        }());
        angular
            .module('customer.changePassword')
            .directive('validateHash', validateHash.factory());
    })(changePassword = customer.changePassword || (customer.changePassword = {}));
})(customer || (customer = {}));
//# sourceMappingURL=validateHash.directive.js.map
var customer;
(function (customer) {
    var changePassword;
    (function (changePassword) {
        var validateNewHash = (function () {
            function validateNewHash(userService, $q) {
                var _this = this;
                this.userService = userService;
                this.$q = $q;
                this.restrict = 'A';
                this.require = 'ngModel';
                this.link = function (scope, element, attrs, ngModel) {
                    ngModel.$asyncValidators.validateNewHash = function (modelValue, viewValue) {
                        var value = viewValue;
                        if (!ngModel.$dirty) {
                            return _this.$q.when(true);
                        }
                        else if (attrs.username.toLowerCase() === value.toLowerCase()) {
                            return _this.$q.reject(false);
                        }
                        else {
                            return _this.userService.validatePassword(value).then(function (response) {
                                var isValid = response !== true;
                                if (!isValid) {
                                    return _this.$q.reject(false);
                                }
                                return true;
                            });
                        }
                    };
                };
            }
            validateNewHash.factory = function () {
                var directive = function (userService, $q) { return new validateNewHash(userService, $q); };
                directive.$inject = ['userService', '$q'];
                return directive;
            };
            return validateNewHash;
        }());
        angular
            .module('customer.changePassword')
            .directive('validateNewHash', validateNewHash.factory());
    })(changePassword = customer.changePassword || (customer.changePassword = {}));
})(customer || (customer = {}));
//# sourceMappingURL=validateNewHash.directive.js.map
var customer;
(function (customer) {
    var chatWrapper;
    (function (chatWrapper_1) {
        var chatWrapper = (function () {
            function chatWrapper(dataservice, $scope) {
                this.dataservice = dataservice;
                this.$scope = $scope;
                this.$inject = ["dataserrvice", "$scope"];
            }
            chatWrapper.prototype.$onInit = function () {
                this.loadChatSettings().then(function (settings) {
                    if (settings.data.WebChatEnabled) {
                        ZigConversational.init({
                            integrationId: settings.data.WebChatIntegrationId,
                            fixedIntroPane: false,
                            businessName: settings.data.WebChatBusinessName,
                            region: "eu-1",
                            locale: "nl-NL",
                            customText: {
                                conversationTimestampHeaderFormat: "D MMMM YYYY, h:mm A",
                                introAppText: "",
                                headerText: "Hoe kunnen we je helpen?",
                                inputPlaceholder: "Typ jouw bericht...",
                                sendButtonText: "Stuur",
                                introductionText: "Stel je vraag!",
                                connectNotificationText: "Je kunt ook met ons chatten via:",
                                messageIndicatorTitlePlural: "({count}) Nieuwe berichten",
                                messageIndicatorTitleSingular: "({count}) Nieuw bericht",
                                messageRelativeTimeDay: "{value}d geleden",
                                messageRelativeTimeHour: "{value}u geleden",
                                messageRelativeTimeJustNow: "Zojuist",
                                messageRelativeTimeMinute: "{value}m geleden",
                                messageSending: "Versturenâ€¦",
                                messageDelivered: "Afgeleverd",
                            },
                            customColors: {
                                brandColor: settings.data.WebChatBrandColor,
                                conversationColor: settings.data.WebChatConversationColor,
                                actionColor: settings.data.WebChatActionColor,
                            },
                        }).then(function () {
                        });
                    }
                });
            };
            chatWrapper.prototype.loadChatSettings = function () {
                var url = "/api/web-chat-settings";
                return this.dataservice.getData(url);
            };
            return chatWrapper;
        }());
        angular.module("customer.chatWrapper").component("chatWrapper", {
            controller: chatWrapper,
            controllerAs: "$ctrl",
            templateUrl: "/App/chatWrapper/chatWrapper.component.html",
        });
    })(chatWrapper = customer.chatWrapper || (customer.chatWrapper = {}));
})(customer || (customer = {}));
//# sourceMappingURL=chatWrapper.component.js.map
var core;
(function (core) {
    var services;
    (function (services) {
        var companyService = (function () {
            function companyService(dataservice, $q) {
                this.dataservice = dataservice;
                this.$q = $q;
                this.currentCompany = null;
            }
            companyService.prototype.getCurrentCompany = function () {
                var _this = this;
                if (this.currentCompany) {
                    return this.$q(function (resolve) {
                        resolve(_this.currentCompany);
                    });
                }
                else {
                    this.currentCompany = this.dataservice.getData('/api/company/current');
                    return this.currentCompany;
                }
            };
            return companyService;
        }());
        services.companyService = companyService;
        angular
            .module('customer.core')
            .service('companyService', companyService);
    })(services = core.services || (core.services = {}));
})(core || (core = {}));
//# sourceMappingURL=company.service.js.map
var customer;
(function (customer) {
    var contact;
    (function (contact) {
        var controller = (function () {
            function controller(companyService, localize, alerting, portalModules) {
                var _this = this;
                this.companyService = companyService;
                this.localize = localize;
                this.alerting = alerting;
                this.portalModules = portalModules;
                this.$inject = ['companyService', 'localize', 'alerting', 'portalModules'];
                this.getCurrentCompanyCallback = function (data) {
                    if (data.success === true) {
                        _this.currentCompany = data.data;
                        var infoLbl = _this.localize.getLocalizedString('Informative_Text', 'Contact');
                        var phoneLbl = _this.localize.getLocalizedString('Label_Phone', 'Contact');
                        var faxLbl = _this.localize.getLocalizedString('Label_Fax', 'Contact');
                        var mailLbl = _this.localize.getLocalizedString('Label_Email', 'Contact');
                        var addressLbl = _this.localize.getLocalizedString('Label_Address', 'Contact');
                        _this.contactInformation = {};
                        _this.contactInformation[infoLbl] = new core.models.keyValues.keyValue('');
                        _this.contactInformation[phoneLbl] = new core.models.keyValues.keyValue(_this.currentCompany.PhoneNo ? '<a href="tel:' + _this.currentCompany.PhoneNo + '">' + _this.currentCompany.PhoneNo + '</a>' : '');
                        _this.contactInformation[faxLbl] = new core.models.keyValues.keyValue(_this.currentCompany.FaxNo ? '<a href="fax:' + _this.currentCompany.FaxNo + '">' + _this.currentCompany.FaxNo + '</a>' : '');
                        _this.contactInformation[mailLbl] = new core.models.keyValues.keyValue(_this.currentCompany.Email ? '<a href="mailto:' + _this.currentCompany.Email + '">' + _this.currentCompany.Email + '</a>' : '');
                        _this.contactInformation[addressLbl] = new core.models.keyValues.keyValue(_this.currentCompany.Address + '<br/>' + _this.currentCompany.PostCodeAndCity);
                    }
                    else {
                        var message = _this.localize.getLocalizedString('Message_FailedToLoadCurrentCompany', 'Contact');
                        _this.alerting.popError(message);
                    }
                };
                this.activate();
            }
            controller.prototype.activate = function () {
                if (this.portalModules.data && this.portalModules.data.Contact) {
                    this.companyService.getCurrentCompany().then(this.getCurrentCompanyCallback);
                }
            };
            return controller;
        }());
        angular
            .module('customer.contact')
            .component('contact', {
            controller: controller,
            templateUrl: '/App/contact/contact.html'
        });
    })(contact = customer.contact || (customer.contact = {}));
})(customer || (customer = {}));
//# sourceMappingURL=contact.component.js.map
var customer;
(function (customer) {
    var contractTermination;
    (function (contractTermination_1) {
        var controller = (function () {
            function controller(contractTerminationService, contractService, localize, alerting, $stateParams, $state, $filter, $timeout) {
                var _this = this;
                this.contractTerminationService = contractTerminationService;
                this.contractService = contractService;
                this.localize = localize;
                this.alerting = alerting;
                this.$stateParams = $stateParams;
                this.$state = $state;
                this.$filter = $filter;
                this.$timeout = $timeout;
                this.terminationDatePickerConfig = {
                    weekOnly: true,
                    format: 'DD-MM-YYYY',
                    locale: 'nl',
                    daysOfWeekDisabled: [0, 6]
                };
                this.changeContactDataFromDatePickerConfig = {
                    weekOnly: true,
                    format: 'DD-MM-YYYY',
                    locale: 'nl',
                    daysOfWeekDisabled: [0, 6],
                    minDate: moment()
                };
                this.firstInitialTimeSlotsLoading = true;
                this.initialTimeSlotsLoading = true;
                this.finalTimeSlotsLoading = true;
                this.$inject = ['contractTerminationService', 'contractService', 'localize', 'alerting', '$stateParams', '$state', '$filter', '$timeout'];
                this.getTermPlanningFirstInspectionCallBack = function (data) {
                    if (data.success === true) {
                        _this.termPlanningFirstInspection = data.data.CustomerPortalModules.TermPlanningFirstInspection;
                        _this.minDate = _this.computeMinDate();
                    }
                };
                this.countryCallback = function (data) {
                    _this.countries = data.data;
                };
                this.getUserContactDetailsValidationCallback = function (data) {
                    if (data.success === true) {
                        _this.userContactDetailsValidation = data.data;
                    }
                    _this.contactDetailsChanged();
                    _this.determineForeignCountry();
                    _this.initialInspection1RequiredMessage = _this.localize.getLocalizedString("Message_InitialInspection1Required", 'ContractTermination');
                    _this.initialInspection2RequiredMessage = _this.localize.getLocalizedString("Message_InitialInspection2Required", 'ContractTermination');
                    _this.finalInspection1RequiredMessage = _this.localize.getLocalizedString("Message_FinalInspection1Required", 'ContractTermination');
                    _this.finalInspection2RequiredMessage = _this.localize.getLocalizedString("Message_FinalInspection2Required", 'ContractTermination');
                    _this.prepareTermination();
                };
                this.updateStreetAndCityCallback = function (data) {
                    if (data && data.success) {
                        _this.formContainer.Street = data.data.Street;
                        _this.formContainer.City = data.data.City;
                        _this.terminationForm.postcode.$setValidity('validaddress', true);
                        _this.terminationForm.HouseNumber.$setValidity('validaddress', true);
                    }
                    else {
                        _this.formContainer.Street = '';
                        _this.formContainer.City = '';
                        _this.terminationForm.postcode.$setValidity('validaddress', false);
                        _this.terminationForm.HouseNumber.$setValidity('validaddress', false);
                    }
                };
                this.getContractTerminationExistsCallback = function (data) {
                    if (data.success === true && !data.data.Success) {
                        _this.determineFirstTerminationDate();
                        _this.contractTerminationService.getInspectionsData(_this.formContainer.selectedContract.CompanyName, _this.formContainer.selectedContract.RentalUnit.No).then(_this.getInspectionsDataCallback);
                        _this.contractTerminationService.getContractTerminationReasons(_this.formContainer.selectedContract.CompanyName).then(_this.getContractTerminationReasonsCallback);
                    }
                    else {
                        var message = _this.localize.getLocalizedString('Message_ContractTerminationExistst', 'ContractTermination');
                        _this.alerting.popError(message);
                        _this.$state.go('myContracts');
                    }
                };
                this.getInspectionsDataCallback = function (data) {
                    if (data.success === true) {
                        _this.inspectionsData = data.data;
                        _this.inspectionsData.InitialDurationString = _this.getInspectionDuration('Label_DurationOfInitialInspection', _this.inspectionsData.InitialDurationOfInspection);
                        _this.inspectionsData.FinalDurationString = _this.getInspectionDuration('Label_DurationOfFinalInspection', _this.inspectionsData.FinalDurationOfInspection);
                    }
                    else {
                        var message = _this.localize.getLocalizedString('Message_GenericError', 'ContractTermination');
                        _this.alerting.popError(message);
                    }
                };
                this.getContractTerminationReasonsCallback = function (data) {
                    if (data.success === true) {
                        _this.terminationReasons = data.data;
                    }
                    else {
                        var message = _this.localize.getLocalizedString('Message_GenericError', 'ContractTermination');
                        _this.alerting.popError(message);
                    }
                };
                this.getFirstAvailableWorkingDayCallback = function (terminationDate) {
                    _this.formContainer.terminationDate = terminationDate;
                    _this.terminationDatePickerConfig.minDate = terminationDate;
                    _this.formContainer.changeContactDataFrom = terminationDate;
                    _this.changeContactDataFromDatePickerConfig.maxDate = terminationDate;
                };
                this.computeMinDate = function () {
                    var date = moment().add(1, 'days');
                    if (_this.termPlanningFirstInspection) {
                        var nonWorkingDays = 0;
                        for (var i = 1; i <= _this.termPlanningFirstInspection; i++) {
                            var dayNumber = moment().add(i + 1, 'days').day();
                            if (dayNumber === 0 || dayNumber === 6)
                                nonWorkingDays += 1;
                        }
                        var daysToAdd = _this.termPlanningFirstInspection + nonWorkingDays;
                        date.add(daysToAdd, 'days');
                        if (date.day() === 0) {
                            date.add(1, 'days');
                        }
                        if (date.day() === 6) {
                            date.add(2, 'days');
                        }
                    }
                    return date;
                };
                this.loadAvailableFirstInitialInspectionTimeSlots = function (date) {
                    var searchDate = date.format('YYYY-MM-DD');
                    _this.firstInitialTimeSlotsLoading = true;
                    _this.contractTerminationService.getAvailableDates(_this.formContainer.selectedContract.CompanyName, _this.formContainer.selectedContract.RentalUnit.No, '0', searchDate, true).then(_this.loadAvailableFirstInitialInspectionTimeSlotsCallback);
                };
                this.loadAvailableInitialInspectionTimeSlots = function (date) {
                    var searchDate = date.format('YYYY-MM-DD');
                    _this.initialTimeSlotsLoading = true;
                    _this.contractTerminationService.getAvailableDates(_this.formContainer.selectedContract.CompanyName, _this.formContainer.selectedContract.RentalUnit.No, '0', searchDate, false).then(_this.loadAvailableInitialInspectionTimeSlotsCallback);
                };
                this.loadAvailableFinalInspectionTimeSlots = function (date) {
                    var searchDate = date.format('YYYY-MM-DD');
                    _this.finalTimeSlotsLoading = true;
                    _this.contractTerminationService.getAvailableDates(_this.formContainer.selectedContract.CompanyName, _this.formContainer.selectedContract.RentalUnit.No, '1', searchDate, false).then(_this.loadAvailableFinalInspectionTimeSlotsCallback);
                };
                this.loadAvailableFirstInitialInspectionTimeSlotsCallback = function (data) {
                    if (data.success === true) {
                        if (data.data.length >= 1) {
                            _this.firstInitialInspectionOnDate = data.data[0].FirstPreInspectionOnDate;
                        }
                        var result = [];
                        if (data.data && data.data.length === 1) {
                            var entry = data.data[0];
                            if (entry.TimeSlots && entry.TimeSlots.length !== 0) {
                                angular.forEach(entry.TimeSlots, function (slot) {
                                    result.push({
                                        Description: slot.StartTime + ' - ' + slot.EndTime,
                                        Item: slot
                                    });
                                });
                            }
                        }
                        if (result.length > 0) {
                            _this.availableFirstInitialInspectionTimeSlots = result;
                        }
                        else {
                            delete _this.availableFirstInitialInspectionTimeSlots;
                        }
                        _this.firstInitialTimeSlotsLoading = false;
                    }
                    else {
                        var message = _this.localize.getLocalizedString('Message_FailedToLoadAvailableDays', 'ContractTermination');
                        _this.alerting.popError(message);
                        _this.firstInitialTimeSlotsLoading = false;
                    }
                };
                this.loadAvailableInitialInspectionTimeSlotsCallback = function (data) {
                    if (data.success === true) {
                        var result = [];
                        if (data.data && data.data.length === 1) {
                            var entry = data.data[0];
                            if (entry.TimeSlots && entry.TimeSlots.length !== 0) {
                                angular.forEach(entry.TimeSlots, function (slot) {
                                    result.push({
                                        Description: slot.StartTime + ' - ' + slot.EndTime,
                                        Item: slot
                                    });
                                });
                            }
                        }
                        if (result.length > 0) {
                            _this.availableInitialInspectionTimeSlots = result;
                        }
                        else {
                            delete _this.availableInitialInspectionTimeSlots;
                        }
                        _this.initialTimeSlotsLoading = false;
                    }
                    else {
                        var message = _this.localize.getLocalizedString('Message_FailedToLoadAvailableDays', 'ContractTermination');
                        _this.alerting.popError(message);
                        delete _this.availableInitialInspectionTimeSlots;
                        _this.initialTimeSlotsLoading = false;
                    }
                };
                this.loadAvailableFinalInspectionTimeSlotsCallback = function (data) {
                    if (data.success === true) {
                        var result = [];
                        if (data.data && data.data.length === 1) {
                            var entry = data.data[0];
                            if (entry.TimeSlots && entry.TimeSlots.length !== 0) {
                                angular.forEach(entry.TimeSlots, function (slot) {
                                    result.push({
                                        Description: slot.StartTime + ' - ' + slot.EndTime,
                                        Item: slot
                                    });
                                });
                            }
                        }
                        if (result.length > 0) {
                            _this.availableFinalInspectionTimeSlots = result;
                        }
                        else {
                            delete _this.availableFinalInspectionTimeSlots;
                        }
                        _this.finalTimeSlotsLoading = false;
                    }
                    else {
                        var message = _this.localize.getLocalizedString('Message_FailedToLoadAvailableDays', 'ContractTermination');
                        _this.alerting.popError(message);
                        delete _this.availableFinalInspectionTimeSlots;
                        _this.finalTimeSlotsLoading = false;
                    }
                };
                this.contractTerminationCallback = function (result) {
                    if (!result.success && !result.data.success) {
                        _this.alerting.popError(_this.getResource("Message_GenericError"), _this.title);
                        _this.processing = false;
                        return;
                    }
                    _this.contractService.refreshCustomerDetails().then(function (result) {
                        var terminationDate = _this.$filter('date')(_this.formContainer.terminationDate.toDate(), 'd MMMM yyyy');
                        var message = _this.getResource('Message_ContractTerminationInfo', [_this.formContainer.selectedContract.Address, terminationDate]);
                        var notEndedContracts = _this.countExtraNotEndedContracts(result.data.ActiveContracts);
                        _this.alerting
                            .popInfo(message, _this.title)
                            .then(function () {
                            if (notEndedContracts > 0) {
                                _this.displayWarningMessageForEndingOtherContracts(result.data.ActiveContracts);
                            }
                            _this.$state.go('myContracts');
                        })
                            .catch(function () {
                            if (notEndedContracts > 0) {
                                _this.displayWarningMessageForEndingOtherContracts(result.data.ActiveContracts);
                            }
                            _this.$state.go('myContracts');
                        });
                    });
                };
                this.formContainer = {
                    companyName: $stateParams.companyName,
                    realtyObjectNo: $stateParams.realtyObjectNo
                };
            }
            controller.prototype.$onInit = function () {
                this.activate();
            };
            controller.prototype.activate = function () {
                if (this.$stateParams.shouldTransitionToState !== null) {
                    this.$state.go(this.$stateParams.shouldTransitionToState);
                    return;
                }
                this.title = this.getResource("Page_Title");
                this.processCustomerDetails(this.customerDetailsResponse);
                this.contractTerminationService.getCountries().then(this.countryCallback);
                this.contractTerminationService.getTermPlanningFirstInspection()
                    .then(this.getTermPlanningFirstInspectionCallBack);
            };
            controller.prototype.processCustomerDetails = function (data) {
                if (data.success === true) {
                    this.customerDetails = data.data;
                    this.contractTerminationService.getUserContactDetailsValidation().then(this.getUserContactDetailsValidationCallback);
                }
                else {
                    var message = this.localize.getLocalizedString('Message_FailedToLoadCustomerDetails', 'ContractTermination');
                    this.alerting.popError(message, this.title);
                }
            };
            controller.prototype.terminationDateChanged = function () {
                if (!this.formContainer.terminationDate) {
                    return;
                }
                if (this.formContainer.initialInspection1
                    && this.formContainer.terminationDate.isBefore(this.formContainer.initialInspection1.Date, 'day')) {
                    delete this.formContainer.initialInspection1;
                }
                if (this.formContainer.initialInspection2
                    && this.formContainer.terminationDate.isBefore(this.formContainer.initialInspection2.Date, 'day')) {
                    delete this.formContainer.initialInspection2;
                }
                if (this.formContainer.finalInspection1
                    && this.formContainer.terminationDate.isBefore(this.formContainer.finalInspection1.Date, 'day')) {
                    delete this.formContainer.finalInspection1;
                }
                if (this.formContainer.finalInspection2
                    && this.formContainer.terminationDate.isBefore(this.formContainer.finalInspection2.Date, 'day')) {
                    delete this.formContainer.finalInspection2;
                }
                if (this.formContainer.terminationDate.isBefore(this.formContainer.changeContactDataFrom, 'day')) {
                    this.formContainer.changeContactDataFrom = this.formContainer.terminationDate;
                }
                this.changeContactDataFromDatePickerConfig.maxDate = this.formContainer.terminationDate;
            };
            controller.prototype.contactDetailsChanged = function () {
                if (!this.userContactDetailsValidation) {
                    this.phoneNumberRequired = false;
                    this.emailRequired = false;
                }
                else {
                    var telephone = this.userContactDetailsValidation.indexOf('telephone') != -1;
                    var email = this.userContactDetailsValidation.indexOf('email') != -1;
                    var or = this.userContactDetailsValidation.indexOf('|') != -1;
                    if (telephone) {
                        if (or && email) {
                            this.phoneNumberRequired = !this.customerDetails.Email || this.customerDetails.Email === '';
                        }
                        else {
                            this.phoneNumberRequired = true;
                        }
                    }
                    else {
                        this.phoneNumberRequired = false;
                    }
                    if (email) {
                        if (or && telephone) {
                            this.emailRequired = !this.customerDetails.PhoneNo || this.customerDetails.PhoneNo === '';
                        }
                        else {
                            this.emailRequired = true;
                        }
                    }
                    else {
                        this.emailRequired = false;
                    }
                }
            };
            controller.prototype.getDefaultCountryCode = function () {
                if (typeof this._defaultCountryCode === 'undefined') {
                    this._defaultCountryCode = this.localize.getLocalizedString('DefaultCountryCode', 'MyDetails');
                }
                return this._defaultCountryCode;
            };
            controller.prototype.determineForeignCountry = function () {
                this.isNL = this.formContainer.CountryCode === this.getDefaultCountryCode() || this.formContainer.CountryCode === '' || this.formContainer.CountryCode === undefined;
            };
            controller.prototype.updateStreetAndCity = function (myAddressForm) {
                if (this.isNL) {
                    if (this.formContainer.Postcode && this.formContainer.HouseNo) {
                        this.terminationForm = myAddressForm;
                        this.contractTerminationService.getStreetAndCityFromPostcode(this.formContainer.Country, this.formContainer.Postcode, this.formContainer.HouseNo).then(this.updateStreetAndCityCallback);
                    }
                    else {
                        this.formContainer.Street = '';
                        this.formContainer.City = '';
                    }
                }
            };
            controller.prototype.prepareTermination = function () {
                var _this = this;
                angular.forEach(this.customerDetails.ActiveContracts, function (contract) {
                    if (contract.CompanyName == _this.formContainer.companyName
                        && contract.RentalUnit.No == _this.formContainer.realtyObjectNo) {
                        _this.formContainer.selectedContract = contract;
                    }
                });
                if (this.formContainer.selectedContract) {
                    this.contractTerminationService.getContractTerminationExists(this.formContainer.selectedContract.CompanyName, this.formContainer.selectedContract.RentalUnit.No).then(this.getContractTerminationExistsCallback);
                }
            };
            controller.prototype.determineFirstTerminationDate = function () {
                var firstTerminationDate = moment(this.formContainer.selectedContract.FirstTerminationDate);
                this.getFirstAvailableWorkingDay(firstTerminationDate, this.getFirstAvailableWorkingDayCallback);
            };
            controller.prototype.getFirstAvailableWorkingDay = function (terminationDate, callback) {
                var _this = this;
                var dayOfWeek = terminationDate.day();
                if (dayOfWeek !== 0 && dayOfWeek !== 6) {
                    var year = terminationDate.year();
                    var month = terminationDate.month() + 1;
                    var day = terminationDate.date();
                    return this.contractService.isWorkingDay(year, month, day).then(function (response) {
                        if (response.data === true) {
                            callback(terminationDate);
                        }
                        else {
                            terminationDate = terminationDate.add(1, 'day');
                            _this.getFirstAvailableWorkingDay(terminationDate, callback);
                        }
                    });
                }
                else {
                    terminationDate = terminationDate.add(1, 'day');
                    this.getFirstAvailableWorkingDay(terminationDate, callback);
                }
            };
            controller.prototype.getInspectionDuration = function (resourceString, duration) {
                duration = duration.replace('PT', '');
                if (duration.indexOf('H') != -1 && duration.indexOf('M') != -1) {
                    duration = duration.replace('H', ":").replace('M', ' uur');
                }
                else {
                    duration = duration.replace('H', ' uur').replace('M', ' minuten');
                }
                duration = this.localize.getLocalizedString(resourceString, 'ContractTermination', duration);
                return duration;
            };
            controller.prototype.createAppointmentForInspection = function (inspection) {
                var startDate = inspection.Date.format("YYYY-MM-DD");
                var startTime = inspection.TimeSlot.StartTime;
                startTime = 'PT' + startTime.replace(':', 'H') + 'M';
                startTime = startTime.replace('00M', '');
                return {
                    'StartDate': startDate,
                    'StartTime': startTime
                };
            };
            controller.prototype.terminateContract = function (terminationForm) {
                if (terminationForm.$invalid) {
                    return;
                }
                this.processing = true;
                var contractTermination = {
                    CompanyName: this.formContainer.selectedContract.CompanyName,
                    RealtyObjectNo: this.formContainer.selectedContract.RentalUnit.No,
                    Address: this.formContainer.selectedContract.Address,
                    TerminationDate: this.formContainer.terminationDate.format('YYYY-MM-DD'),
                    Street: this.formContainer.Street,
                    HouseNo: this.formContainer.HouseNo,
                    HouseNoAddition: this.formContainer.HouseNoAddition,
                    Postcode: this.formContainer.Postcode,
                    City: this.formContainer.City,
                    Reason: this.formContainer.selectedTerminationReason,
                    Comments: "",
                    PhoneNo: this.customerDetails.PhoneNo,
                    Email: this.customerDetails.Email,
                    CountryCode: this.determineCountryCode(this.formContainer.CountryCode),
                    ChangeContactDataFrom: this.formContainer.changeContactDataFrom.format('YYYY-MM-DD'),
                    FirstInitialAppointment: (this.formContainer.initialInspection1 ? this.createAppointmentForInspection(this.formContainer.initialInspection1) : null),
                    SecondInitialAppointment: (this.formContainer.initialInspection2 ? this.createAppointmentForInspection(this.formContainer.initialInspection2) : null),
                    FirstFinalAppointment: (this.formContainer.finalInspection1 ? this.createAppointmentForInspection(this.formContainer.finalInspection1) : null),
                    SecondFinalAppointment: (this.formContainer.finalInspection2 ? this.createAppointmentForInspection(this.formContainer.finalInspection2) : null)
                };
                this.contractTerminationService.contractTermination(contractTermination).then(this.contractTerminationCallback);
            };
            controller.prototype.displayWarningMessageForEndingOtherContracts = function (activeContracts) {
                var message = this.getResource("Message_EndOtherContracts");
                var title = this.getResource("Dialog_EndOtherContractsTitle");
                this.alerting.popInfo(message, title)
                    .then(function () { })
                    .catch(function () { });
            };
            controller.prototype.countExtraNotEndedContracts = function (activeContracts) {
                var _this = this;
                var notEndedContracts = 0;
                angular.forEach(activeContracts, function (contract) {
                    if (contract.RentalUnit.No !== _this.$stateParams.realtyObjectNo && !contract.EndDate) {
                        notEndedContracts++;
                    }
                });
                return notEndedContracts;
            };
            controller.prototype.determineCountryCode = function (code) {
                if (!code) {
                    code = this.getDefaultCountryCode();
                }
                return code;
            };
            controller.prototype.getResource = function (key, values) {
                return this.localize.getLocalizedString(key, "ContractTermination", values);
            };
            return controller;
        }());
        angular
            .module('customer.contractTermination')
            .component('contractTermination', {
            bindings: {
                customerDetailsResponse: '='
            },
            controller: controller,
            templateUrl: '/App/contractTermination/contractTermination.html'
        });
    })(contractTermination = customer.contractTermination || (customer.contractTermination = {}));
})(customer || (customer = {}));
//# sourceMappingURL=contractTermination.component.js.map
var customer;
(function (customer) {
    var contractTermination;
    (function (contractTermination) {
        angular
            .module('customer.contractTermination')
            .config(configRoutes);
        function configRoutes($stateProvider, $urlRouterProvider, $locationProvider) {
            var contractTerminationRoute = {
                name: 'contractTermination',
                url: '/myContracts/terminate/:companyName/:realtyObjectNo',
                params: {
                    companyName: null,
                    realtyObjectNo: null,
                    shouldTransitionToState: null
                },
                template: '<contract-termination customer-details-response="$resolve.customerDetailsResponse"></contract-termination>',
                portalModule: 'Rescission',
                resolve: {
                    contractTerminationExists: contractTerminationExistsProvider,
                    customerDetailsResponse: customerDetailsResponseProvider
                },
                onEnter: checkStateChangePreconditions
            };
            $locationProvider.html5Mode(true);
            $stateProvider
                .state('contractTermination', contractTerminationRoute);
            contractTerminationExistsProvider.$inject = ['contractTerminationService', '$stateParams'];
            function contractTerminationExistsProvider(contractTerminationService, $stateParams) {
                return contractTerminationService
                    .getContractTerminationExists($stateParams.companyName, $stateParams.realtyObjectNo)
                    .then(function (response) {
                    return response.data;
                });
            }
            customerDetailsResponseProvider.$inject = ['contractService'];
            function customerDetailsResponseProvider(contractService) {
                return contractService.getCustomerDetails();
            }
            checkStateChangePreconditions.$inject = ['contractTerminationExists', 'customerDetailsResponse', 'alerting', 'localize', '$stateParams'];
            function checkStateChangePreconditions(contractTerminationExists, customerDetailsResponse, alerting, localize, $stateParams) {
                var preconditions = getStateChangePreconditions(contractTerminationExists, customerDetailsResponse, alerting, localize, $stateParams);
                for (var i = 0; i < preconditions.length; i++) {
                    var condition = preconditions[i];
                    if (!condition.conditionTest()) {
                        condition.testFailedAction();
                        break;
                    }
                }
            }
            function getStateChangePreconditions(contractTerminationExists, customerDetailsResponse, alerting, localize, $stateParams) {
                var preconditions = [
                    {
                        conditionTest: contractBelongsToTheCurrentUser,
                        testFailedAction: redirectToMyContractsPage
                    },
                    {
                        conditionTest: contractNotAlreadyTerminated,
                        testFailedAction: displayContractTerminationExists
                    }
                ];
                return preconditions;
                function contractNotAlreadyTerminated() {
                    return !contractTerminationExists.Success;
                }
                function displayContractTerminationExists() {
                    var message = localize.getLocalizedString('Message_ContractTerminationExistst', 'ContractTermination');
                    alerting.popError(message);
                    $stateParams.shouldTransitionToState = 'myContracts';
                }
                function contractBelongsToTheCurrentUser() {
                    var activeContracts = customerDetailsResponse.data.ActiveContracts;
                    var contractFound = false;
                    angular.forEach(activeContracts, function (contract) {
                        if (contract.CompanyName == $stateParams.companyName && contract.RentalUnit.No == $stateParams.realtyObjectNo) {
                            contractFound = true;
                        }
                    });
                    return contractFound;
                }
                function redirectToMyContractsPage() {
                    $stateParams.shouldTransitionToState = 'myContracts';
                }
            }
        }
    })(contractTermination = customer.contractTermination || (customer.contractTermination = {}));
})(customer || (customer = {}));
//# sourceMappingURL=contractTermination.route.js.map
var customer;
(function (customer) {
    var contractTermination;
    (function (contractTermination_1) {
        var contractTerminationService = (function () {
            function contractTerminationService(dataservice, $http) {
                this.dataservice = dataservice;
                this.$http = $http;
            }
            contractTerminationService.prototype.getInspectionsData = function (companyName, realtyObjectNo) {
                var url = '/api/contract/readinspectiondata/' + companyName + '?realtyObjectNo=' + realtyObjectNo;
                return this.dataservice.getData(url);
            };
            contractTerminationService.prototype.getContractTerminationReasons = function (companyName) {
                var url = '/api/contract/terminationreasons/' + companyName;
                return this.dataservice.getData(url);
            };
            contractTerminationService.prototype.getCountries = function () {
                var url = '/api/settings/countries';
                return this.dataservice.getData(url, true);
            };
            contractTerminationService.prototype.getTermPlanningFirstInspection = function () {
                var url = '/api/settings';
                return this.dataservice.getData(url, true);
            };
            contractTerminationService.prototype.getStreetAndCityFromPostcode = function (country, postcode, houseNo) {
                if (!country) {
                    country = 'NL';
                }
                var url = '/api/settings/address/' + encodeURIComponent(country) + '/' + encodeURIComponent(postcode) + '/' + encodeURIComponent(houseNo);
                return this.$http.get(url)
                    .then(function (response) {
                    if (response.data.success === false) {
                        return response;
                    }
                    return response.data;
                })
                    .catch(function (response) {
                    var error = {
                        success: false,
                        message: response.data.data.message,
                        code: response.data.data.code,
                        fullMessage: response.data.data.fullMessage
                    };
                    return error;
                });
            };
            contractTerminationService.prototype.contractTermination = function (contractTermination) {
                var url = '/api/contract/termination';
                return this.dataservice.postData(url, contractTermination);
            };
            contractTerminationService.prototype.getUserContactDetailsValidation = function () {
                var url = '/api/settings/usercontactdetailsvalidation';
                return this.dataservice.getData(url);
            };
            contractTerminationService.prototype.getContractTerminationExists = function (companyName, realtyObjectNo) {
                var url = '/api/contract/' + companyName + '/terminationexists?realtyObjectNo=' + realtyObjectNo;
                return this.dataservice.getData(url);
            };
            contractTerminationService.prototype.getAvailableDates = function (companyName, realtyObjectNo, type, date, firstPreInspection) {
                var url = '/api/contract/getavailabledates/' + companyName + '?realtyObjectNo=' + realtyObjectNo + '&inspectionType=' + type + '&startDate=' + date + '&firstPreInspection=' + firstPreInspection;
                return this.dataservice.getData(url);
            };
            return contractTerminationService;
        }());
        contractTermination_1.contractTerminationService = contractTerminationService;
        angular
            .module('customer.contractTermination')
            .service('contractTerminationService', contractTerminationService);
    })(contractTermination = customer.contractTermination || (customer.contractTermination = {}));
})(customer || (customer = {}));
//# sourceMappingURL=contractTermination.service.js.map
var customer;
(function (customer) {
    var customerQuestion;
    (function (customerQuestion) {
        var controller = (function () {
            function controller($stateParams, contractService, knowledgebaseService, localize, alerting, $window) {
                var _this = this;
                this.$stateParams = $stateParams;
                this.contractService = contractService;
                this.knowledgebaseService = knowledgebaseService;
                this.localize = localize;
                this.alerting = alerting;
                this.$window = $window;
                this.companyName = null;
                this.rentalUnit = null;
                this.contractSelection = true;
                this.tmpAnswer = null;
                this.$inject = ['$stateParams', 'contractService', 'knowledgebaseService', 'localize', 'alerting', '$window'];
                this.customerDetailsCallback = function (data) {
                    if (data.success === true) {
                        _this.customerDetails = data.data;
                        if (_this.customerDetails.ActiveContracts && _this.customerDetails.ActiveContracts.length === 1) {
                            _this.contractSelection = false;
                            _this.selectContract(_this.customerDetails.ActiveContracts[0]);
                        }
                    }
                    else {
                        var message = _this.localize.getLocalizedString('Message_FailedToLoadCustomer', 'CustomerQuestion');
                        _this.alerting.popError(message);
                    }
                };
                this.selectContract = function (contract) {
                    _this.selectedContract = contract;
                    _this.companyName = contract.CompanyName;
                    _this.rentalUnit = contract.RentalUnit.No;
                    _this.getData();
                };
                this.getData = function () {
                    _this.knowledgebaseService.getCustomerQuestion(_this.questionId, _this.companyName, _this.rentalUnit, _this.searchID).then(function (data) {
                        if (data.success === true) {
                            _this.processData(data.data);
                        }
                        else {
                            var message = _this.localize.getLocalizedString('Message_FailedToLoadQuestion', 'CustomerQuestion');
                            _this.alerting.popError(message);
                        }
                    });
                };
                this.processData = function (serverResponse) {
                    _this.tmpAnswer = null;
                    if (serverResponse.CurrentQuestion && serverResponse.CurrentQuestion.PossibleAnswers) {
                        serverResponse.CurrentQuestion.PossibleAnswers.sort(function (a, b) { return a.Description.localeCompare(b.Description); });
                    }
                    if (!serverResponse.AnsweredQuestions) {
                        serverResponse.AnsweredQuestions = [];
                    }
                    if (serverResponse.Advice && !serverResponse.Advice.Description && serverResponse.CurrentQuestion.ID) {
                        serverResponse.Advice = null;
                    }
                    else if (serverResponse.Advice && !serverResponse.Advice.Description) {
                        serverResponse.Advice.Description = _this.localize.getLocalizedString('Label_No_Advice', 'CustomerQuestion');
                    }
                    _this.baseQuestion = JSON.parse(JSON.stringify(serverResponse));
                    _this.initialQuestion = _this.baseQuestion.Description;
                };
                this.submitAnswer = function (answer) {
                    var answerData = new customer.knowledgebase.models.AnsweredQuestion();
                    answerData.Answer = new customer.knowledgebase.models.Answer();
                    answerData.Answer.ID = answer.ID;
                    answerData.Question = JSON.parse(JSON.stringify(_this.baseQuestion.CurrentQuestion));
                    _this.postAnswer(answerData);
                };
                this.postAnswer = function (answer) {
                    if (answer) {
                        _this.baseQuestion.AnsweredQuestions.push(answer);
                    }
                    _this.baseQuestion.CurrentQuestion = null;
                    _this.knowledgebaseService.postCustomerQuestionAnswer(_this.questionId, _this.companyName, _this.rentalUnit, _this.baseQuestion).then(function (data) {
                        if (data.success === true) {
                            _this.processData(data.data);
                        }
                        else {
                            var message = _this.localize.getLocalizedString('Message_FailedToLoadQuestion', 'CustomerQuestion');
                            _this.alerting.popError(message);
                        }
                    });
                };
                this.resetUntil = function (index) {
                    if (index < 0) {
                        delete _this.selectedContract;
                        delete _this.companyName;
                        delete _this.rentalUnit;
                        delete _this.baseQuestion;
                    }
                    else {
                        if (index === 0) {
                            _this.getData();
                        }
                        else {
                            _this.baseQuestion.AnsweredQuestions.splice(index + 1, _this.baseQuestion.AnsweredQuestions.length);
                            _this.postAnswer();
                        }
                    }
                };
                this.formatLink = function (url) {
                    if (!url) {
                        return "javascript:void(0);";
                    }
                    url = url.trim();
                    if (_this.isAbsoluteURL(url)) {
                        if (_this.hasSchemeDefined(url)) {
                            return url;
                        }
                        else {
                            return _this.buildURL("http://", url);
                        }
                    }
                    else {
                        return _this.buildURL(window.location.origin, url);
                    }
                };
                this.isAbsoluteURL = function (url) {
                    if (!url) {
                        return false;
                    }
                    url = url.trim();
                    if (_this.hasSchemeDefined(url)) {
                        return true;
                    }
                    if (_this.startsWith(url, "/")) {
                        return false;
                    }
                    var host = url.split("/")[0];
                    if (host.indexOf(".") !== -1 || host.indexOf(":") !== -1) {
                        return true;
                    }
                    return false;
                };
                this.buildURL = function (base, relativeURL) {
                    if (_this.endsWith(base, "/")) {
                        base = base.substring(0, base.length - 1);
                    }
                    if (_this.startsWith(relativeURL, "/")) {
                        relativeURL = relativeURL.substring(1);
                    }
                    return base + "/" + relativeURL;
                };
                this.hasSchemeDefined = function (url) {
                    return /^(?:[a-z]+:)?\/\//i.test(url);
                };
                this.startsWith = function (str, prefix) {
                    return str.lastIndexOf(prefix, 0) === 0;
                };
                this.endsWith = function (str, suffix) {
                    return str.indexOf(suffix, str.length - suffix.length) !== -1;
                };
                this.initialQuestion = $stateParams.initialQuestion;
                this.questionId = $stateParams.questionId;
                this.searchID = $stateParams.searchID;
                this.query = $stateParams.knowledgeQuery;
                this.items = $stateParams.knowledgeItems;
                this.defaultOpenSubject = $stateParams.openSubject;
                this.activate();
            }
            controller.prototype.activate = function () {
                if (this.questionId) {
                    this.contractService.getCustomerDetails().then(this.customerDetailsCallback);
                }
            };
            return controller;
        }());
        angular
            .module('customer.customerQuestion')
            .component('customerQuestion', {
            controller: controller,
            templateUrl: '/App/customerQuestion/customerQuestion.html'
        });
    })(customerQuestion = customer.customerQuestion || (customer.customerQuestion = {}));
})(customer || (customer = {}));
//# sourceMappingURL=customerQuestion.component.js.map
var customer;
(function (customer) {
    var customerQuestion;
    (function (customerQuestion) {
        angular
            .module('customer.customerQuestion')
            .config(configRoutes);
        function configRoutes($stateProvider, $urlRouterProvider, $locationProvider) {
            $locationProvider.html5Mode(true);
            $stateProvider
                .state('customerQuestion', {
                url: '/customerQuestion/:questionId',
                params: {
                    questionId: null,
                    initialQuestion: null,
                    knowledgeQuery: null,
                    knowledgeItems: null,
                    openSubject: null,
                    searchID: null
                },
                template: '<customer-question></customer-question>',
                name: 'customerQuestion'
            });
        }
    })(customerQuestion = customer.customerQuestion || (customer.customerQuestion = {}));
})(customer || (customer = {}));
//# sourceMappingURL=customerQuestion.route.js.map
var customer;
(function (customer) {
    var emailTemplatesManagement;
    (function (emailTemplatesManagement) {
        var emailData = (function () {
            function emailData() {
            }
            return emailData;
        }());
        emailTemplatesManagement.emailData = emailData;
    })(emailTemplatesManagement = customer.emailTemplatesManagement || (customer.emailTemplatesManagement = {}));
})(customer || (customer = {}));
//# sourceMappingURL=emailData.js.map
var customer;
(function (customer) {
    var emailTemplatesManagement;
    (function (emailTemplatesManagement) {
        var emailTemplateOption = (function () {
            function emailTemplateOption() {
            }
            return emailTemplateOption;
        }());
        emailTemplatesManagement.emailTemplateOption = emailTemplateOption;
    })(emailTemplatesManagement = customer.emailTemplatesManagement || (customer.emailTemplatesManagement = {}));
})(customer || (customer = {}));
//# sourceMappingURL=emailTemplateOption.js.map
var customer;
(function (customer) {
    var emailTemplatesManagement;
    (function (emailTemplatesManagement) {
        var emailTemplatesController = (function () {
            function emailTemplatesController(emailTemplatesManagementService, localize, alerting, $scope) {
                this.emailTemplatesManagementService = emailTemplatesManagementService;
                this.localize = localize;
                this.alerting = alerting;
                this.$scope = $scope;
                this.$inject = ['emailTemplatesManagementService', 'localize', 'alerting', '$scope'];
                this.activate();
            }
            emailTemplatesController.prototype.activate = function () {
                this.$scope.btnClass = "btn btn-primary";
                this.$scope.btnIcon = "";
                this.$scope.btnTitle = this.getResource("Button_Import");
                this.availableOptions = [
                    { Id: 1, Name: this.getResource("Option_Change_Password") },
                    { Id: 2, Name: this.getResource("Option_Reset_Account") },
                    { Id: 3, Name: this.getResource("Option_Confirm_Account") },
                    { Id: 4, Name: this.getResource("Option_Email_Change") },
                    { Id: 5, Name: this.getResource("Option_Contact_Change_Details") },
                    { Id: 6, Name: this.getResource("Option_TwoFactorCode_Mail") }
                ];
                var mb = 1024 * 1024;
                this.maxFileSize = 0.5 * mb;
                this.fileType = ".html";
            };
            emailTemplatesController.prototype.getResource = function (key, dict) {
                if (dict === void 0) { dict = "EmailTemplatesManagement"; }
                return this.localize.getLocalizedString(key, dict);
            };
            emailTemplatesController.prototype.onFileSelected = function () {
                var reader = new FileReader();
                var that = this;
                var opt = this.selectedOption;
                reader.onload = function (e) {
                    var emd = new customer.emailTemplatesManagement.emailData();
                    emd.Id = opt.Id;
                    emd.Name = opt.Name;
                    emd.FileContent = e.target.result;
                    return that.emailTemplatesManagementService.importItem(emd).then(function (response) {
                        if (response) {
                            that.alerting.popInfo(that.getResource('Message_SucessfullyImported'), that.getResource('Dialog_ImportEmailTemplateTitle'));
                            that.activate();
                        }
                        else {
                            that.alerting.popError(that.getResource('Message_ImportFailed'), that.getResource('Dialog_ImportEmailTemplateTitle'));
                        }
                    });
                };
                reader.readAsText(this.selectedFiles[0]);
            };
            emailTemplatesController.prototype.getExportUrl = function () {
                var id = 0;
                if (this.selectedOption && this.selectedOption.Id) {
                    id = this.selectedOption.Id;
                }
                return this.emailTemplatesManagementService.getExportUrl(id);
            };
            emailTemplatesController.prototype.onerror = function (file, errorMessageCode) {
                switch (errorMessageCode) {
                    case 1:
                        this.fileTooLargeMessage = this.localize.getLocalizedString(this.$scope.fileTooLargeMessage, this.$scope.viewName, file.name);
                        break;
                    case 2:
                        this.fileTooLargeMessage = this.localize.getLocalizedString(this.$scope.invalidFileExtension, this.$scope.viewName, file.name);
                        break;
                }
                this.fileTooLarge = true;
            };
            return emailTemplatesController;
        }());
        ;
        angular
            .module('customer.emailTemplatesManagement')
            .component('emailTemplatesManagement', {
            controller: emailTemplatesController,
            controllerAs: '$ctrl',
            templateUrl: '/App/emailTemplatesManagement/emailTemplatesManagement.html'
        });
    })(emailTemplatesManagement = customer.emailTemplatesManagement || (customer.emailTemplatesManagement = {}));
})(customer || (customer = {}));
;
//# sourceMappingURL=emailTemplatesManagement.component.js.map
var customer;
(function (customer) {
    var emailTemplatesManagement;
    (function (emailTemplatesManagement) {
        angular
            .module('customer.emailTemplatesManagement')
            .config(configRoutes);
        function configRoutes($stateProvider, $locationProvider) {
            $locationProvider.html5Mode(true);
            $stateProvider
                .state('emailTemplatesManagement', {
                url: '/emailTemplatesManagement/manage',
                template: '<email-templates-management></email-templates-management>',
                params: {
                    searchState: null
                }
            });
        }
    })(emailTemplatesManagement = customer.emailTemplatesManagement || (customer.emailTemplatesManagement = {}));
})(customer || (customer = {}));
//# sourceMappingURL=emailTemplatesManagement.route.js.map
var customer;
(function (customer) {
    var emailTemplatesManagement;
    (function (emailTemplatesManagement) {
        var emailTemplatesManagementService = (function () {
            function emailTemplatesManagementService(dataservice) {
                this.dataservice = dataservice;
            }
            emailTemplatesManagementService.prototype.importItem = function (template) {
                return this.dataservice.postData('/api/emailTemplatesManagement/import', template).then(function (response) {
                    return response;
                });
            };
            emailTemplatesManagementService.prototype.getExportUrl = function (id) {
                return "/api/emailTemplatesManagement/template/" + id;
            };
            return emailTemplatesManagementService;
        }());
        emailTemplatesManagement.emailTemplatesManagementService = emailTemplatesManagementService;
        angular
            .module('customer.emailTemplatesManagement')
            .service('emailTemplatesManagementService', emailTemplatesManagementService);
    })(emailTemplatesManagement = customer.emailTemplatesManagement || (customer.emailTemplatesManagement = {}));
})(customer || (customer = {}));
//# sourceMappingURL=emailTemplatesManagement.service.js.map
var customer;
(function (customer) {
    var footer;
    (function (footer) {
        var controller = (function () {
            function controller($rootScope) {
                var _this = this;
                this.$rootScope = $rootScope;
                this.$inject = ['$rootScope'];
                this.footerPositionChanged = function () {
                    var footerTop = $(window).height() - ($('.footer').offset().top - _this.getScrollTop());
                    var lastMenuItemBottom = $(window).height() - ($('.nav-sidebar').find('li').last().position().top + $('.nav-sidebar').find('li').last().outerHeight() + $('nav').outerHeight());
                    $('.nav-sidebar li').css("padding-left", _this.sidebarListItemPadding + "px");
                    $('.nav-sidebar li > .icon').css("margin-right", _this.sidebarListItemIconMargin + "px");
                    if (_this.sidebarHeightLargerThanScreen(lastMenuItemBottom) && !_this.footerIsVisible(footerTop)) {
                        _this.setSidebarScroll('0', 'auto');
                    }
                    else {
                        if (footerTop > lastMenuItemBottom) {
                            _this.setSidebarScroll(footerTop + 'px', 'auto');
                            $('.nav-sidebar li').css("padding-left", "10px");
                            $('.nav-sidebar li > .icon').css("margin-right", "0");
                        }
                        else {
                            _this.setSidebarScroll('0', '100vh');
                        }
                    }
                };
                this.activate();
            }
            controller.prototype.activate = function () {
                var _this = this;
                this.sidebarListItemIconMargin = parseInt($('.nav-sidebar li > .icon').css("margin-right"));
                this.sidebarListItemPadding = parseInt($('.nav-sidebar li').css("padding-left"));
                this.$rootScope.$on('$viewContentLoaded', function (event, viewConfig) {
                    $('.sidebar').collapse('hide');
                    setTimeout(function () {
                        $('.navbar-title').html($('.nav-sidebar > li.active > .nav-sidebar-title').html());
                        $('.sidebar').scrollTop(0);
                        window.scrollTo(0, 0);
                        $('.main').resize(_this.footerPositionChanged);
                    }, 200);
                });
                $(window).scroll(function () {
                    _this.footerPositionChanged();
                    if ($(document).scrollLeft() !== 0) {
                        $(document).scrollLeft(0);
                    }
                });
            };
            controller.prototype.getScrollTop = function () {
                var windowHeigthDiff = window.innerHeight - $(window).height();
                var returnedHeight = $(window).scrollTop();
                if (windowHeigthDiff > 0)
                    returnedHeight += windowHeigthDiff;
                return returnedHeight;
            };
            controller.prototype.sidebarHeightLargerThanScreen = function (lastMenuItemBottom) {
                return lastMenuItemBottom < 0;
            };
            controller.prototype.footerIsVisible = function (footerTop) {
                return footerTop > 0;
            };
            controller.prototype.setSidebarScroll = function (bottomPos, height) {
                $('.sidebar').css('bottom', bottomPos);
                $('.sidebar').css('height', height);
                $(".sidebar").css("overflow-y", "auto");
            };
            return controller;
        }());
        angular
            .module('customer.footer')
            .component('portalFooter', {
            controller: controller,
            templateUrl: '/App/footer/footer.html'
        });
    })(footer = customer.footer || (customer.footer = {}));
})(customer || (customer = {}));
//# sourceMappingURL=footer.component.js.map
var customer;
(function (customer) {
    var home;
    (function (home) {
        var controller = (function () {
            function controller(homeService, newsService, knowledgebaseService, contractService, $filter, localize, alerting) {
                var _this = this;
                this.homeService = homeService;
                this.newsService = newsService;
                this.knowledgebaseService = knowledgebaseService;
                this.contractService = contractService;
                this.$filter = $filter;
                this.localize = localize;
                this.alerting = alerting;
                this.slideInterval = 5000;
                this.firstTimeLogon = null;
                this.$inject = ['homeService', 'newsService', 'knowledgebaseService', 'contractService', '$filter', 'localize', 'alerting'];
                this.customerDetailsCallback = function (response) {
                    if (response.success === true) {
                        _this.customerDetails = response.data;
                    }
                    else {
                        var message = _this.localize.getLocalizedString('Message_FailedToLoadCustomerDetails', 'Home');
                        _this.alerting.popError(message);
                    }
                };
                this.activate();
            }
            controller.prototype.activate = function () {
                var _this = this;
                this.newsService.getNews(3, 0, true).then(function (response) {
                    _this.news = response.rows;
                });
                this.firstTimeLogon = this.homeService.getFirstTimeLogon();
                this.knowledgebaseService.getTopSubjectsQuestions().then(function (response) {
                    if (response.success === true && response.data !== null && response.data.length > 0) {
                        _this.questionsGroupedBySubject = _this.$filter('groupByElement')(response.data, 'SubjectDescription');
                    }
                });
                this.contractService.getCustomerDetails().then(this.customerDetailsCallback);
            };
            return controller;
        }());
        angular
            .module('customer.home')
            .component('home', {
            controller: controller,
            templateUrl: '/App/home/home.html'
        });
    })(home = customer.home || (customer.home = {}));
})(customer || (customer = {}));
//# sourceMappingURL=home.component.js.map
var customer;
(function (customer) {
    var home;
    (function (home) {
        angular
            .module('customer.home')
            .config(configRoutes);
        function configRoutes($stateProvider, $urlRouterProvider, $locationProvider) {
            $locationProvider.html5Mode(true);
            $stateProvider
                .state('home', {
                url: '/',
                template: '<home></home>'
            });
        }
    })(home = customer.home || (customer.home = {}));
})(customer || (customer = {}));
//# sourceMappingURL=home.route.js.map
var customer;
(function (customer) {
    var home;
    (function (home) {
        var homeService = (function () {
            function homeService($cookies) {
                this.$cookies = $cookies;
                this.FirstTimeLogon = false;
                this.$inject = ['$cookies'];
            }
            homeService.prototype.getFirstTimeLogon = function () {
                var firstTime = this.$cookies.get('FirstTimeLogon');
                if (firstTime) {
                    this.FirstTimeLogon = firstTime.toLocaleLowerCase() == 'true';
                    this.$cookies.remove('FirstTimeLogon');
                }
                return this.FirstTimeLogon;
            };
            return homeService;
        }());
        home.homeService = homeService;
        angular
            .module('customer.home')
            .service('homeService', homeService);
    })(home = customer.home || (customer.home = {}));
})(customer || (customer = {}));
//# sourceMappingURL=home.service.js.map
(function () {
    /*jshint -W069*/
    $.validator.addMethod("passwordcomplexity", function (value, element, params) {
        return isValid(
            value,
            core.constants.passwordValidation.minLength,
            core.constants.passwordValidation.maxLength,
            core.constants.passwordValidation.minUpper,
            core.constants.passwordValidation.minLower,
            core.constants.passwordValidation.minDigits,
            core.constants.passwordValidation.minNonAlphanumeric
        );
    });

    $.validator.unobtrusive.adapters.add("passwordcomplexity", function (options) {
        options.rules["passwordcomplexity"] = "#";
        options.messages["passwordcomplexity"] = options.message;
    });

    function isValid(password, minLength, maxLength, minUpper, minLower, minDigits, minNonAlphanumeric) {
        if (!password) {
            return false;
        }

        if (password.length < minLength || password.length > maxLength) {
            return false;
        }

        var hasUpperCase = new RegExp("^(.*?[A-Z]){" + minUpper + ",}", "g").test(password); // The password must contain uppercase characters
        var hasLowerCase = new RegExp("^(.*?[a-z]){" + minLower + ",}", "g").test(password); // The password must contain lowercase characters
        var hasNumbers = new RegExp("^(.*?[\\d]){" + minDigits + ",}", "g").test(password); // The password must contain numbers
        var hasNonalphas = new RegExp("^(.*?[\\W]){" + minNonAlphanumeric + ",}", "g").test(password); // The password must contain special characters

        if (!hasUpperCase || !hasLowerCase || !hasNumbers || !hasNonalphas) {
            return false;
        }

        return true;
    }
})();
var customer;
(function (customer) {
    var knowledgebase;
    (function (knowledgebase) {
        var controller = (function () {
            function controller($stateParams, knowledgebaseService, $filter, localize, keywords, $location, $anchorScroll) {
                var _this = this;
                this.$stateParams = $stateParams;
                this.knowledgebaseService = knowledgebaseService;
                this.$filter = $filter;
                this.localize = localize;
                this.keywords = keywords;
                this.$location = $location;
                this.$anchorScroll = $anchorScroll;
                this.page = 1;
                this.pageSize = 20;
                this.totalSubjects = 0;
                this.isLoading = false;
                this.doneLoadingMore = false;
                this.showHelperText = false;
                this.$inject = ['$stateParams', 'knowledgebaseService', '$filter', 'localize', 'keywords', '$location', '$anchorScroll'];
                this.scrollToDefaultOpenSubject = function () {
                    if (_this.defaultOpenSubject && _this.items) {
                        var subjectIndex = Object.keys(_this.items).indexOf(_this.defaultOpenSubject);
                        _this.$location.hash('subject_' + subjectIndex);
                        _this.$anchorScroll.yOffset = $(".navbar");
                        _this.$anchorScroll();
                    }
                };
                this.setTitle = function () {
                    if (!_this.query) {
                        _this.viewTitle = _this.localize.getLocalizedString('Title_Knowledge', 'KnowledgeBase');
                    }
                    else if (_this.query === _this.keywords.FAQ) {
                        _this.viewTitle = _this.localize.getLocalizedString('Title_TopSubjects', 'KnowledgeBase');
                    }
                    else if (_this.query === _this.keywords.ALL) {
                        _this.viewTitle = _this.localize.getLocalizedString('Title_Knowledge', 'KnowledgeBase');
                    }
                    else {
                        _this.viewTitle = _this.localize.getLocalizedString('Title_Search', 'KnowledgeBase', _this.query);
                    }
                };
                this.loadMore = function () {
                    if (_this.query !== _this.keywords.ALL || _this.doneLoadingMore === true)
                        return;
                    if (!_this.isLoading) {
                        _this.isLoading = true;
                        return _this.knowledgebaseService.getAllSubjectsAndQuestions(_this.page, _this.pageSize).then(function (data) {
                            var questions = data.rows;
                            Array.prototype.push.apply(_this.questions, questions);
                            _this.items = _this.$filter('groupByElement')(_this.questions, 'SubjectDescription');
                            _this.totalSubjects = data.results;
                            _this.isLoading = false;
                            _this.page++;
                            if (_this.totalSubjects === Object.keys(_this.items).length) {
                                _this.doneLoadingMore = true;
                            }
                        });
                    }
                };
                this.query = $stateParams.knowledgeQuery;
                this.defaultOpenSubject = $stateParams.openSubject;
                this.searchID = $stateParams.searchID;
                this.activate();
            }
            controller.prototype.activate = function () {
                var _this = this;
                this.setTitle();
                switch (this.query) {
                    case this.keywords.FAQ: {
                        this.items = this.$stateParams.knowledgeItems;
                        if (!this.items) {
                            this.knowledgebaseService.getTopSubjectsQuestions().then(function (data) {
                                _this.items = _this.$filter('groupByElement')(data.data, 'SubjectDescription');
                                _this.scrollToDefaultOpenSubject();
                            });
                        }
                        break;
                    }
                    case this.keywords.ALL: {
                        this.showHelperText = true;
                        this.isLoading = true;
                        this.knowledgebaseService.getAllSubjectsAndQuestions(this.page, this.pageSize).then(function (data) {
                            _this.isLoading = false;
                            _this.questions = data.rows;
                            _this.items = _this.$filter('groupByElement')(_this.questions, 'SubjectDescription');
                            _this.totalSubjects = data.results;
                            _this.page++;
                            if (_this.totalSubjects === Object.keys(_this.items).length) {
                                _this.doneLoadingMore = true;
                            }
                            _this.scrollToDefaultOpenSubject();
                        });
                        break;
                    }
                    default: {
                        this.items = this.$stateParams.knowledgeItems;
                        if (!this.items) {
                            if (!this.query)
                                this.query = '';
                            this.knowledgebaseService.search(this.query).then(function (data) {
                                _this.items = _this.$filter('groupByElement')(data.data.CustomerQuestions, 'SubjectDescription');
                                _this.scrollToDefaultOpenSubject();
                            });
                        }
                    }
                }
            };
            return controller;
        }());
        angular
            .module('customer.knowledgebase')
            .component('knowledgebase', {
            controller: controller,
            templateUrl: '/App/knowledgebase/knowledgebase.html'
        });
    })(knowledgebase = customer.knowledgebase || (customer.knowledgebase = {}));
})(customer || (customer = {}));
//# sourceMappingURL=knowledgebase.component.js.map
var customer;
(function (customer) {
    var knowledgebase;
    (function (knowledgebase) {
        angular
            .module('customer.knowledgebase')
            .constant('keywords', {
            "FAQ": "_faq",
            "ALL": "_all"
        });
    })(knowledgebase = customer.knowledgebase || (customer.knowledgebase = {}));
})(customer || (customer = {}));
//# sourceMappingURL=knowledgebase.constants.js.map
var customer;
(function (customer) {
    var knowledgebase;
    (function (knowledgebase) {
        angular
            .module('customer.knowledgebase')
            .config(configRoutes);
        function configRoutes($stateProvider, $urlRouterProvider, $locationProvider) {
            $locationProvider.html5Mode(true);
            $stateProvider
                .state('knowledgebase', {
                url: '/knowledgebase/:knowledgeQuery',
                params: {
                    knowledgeQuery: null,
                    knowledgeItems: null,
                    openSubject: null,
                    searchID: null
                },
                template: '<knowledgebase></knowledgebase>',
                name: 'knowledgebase'
            });
        }
    })(knowledgebase = customer.knowledgebase || (customer.knowledgebase = {}));
})(customer || (customer = {}));
//# sourceMappingURL=knowledgebase.route.js.map
var customer;
(function (customer) {
    var knowledgebase;
    (function (knowledgebase) {
        var knowledgebaseService = (function () {
            function knowledgebaseService(dataservice) {
                this.dataservice = dataservice;
                this.searchResults = null;
            }
            knowledgebaseService.prototype.search = function (keyword) {
                var _this = this;
                return this.dataservice.getData('/api/knowledgebase/search?keyword=' + keyword).then(function (data) {
                    data.searchValue = keyword;
                    _this.searchResults = data;
                    return data;
                });
            };
            knowledgebaseService.prototype.getTopSubjectsQuestions = function () {
                return this.dataservice.getData('/api/knowledgebase/topSubjects');
            };
            knowledgebaseService.prototype.getAllSubjectsAndQuestions = function (page, pageSize) {
                return this.dataservice.getData('/api/knowledgebase/all?page=' + page + '&pagesize=' + pageSize);
            };
            knowledgebaseService.prototype.getCustomerQuestion = function (questionId, companyName, rentalUnitId, searchID) {
                var url = '/api/knowledgebase/customerQuestion/' + questionId + '/' + companyName + '?rentalUnitId=' + rentalUnitId + '&searchID=' + (searchID ? encodeURIComponent(searchID) : '');
                return this.dataservice.getData(url);
            };
            knowledgebaseService.prototype.postCustomerQuestionAnswer = function (questionId, companyName, rentalUnitId, answer) {
                return this.dataservice.postData('/api/knowledgebase/customerQuestion/answer/' + questionId + '/' + companyName + '?rentalUnitId=' + rentalUnitId, answer);
            };
            return knowledgebaseService;
        }());
        knowledgebase.knowledgebaseService = knowledgebaseService;
        angular
            .module('customer.core')
            .service('knowledgebaseService', knowledgebaseService);
    })(knowledgebase = customer.knowledgebase || (customer.knowledgebase = {}));
})(customer || (customer = {}));
//# sourceMappingURL=knowledgebase.service.js.map
var customer;
(function (customer) {
    var menu;
    (function (menu) {
        var controller = (function () {
            function controller($state, menuService, menuItems, currentUser, $window, $cookies) {
                var _this = this;
                this.$state = $state;
                this.menuService = menuService;
                this.menuItems = menuItems;
                this.currentUser = currentUser;
                this.$window = $window;
                this.$cookies = $cookies;
                this.$inject = ['$state', 'menuService', 'menuItems', 'currentUser', '$window', '$cookies'];
                this.logout = function () {
                    var env = _this.$cookies.get('environment');
                    _this.menuService.logout().then(function () {
                        if (env === undefined)
                            _this.$window.location.href = '/Account/Login';
                        else
                            _this.$window.location.href = '/Account/Login' + '?environment=' + env;
                    });
                };
                this.activate();
            }
            controller.prototype.activate = function () {
                this.parametersToBeInjected = {
                    userId: this.currentUser.EmpireId,
                    empireId: this.currentUser.EmpireId
                };
                this.environment = this.$cookies.get('environment');
                this.menuItems = this.menuService.filterMenuItems(this.menuItems);
            };
            controller.prototype.getStateReference = function (menuItem) {
                var _this = this;
                var state = this.$state.get(menuItem.StateReference);
                if (state) {
                    var stateParameters = this.getParameters(state.url);
                    var toInject = {};
                    angular.forEach(stateParameters, function (stateParameter) {
                        if (_this.parametersToBeInjected[stateParameter]) {
                            toInject[stateParameter] = _this.parametersToBeInjected[stateParameter];
                        }
                    });
                    if (!this.isEmpty(toInject)) {
                        return menuItem.StateReference + "(" + JSON.stringify(toInject) + ")";
                    }
                    else {
                        return menuItem.StateReference;
                    }
                }
                else {
                    return menuItem.StateReference;
                }
            };
            controller.prototype.getParameters = function (url) {
                var regex = /\{(.*?)\}/g;
                var result, allMatches = [];
                while ((result = regex.exec(url.toString())) !== null) {
                    var match = result[1];
                    allMatches.push(match);
                }
                return allMatches;
            };
            controller.prototype.isEmpty = function (obj) {
                for (var key in obj) {
                    if (obj.hasOwnProperty(key))
                        return false;
                }
                return true;
            };
            return controller;
        }());
        angular
            .module('customer.menu')
            .component('portalMenu', {
            controller: controller,
            templateUrl: '/App/menu/menu.html'
        });
    })(menu = customer.menu || (customer.menu = {}));
})(customer || (customer = {}));
//# sourceMappingURL=menu.component.js.map
var customer;
(function (customer) {
    var menu;
    (function (menu) {
        var menuService = (function () {
            function menuService(dataservice) {
                this.dataservice = dataservice;
                this.$inject = ['dataservice'];
            }
            menuService.prototype.getMenuItems = function () {
                var _this = this;
                var url = '/api/menu/menuitems';
                return this.dataservice.getData(url).then(function (data) {
                    return _this.filterMenuItems(data);
                });
            };
            menuService.prototype.logout = function () {
                var url = '/account/logoff';
                return this.dataservice.postData(url, null, null);
            };
            menuService.prototype.filterMenuItems = function (data) {
                var menuItems = [];
                for (var i = 0; i < data.length; i++) {
                    var element = data[i];
                    if (element.IsSidebarItem)
                        menuItems.push(element);
                }
                return menuItems;
            };
            return menuService;
        }());
        menu.menuService = menuService;
        angular
            .module('customer.menu')
            .service('menuService', menuService);
    })(menu = customer.menu || (customer.menu = {}));
})(customer || (customer = {}));
//# sourceMappingURL=menu.service.js.map
var customer;
(function (customer) {
    var myContracts;
    (function (myContracts) {
        var inspectionAppointment = (function () {
            function inspectionAppointment() {
            }
            inspectionAppointment.Factory = function () {
                var factoryFunction = function ($filter) {
                    return function (input, format) {
                        if (input === null) {
                            return "";
                        }
                        var result = input;
                        if (format) {
                            var parts = input.split(' ');
                            var momentValue = moment(parts[0], 'DD-MM-YYYY');
                            var date = $filter('date')(momentValue.toDate(), format);
                            result = date + ' ' + parts[1];
                        }
                        return result;
                    };
                };
                factoryFunction.$inject = ['$filter'];
                return factoryFunction;
            };
            return inspectionAppointment;
        }());
        myContracts.inspectionAppointment = inspectionAppointment;
        angular.module('customer.myContracts')
            .filter('inspectionAppointment', inspectionAppointment.Factory());
    })(myContracts = customer.myContracts || (customer.myContracts = {}));
})(customer || (customer = {}));
//# sourceMappingURL=inspectionAppointment.filter.js.map
var customer;
(function (customer) {
    var myContracts;
    (function (myContracts) {
        var controller = (function () {
            function controller(contractService, myContractsService, alerting, localize, generalSettings) {
                var _this = this;
                this.contractService = contractService;
                this.myContractsService = myContractsService;
                this.alerting = alerting;
                this.localize = localize;
                this.generalSettings = generalSettings;
                this.isEdittingContract = [];
                this.paymentCopies = [];
                this.energyLabelImages = {
                    "A": "energy_a.png",
                    "A+": "energy_a_plus.png",
                    "A++": "energy_a_2plus.png",
                    "A+++": "energy_a_3plus.png",
                    "A++++": "energy_a_4plus.png",
                    "B": "energy_b.png",
                    "C": "energy_c.png",
                    "D": "energy_d.png",
                    "E": "energy_e.png",
                    "F": "energy_f.png",
                    "G": "energy_g.png"
                };
                this.initialDebtCollectionMethodCode = [];
                this.customerDetailsCallback = function (data) {
                    if (data.success === true) {
                        _this.customerDetails = data.data;
                        angular.forEach(_this.customerDetails.ActiveContracts, function (contract) {
                            if (contract.BankAccount) {
                                _this.initialDebtCollectionMethodCode[contract.EntryNo] = contract.BankAccount.DebtCollectionMethod.Code;
                                _this.myContractsService.loadRentalUnitImage(contract.CompanyName, contract.RentalUnit.No).then(function (data) {
                                    if (data.success !== false) {
                                        contract.RentalUnitImage = data;
                                    }
                                });
                            }
                        });
                    }
                    else {
                        var message = _this.localize.getLocalizedString("Message_FailedToLoadCustomerDetails", "MyContracts");
                        var title = _this.localize.getLocalizedString("Page_Title", "MyContracts");
                        _this.alerting.popError(message, title);
                    }
                };
                this.loadDocuments = function (contract) {
                    _this.contractService.getContractDocuments(contract).then(function (data) {
                        if (data.success !== true) {
                            var message = _this.localize.getLocalizedString("Message_FailedToLoadDocuments", "MyContracts");
                            var title = _this.localize.getLocalizedString("Page_Title", "MyContracts");
                            _this.alerting.popError(message, title);
                        }
                    });
                };
                this.getEnergyLabelImage = function (energyLabel) {
                    if (typeof (energyLabel) !== "undefined") {
                        var parts = energyLabel.split(" ");
                        if (parts.length >= 1) {
                            var label = parts[0].toUpperCase();
                            var image = _this.energyLabelImages[label];
                            var icon = "/content/images/energy_labels/" + image;
                            return icon;
                        }
                    }
                };
                this.getPaymentMethodName = function (contract) {
                    var paymentMethod = "Label_PaymentMethodNotSet";
                    if (contract)
                        if (contract.BankAccount) {
                            switch (contract.BankAccount.DebtCollectionMethod.Code) {
                                case "0":
                                    paymentMethod = "Label_AcceptGiroLabel";
                                    break;
                                case "1":
                                    paymentMethod = "Label_DirectDebitLabel";
                                    break;
                                case "2":
                                    paymentMethod = "Label_PayYourself";
                                    break;
                                default:
                                    paymentMethod = "Label_PaymentMethodNotSet";
                                    break;
                            }
                        }
                    return _this.localize.getLocalizedString(paymentMethod, "MyContracts");
                };
                this.updateCurrentBankAccountInformation = function (form, contract, index) {
                    _this.isEdittingContract[index] = false;
                    _this.myContractsService.updateCurrentBankAccountInformation(contract.CompanyName, contract.RentalUnit.No, contract.BankAccount).then(function (response) {
                        if (response && response.success) {
                            _this.contractService.refreshCustomerDetails().then(_this.customerDetailsCallback);
                            form.$setPristine();
                            form.$setUntouched();
                        }
                        else {
                            var alertMessage = _this.localize.getLocalizedString("Message_UpdateBankAccoutError", "MyContracts");
                            if (response && response.data && response.data.code === "5000") {
                                alertMessage = _this.localize.getLocalizedString("Message_InvalidIBAN", "MyContracts");
                            }
                            else if (response && response.data && response.data.fullMessage) {
                                var msgJson = JSON.parse(response.data.fullMessage);
                                var msg = msgJson.message;
                                if (msg.substring(0, 30) === "Payment Details already exists" || msg.substring(0, 30) === "Er zijn al betalingsgegevens a") {
                                    alertMessage = _this.localize.getLocalizedString("Message_UpdateBankAccoutDetailsExist", "MyContracts");
                                }
                                if (msg === "You cannot change the payment details, because a replacement payee is momentarily active. Please contact the rental company."
                                    || msg === "U kunt de betalingsgegevens niet wijzigen, aangezien er momenteel een vervangende betaler actief is. Neem contact op met uw verhuurder.") {
                                    alertMessage = _this.localize.getLocalizedString("Message_ReplacementPayeeActive", "MyContracts");
                                }
                            }
                            _this.isEdittingContract[index] = true;
                            _this.alerting.popError(alertMessage);
                        }
                    });
                };
                this.startEdittingPaymentDetails = function (index) {
                    _this.isEdittingContract[index] = true;
                    _this.paymentCopies[index] = JSON.parse(JSON.stringify(_this.customerDetails.ActiveContracts[index].BankAccount));
                };
                this.cancelEdittingPaymentDetails = function (form, index) {
                    _this.isEdittingContract[index] = false;
                    angular.copy(_this.paymentCopies[index], _this.customerDetails.ActiveContracts[index].BankAccount);
                    form.$setPristine();
                    form.$setUntouched();
                };
                this.originalIsDirectDebit = function (index) {
                    var original = _this.paymentCopies[index];
                    if (original) {
                        return original.DebtCollectionMethod.Code == "1";
                    }
                };
                this.showDirectDebitMessage = function (contract) {
                    return contract !== null && contract.BankAccount !== null && _this.initialDebtCollectionMethodCode[contract.EntryNo] === "1";
                };
                this.activate();
            }
            controller.prototype.activate = function () {
                this.contractService.getCustomerDetails().then(this.customerDetailsCallback);
            };
            controller.prototype.getTotalRentprice = function (contract) {
                var total = 0;
                angular.forEach(contract.RentedItems, function (renteditem) {
                    total += renteditem.Amount;
                });
                return total;
            };
            controller.prototype.isDirectDebit = function (contract) {
                return contract !== null && contract.BankAccount !== null && contract.BankAccount.DebtCollectionMethod.Code == "1";
            };
            controller.prototype.isBankTransfer = function (contract) {
                return contract !== null && contract.BankAccount !== null && contract.BankAccount.DebtCollectionMethod.Code == "0";
            };
            controller.prototype.isPayYourself = function (contract) {
                return contract !== null && contract.BankAccount !== null && contract.BankAccount.DebtCollectionMethod.Code == "2";
            };
            controller.prototype.isPaymentMethodNotSet = function (contract) {
                return contract !== null && contract.BankAccount === null;
            };
            controller.prototype.setPaymentToDirectDebit = function (contract) {
                if (contract.BankAccount === null) {
                    contract.BankAccount = new core.models.BankAccount();
                }
                contract.BankAccount.DebtCollectionMethod.Code = "1";
                contract.BankAccount.PaymentMethodNew = true;
            };
            controller.prototype.setPaymentToBankTransfer = function (contract) {
                if (contract.BankAccount === null) {
                    contract.BankAccount = new core.models.BankAccount();
                }
                contract.BankAccount.DebtCollectionMethod.Code = "0";
                contract.BankAccount.PaymentMethodNew = true;
            };
            controller.prototype.getRentCompositionUrl = function (contract) {
                return "/api/document/rentprice/" + contract.CompanyName + "?realtyObjectNo=" + contract.RentalUnit.No + "&entryNo=" + contract.EntryNo;
            };
            controller.prototype.getPropertyValuationUrl = function (contract) {
                return "/api/document/propertyvaluation/" + contract.CompanyName + "?realtyObjectNo=" + contract.RentalUnit.No;
            };
            controller.prototype.getDownloadDocumentUrl = function (contract, document) {
                return '/api/contractdocument/' + contract.CompanyName + "/" + document.Id + "?realtyObjectNo=" + contract.RentalUnit.No;
            };
            return controller;
        }());
        angular
            .module("customer.myContracts")
            .component("myContracts", {
            controller: controller,
            templateUrl: '/App/myContracts/myContracts.html'
        });
    })(myContracts = customer.myContracts || (customer.myContracts = {}));
})(customer || (customer = {}));
//# sourceMappingURL=myContracts.component.js.map
var customer;
(function (customer) {
    var myContracts;
    (function (myContracts) {
        angular
            .module('customer.myContracts')
            .config(configRoutes);
        function configRoutes($stateProvider, $urlRouterProvider, $locationProvider) {
            $locationProvider.html5Mode(true);
            var myContractsState = {
                name: 'myContracts',
                url: '/myContracts',
                template: '<my-contracts></my-contracts>',
                portalModule: 'ContractData'
            };
            $stateProvider
                .state('myContracts', myContractsState);
        }
    })(myContracts = customer.myContracts || (customer.myContracts = {}));
})(customer || (customer = {}));
//# sourceMappingURL=myContracts.route.js.map
var customer;
(function (customer) {
    var myContracts;
    (function (myContracts) {
        var myContractsService = (function () {
            function myContractsService(dataservice) {
                this.dataservice = dataservice;
                this.$inject = ['dataservice'];
            }
            myContractsService.prototype.updateCurrentBankAccountInformation = function (companyName, realtyObjectNo, bankAccount) {
                var url = '/api/contract/updatecurrentbankaccountinformation/' + companyName + '?realtyObjectNo=' + realtyObjectNo;
                return this.dataservice.putData(url, bankAccount);
            };
            myContractsService.prototype.loadRentalUnitImage = function (companyName, rentalUnitNo) {
                var url = '/api/realtyobject/picture/' + companyName + '?realtyObjectNo=' + rentalUnitNo;
                return this.dataservice.getData(url);
            };
            return myContractsService;
        }());
        myContracts.myContractsService = myContractsService;
        angular
            .module('customer.myContracts')
            .service('myContractsService', myContractsService);
    })(myContracts = customer.myContracts || (customer.myContracts = {}));
})(customer || (customer = {}));
//# sourceMappingURL=myContracts.service.js.map
var customer;
(function (customer) {
    var myDetails;
    (function (myDetails) {
        var controller = (function () {
            function controller(contractService, myDetailsService, userService, localize, alerting, focus, emailChangeDialog) {
                var _this = this;
                this.contractService = contractService;
                this.myDetailsService = myDetailsService;
                this.userService = userService;
                this.localize = localize;
                this.alerting = alerting;
                this.focus = focus;
                this.emailChangeDialog = emailChangeDialog;
                this.customerCurrentEmail = "";
                this.user = null;
                this.isNL = false;
                this.correspondenceType = ['Geen voorkeur', 'Afdruk', 'E-mail'];
                this.preferredCommunicationChannel = "";
                this.canEditPreferredCommunicationChannel = false;
                this.isEdittingMyAddress = false;
                this.isEdittingMyDetails = false;
                this.isEdittingMyEmailAddress = false;
                this.isEditingTwoFactorAuthentication = false;
                this.isEditingCorrespondenceType = false;
                this.$inject = ['contractService', 'myDetailsService', 'userService', 'localize', 'alerting', 'focus', 'emailChangeDialog'];
                this.countryCallback = function (data) {
                    _this.countries = data.data;
                };
                this.twoFactorAuthSettingsCallBack = function (data) {
                    _this.twoFactorAuth = data.data;
                };
                this.getDefaultCountryCode = function () {
                    if (typeof _this._defaultCountryCode === 'undefined') {
                        _this._defaultCountryCode = _this.getResource('DefaultCountryCode');
                    }
                    return _this._defaultCountryCode;
                };
                this.getResource = function (key) {
                    return _this.localize.getLocalizedString(key, "MyDetails");
                };
                this.determineForeignCountry = function () {
                    _this.isNL = _this.customerDetails.CountryCode === _this.getDefaultCountryCode() || _this.customerDetails.CountryCode === '' || _this.customerDetails.CountryCode === undefined;
                };
                this.determinePreferredCommunicationChanel = function () {
                    switch (_this.customerDetails.CorrespondenceType) {
                        case 0:
                            _this.preferredCommunicationChannel = _this.correspondenceType[0];
                            break;
                        case 1:
                            _this.preferredCommunicationChannel = _this.correspondenceType[1];
                            break;
                        case 2:
                            _this.preferredCommunicationChannel = _this.correspondenceType[2];
                            break;
                        default:
                            _this.preferredCommunicationChannel = _this.correspondenceType[0];
                            break;
                    }
                };
                this.getCustomerPortalModuleSettingsCallBack = function (data) {
                    if (data.success === true && _this.customerDetails) {
                        _this.canEditPreferredCommunicationChannel = data.data.CustomerPortalModules.ChangeCorrespondenceType;
                        if (_this.canEditPreferredCommunicationChannel && _this.canEditPreferredCommunicationChannel === true) {
                            _this.determinePreferredCommunicationChanel();
                        }
                    }
                    else {
                        var message = _this.getResource('Message_FailedToLoadCustomerDetails');
                        var title = _this.title;
                        _this.alerting.popError(message, title);
                    }
                };
                this.customerDetailsCallback = function (data) {
                    if (data.success === true) {
                        _this.customerDetails = data.data;
                        _this.customerCurrentEmail = _this.customerDetails.Email;
                        _this.determineForeignCountry();
                    }
                    else {
                        var message = _this.getResource('Message_FailedToLoadCustomerDetails');
                        var title = _this.title;
                        _this.alerting.popError(message, title);
                    }
                };
                this.updateStreetAndCity = function (myAddressForm) {
                    if (_this.isNL) {
                        if (_this.customerDetails.Postcode && _this.customerDetails.HouseNo) {
                            _this.addressForm = myAddressForm;
                            _this.myDetailsService.getStreetAndCityFromPostcode(_this.customerDetails.CountryCode, _this.customerDetails.Postcode, _this.customerDetails.HouseNo).then(_this.updateStreetAndCityCallback);
                        }
                        else {
                            _this.customerDetails.Street = '';
                            _this.customerDetails.City = '';
                        }
                    }
                };
                this.updateStreetAndCityCallback = function (data) {
                    if (data && data.success) {
                        _this.customerDetails.Street = data.data.Street;
                        _this.customerDetails.City = data.data.City;
                        _this.addressForm.postcode.$setValidity('validaddress', true);
                        _this.addressForm.HouseNumber.$setValidity('validaddress', true);
                    }
                    else {
                        _this.customerDetails.Street = '';
                        _this.customerDetails.City = '';
                        _this.addressForm.postcode.$setValidity('validaddress', false);
                        _this.addressForm.HouseNumber.$setValidity('validaddress', false);
                    }
                };
                this.customerAddressLine1 = function () {
                    if (_this.customerDetails) {
                        return _this.customerDetails.Address;
                    }
                };
                this.customerAddressLine2 = function () {
                    var line2 = '';
                    if (_this.customerDetails) {
                        if (_this.customerDetails.Postcode) {
                            line2 += _this.customerDetails.Postcode;
                        }
                        if (_this.customerDetails.City) {
                            if (line2 !== '') {
                                line2 += ' ';
                            }
                            line2 += _this.customerDetails.City;
                        }
                    }
                    return line2.toUpperCase();
                };
                this.startEdittingContactDetails = function () {
                    _this.isEdittingMyDetails = true;
                    _this.customerDetailsCopy = angular.copy(_this.customerDetails);
                    _this.focus("focusContactDetails");
                };
                this.cancelEdittingContactDetails = function (myDetailsForm) {
                    _this.isEdittingMyDetails = false;
                    _this.customerDetails = _this.customerDetailsCopy;
                    myDetailsForm.$setPristine();
                    myDetailsForm.$setUntouched();
                };
                this.saveContactDetails = function (myDetailsForm) {
                    if (myDetailsForm.$invalid) {
                        return;
                    }
                    _this.updateCustomerDetails(myDetailsForm);
                };
                this.startEdittingEmailAddress = function () {
                    _this.isEdittingMyEmailAddress = true;
                    _this.customerDetailsCopy = angular.copy(_this.customerDetails);
                    _this.focus("focusContactDetails");
                };
                this.cancelEdittingEmailAddress = function (myEmailAddressForm) {
                    _this.isEdittingMyEmailAddress = false;
                    _this.customerDetails = _this.customerDetailsCopy;
                    myEmailAddressForm.$setPristine();
                    myEmailAddressForm.$setUntouched();
                };
                this.saveEmailAddress = function (myEmailAddressForm) {
                    if (myEmailAddressForm.$invalid) {
                        return;
                    }
                    if (_this.customerDetails.Email !== _this.customerCurrentEmail) {
                        _this.emailChangeDialog
                            .checkPassword()
                            .then(function () {
                            _this.updateCustomerEmail(myEmailAddressForm);
                        })
                            .catch(angular.noop);
                    }
                };
                this.startEditingTwoFactorAuthSettings = function () {
                    _this.isEditingTwoFactorAuthentication = true;
                    _this.twoFactorAuthCopy = angular.copy(_this.twoFactorAuth);
                    _this.focus("focusTwoFactorAuth");
                };
                this.saveTwoFactorAuthSettings = function (twoFactorAuthenticationForm) {
                    if (twoFactorAuthenticationForm.$invalid) {
                        return;
                    }
                    _this.userService.setTwoFactorAuth(_this.twoFactorAuth.Enabled).then(_this.setTwoFactorAuthCallback);
                    return;
                };
                this.setTwoFactorAuthCallback = function (data) {
                    _this.isEditingTwoFactorAuthentication = false;
                };
                this.cancelEditingTwoFactorAuthSettings = function (twoFactorAuthenticationForm) {
                    _this.isEditingTwoFactorAuthentication = false;
                    twoFactorAuthenticationForm.$setPristine();
                    twoFactorAuthenticationForm.$setUntouched();
                };
                this.updateCustomerDetails = function (myDetailsForm) {
                    _this.isEdittingMyDetails = false;
                    var newEmail = _this.customerDetails.Email;
                    _this.customerDetails.Email = _this.customerCurrentEmail;
                    _this.myDetailsService.updateCustomerDetails({
                        No: _this.customerDetails.No,
                        CountryCode: _this.determineCountryCode(_this.customerDetails.CountryCode),
                        Postcode: _this.customerDetails.Postcode,
                        HouseNo: _this.customerDetails.HouseNo,
                        HouseNoAddition: _this.customerDetails.HouseNoAddition,
                        City: _this.customerDetails.City,
                        PhoneNo: _this.customerDetails.PhoneNo,
                        PhoneNo2: _this.customerDetails.PhoneNo2,
                        DayPhoneNo: _this.customerDetails.DayPhoneNo,
                        MobilePhoneNo: _this.customerDetails.MobilePhoneNo,
                        MobilePhoneNo2: _this.customerDetails.MobilePhoneNo2,
                        Email: newEmail,
                        PhoneChanged: _this.customerDetails.PhoneNo != _this.customerDetailsCopy.PhoneNo,
                        CorrespondenceType: _this.customerDetails.CorrespondenceType
                    }).then(function (response) {
                        myDetailsForm.$setPristine();
                        myDetailsForm.$setUntouched();
                        if (!response || !response.success) {
                            var errorMessage = _this.getResource("Message_PersonSaveFailed");
                            if (response.data && response.data.message) {
                                errorMessage += " " + response.data.message;
                            }
                            _this.alerting.popError(errorMessage, _this.title);
                        }
                        _this.contractService.refreshCustomerDetails().then(_this.customerDetailsCallback);
                    });
                };
                this.updateCustomerEmail = function (form) {
                    _this.isEdittingMyEmailAddress = false;
                    var newEmail = _this.customerDetails.Email;
                    _this.customerDetails.Email = _this.customerCurrentEmail;
                    _this.myDetailsService.updateCustomerEmail({
                        Email: newEmail
                    }).then(function (response) {
                        form.$setPristine();
                        form.$setUntouched();
                        if (!response || !response.success) {
                            var errorMessage = _this.getResource("Message_EmailChangeActivationLinkNotSent");
                            if (response.data && response.data.message) {
                                errorMessage += " " + response.data.message;
                            }
                            _this.alerting.popError(errorMessage, _this.title);
                        }
                        else {
                            var message = _this.localize.getLocalizedString("Message_EmailChangeActivationLinkSent", "MyDetails", newEmail);
                            _this.alerting.popInfo(message, _this.title);
                        }
                        _this.contractService.refreshCustomerDetails().then(_this.customerDetailsCallback);
                    });
                };
                this.startEdittingAddress = function () {
                    _this.isEdittingMyAddress = true;
                    _this.customerDetailsCopy = angular.copy(_this.customerDetails);
                    _this.focus("focusAddress");
                };
                this.cancelEdittingAddress = function (myAddressForm) {
                    _this.isEdittingMyAddress = false;
                    _this.customerDetails = _this.customerDetailsCopy;
                    myAddressForm.$setPristine();
                    myAddressForm.$setUntouched();
                };
                this.determineCountryCode = function (code) {
                    if (!code) {
                        code = _this.getDefaultCountryCode();
                    }
                    return code;
                };
                this.saveAddress = function (myAddressForm) {
                    if (myAddressForm.$invalid) {
                        return;
                    }
                    var addressLine = _this.customerDetails.Street;
                    if (_this.customerDetails.HouseNo) {
                        addressLine += ' ' + _this.customerDetails.HouseNo;
                    }
                    if (_this.customerDetails.HouseNoAddition) {
                        addressLine += ' ' + _this.customerDetails.HouseNoAddition;
                    }
                    _this.customerDetails.Address = addressLine;
                    _this.isEdittingMyAddress = false;
                    _this.myDetailsService.updateCustomerDetails({
                        No: _this.customerDetails.No,
                        CountryCode: _this.determineCountryCode(_this.customerDetails.CountryCode),
                        Postcode: _this.customerDetails.Postcode,
                        Street: _this.customerDetails.Street,
                        HouseNo: _this.customerDetails.HouseNo,
                        HouseNoAddition: _this.customerDetails.HouseNoAddition,
                        City: _this.customerDetails.City,
                        PhoneNo: _this.customerDetails.PhoneNo,
                        PhoneNo2: _this.customerDetails.PhoneNo2,
                        DayPhoneNo: _this.customerDetails.DayPhoneNo,
                        MobilePhoneNo: _this.customerDetails.MobilePhoneNo,
                        MobilePhoneNo2: _this.customerDetails.MobilePhoneNo2,
                        Email: _this.customerDetails.Email,
                        AddressChanged: _this.addressChanged()
                    }).then(function (response) {
                        if (!response || !response.success) {
                            _this.isEdittingMyAddress = true;
                            var errorMessage = _this.getResource("Message_PersonSaveFailed");
                            if (response.message && response.message.message) {
                                errorMessage += " " + response.message.message;
                            }
                            _this.alerting.popError(errorMessage, _this.title);
                        }
                        else {
                            _this.isEdittingMyAddress = false;
                            myAddressForm.$setPristine();
                            myAddressForm.$setUntouched();
                        }
                    });
                };
                this.addressChanged = function () {
                    return (_this.customerDetails.CountryCode != _this.customerDetailsCopy.CountryCode)
                        || (_this.customerDetails.Postcode != _this.customerDetailsCopy.Postcode)
                        || (_this.customerDetails.HouseNo != _this.customerDetailsCopy.HouseNo)
                        || (_this.customerDetails.HouseNoAddition != _this.customerDetailsCopy.HouseNoAddition)
                        || (_this.customerDetails.Street != _this.customerDetailsCopy.Street)
                        || (_this.customerDetails.City != _this.customerDetailsCopy.City);
                };
                this.startEdittingPrefferedCommunicationChanel = function () {
                    _this.isEditingCorrespondenceType = true;
                    _this.customerDetailsCopy = angular.copy(_this.customerDetails);
                    _this.focus("focusAddress");
                };
                this.cancelEdittingPrefferedCommunicationChanel = function (prefferedChannelForm) {
                    _this.isEditingCorrespondenceType = false;
                    _this.customerDetails = _this.customerDetailsCopy;
                    prefferedChannelForm.$setPristine();
                    prefferedChannelForm.$setUntouched();
                };
                this.updatePrefferedCommunicationChanel = function (prefferedChannelForm) {
                    switch (_this.preferredCommunicationChannel) {
                        case _this.correspondenceType[0]:
                            _this.customerDetails.CorrespondenceType = 0;
                            break;
                        case _this.correspondenceType[1]:
                            _this.customerDetails.CorrespondenceType = 1;
                            break;
                        case _this.correspondenceType[2]:
                            _this.customerDetails.CorrespondenceType = 2;
                            break;
                        default:
                            _this.customerDetails.CorrespondenceType = 0;
                            break;
                    }
                };
                this.savePrefferedCommunicationChanel = function (prefferedChannelForm) {
                    if (prefferedChannelForm.$invalid) {
                        return;
                    }
                    _this.updateCustomerDetails(prefferedChannelForm);
                    _this.isEditingCorrespondenceType = false;
                };
                this.activate();
            }
            controller.prototype.activate = function () {
                var _this = this;
                this.title = this.getResource('Title_My_Contact_Details');
                this.contractService.getCustomerDetails().then(this.customerDetailsCallback);
                this.myDetailsService.getCountries().then(this.countryCallback);
                this.myDetailsService.getCustomerPortalModuleSettings().then(this.getCustomerPortalModuleSettingsCallBack);
                this.userService.getCurrentUser().then(function (userModel) {
                    _this.user = userModel;
                });
                this.userService.getTwoFactorAuthSettings().then(this.twoFactorAuthSettingsCallBack);
            };
            return controller;
        }());
        angular
            .module('customer.myDetails')
            .component('myDetails', {
            controller: controller,
            templateUrl: '/App/myDetails/myDetails.html'
        });
    })(myDetails = customer.myDetails || (customer.myDetails = {}));
})(customer || (customer = {}));
//# sourceMappingURL=myDetails.component.js.map
var customer;
(function (customer) {
    var myDetails;
    (function (myDetails) {
        angular
            .module('customer.myDetails')
            .config(configRoutes);
        function configRoutes($stateProvider, $urlRouterProvider, $locationProvider) {
            $locationProvider.html5Mode(true);
            var myDetailsRoute = {
                name: 'myDetails',
                url: '/myDetails',
                template: '<my-details></my-details>',
                portalModule: 'HouseholdData'
            };
            $stateProvider
                .state('myDetails', myDetailsRoute);
        }
    })(myDetails = customer.myDetails || (customer.myDetails = {}));
})(customer || (customer = {}));
//# sourceMappingURL=myDetails.route.js.map
var customer;
(function (customer) {
    var myDetails;
    (function (myDetails) {
        var myDetailsService = (function () {
            function myDetailsService(dataservice, $http) {
                this.dataservice = dataservice;
                this.$http = $http;
            }
            myDetailsService.prototype.getCountries = function () {
                var url = '/api/settings/countries';
                return this.dataservice.getData(url, true);
            };
            myDetailsService.prototype.getStreetAndCityFromPostcode = function (country, postcode, houseNo) {
                if (!country) {
                    country = 'NL';
                }
                var url = '/api/settings/address/' + encodeURIComponent(country) + '/' + encodeURIComponent(postcode) + '/' + encodeURIComponent(houseNo);
                return this.$http.get(url)
                    .then(function (response) {
                    if (response.data.success === false) {
                        return response;
                    }
                    return response.data;
                })
                    .catch(function (response) {
                    var error = {
                        success: false,
                        message: response.data.data.message,
                        code: response.data.data.code,
                        fullMessage: response.data.data.fullMessage
                    };
                    return error;
                });
            };
            myDetailsService.prototype.getMaritalStatuses = function () {
                var url = '/api/settings/maritalstatuses';
                return this.dataservice.getData(url, true);
            };
            myDetailsService.prototype.getRoles = function () {
                var url = '/api/settings/roles';
                return this.dataservice.getData(url, true);
            };
            myDetailsService.prototype.updateCustomerDetails = function (customerDetails) {
                var url = '/api/customerDetails';
                return this.dataservice.putData(url, customerDetails);
            };
            myDetailsService.prototype.updateCustomerEmail = function (customerEmail) {
                var url = '/api/customerEmail';
                return this.dataservice.putData(url, customerEmail);
            };
            myDetailsService.prototype.getCustomerPortalModuleSettings = function () {
                var url = '/api/settings';
                return this.dataservice.getData(url, true);
            };
            myDetailsService.prototype.updateContactDetails = function (customerDetails, email, phoneNo) {
                var newCustomerDetails = {
                    No: customerDetails.No,
                    CountryCode: customerDetails.CountryCode,
                    Postcode: customerDetails.Postcode,
                    HouseNo: customerDetails.HouseNo,
                    HouseNoAddition: customerDetails.HouseNoAddition,
                    City: customerDetails.City,
                    PhoneNo: phoneNo,
                    PhoneNo2: customerDetails.PhoneNo2,
                    DayPhoneNo: customerDetails.DayPhoneNo,
                    MobilePhoneNo: customerDetails.MobilePhoneNo,
                    MobilePhoneNo2: customerDetails.MobilePhoneNo2,
                    Email: email,
                    PhoneChanged: phoneNo !== customerDetails.PhoneNo
                };
                return this.updateCustomerDetails(newCustomerDetails);
            };
            return myDetailsService;
        }());
        myDetails.myDetailsService = myDetailsService;
        angular
            .module('customer.myDetails')
            .service('myDetailsService', myDetailsService);
    })(myDetails = customer.myDetails || (customer.myDetails = {}));
})(customer || (customer = {}));
//# sourceMappingURL=myDetails.service.js.map
var customer;
(function (customer) {
    var myDocuments;
    (function (myDocuments) {
        var controller = (function () {
            function controller(myDocumentsService, alerting, localize, FileSaver) {
                this.myDocumentsService = myDocumentsService;
                this.alerting = alerting;
                this.localize = localize;
                this.FileSaver = FileSaver;
                this.documents = [];
                this.hasDocuments = false;
                this.$inject = ['myDocumentsService', 'alerting', 'localize', 'FileSaver'];
                this.activate();
            }
            controller.prototype.activate = function () {
                this.noReferenceText = this.getResource("Text_None");
                this.paging = {
                    currentPage: 1,
                    totalItems: 0,
                    maxSize: core.constants.paging.maxPages,
                    count: core.constants.paging.itemsPerPage,
                    firstText: this.getResource('Paging_FirstText'),
                    lastText: this.getResource('Paging_LastText'),
                    nextText: this.getResource('Paging_NextText'),
                    previousText: this.getResource('Paging_PreviousText')
                };
                this.search();
            };
            controller.prototype.search = function () {
                var _this = this;
                this.myDocumentsService.getDocuments(this.paging.currentPage, core.constants.paging.itemsPerPage).then(function (data) {
                    _this.paging.totalItems = data.results;
                    _this.documents = data.rows;
                    _this.hasDocuments = (data && data.rows && (data.rows.length > 0)) ? true : false;
                    if (_this.hasDocuments) {
                        for (var i = 0; i < _this.documents.length; i++) {
                            var documentDate = new Date(_this.documents[i].Date);
                            _this.documents[i].sortDate = new Date(documentDate.getFullYear(), documentDate.getMonth(), documentDate.getDate());
                        }
                    }
                });
            };
            controller.prototype.expandDetails = function (index) {
                var elem = $('#document_details_' + index + '.in');
                if (elem.length === 0) {
                    setTimeout(function () { $('tr[data-target="#document_details_' + index + '"]').trigger('click'); }, 100);
                }
            };
            controller.prototype.getDownloadDocumentUrl = function (document) {
                return '/api/document/' + document.Id;
            };
            controller.prototype.getDownloadDocumentAttachmentUrl = function (document, attachment) {
                return '/api/documentattachment/' + document.Id + '/' + attachment.Id;
            };
            controller.prototype.loadAttachments = function (document) {
                if (!document.attachments) {
                    this.myDocumentsService.getDocumentAttachments(document.Id).then(function (data) {
                        if (data && data.success === true)
                            document.attachments = data.data;
                    });
                }
            };
            controller.prototype.getResource = function (key, values) {
                return this.localize.getLocalizedString(key, "MyDocuments", values);
            };
            return controller;
        }());
        angular
            .module('customer.myDocuments')
            .component('myDocuments', {
            controller: controller,
            templateUrl: '/App/myDocuments/myDocuments.html'
        });
    })(myDocuments = customer.myDocuments || (customer.myDocuments = {}));
})(customer || (customer = {}));
//# sourceMappingURL=myDocuments.component.js.map
var customer;
(function (customer) {
    var myDocuments;
    (function (myDocuments) {
        angular
            .module('customer.myDocuments')
            .config(configRoutes);
        function configRoutes($stateProvider, $urlRouterProvider, $locationProvider) {
            var myDocumentsState = {
                name: 'myDocuments',
                url: '/myDocuments',
                template: '<my-documents></my-documents>',
                portalModule: 'InspectDMSfile'
            };
            $locationProvider.html5Mode(true);
            $stateProvider
                .state('myDocuments', myDocumentsState);
        }
    })(myDocuments = customer.myDocuments || (customer.myDocuments = {}));
})(customer || (customer = {}));
//# sourceMappingURL=myDocuments.route.js.map
var customer;
(function (customer) {
    var myDocuments;
    (function (myDocuments) {
        var myDocumentsService = (function () {
            function myDocumentsService(dataservice) {
                this.dataservice = dataservice;
                this.$inject = ['dataservice'];
            }
            myDocumentsService.prototype.getDocuments = function (page, count) {
                var url = '/api/documents?page=' + page + "&count=" + count;
                return this.dataservice.getData(url);
            };
            myDocumentsService.prototype.getDocumentAttachments = function (documentId) {
                var url = '/api/document/attachments/' + documentId;
                return this.dataservice.getData(url);
            };
            return myDocumentsService;
        }());
        myDocuments.myDocumentsService = myDocumentsService;
        angular
            .module('customer.myDocuments')
            .service('myDocumentsService', myDocumentsService);
    })(myDocuments = customer.myDocuments || (customer.myDocuments = {}));
})(customer || (customer = {}));
//# sourceMappingURL=myDocuments.service.js.map
var customer;
(function (customer) {
    var myHousehold;
    (function (myHousehold) {
        var controller = (function () {
            function controller(contractService, myHouseholdService, localize, alerting, focus) {
                var _this = this;
                this.contractService = contractService;
                this.myHouseholdService = myHouseholdService;
                this.localize = localize;
                this.alerting = alerting;
                this.focus = focus;
                this.preferredDatePickerConfig = {
                    format: 'DD-MM-YYYY',
                    locale: 'nl',
                    viewDate: moment("01-01-1975", "DD-MM-YYYY"),
                    maxDate: new Date(),
                    minDate: moment('01-01-1890', 'DD-MM-YYYY')
                };
                this.isAddingPerson = false;
                this.personsInEdit = {};
                this.addingPersons = {};
                this.originalPersons = {};
                this.availableRoles = [];
                this.rolesToShow = [];
                this.formattedDate = function (date) {
                    if (date) {
                        var m = moment(date);
                        if (m.isValid()) {
                            var minDate = moment("01-01-1753", "DD-MM-YYYY");
                            if (m.diff(minDate, "days") > 0) {
                                return m.format("D MMMM YYYY");
                            }
                        }
                    }
                    return _this.getResource(core.constants.labels.unknownValue);
                };
                this.isReadOnly = function (no) {
                    return (no !== null && typeof no !== "undefined" && no !== "" && (typeof _this.personsInEdit[no] === "undefined"));
                };
                this.findRelatedContactIndex = function (no) {
                    if (typeof _this.customerDetails.RelatedContacts === "undefined") {
                        _this.customerDetails.RelatedContacts = [];
                    }
                    var length = _this.customerDetails.RelatedContacts.length, i = 0;
                    for (i = 0; i < length; i++) {
                        if (_this.customerDetails.RelatedContacts[i].No === no) {
                            return i;
                        }
                    }
                    return -1;
                };
                this.getRelatedContact = function (no) {
                    var index = _this.findRelatedContactIndex(no);
                    if (index === -1) {
                        return null;
                    }
                    else {
                        return _this.customerDetails.RelatedContacts[index];
                    }
                };
                this.updateRelatedContact = function (person) {
                    var index = _this.findRelatedContactIndex(person.No);
                    if (index !== -1) {
                        _this.customerDetails.RelatedContacts[index] = person;
                    }
                };
                this.startEditing = function (no) {
                    var person = _this.getRelatedContact(no);
                    person.Role.Previous = person.Role.Current;
                    _this.personsInEdit[no] = true;
                    _this.originalPersons[no] = JSON.parse(JSON.stringify(person));
                    _this.focus("focusEditPerson");
                };
                this.cancelEditing = function (no, editPersonForm) {
                    delete _this.personsInEdit[no];
                    _this.updateRelatedContact(_this.originalPersons[no]);
                    delete _this.originalPersons[no];
                    editPersonForm.$setPristine();
                    editPersonForm.$setUntouched();
                };
                this.canAddPerson = function () {
                    if (_this.isAddingPerson) {
                        return false;
                    }
                    return _this.rolesToShow.length > 0;
                };
                this.addPerson = function (newPersonForm) {
                    _this.addingPersons[0] = new customer.myHousehold.models.Person();
                    _this.addingPersons[0].Gender = "1";
                    _this.isAddingPerson = true;
                    _this.focus("focusAddPerson");
                };
                this.cancelAddPerson = function (newPersonForm) {
                    newPersonForm.$setPristine();
                    newPersonForm.$setUntouched();
                    _this.isAddingPerson = false;
                };
                this.deletePerson = function (person, editPersonForm) {
                    var deleteTitle = _this.getResource("Dialog_DeletePersonTitle");
                    _this.alerting.confirm(_this.getResource("Message_ConfirmPersonDelete", person.DisplayName), deleteTitle).then(function (result) {
                        if (result) {
                            person.processing = true;
                            return _this.myHouseholdService.deletePerson(person).then(function (response) {
                                person.processing = false;
                                if (response && response.success && response.data) {
                                    _this.loadCustomerDetails();
                                    _this.alerting.popInfo(_this.getResource("Message_PersonDeleted"), deleteTitle).then(function () {
                                        delete _this.personsInEdit[person.No];
                                        delete _this.originalPersons[person.No];
                                        _this.deleteRelatedContact(person.No);
                                        editPersonForm.$setPristine();
                                        editPersonForm.$setUntouched();
                                    });
                                }
                                else {
                                    _this.alerting.popError(_this.getResource("Message_PersonDeleteError"), deleteTitle);
                                }
                            });
                        }
                    });
                };
                this.updatePerson = function (person, editPersonForm) {
                    if (editPersonForm.$invalid) {
                        return;
                    }
                    person.processing = true;
                    var personToUpdate = {
                        No: person.No,
                        Initials: person.Initials.toUpperCase(),
                        MiddleName: person.MiddleName,
                        Surname: person.Surname,
                        Gender: person.Gender,
                        BirthDate: moment(person.BirthDate, "DD-MM-YYYY").format("YYYY-MM-DD"),
                        Email: null,
                        processing: null,
                        Role: {
                            HouseholdNo: _this.customerDetails.No,
                            Current: person.Role.Current,
                            Previous: person.Role.Previous,
                            CurrentDescription: person.Role.CurrentDescription
                        }
                    };
                    _this.myHouseholdService.updatePerson(personToUpdate).then(function (response) {
                        person.processing = false;
                        if (response && response.success && response.data) {
                            _this.loadCustomerDetails();
                            editPersonForm.$setPristine();
                            editPersonForm.$setUntouched();
                            delete _this.personsInEdit[person.No];
                            delete _this.originalPersons[person.No];
                        }
                        else {
                            var errorMessage = _this.getResource("Message_PersonSaveFailed");
                            _this.alerting.popError(errorMessage, _this.title);
                        }
                    });
                };
                this.saveNewPerson = function (newPersonForm) {
                    var p = _this.addingPersons[0];
                    if (newPersonForm.$invalid) {
                        return;
                    }
                    p.processing = true;
                    var personToAdd = {
                        No: null,
                        Initials: p.Initials.toUpperCase(),
                        MiddleName: p.MiddleName,
                        Surname: p.Surname,
                        Gender: p.Gender,
                        BirthDate: moment(p.BirthDate, "DD-MM-YYYY").format("YYYY-MM-DD"),
                        Email: null,
                        processing: null,
                        Role: {
                            HouseholdNo: _this.customerDetails.No,
                            Current: p.Role.Current,
                            Previous: p.Role.Previous,
                            CurrentDescription: p.Role.CurrentDescription
                        }
                    };
                    _this.myHouseholdService.createPerson(personToAdd).then(function (response) {
                        p.processing = false;
                        if (!response || !response.success) {
                            _this.isAddingPerson = true;
                            var errorMessage = _this.getResource("Message_PersonUpdateFailed");
                            _this.alerting.popError(errorMessage, _this.title);
                        }
                        else {
                            _this.isAddingPerson = false;
                            _this.loadCustomerDetails();
                            newPersonForm.$setPristine();
                            newPersonForm.$setUntouched();
                        }
                    });
                };
                this.activate();
            }
            controller.prototype.activate = function () {
                this.title = this.getResource('Title');
                this.getCustomerDetails();
                this.getRoles();
            };
            controller.prototype.getCustomerDetails = function () {
                var _this = this;
                this.contractService.getCustomerDetails().then(function (response) {
                    if (response.success === true) {
                        _this.customerDetails = response.data;
                    }
                    else {
                        var message = _this.getResource('Message_FailedToLoadCustomerDetails');
                        var title = _this.title;
                        _this.alerting.popError(message, title);
                    }
                });
            };
            controller.prototype.getRoles = function () {
                var _this = this;
                this.myHouseholdService.getRoles().then(function (response) {
                    if (response.success === true) {
                        _this.availableRoles = response.data;
                        _this.rolesToShow = _this.filterRolesToShow(response.data);
                    }
                    else {
                        var message = _this.getResource('Message_FailedToLoadRoles');
                        var title = _this.title;
                        _this.alerting.popError(message, title);
                    }
                });
            };
            controller.prototype.loadCustomerDetails = function () {
                var _this = this;
                this.contractService.refreshCustomerDetails().then(function (response) {
                    if (response.success === true) {
                        _this.customerDetails = response.data;
                    }
                    else {
                        var message = _this.getResource('Message_FailedToLoadCustomerDetails');
                        var title = _this.title;
                        _this.alerting.popError(message, title);
                    }
                });
            };
            controller.prototype.getResource = function (key, values) {
                return this.localize.getLocalizedString(key, "MyHousehold", values);
            };
            controller.prototype.filterRolesToShow = function (roles) {
                var length = roles.length, result = [], i;
                for (i = 0; i < length; i++) {
                    if (roles[i].UseInPortal) {
                        result.push(roles[i]);
                    }
                }
                return result;
            };
            controller.prototype.deleteRelatedContact = function (no) {
                var index = this.findRelatedContactIndex(no);
                if (index !== -1) {
                    this.customerDetails.RelatedContacts.slice(index, 1);
                }
            };
            controller.prototype.canEdit = function (person) {
                if (person.Role && person.Role.Current) {
                    var result = this.getRoleByCode(this.rolesToShow, person.Role.Current);
                    return result !== null;
                }
                return false;
            };
            controller.prototype.getRoleByCode = function (roles, code) {
                var i = 0, length = roles.length;
                for (i = 0; i < length; i++) {
                    if (roles[i].Code === code) {
                        return roles[i];
                    }
                }
                return null;
            };
            controller.prototype.roleForCode = function (code) {
                var result = this.getRoleByCode(this.availableRoles, code);
                if (result !== null) {
                    return result.Description;
                }
                else {
                    return this.getResource("Value_Unkown");
                }
            };
            controller.prototype.createDisplayName = function (person) {
                var name = person.Initials.toUpperCase();
                if (typeof person.MiddleName !== "undefined" && person.MiddleName && person.MiddleName.length > 0) {
                    name += ' ' + person.MiddleName;
                }
                name += ' ' + person.Surname;
                return name;
            };
            controller.prototype.getPersonOrderByRole = function (person) {
                return person.IsContractant ? 0 : 1;
            };
            controller.prototype.getPersonOrderByShowFirstFlag = function (person) {
                return person.ShowFirst ? 0 : 1;
            };
            controller.prototype.getGenderLabel = function (gender) {
                if (gender === core.constants.gender.male) {
                    return "Value_Gender_Male";
                }
                else if (gender === core.constants.gender.female) {
                    return "Value_Gender_Female";
                }
                return core.constants.labels.unknownValue;
            };
            return controller;
        }());
        angular
            .module('customer.myHousehold')
            .component('myHousehold', {
            controller: controller,
            templateUrl: '/App/myHousehold/myHousehold.html'
        });
    })(myHousehold = customer.myHousehold || (customer.myHousehold = {}));
})(customer || (customer = {}));
//# sourceMappingURL=myHousehold.component.js.map
var customer;
(function (customer) {
    var myHousehold;
    (function (myHousehold) {
        var myHouseholdService = (function () {
            function myHouseholdService(dataservice) {
                this.dataservice = dataservice;
                this.$inject = ['dataservice'];
            }
            myHouseholdService.prototype.updatePerson = function (person) {
                var url = '/api/person/' + encodeURIComponent(person.No);
                return this.dataservice.putData(url, person);
            };
            myHouseholdService.prototype.createPerson = function (person) {
                var url = '/api/person';
                return this.dataservice.postData(url, person);
            };
            myHouseholdService.prototype.deletePerson = function (person) {
                var url = '/api/person/' + encodeURIComponent(person.No);
                return this.dataservice.deleteData(url);
            };
            myHouseholdService.prototype.getRoles = function () {
                var url = '/api/settings/roles';
                return this.dataservice.getData(url, true);
            };
            return myHouseholdService;
        }());
        myHousehold.myHouseholdService = myHouseholdService;
        angular
            .module('customer.myHousehold')
            .service('myHouseholdService', myHouseholdService);
    })(myHousehold = customer.myHousehold || (customer.myHousehold = {}));
})(customer || (customer = {}));
//# sourceMappingURL=myHousehold.service.js.map
var customer;
(function (customer) {
    var myPayments;
    (function (myPayments) {
        var controller = (function () {
            function controller($filter, $state, $window, dueDateService, onlinePaymentService, outstandingBalanceService, paymentArrangementService, logger, localize, alerting, cpMath) {
                this.$filter = $filter;
                this.$state = $state;
                this.$window = $window;
                this.dueDateService = dueDateService;
                this.onlinePaymentService = onlinePaymentService;
                this.outstandingBalanceService = outstandingBalanceService;
                this.paymentArrangementService = paymentArrangementService;
                this.logger = logger;
                this.localize = localize;
                this.alerting = alerting;
                this.cpMath = cpMath;
                this.hasBailiffFile = null;
                this.paymentArrangements = null;
                this.paymentArrangementExists = false;
                this.initialNumberOfInvoices = 10;
                this.initialNumberOfPayments = 10;
                this.lastAmount = null;
                this.processing = false;
                this.extendedInfoItems = {};
                this.regardingColumnValues = {};
                this.numberOfInvoicesShown = this.initialNumberOfInvoices;
                this.numberOfPaymentsShown = this.initialNumberOfPayments;
                this.activate();
            }
            controller.prototype.activate = function () {
                var _this = this;
                this.outstandingBalanceService.getOutstandingBalance().then(function (data) {
                    if (data.success === false) {
                        var message = _this.getResourceString('Message_FailedToLoadInvoices', 'MyPayments');
                        var title = _this.getResourceString('MessageBox_Title', 'MyPayments');
                        _this.alerting.popError(message, title);
                        return;
                    }
                    _this.hasBailiffFile = data.data.BailiffDossier;
                    if (_this.hasBailiffFile === true) {
                        return;
                    }
                    _this.outstandingBalance = JSON.parse(JSON.stringify(data.data));
                    _this.payments = data.data;
                    _this.payments.Invoices = _this.$filter('filter')(_this.payments.Invoices, { CanPayOnline: true });
                    _this.payments.Invoices.sort(function (a, b) {
                        return Date.parse(a.DueDate) - Date.parse(b.DueDate);
                    });
                    _this.payments.Invoices.forEach(function (item) {
                        if (item.selected === true) {
                            item.selected = false;
                            _this.onCheckChange(item);
                        }
                    });
                    _this.totalAmount = 0;
                    _this.amountToBePaid = 0;
                    _this.populateExtendedInfoArray();
                });
                this.paymentArrangementService.getPaymentArrangements().then(function (response) {
                    if (response.success === true) {
                        _this.paymentArrangements = response.data;
                        if (_this.paymentArrangements) {
                            angular.forEach(_this.paymentArrangements, function (paymentArrangement) {
                                if (paymentArrangement.Status === "Created" || paymentArrangement.Status === "Activated") {
                                    this.paymentArrangementExists = true;
                                }
                            });
                        }
                    }
                });
            };
            controller.prototype.populateExtendedInfoArray = function () {
                var _this = this;
                this.extendedInfoItems = {};
                this.regardingColumnValues = {};
                angular.forEach(this.outstandingBalance.Invoices, function (value) {
                    _this.extendedInfoItems[value.EntryNo] = _this.extendedInfo(value);
                    _this.regardingColumnValues[value.EntryNo] = value.Description;
                });
            };
            controller.prototype.extendedInfo = function (item) {
                var keyValues = {};
                var dict = 'MyPayments_InvoicePanel';
                keyValues[this.getResourceString('Label_Period', dict)] = new core.models.keyValues.keyValue(item.Description);
                var contract = item.Address;
                if (!contract || contract.length === 0) {
                    contract = this.getResourceString('Label_None', dict);
                }
                keyValues[this.getResourceString('Label_Contract', dict)] = new core.models.keyValues.keyValue(contract);
                keyValues[this.getResourceString('Label_Original_Amount', dict)] = new core.models.keyValues.keyValue(this.$filter('number')(item.OriginalAmount, 2), 'currency');
                keyValues[this.getResourceString('Label_Due', dict)] = new core.models.keyValues.keyValue(this.$filter('date')(item.DueDate, 'dd-MM-yyyy') + this.dueDateService.getDueHtml(item.DueDate));
                keyValues[this.getResourceString('Label_Received_Amount', dict)] = new core.models.keyValues.keyValue(this.$filter('number')(item.PaymentReceivedAmount, 2), 'currency');
                keyValues[this.getResourceString('Label_Open_Amount', dict)] = new core.models.keyValues.keyValue(this.$filter('number')(item.OutstandingAmount, 2), 'currency');
                keyValues[this.getResourceString('Label_Payment_Underway_Amount', dict)] = new core.models.keyValues.keyValue(this.$filter('number')(item.PaymentUnderwayAmount, 2), 'currency');
                keyValues[this.getResourceString('Label_Online_Payment_Not_Payed_Amount', dict)] = new core.models.keyValues.keyValue(this.$filter('number')(item.OnlinePaymentNotPayed, 2), 'currency');
                return keyValues;
            };
            controller.prototype.getDocumentTypeLabel = function (documentType) {
                var label = 'Label_DocumentType';
                if (!(typeof documentType === "undefined" || documentType == null || documentType === '')) {
                    label = label + documentType;
                }
                return this.getResourceString(label, "MyPayments_InvoicePanel");
            };
            controller.prototype.getResourceString = function (key, dict) {
                return this.localize.getLocalizedString(key, dict);
            };
            controller.prototype.pay = function () {
                var _this = this;
                this.processing = true;
                var payments = this.payments.Invoices.filter(function (item) {
                    return (item.AmountToBePaid !== null && item.AmountToBePaid !== 0 && item.selected);
                });
                var result = [];
                var companyName;
                payments.forEach(function (p) {
                    result.push({ EntryNo: p.EntryNo.toString(), AmountToBePaid: p.AmountToBePaid });
                    companyName = p.CompanyName;
                });
                if (result.length > 0) {
                    var win = this.$window.open("/Loading", '_blank');
                    this.onlinePaymentService
                        .postPayment({ Invoices: result }, companyName)
                        .then(function (response) {
                        _this.processing = false;
                        if (response.success) {
                            _this.outstandingBalanceService.refreshOutstandingBalance().then(function () { this.$state.reload(); });
                            _this.alerting.popInfo(_this.localize.getLocalizedString('Message_PaymentRequestSuccess', 'MyPayments_OnlinePayment'));
                            win.location.href = response.data.TransactionURL;
                            win.focus();
                        }
                        else {
                            win.close();
                            _this.alerting.popError(_this.localize.getLocalizedString('Message_UnexpectedError'));
                        }
                    });
                }
            };
            controller.prototype.computeTotal = function () {
                var _this = this;
                this.totalAmount = 0;
                if (this.payments) {
                    this.payments.Invoices.forEach(function (el) {
                        if (el.selected === true) {
                            _this.totalAmount = _this.cpMath.sum(_this.totalAmount, el.OnlinePaymentMaximumAmount || 0);
                        }
                    });
                }
                return this.totalAmount;
            };
            controller.prototype.disableInvoicesFromOtherCompanies = function (companyName) {
                this.payments.Invoices.forEach(function (elem) {
                    elem.disabled = elem.CompanyName !== companyName;
                });
            };
            controller.prototype.enableInvoices = function () {
                var isLastSelected = true;
                this.payments.Invoices.forEach(function (elem) {
                    if (elem.selected) {
                        isLastSelected = false;
                    }
                });
                if (isLastSelected) {
                    this.payments.Invoices.forEach(function (elem) {
                        elem.disabled = false;
                    });
                }
            };
            controller.prototype.isValid = function (value) {
                return !isNaN(value) && value !== undefined;
            };
            controller.prototype.onCheckChange = function (item) {
                if (item.selected) {
                    item.AmountToBePaid = item.OnlinePaymentMaximumAmount;
                    var s = this.isValid(this.amountToBePaid) ? this.amountToBePaid : this.lastAmount;
                    this.amountToBePaid = this.cpMath.sum(s, item.AmountToBePaid);
                    this.disableInvoicesFromOtherCompanies(item.CompanyName);
                }
                else {
                    var s = this.isValid(this.amountToBePaid) ? this.amountToBePaid : this.lastAmount;
                    this.amountToBePaid = this.cpMath.substract(s, item.AmountToBePaid);
                    delete item.AmountToBePaid;
                    this.enableInvoices();
                }
                this.computeTotal();
                this.onAmountChanged();
            };
            controller.prototype.onAmountChanged = function () {
                if (this.isValid(this.amountToBePaid)) {
                    this.lastAmount = this.amountToBePaid;
                }
                if (this.amountToBePaid <= this.totalAmount) {
                    var sum = this.amountToBePaid;
                    var i = -1;
                    while (++i < this.payments.Invoices.length) {
                        var invoice = this.payments.Invoices[i];
                        if (invoice.selected !== true) {
                            continue;
                        }
                        if (sum >= invoice.OnlinePaymentMaximumAmount) {
                            invoice.AmountToBePaid = invoice.OnlinePaymentMaximumAmount;
                            sum = this.cpMath.substract(sum, invoice.OnlinePaymentMaximumAmount);
                        }
                        else {
                            var dif = this.cpMath.substract(invoice.OnlinePaymentMaximumAmount, sum);
                            invoice.AmountToBePaid = this.cpMath.substract(invoice.OnlinePaymentMaximumAmount, dif);
                            sum = 0;
                        }
                    }
                }
            };
            controller.prototype.isAnyInvoiceSelected = function () {
                if (!this.payments)
                    return false;
                for (var i = 0; i < this.payments.Invoices.length; i++) {
                    var item = this.payments.Invoices[i];
                    if (item.selected === true) {
                        return true;
                    }
                }
                return false;
            };
            controller.prototype.goToAgreement = function () {
                $('#collapseinvoices_id').collapse('hide');
                $('#collapseagreement_id').collapse('show');
            };
            controller.prototype.newPaymentArrangement = function () {
                if (this.paymentArrangementExists) {
                    var message = this.localize.getLocalizedString('Message_PaymentArrangementExists', 'PaymentArrangement');
                    this.alerting.popError(message);
                    return;
                }
                var eligibleInvoices = this.getInvoicesEligibleForBeingIncludedInAPaymentArragement();
                if (!eligibleInvoices || eligibleInvoices.length === 0) {
                    var message = this.localize.getLocalizedString("Message_NoInvoicesToPay", "PaymentArrangement");
                    this.alerting.popError(message);
                    return;
                }
                this.$state.go('paymentArrangementStart');
            };
            controller.prototype.getInvoicesEligibleForBeingIncludedInAPaymentArragement = function () {
                return this.payments.Invoices.filter(function (elm) {
                    return elm.CanPayOnline && elm.CanIncludeInPaymentScheme;
                });
            };
            controller.prototype.showMore = function () {
                this.numberOfInvoicesShown = this.outstandingBalance.Invoices.length;
            };
            controller.prototype.showLess = function () {
                this.numberOfInvoicesShown = this.initialNumberOfInvoices;
            };
            controller.prototype.canShowMore = function () {
                if (this.outstandingBalance) {
                    return this.numberOfInvoicesShown == this.initialNumberOfInvoices &&
                        this.outstandingBalance.Invoices.length > this.initialNumberOfInvoices;
                }
                else {
                    return false;
                }
            };
            controller.prototype.canShowLess = function () {
                return this.numberOfInvoicesShown > this.initialNumberOfInvoices;
            };
            controller.prototype.showMorePayments = function () {
                this.numberOfPaymentsShown = this.outstandingBalance.Payments.length;
            };
            controller.prototype.showLessPayments = function () {
                this.numberOfPaymentsShown = this.initialNumberOfPayments;
            };
            controller.prototype.canShowMorePayments = function () {
                if (this.outstandingBalance) {
                    return this.numberOfPaymentsShown == this.initialNumberOfPayments &&
                        this.outstandingBalance.Payments.length > this.initialNumberOfPayments;
                }
                else {
                    return false;
                }
            };
            controller.prototype.canShowLessPayments = function () {
                return this.numberOfPaymentsShown > this.initialNumberOfPayments;
            };
            controller.prototype.getDescriptionSortValue = function (invoice) {
                var value = invoice.Address;
                if (!invoice.Address || invoice.Address.length === 0) {
                    value = invoice.Description;
                }
                return value;
            };
            return controller;
        }());
        controller.$inject = ['$filter', '$state', '$window', 'dueDateService', 'onlinePaymentService', 'outstandingBalanceService', 'paymentArrangementService', 'logger', 'localize', 'alerting', 'cpMath'];
        angular
            .module('customer.myPayments')
            .component('myPayments', {
            controller: controller,
            templateUrl: '/App/myPayments/myPayments.html'
        });
    })(myPayments = customer.myPayments || (customer.myPayments = {}));
})(customer || (customer = {}));
//# sourceMappingURL=myPayments.component.js.map
var customer;
(function (customer) {
    var myPayments;
    (function (myPayments) {
        angular
            .module('customer.myPayments')
            .config(configRoutes);
        function configRoutes($stateProvider, $urlRouterProvider, $locationProvider) {
            var myPaymentsRoute = {
                url: '/myPayments',
                template: '<my-payments></my-payments>',
                portalModule: 'InspectBalance'
            };
            $locationProvider.html5Mode(true);
            $stateProvider
                .state('myPayments', myPaymentsRoute);
        }
    })(myPayments = customer.myPayments || (customer.myPayments = {}));
})(customer || (customer = {}));
//# sourceMappingURL=myPayments.route.js.map
var customer;
(function (customer) {
    var myPayments;
    (function (myPayments) {
        var onlinePaymentService = (function () {
            function onlinePaymentService(dataservice, $q) {
                this.dataservice = dataservice;
                this.$q = $q;
                this.$inject = ['dataservice', '$q'];
            }
            onlinePaymentService.prototype.postPayment = function (invoices, companyName) {
                return this.dataservice.postData('/api/invoice/postpayment/' + companyName, invoices);
            };
            return onlinePaymentService;
        }());
        myPayments.onlinePaymentService = onlinePaymentService;
        angular
            .module('customer.myPayments')
            .service('onlinePaymentService', onlinePaymentService);
    })(myPayments = customer.myPayments || (customer.myPayments = {}));
})(customer || (customer = {}));
//# sourceMappingURL=myPayments.service.js.map
var customer;
(function (customer) {
    var myRepairments;
    (function (myRepairments) {
        var controller = (function () {
            function controller(repairmentsService, alerting, localize, $scope, $stateParams, $state) {
                var _this = this;
                this.repairmentsService = repairmentsService;
                this.alerting = alerting;
                this.localize = localize;
                this.$scope = $scope;
                this.$stateParams = $stateParams;
                this.$state = $state;
                this.requestCancelReasons = [];
                this.$inject = ['repairmentsService', 'alerting', 'localize', '$scope', '$stateParams', '$state'];
                this.cancelRequest = function (form) {
                    if (form.$invalid) {
                        return;
                    }
                    _this.terminateRequest().then(function (result) {
                        if (result.success) {
                            _this.alerting.popInfo(_this.getResourceString('Message_Info_Cancel_Repairment_Success')).then(function () {
                                _this.$state.go('repairments');
                            });
                        }
                        else {
                            _this.alerting.popError(_this.getResourceString('Message_Error_Cancel_Repairment'));
                        }
                    });
                };
                this.cancel = function () {
                    _this.$state.go('repairments');
                };
                this.terminateRequest = function () {
                    return _this.repairmentsService.cancelMaintenanceRequest(_this.companyName, {
                        MaintenanceRequestNo: _this.repairmentNo,
                        ReasonDeclinedCode: _this.selectedReason.Code,
                        CancellationDescription: _this.selectedReason.Description
                    });
                };
                this.activate();
            }
            controller.prototype.activate = function () {
                var _this = this;
                this.repairRequestDescription = this.$stateParams.repairRequestDescription;
                this.companyName = this.$stateParams.companyName;
                this.repairmentNo = this.$stateParams.repairmentNo;
                this.selectedReason = { Code: '', Description: '' };
                if (this.$stateParams.shouldTransitionToState != undefined) {
                    this.$state.go(this.$stateParams.shouldTransitionToState);
                    return;
                }
                this.repairmentsService.getRequestCancelReasons(this.companyName).then(function (result) {
                    if (result.success && result.data) {
                        _this.requestCancelReasons = result.data;
                    }
                    else {
                        _this.alerting.popError(_this.getResourceString('Message_Error_Retriving_CancelReasons'));
                    }
                });
            };
            controller.prototype.getResourceString = function (key) {
                return this.localize.getLocalizedString(key, "CancelRepairment");
            };
            return controller;
        }());
        angular.module('customer.myRepairments')
            .component('cancelRepairment', {
            controller: controller,
            templateUrl: '/App/myRepairments/cancelRepairment.html'
        });
    })(myRepairments = customer.myRepairments || (customer.myRepairments = {}));
})(customer || (customer = {}));
//# sourceMappingURL=cancelRepairment.component.js.map
var customer;
(function (customer) {
    var myRepairments;
    (function (myRepairments) {
        var contactInfoDialog = (function () {
            function contactInfoDialog(localize, alerting) {
                this.localize = localize;
                this.alerting = alerting;
            }
            contactInfoDialog.prototype.emailDialog = function (contactEmail, customerDetailsEmail) {
                var _this = this;
                return function () {
                    var message = _this.localize.getLocalizedString("Message_EmailUpdate", "NewRepairments", [contactEmail, customerDetailsEmail]);
                    var title = _this.localize.getLocalizedString("Title_EmailUpdate", "NewRepairments");
                    var buttonYes = _this.localize.getLocalizedString("Button_ForThisRequest", "NewRepairments");
                    var buttonNo = _this.localize.getLocalizedString("Button_ChangeInAdministration", "NewRepairments");
                    return _this.alerting.confirm(message, title, buttonYes, buttonNo, "xlg", true);
                };
            };
            contactInfoDialog.prototype.phoneDialog = function (contactPhoneNo, customerDetailsPhoneNo) {
                var _this = this;
                return function () {
                    var message = _this.localize.getLocalizedString("Message_PhoneUpdate", "NewRepairments", [contactPhoneNo, customerDetailsPhoneNo]);
                    var title = _this.localize.getLocalizedString("Title_PhoneUpdate", "NewRepairments");
                    var buttonYes = _this.localize.getLocalizedString("Button_ForThisRequest", "NewRepairments");
                    var buttonNo = _this.localize.getLocalizedString("Button_ChangeInAdministration", "NewRepairments");
                    return _this.alerting.confirm(message, title, buttonYes, buttonNo, "xlg", true);
                };
            };
            contactInfoDialog.factory = function () {
                var dialog = function (localize, alerting) { return new contactInfoDialog(localize, alerting); };
                dialog.$inject = ['localize', 'alerting'];
                return dialog;
            };
            return contactInfoDialog;
        }());
        myRepairments.contactInfoDialog = contactInfoDialog;
        angular
            .module('customer.myRepairments')
            .factory('contactInfoDialog', contactInfoDialog.factory());
    })(myRepairments = customer.myRepairments || (customer.myRepairments = {}));
})(customer || (customer = {}));
//# sourceMappingURL=contactInfoDialog.service.js.map
var customer;
(function (customer) {
    var myRepairments;
    (function (myRepairments) {
        var controller = (function () {
            function controller(repairmentsService, alerting, localize, $scope, $stateParams, $state, $q, $timeout, $filter, contractService, myDetailsService, dialogChainer, contactInfoDialog, emailChangeDialog) {
                var _this = this;
                this.repairmentsService = repairmentsService;
                this.alerting = alerting;
                this.localize = localize;
                this.$scope = $scope;
                this.$stateParams = $stateParams;
                this.$state = $state;
                this.$q = $q;
                this.$timeout = $timeout;
                this.$filter = $filter;
                this.contractService = contractService;
                this.myDetailsService = myDetailsService;
                this.dialogChainer = dialogChainer;
                this.contactInfoDialog = contactInfoDialog;
                this.emailChangeDialog = emailChangeDialog;
                this.failedDeletedImages = [];
                this.failedAddedImages = [];
                this.updateCustomerDetailsFailed = false;
                this.minimumDate = null;
                this.oldSearchDate = null;
                this.formContainer = {};
                this.$inject = ['repairmentsService', 'alerting', 'localize', '$scope', '$stateParams', '$state', '$q', '$timeout', '$filter', 'contractService', 'myDetailsService', 'dialogChainer', 'contactInfoDialog', 'emailChangeDialog'];
                this.customerDetailsCallback = function (response) {
                    if (response.success === true) {
                        _this.customerDetails = response.data;
                    }
                    else {
                        var message = _this.localize.getLocalizedString('Message_FailedToLoadCustomerDetails', 'MyDetails');
                        _this.alerting.popError(message);
                    }
                };
                this.saveChanges = function () {
                    _this.updateMaintenanceRequest().then(function (result) {
                        if (result.success) {
                            _this.updatePlanningData().then(function (result) {
                                if (result.success) {
                                    var chain = _this.updateContactDetails();
                                    _this.deletePhotos(chain)
                                        .then(function () {
                                        if (_this.failedDeletedImages.length === 0) {
                                            _this.addPhotos()
                                                .then(function () {
                                                if (_this.failedAddedImages.length === 0) {
                                                    _this.alerting.popInfo(_this.getResourceString("Success_Save_Request_Changes"));
                                                    _this.$state.go("repairments");
                                                }
                                                else {
                                                    _this.alerting.popError(_this.getResourceString("Error_Saving_Changes"));
                                                }
                                            });
                                        }
                                        else {
                                            _this.alerting.popError(_this.getResourceString("Error_Saving_Changes"));
                                        }
                                    });
                                }
                                else {
                                    _this.alerting.popError(_this.getResourceString("Error_Saving_Changes"));
                                }
                            });
                        }
                        else {
                            _this.alerting.popError(_this.getResourceString("Error_Saving_Changes"));
                        }
                    });
                };
                this.addPhotos = function () {
                    var chain = _this.$q.when();
                    _this.failedAddedImages = [];
                    angular.forEach(_this.requestData.images, function (image) {
                        if (image.no == undefined && image.uploaded === undefined)
                            chain = chain.then(_this.addPhoto(image));
                    });
                    return chain;
                };
                this.loadTimeSlots = function (selectedDate) {
                    if (!selectedDate)
                        return;
                    delete _this.formContainer.selectedPlanSuggestion;
                    var searchDate = selectedDate;
                    if (selectedDate.format)
                        searchDate = selectedDate.format('YYYY-MM-DD');
                    if (searchDate === _this.oldSearchDate)
                        return;
                    _this.oldSearchDate = searchDate;
                    _this.repairmentsService.getPlanningData(_this.repairment.CompanyName, _this.repairment.No, searchDate).then(_this.getLoadTimeSlotsCallback(selectedDate));
                };
                this.getLoadTimeSlotsCallback = function (selectedDate) {
                    return function (data) {
                        _this.formContainer.TimeSlots = null;
                        if (data.success === true && data.data) {
                            _this.planningData = data.data;
                            if (selectedDate.isBefore(_this.planningData.PlanDate, 'day')) {
                                _this.minimumDate = new moment(_this.planningData.PlanDate);
                            }
                            if (_this.planningData.Periods.length > 0) {
                                _this.processPeriods();
                            }
                            else if (_this.planningData.ConnectItProposals.length > 0) {
                                _this.processConnectItProposals();
                            }
                            else if (_this.planningData.InspectionAppointments.length > 0) {
                                _this.processInspectionAppointments();
                            }
                        }
                    };
                };
                this.activate();
            }
            controller.prototype.activate = function () {
                var _this = this;
                this.requestData = { images: [], defectDescription: {}, defectRequired: false };
                this.originalRepairment = this.$stateParams.repairment;
                this.repairment = JSON.parse(JSON.stringify(this.$stateParams.repairment));
                this.initialRequestData = { images: [], defectDescription: {} };
                this.userResponse = { phone: {}, email: {} };
                if (this.$stateParams.shouldTransitionToState != undefined) {
                    this.$state.go(this.$stateParams.shouldTransitionToState);
                    return;
                }
                this.contractService.getCustomerDetails().then(this.customerDetailsCallback);
                this.requestData.defectDescription = this.getAdditionalDescription(this.repairment);
                this.initialRequestData = JSON.parse(JSON.stringify(this.requestData));
                if (this.repairment.MaintenanceOrders
                    && this.repairment.MaintenanceOrders.length == 1
                    && this.repairment.MaintenanceOrders[0].Urgent === true) {
                    this.minimumDate = moment();
                }
                else {
                    this.minimumDate = moment().add(1, 'day');
                }
                this.repairmentsService.getMaintenanceRequestAttachments(this.repairment.CompanyName, this.repairment.No)
                    .then(function (result) {
                    if (result.success && result.data) {
                        _this.requestData.images = _this.getTranslatedImageData(result.data);
                        _this.initialRequestData.images = _this.getPhotosIds(_this.requestData.images);
                    }
                    else {
                        _this.alerting.popError(_this.getResourceString("Error_Retrieve_Photos"));
                    }
                });
                this.loadTimeSlots(this.minimumDate);
                this.fillSelectedTimeSlot();
            };
            controller.prototype.fillSelectedTimeSlot = function () {
                if (this.repairment.Inspections && this.repairment.Inspections.length == 1) {
                    var inspection = this.repairment.Inspections[0];
                    this.formContainer.selectedTimeSlot = {
                        Date: new moment(inspection.Date),
                        Description: this.$filter('date')(inspection.Date + 'T' + inspection.StartTime, 'HH:mm') + ' - '
                            + this.$filter('date')(inspection.Date + 'T' + inspection.EndTime, 'HH:mm')
                    };
                    if (!this.formContainer.selectedTimeSlot.Date.isValid()) {
                        this.formContainer.selectedTimeSlot.Description = this.getResourceString("Message_NoInspectionDayAndTime");
                    }
                }
                else if (this.repairment.MaintenanceOrders && this.repairment.MaintenanceOrders.length == 1) {
                    var order = this.repairment.MaintenanceOrders[0];
                    this.formContainer.selectedTimeSlot = {
                        Date: new moment(order.AppointmentDate),
                        Description: this.$filter('date')(order.AppointmentDate + 'T' + order.TimeFrom, 'HH:mm') + ' - '
                            + this.$filter('date')(order.AppointmentDate + 'T' + order.TimeTo, 'HH:mm')
                    };
                    if (!this.formContainer.selectedTimeSlot.Date.isValid()) {
                        this.formContainer.selectedTimeSlot.Description = this.getResourceString("Message_NoAppointmentDayAndTime");
                    }
                }
                else {
                    this.formContainer.selectedTimeSlot = {
                        Date: new moment(this.repairment.PreferredDate),
                        Description: this.repairment.PreferredDaypart
                    };
                    if (!this.formContainer.selectedTimeSlot.Date.isValid()) {
                        this.formContainer.selectedTimeSlot.Description = this.getResourceString("Message_NoPreferenceDayAndTime");
                    }
                }
            };
            controller.prototype.getAdditionalDescription = function (maintenanceRequest) {
                if (!maintenanceRequest.Descriptions || maintenanceRequest.Descriptions.length === 0) {
                    return new customer.myRepairments.models.Description();
                }
                var description = new customer.myRepairments.models.Description();
                for (var i = maintenanceRequest.Descriptions.length - 1; i >= 0; i--) {
                    if (maintenanceRequest.Descriptions[i].DescriptionCustomer) {
                        description = maintenanceRequest.Descriptions[i];
                        break;
                    }
                }
                return description;
            };
            controller.prototype.saveRepairmentChanges = function (form) {
                if (form.$invalid) {
                    return;
                }
                this.collectUserInput().then(this.saveChanges);
            };
            controller.prototype.cancelEdit = function () {
                this.$state.go('repairments');
            };
            controller.prototype.updateMaintenanceRequest = function () {
                if (angular.equals(this.requestData.defectDescription, this.initialRequestData.defectDescription)
                    && angular.equals(this.repairment, this.originalRepairment)) {
                    return this.$q.resolve({ success: true });
                }
                var updateMaintenaceRequestData = {
                    MaintenanceRequestNo: this.repairment.No,
                    CallerEmail: this.repairment.CallerEmail,
                    CallerDaytimePhoneNo: this.repairment.CallerDaytimePhoneNo,
                    Descriptions: {
                        Description: this.requestData.defectDescription.DescriptionBigText,
                        DescriptionID: this.requestData.defectDescription.DescriptionID
                    }
                };
                return this.repairmentsService.updateMaintenanceRequest(this.repairment.CompanyName, updateMaintenaceRequestData);
            };
            controller.prototype.updatePlanningData = function () {
                if (this.formContainer.selectedTimeSlot.TimeSlot == null) {
                    return this.$q.resolve({ success: true });
                }
                var updatePlanningData = {
                    MaintenanceRequestNo: this.repairment.No,
                    PlanDate: this.formContainer.selectedTimeSlot.Date.format("YYYY-MM-DD"),
                    Periods: null,
                    ConnectItProposals: null,
                    InspectionAppointments: null
                };
                if (this.planningData.Periods.length > 0) {
                    updatePlanningData.Periods = [this.formContainer.selectedTimeSlot.TimeSlot];
                }
                else if (this.planningData.ConnectItProposals.length > 0) {
                    updatePlanningData.ConnectItProposals = [this.formContainer.selectedTimeSlot.TimeSlot];
                }
                else if (this.planningData.InspectionAppointments.length > 0) {
                    updatePlanningData.InspectionAppointments = [this.formContainer.selectedTimeSlot.TimeSlot];
                }
                return this.repairmentsService.updatePlanningData(this.repairment.CompanyName, updatePlanningData);
            };
            controller.prototype.deletePhotos = function (chain) {
                var _this = this;
                this.failedDeletedImages = [];
                angular.forEach(this.initialRequestData.images, function (imageId) {
                    var found = false;
                    angular.forEach(_this.requestData.images, function (image) {
                        if (image.no === imageId) {
                            found = true;
                        }
                    });
                    if (found === false)
                        chain = chain.then(_this.deletePhoto(imageId));
                });
                return chain;
            };
            controller.prototype.deletePhoto = function (imageId) {
                var _this = this;
                return function () {
                    return _this.repairmentsService.deleteMaintenanceRequestAttachment(_this.repairment.CompanyName, _this.repairment.No, imageId)
                        .then(function (result) {
                        if (result.success) {
                            var index = _this.initialRequestData.images.indexOf(imageId);
                            if (index !== -1)
                                _this.initialRequestData.images.splice(index, 1);
                        }
                        else {
                            _this.failedDeletedImages.push(imageId);
                        }
                    });
                };
            };
            controller.prototype.addPhoto = function (image) {
                var _this = this;
                return function () {
                    var maintenanceRequestAttachment = _this.createMaintenanceRequestAttachmentObject(image, _this.repairment.No);
                    return _this.repairmentsService
                        .submitMaintenanceRequestAttachment(_this.repairment.CompanyName, maintenanceRequestAttachment)
                        .then(function (result) {
                        if (result.success) {
                            image.uploaded = true;
                            _this.initialRequestData.images.push(result.data);
                        }
                        else {
                            _this.failedAddedImages.push(result.data);
                        }
                    });
                };
            };
            controller.prototype.createMaintenanceRequestAttachmentObject = function (image, maintenanceRequestNo) {
                return {
                    MaintenanceRequestNo: maintenanceRequestNo,
                    Attachment: {
                        AttachmentNo: '',
                        AttachmentTitle: image.name,
                        AttachmentDescription: image.name,
                        AttachmentFileName: image.name,
                        AttachmentExtension: image.ext,
                        AttachmentBase64: image.data.substring(image.data.indexOf(",") + 1)
                    }
                };
            };
            controller.prototype.getTranslatedImageData = function (empireData) {
                var translatedData = [];
                empireData.forEach(function (result, index, array) {
                    translatedData.push({ data: "data:image/jpeg;base64," + result.AttachmentBase64, ext: result.AttachmentExtension, name: result.AttachmentTitle, no: result.AttachmentNo, canDelete: result.DeleteAllowed });
                });
                return translatedData;
            };
            controller.prototype.getPhotosIds = function (images) {
                var imageIds = [];
                images.forEach(function (image, index, array) {
                    imageIds.push(image.no);
                });
                return imageIds;
            };
            controller.prototype.updateContactDetails = function () {
                var _this = this;
                if (!this.userResponse.phone.save && !this.userResponse.email.save) {
                    return this.$q.when();
                }
                var email = this.userResponse.email.save ? this.userResponse.email.value : this.customerDetails.Email;
                var phoneNo = this.userResponse.phone.save ? this.userResponse.phone.value : this.customerDetails.PhoneNo;
                return this.myDetailsService.updateContactDetails(this.customerDetails, email, phoneNo).then(function (response) {
                    if (response.success) {
                        _this.contractService.refreshCustomerDetails();
                    }
                    _this.updateCustomerDetailsFailed = !response.success;
                    return response;
                });
            };
            controller.prototype.collectUserInput = function () {
                var _this = this;
                var phoneChanged = this.repairment.CallerDaytimePhoneNo !== this.originalRepairment.CallerDaytimePhoneNo && this.repairment.CallerDaytimePhoneNo !== this.customerDetails.PhoneNo;
                var emailChanged = this.repairment.CallerEmail !== this.originalRepairment.CallerEmail && this.repairment.CallerEmail !== this.customerDetails.Email;
                var dialogs = [];
                if (phoneChanged && this.userResponse.phone.value !== this.repairment.CallerDaytimePhoneNo) {
                    dialogs.push({
                        name: "phoneOnlyForThisRequest",
                        display: this.contactInfoDialog.phoneDialog(this.repairment.CallerDaytimePhoneNo, this.customerDetails.PhoneNo),
                        userResponse: false
                    });
                }
                if (emailChanged && this.userResponse.email.value !== this.repairment.CallerEmail) {
                    dialogs.push({
                        name: "emailOnlyForThisRequest",
                        display: this.contactInfoDialog.emailDialog(this.repairment.CallerEmail, this.customerDetails.Email),
                        checkPassword: this.emailChangeDialog.checkPassword,
                        userResponse: false
                    });
                }
                return this.dialogChainer.gatherData(dialogs).then(function (response) {
                    if (response.phoneOnlyForThisRequest !== undefined) {
                        _this.userResponse.phone.value = _this.repairment.CallerDaytimePhoneNo;
                        _this.userResponse.phone.save = !response.phoneOnlyForThisRequest;
                    }
                    if (response.emailOnlyForThisRequest !== undefined) {
                        _this.userResponse.email.value = _this.repairment.CallerEmail;
                        _this.userResponse.email.save = !response.emailOnlyForThisRequest;
                    }
                    return _this.userResponse;
                });
            };
            controller.prototype.processPeriods = function () {
                var timeSlots = [];
                angular.forEach(this.planningData.Periods, function (item) {
                    timeSlots.push({
                        Description: item.Description,
                        Item: item
                    });
                });
                if (timeSlots.length > 0) {
                    this.formContainer.TimeSlots = timeSlots;
                }
            };
            controller.prototype.processConnectItProposals = function () {
                var timeSlots = [];
                angular.forEach(this.planningData.ConnectItProposals, function (item) {
                    timeSlots.push({
                        Description: item.BlockTimeFrom + ' - ' + item.BlockTimeUntil,
                        Item: item
                    });
                });
                if (timeSlots.length > 0) {
                    this.formContainer.TimeSlots = timeSlots;
                }
            };
            controller.prototype.processInspectionAppointments = function () {
                var timeSlots = [];
                angular.forEach(this.planningData.InspectionAppointments, function (item) {
                    timeSlots.push({
                        Description: item.StartTime + ' - ' + item.EndTime,
                        Item: item
                    });
                });
                if (timeSlots.length > 0) {
                    this.formContainer.TimeSlots = timeSlots;
                }
            };
            controller.prototype.getResourceString = function (key) {
                return this.localize.getLocalizedString(key, "EditRepairment");
            };
            return controller;
        }());
        angular.module('customer.myRepairments').
            component('editRepairment', {
            controller: controller,
            templateUrl: '/App/myRepairments/editRepairment.html'
        });
    })(myRepairments = customer.myRepairments || (customer.myRepairments = {}));
})(customer || (customer = {}));
//# sourceMappingURL=editRepairmencomponent.js.map
var customer;
(function (customer) {
    var myRepairments;
    (function (myRepairments) {
        var controller = (function () {
            function controller(repairmentsService, localize, alerting, $filter, $state) {
                var _this = this;
                this.repairmentsService = repairmentsService;
                this.localize = localize;
                this.alerting = alerting;
                this.$filter = $filter;
                this.$state = $state;
                this.photosDownloadStarted = {};
                this.$inject = ['repairmentsService', 'localize', 'alerting', '$filter', '$state'];
                this.dailyMaintenanceCallback = function (data) {
                    if (data.success === true) {
                        _this.repairments = data.data;
                        _this.populateExtendedInfoArrays();
                    }
                    else {
                        var message = _this.localize.getLocalizedString('Message_FailedToLoadRepairments', 'MyRepairments');
                        _this.alerting.popError(message);
                    }
                };
                this.getContractSortValue = function (item) {
                    var value = item.Address;
                    if (item.ClusterName) {
                        value = item.ClusterName;
                    }
                    return value;
                };
                this.downloadAttachments = function (item) {
                    var keyValues = _this.secondExtendedInfoItems[item.No];
                    if (!_this.photosDownloadStarted[item.No]) {
                        _this.photosDownloadStarted[item.No] = true;
                        _this.repairmentsService.getMaintenanceRequestAttachments(item.CompanyName, item.No)
                            .then(function (result) {
                            var content = "";
                            if (result.success && result.data && result.data.length > 0) {
                                angular.forEach(result.data, function (attachment) {
                                    content += _this.getImageMarkup(attachment.AttachmentDescription, attachment.AttachmentBase64);
                                });
                            }
                            else {
                                content = _this.getResourceString("Text_NoPhotosFound");
                            }
                            keyValues[_this.getResourceString("Label_Photos")] = new core.models.keyValues.keyValue(content);
                        });
                    }
                };
                this.editRepairment = function (repairment) {
                    _this.$state.go('editRepairment', { repairment: repairment }, { location: 'replace' });
                };
                this.cancelRepairment = function (repairment) {
                    _this.$state.go('cancelRepairment', { repairRequestDescription: _this.firstExtendedInfo(repairment, true), companyName: repairment.CompanyName, repairmentNo: repairment.No }, { location: 'replace' });
                };
                this.isUnhandledRepairRequest = function (item) {
                    return (item.StatusDescription === 'Afgehandeld') || (item.StatusDescription === 'Geannuleerd');
                };
                this.isHandledRepairRequest = function (item) {
                    return !_this.isUnhandledRepairRequest(item);
                };
                this.activate();
            }
            controller.prototype.activate = function () {
                this.repairmentsService.getDailyMaintenance().then(this.dailyMaintenanceCallback);
            };
            controller.prototype.populateExtendedInfoArrays = function () {
                var _this = this;
                this.firstExtendedInfoItems = {};
                this.secondExtendedInfoItems = {};
                angular.forEach(this.repairments, function (value) {
                    _this.firstExtendedInfoItems[value.No] = _this.firstExtendedInfo(value);
                    _this.secondExtendedInfoItems[value.No] = _this.secondExtendedInfo(value);
                });
            };
            controller.prototype.firstExtendedInfo = function (maintenanceItem, generateForCancel) {
                var keyValues = {};
                if (generateForCancel === true) {
                    var objectAddress = maintenanceItem.Address;
                    if (maintenanceItem.CommonArea === true) {
                        objectAddress += '<br/>' + maintenanceItem.CommonAreaDescription;
                    }
                    keyValues[this.getResourceString('Column_Object')] = new core.models.keyValues.keyValue(maintenanceItem.Address);
                    keyValues[this.getResourceString('Details_Description')] = new core.models.keyValues.keyValue(maintenanceItem.Description);
                }
                keyValues[this.getResourceString('Details_Report_Date')] = new core.models.keyValues.keyValue(this.$filter('date')(maintenanceItem.ReportingDate, 'EEEE dd-MM-yyyy'));
                keyValues[this.getResourceString('Details_Request_Number')] = new core.models.keyValues.keyValue(maintenanceItem.No);
                keyValues[this.getResourceString('Details_Request_Status')] = new core.models.keyValues.keyValue(maintenanceItem.StatusDescription);
                if (maintenanceItem.ReasonDeclinedDescription)
                    keyValues[this.getResourceString('Details_Cancellation_Reason')] = new core.models.keyValues.keyValue(maintenanceItem.ReasonDeclinedDescription);
                var description = this.getResourceString('Label_Room') + ': ' + this.nullableToString(maintenanceItem.DecisionTreeStep.ExternalRoomTypeDescription) + '<br/>' +
                    this.getResourceString('Label_ConstructionPart') + ': ' + this.nullableToString(maintenanceItem.DecisionTreeStep.ExternalConstructionPartDescription) + '<br/>' +
                    this.getResourceString('Label_Part') + ': ' + this.nullableToString(maintenanceItem.DecisionTreeStep.ExternalPartDescription) + '<br/>' +
                    this.getResourceString('Label_Issue') + ': ' + this.nullableToString(maintenanceItem.DecisionTreeStep.ExternalIssueDescription);
                if (maintenanceItem.DecisionTreeStep.Specification) {
                    description += '<br/>' + this.getResourceString('Label_Specification') + ': ' + maintenanceItem.DecisionTreeStep.Specification;
                }
                var descriptionKey = 'Details_Description';
                if (generateForCancel === true) {
                    descriptionKey = 'Label_SelectedDefect';
                }
                keyValues[this.getResourceString(descriptionKey)] = new core.models.keyValues.keyValue(description);
                keyValues[this.getResourceString('Details_Cause')] = new core.models.keyValues.keyValue((maintenanceItem.DecisionTreeStep.ExternalCauseDescription ? maintenanceItem.DecisionTreeStep.ExternalCauseDescription : '-'));
                if (maintenanceItem.FixedBySolutionTips) {
                    keyValues[this.getResourceString('Details_SolutionTip')] = new core.models.keyValues.keyValue(maintenanceItem.SolutionTip);
                }
                if (maintenanceItem.TotalChargeToTenantAmount > 0) {
                    keyValues[this.getResourceString('Details_Costs')] = new core.models.keyValues.keyValue(this.$filter('number')(maintenanceItem.TotalChargeToTenantAmount, 2), 'currency');
                }
                return keyValues;
            };
            controller.prototype.secondExtendedInfo = function (maintenanceItem) {
                var keyValues = {};
                if (maintenanceItem.Descriptions) {
                    var additionalDescription = this.getAdditionalDescription(maintenanceItem);
                    keyValues[this.getResourceString('Details_AdditionalDescription')] = new core.models.keyValues.keyValue(additionalDescription ? additionalDescription : "");
                }
                keyValues[this.getResourceString("Label_Photos")] = new core.models.keyValues.keyValue('<span>' + this.getResourceString("Text_LoadingPhotos") + '</span><i class="fa fa-spinner fa-spin fa-1x fa-fw"></i>');
                if (maintenanceItem.PreferredDate) {
                    keyValues[this.getResourceString('Details_PreferredDate')] = new core.models.keyValues.keyValue(this.$filter('date')(maintenanceItem.PreferredDate, 'EEEE dd-MM-yyyy') + ', ' + maintenanceItem.PreferredDaypart);
                }
                var contactDetails = '';
                if (maintenanceItem.CallerDaytimePhoneNo) {
                    contactDetails += this.getResourceString('Label_PhoneNo') + ': ' + maintenanceItem.CallerDaytimePhoneNo;
                }
                if (maintenanceItem.CallerEmail) {
                    if (contactDetails != '') {
                        contactDetails += '<br/>';
                    }
                    contactDetails += this.getResourceString('Label_Email') + ': ' + maintenanceItem.CallerEmail;
                }
                if (contactDetails != '') {
                    keyValues[this.getResourceString('Details_ContactDetails')] = new core.models.keyValues.keyValue(contactDetails);
                }
                return keyValues;
            };
            controller.prototype.getAdditionalDescription = function (maintenanceRequest) {
                if (!maintenanceRequest.Descriptions || maintenanceRequest.Descriptions.length === 0) {
                    return null;
                }
                var description = "";
                for (var i = maintenanceRequest.Descriptions.length - 1; i >= 0; i--) {
                    description += maintenanceRequest.Descriptions[i].DescriptionBigText + "<br/>";
                }
                return description;
            };
            controller.prototype.getImageMarkup = function (title, base64Content) {
                var img = $("<img>");
                img.attr("title", title);
                img.attr("src", "data:image/jpeg;base64," + base64Content);
                img.addClass("img-thumbnail img-thumbnail-fixed-size");
                return $("<div>").append(img).html();
            };
            controller.prototype.nullableToString = function (nullableString) {
                return nullableString || "";
            };
            controller.prototype.getResourceString = function (resourceString) {
                return this.localize.getLocalizedString(resourceString, 'MyRepairments');
            };
            return controller;
        }());
        angular
            .module('customer.myRepairments')
            .component('myRepairments', {
            controller: controller,
            templateUrl: '/App/myRepairments/myRepairments.html'
        });
    })(myRepairments = customer.myRepairments || (customer.myRepairments = {}));
})(customer || (customer = {}));
//# sourceMappingURL=myRepairments.component.js.map
var customer;
(function (customer) {
    var myRepairments;
    (function (myRepairments) {
        angular
            .module('customer.myRepairments')
            .config(configRoutes);
        function configRoutes($stateProvider, $urlRouterProvider, $locationProvider) {
            var repairmentsState = {
                name: 'repairments',
                url: '/repairments',
                template: '<my-repairments></my-repairments>',
                portalModule: 'Repairs'
            };
            var editRepairmentState = {
                url: '/editRepairment',
                template: '<edit-repairment></edit-repairment>',
                portalModule: 'Repairs',
                resolve: {},
                params: { repairment: null },
                onEnter: checkEditRepairmentPreconditions
            };
            var cancelRepairmentState = {
                url: '/cancelRepairment',
                template: '<cancel-repairment></cancel-repairment>',
                portalModule: 'Repairs',
                params: { repairRequestDescription: '', companyName: '', repairmentNo: '' },
                onEnter: checkCancelRepairmentPreconditions
            };
            $locationProvider.html5Mode(true);
            $stateProvider.state('repairments', repairmentsState);
            $stateProvider.state('editRepairment', editRepairmentState);
            $stateProvider.state('cancelRepairment', cancelRepairmentState);
        }
        checkEditRepairmentPreconditions.$inject = ['$stateParams'];
        function checkEditRepairmentPreconditions($stateParams) {
            if ($stateParams.repairment == null) {
                $stateParams.shouldTransitionToState = 'repairments';
            }
        }
        checkCancelRepairmentPreconditions.$inject = ['$stateParams'];
        function checkCancelRepairmentPreconditions($stateParams) {
            if ($stateParams.companyName == null || $stateParams.companyName === ''
                || $stateParams.repairmentNo == null || $stateParams.repairmentNo === '') {
                $stateParams.shouldTransitionToState = 'repairments';
            }
        }
    })(myRepairments = customer.myRepairments || (customer.myRepairments = {}));
})(customer || (customer = {}));
//# sourceMappingURL=myRepairments.route.js.map
var customer;
(function (customer) {
    var myRepairments;
    (function (myRepairments) {
        var repairmentsService = (function () {
            function repairmentsService(dataservice) {
                this.dataservice = dataservice;
            }
            repairmentsService.prototype.getDailyMaintenance = function () {
                return this.dataservice.getData('/api/maintenance/dailymaintenance');
            };
            repairmentsService.prototype.getRoomTypes = function (companyName, realtyObjectNo, searchValue) {
                var url = '/api/maintenance/roomtypes/' + encodeURIComponent(companyName) + '?realtyObjectNo=' + encodeURIComponent(realtyObjectNo) + '&searchValue=' + encodeURIComponent(searchValue);
                return this.dataservice.getData(url);
            };
            repairmentsService.prototype.getConstructionParts = function (companyName, realtyObjectNo, roomType, searchValue) {
                var url = '/api/maintenance/constructionparts/' + encodeURIComponent(companyName) + '?realtyObjectNo=' + encodeURIComponent(realtyObjectNo) + '&roomType=' + encodeURIComponent(roomType) + '&searchValue=' + encodeURIComponent(searchValue);
                return this.dataservice.getData(url);
            };
            repairmentsService.prototype.getParts = function (companyName, realtyObjectNo, roomType, constructionPart, searchValue) {
                var url = '/api/maintenance/parts/' + encodeURIComponent(companyName) + '?realtyObjectNo=' + encodeURIComponent(realtyObjectNo) + '&roomType=' + encodeURIComponent(roomType) + '&constructionPart=' + encodeURIComponent(constructionPart) + '&searchValue=' + encodeURIComponent(searchValue);
                return this.dataservice.getData(url);
            };
            repairmentsService.prototype.getIssues = function (companyName, realtyObjectNo, roomType, constructionPart, part, searchValue) {
                var url = '/api/maintenance/issues/' + encodeURIComponent(companyName) + '?realtyObjectNo=' + encodeURIComponent(realtyObjectNo) + '&roomType=' + encodeURIComponent(roomType) + '&constructionPart=' + encodeURIComponent(constructionPart) + '&part=' + encodeURIComponent(part) + '&searchValue=' + encodeURIComponent(searchValue);
                return this.dataservice.getData(url);
            };
            repairmentsService.prototype.getSpecifications = function (companyName, realtyObjectNo, roomType, constructionPart, part, issue) {
                var url = '/api/maintenance/specifications/' + encodeURIComponent(companyName) + '?realtyObjectNo=' + encodeURIComponent(realtyObjectNo) + '&roomType=' + encodeURIComponent(roomType) + '&constructionPart=' + encodeURIComponent(constructionPart) + '&part=' + encodeURIComponent(part) + '&issue=' + encodeURIComponent(issue);
                return this.dataservice.getData(url);
            };
            repairmentsService.prototype.getCauses = function (companyName) {
                var url = "/api/maintenance/causes/" + encodeURIComponent(companyName);
                return this.dataservice.getData(url);
            };
            repairmentsService.prototype.getRepairTemplate = function (companyName, repairTemplateCode) {
                var url = '/api/maintenance/repairtemplate/' + encodeURIComponent(companyName) + '/?repairTemplateCode=' + encodeURIComponent(repairTemplateCode);
                return this.dataservice.getData(url);
            };
            repairmentsService.prototype.canSubmitMaintenanceRequest = function (companyName, realtyObjectNo) {
                var url = '/api/maintenance/' + encodeURIComponent(companyName) + '/cansubmitmaintenancerequest?realtyObjectNo=' + realtyObjectNo;
                return this.dataservice.getData(url);
            };
            repairmentsService.prototype.canCreateMaintenanceRequest = function (companyName, realtyObjectNo, issueNo, causeCode) {
                var url = '/api/maintenance/cancreatemaintenancerequest/' + encodeURIComponent(companyName) + '?realtyObjectNo=' + realtyObjectNo + '&issueNo=' + issueNo + '&causeCode=' + encodeURIComponent(causeCode);
                return this.dataservice.getData(url);
            };
            repairmentsService.prototype.getCustomerCharged = function (companyName, realtyObjectNo, decisionTreeEntryNo, causeCode) {
                var url = '/api/maintenance/customercharged/' + encodeURIComponent(companyName) + '?realtyObjectNo=' + encodeURIComponent(realtyObjectNo) + '&decisionTreeEntryNo=' + encodeURIComponent(decisionTreeEntryNo) + '&causeCode=' + encodeURIComponent(causeCode);
                return this.dataservice.getData(url);
            };
            repairmentsService.prototype.submitMaintenanceRequest = function (maintenanceRequest) {
                var url = '/api/maintenance/submit';
                return this.dataservice.postData(url, maintenanceRequest);
            };
            repairmentsService.prototype.getPlanningData = function (companyName, maintenanceRequestNo, planDate) {
                var url = '/api/maintenance/planningdata/' + encodeURIComponent(companyName) + '?maintenanceRequestNo=' + encodeURIComponent(maintenanceRequestNo) + '&planDate=' + encodeURIComponent(planDate);
                return this.dataservice.getData(url);
            };
            repairmentsService.prototype.updatePlanningData = function (companyName, updatePlanningData) {
                var url = '/api/maintenance/updateplanningdata/' + encodeURIComponent(companyName);
                return this.dataservice.postData(url, updatePlanningData);
            };
            repairmentsService.prototype.submitMaintenanceRequestAttachment = function (companyName, maintenanceRequestAttachment) {
                var url = '/api/maintenance/' + encodeURIComponent(companyName) + '/attachment/submit';
                return this.dataservice.postData(url, maintenanceRequestAttachment);
            };
            repairmentsService.prototype.getMaintenanceRequestAttachments = function (companyName, maintenanceRequestNo) {
                var url = "/api/maintenance/" + encodeURIComponent(companyName) + "/attachments?maintenanceRequestNo=" + encodeURIComponent(maintenanceRequestNo);
                return this.dataservice.getData(url);
            };
            repairmentsService.prototype.deleteMaintenanceRequestAttachment = function (companyName, maintenanceRequestNo, maintenanceRequestAttachmentId) {
                var url = '/api/maintenance/attachment/delete' + '?companyName=' + encodeURIComponent(companyName) + '&maintenanceRequestNo=' + encodeURIComponent(maintenanceRequestNo) + '&maintenanceRequestAttachmentId=' + encodeURIComponent(maintenanceRequestAttachmentId);
                return this.dataservice.postData(url, {});
            };
            repairmentsService.prototype.updateMaintenanceRequest = function (companyName, updateMaintenanceRequestData) {
                var url = '/api/maintenance/' + encodeURIComponent(companyName) + '/update';
                return this.dataservice.postData(url, updateMaintenanceRequestData);
            };
            repairmentsService.prototype.cancelMaintenanceRequest = function (companyName, cancelMaintenanceRequestData) {
                var url = '/api/maintenance/' + encodeURIComponent(companyName) + '/cancel';
                return this.dataservice.postData(url, cancelMaintenanceRequestData);
            };
            repairmentsService.prototype.getRequestCancelReasons = function (companyName) {
                var url = '/api/maintenance/' + encodeURIComponent(companyName) + '/cancelreasons';
                return this.dataservice.getData(url);
            };
            repairmentsService.prototype.getPlanningDelay = function () {
                var url = '/api/settings';
                return this.dataservice.getData(url);
            };
            return repairmentsService;
        }());
        myRepairments.repairmentsService = repairmentsService;
        angular
            .module('customer.myRepairments')
            .service('repairmentsService', repairmentsService);
    })(myRepairments = customer.myRepairments || (customer.myRepairments = {}));
})(customer || (customer = {}));
//# sourceMappingURL=myRepairments.service.js.map
var customer;
(function (customer) {
    var myTimeline;
    (function (myTimeline) {
        var controller = (function () {
            function controller($rootScope, timelineService, contractService, $filter, $timeout, localize, alerting) {
                var _this = this;
                this.$rootScope = $rootScope;
                this.timelineService = timelineService;
                this.contractService = contractService;
                this.$filter = $filter;
                this.$timeout = $timeout;
                this.localize = localize;
                this.alerting = alerting;
                this.iconDictionary = {
                    "icon_pencil_light": [
                        "wijzigen",
                        "aanpassen",
                        "edit",
                        "change"
                    ],
                    "icon_plus_light": [
                        "aanmaken",
                        "toevoegen",
                        "indienen",
                        "add",
                        "create"
                    ],
                    "icon_min_light": [
                        "verwijderen",
                        "delete",
                        "remove"
                    ],
                    "icon_attention": [
                        "melden",
                        "announce"
                    ]
                };
                this.codeIconDictionary = {
                    "CP_ARRANGEMENT_ADD": "icon_payment_light",
                    "CP_CONTACT_EDIT": "icon_user_light",
                    "CP_CONTRACT_END": "icon_contracts",
                    "CP_MAINTREQUEST_ADD": "icon_tool_light",
                    "CP_PASSWORD_EDIT": "icon_user_light",
                    "CP_PERSON_ADD": "icon_user_light",
                    "CP_PERSON_DELETE": "icon_user_light",
                    "CP_PERSON_EDIT": "icon_user_light",
                    "CP_TRANSACTMODE_EDIT": "icon_payment_light"
                };
                this.actions = [];
                this.filteredItems = [];
                this.totalActions = 0;
                this.page = 1;
                this.isLoadingMore = false;
                this.addNewInteraction = false;
                this.interactionSubjects = {};
                this.$inject = ['$rootScope', 'timelineService', 'contractService', '$filter', '$timeout', 'localize', 'alerting'];
                this.getInteractionTemplatesCallback = function (data) {
                    if (data.success === true) {
                        angular.forEach(data.data, function (template) {
                            _this.interactionSubjects[template.Code] = template.Description;
                        });
                        _this.timelineService.getTimeline(10, _this.page, true).then(_this.getTimelineCallback);
                    }
                    else {
                        var message = _this.localize.getLocalizedString('Message_FailedToLoadTemplates', 'MyTimeline');
                        _this.alerting.popError(message);
                    }
                };
                this.getTimelineCallback = function (data) {
                    if (data.success === true) {
                        _this.actions = data.rows;
                        var obj = _this;
                        _this.actions.forEach(function (val, key) {
                            val.ClientDateTime = obj.parseClientDate(val.CreationDateTime);
                        });
                        _this.filteredItems = _this.groupByDateFilter(_this.actions, 'CreationDateTime');
                        _this.totalActions = data.results;
                        _this.page++;
                    }
                    else {
                        var message = _this.localize.getLocalizedString('Message_FailedToLoadTimeline', 'MyTimeline');
                        _this.alerting.popError(message);
                    }
                };
                this.refreshTimeline = function () {
                    _this.actions = [];
                    _this.filteredItems = [];
                    _this.totalActions = 0;
                    _this.page = 1;
                    _this.isLoadingMore = false;
                    _this.activate();
                };
                this.loadMore = function () {
                    if (_this.isLoadingMore)
                        return;
                    if (_this.actions.length < _this.totalActions && !_this.isLoadingMore) {
                        _this.isLoadingMore = true;
                        _this.timelineService.getTimeline(10, _this.page, true).then(function (data) {
                            if (_this.isLoadingMore) {
                                if (data.success === true) {
                                    Array.prototype.push.apply(_this.actions, data.rows);
                                    _this.filteredItems = _this.groupByDateFilter(_this.actions, 'CreationDateTime');
                                    _this.totalActions = data.results;
                                    _this.isLoadingMore = false;
                                    _this.page++;
                                }
                                else {
                                    var message = _this.localize.getLocalizedString('Message_FailedToLoadTimeline', 'MyTimeline');
                                    _this.alerting.popError(message);
                                }
                            }
                        });
                    }
                };
                this.iconForInteraction = function (interaction) {
                    if (interaction && interaction.TemplateDefaultValues) {
                        return _this.codeIconDictionary[interaction.TemplateDefaultValues] ? _this.codeIconDictionary[interaction.TemplateDefaultValues] : "icon_question";
                    }
                    else {
                        return _this.iconFromDescription(interaction ? interaction.Description : undefined);
                    }
                };
                this.iconFromDescription = function (filter) {
                    var result = "icon_question";
                    if (filter) {
                        angular.forEach(_this.iconDictionary, function (value, key) {
                            angular.forEach(value, function (keyword) {
                                if (filter.toLowerCase().indexOf(keyword.toLowerCase()) > -1) {
                                    result = key;
                                }
                            });
                        });
                    }
                    return result;
                };
                this.descriptionForInteraction = function (interaction) {
                    var description = interaction.Description;
                    if (interaction.TemplateDefaultValues) {
                        if (_this.interactionSubjects[interaction.TemplateDefaultValues]) {
                            description = _this.interactionSubjects[interaction.TemplateDefaultValues];
                        }
                    }
                    return description;
                };
                this.groupByDateFilter = $filter('groupByDate');
                this.activate();
            }
            controller.prototype.activate = function () {
                var _this = this;
                this.timelineService.getInteractionTemplates().then(this.getInteractionTemplatesCallback);
                this.$timeout(function () {
                    $('textarea[name="userComment"]').on('keyup', function () {
                        var $feedbackIcon = $(this).next('.form-control-feedback');
                        if (this.clientHeight < this.scrollHeight) {
                            $feedbackIcon.css('right', '15px');
                        }
                        else {
                            $feedbackIcon.css('right', '0');
                        }
                    });
                }, 500, false);
                this.$rootScope.$on("newTimelineAction_Added", function () {
                    _this.addNewInteraction = false;
                    _this.refreshTimeline();
                });
                this.$rootScope.$on("newTimelineAction_Canceled", function () {
                    _this.addNewInteraction = false;
                });
            };
            controller.prototype.parseClientDate = function (serverCreationDate) {
                if (serverCreationDate) {
                    var split = serverCreationDate.split('+');
                    var creationDate = new Date(split[0]);
                    var creationDateMin = creationDate.getMinutes();
                    var clientTimeZoneMinutes = new Date().getTimezoneOffset();
                    return new Date(creationDate.setMinutes(creationDateMin + (-1 * clientTimeZoneMinutes)));
                }
                return serverCreationDate;
            };
            return controller;
        }());
        angular
            .module('customer.myTimeline')
            .component('myTimeline', {
            controller: controller,
            templateUrl: '/App/myTimeline/myTimeline.html'
        });
    })(myTimeline = customer.myTimeline || (customer.myTimeline = {}));
})(customer || (customer = {}));
//# sourceMappingURL=myTimeline.component.js.map
var customer;
(function (customer) {
    var myTimeline;
    (function (myTimeline) {
        angular
            .module('customer.myTimeline')
            .config(configRoutes);
        function configRoutes($stateProvider, $urlRouterProvider, $locationProvider) {
            $locationProvider.html5Mode(true);
            var myTimelineRoute = {
                name: 'myTimeline',
                url: '/timeline',
                template: '<my-timeline></my-timeline>',
                portalModule: 'InteractionLogEntries'
            };
            $stateProvider
                .state('myTimeline', myTimelineRoute);
        }
    })(myTimeline = customer.myTimeline || (customer.myTimeline = {}));
})(customer || (customer = {}));
//# sourceMappingURL=myTimeline.route.js.map
var customer;
(function (customer) {
    var myTimeline;
    (function (myTimeline) {
        var timelineService = (function () {
            function timelineService(dataservice) {
                this.dataservice = dataservice;
                this.$inject = ['dataservice'];
            }
            timelineService.prototype.getTimeline = function (count, page, content) {
                return this.dataservice.getData('/api/interactions?count=' + count + '&page=' + page + '&content=' + content);
            };
            timelineService.prototype.getInteractionTemplates = function () {
                return this.dataservice.getData('/api/interactionTemplates');
            };
            timelineService.prototype.saveNewInteraction = function (interaction) {
                return this.dataservice.putData('/api/saveInteraction', interaction);
            };
            return timelineService;
        }());
        myTimeline.timelineService = timelineService;
        angular
            .module('customer.myTimeline')
            .service('timelineService', timelineService);
    })(myTimeline = customer.myTimeline || (customer.myTimeline = {}));
})(customer || (customer = {}));
//# sourceMappingURL=myTimeline.service.js.map
var customer;
(function (customer) {
    var network;
    (function (network) {
        var IpRangeController = (function () {
            function IpRangeController($scope, networkService, alerting, localize, $q, $state) {
                var _this = this;
                this.$scope = $scope;
                this.networkService = networkService;
                this.alerting = alerting;
                this.localize = localize;
                this.$q = $q;
                this.$state = $state;
                this.ipv4v6CIDR = new RegExp(/^([0-9]{1,3}\.){3}[0-9]{1,3}(\/([0-9]|[1-2][0-9]|3[0-2]))?$|^s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:)))(%.+)?s*(\/([0-9]|[1-9][0-9]|1[0-1][0-9]|12[0-8]))?$/);
                this.saveIpRange = function (ipRangeDetailsForm) {
                    if (ipRangeDetailsForm.$invalid || (!_this.ipRange.Administrator && !_this.ipRange.KccEmployee)) {
                        return;
                    }
                    var message = _this.getResource("Save_IPRange_Warning_Message");
                    _this.alerting.confirm(message, "").then(function (result) {
                        if (result) {
                            _this.networkService.saveIpRange(_this.ipRange).then(function (data) {
                                if (data == true) {
                                    _this.alerting.popInfo(_this.getResource("Message_IpRangeSaved")).then(function () {
                                        _this.goBackToIpRanges();
                                    });
                                }
                                else {
                                    _this.alerting.popError(_this.getResource("Message_SaveIpRangeError"));
                                }
                            });
                        }
                    });
                };
                this.goBackToIpRanges = function () {
                    _this.$state.go('network', null, { location: 'replace' });
                };
            }
            IpRangeController.prototype.$onInit = function () {
                this.activate();
            };
            IpRangeController.prototype.activate = function () {
                if (this.ipRange.isNew) {
                    this.panelHeading = this.getResource("Panel_NewIpRangeTitle");
                }
                else {
                    this.panelHeading = this.getResource("Panel_EditIpRangeTitle");
                }
            };
            IpRangeController.prototype.getResource = function (key) {
                return this.localize.getLocalizedString(key, "Network");
            };
            return IpRangeController;
        }());
        IpRangeController.$inject = ["$scope", "networkService", "alerting", "localize", "$q", "$state"];
        angular
            .module("customer.network")
            .component("ipRange", {
            templateUrl: "/App/network/editIpRange.html",
            bindings: {
                ipRange: '='
            },
            controller: IpRangeController
        });
    })(network = customer.network || (customer.network = {}));
})(customer || (customer = {}));
//# sourceMappingURL=ipRange.component.js.map
var customer;
(function (customer) {
    var network;
    (function (network) {
        var NetworkController = (function () {
            function NetworkController($scope, networkService, alerting, localize, $q, $state) {
                var _this = this;
                this.$scope = $scope;
                this.networkService = networkService;
                this.alerting = alerting;
                this.localize = localize;
                this.$q = $q;
                this.$state = $state;
                this.onCheckChange = function (selection) {
                    angular.forEach(_this.ipRanges, function (range) {
                        if (range.Id !== selection.Id) {
                            range.selected = false;
                        }
                    });
                    _this.gridSelection = selection;
                };
                this.newIpRange = function () {
                    _this.$state.go('newiprange', '', { location: 'replace' });
                };
                this.editIpRange = function (ipRange) {
                    _this.$state.go('editiprange', { ipRangeId: ipRange.Id }, { location: 'replace' });
                };
                this.removeIpRange = function (ipRange) {
                    var title = _this.getResource("Dialog_DeleteIpRangeTitle");
                    var message = _this.getResource("Message_DeleteIpRangeConfirmation");
                    _this.alerting.confirm(message, title).then(function (result) {
                        if (result) {
                            _this.networkService.deleteIpRange(ipRange.Id).then(function (data) {
                                if (data == true) {
                                    _this.alerting.popInfo(_this.getResource("Message_IpRangeDeleted")).then(function () {
                                        _this.loadIpRanges();
                                    });
                                }
                                else {
                                    _this.alerting.popError(_this.getResource("Message_DeleteIpRangeError"));
                                }
                            });
                        }
                    });
                };
            }
            NetworkController.prototype.$onInit = function () {
                this.activate();
            };
            NetworkController.prototype.activate = function () {
                this.loadIpRanges();
            };
            NetworkController.prototype.loadIpRanges = function () {
                var _this = this;
                this.networkService.getIpRanges().then(function (data) {
                    if (data) {
                        _this.ipRanges = data;
                    }
                });
            };
            NetworkController.prototype.getResource = function (key) {
                return this.localize.getLocalizedString(key, "Network");
            };
            return NetworkController;
        }());
        NetworkController.$inject = ["$scope", "networkService", "alerting", "localize", "$q", "$state"];
        angular
            .module("customer.network")
            .component("network", {
            templateUrl: "/App/network/network.html",
            bindings: {},
            controller: NetworkController
        });
    })(network = customer.network || (customer.network = {}));
})(customer || (customer = {}));
//# sourceMappingURL=network.component.js.map
var customer;
(function (customer) {
    var network;
    (function (network) {
        angular
            .module('customer.network')
            .config(configRoutes);
        function configRoutes($stateProvider, $urlRouterProvider, $locationProvider) {
            $locationProvider.html5Mode(true);
            $stateProvider
                .state('network', {
                url: '/network/manage',
                template: '<network></network>'
            });
            $stateProvider
                .state('newiprange', {
                resolve: {
                    ipRange: function () {
                        return {
                            isNew: true
                        };
                    }
                },
                url: '/network/manage/new',
                template: '<ip-range ip-range="$resolve.ipRange"></ip-range>'
            });
            $stateProvider
                .state('editiprange', {
                resolve: {
                    ipRange: ipRangeProvider
                },
                url: '/network/manage/edit/{ipRangeId}',
                template: '<ip-range ip-range="$resolve.ipRange"></ip-range>'
            });
            ipRangeProvider.$inject = ['networkService', '$stateParams'];
            function ipRangeProvider(networkService, $stateParams) {
                return networkService.getIpRange($stateParams.ipRangeId).then(function (data) { return data; });
            }
        }
    })(network = customer.network || (customer.network = {}));
})(customer || (customer = {}));
//# sourceMappingURL=network.route.js.map
var customer;
(function (customer) {
    var network;
    (function (network) {
        var NetworkService = (function () {
            function NetworkService(dataservice) {
                this.dataservice = dataservice;
            }
            NetworkService.prototype.getIpRanges = function () {
                var url = "/api/portalsettings/ipranges";
                return this.dataservice.getData(url);
            };
            NetworkService.prototype.getIpRange = function (ipRangeId) {
                var url = "/api/portalsettings/iprange/" + encodeURIComponent(ipRangeId);
                return this.dataservice.getData(url);
            };
            NetworkService.prototype.saveIpRange = function (rangeDetails) {
                var url = "/api/portalsettings/ipranges";
                return this.dataservice.putData(url, rangeDetails);
            };
            NetworkService.prototype.deleteIpRange = function (ipRangeId) {
                var url = "/api/portalsettings/iprange/" + encodeURIComponent(ipRangeId);
                return this.dataservice.deleteData(url);
            };
            return NetworkService;
        }());
        NetworkService.$inject = ["dataservice"];
        network.NetworkService = NetworkService;
        angular
            .module("customer.network")
            .service("networkService", NetworkService);
    })(network = customer.network || (customer.network = {}));
})(customer || (customer = {}));
//# sourceMappingURL=network.service.js.map
var customer;
(function (customer) {
    var newRepairment;
    (function (newRepairment) {
        var navigationState = (function () {
            function navigationState(clickable, editable) {
                if (clickable === void 0) { clickable = false; }
                if (editable === void 0) { editable = false; }
                this.clickable = clickable;
                this.editable = editable;
            }
            ;
            return navigationState;
        }());
        ;
        var navigationStates = (function () {
            function navigationStates() {
            }
            return navigationStates;
        }());
        ;
        var controller = (function () {
            function controller($scope, $rootScope, $state) {
                var _this = this;
                this.$scope = $scope;
                this.$rootScope = $rootScope;
                this.$state = $state;
                this.$inject = ["$scope", "$rootScope", "$state"];
                this.trackStateChange = function (event, toState, toParams, fromState, fromParams, options) {
                    _this.currentState = toState.name;
                    _this.trackwizardData(fromState);
                    _this.updateProgressBar(fromState, toState);
                };
                this.states = new navigationStates();
                this.states['newRepairment.objectSelection'] = new navigationState(true);
                this.states['newRepairment.defectSelection'] = new navigationState();
                this.states['newRepairment.costConfirmation'] = new navigationState();
                this.states['newRepairment.defectDescription'] = new navigationState(false, true);
                this.states['newRepairment.contactDetails'] = new navigationState(false, true);
                this.states['newRepairment.requestSubmission'] = new navigationState();
                this.states['newRepairment.appointmentPlanner'] = new navigationState();
            }
            controller.prototype.$onInit = function () {
                this.activate();
            };
            controller.prototype.activate = function () {
                var _this = this;
                this.unregisterHandler = this.$rootScope.$on('$stateChangeStart', this.trackStateChange);
                this.$scope.$on('$destroy', function () {
                    _this.unregisterHandler();
                });
                this.setIsClickableMethods();
                this.currentState = 'newRepairment.objectSelection';
            };
            controller.prototype.setIsClickableMethods = function () {
                var keys = Object.keys(this.states);
                for (var i = 0; i < keys.length; i++) {
                    this.states[keys[i]].isClickable = this.createIsClickable(keys[i]);
                }
            };
            controller.prototype.createIsClickable = function (stateName) {
                var _this = this;
                return function () {
                    if (_this.states[stateName].clickable !== true) {
                        return false;
                    }
                    var keys = Object.keys(_this.states);
                    var currentIndex = keys.indexOf(stateName);
                    if (currentIndex < keys.length) {
                        for (var i = currentIndex - 1; i >= 0; i--) {
                            if (_this.states[keys[i]].clickable || _this.states[keys[i]].savedState) {
                                var stepName = keys[i].split('.')[1];
                                if (!angular.equals(_this.states[keys[i]].savedState, _this.wizardData[stepName]) && _this.states[keys[i]].editable !== true) {
                                    _this.states[stateName].clickable = false;
                                    delete _this.states[stateName].savedState;
                                    delete _this.wizardData[stateName.split('.')[1]];
                                    return false;
                                }
                            }
                        }
                    }
                    return true;
                };
            };
            controller.prototype.updateProgressBar = function (fromState, toState) {
                var keys = Object.keys(this.states);
                var fromIndex = keys.indexOf(fromState.name);
                var toIndex = keys.indexOf(toState.name);
                if (toIndex == -1) {
                    return;
                }
                if (toIndex != keys.length - 1) {
                    for (var i = fromIndex + 1; i < keys.length; i++) {
                        this.states[keys[i]].clickable = (this.states[keys[i]].savedState !== undefined);
                    }
                }
                else {
                    for (var i = 0; i < toIndex; i++) {
                        this.states[keys[i]].clickable = false;
                    }
                }
                this.states[toState.name].clickable = true;
            };
            controller.prototype.trackwizardData = function (fromState) {
                var stepName = fromState.name.split('.')[1];
                var keys = Object.keys(this.states);
                if (this.states[fromState.name].savedState && !this.states[fromState.name].editable) {
                    if (!angular.equals(this.states[fromState.name].savedState, this.wizardData[stepName])) {
                        var fromIndex = keys.indexOf(fromState.name);
                        for (var i = fromIndex + 1; i < keys.length; i++) {
                            delete this.states[keys[i]].savedState;
                            var keyStep = keys[i].split('.')[1];
                            delete this.wizardData[keyStep];
                        }
                    }
                }
                this.states[fromState.name].savedState = JSON.parse(JSON.stringify(this.wizardData[stepName]));
            };
            return controller;
        }());
        angular
            .module('customer.newRepairment')
            .component('newRepairment', {
            bindings: {
                wizardData: '='
            },
            controller: controller,
            templateUrl: '/App/newRepairment/newRepairmentWizard.html',
        });
    })(newRepairment = customer.newRepairment || (customer.newRepairment = {}));
})(customer || (customer = {}));
//# sourceMappingURL=newRepairment.component.js.map
var customer;
(function (customer) {
    var newRepairment;
    (function (newRepairment) {
        angular
            .module('customer.newRepairment')
            .config(configRoutes);
        function configRoutes($stateProvider, $urlRouterProvider, $locationProvider) {
            $locationProvider.html5Mode(true);
            var newRepairmentState = {
                abstract: true,
                name: 'newRepairment',
                url: '/repairments/new',
                template: '<new-repairment wizard-data="$resolve.wizardData"></new-repairment>',
                resolve: {
                    wizardData: function () {
                        return {};
                    }
                },
                portalModule: 'MaintenanceOrders'
            };
            $stateProvider
                .state('newRepairment', newRepairmentState)
                .state('newRepairment.objectSelection', {
                url: '/',
                template: '<object-selection wizard-data="$resolve.wizardData"></object-selection>'
            })
                .state('newRepairment.defectSelection', {
                url: '/',
                template: '<defect-selection wizard-data="$resolve.wizardData"></defect-selection>'
            })
                .state('newRepairment.costConfirmation', {
                url: '/',
                template: '<cost-confirmation wizard-data="$resolve.wizardData"></cost-confirmation>'
            })
                .state('newRepairment.defectDescription', {
                url: '/',
                template: '<defect-description wizard-data="$resolve.wizardData"></defect-description>'
            })
                .state('newRepairment.contactDetails', {
                url: '/',
                template: '<contact-details wizard-data="$resolve.wizardData"></contact-details>'
            })
                .state('newRepairment.requestSubmission', {
                url: '/',
                template: '<request-submission wizard-data="$resolve.wizardData"></request-submission>'
            })
                .state('newRepairment.appointmentPlanner', {
                url: '/',
                template: '<appointment-planner wizard-data="$resolve.wizardData"></appointment-planner>'
            });
        }
    })(newRepairment = customer.newRepairment || (customer.newRepairment = {}));
})(customer || (customer = {}));
//# sourceMappingURL=newRepairment.route.js.map
var customer;
(function (customer) {
    var newRepairment;
    (function (newRepairment) {
        var controller = (function () {
            function controller($scope, $uibModalInstance, model) {
                var _this = this;
                this.$scope = $scope;
                this.$uibModalInstance = $uibModalInstance;
                this.model = model;
                this.$inject = ['$scope', '$uibModalInstance', 'model'];
                this.onRequestSubmitted = function (event, args) {
                    _this.model.MaintenanceRequestSubmitted = !args.error;
                    _this.errors = args.error;
                    _this.showFooter = args.error || (!_this.hasImages() && !_this.updatesCustomerDetails());
                    _this.model.MaintenanceRequestMessage = args.message;
                };
                this.onImagesUploaded = function (event, args) {
                    _this.model.ImagesUploaded = true;
                    _this.errors = _this.errors || args.error;
                    _this.showFooter = _this.errors || !_this.updatesCustomerDetails();
                    _this.model.ImageUploadMessage = args.message;
                };
                this.onUpdateCustomerDetails = function (event, args) {
                    _this.showFooter = true;
                    _this.errors = _this.errors || args.error;
                    _this.model.UpdateCustomerDetailsMessage = args.message;
                };
            }
            controller.prototype.$onInit = function () {
                this.activate();
            };
            controller.prototype.activate = function () {
                this.model.ImageUploadMessage = '';
                this.model.MaintenanceRequestMessage = '';
                this.model.UpdateCustomerDetailsMessage = '';
                this.errors = false;
                this.showFooter = false;
                this.$scope.$on('maintenanceRequest.progress.request', this.onRequestSubmitted);
                this.$scope.$on('maintenanceRequest.progress.image', this.onImagesUploaded);
                this.$scope.$on('maintenanceRequest.progress.updateCustomerDetails', this.onUpdateCustomerDetails);
            };
            controller.prototype.hasImages = function () {
                return !!this.model.MaintenanceRequestSubmitted &&
                    !!this.model.ImageCount &&
                    this.model.ImageCount > 0;
            };
            controller.prototype.updatesCustomerDetails = function () {
                return !!this.model.MaintenanceRequestSubmitted &&
                    !!this.model.UpdateCustomerDetails &&
                    this.model.UpdateCustomerDetails;
            };
            controller.prototype.requestSubmitted = function () {
                return typeof this.model.MaintenanceRequestSubmitted !== "undefined";
            };
            controller.prototype.imagesUploaded = function () {
                return this.model.ImagesUploaded;
            };
            controller.prototype.close = function () {
                this.$uibModalInstance.close({ error: this.errors });
            };
            return controller;
        }());
        angular.module('customer.newRepairment')
            .controller('progressDialogController', controller);
    })(newRepairment = customer.newRepairment || (customer.newRepairment = {}));
})(customer || (customer = {}));
//# sourceMappingURL=progressDialog.controller.js.map
var customer;
(function (customer) {
    var newRepairment;
    (function (newRepairment) {
        var progressDialogService = (function () {
            function progressDialogService($rootScope, $uibModal) {
                this.$rootScope = $rootScope;
                this.$uibModal = $uibModal;
                this.$inject = ['$rootScope', '$uibModal'];
            }
            progressDialogService.prototype.show = function (model) {
                var options = {
                    backdrop: 'static',
                    templateUrl: '/App/newRepairment/progressDialog.html',
                    size: "lg",
                    controllerAs: '$ctrl',
                    controller: 'progressDialogController',
                    resolve: {
                        model: model
                    }
                };
                return this.$uibModal.open(options).result;
            };
            return progressDialogService;
        }());
        newRepairment.progressDialogService = progressDialogService;
        angular.module('customer.newRepairment').factory('progressDialogService', ['$rootScope', '$uibModal', function ($rootScope, $uibModal) {
                return new progressDialogService($rootScope, $uibModal);
            }]);
    })(newRepairment = customer.newRepairment || (customer.newRepairment = {}));
})(customer || (customer = {}));
;
//# sourceMappingURL=progressDialog.service.js.map
var customer;
(function (customer) {
    var newTimelineAction;
    (function (newTimelineAction) {
        var controller = (function () {
            function controller($rootScope, timelineService, contractService, $timeout, localize, alerting, $state) {
                var _this = this;
                this.$rootScope = $rootScope;
                this.timelineService = timelineService;
                this.contractService = contractService;
                this.$timeout = $timeout;
                this.localize = localize;
                this.alerting = alerting;
                this.$state = $state;
                this.externalPage = false;
                this.addNewInteraction = false;
                this.processing = false;
                this.$inject = ['$rootScope', 'timelineService', 'contractService', '$timeout', 'localize', 'alerting', '$state'];
                this.getCustomerDetailsCallback = function (data) {
                    if (data.success === true) {
                        _this.customerDetails = data.data;
                        if (_this.customerDetails.ActiveContracts.length == 1) {
                            _this.selectTheFirstActiveContract();
                        }
                    }
                    else {
                        var message = _this.localize.getLocalizedString('Message_FailedToLoadCustomerDetails', 'MyDetails');
                        _this.alerting.popError(message);
                    }
                };
                this.getInteractionTemplatesCallback = function (data) {
                    if (data.success === true) {
                        _this.interactionSubjects = data.data;
                    }
                    else {
                        var message = _this.localize.getLocalizedString('Message_FailedToLoadTemplates', 'MyTimeline');
                        _this.alerting.popError(message);
                    }
                };
                this.contractChanged = function () {
                    angular.forEach(_this.customerDetails.ActiveContracts, function (val) {
                        if (val.RentalUnit.No == _this.newInteraction.RealtyObjectNo) {
                            _this.newInteraction.CompanyName = val.CompanyName;
                        }
                    });
                };
                this.saveNewInteraction = function (newForm) {
                    if (newForm.$invalid) {
                        return;
                    }
                    _this.processing = true;
                    _this.timelineService.saveNewInteraction(_this.newInteraction).then(function (data) {
                        if (data.success === true) {
                            var message = _this.localize.getLocalizedString('Message_ActionCreated', 'MyTimeline');
                            _this.alerting.popInfo(message);
                            _this.$rootScope.$broadcast("newTimelineAction_Added");
                            if (_this.externalPage) {
                                _this.$state.go('myTimeline');
                            }
                        }
                        else {
                            var message = _this.localize.getLocalizedString('Message_FailedToSendAction', 'MyTimeline');
                            _this.alerting.popError(message);
                        }
                        _this.resetForm(newForm);
                        _this.processing = false;
                    });
                };
                this.cancelNewInteraction = function (newForm) {
                    _this.addNewInteraction = false;
                    _this.newInteraction = new customer.newTimelineAction.models.newInteraction();
                    _this.resetForm(newForm);
                    _this.$rootScope.$broadcast("newTimelineAction_Canceled");
                };
                this.resetForm = function (form) {
                    _this.$timeout(function () {
                        _this.newInteraction = new customer.newTimelineAction.models.newInteraction();
                        form.$setPristine();
                        form.$setUntouched();
                        if (_this.customerDetails.ActiveContracts.length == 1) {
                            _this.selectTheFirstActiveContract();
                        }
                    }, 500);
                };
                this.adjustFeedbackPosition = function () {
                    $('textarea[name="userComment"]').on('keyup', function () {
                        var $feedbackIcon = $(this).next('.form-control-feedback');
                        if (this.clientHeight < this.scrollHeight) {
                            $feedbackIcon.css('right', '15px');
                        }
                        else {
                            $feedbackIcon.css('right', '0');
                        }
                    });
                };
                this.selectTheFirstActiveContract = function () {
                    _this.newInteraction.RealtyObjectNo = _this.customerDetails.ActiveContracts[0].RentalUnit.No;
                    _this.contractChanged();
                };
                if ($state.current.data && $state.current.data.hideCancelButton) {
                    this.hideCancelButton = $state.current.data.hideCancelButton;
                }
                if ($state.current.data && $state.current.data.externalPage) {
                    this.externalPage = true;
                }
                this.newInteraction = new customer.newTimelineAction.models.newInteraction();
                this.customerDetails = new core.models.CustomerDetails();
                this.activate();
            }
            controller.prototype.activate = function () {
                this.contractService.getCustomerDetails().then(this.getCustomerDetailsCallback);
                this.timelineService.getInteractionTemplates().then(this.getInteractionTemplatesCallback);
                this.$timeout(this.adjustFeedbackPosition, 500, false);
            };
            return controller;
        }());
        angular
            .module('customer.newTimelineAction')
            .component('newTimelineAction', {
            controller: controller,
            templateUrl: '/App/newTimelineAction/newTimelineAction.html'
        });
    })(newTimelineAction = customer.newTimelineAction || (customer.newTimelineAction = {}));
})(customer || (customer = {}));
//# sourceMappingURL=newTimelineAction.component.js.map
var customer;
(function (customer) {
    var newTimelineAction;
    (function (newTimelineAction) {
        angular
            .module('customer.newTimelineAction')
            .config(configRoutes);
        function configRoutes($stateProvider, $urlRouterProvider, $locationProvider) {
            $locationProvider.html5Mode(true);
            var newTimelineActionRoute = {
                name: 'newTimelineAction',
                url: '/newTimelineAction',
                template: '<new-timeline-action></new-timeline-action>',
                data: {
                    hideCancelButton: true,
                    externalPage: true
                },
                portalModule: 'OtherActions'
            };
            $stateProvider
                .state('newTimelineAction', newTimelineActionRoute);
        }
    })(newTimelineAction = customer.newTimelineAction || (customer.newTimelineAction = {}));
})(customer || (customer = {}));
//# sourceMappingURL=newTimelineAction.route.js.map
var customer;
(function (customer) {
    var news;
    (function (news) {
        var controller = (function () {
            function controller(newsService) {
                var _this = this;
                this.newsService = newsService;
                this.news = [];
                this.totalNewsItems = 0;
                this.page = 1;
                this.newsLoaded = false;
                this.isLoadingMore = false;
                this.$inject = ['newsService'];
                this.loadMore = function () {
                    if (_this.isLoadingMore)
                        return;
                    if (_this.news.length < _this.totalNewsItems && !_this.isLoadingMore) {
                        _this.isLoadingMore = true;
                        return _this.newsService.getNews(10, _this.page, true).then(function (data) {
                            Array.prototype.push.apply(_this.news, data.rows);
                            _this.totalNewsItems = data.results;
                            _this.isLoadingMore = false;
                            _this.page++;
                        });
                    }
                };
                this.activate();
            }
            controller.prototype.activate = function () {
                var _this = this;
                this.newsService.getNews(10, this.page, true).then(function (data) {
                    _this.news = JSON.parse(JSON.stringify(data.rows));
                    _this.totalNewsItems = data.results;
                    _this.page++;
                    _this.newsLoaded = true;
                });
            };
            return controller;
        }());
        angular
            .module('customer.news')
            .component('news', {
            templateUrl: '/App/news/news.html',
            bindings: {},
            controller: controller
        });
    })(news = customer.news || (customer.news = {}));
})(customer || (customer = {}));
//# sourceMappingURL=news.component.js.map
var customer;
(function (customer) {
    var news;
    (function (news) {
        angular
            .module('customer.news')
            .config(configRoutes);
        function configRoutes($stateProvider, $urlRouterProvider, $locationProvider) {
            $locationProvider.html5Mode(true);
            var newsRoute = {
                url: '/news',
                template: '<news></news>',
                name: 'news',
                portalModule: 'News'
            };
            $stateProvider
                .state('news', newsRoute);
        }
    })(news = customer.news || (customer.news = {}));
})(customer || (customer = {}));
//# sourceMappingURL=news.route.js.map
var customer;
(function (customer) {
    var news;
    (function (news) {
        var newsService = (function () {
            function newsService(dataservice) {
                this.dataservice = dataservice;
                this.$inject = ['dataservice'];
            }
            newsService.prototype.getNews = function (count, page, content) {
                var url = '/api/news?count=' + count + '&page=' + page + '&content=' + content;
                return this.dataservice.getData(url);
            };
            newsService.prototype.getNewsItem = function (id) {
                var url = '/api/news/' + id;
                return this.dataservice.getData(url);
            };
            return newsService;
        }());
        news.newsService = newsService;
        angular
            .module('customer.news')
            .service('newsService', newsService);
    })(news = customer.news || (customer.news = {}));
})(customer || (customer = {}));
//# sourceMappingURL=news.service.js.map
var customer;
(function (customer) {
    var newsDetails;
    (function (newsDetails) {
        var controller = (function () {
            function controller($stateParams, $window, newsService) {
                var _this = this;
                this.$stateParams = $stateParams;
                this.$window = $window;
                this.newsService = newsService;
                this.$inject = ['$stateParams', '$window', 'newsService'];
                this.goBack = function () {
                    _this.$window.history.back();
                };
                this.parseUrl = function (url) {
                    if (url && url.indexOf('http') !== 0) {
                        url = 'http://' + url;
                    }
                    return url;
                };
                this.newsItemId = $stateParams.itemId;
                this.newsItem = $stateParams.newsItem;
                this.activate();
            }
            controller.prototype.activate = function () {
                var _this = this;
                if (!this.newsItem && this.newsItemId) {
                    this.newsService.getNewsItem(this.newsItemId).then(function (data) {
                        _this.newsItem = data.data;
                    });
                }
            };
            return controller;
        }());
        angular
            .module('customer.newsDetails')
            .component('newsDetails', {
            controller: controller,
            bindings: {},
            templateUrl: '/App/newsDetails/newsDetails.html'
        });
    })(newsDetails = customer.newsDetails || (customer.newsDetails = {}));
})(customer || (customer = {}));
//# sourceMappingURL=newsDetails.component.js.map
var customer;
(function (customer) {
    var newsDetails;
    (function (newsDetails) {
        angular
            .module('customer.newsDetails')
            .config(configRoutes);
        function configRoutes($stateProvider, $urlRouterProvider, $locationProvider) {
            $locationProvider.html5Mode(true);
            var newsDetailsRoute = {
                url: '/news/details/:itemId',
                params: {
                    newsItem: null,
                    itemId: null
                },
                template: '<news-details></news-details>',
                name: 'newsDetails',
                portalModule: 'News'
            };
            $stateProvider
                .state('newsDetails', newsDetailsRoute);
        }
    })(newsDetails = customer.newsDetails || (customer.newsDetails = {}));
})(customer || (customer = {}));
//# sourceMappingURL=newsDetails.route.js.map
var customer;
(function (customer) {
    var pageNotFound;
    (function (pageNotFound) {
        var controller = (function () {
            function controller() {
            }
            return controller;
        }());
        angular
            .module('customer.pageNotFound')
            .component('pageNotFound', {
            controller: controller,
            templateUrl: '/App/pageNotFound/pageNotFound.html'
        });
    })(pageNotFound = customer.pageNotFound || (customer.pageNotFound = {}));
})(customer || (customer = {}));
//# sourceMappingURL=pageNotFound.component.js.map
var customer;
(function (customer) {
    var pageNotFound;
    (function (pageNotFound) {
        angular
            .module('customer.pageNotFound')
            .config(configRoutes);
        function configRoutes($stateProvider, $urlRouterProvider, $locationProvider) {
            $locationProvider.html5Mode(true);
            $stateProvider
                .state('pageNotFound', {
                url: '*path',
                template: '<page-not-found></page-not-found>'
            });
        }
    })(pageNotFound = customer.pageNotFound || (customer.pageNotFound = {}));
})(customer || (customer = {}));
//# sourceMappingURL=pageNotFound.route.js.map
var customer;
(function (customer) {
    var paymentArrangement;
    (function (paymentArrangement) {
        var controller = (function () {
            function controller($filter, $state, $stateParams, paymentArrangementService, outstandingBalanceService, localize, alerting, cpMath, dueDateService) {
                var _this = this;
                this.$filter = $filter;
                this.$state = $state;
                this.$stateParams = $stateParams;
                this.paymentArrangementService = paymentArrangementService;
                this.outstandingBalanceService = outstandingBalanceService;
                this.localize = localize;
                this.alerting = alerting;
                this.cpMath = cpMath;
                this.dueDateService = dueDateService;
                this.totalAmount = 0;
                this.openInvoices = [];
                this.selectedInvoices = [];
                this.selectedCompanyName = null;
                this.selectedRealtyObjectNo = null;
                this.selectedTemplateCode = null;
                this.selectedTemplate = null;
                this.installmentAmount = null;
                this.numberOfInstallments = null;
                this.processing = false;
                this.onPreviousClick = function () {
                    _this.$state.go('paymentArrangementStart', { selectedInvoices: _this.selectedInvoices });
                };
            }
            controller.prototype.$onInit = function () {
                this.activate();
            };
            controller.prototype.activate = function () {
                if (this.$stateParams.shouldTransitionToState) {
                    this.$state.go(this.$stateParams.shouldTransitionToState);
                    return;
                }
                if (this.$stateParams.wizardPage == 'Start') {
                    this.activateStartWizardPage();
                }
                else {
                    this.activateFinishWizardPage();
                }
            };
            controller.prototype.activateStartWizardPage = function () {
                var _this = this;
                this.totalAmount = 0;
                this.selectedInvoices = this.$stateParams.selectedInvoices ? this.$stateParams.selectedInvoices : [];
                this.outstandingBalanceService.getOutstandingBalance().then(function (response) {
                    if (response.success === false) {
                        var message = _this.getResourceString('Message_FailedToLoadInvoiceDetails');
                        _this.alerting.popError(message);
                        return;
                    }
                    _this.openInvoices = response.data.Invoices;
                    if (_this.openInvoices) {
                        _this.selectInvoicesByEntryNo();
                        _this.openInvoices.sort(function (a, b) {
                            return Date.parse(a.DueDate) - Date.parse(b.DueDate);
                        });
                        _this.populateExtendedInfoArray();
                    }
                });
            };
            controller.prototype.activateFinishWizardPage = function () {
                var _this = this;
                this.selectedInvoices = this.$stateParams.selectedInvoices;
                this.selectedCompanyName = this.$stateParams.companyName;
                this.selectedRealtyObjectNo = this.$stateParams.realtyObjectNo;
                this.totalAmount = this.$stateParams.totalAmount;
                if (!this.selectedInvoices || !this.selectedCompanyName || !this.totalAmount) {
                    this.$state.go('paymentArrangementStart', { selectedInvoices: this.selectedInvoices });
                    return;
                }
                this.paymentArrangementService.getPaymentSchemeTemplates(this.selectedCompanyName, this.selectedRealtyObjectNo, this.totalAmount).then(function (response) {
                    if (!response.success) {
                        var message;
                        if (response.data && response.data.code === "NotFound") {
                            message = _this.getResourceString('Message_NoTemplateFound');
                        }
                        else {
                            message = _this.getResourceString('Message_FailedToLoadTemplates');
                        }
                        _this.alerting
                            .popError(message)
                            .then(_this.onPreviousClick)
                            .catch(_this.onPreviousClick);
                        return;
                    }
                    _this.templates = response.data;
                    if (_this.templates.length == 1) {
                        _this.selectedTemplateCode = _this.templates[0].Code;
                        _this.onTemplateChange();
                    }
                });
            };
            controller.prototype.onNextClick = function () {
                this.$state.go('paymentArrangementFinish', {
                    selectedInvoices: this.selectedInvoices,
                    companyName: this.selectedCompanyName,
                    realtyObjectNo: this.selectedRealtyObjectNo,
                    totalAmount: this.totalAmount
                });
            };
            controller.prototype.onCancelClick = function () {
                this.$state.go("myPayments");
            };
            controller.prototype.onCreateClick = function (form) {
                var _this = this;
                if (form.$invalid) {
                    return;
                }
                var arrangement = {
                    TotalAmount: this.totalAmount,
                    Terms: this.numberOfInstallments,
                    TemplateCode: this.selectedTemplate.Code,
                    Invoices: this.selectedInvoices
                };
                if (!this.processing) {
                    this.processing = true;
                    this.paymentArrangementService.createPaymentArrangement(this.selectedCompanyName, arrangement).then(function (response) {
                        _this.processing = false;
                        if (!response || !response.success) {
                            _this.alerting.popError(_this.getResourceString("Message_CreateArrangementFailed"));
                        }
                        else {
                            var template_1 = null;
                            angular.forEach(_this.templates, function (t) {
                                if (t.Code === arrangement.TemplateCode) {
                                    template_1 = t;
                                }
                            });
                            if (!template_1.ImmediateActivation) {
                                _this.alerting.popInfo(_this.getResourceString("Message_CreateArrangementSucceeded"));
                            }
                            else {
                                _this.paymentArrangementService
                                    .activatePaymentArrangement(_this.selectedCompanyName, template_1.Code, response.data)
                                    .then(function (res) {
                                    if (!res || !res.success) {
                                        _this.alerting.popError(_this.getResourceString("Message_CreateArrangementSucceededButActivationFailed"));
                                    }
                                    else {
                                        _this.alerting.popInfo(_this.getResourceString("Message_ArrangementCreatedAndActivatedSuccessfully"));
                                    }
                                });
                            }
                            _this.$state.go("myPayments");
                        }
                    });
                }
            };
            controller.prototype.onCheckChange = function (item) {
                if (item.selected) {
                    this.disableInvoicesForOtherContracts(item.RealtyObjectNo);
                }
                else {
                    this.enableInvoices();
                }
                this.updateSecondPageParams();
            };
            controller.prototype.onTemplateChange = function (form) {
                var _this = this;
                this.numberOfInstallments = null;
                this.installmentAmount = null;
                if (form) {
                    form.$setPristine();
                    form.$setUntouched();
                }
                angular.forEach(this.templates, function (template) {
                    if (template.Code == _this.selectedTemplateCode) {
                        _this.selectedTemplate = template;
                    }
                });
            };
            controller.prototype.onNumberOfInstallmentsChange = function () {
                this.installmentAmount = this.calculateInstallmentAmount(this.totalAmount, this.numberOfInstallments);
            };
            controller.prototype.calculateInstallmentAmount = function (totalAmount, numberOfInstallments) {
                if (numberOfInstallments == 1) {
                    return totalAmount;
                }
                return this.cpMath.roundNumberUp(totalAmount / numberOfInstallments, 2);
            };
            controller.prototype.populateExtendedInfoArray = function () {
                var _this = this;
                this.extendedInfoItems = {};
                angular.forEach(this.openInvoices, function (value) {
                    _this.extendedInfoItems[value.EntryNo] = _this.extendedInfo(value);
                });
            };
            controller.prototype.extendedInfo = function (item) {
                var keyValues = {};
                keyValues[this.getResourceString('Label_Period')] = new core.models.keyValues.keyValue(item.Description);
                var contract = item.Address;
                if (!contract || contract.length === 0) {
                    contract = this.getResourceString('Label_None');
                }
                keyValues[this.getResourceString('Label_Contract')] = new core.models.keyValues.keyValue(contract);
                keyValues[this.getResourceString('Label_Original_Amount')] = new core.models.keyValues.keyValue(this.$filter('number')(item.OriginalAmount, 2), 'currency');
                keyValues[this.getResourceString('Label_Due')] = new core.models.keyValues.keyValue(this.$filter('date')(item.DueDate, 'dd-MM-yyyy') + this.dueDateService.getDueHtml(item.DueDate));
                keyValues[this.getResourceString('Label_Received_Amount')] = new core.models.keyValues.keyValue(this.$filter('number')(item.PaymentReceivedAmount, 2), 'currency');
                keyValues[this.getResourceString('Label_Open_Amount')] = new core.models.keyValues.keyValue(this.$filter('number')(item.OutstandingAmount, 2), 'currency');
                keyValues[this.getResourceString('Label_Payment_Underway_Amount')] = new core.models.keyValues.keyValue(this.$filter('number')(item.PaymentUnderwayAmount, 2), 'currency');
                keyValues[this.getResourceString('Label_Online_Payment_Not_Payed_Amount')] = new core.models.keyValues.keyValue(this.$filter('number')(item.OnlinePaymentNotPayed, 2), 'currency');
                return keyValues;
            };
            controller.prototype.updateSecondPageParams = function () {
                var _this = this;
                this.totalAmount = 0;
                this.selectedInvoices = [];
                this.selectedCompanyName = null;
                this.selectedRealtyObjectNo = "";
                if (this.openInvoices) {
                    this.openInvoices.forEach(function (el) {
                        if (el.selected === true) {
                            _this.totalAmount = _this.cpMath.sum(_this.totalAmount, el.OnlinePaymentMaximumAmount || 0);
                            _this.selectedInvoices.push({ EntryNo: el.EntryNo, DocumentNo: el.DocumentNo });
                            _this.selectedCompanyName = el.CompanyName;
                            if (el.RealtyObjectNo) {
                                _this.selectedRealtyObjectNo = el.RealtyObjectNo;
                            }
                        }
                    });
                }
            };
            controller.prototype.disableInvoicesForOtherContracts = function (realtyObjectNo) {
                if (realtyObjectNo) {
                    this.openInvoices.forEach(function (elem) {
                        if (elem.RealtyObjectNo) {
                            elem.disabled = elem.RealtyObjectNo !== realtyObjectNo;
                        }
                    });
                }
            };
            controller.prototype.enableInvoices = function () {
                var isLastSelectedWithRealtyObject = true;
                this.openInvoices.forEach(function (elem) {
                    if (elem.selected && elem.RealtyObjectNo) {
                        isLastSelectedWithRealtyObject = false;
                    }
                });
                if (isLastSelectedWithRealtyObject) {
                    this.openInvoices.forEach(function (elem) {
                        elem.disabled = false;
                    });
                }
            };
            controller.prototype.selectInvoicesByEntryNo = function () {
                var _this = this;
                this.openInvoices.forEach(function (invoice) {
                    invoice.selected = false;
                    _this.selectedInvoices.forEach(function (selectedInvoice) {
                        if (selectedInvoice.EntryNo === invoice.EntryNo) {
                            invoice.selected = true;
                        }
                    });
                });
                this.openInvoices.forEach(function (invoice) {
                    if (invoice.selected) {
                        _this.onCheckChange(invoice);
                    }
                });
            };
            controller.prototype.filterNumberOfInstallments = function (remainingAmountOption) {
                var _this = this;
                return function (item) {
                    if (remainingAmountOption !== core.constants.paymentArrangement.remainingAmount.asAnExtraTerm) {
                        return true;
                    }
                    var amountPerInstallment = _this.calculateInstallmentAmount(_this.totalAmount, item);
                    if (_this.totalAmount < item * amountPerInstallment) {
                        return false;
                    }
                    return true;
                };
            };
            controller.prototype.translateTransactionCode = function (transactionCode) {
                var dictionary = {
                    "INCHUUR": "Text_TransactionMethod_DirectDebit",
                    "OLAHUUR": "Text_TransactionMethod_Giro"
                };
                if (transactionCode === undefined) {
                    return "";
                }
                var value = dictionary[transactionCode];
                if (!value) {
                    value = "Text_TransactionMethod_PaySelf";
                }
                return this.getResourceString(value);
            };
            controller.prototype.translateRemainingAmountOption = function (remainingAmountOption) {
                var dictionary = {
                    0: "Text_RemainingAmount_N/A",
                    1: "Text_RemainingAmount_AsAnExtraTerm",
                    2: "Text_RemainingAmount_SettleWithFirstTerm",
                    3: "Text_RemainingAmount_SettleWithLastTerm"
                };
                var value = dictionary[remainingAmountOption];
                if (!value) {
                    return "";
                }
                return this.getResourceString(value);
            };
            controller.prototype.getResourceString = function (key) {
                return this.localize.getLocalizedString(key, "PaymentArrangement");
            };
            return controller;
        }());
        controller.$inject = ['$filter', '$state', '$stateParams', 'paymentArrangementService', 'outstandingBalanceService', 'localize', 'alerting', 'cpMath', 'dueDateService'];
        angular
            .module('customer.paymentArrangement')
            .component('paymentArrangementWizardStart', {
            controller: controller,
            templateUrl: '/App/paymentArrangement/paymentArrangementWizardStart.html'
        });
        angular
            .module('customer.paymentArrangement')
            .component('paymentArrangementWizardFinish', {
            controller: controller,
            templateUrl: '/App/paymentArrangement/paymentArrangementWizardFinish.html'
        });
    })(paymentArrangement = customer.paymentArrangement || (customer.paymentArrangement = {}));
})(customer || (customer = {}));
//# sourceMappingURL=paymentArrangement.component.js.map
var customer;
(function (customer) {
    var paymentArrangement;
    (function (paymentArrangement_1) {
        angular
            .module('customer.paymentArrangement')
            .config(configRoutes);
        function configRoutes($stateProvider, $urlRouterProvider, $locationProvider) {
            var paymentArrangementStartState = {
                url: '/paymentArrangementWizardStart',
                template: '<payment-arrangement-wizard-start></payment-arrangement-wizard-start>',
                portalModule: 'PaymentSchemes',
                params: {
                    selectedInvoices: null,
                    wizardPage: 'Start',
                    shouldTransitionToState: null
                },
                resolve: {
                    paymentArrangements: paymentArrangementProvider
                },
                onEnter: checkStateChangePreconditions
            };
            var paymentArrangementFinishState = {
                url: '/paymentArrangementWizardFinish',
                template: '<payment-arrangement-wizard-finish></payment-arrangement-wizard-finish>',
                portalModule: 'PaymentSchemes',
                params: {
                    selectedInvoices: null,
                    companyName: null,
                    realtyObjectNo: null,
                    totalAmount: null,
                    wizardPage: 'Finish',
                    shouldTransitionToState: null
                },
                resolve: {
                    paymentArrangements: paymentArrangementProvider
                },
                onEnter: checkStateChangePreconditions
            };
            $locationProvider.html5Mode(true);
            $stateProvider
                .state('paymentArrangementStart', paymentArrangementStartState)
                .state('paymentArrangementFinish', paymentArrangementFinishState);
            paymentArrangementProvider.$inject = ['paymentArrangementService'];
            function paymentArrangementProvider(paymentArrangementService) {
                return paymentArrangementService.getPaymentArrangements().then(function (response) {
                    return response.data;
                });
            }
            checkStateChangePreconditions.$inject = ['paymentArrangements', 'alerting', 'localize', '$stateParams'];
            function checkStateChangePreconditions(paymentArrangements, alerting, localize, $stateParams) {
                var preconditions = getStateChangePreconditions(paymentArrangements, alerting, localize, $stateParams);
                for (var i = 0; i < preconditions.length; i++) {
                    var condition = preconditions[i];
                    if (!condition.conditionTest()) {
                        condition.testFailedAction();
                        break;
                    }
                }
            }
            function getStateChangePreconditions(paymentArrangements, alerting, localize, $stateParams) {
                var preconditions = [
                    {
                        conditionTest: noCreatedOrActivatedPaymentArrangement,
                        testFailedAction: displayPaymentArrangementExists
                    }
                ];
                return preconditions;
                function noCreatedOrActivatedPaymentArrangement() {
                    var response = true;
                    if (paymentArrangements) {
                        angular.forEach(paymentArrangements, function (paymentArrangement) {
                            if (paymentArrangement.Status === "Created" || paymentArrangement.Status === "Activated") {
                                response = false;
                            }
                        });
                    }
                    return response;
                }
                function displayPaymentArrangementExists() {
                    var message = localize.getLocalizedString('Message_PaymentArrangementExists', 'PaymentArrangement');
                    alerting.popError(message);
                    $stateParams.shouldTransitionToState = 'myPayments';
                }
            }
        }
    })(paymentArrangement = customer.paymentArrangement || (customer.paymentArrangement = {}));
})(customer || (customer = {}));
//# sourceMappingURL=paymentArrangement.route.js.map
var customer;
(function (customer) {
    var paymentArrangement;
    (function (paymentArrangement) {
        var paymentArrangementService = (function () {
            function paymentArrangementService(dataservice) {
                this.dataservice = dataservice;
                this.$inject = ['dataservice'];
            }
            paymentArrangementService.prototype.getPaymentSchemeTemplates = function (companyName, realtyUnitNo, amount) {
                var url = "/api/paymentschemes/templates/" + companyName + "?amount=" + amount;
                if (realtyUnitNo) {
                    url += "&realtyUnitNo=" + realtyUnitNo;
                }
                return this.dataservice.getData(url, false);
            };
            paymentArrangementService.prototype.createPaymentArrangement = function (companyName, arrangement) {
                var url = '/api/paymentschemes/' + companyName + '/paymentscheme';
                return this.dataservice.putData(url, arrangement);
            };
            paymentArrangementService.prototype.activatePaymentArrangement = function (companyName, templateCode, paymentSchemeNo) {
                var url = '/api/paymentschemes/' + companyName + '/activate?templateCode=' + templateCode + '&paymentSchemeNo=' + paymentSchemeNo;
                return this.dataservice.postData(url, "");
            };
            paymentArrangementService.prototype.getPaymentArrangements = function () {
                return this.dataservice.getData('/api/paymentarrangements');
            };
            return paymentArrangementService;
        }());
        paymentArrangement.paymentArrangementService = paymentArrangementService;
        angular
            .module('customer.paymentArrangement')
            .service('paymentArrangementService', paymentArrangementService);
    })(paymentArrangement = customer.paymentArrangement || (customer.paymentArrangement = {}));
})(customer || (customer = {}));
//# sourceMappingURL=paymentArrangement.service.js.map
var customer;
(function (customer) {
    var portalDown;
    (function (portalDown) {
        var controller = (function () {
            function controller() {
            }
            return controller;
        }());
        angular
            .module('customer.portalDown')
            .component('portalDown', {
            controller: controller,
            templateUrl: '/App/portalDown/portalDown.html'
        });
    })(portalDown = customer.portalDown || (customer.portalDown = {}));
})(customer || (customer = {}));
//# sourceMappingURL=portalDown.component.js.map
var customer;
(function (customer) {
    var portalDown;
    (function (portalDown) {
        angular
            .module('customer.portalDown')
            .config(configRoutes);
        function configRoutes($stateProvider, $urlRouterProvider, $locationProvider) {
            $locationProvider.html5Mode(true);
            $stateProvider
                .state('portalDown', {
                url: '/portalDown',
                template: '<portal-down></portal-down>'
            });
        }
    })(portalDown = customer.portalDown || (customer.portalDown = {}));
})(customer || (customer = {}));
//# sourceMappingURL=portalDown.route.js.map
var customer;
(function (customer) {
    var portalSettings;
    (function (portalSettings_1) {
        var portalSettings = (function () {
            function portalSettings(portalSettingsService, alerting, localize, $scope, $cookies) {
                var _this = this;
                this.portalSettingsService = portalSettingsService;
                this.alerting = alerting;
                this.localize = localize;
                this.$scope = $scope;
                this.$cookies = $cookies;
                this.analyticsEnabled = false;
                this.processing = false;
                this.isConsentRequired = false;
                this.isOuthForMailClickable = false;
                this.googleAnalyticsPattern = new RegExp(/^ua-\d{4,9}-\d{1,4}$/i);
                this.facebookPattern = new RegExp(/^([a-z_0-9]+)$/);
                this.$inject = ['portalSettingsService', 'alerting', 'localize', '$scope', '$cookies'];
                this.savePortalSettings = function (portalSettingsForm) {
                    if (portalSettingsForm.$invalid) {
                        return;
                    }
                    _this.processing = true;
                    var portalSettings = new portalSettings_1.PortalSettings(_this.googleAnalyticsTrackigId, _this.sessionTimeout, _this.persistentTimeout, _this.allowAnonymousMR, _this.UseS2SAuthentication, _this.useOauthForSendingMails, _this.isOnPremise, _this.getDocsFromDmsOnline, _this.facebookAppId, _this.facebookAppSecret, _this.webChatIntegrationId || "", _this.webChatBusinessName || "", hslToHex(_this.webChatBrandColor), hslToHex(_this.webChatConversationColor), hslToHex(_this.webChatActionColor), _this.webChatEnabled);
                    _this.portalSettingsService.savePortalSettings(portalSettings)
                        .then(function (result) {
                        if (result.success) {
                            _this.getPortalSettings(portalSettingsForm);
                            _this.alerting.popInfo(_this.getResourceString("Message_Success_Saving_Portal_Settings"));
                        }
                        else {
                            _this.alerting.popError(_this.getResourceString("Message_Error_Saving_Portal_Settings"));
                        }
                        _this.processing = false;
                    });
                };
                this.cancel = function (portalSettingsForm) {
                    _this.getPortalSettings(portalSettingsForm);
                };
                this.grantConsent = function () {
                    _this.portalSettingsService.grantConsent();
                };
                this.activate();
            }
            portalSettings.prototype.activate = function () {
                this.getPortalSettings(null);
            };
            portalSettings.prototype.getPortalSettings = function (portalSettingsForm) {
                var _this = this;
                this.portalSettingsService.loadPortalSettings().then(function (response) {
                    if (response.success) {
                        _this.googleAnalyticsTrackigId = response.data.GoogleAnalyticsTrackingId;
                        _this.sessionTimeout = response.data.SessionTimeout;
                        _this.persistentTimeout = response.data.PersistentTimeout;
                        _this.allowAnonymousMR = response.data.AllowAnonymousMR;
                        _this.UseS2SAuthentication = response.data.UseS2SAuthentication;
                        _this.useOauthForSendingMails = response.data.UseOauthForSendingMails;
                        _this.isOnPremise = response.data.IsOnpremise;
                        _this.getDocsFromDmsOnline = response.data.GetDocsFromDmsOnline;
                        _this.facebookAppId = response.data.FacebookAppId;
                        _this.facebookAppSecret = response.data.FacebookAppSecret;
                        _this.webChatIntegrationId = response.data.WebChatIntegrationId;
                        _this.webChatBusinessName = response.data.WebChatBusinessName;
                        _this.webChatBrandColor = response.data.WebChatBrandColor;
                        _this.webChatConversationColor = response.data.WebChatConversationColor;
                        _this.webChatActionColor = response.data.WebChatActionColor;
                        _this.webChatEnabled = response.data.WebChatEnabled;
                        _this.analyticsEnabled = (_this.googleAnalyticsTrackigId
                            !== "");
                        _this.initializeOAuthMailSettings();
                        if (portalSettingsForm) {
                            portalSettingsForm.$setPristine();
                            portalSettingsForm.$setUntouched();
                        }
                    }
                    else {
                        _this.alerting.popError(_this.getResourceString("Message_Error_Loading_Portal_Settings"));
                    }
                });
            };
            portalSettings.prototype.getResourceString = function (key) {
                return this.localize.getLocalizedString(key, "PortalSettings");
            };
            portalSettings.prototype.initializeOAuthMailSettings = function () {
                console.log(this.$cookies.get('.Cs'));
                console.log(this.$cookies.get('environment'));
                this.consentGrantedMessage = this.$cookies.get('.Cs');
                if (this.useOauthForSendingMails === true) {
                    this.isConsentRequired = false;
                    this.isOuthForMailClickable = true;
                }
                else {
                    if (this.consentGrantedMessage === null) {
                        this.isConsentRequired = true;
                        this.isOuthForMailClickable = false;
                    }
                    else if (this.consentGrantedMessage === 'cgsucc') {
                        this.isConsentRequired = false;
                        this.isOuthForMailClickable = true;
                    }
                    else {
                        this.isConsentRequired = true;
                        this.isOuthForMailClickable = false;
                    }
                }
            };
            return portalSettings;
        }());
        ;
        angular
            .module('customer.portalSettings')
            .component('portalSettings', {
            controller: portalSettings,
            controllerAs: '$ctrl',
            templateUrl: '/App/portalSettings/portalSettings.html'
        });
    })(portalSettings = customer.portalSettings || (customer.portalSettings = {}));
})(customer || (customer = {}));
;
function hslToHex(hsl) {
    if (!hsl) {
        return "";
    }
    if (hsl.startsWith("#"))
        return hsl.replace("#", "");
    if (!hsl.startsWith("hsl"))
        return hsl;
    var hslRegex = /hsl\(\s*(\d+),\s*(\d+)%,\s*(\d+)%\s*\)/;
    var result = hsl.match(hslRegex);
    if (!result) {
        throw new Error('Invalid HSL format');
    }
    var h = parseInt(result[1], 10);
    var s = parseInt(result[2], 10) / 100;
    var l = parseInt(result[3], 10) / 100;
    var c = (1 - Math.abs(2 * l - 1)) * s;
    var x = c * (1 - Math.abs((h / 60) % 2 - 1));
    var m = l - c / 2;
    var r = 0, g = 0, b = 0;
    if (0 <= h && h < 60) {
        r = c;
        g = x;
        b = 0;
    }
    else if (60 <= h && h < 120) {
        r = x;
        g = c;
        b = 0;
    }
    else if (120 <= h && h < 180) {
        r = 0;
        g = c;
        b = x;
    }
    else if (180 <= h && h < 240) {
        r = 0;
        g = x;
        b = c;
    }
    else if (240 <= h && h < 300) {
        r = x;
        g = 0;
        b = c;
    }
    else if (300 <= h && h < 360) {
        r = c;
        g = 0;
        b = x;
    }
    r = Math.round((r + m) * 255);
    g = Math.round((g + m) * 255);
    b = Math.round((b + m) * 255);
    var toHex = function (n) {
        var hex = n.toString(16);
        return hex.length === 1 ? '0' + hex : hex;
    };
    return "" + toHex(r) + toHex(g) + toHex(b);
}
//# sourceMappingURL=portalSettings.component.js.map
var customer;
(function (customer) {
    var portalSettings;
    (function (portalSettings) {
        angular
            .module('customer.portalSettings')
            .config(configRoutes);
        function configRoutes($stateProvider, $urlRouterProvider, $locationProvider) {
            $locationProvider.html5Mode(true);
            $stateProvider
                .state('portalSettings', {
                url: '/portalsettings',
                template: '<portal-settings></portal-settings>'
            });
        }
    })(portalSettings = customer.portalSettings || (customer.portalSettings = {}));
})(customer || (customer = {}));
//# sourceMappingURL=portalSettings.route.js.map
var customer;
(function (customer) {
    var portalSettings;
    (function (portalSettings_1) {
        var PortalSettings = (function () {
            function PortalSettings(GoogleAnalyticsTrackingId, SessionTimeout, PersistentTimeout, AllowAnonymousMR, UseS2SAuthentication, UseOauthForSendingMails, IsOnPremise, GetDocsFromDmsOnline, FacebookAppId, FacebookAppSecret, webChatIntegrationId, webChatBusinessName, webChatBrandColor, webChatConversationColor, webChatActionColor, webChatEnabled) {
                this.GoogleAnalyticsTrackingId = GoogleAnalyticsTrackingId;
                this.SessionTimeout = SessionTimeout;
                this.PersistentTimeout = PersistentTimeout;
                this.AllowAnonymousMR = AllowAnonymousMR;
                this.UseS2SAuthentication = UseS2SAuthentication;
                this.UseOauthForSendingMails = UseOauthForSendingMails;
                this.IsOnPremise = IsOnPremise;
                this.GetDocsFromDmsOnline = GetDocsFromDmsOnline;
                this.FacebookAppId = FacebookAppId;
                this.FacebookAppSecret = FacebookAppSecret;
                this.webChatIntegrationId = webChatIntegrationId;
                this.webChatBusinessName = webChatBusinessName;
                this.webChatBrandColor = webChatBrandColor;
                this.webChatConversationColor = webChatConversationColor;
                this.webChatActionColor = webChatActionColor;
                this.webChatEnabled = webChatEnabled;
            }
            return PortalSettings;
        }());
        portalSettings_1.PortalSettings = PortalSettings;
        var PortalSettingsService = (function () {
            function PortalSettingsService(dataservice) {
                this.dataservice = dataservice;
                this.$inject = ["dataservice"];
            }
            PortalSettingsService.prototype.savePortalSettings = function (portalSettings) {
                var url = "/api/portalsettings";
                return this.dataservice.postData(url, portalSettings);
            };
            PortalSettingsService.prototype.loadPortalSettings = function () {
                var url = "/api/portalsettings";
                return this.dataservice.getData(url);
            };
            PortalSettingsService.prototype.grantConsent = function () {
                var url = "/emailconsent/grantconsent";
                window.location.href = url;
                return;
            };
            return PortalSettingsService;
        }());
        portalSettings_1.PortalSettingsService = PortalSettingsService;
        angular
            .module("customer.portalSettings")
            .service("portalSettingsService", PortalSettingsService);
    })(portalSettings = customer.portalSettings || (customer.portalSettings = {}));
})(customer || (customer = {}));
//# sourceMappingURL=portalSettings.service.js.map
var customer;
(function (customer) {
    var resourcesManagement;
    (function (resourcesManagement) {
        var controller = (function () {
            function controller($state, $stateParams, resourcesManagementService, localize, alerting, $scope) {
                this.$state = $state;
                this.$stateParams = $stateParams;
                this.resourcesManagementService = resourcesManagementService;
                this.localize = localize;
                this.alerting = alerting;
                this.$scope = $scope;
                this.searchState = new resourcesManagement.searchState();
                this.resourcesFiles = null;
                this.maxTotalItems = Math.pow(2, 53) - 1;
                this.$inject = ['$state', '$stateParams', 'resourcesManagementService', 'localize', 'alerting', '$scope'];
                this.paging = {
                    currentPage: 1,
                    totalItems: this.maxTotalItems,
                    maxSize: core.constants.paging.maxPages,
                    count: core.constants.paging.itemsPerPage,
                    firstText: this.getResource('Paging_FirstText', 'UserManagement'),
                    lastText: this.getResource('Paging_LastText', 'UserManagement'),
                    nextText: this.getResource('Paging_NextText', 'UserManagement'),
                    previousText: this.getResource('Paging_PreviousText', 'UserManagement')
                };
                var mb = 1024 * 1024;
                this.resourcesFileMaxSize = 0.5 * mb;
                this.activate();
            }
            controller.prototype.activate = function () {
                this.$scope.btnClass = "btn btn-primary";
                this.$scope.btnIcon = "";
                this.$scope.btnTitle = this.getResource("Button_Import", "ResourcesManagement");
                this.fileType = ".json";
                this.getViewNames();
                this.restoreSearchState(this.$stateParams.searchState);
                this.search();
            };
            controller.prototype.getViewNames = function () {
                var _this = this;
                return this.resourcesManagementService.getViewNames().then(function (response) {
                    _this.viewNames = response;
                });
            };
            controller.prototype.search = function () {
                var _this = this;
                this.saveCurrentSearchState();
                if (this.gridSelection) {
                    this.gridSelection = null;
                }
                return this.resourcesManagementService.search(this.searchState.searchText, this.searchState.viewName, this.paging.currentPage, this.paging.count).then(function (response) {
                    _this.paging.totalItems = response.results;
                    _this.resources = response.rows;
                });
            };
            controller.prototype.getTotalItems = function () {
                return this.paging.totalItems !== this.maxTotalItems ? this.paging.totalItems : 0;
            };
            controller.prototype.getResource = function (key, viewName, values) {
                return this.localize.getLocalizedString(key, viewName, values);
            };
            controller.prototype.onCheckChange = function (selection) {
                angular.forEach(this.resources, function (resource) {
                    if (resource.Id !== selection.Id) {
                        resource.Selected = false;
                    }
                });
                this.gridSelection = selection;
            };
            controller.prototype.fileSelected = function () {
                var _this = this;
                if (!this.resourcesFiles[0])
                    return;
                var reader = new FileReader();
                try {
                    reader.readAsText(this.resourcesFiles[0]);
                    reader.onload = function () {
                        if (reader.result) {
                            try {
                                var resources = JSON.parse(reader.result);
                                if (resources) {
                                    _this.importResouces(resources);
                                }
                            }
                            catch (e) {
                                _this.alerting.popError(_this.getResource('Message_ImportFailed', 'ResourcesManagement'), _this.getResource('Dialog_ImportFexibleLabelsTitle', 'ResourcesManagement'));
                                console.log(e.message);
                            }
                        }
                    };
                }
                catch (e) {
                    console.log(e.message);
                }
            };
            controller.prototype.saveCurrentSearchState = function () {
                this.searchState = {
                    page: this.paging.currentPage,
                    searchText: this.searchState.searchText,
                    viewName: this.searchState.viewName,
                };
            };
            controller.prototype.restoreSearchState = function (searchState) {
                if (searchState) {
                    this.searchState = searchState;
                    this.paging.currentPage = searchState.page;
                }
            };
            controller.prototype.edit = function (resource) {
                this.$state.go('editResource', { id: resource.Id, searchState: this.searchState }, { location: 'replace' });
                ;
            };
            controller.prototype.importResouces = function (importedResources) {
                var _this = this;
                this.resourcesManagementService.importResources(importedResources).then(function (response) {
                    if (response) {
                        _this.alerting.popInfo(_this.getResource('Message_SucessfullyImported', 'ResourcesManagement'), _this.getResource('Dialog_ImportFexibleLabelsTitle', 'ResourcesManagement'));
                        _this.activate();
                    }
                    else {
                        _this.alerting.popError(_this.getResource('Message_ImportFailed', 'ResourcesManagement'), _this.getResource('Dialog_ImportFexibleLabelsTitle', 'ResourcesManagement'));
                    }
                });
            };
            controller.prototype.getExportResourcesUrl = function () {
                return '/api/resourcesManagement/exportresources';
            };
            return controller;
        }());
        angular.module('customer.resourcesManagement')
            .component('resourcesManagement', {
            controller: controller,
            bindings: {
                rights: '='
            },
            templateUrl: '/App/resourcesManagement/resourcesManagement.html'
        });
    })(resourcesManagement = customer.resourcesManagement || (customer.resourcesManagement = {}));
})(customer || (customer = {}));
//# sourceMappingURL=resourcesManagement.component.js.map
var customer;
(function (customer) {
    var resourcesManagement;
    (function (resourcesManagement) {
        angular
            .module('customer.resourcesManagement')
            .config(configRoutes);
        function configRoutes($stateProvider, $locationProvider) {
            $locationProvider.html5Mode(true);
            $stateProvider
                .state('resourcesManagement', {
                url: '/resources/manage',
                template: '<resources-management></resources-management>',
                params: {
                    searchState: null
                }
            });
            $stateProvider
                .state('editResource', {
                url: '/resources/edit/{id}',
                template: '<resource-details resource="$resolve.resource"></resource-details>',
                resolve: {
                    resource: resourceProvider,
                },
                params: {
                    searchState: null
                }
            });
        }
        resourceProvider.$inject = ['$stateParams', 'resourcesManagementService'];
        function resourceProvider($stateParams, resourcesService) {
            if (/^\d+$/i.test($stateParams.id)) {
                return resourcesService.getResource($stateParams.id).then(function (resource) {
                    return resource;
                });
            }
        }
    })(resourcesManagement = customer.resourcesManagement || (customer.resourcesManagement = {}));
})(customer || (customer = {}));
//# sourceMappingURL=resourcesManagement.route.js.map
var customer;
(function (customer) {
    var resourcesManagement;
    (function (resourcesManagement) {
        var resourcesManagementService = (function () {
            function resourcesManagementService(dataservice) {
                this.dataservice = dataservice;
            }
            resourcesManagementService.prototype.getViewNames = function () {
                return this.dataservice.getData('/api/resourcesManagement/views').then(function (response) {
                    return response;
                });
            };
            resourcesManagementService.prototype.search = function (text, viewName, page, count) {
                return this.dataservice.getData('/api/resourcesManagement/search?text=' + text + '&viewName=' + viewName + '&page=' + page + '&count=' + count).then(function (response) {
                    return response;
                });
            };
            resourcesManagementService.prototype.getResource = function (id) {
                return this.dataservice.getData("/api/resourcesManagement/resource/" + id).then(function (response) {
                    return response;
                });
            };
            resourcesManagementService.prototype.saveResource = function (resource) {
                return this.dataservice.postData('/api/resourcesManagement/update', resource).then(function (response) {
                    return response;
                });
            };
            resourcesManagementService.prototype.importResources = function (resources) {
                return this.dataservice.postData('/api/resourcesManagement/importresources', resources).then(function (response) {
                    return response;
                });
            };
            return resourcesManagementService;
        }());
        resourcesManagement.resourcesManagementService = resourcesManagementService;
        angular
            .module('customer.resourcesManagement')
            .service('resourcesManagementService', resourcesManagementService);
    })(resourcesManagement = customer.resourcesManagement || (customer.resourcesManagement = {}));
})(customer || (customer = {}));
//# sourceMappingURL=resourcesManagement.service.js.map
var customer;
(function (customer) {
    var search;
    (function (search) {
        var controller = (function () {
            function controller($scope, $sce, $timeout, knowledgebaseService, $filter) {
                this.$scope = $scope;
                this.$sce = $sce;
                this.$timeout = $timeout;
                this.knowledgebaseService = knowledgebaseService;
                this.$filter = $filter;
                this.activate();
            }
            controller.prototype.activate = function () {
                var _this = this;
                this.$scope.$watch(function () { return _this.knowledgebaseService.searchResults; }, function (searchResult) {
                    if (searchResult != null) {
                        _this.searchValue = searchResult.searchValue;
                    }
                    else {
                        _this.searchValue = '';
                    }
                });
            };
            controller.prototype.doSearch = function () {
                if (this.searchValue.length >= 3 && /[A-Za-z0-9 ]/.test(this.searchValue)) {
                    this.knowledgebaseService.search(this.searchValue);
                }
                else {
                    this.knowledgebaseService.searchResults = { searchValue: this.searchValue };
                }
            };
            return controller;
        }());
        angular
            .module('customer.search')
            .component('navbarSearch', {
            controller: controller,
            templateUrl: '/App/search/navbarSearch.html'
        });
    })(search = customer.search || (customer.search = {}));
})(customer || (customer = {}));
//# sourceMappingURL=navbarSearch.component.js.map
var customer;
(function (customer) {
    var search;
    (function (search) {
        var controller = (function () {
            function controller($scope, $sce, $timeout, knowledgebaseService, $filter, $window) {
                this.$scope = $scope;
                this.$sce = $sce;
                this.$timeout = $timeout;
                this.knowledgebaseService = knowledgebaseService;
                this.$filter = $filter;
                this.$window = $window;
                this.searchValue = '';
                this.searchResults = [];
                this.searchResultCount = 0;
                this.searchID = '';
                this.activate();
                this.listenOnClickOutside();
            }
            controller.prototype.activate = function () {
                var _this = this;
                angular.element('#search_overlay').on('shown.bs.collapse', function () {
                    angular.element('#search_overlay .form-control').focus();
                });
                angular.element('#search_overlay').on('hidden.bs.collapse', function () {
                    angular.element('#search_overlay .form-control').blur();
                });
                this.$scope.$watch(function () { return _this.knowledgebaseService.searchResults; }, function (searchResult) {
                    if (searchResult != null) {
                        _this.searchValue = searchResult.searchValue;
                        if (searchResult.data) {
                            _this.searchResults = _this.$filter('groupByElement')(searchResult.data.CustomerQuestions, 'SubjectDescription');
                        }
                        else {
                            _this.searchResults = null;
                        }
                        if (_this.searchResults) {
                            _this.searchID = searchResult.data.SearchID;
                            _this.searchResultCount = Object.keys(_this.searchResults).length;
                            angular.element('#search_overlay').collapse('show');
                        }
                        else {
                            _this.searchID = null;
                            _this.searchResultCount = 0;
                            if (searchResult.data && searchResult.data.success == false) {
                                angular.element('#search_overlay').collapse('show');
                            }
                            else {
                                angular.element('#search_overlay').collapse('hide');
                            }
                        }
                    }
                });
            };
            controller.prototype.doSearch = function () {
                if (this.searchValue.length >= 3 && /[A-Za-z0-9 ]/.test(this.searchValue)) {
                    this.knowledgebaseService.search(this.searchValue);
                }
                else {
                    this.searchResults = [];
                    this.searchResultCount = 0;
                }
            };
            controller.prototype.highlightQuery = function (searchResult) {
                return searchResult.replace(new RegExp(this.searchValue, 'gi'), '<span class="highlighted">$&</span>');
            };
            controller.prototype.hideSearchPanel = function () {
                angular.element('#search_overlay').collapse('hide');
            };
            controller.prototype.clearSearch = function () {
                this.knowledgebaseService.searchResults = [];
            };
            controller.prototype.listenOnClickOutside = function () {
                var _this = this;
                angular.element(this.$window).on('click', function (event) {
                    var $target = $(event.target);
                    if (!$target.closest('#search_overlay').length) {
                        _this.hideSearchPanel();
                    }
                });
            };
            return controller;
        }());
        angular
            .module('customer.search')
            .component('search', {
            controller: controller,
            templateUrl: '/App/search/search.html'
        });
    })(search = customer.search || (customer.search = {}));
})(customer || (customer = {}));
//# sourceMappingURL=search.component.js.map
var Customer;
(function (Customer) {
    var StyleManagement;
    (function (StyleManagement) {
        var StyleManagementController = (function () {
            function StyleManagementController($window, $scope, styleManagementService, alerting, localize, base64FileReader, compileConfirmationAlert, $q) {
                this.$window = $window;
                this.$scope = $scope;
                this.styleManagementService = styleManagementService;
                this.alerting = alerting;
                this.localize = localize;
                this.base64FileReader = base64FileReader;
                this.compileConfirmationAlert = compileConfirmationAlert;
                this.$q = $q;
                this.logo = null;
                this.logoFooter = null;
                this.banner = null;
                this.styles = {};
                this.processing = false;
                this.isDirty = false;
                var mb = 1024 * 1024;
                this.bannerMaxSizeBytes = 2.5 * mb;
                this.logoMaxSizeBytes = 0.5 * mb;
                this.activate();
            }
            StyleManagementController.prototype.activate = function () {
                var _this = this;
                this.styleManagementService.getStyles()
                    .then(function (response) {
                    if (response.success && response.data) {
                        _this.styles = response.data;
                        _this.addStylesWatchers();
                    }
                    else {
                        _this.alerting.popError(_this.getResourceString("Message_LoadStylesError"));
                    }
                });
            };
            StyleManagementController.prototype.save = function () {
                var _this = this;
                if (this.processing) {
                    return;
                }
                this.processing = true;
                this.saveData().then(function (response) {
                    _this.processing = false;
                    if (response && response.success) {
                        _this.isDirty = false;
                        _this.alerting.popInfo(_this.getResourceString("Message_SaveStylesSuccess"));
                    }
                    else {
                        _this.alerting.popError(_this.getResourceString("Message_SaveStylesError"));
                    }
                });
            };
            StyleManagementController.prototype.compileCss = function () {
                var _this = this;
                if (this.processing) {
                    return;
                }
                this.processing = true;
                if (this.isDirty) {
                    this.compileConfirmationAlert.showDialog().then(function (result) {
                        _this.processing = false;
                        switch (result) {
                            case 'close':
                                return;
                            case 'saveCompile':
                                _this.saveData().then(function (response) {
                                    if (response.success)
                                        _this.compile();
                                    else
                                        _this.alerting.popError(_this.getResourceString("Message_SaveStylesError"));
                                });
                                break;
                            case 'compile':
                                _this.compile();
                                break;
                        }
                    }).catch(function () {
                        _this.processing = false;
                    });
                }
                else {
                    this.compile();
                }
            };
            StyleManagementController.prototype.saveData = function () {
                var _this = this;
                var defered = this.$q.defer();
                var logo = this.logo != null && this.logo.length > 0 ? this.logo[0] : null;
                var logoFooter = this.logoFooter != null && this.logoFooter.length > 0 ? this.logoFooter[0] : null;
                var banner = this.banner != null && this.banner.length > 0 ? this.banner[0] : null;
                this.base64FileReader.read([logo, logoFooter, banner], function (logoContent, logoFooterContent, bannerContent) {
                    var logoImage = null, footerLogoImage = null, bannerImage = null;
                    if (_this.logo) {
                        logoImage = { Name: logo.name, Content: logoContent };
                    }
                    if (_this.logoFooter) {
                        footerLogoImage = { Name: logoFooter.name, Content: logoFooterContent };
                    }
                    if (_this.banner) {
                        bannerImage = { Name: banner.name, Content: bannerContent };
                    }
                    _this.styleManagementService
                        .saveStyles({ CustomerVariables: _this.styles, Logo: logoImage, FooterLogo: footerLogoImage, Banner: bannerImage })
                        .then(function (response) {
                        defered.resolve(response);
                    });
                });
                return defered.promise;
            };
            StyleManagementController.prototype.compile = function () {
                var _this = this;
                this.styleManagementService
                    .compileStyles()
                    .then(function (response) {
                    _this.processing = false;
                    if (response.success) {
                        _this.$window.location.reload();
                    }
                    else {
                        _this.alerting.popError(_this.getResourceString("Message_CompileStylesError"));
                    }
                });
            };
            StyleManagementController.prototype.getResourceString = function (key) {
                return this.localize.getLocalizedString(key, "StyleManagement");
            };
            StyleManagementController.prototype.addStylesWatchers = function () {
                var _this = this;
                this.$scope.$watchCollection(function () { return _this.styles['Configuration']; }, function (newValue, oldValue) {
                    if (newValue !== oldValue)
                        _this.isDirty = true;
                });
                this.$scope.$watchCollection(function () { return _this.styles['Background colors']; }, function (newValue, oldValue) {
                    if (newValue !== oldValue)
                        _this.isDirty = true;
                });
                this.$scope.$watchCollection(function () { return _this.styles['Text colors']; }, function (newValue, oldValue) {
                    if (newValue !== oldValue)
                        _this.isDirty = true;
                });
                this.$scope.$watch(function () { return _this.logoFooter; }, function (newValue, oldValue) {
                    if (newValue !== oldValue)
                        _this.isDirty = true;
                });
                this.$scope.$watch(function () { return _this.banner; }, function (newValue, oldValue) {
                    if (newValue !== oldValue)
                        _this.isDirty = true;
                });
                this.$scope.$watch(function () { return _this.logo; }, function (newValue, oldValue) {
                    if (newValue !== oldValue)
                        _this.isDirty = true;
                });
            };
            return StyleManagementController;
        }());
        StyleManagementController.$inject = ["$window", "$scope", "styleManagementService", "alerting", "localize", "base64FileReader", "compileConfirmationAlert", "$q"];
        angular
            .module("customer.styleManagement")
            .component("styleManagement", {
            templateUrl: "/App/styleManagement/styleManagement.html",
            bindings: {},
            controller: StyleManagementController
        });
    })(StyleManagement = Customer.StyleManagement || (Customer.StyleManagement = {}));
})(Customer || (Customer = {}));
//# sourceMappingURL=styleManagement.component.js.map
var customer;
(function (customer) {
    var styleManagement;
    (function (styleManagement) {
        angular
            .module('customer.styleManagement')
            .config(configRoutes);
        function configRoutes($stateProvider, $urlRouterProvider, $locationProvider) {
            $locationProvider.html5Mode(true);
            $stateProvider
                .state('styleManagement', {
                url: '/styles/manage',
                template: '<style-management></style-management>'
            });
        }
    })(styleManagement = customer.styleManagement || (customer.styleManagement = {}));
})(customer || (customer = {}));
//# sourceMappingURL=styleManagement.route.js.map
var Customer;
(function (Customer) {
    var StyleManagement;
    (function (StyleManagement) {
        var StyleManagementService = (function () {
            function StyleManagementService(dataservice) {
                this.dataservice = dataservice;
            }
            StyleManagementService.prototype.getStyles = function () {
                var url = "/api/styling";
                return this.dataservice.getData(url);
            };
            StyleManagementService.prototype.saveStyles = function (styles) {
                var url = "/api/styling";
                return this.dataservice.postData(url, styles);
            };
            StyleManagementService.prototype.compileStyles = function () {
                var url = "/api/styling/compile";
                return this.dataservice.getData(url);
            };
            return StyleManagementService;
        }());
        StyleManagementService.$inject = ["dataservice"];
        StyleManagement.StyleManagementService = StyleManagementService;
        angular
            .module("customer.styleManagement")
            .service("styleManagementService", StyleManagementService);
    })(StyleManagement = Customer.StyleManagement || (Customer.StyleManagement = {}));
})(Customer || (Customer = {}));
//# sourceMappingURL=styleManagement.service.js.map
var customer;
(function (customer) {
    var userManagement;
    (function (userManagement) {
        var controller = (function () {
            function controller(userService, alerting, localize, $state, $stateParams) {
                this.userService = userService;
                this.alerting = alerting;
                this.localize = localize;
                this.$state = $state;
                this.$stateParams = $stateParams;
                this.$inject = ['userService', 'alerting', 'localize', '$state', '$stateParams'];
            }
            controller.prototype.createKcc = function (form) {
                var _this = this;
                if (form.$invalid || form.validationInProgress) {
                    return;
                }
                this.userService.createKccUser(this.account.DomainName, this.account.UserName, this.account.Email, '')
                    .then(function (result) {
                    if (result.success) {
                        _this.alerting.popInfo(_this.getResource("Message_UserCreated")).then(function () {
                            _this.$state.go('userManagement');
                        });
                    }
                    else {
                        if (result.message.code === core.constants.httpStatusCodes.BadRequest) {
                            _this.alerting.popError(result.message.message);
                        }
                        else {
                            _this.alerting.popError(_this.getResource("Message_Error_CreatingKccUser"));
                        }
                    }
                });
            };
            controller.prototype.goBackToUserManagement = function () {
                this.$state.go('userManagement', { searchState: this.$stateParams.userManagementSearchState });
            };
            controller.prototype.getResource = function (key, values) {
                return this.localize.getLocalizedString(key, "NewKcc", values);
            };
            return controller;
        }());
        angular.module('customer.userManagement').
            component('newKcc', {
            bindings: {
                account: '=',
                rights: '=',
                rolers: '='
            },
            controller: controller,
            templateUrl: '/App/userManagement/newKcc.html'
        });
    })(userManagement = customer.userManagement || (customer.userManagement = {}));
})(customer || (customer = {}));
//# sourceMappingURL=newKcc.component.js.map
var customer;
(function (customer) {
    var userManagement;
    (function (userManagement) {
        var controller = (function () {
            function controller($state, $stateParams, userService, localize, alerting, blockUserDialog, utcToLocalFilter) {
                this.$state = $state;
                this.$stateParams = $stateParams;
                this.userService = userService;
                this.localize = localize;
                this.alerting = alerting;
                this.blockUserDialog = blockUserDialog;
                this.utcToLocalFilter = utcToLocalFilter;
                this.userNotFound = false;
                this.$inject = ['$state', '$stateParams', 'userService', 'localize', 'alerting', 'blockUserDialog', 'utcToLocalFilter'];
            }
            controller.prototype.$onInit = function () {
                this.activate();
            };
            controller.prototype.activate = function () {
                if (!this.account) {
                    this.userNotFound = true;
                }
                else {
                    if (!this.account.isNew) {
                        this.isAdminRoleSelected();
                        this.account.Role = this.getAccountRole();
                    }
                }
            };
            controller.prototype.saveAccount = function (form) {
                var _this = this;
                if (form.$invalid || form.validationInProgress) {
                    return;
                }
                var promise;
                var message;
                if (this.account.isNew) {
                    promise = this.userService.createUser(this.account);
                    message = this.getResource("Message_UserCreated");
                }
                else {
                    promise = this.userService.updateUser(this.account);
                    message = this.getResource("Message_UserUpdated");
                }
                return promise.then(function (response) {
                    var dialogTitle = _this.getResource("Dialog_SaveUserTitle");
                    if (response.success && response.data) {
                        _this.goBackToUserManagement();
                        _this.alerting.popInfo(message, dialogTitle);
                    }
                    else {
                        var errorMessage = _this.getResource("Message_UserSaveFailed");
                        if (response.message && response.message.message) {
                            errorMessage += " " + response.message.message;
                        }
                        _this.alerting.popError(errorMessage, dialogTitle);
                        if (response.message.code == core.constants.httpStatusCodes.Gone) {
                            _this.goBackToUserManagement();
                        }
                    }
                });
            };
            controller.prototype.removeAccount = function (account) {
                var _this = this;
                var deleteUserTitle = this.getResource("Dialog_DeleteUserTitle");
                this.alerting.confirm(this.getResource("Message_ConfirmUserDelete", account.UserName), deleteUserTitle).then(function (result) {
                    if (result) {
                        return _this.userService.deleteUser(account.UserId).then(function (response) {
                            if (response.success && response.data) {
                                _this.alerting.popInfo(_this.getResource("Message_UserDeleted"), deleteUserTitle).then(function () {
                                    _this.goBackToUserManagement();
                                });
                            }
                            else {
                                _this.alerting.popError(_this.getResource("Message_UserDeleteError"), deleteUserTitle);
                            }
                        });
                    }
                });
            };
            controller.prototype.unblockAccount = function (account) {
                var _this = this;
                return this.userService.unblockUser(account.UserName).then(function (response) {
                    var unblockUserTitle = _this.getResource("Dialog_UnblockUserTitle");
                    if (response.success && response.data) {
                        account.IsAutomaticallyBlocked = false;
                        account.IsManuallyBlocked = false;
                        _this.alerting.popInfo(_this.getResource("Message_UserUnblocked"), unblockUserTitle);
                    }
                    else {
                        _this.alerting.popError(_this.getResource("Message_UserUnblockError"), unblockUserTitle);
                    }
                });
            };
            controller.prototype.activateAccount = function (account) {
                var _this = this;
                return this.userService.unblockUser(account.UserName).then(function (response) {
                    var activateAccountTitle = _this.getResource("Dialog_ActivateAccountTitle");
                    if (response.success && response.data) {
                        account.IsAutomaticallyBlocked = false;
                        account.IsManuallyBlocked = false;
                        _this.alerting.popInfo(_this.getResource("Message_AccountActivated"), activateAccountTitle);
                    }
                    else {
                        _this.alerting.popError(_this.getResource("Message_AccountActivationError"), activateAccountTitle);
                    }
                });
            };
            controller.prototype.blockAccount = function (account) {
                var _this = this;
                this.blockUserDialog.showDialog().then(function (result) {
                    switch (result.res) {
                        case 'block':
                            _this.userService.blockUser(account.UserName, result.blockReason).then(function (response) {
                                var blockUserTitle = _this.getResource("Dialog_BlockUserTitle");
                                if (response.success && response.data) {
                                    account.IsManuallyBlocked = true;
                                    account.IsAutomaticallyBlocked = false;
                                    account.BlockReason = result.blockReason;
                                    _this.alerting.popInfo(_this.getResource("Message_UserBlocked"), blockUserTitle);
                                }
                                else {
                                    if (response.message && response.message.data === "LockoutDisabled") {
                                        _this.alerting.popError(_this.getResource("Message_CannotBlockAccount"), blockUserTitle);
                                    }
                                    else {
                                        _this.alerting.popError(_this.getResource("Message_UserBlockError"), blockUserTitle);
                                    }
                                }
                            });
                            break;
                        case 'close':
                            return;
                    }
                });
            };
            controller.prototype.goBackToUserManagement = function () {
                this.$state.go('userManagement', { searchState: this.$stateParams.userManagementSearchState });
            };
            controller.prototype.isAdminRoleSelected = function () {
                var selected = false;
                for (var i = 0; i < this.roles.length; i++) {
                    if (this.roles[i].Name === this.account.RoleName && this.roles[i].IsAdministratorRole) {
                        selected = true;
                        break;
                    }
                }
                this.account.isAdminRoleSelected = selected;
                return selected;
            };
            controller.prototype.getResource = function (key, values) {
                return this.localize.getLocalizedString(key, "UserManagement", values);
            };
            controller.prototype.getRoles = function () {
                var filteredRoles = [];
                for (var i = 0; i < this.roles.length; i++) {
                    if (this.account && this.roles[i].Name === this.account.RoleName || !this.roles[i].IsKCCEmployeeRole) {
                        filteredRoles.push(this.roles[i]);
                    }
                }
                return filteredRoles;
            };
            controller.prototype.getAccountRole = function () {
                for (var i = 0; i < this.roles.length; i++) {
                    if (this.roles[i].Name === this.account.RoleName) {
                        return this.roles[i];
                    }
                }
                return null;
            };
            controller.prototype.turnOnPasswordStyle = function (event) {
                event.target.type = 'password';
            };
            controller.prototype.getLocalDate = function (date) {
                if (!date) {
                    return this.getResource("Text_DateUnknown");
                }
                return this.utcToLocalFilter(date, "EEEE, dd-MM-yyyy HH:mm:ss");
            };
            return controller;
        }());
        angular.module('customer.userManagement')
            .component('userDetails', {
            controller: controller,
            bindings: {
                account: '=',
                rights: '=',
                roles: '='
            },
            templateUrl: '/App/userManagement/editUser.html'
        });
        angular.module('customer.userManagement')
            .component('newUserDetails', {
            controller: controller,
            bindings: {
                account: '=',
                rights: '=',
                roles: '='
            },
            templateUrl: '/App/userManagement/newUser.html'
        });
    })(userManagement = customer.userManagement || (customer.userManagement = {}));
})(customer || (customer = {}));
//# sourceMappingURL=userDetails.component.js.map
var customer;
(function (customer) {
    var userManagement;
    (function (userManagement) {
        var controller = (function () {
            function controller($state, $stateParams, userService, localize, alerting) {
                this.$state = $state;
                this.$stateParams = $stateParams;
                this.userService = userService;
                this.localize = localize;
                this.alerting = alerting;
                this.searchModel = new core.models.users.SearchModel();
                this.searchState = new userManagement.models.SearchState();
                this.maxTotalItems = 10000000000;
                this.$inject = ['$state', '$stateParams', 'userService', 'localize', 'alerting'];
                this.paging = {
                    currentPage: 1,
                    totalItems: this.maxTotalItems,
                    maxSize: core.constants.paging.maxPages,
                    count: core.constants.paging.itemsPerPage,
                    firstText: this.getResource('Paging_FirstText'),
                    lastText: this.getResource('Paging_LastText'),
                    nextText: this.getResource('Paging_NextText'),
                    previousText: this.getResource('Paging_PreviousText')
                };
                this.activate();
            }
            controller.prototype.activate = function () {
                this.restoreSearchState(this.$stateParams.searchState);
                this.search();
                this.getLastSyncDate();
            };
            controller.prototype.search = function () {
                var _this = this;
                this.saveCurrentSearchState();
                if (this.gridSelection) {
                    this.gridSelection.selected = null;
                    this.gridSelection = null;
                }
                return this.userService.searchUsers(this.searchModel, this.paging.currentPage, this.paging.count).then(function (response) {
                    _this.paging.totalItems = response.results;
                    _this.accounts = response.rows;
                });
            };
            controller.prototype.getLastSyncDate = function () {
                var _this = this;
                this.userService.getLastSyncDate().then(function (data) { _this.lastSyncDate = data.data; });
            };
            controller.prototype.removeAccount = function (account) {
                var _this = this;
                var deleteUserTitle = this.getResource("Dialog_DeleteUserTitle");
                this.alerting.confirm(this.getResource("Message_ConfirmUserDelete", account.UserName), deleteUserTitle).then(function (result) {
                    if (result) {
                        return _this.userService.deleteUser(account.UserId).then(function (response) {
                            if (response.success && response.data) {
                                _this.search();
                                _this.alerting.popInfo(_this.getResource("Message_UserDeleted"), deleteUserTitle);
                            }
                            else {
                                _this.alerting.popError(_this.getResource("Message_UserDeleteError"), deleteUserTitle);
                            }
                        });
                    }
                });
            };
            controller.prototype.activateAccount = function (account) {
                var _this = this;
                return this.userService.unblockUser(account.UserName).then(function (response) {
                    var activateAccountTitle = _this.getResource("Dialog_ActivateAccountTitle");
                    if (response.success && response.data) {
                        _this.search();
                        _this.alerting.popInfo(_this.getResource("Message_AccountActivated"), activateAccountTitle);
                    }
                    else {
                        _this.alerting.popError(_this.getResource("Message_AccountActivationError"), activateAccountTitle);
                    }
                });
            };
            controller.prototype.newAccount = function () {
                this.$state.go('new', '', { location: 'replace' });
            };
            controller.prototype.newKccAccount = function () {
                this.$state.go('newKcc', '', { location: 'replace' });
            };
            controller.prototype.editAccount = function (account) {
                this.$state.go('edit', { userId: account.UserId, userManagementSearchState: this.searchState }, { location: 'replace' });
            };
            controller.prototype.onCheckChange = function (selection) {
                angular.forEach(this.accounts, function (account) {
                    if (account.UserName !== selection.UserName) {
                        account.selected = false;
                    }
                });
                this.gridSelection = selection;
            };
            controller.prototype.getResource = function (key, values) {
                return this.localize.getLocalizedString(key, "UserManagement", values);
            };
            controller.prototype.saveCurrentSearchState = function () {
                this.searchState = {
                    page: this.paging.currentPage,
                    searchModel: this.searchModel
                };
            };
            controller.prototype.restoreSearchState = function (searchState) {
                if (searchState) {
                    this.paging.currentPage = searchState.page;
                    this.searchModel = searchState.searchModel;
                }
            };
            controller.prototype.getTotalItems = function () {
                return this.paging.totalItems !== this.maxTotalItems ? this.paging.totalItems : 0;
            };
            controller.prototype.syncAccounts = function () {
                var _this = this;
                this.userService.syncAccounts().then(function (response) {
                    var title = _this.localize.getLocalizedString("Menu_Item_User_Management", "Menu");
                    response.success === true ? _this.alerting.popInfo(_this.localize.getLocalizedString('Sync_Success_Msg', 'UserManagement'), title)
                        : _this.alerting.popError(_this.localize.getLocalizedString('Sync_Failed_Msg', 'UserManagement'), title);
                    _this.lastSyncDate = response.data != null ? response.data : _this.lastSyncDate;
                });
            };
            return controller;
        }());
        angular.module('customer.userManagement')
            .component('userManagement', {
            controller: controller,
            bindings: {
                rights: '='
            },
            templateUrl: '/App/userManagement/usermanagement.html'
        });
    })(userManagement = customer.userManagement || (customer.userManagement = {}));
})(customer || (customer = {}));
//# sourceMappingURL=userManagement.component.js.map
var customer;
(function (customer) {
    var userManagement;
    (function (userManagement) {
        angular
            .module('customer.userManagement')
            .config(configRoutes);
        function configRoutes($stateProvider, $urlRouterProvider, $locationProvider) {
            $locationProvider.html5Mode(true);
            $stateProvider
                .state('userManagement', {
                url: '/users/manage',
                template: '<user-management rights="$resolve.rights"></user-management>',
                resolve: {
                    rights: rightsProvider
                },
                params: {
                    searchState: null
                }
            });
            $stateProvider
                .state('edit', {
                url: '/users/edit/{userId}',
                resolve: {
                    account: accountProvider,
                    roles: rolesProvider,
                    rights: rightsProvider
                },
                template: '<user-details account="$resolve.account" rights="$resolve.rights" roles="$resolve.roles"></user-details>',
                params: {
                    userManagementSearchState: null
                }
            });
            $stateProvider
                .state('new', {
                url: '/users/new/',
                resolve: {
                    account: function () {
                        return {
                            isNew: true
                        };
                    },
                    roles: rolesProvider,
                    rights: rightsProvider
                },
                template: '<new-user-details account="$resolve.account" rights="$resolve.rights" roles="$resolve.roles"></new-user-details>'
            });
            $stateProvider
                .state('newKcc', {
                url: '/users/newKcc/',
                template: '<new-kcc account="$resolve.account" rights="$resolve.rights" roles="$resolve.roles"></new-kcc>',
                resolve: {
                    account: function () {
                        return {
                            isNew: true
                        };
                    },
                    roles: rolesProvider,
                    rights: rightsProvider
                }
            });
            accountProvider.$inject = ['$rootScope', '$stateParams', 'userService'];
            function accountProvider($rootScope, $stateParams, userService) {
                if (/[a-f0-9]{8}-([a-f0-9]{4}-){3}[a-f0-9]{12}/i.test($stateParams.userId)) {
                    return userService.getUser($stateParams.userId);
                }
                else {
                    return userService.getUserByCustomerId($stateParams.userId).then(function (response) {
                        if (response.success) {
                            return response.data;
                        }
                        if (response.code === parseInt(core.constants.httpStatusCodes.Forbidden)) {
                            $rootScope.$emit("customerPortalUnauthorizedAccess");
                        }
                        return null;
                    });
                }
            }
            rightsProvider.$inject = ['userService'];
            function rightsProvider(userService) {
                return userService.getUserManagementRights();
            }
            rolesProvider.$inject = ['$stateParams', 'userService'];
            function rolesProvider($stateParams, userService) {
                return userService.getRoles().then(function (response) {
                    return response;
                });
            }
        }
    })(userManagement = customer.userManagement || (customer.userManagement = {}));
})(customer || (customer = {}));
//# sourceMappingURL=userManagement.route.js.map
var customer;
(function (customer) {
    var accountRequests;
    (function (accountRequests) {
        var models;
        (function (models) {
            var AccountRequest = (function () {
                function AccountRequest() {
                }
                return AccountRequest;
            }());
            models.AccountRequest = AccountRequest;
        })(models = accountRequests.models || (accountRequests.models = {}));
    })(accountRequests = customer.accountRequests || (customer.accountRequests = {}));
})(customer || (customer = {}));
//# sourceMappingURL=AccountREquest.js.map
var customer;
(function (customer) {
    var accountRequests;
    (function (accountRequests) {
        var models;
        (function (models) {
            var SearchModel = (function () {
                function SearchModel() {
                }
                return SearchModel;
            }());
            models.SearchModel = SearchModel;
        })(models = accountRequests.models || (accountRequests.models = {}));
    })(accountRequests = customer.accountRequests || (customer.accountRequests = {}));
})(customer || (customer = {}));
//# sourceMappingURL=SearchModel.js.map
var customer;
(function (customer) {
    var contractTermination;
    (function (contractTermination) {
        var models;
        (function (models) {
            var Appointment = (function () {
                function Appointment() {
                }
                return Appointment;
            }());
            models.Appointment = Appointment;
        })(models = contractTermination.models || (contractTermination.models = {}));
    })(contractTermination = customer.contractTermination || (customer.contractTermination = {}));
})(customer || (customer = {}));
//# sourceMappingURL=Appointment.js.map
var customer;
(function (customer) {
    var contractTermination;
    (function (contractTermination) {
        var models;
        (function (models) {
            var ContractTermination = (function () {
                function ContractTermination() {
                }
                return ContractTermination;
            }());
            models.ContractTermination = ContractTermination;
        })(models = contractTermination.models || (contractTermination.models = {}));
    })(contractTermination = customer.contractTermination || (customer.contractTermination = {}));
})(customer || (customer = {}));
//# sourceMappingURL=ContractTermination.js.map
var customer;
(function (customer) {
    var contractTermination;
    (function (contractTermination) {
        var models;
        (function (models) {
            var Country = (function () {
                function Country() {
                }
                return Country;
            }());
            models.Country = Country;
        })(models = contractTermination.models || (contractTermination.models = {}));
    })(contractTermination = customer.contractTermination || (customer.contractTermination = {}));
})(customer || (customer = {}));
//# sourceMappingURL=Country.js.map
var customer;
(function (customer) {
    var contractTermination;
    (function (contractTermination) {
        var models;
        (function (models) {
            var InspectionData = (function () {
                function InspectionData() {
                }
                return InspectionData;
            }());
            models.InspectionData = InspectionData;
        })(models = contractTermination.models || (contractTermination.models = {}));
    })(contractTermination = customer.contractTermination || (customer.contractTermination = {}));
})(customer || (customer = {}));
//# sourceMappingURL=InspectionData.js.map
var customer;
(function (customer) {
    var contractTermination;
    (function (contractTermination) {
        var models;
        (function (models) {
            var TerminationReason = (function () {
                function TerminationReason() {
                }
                return TerminationReason;
            }());
            models.TerminationReason = TerminationReason;
        })(models = contractTermination.models || (contractTermination.models = {}));
    })(contractTermination = customer.contractTermination || (customer.contractTermination = {}));
})(customer || (customer = {}));
//# sourceMappingURL=TerminationReason.js.map
var customer;
(function (customer) {
    var contractTermination;
    (function (contractTermination) {
        var models;
        (function (models) {
            var TimeSlot = (function () {
                function TimeSlot() {
                }
                return TimeSlot;
            }());
            models.TimeSlot = TimeSlot;
        })(models = contractTermination.models || (contractTermination.models = {}));
    })(contractTermination = customer.contractTermination || (customer.contractTermination = {}));
})(customer || (customer = {}));
//# sourceMappingURL=TimeSlot.js.map
var customer;
(function (customer) {
    var knowledgebase;
    (function (knowledgebase) {
        var models;
        (function (models) {
            var Advice = (function () {
                function Advice() {
                }
                return Advice;
            }());
            models.Advice = Advice;
        })(models = knowledgebase.models || (knowledgebase.models = {}));
    })(knowledgebase = customer.knowledgebase || (customer.knowledgebase = {}));
})(customer || (customer = {}));
//# sourceMappingURL=Advice.js.map
var customer;
(function (customer) {
    var knowledgebase;
    (function (knowledgebase) {
        var models;
        (function (models) {
            var Answer = (function () {
                function Answer() {
                }
                return Answer;
            }());
            models.Answer = Answer;
        })(models = knowledgebase.models || (knowledgebase.models = {}));
    })(knowledgebase = customer.knowledgebase || (customer.knowledgebase = {}));
})(customer || (customer = {}));
//# sourceMappingURL=Answer.js.map
var customer;
(function (customer) {
    var knowledgebase;
    (function (knowledgebase) {
        var models;
        (function (models) {
            var AnsweredQuestion = (function () {
                function AnsweredQuestion() {
                }
                return AnsweredQuestion;
            }());
            models.AnsweredQuestion = AnsweredQuestion;
        })(models = knowledgebase.models || (knowledgebase.models = {}));
    })(knowledgebase = customer.knowledgebase || (customer.knowledgebase = {}));
})(customer || (customer = {}));
//# sourceMappingURL=AnsweredQuestion.js.map
var customer;
(function (customer) {
    var knowledgebase;
    (function (knowledgebase) {
        var models;
        (function (models) {
            var CurrentQuestion = (function () {
                function CurrentQuestion() {
                }
                return CurrentQuestion;
            }());
            models.CurrentQuestion = CurrentQuestion;
        })(models = knowledgebase.models || (knowledgebase.models = {}));
    })(knowledgebase = customer.knowledgebase || (customer.knowledgebase = {}));
})(customer || (customer = {}));
//# sourceMappingURL=CurrentQuestion.js.map
var customer;
(function (customer) {
    var knowledgebase;
    (function (knowledgebase) {
        var models;
        (function (models) {
            var CustomerQuestion = (function () {
                function CustomerQuestion() {
                }
                return CustomerQuestion;
            }());
            models.CustomerQuestion = CustomerQuestion;
        })(models = knowledgebase.models || (knowledgebase.models = {}));
    })(knowledgebase = customer.knowledgebase || (customer.knowledgebase = {}));
})(customer || (customer = {}));
//# sourceMappingURL=CustomerQuestion.js.map
var customer;
(function (customer) {
    var knowledgebase;
    (function (knowledgebase) {
        var models;
        (function (models) {
            var Question = (function () {
                function Question() {
                }
                return Question;
            }());
            models.Question = Question;
        })(models = knowledgebase.models || (knowledgebase.models = {}));
    })(knowledgebase = customer.knowledgebase || (customer.knowledgebase = {}));
})(customer || (customer = {}));
//# sourceMappingURL=Question.js.map
var customer;
(function (customer) {
    var knowledgebase;
    (function (knowledgebase) {
        var models;
        (function (models) {
            var ReadKBQuestions = (function () {
                function ReadKBQuestions() {
                }
                return ReadKBQuestions;
            }());
            models.ReadKBQuestions = ReadKBQuestions;
        })(models = knowledgebase.models || (knowledgebase.models = {}));
    })(knowledgebase = customer.knowledgebase || (customer.knowledgebase = {}));
})(customer || (customer = {}));
//# sourceMappingURL=ReadKBQuestions.js.map
var customer;
(function (customer) {
    var knowledgebase;
    (function (knowledgebase) {
        var models;
        (function (models) {
            var SearchResult = (function () {
                function SearchResult() {
                }
                return SearchResult;
            }());
            models.SearchResult = SearchResult;
        })(models = knowledgebase.models || (knowledgebase.models = {}));
    })(knowledgebase = customer.knowledgebase || (customer.knowledgebase = {}));
})(customer || (customer = {}));
//# sourceMappingURL=SearchResult.js.map
var customer;
(function (customer) {
    var menu;
    (function (menu) {
        var models;
        (function (models) {
            var MenuItem = (function () {
                function MenuItem() {
                }
                return MenuItem;
            }());
            models.MenuItem = MenuItem;
        })(models = menu.models || (menu.models = {}));
    })(menu = customer.menu || (customer.menu = {}));
})(customer || (customer = {}));
//# sourceMappingURL=MenuItem.js.map
var customer;
(function (customer) {
    var myDetails;
    (function (myDetails) {
        var controller = (function () {
            function controller($scope) {
                this.$scope = $scope;
                this.$inject = ['$scope'];
            }
            controller.prototype.submitForm = function (form) {
                if (form.$invalid || form.password.$viewValue != form.password.$modelValue || form.password.$pending) {
                    return;
                }
                this.$scope.$close(true);
            };
            return controller;
        }());
        angular.module('customer.myDetails')
            .controller('emailChangeDialogController', controller);
    })(myDetails = customer.myDetails || (customer.myDetails = {}));
})(customer || (customer = {}));
//# sourceMappingURL=emailChangeDialog.controller.js.map
var customer;
(function (customer) {
    var myDetails;
    (function (myDetails) {
        var emailChangeDialog = (function () {
            function emailChangeDialog($uibModal) {
                var _this = this;
                this.$uibModal = $uibModal;
                this.checkPassword = function () {
                    var options = {
                        templateUrl: '/App/myDetails/emailChangeDialog/emailChangeDialog.html',
                        controller: 'emailChangeDialogController',
                        controllerAs: '$ctrl'
                    };
                    return _this.$uibModal.open(options).result;
                };
            }
            emailChangeDialog.factory = function () {
                var dialog = function ($uibModal) { return new emailChangeDialog($uibModal); };
                dialog.$inject = ['$uibModal'];
                return dialog;
            };
            return emailChangeDialog;
        }());
        myDetails.emailChangeDialog = emailChangeDialog;
        angular
            .module('customer.myDetails')
            .factory('emailChangeDialog', emailChangeDialog.factory());
    })(myDetails = customer.myDetails || (customer.myDetails = {}));
})(customer || (customer = {}));
//# sourceMappingURL=emailChangeDialog.js.map
var customer;
(function (customer) {
    var myHousehold;
    (function (myHousehold) {
        var models;
        (function (models) {
            var Person = (function () {
                function Person() {
                }
                return Person;
            }());
            models.Person = Person;
        })(models = myHousehold.models || (myHousehold.models = {}));
    })(myHousehold = customer.myHousehold || (customer.myHousehold = {}));
})(customer || (customer = {}));
//# sourceMappingURL=Person.js.map
var customer;
(function (customer) {
    var myHousehold;
    (function (myHousehold) {
        var models;
        (function (models) {
            var SettingsRole = (function () {
                function SettingsRole() {
                }
                return SettingsRole;
            }());
            models.SettingsRole = SettingsRole;
        })(models = myHousehold.models || (myHousehold.models = {}));
    })(myHousehold = customer.myHousehold || (customer.myHousehold = {}));
})(customer || (customer = {}));
//# sourceMappingURL=SettingsRole.js.map
var customer;
(function (customer) {
    var myPayments;
    (function (myPayments) {
        var amountDisplay = (function () {
            function amountDisplay($filter, localize) {
                var _this = this;
                this.$filter = $filter;
                this.localize = localize;
                this.restrict = 'A';
                this.scope = {
                    amount: "=",
                    total: "="
                };
                this.link = function (scope, element, attrs) {
                    scope.$watch('amount', function (newAmount) {
                        element.empty();
                        var display = _this.getDisplay(scope.total);
                        var amount = parseFloat(scope.amount);
                        var total = parseFloat(scope.total);
                        if (amount < total) {
                            display = _this.localize.getLocalizedString("Label_Instead_Of", "MyPayments_OnlinePayment", [_this.getDisplay(amount), _this.getDisplay(total)]);
                        }
                        element.append(display);
                    });
                };
            }
            amountDisplay.prototype.getDisplay = function (value) {
                return this.$filter('number')(value, 2);
            };
            amountDisplay.factory = function () {
                var directive = function ($filter, localize) { return new amountDisplay($filter, localize); };
                directive.$inject = ['$filter', 'localize'];
                return directive;
            };
            return amountDisplay;
        }());
        angular
            .module('customer.myPayments')
            .directive('amountDisplay', amountDisplay.factory());
    })(myPayments = customer.myPayments || (customer.myPayments = {}));
})(customer || (customer = {}));
//# sourceMappingURL=amountDisplay.directive.js.map
var customer;
(function (customer) {
    var myPayments;
    (function (myPayments) {
        var dueDate = (function () {
            function dueDate(dueDateService) {
                var _this = this;
                this.dueDateService = dueDateService;
                this.restrict = 'A';
                this.scope = {
                    value: "="
                };
                this.link = function (scope, element, attrs) {
                    var response = _this.dueDateService.getDueText(scope.value);
                    if (response.difference < 0) {
                        element.addClass('text-danger');
                    }
                    else {
                        element.removeAttr('class');
                    }
                    element.empty();
                    element.append(response.text);
                };
            }
            dueDate.factory = function () {
                var directive = function (dueDateService) { return new dueDate(dueDateService); };
                directive.$inject = ['dueDateService'];
                return directive;
            };
            return dueDate;
        }());
        angular
            .module('customer.myPayments')
            .directive('dueDate', dueDate.factory());
    })(myPayments = customer.myPayments || (customer.myPayments = {}));
})(customer || (customer = {}));
//# sourceMappingURL=dueDate.directive.js.map
var customer;
(function (customer) {
    var myPayments;
    (function (myPayments) {
        var dueDateService = (function () {
            function dueDateService(localize) {
                this.localize = localize;
            }
            dueDateService.prototype.getDueText = function (dueDate) {
                var difference = this.getDaysDifference(new Date(), dueDate);
                var text = '';
                if (difference < -1) {
                    text = this.localize.getLocalizedString('Text_XDaysAgo').replace('{}', (-difference).toString());
                }
                else if (difference === -1) {
                    text = this.localize.getLocalizedString('Text_Yesterday');
                }
                else if (difference === 0) {
                    text = this.localize.getLocalizedString('Text_Today');
                }
                else if (difference === 1) {
                    text = this.localize.getLocalizedString('Text_Tomorrow');
                }
                else {
                    text = this.localize.getLocalizedString('Text_InXDays').replace('{}', difference.toString());
                }
                return {
                    "text": text,
                    "difference": difference
                };
            };
            dueDateService.prototype.treatAsUTC = function (date) {
                var result = new Date(date);
                result.setMinutes(result.getMinutes() - result.getTimezoneOffset());
                return result;
            };
            dueDateService.prototype.getDaysDifference = function (startDate, endDate) {
                var millisecondsPerDay = 24 * 60 * 60 * 1000;
                var difference = (this.treatAsUTC(endDate) - this.treatAsUTC(startDate)) / millisecondsPerDay;
                return Math.round(difference);
            };
            dueDateService.prototype.getDueHtml = function (date) {
                var response = this.getDueText(date);
                var attrClass = '';
                if (response.difference < 0) {
                    attrClass = '="text-danger"';
                }
                return " (<span class" + attrClass + ">" + response.text + "</span>)";
            };
            return dueDateService;
        }());
        dueDateService.$inject = ['localize'];
        myPayments.dueDateService = dueDateService;
        angular
            .module('customer.myPayments')
            .service('dueDateService', dueDateService);
    })(myPayments = customer.myPayments || (customer.myPayments = {}));
})(customer || (customer = {}));
//# sourceMappingURL=dueDate.service.js.map
var customer;
(function (customer) {
    var myPayments;
    (function (myPayments) {
        var maxAmount = (function () {
            function maxAmount() {
                var _this = this;
                this.restrict = 'A';
                this.require = 'ngModel';
                this.scope = {
                    maxValue: '='
                };
                this.link = function (scope, element, attrs, ngModel) {
                    scope.$watch('maxValue', function (newMax) {
                        scope.maxValue = newMax;
                        ngModel.$validate();
                    });
                    ngModel.$validators.maxAmount = function (modelValue, viewValue) {
                        var amount = _this.getFloatValue(viewValue);
                        var max = _this.getFloatValue(scope.maxValue);
                        var result = true;
                        if (amount && max) {
                            result = amount <= max;
                        }
                        return result;
                    };
                };
            }
            maxAmount.prototype.getFloatValue = function (val) {
                var result = null;
                if (val) {
                    result = typeof (val) == 'string' ? parseFloat(val.replace(',', '.')) : val;
                }
                return result;
            };
            maxAmount.factory = function () {
                var directive = function () { return new maxAmount(); };
                return directive;
            };
            return maxAmount;
        }());
        angular
            .module('customer.myPayments')
            .directive('maxAmount', maxAmount.factory());
    })(myPayments = customer.myPayments || (customer.myPayments = {}));
})(customer || (customer = {}));
//# sourceMappingURL=maxAmount.directive.js.map
var customer;
(function (customer) {
    var myRepairments;
    (function (myRepairments) {
        var models;
        (function (models) {
            var Attachment = (function () {
                function Attachment() {
                }
                return Attachment;
            }());
            models.Attachment = Attachment;
        })(models = myRepairments.models || (myRepairments.models = {}));
    })(myRepairments = customer.myRepairments || (customer.myRepairments = {}));
})(customer || (customer = {}));
//# sourceMappingURL=Attachment.js.map
var customer;
(function (customer) {
    var myRepairments;
    (function (myRepairments) {
        var models;
        (function (models) {
            var DecisionTreeStep = (function () {
                function DecisionTreeStep() {
                }
                return DecisionTreeStep;
            }());
            models.DecisionTreeStep = DecisionTreeStep;
        })(models = myRepairments.models || (myRepairments.models = {}));
    })(myRepairments = customer.myRepairments || (customer.myRepairments = {}));
})(customer || (customer = {}));
//# sourceMappingURL=DecisionTreeStep.js.map
var customer;
(function (customer) {
    var myRepairments;
    (function (myRepairments) {
        var models;
        (function (models) {
            var Description = (function () {
                function Description() {
                }
                return Description;
            }());
            models.Description = Description;
        })(models = myRepairments.models || (myRepairments.models = {}));
    })(myRepairments = customer.myRepairments || (customer.myRepairments = {}));
})(customer || (customer = {}));
//# sourceMappingURL=Description.js.map
var customer;
(function (customer) {
    var myRepairments;
    (function (myRepairments) {
        var models;
        (function (models) {
            var Inspection = (function () {
                function Inspection() {
                }
                return Inspection;
            }());
            models.Inspection = Inspection;
        })(models = myRepairments.models || (myRepairments.models = {}));
    })(myRepairments = customer.myRepairments || (customer.myRepairments = {}));
})(customer || (customer = {}));
//# sourceMappingURL=Inspection.js.map
var customer;
(function (customer) {
    var myRepairments;
    (function (myRepairments) {
        var models;
        (function (models) {
            var MaintenanceOrder = (function () {
                function MaintenanceOrder() {
                }
                return MaintenanceOrder;
            }());
            models.MaintenanceOrder = MaintenanceOrder;
        })(models = myRepairments.models || (myRepairments.models = {}));
    })(myRepairments = customer.myRepairments || (customer.myRepairments = {}));
})(customer || (customer = {}));
//# sourceMappingURL=MaintenanceOrder.js.map
var customer;
(function (customer) {
    var myRepairments;
    (function (myRepairments) {
        var models;
        (function (models) {
            var MaintenanceRequest = (function () {
                function MaintenanceRequest() {
                }
                return MaintenanceRequest;
            }());
            models.MaintenanceRequest = MaintenanceRequest;
        })(models = myRepairments.models || (myRepairments.models = {}));
    })(myRepairments = customer.myRepairments || (customer.myRepairments = {}));
})(customer || (customer = {}));
//# sourceMappingURL=MaintenanceRequest.js.map
var customer;
(function (customer) {
    var myTimeline;
    (function (myTimeline) {
        var models;
        (function (models) {
            var interaction = (function () {
                function interaction() {
                }
                return interaction;
            }());
            models.interaction = interaction;
        })(models = myTimeline.models || (myTimeline.models = {}));
    })(myTimeline = customer.myTimeline || (customer.myTimeline = {}));
})(customer || (customer = {}));
//# sourceMappingURL=Interaction.js.map
var customer;
(function (customer) {
    var myTimeline;
    (function (myTimeline) {
        var models;
        (function (models) {
            var interactionTemplate = (function () {
                function interactionTemplate() {
                }
                return interactionTemplate;
            }());
            models.interactionTemplate = interactionTemplate;
        })(models = myTimeline.models || (myTimeline.models = {}));
    })(myTimeline = customer.myTimeline || (customer.myTimeline = {}));
})(customer || (customer = {}));
//# sourceMappingURL=interactionTemplate.js.map
var customer;
(function (customer) {
    var newRepairment;
    (function (newRepairment) {
        var models;
        (function (models) {
            var contactDetails = (function () {
                function contactDetails(PhoneNo, Email) {
                    this.PhoneNo = PhoneNo;
                    this.Email = Email;
                }
                return contactDetails;
            }());
            models.contactDetails = contactDetails;
        })(models = newRepairment.models || (newRepairment.models = {}));
    })(newRepairment = customer.newRepairment || (customer.newRepairment = {}));
})(customer || (customer = {}));
//# sourceMappingURL=contactDetails.js.map
var customer;
(function (customer) {
    var newRepairment;
    (function (newRepairment) {
        var models;
        (function (models) {
            var costConfirmationDetails = (function () {
                function costConfirmationDetails() {
                }
                return costConfirmationDetails;
            }());
            models.costConfirmationDetails = costConfirmationDetails;
        })(models = newRepairment.models || (newRepairment.models = {}));
    })(newRepairment = customer.newRepairment || (customer.newRepairment = {}));
})(customer || (customer = {}));
//# sourceMappingURL=costConfirmationDetails.js.map
var customer;
(function (customer) {
    var newRepairment;
    (function (newRepairment) {
        var models;
        (function (models) {
            var defectDescriptionDetails = (function () {
                function defectDescriptionDetails() {
                    this.Images = [];
                }
                return defectDescriptionDetails;
            }());
            models.defectDescriptionDetails = defectDescriptionDetails;
        })(models = newRepairment.models || (newRepairment.models = {}));
    })(newRepairment = customer.newRepairment || (customer.newRepairment = {}));
})(customer || (customer = {}));
//# sourceMappingURL=defectDescriptionDetails.js.map
var customer;
(function (customer) {
    var newRepairment;
    (function (newRepairment) {
        var models;
        (function (models) {
            var defectSelectionDetails = (function () {
                function defectSelectionDetails(appliedSearchValue) {
                    if (appliedSearchValue === void 0) { appliedSearchValue = ''; }
                    this.appliedSearchValue = appliedSearchValue;
                }
                return defectSelectionDetails;
            }());
            models.defectSelectionDetails = defectSelectionDetails;
        })(models = newRepairment.models || (newRepairment.models = {}));
    })(newRepairment = customer.newRepairment || (customer.newRepairment = {}));
})(customer || (customer = {}));
//# sourceMappingURL=defectSelectionDetails.js.map
var customer;
(function (customer) {
    var newRepairment;
    (function (newRepairment) {
        var models;
        (function (models) {
            var objectSelectionDetails = (function () {
                function objectSelectionDetails(realtyObjectNo, selectedContract, showCommonAreaFilter) {
                    if (selectedContract === void 0) { selectedContract = null; }
                    if (showCommonAreaFilter === void 0) { showCommonAreaFilter = false; }
                    this.realtyObjectNo = realtyObjectNo;
                    this.selectedContract = selectedContract;
                    this.showCommonAreaFilter = showCommonAreaFilter;
                }
                return objectSelectionDetails;
            }());
            models.objectSelectionDetails = objectSelectionDetails;
        })(models = newRepairment.models || (newRepairment.models = {}));
    })(newRepairment = customer.newRepairment || (customer.newRepairment = {}));
})(customer || (customer = {}));
//# sourceMappingURL=objectSelectionDetails.js.map
var customer;
(function (customer) {
    var newRepairment;
    (function (newRepairment) {
        var models;
        (function (models) {
            var requestSubmissionDetails = (function () {
                function requestSubmissionDetails() {
                }
                return requestSubmissionDetails;
            }());
            models.requestSubmissionDetails = requestSubmissionDetails;
        })(models = newRepairment.models || (newRepairment.models = {}));
    })(newRepairment = customer.newRepairment || (customer.newRepairment = {}));
})(customer || (customer = {}));
//# sourceMappingURL=requestSubmissionDetails.js.map
var customer;
(function (customer) {
    var newRepairment;
    (function (newRepairment) {
        var models;
        (function (models) {
            var wizardData = (function () {
                function wizardData() {
                }
                return wizardData;
            }());
            models.wizardData = wizardData;
        })(models = newRepairment.models || (newRepairment.models = {}));
    })(newRepairment = customer.newRepairment || (customer.newRepairment = {}));
})(customer || (customer = {}));
//# sourceMappingURL=wizardData.js.map
var customer;
(function (customer) {
    var newRepairment;
    (function (newRepairment) {
        var controller = (function () {
            function controller($state, $q, contractService, repairmentsService, localize, alerting) {
                var _this = this;
                this.$state = $state;
                this.$q = $q;
                this.contractService = contractService;
                this.repairmentsService = repairmentsService;
                this.localize = localize;
                this.alerting = alerting;
                this.oldSearchDate = null;
                this.planningSubmitting = false;
                this.$inject = ["$state", "$q", "contractService", "repairmentsService", "localize", "alerting"];
                this.loadTimeSlots = function (selectedDate) {
                    if (!selectedDate)
                        return;
                    delete _this.formContainer.selectedPlanSuggestion;
                    var searchDate = selectedDate;
                    if (selectedDate.format)
                        searchDate = selectedDate.format('YYYY-MM-DD');
                    if (searchDate === _this.oldSearchDate)
                        return;
                    _this.oldSearchDate = searchDate;
                    _this.repairmentsService.getPlanningData(_this.selectedContact.CompanyName, _this.maintenanceRequestNo, searchDate).then(_this.getLoadTimeSlotsCallback(selectedDate));
                };
                this.getLoadTimeSlotsCallback = function (selectedDate) {
                    return function (data) {
                        _this.formContainer.TimeSlots = null;
                        if (data.success === true) {
                            _this.planningData = data.data;
                            if (selectedDate.isBefore(_this.planningData.PlanDate, 'day')) {
                                _this.minimumDate = new moment(_this.planningData.PlanDate);
                            }
                            if (_this.planningData.Periods.length > 0) {
                                _this.processPeriods();
                            }
                            else if (_this.planningData.ConnectItProposals.length > 0) {
                                _this.processConnectItProposals();
                            }
                            else if (_this.planningData.InspectionAppointments.length > 0) {
                                _this.processInspectionAppointments();
                            }
                        }
                    };
                };
                this.getPlanningDelayCallBack = function (data) {
                    if (data.success === true) {
                        _this.maintenanceOrderPlanningDelay = data.data.CustomerPortalModules.TermPlanningMaintenanceOrder;
                        _this.repairInspectionPlanningDelay = data.data.CustomerPortalModules.TermPlanningRepairInspection;
                        _this.minimumDate = _this.computeMinDate();
                    }
                };
                this.computeMinDate = function () {
                    if (_this.wizardData.defectSelection.selectedSpecification.Urgent === true) {
                        return moment();
                    }
                    var date = moment().add(1, 'days');
                    var delay = 0;
                    if (_this.wizardData.requestSubmission.repairTemplate.InspectionTemplate) {
                        delay = _this.repairInspectionPlanningDelay;
                    }
                    else {
                        delay = _this.maintenanceOrderPlanningDelay;
                    }
                    if (delay) {
                        var nonWorkingDays = 0;
                        for (var i = 1; i <= delay; i++) {
                            var dayNumber = moment().add(i + 1, 'days').day();
                            if (dayNumber === 0 || dayNumber === 6)
                                nonWorkingDays += 1;
                        }
                        var daysToAdd = delay + nonWorkingDays;
                        date.add(daysToAdd, 'days');
                        if (date.day() === 0) {
                            date.add(1, 'days');
                        }
                        if (date.day() === 6) {
                            date.add(2, 'days');
                        }
                    }
                    return date;
                };
                this.formContainer = {};
                this.minimumDate = null;
            }
            controller.prototype.$onInit = function () {
                this.activate();
            };
            controller.prototype.activate = function () {
                this.appointmentNeeded = this.wizardData.defectSelection.selectedSpecification.AppointmentNeeded;
                this.alreadyRedirected = false;
                this.repairmentsService.getPlanningDelay().then(this.getPlanningDelayCallBack);
                if (this.appointmentNeeded) {
                    this.selectedContact = this.wizardData.objectSelection.selectedContract;
                    this.maintenanceRequestNo = this.wizardData.requestSubmission.maintenanceRequestNo;
                    this.initializePlanner();
                }
            };
            controller.prototype.initializePlanner = function () {
                if (this.wizardData.defectSelection.selectedSpecification.Urgent === true) {
                    this.minimumDate = moment();
                }
                else {
                    this.minimumDate = this.computeMinDate();
                }
            };
            controller.prototype.processPeriods = function () {
                var timeSlots = [];
                angular.forEach(this.planningData.Periods, function (item) {
                    timeSlots.push({
                        Description: item.Description,
                        Item: item
                    });
                });
                if (timeSlots.length > 0) {
                    this.formContainer.TimeSlots = timeSlots;
                }
            };
            controller.prototype.processConnectItProposals = function () {
                var timeSlots = [];
                angular.forEach(this.planningData.ConnectItProposals, function (item) {
                    timeSlots.push({
                        Description: item.BlockTimeFrom + ' - ' + item.BlockTimeUntil,
                        Item: item
                    });
                });
                if (timeSlots.length > 0) {
                    this.formContainer.TimeSlots = timeSlots;
                }
            };
            controller.prototype.processInspectionAppointments = function () {
                var timeSlots = [];
                angular.forEach(this.planningData.InspectionAppointments, function (item) {
                    timeSlots.push({
                        Description: item.StartTime + ' - ' + item.EndTime,
                        Item: item
                    });
                });
                if (timeSlots.length > 0) {
                    this.formContainer.TimeSlots = timeSlots;
                }
            };
            controller.prototype.planMaintenanceRequest = function (planDetailsForm) {
                var _this = this;
                if (planDetailsForm.$invalid) {
                    return;
                }
                this.planningSubmitting = true;
                var updatePlanningData = {
                    MaintenanceRequestNo: this.maintenanceRequestNo,
                    PlanDate: this.formContainer.selectedTimeSlot.Date.format("YYYY-MM-DD")
                };
                if (this.planningData.Periods.length > 0) {
                    updatePlanningData.Periods = [this.formContainer.selectedTimeSlot.TimeSlot];
                }
                else if (this.planningData.ConnectItProposals.length > 0) {
                    updatePlanningData.ConnectItProposals = [this.formContainer.selectedTimeSlot.TimeSlot];
                }
                else if (this.planningData.InspectionAppointments.length > 0) {
                    updatePlanningData.InspectionAppointments = [this.formContainer.selectedTimeSlot.TimeSlot];
                }
                this.repairmentsService.updatePlanningData(this.selectedContact.CompanyName, updatePlanningData).then(function (result) {
                    if (!result.success) {
                        var message = _this.localize.getLocalizedString('Message_ErrorUpdatingPlanningData', 'NewRepairments');
                        _this.alerting.popError(message);
                    }
                    _this.planningSubmitting = false;
                    _this.$state.go('repairments');
                }, function (error) {
                    _this.planningSubmitting = false;
                });
            };
            return controller;
        }());
        angular
            .module('customer.newRepairment')
            .component('appointmentPlanner', {
            bindings: {
                wizardData: '='
            },
            controller: controller,
            templateUrl: '/App/newRepairment/wizardPages/appointmentPlanner.html'
        });
    })(newRepairment = customer.newRepairment || (customer.newRepairment = {}));
})(customer || (customer = {}));
//# sourceMappingURL=appointmentPlanner.component.js.map
var customer;
(function (customer) {
    var newRepairment;
    (function (newRepairment) {
        var controller = (function () {
            function controller($state, $q, $timeout, contractService, repairmentsService, localize, alerting, emailChangeDialog) {
                var _this = this;
                this.$state = $state;
                this.$q = $q;
                this.$timeout = $timeout;
                this.contractService = contractService;
                this.repairmentsService = repairmentsService;
                this.localize = localize;
                this.alerting = alerting;
                this.emailChangeDialog = emailChangeDialog;
                this.$inject = ["$state", "$q", "$timeout", "contractService", "repairmentsService", "localize", "alerting", "emailChangeDialog"];
                this.moveToRequestSubmission = function (contactInfoForm) {
                    if (contactInfoForm.$invalid) {
                        return;
                    }
                    if (_this.formContainer.PhoneNo !== _this.formContainer.phoneToSave) {
                        _this.formContainer.savePhone = false;
                        _this.formContainer.phoneToSave = null;
                    }
                    if (_this.formContainer.Email !== _this.formContainer.emailToSave) {
                        _this.formContainer.saveEmail = false;
                        _this.formContainer.emailToSave = null;
                    }
                    var phoneChanged = !_this.formContainer.phoneToSave && _this.formContainer.PhoneNo !== _this.wizardData.customerDetails.PhoneNo;
                    var emailChanged = !_this.formContainer.emailToSave && _this.formContainer.Email !== _this.wizardData.customerDetails.Email;
                    _this.collectUserInput(phoneChanged, emailChanged).then(function (userInput) {
                        if (phoneChanged) {
                            _this.wizardData.contactDetails.savePhone = userInput.savePhone;
                        }
                        if (emailChanged) {
                            _this.wizardData.contactDetails.saveEmail = userInput.saveEmail;
                        }
                        if (userInput.savePhone) {
                            _this.wizardData.contactDetails.phoneToSave = _this.formContainer.PhoneNo;
                        }
                        if (userInput.saveEmail) {
                            _this.wizardData.contactDetails.emailToSave = _this.formContainer.Email;
                        }
                        _this.transitionToRequestSubmission();
                    });
                };
                this.saveEmailDialog = function () {
                    var email = _this.wizardData.customerDetails.Email;
                    if (!email || email === '') {
                        email = 'geen';
                    }
                    ;
                    var message = _this.getResourceString("Message_EmailUpdate", [_this.formContainer.Email, email]);
                    var title = _this.getResourceString("Title_EmailUpdate");
                    var buttonYes = _this.getResourceString("Button_ForThisRequest");
                    var buttonNo = _this.getResourceString("Button_ChangeInAdministration");
                    return _this.alerting.confirm(message, title, buttonYes, buttonNo, "xlg", true);
                };
                this.savePhoneDialog = function () {
                    var phoneNo = _this.wizardData.customerDetails.PhoneNo;
                    if (!phoneNo || phoneNo === '') {
                        phoneNo = 'geen';
                    }
                    ;
                    var message = _this.getResourceString("Message_PhoneUpdate", [_this.formContainer.PhoneNo, phoneNo]);
                    var title = _this.getResourceString("Title_PhoneUpdate");
                    var buttonYes = _this.getResourceString("Button_ForThisRequest");
                    var buttonNo = _this.getResourceString("Button_ChangeInAdministration");
                    return _this.alerting.confirm(message, title, buttonYes, buttonNo, "xlg", true);
                };
                this.delay = function (milliseconds) {
                    return function () {
                        return _this.$timeout(function () { }, milliseconds);
                    };
                };
            }
            controller.prototype.$onInit = function () {
                this.formContainer = new newRepairment.models.contactDetails(this.wizardData.customerDetails.PhoneNo, this.wizardData.customerDetails.Email);
                this.activate();
            };
            controller.prototype.activate = function () {
                if (this.wizardData.contactDetails) {
                    this.formContainer = this.wizardData.contactDetails;
                }
                else {
                    this.wizardData.contactDetails = this.formContainer;
                }
            };
            controller.prototype.transitionToRequestSubmission = function () {
                this.$state.transitionTo('newRepairment.requestSubmission');
            };
            controller.prototype.collectUserInput = function (phoneChanged, emailChanged) {
                var _this = this;
                var deferred = this.$q.defer();
                var dialogs = [];
                if (phoneChanged) {
                    dialogs.push({ name: "savePhone", display: this.savePhoneDialog, userResponse: false });
                }
                if (emailChanged) {
                    dialogs.push({ name: "saveEmail", display: this.saveEmailDialog, checkPassword: this.emailChangeDialog.checkPassword, userResponse: false });
                }
                var chain = this.$q.when({});
                angular.forEach(dialogs, function (dialog, index) {
                    chain = chain.then(function () {
                        var dialogDismissed = _this.$q.defer();
                        dialog.display().then(function (forThisRequest) {
                            dialog.userResponse = !forThisRequest;
                            if (forThisRequest) {
                                dialogDismissed.resolve();
                            }
                            else {
                                if (dialog.checkPassword) {
                                    dialog
                                        .checkPassword()
                                        .then(function () {
                                        dialog.userResponse = true;
                                        dialogDismissed.resolve();
                                    })
                                        .catch(function () {
                                        dialog.userResponse = false;
                                        dialogDismissed.resolve();
                                    });
                                }
                                else {
                                    dialogDismissed.resolve();
                                }
                            }
                        });
                        return dialogDismissed.promise;
                    });
                    if (index !== dialogs.length - 1) {
                        chain = chain.then(_this.delay(250));
                    }
                });
                chain.then(function () {
                    var result = {};
                    angular.forEach(dialogs, function (dialog) {
                        result[dialog.name] = dialog.userResponse;
                    });
                    deferred.resolve(result);
                });
                return deferred.promise;
            };
            controller.prototype.getResourceString = function (key, values) {
                if (values === void 0) { values = null; }
                return this.localize.getLocalizedString(key, "NewRepairments", values);
            };
            return controller;
        }());
        angular
            .module('customer.newRepairment')
            .component('contactDetails', {
            bindings: {
                wizardData: '='
            },
            controller: controller,
            templateUrl: '/App/newRepairment/wizardPages/contactDetails.html'
        });
    })(newRepairment = customer.newRepairment || (customer.newRepairment = {}));
})(customer || (customer = {}));
//# sourceMappingURL=contactDetails.component.js.map
var customer;
(function (customer) {
    var newRepairment;
    (function (newRepairment) {
        var controller = (function () {
            function controller($state, $q, $filter, contractService, repairmentsService, localize, alerting) {
                var _this = this;
                this.$state = $state;
                this.$q = $q;
                this.$filter = $filter;
                this.contractService = contractService;
                this.repairmentsService = repairmentsService;
                this.localize = localize;
                this.alerting = alerting;
                this.$inject = ["$state", "$q", "filter", "contractService", "repairmentsService", "localize", "alerting"];
                this.getSubjectChargedCallback = function (response) {
                    if (response.success === true && response.data) {
                        var data = response.data;
                        if (data.ChargeCustomer) {
                            _this.formContainer.customerCharged = true;
                            if (data.ServiceContract) {
                                _this.formContainer.costsInfoMessage = _this.localize.getLocalizedString('Label_CostsChargedDueToMissingServiceSubscription', 'NewRepairments');
                            }
                            else {
                                _this.formContainer.costsInfoMessage = _this.localize.getLocalizedString('Label_CostsCharged', 'NewRepairments');
                            }
                            if (data.TotalChargeAmountInclVAT) {
                                _this.formContainer.customerChargedAmount = parseFloat(data.TotalChargeAmountInclVAT);
                            }
                            else {
                                _this.formContainer.customerChargedAmount = 0;
                            }
                            if (_this.formContainer.customerChargedAmount > 0) {
                                if (data.ChargeCalculation) {
                                    _this.formContainer.customerChargedMessage = _this.localize.getLocalizedString('Label_CostsMinimumAmount', 'NewRepairments', _this.$filter('number')(_this.formContainer.customerChargedAmount, 2));
                                }
                                else {
                                    _this.formContainer.customerChargedMessage = _this.localize.getLocalizedString('Label_CostsAmount', 'NewRepairments', _this.$filter('number')(_this.formContainer.customerChargedAmount, 2));
                                }
                            }
                            else {
                                if (data.ChargeCalculation) {
                                    _this.formContainer.customerChargedMessage = _this.localize.getLocalizedString('Label_CostsPercentage', 'NewRepairments');
                                }
                            }
                        }
                        else {
                            _this.formContainer.customerCharged = false;
                            delete _this.formContainer.customerChargedAmount;
                            delete _this.formContainer.customerChargedMessage;
                            if (data.ServiceContract) {
                                _this.formContainer.costsInfoMessage = _this.localize.getLocalizedString('Label_NoCostsChargedDueToServiceSubscription', 'NewRepairments');
                            }
                            else {
                                _this.formContainer.costsInfoMessage = _this.localize.getLocalizedString('Label_NoCostsCharged', 'NewRepairments');
                            }
                        }
                    }
                    else {
                        var message = _this.localize.getLocalizedString('Message_GenericError', 'NewRepairments');
                        _this.alerting.popError(message);
                    }
                };
                this.formContainer = new newRepairment.models.costConfirmationDetails();
            }
            controller.prototype.$onInit = function () {
                this.activate();
            };
            controller.prototype.activate = function () {
                if (this.wizardData.costConfirmation) {
                    this.formContainer = this.wizardData.costConfirmation;
                }
                else {
                    this.wizardData.costConfirmation = this.formContainer;
                }
                this.getCustomerCharged();
            };
            controller.prototype.getCustomerCharged = function () {
                var causeCode = "";
                if (this.wizardData.defectSelection.selectedCause) {
                    causeCode = this.wizardData.defectSelection.selectedCause.Code;
                }
                this.repairmentsService.getCustomerCharged(this.wizardData.objectSelection.selectedContract.CompanyName, this.wizardData.objectSelection.realtyObjectNo, this.wizardData.defectSelection.selectedSpecification.EntryNo, causeCode).then(this.getSubjectChargedCallback);
            };
            controller.prototype.moveToDefectDescription = function (costConfirmationForm) {
                if (costConfirmationForm.$invalid) {
                    return;
                }
                this.$state.transitionTo('newRepairment.defectDescription');
            };
            return controller;
        }());
        angular
            .module('customer.newRepairment')
            .component('costConfirmation', {
            bindings: {
                wizardData: '='
            },
            controller: controller,
            templateUrl: '/App/newRepairment/wizardPages/costConfirmation.html'
        });
    })(newRepairment = customer.newRepairment || (customer.newRepairment = {}));
})(customer || (customer = {}));
;
//# sourceMappingURL=costConfirmation.component.js.map
var customer;
(function (customer) {
    var newRepairment;
    (function (newRepairment) {
        var controller = (function () {
            function controller($state, $q, contractService, repairmentsService, localize, alerting) {
                this.$state = $state;
                this.$q = $q;
                this.contractService = contractService;
                this.repairmentsService = repairmentsService;
                this.localize = localize;
                this.alerting = alerting;
                this.$inject = ["$state", "$q", "contractService", "repairmentsService", "localize", "alerting"];
                this.formContainer = new newRepairment.models.defectDescriptionDetails();
            }
            controller.prototype.$onInit = function () {
                this.activate();
            };
            controller.prototype.activate = function () {
                if (this.wizardData.defectDescription) {
                    this.formContainer = this.wizardData.defectDescription;
                }
                else {
                    this.wizardData.defectDescription = this.formContainer;
                }
                this.descriptionRequired = this.wizardData.defectSelection.selectedSpecification.AdditionalDescriptionRequired;
            };
            controller.prototype.moveToContactDetails = function (defectDescriptionForm) {
                if (defectDescriptionForm.$invalid) {
                    return;
                }
                this.$state.transitionTo('newRepairment.contactDetails');
            };
            return controller;
        }());
        angular
            .module('customer.newRepairment')
            .component('defectDescription', {
            bindings: {
                wizardData: '='
            },
            controller: controller,
            templateUrl: '/App/newRepairment/wizardPages/defectDescription.html'
        });
    })(newRepairment = customer.newRepairment || (customer.newRepairment = {}));
})(customer || (customer = {}));
//# sourceMappingURL=defectDescription.component.js.map
var customer;
(function (customer) {
    var newRepairment;
    (function (newRepairment) {
        var controller = (function () {
            function controller($state, $q, contractService, repairmentsService, localize, alerting) {
                var _this = this;
                this.$state = $state;
                this.$q = $q;
                this.contractService = contractService;
                this.repairmentsService = repairmentsService;
                this.localize = localize;
                this.alerting = alerting;
                this.$inject = ['$state', '$q', 'contractService', 'repairmentsService', 'localize', 'alerting'];
                this.getCausesCallback = function (data) {
                    if (data.success === true) {
                        _this.formContainer.causes = data.data;
                    }
                    else {
                        var message = _this.localize.getLocalizedString('Message_FailedToLoadCauses', 'NewRepairments');
                        _this.alerting.popError(message);
                    }
                };
                this.getRoomTypesCallback = function (data) {
                    if (data.success === true) {
                        _this.formContainer.rooms = data.data;
                        if (_this.formContainer.rooms && _this.formContainer.rooms.length === 1) {
                            _this.selectRoom(_this.formContainer.rooms[0]);
                        }
                    }
                    else {
                        var message = _this.localize.getLocalizedString('Message_FailedToLoadRoomTypes', 'NewRepairments');
                        if (data.data && !data.data.success && data.data.fullMessage) {
                            var fullMessage = JSON.parse(data.data.fullMessage);
                            if (fullMessage && fullMessage.message) {
                                message = fullMessage.message;
                            }
                        }
                        _this.formContainer.rooms = null;
                        _this.alerting.popError(message);
                    }
                };
                this.getConstructionPartsCallback = function (selections) {
                    return function (data) {
                        if (data.success === true) {
                            _this.formContainer.elements = data.data;
                            if (_this.formContainer.elements && _this.formContainer.elements.length === 1) {
                                _this.selectElement(_this.formContainer.elements[0], selections);
                            }
                            else {
                                _this.applySelections(selections);
                            }
                        }
                        else {
                            var message = _this.localize.getLocalizedString('Message_FailedToLoadConstructionParts', 'NewRepairments');
                            _this.alerting.popError(message);
                        }
                    };
                };
                this.getPartsCallback = function (selections) {
                    return function (data) {
                        if (data.success === true) {
                            _this.formContainer.parts = data.data;
                            if (_this.formContainer.parts && _this.formContainer.parts.length === 1) {
                                _this.selectPart(_this.formContainer.parts[0], selections);
                            }
                            else {
                                _this.applySelections(selections);
                            }
                        }
                        else {
                            var message = _this.localize.getLocalizedString('Message_FailedToLoadParts', 'NewRepairments');
                            _this.alerting.popError(message);
                        }
                    };
                };
                this.getIssuesCallback = function (selections) {
                    return function (data) {
                        if (data.success === true) {
                            _this.formContainer.defects = data.data;
                            if (_this.formContainer.defects && _this.formContainer.defects.length === 1) {
                                _this.selectDefect(_this.formContainer.defects[0], selections, null);
                            }
                            else {
                                _this.applySelections(selections);
                            }
                        }
                        else {
                            var message = _this.localize.getLocalizedString('Message_FailedToLoadIssues', 'NewRepairments');
                            _this.alerting.popError(message);
                        }
                    };
                };
                this.getSpecificationsCallback = function (data) {
                    if (data.success === true) {
                        _this.formContainer.specifications = data.data;
                        if (_this.formContainer.specifications.length === 1) {
                            _this.formContainer.selectedSpecification = _this.formContainer.specifications[0];
                            _this.selectSpecification();
                        }
                    }
                    else {
                        var message = _this.localize.getLocalizedString('Message_FailedToLoadSpecifications', 'NewRepairments');
                        _this.alerting.popError(message);
                    }
                };
                this.getRepairTemplateCallback = function (data) {
                    if (data.success === true) {
                        _this.formContainer.repairTemplate = data.data;
                        delete _this.formContainer.selectedSolutionTip;
                        if (_this.formContainer.repairTemplate.SolutionTips.length == 1) {
                            _this.formContainer.selectedSolutionTip = _this.formContainer.repairTemplate.SolutionTips[0];
                        }
                        _this.formContainer.solutionTipsSolveIssue = 'false';
                        if (_this.formContainer.selectedSpecification.CauseRequest &&
                            _this.formContainer.causes.length >= 1) {
                            var selectedCause;
                            angular.forEach(_this.formContainer.causes, function (item) {
                                if (item.Default) {
                                    selectedCause = item;
                                }
                            });
                            _this.formContainer.selectedCause = selectedCause;
                        }
                        else {
                            _this.formContainer.selectedCause = undefined;
                        }
                    }
                    else {
                        var message = _this.localize.getLocalizedString('Message_FailedToLoadRepairTemplate', 'NewRepairments');
                        _this.alerting.popError(message);
                    }
                };
                this.canCreateMaintenanceRequestCallback = function (data) {
                    if (data.success === true) {
                        if (!data.data.CreateAllowed) {
                            _this.alerting.popInfo(data.data.Message);
                        }
                        else {
                            if (_this.formContainer.repairTemplate.InspectionTemplate) {
                                _this.$state.transitionTo('newRepairment.defectDescription');
                            }
                            else {
                                _this.$state.transitionTo('newRepairment.costConfirmation');
                            }
                        }
                    }
                    else {
                        var message = _this.localize.getLocalizedString('Message_GenericError', 'NewRepairments');
                        _this.alerting.popError(message);
                    }
                };
                this.imagePath = '/Content/images/repairment/';
                this.formContainer = new newRepairment.models.defectSelectionDetails('');
            }
            controller.prototype.$onInit = function () {
                this.activate();
            };
            controller.prototype.activate = function () {
                if (this.wizardData.defectSelection) {
                    this.formContainer = this.wizardData.defectSelection;
                }
                else {
                    this.wizardData.defectSelection = this.formContainer;
                    this.loadRoomTypes();
                    this.repairmentsService.getCauses(this.wizardData.objectSelection.selectedContract.CompanyName).then(this.getCausesCallback);
                }
            };
            controller.prototype.applySelections = function (selections) {
                if (selections.selectedPart) {
                    this.formContainer.selectedPart = selections.selectedPart;
                }
                if (selections.selectedElement) {
                    this.formContainer.selectedElement = selections.selectedElement;
                }
                if (selections.selectedRoom) {
                    this.formContainer.selectedRoom = selections.selectedRoom;
                }
            };
            controller.prototype.loadRoomTypes = function () {
                this.repairmentsService.getRoomTypes(this.wizardData.objectSelection.selectedContract.CompanyName, this.wizardData.objectSelection.realtyObjectNo, this.formContainer.appliedSearchValue).then(this.getRoomTypesCallback);
            };
            controller.prototype.selectRoom = function (selectedRoom) {
                this.repairmentsService.getConstructionParts(this.wizardData.objectSelection.selectedContract.CompanyName, this.wizardData.objectSelection.realtyObjectNo, selectedRoom.Code, this.formContainer.appliedSearchValue).then(this.getConstructionPartsCallback({ selectedRoom: selectedRoom }));
            };
            controller.prototype.selectElement = function (selectedElement, selections) {
                if (!selections) {
                    selections = { selectedRoom: this.formContainer.selectedRoom };
                }
                selections.selectedElement = selectedElement;
                this.repairmentsService.getParts(this.wizardData.objectSelection.selectedContract.CompanyName, this.wizardData.objectSelection.realtyObjectNo, selections.selectedRoom.Code, selections.selectedElement.Code, this.formContainer.appliedSearchValue).then(this.getPartsCallback(selections));
            };
            controller.prototype.selectPart = function (selectedPart, selections) {
                if (!selections) {
                    selections = {
                        selectedRoom: this.formContainer.selectedRoom,
                        selectedElement: this.formContainer.selectedElement
                    };
                }
                selections.selectedPart = selectedPart;
                this.repairmentsService.getIssues(this.wizardData.objectSelection.selectedContract.CompanyName, this.wizardData.objectSelection.realtyObjectNo, selections.selectedRoom.Code, selections.selectedElement.Code, selections.selectedPart.Code, this.formContainer.appliedSearchValue).then(this.getIssuesCallback(selections));
            };
            controller.prototype.selectDefect = function (selectedDefect, selections, defectSelectionForm) {
                this.resetForm(defectSelectionForm);
                this.formContainer.selectedDefect = selectedDefect;
                if (selections) {
                    this.applySelections(selections);
                }
                this.repairmentsService.getSpecifications(this.wizardData.objectSelection.selectedContract.CompanyName, this.wizardData.objectSelection.realtyObjectNo, this.formContainer.selectedRoom.Code, this.formContainer.selectedElement.Code, this.formContainer.selectedPart.Code, this.formContainer.selectedDefect.Code).then(this.getSpecificationsCallback);
            };
            controller.prototype.selectSpecification = function () {
                if (this.formContainer.selectedSpecification != null && this.formContainer.selectedSpecification.RepairTemplateCode != '') {
                    this.repairmentsService.getRepairTemplate(this.wizardData.objectSelection.selectedContract.CompanyName, this.formContainer.selectedSpecification.RepairTemplateCode).then(this.getRepairTemplateCallback);
                }
            };
            controller.prototype.getImagePath = function (pictureName) {
                var path = ' ';
                if (pictureName && pictureName !== '') {
                    path = this.imagePath + pictureName;
                }
                return path;
            };
            controller.prototype.toRoomTypeSelection = function (defectSelectionForm) {
                this.resetForm(defectSelectionForm);
                delete this.formContainer.selectedRoom;
                delete this.formContainer.selectedElement;
                delete this.formContainer.selectedPart;
                delete this.formContainer.selectedDefect;
                delete this.formContainer.selectedSpecification;
                delete this.formContainer.selectedCause;
                this.formContainer.elements = null;
                this.formContainer.parts = null;
                this.formContainer.defects = null;
                this.formContainer.specifications = null;
                this.formContainer.repairTemplate = null;
            };
            controller.prototype.toElementSelection = function (defectSelectionForm) {
                this.resetForm(defectSelectionForm);
                delete this.formContainer.selectedElement;
                delete this.formContainer.selectedPart;
                delete this.formContainer.selectedDefect;
                delete this.formContainer.selectedSpecification;
                delete this.formContainer.selectedCause;
                this.formContainer.parts = null;
                this.formContainer.defects = null;
                this.formContainer.specifications = null;
                this.formContainer.repairTemplate = null;
            };
            controller.prototype.toPartSelection = function (defectSelectionForm) {
                this.resetForm(defectSelectionForm);
                delete this.formContainer.selectedPart;
                delete this.formContainer.selectedDefect;
                delete this.formContainer.selectedSpecification;
                delete this.formContainer.selectedCause;
                this.formContainer.defects = null;
                this.formContainer.specifications = null;
                this.formContainer.repairTemplate = null;
            };
            controller.prototype.toDefectSelection = function (defectSelectionForm) {
                this.resetForm(defectSelectionForm);
                delete this.formContainer.selectedDefect;
                delete this.formContainer.selectedSpecification;
                delete this.formContainer.selectedCause;
                this.formContainer.specifications = null;
                this.formContainer.repairTemplate = null;
            };
            controller.prototype.resetForm = function (defectSelectionForm) {
                if (defectSelectionForm) {
                    defectSelectionForm.$setUntouched();
                    defectSelectionForm.$setPristine();
                }
            };
            controller.prototype.causeSelectionRequired = function () {
                if (!this.formContainer.repairTemplate) {
                    return false;
                }
                var result = (this.formContainer.repairTemplate.SolutionTips.length === 0 ||
                    this.formContainer.repairTemplate.SolutionTips.length >= 1 && this.formContainer.solutionTipsSolveIssue !== "true")
                    && this.formContainer.selectedSpecification.CauseRequest === true;
                return result;
            };
            controller.prototype.doSearch = function () {
                if (this.formContainer.searchValue === '' ||
                    (this.formContainer.searchValue.length >= 3 && /[A-Za-z0-9 ]/.test(this.formContainer.searchValue))) {
                    this.formContainer.appliedSearchValue = this.formContainer.searchValue;
                    this.toRoomTypeSelection(null);
                    this.loadRoomTypes();
                }
                else {
                    this.formContainer.appliedSearchValue = '';
                    this.toRoomTypeSelection(null);
                    this.formContainer.rooms = null;
                }
            };
            controller.prototype.moveToCostConfirmation = function (defectSelectionForm) {
                if (defectSelectionForm && defectSelectionForm.$invalid) {
                    return;
                }
                this.repairmentsService.canCreateMaintenanceRequest(this.wizardData.objectSelection.selectedContract.CompanyName, this.wizardData.objectSelection.realtyObjectNo, this.formContainer.selectedSpecification.EntryNo, (this.formContainer.selectedSpecification.CauseRequest ? this.formContainer.selectedCause.Code : '')).then(this.canCreateMaintenanceRequestCallback);
            };
            controller.prototype.canCreateMaintenanceRequest = function () {
                var result = this.formContainer.solutionTipsSolveIssue != 'true'
                    && this.formContainer.selectedSpecification
                    && this.formContainer.selectedSpecification.RepairTemplateCode != '';
                return result;
            };
            controller.prototype.reportDefectSolved = function (defectSelectionForm) {
                var _this = this;
                if (defectSelectionForm && defectSelectionForm.$invalid) {
                    return;
                }
                var maintenanceRequest = {
                    CompanyName: this.wizardData.objectSelection.selectedContract.CompanyName,
                    RealtyObjectNo: this.wizardData.objectSelection.realtyObjectNo,
                    OriginatingRealtyObject: this.wizardData.objectSelection.selectedContract.RentalUnit.No,
                    TemplateCode: this.formContainer.selectedSpecification.EntryNo,
                    FixedBySolutionCode: this.formContainer.selectedSolutionTip.Code
                };
                this.repairmentsService.submitMaintenanceRequest(maintenanceRequest).then(function (data) {
                    if (data.success === true) {
                        if (data.data !== '') {
                            var message = _this.localize.getLocalizedString('Message_MaintenanceRequestSubmitted', 'NewRepairments');
                            _this.alerting.popInfo(message);
                        }
                        else {
                            var message = _this.localize.getLocalizedString('Message_MaintenanceRequestSubmittedForApproval', 'NewRepairments');
                            _this.alerting.popInfo(message);
                        }
                        _this.$state.go('repairments');
                    }
                    else {
                        var message = _this.localize.getLocalizedString('Message_GenericError', 'NewRepairments');
                        _this.alerting.popError(message);
                        _this.$state.go('repairments');
                    }
                });
            };
            return controller;
        }());
        angular
            .module('customer.newRepairment')
            .component('defectSelection', {
            bindings: {
                wizardData: '='
            },
            controller: controller,
            templateUrl: '/App/newRepairment/wizardPages/defectSelection.html'
        });
    })(newRepairment = customer.newRepairment || (customer.newRepairment = {}));
})(customer || (customer = {}));
//# sourceMappingURL=defectSelection.component.js.map
var customer;
(function (customer) {
    var newRepairment;
    (function (newRepairment) {
        var controller = (function () {
            function controller($state, $q, contractService, repairmentsService, localize, alerting) {
                var _this = this;
                this.$state = $state;
                this.$q = $q;
                this.contractService = contractService;
                this.repairmentsService = repairmentsService;
                this.localize = localize;
                this.alerting = alerting;
                this.$inject = ["$state", "$q", "contractService", "repairmentsService", "localize", "alerting"];
                this.customerDetailsCallback = function (data) {
                    if (data.success === true) {
                        _this.customerDetails = data.data;
                        _this.wizardData.customerDetails = data.data;
                        if (_this.customerDetails.ActiveContracts.length == 1) {
                            _this.selectContract(null, _this.customerDetails.ActiveContracts[0]);
                        }
                    }
                    else {
                        var message = _this.localize.getLocalizedString('Message_FailedToLoadCustomerDetails', 'MyDetails');
                        _this.alerting.popError(message);
                    }
                };
                this.canSubmitMaintenanceRequestCallback = function (data) {
                    if (data.success === true) {
                        if (data.data.CreateAllowed !== true) {
                            _this.formContainer.realtyObjectNo = null;
                            _this.alerting.popInfoMarkdown(data.data.Message);
                        }
                    }
                    else {
                        var message = _this.localize.getLocalizedString('Message_GenericError', 'NewRepairments');
                        _this.alerting.popError(message);
                    }
                };
                this.formContainer = new customer.newRepairment.models.objectSelectionDetails(null);
            }
            controller.prototype.$onInit = function () {
                this.activate();
            };
            controller.prototype.activate = function () {
                if (this.wizardData.objectSelection) {
                    this.formContainer = this.wizardData.objectSelection;
                }
                if (this.wizardData.customerDetails) {
                    this.customerDetails = this.wizardData.customerDetails;
                }
                else {
                    this.contractService.getCustomerDetails().then(this.customerDetailsCallback);
                }
            };
            controller.prototype.contractOption = function (contract) {
                return contract.Address + (contract.RentalUnit.City ? ', ' + contract.RentalUnit.City : '');
            };
            controller.prototype.selectContract = function (objectSelectionForm, option) {
                if (option) {
                    this.formContainer.selectedContract = option;
                }
                if (objectSelectionForm) {
                    objectSelectionForm.$setUntouched();
                    objectSelectionForm.$setPristine();
                }
                if (!this.formContainer.selectedContract.RentalUnit.CommonAreas
                    || this.formContainer.selectedContract.RentalUnit.CommonAreas.length === 0) {
                    this.formContainer = new newRepairment.models.objectSelectionDetails(this.formContainer.selectedContract.RentalUnit.No, this.formContainer.selectedContract);
                    this.canSubmitMaintenanceRequest(this.formContainer.selectedContract.CompanyName, this.formContainer.selectedContract.RentalUnit.No);
                }
                else {
                    this.formContainer = new newRepairment.models.objectSelectionDetails(null, this.formContainer.selectedContract, this.showCommonAreaFilter(this.formContainer.selectedContract));
                }
            };
            controller.prototype.selectCommonArea = function (option) {
                if (option) {
                    this.formContainer.selectedCommonArea = option;
                }
                if (!this.formContainer.selectedCommonArea) {
                    this.formContainer.realtyObjectNo = null;
                    return;
                }
                this.formContainer.realtyObjectNo = this.formContainer.selectedCommonArea.No;
                this.canSubmitMaintenanceRequest(this.formContainer.selectedContract.CompanyName, this.formContainer.selectedCommonArea.No);
            };
            controller.prototype.changeSelectedObject = function (objectSelectionForm) {
                if (objectSelectionForm) {
                    objectSelectionForm.$setUntouched();
                    objectSelectionForm.$setPristine();
                }
                if (this.formContainer.selectedObject === '0') {
                    this.formContainer.realtyObjectNo = this.formContainer.selectedContract.RentalUnit.No;
                    this.canSubmitMaintenanceRequest(this.formContainer.selectedContract.CompanyName, this.formContainer.selectedContract.RentalUnit.No);
                }
                else if (this.formContainer.selectedObject === '1') {
                    if (this.formContainer.selectedContract.RentalUnit.CommonAreas
                        && this.formContainer.selectedContract.RentalUnit.CommonAreas.length == 1) {
                        this.selectCommonArea(this.formContainer.selectedContract.RentalUnit.CommonAreas[0]);
                    }
                    else {
                        this.selectCommonArea(null);
                    }
                }
            };
            controller.prototype.canSubmitMaintenanceRequest = function (companyName, realtyObjectNo) {
                this.repairmentsService.canSubmitMaintenanceRequest(companyName, realtyObjectNo).then(this.canSubmitMaintenanceRequestCallback);
            };
            controller.prototype.showCommonAreaFilter = function (selectedContract) {
                var onBuildingBlock = false;
                var onCluster = false;
                angular.forEach(selectedContract.RentalUnit.CommonAreas, function (area) {
                    if (area.IsWithOGEBuildingBlock) {
                        onBuildingBlock = true;
                    }
                    else {
                        onCluster = true;
                    }
                });
                return onBuildingBlock && onCluster;
            };
            controller.prototype.filterCommonArea = function () {
                var _this = this;
                return function (item) {
                    return _this.formContainer.showCommonAreaFilter === false
                        || _this.formContainer.showAllCommonAreas === true
                        || item.IsWithOGEBuildingBlock === true;
                };
            };
            controller.prototype.moveToDefectSelection = function (objectSelectionForm) {
                if (objectSelectionForm.$invalid) {
                    return;
                }
                this.wizardData.objectSelection = this.formContainer;
                this.$state.transitionTo('newRepairment.defectSelection');
            };
            return controller;
        }());
        angular
            .module('customer.newRepairment')
            .component('objectSelection', {
            bindings: {
                wizardData: '='
            },
            controller: controller,
            templateUrl: '/App/newRepairment/wizardPages/objectSelection.html'
        });
    })(newRepairment = customer.newRepairment || (customer.newRepairment = {}));
})(customer || (customer = {}));
//# sourceMappingURL=objectSelection.component.js.map
var customer;
(function (customer) {
    var newRepairment;
    (function (newRepairment) {
        var maintenanceRequestObject = (function () {
            function maintenanceRequestObject() {
            }
            return maintenanceRequestObject;
        }());
        var maintenanceRequestAttachmentObject = (function () {
            function maintenanceRequestAttachmentObject() {
            }
            return maintenanceRequestAttachmentObject;
        }());
        var attachment = (function () {
            function attachment() {
            }
            return attachment;
        }());
        var controller = (function () {
            function controller($rootScope, $state, $q, contractService, repairmentsService, localize, myDetailsService, progressDialogService) {
                var _this = this;
                this.$rootScope = $rootScope;
                this.$state = $state;
                this.$q = $q;
                this.contractService = contractService;
                this.repairmentsService = repairmentsService;
                this.localize = localize;
                this.myDetailsService = myDetailsService;
                this.progressDialogService = progressDialogService;
                this.requestSubmitting = false;
                this.$inject = ["$rootScope", "$state", "$q", "contractService", "repairmentsService", "localize", "myDetailsService", "progressDialogService"];
                this.updateCustomerDetails = function () {
                    if (!_this.wizardData.contactDetails.savePhone && !_this.wizardData.contactDetails.saveEmail) {
                        return _this.$q.when({});
                    }
                    var email = _this.wizardData.contactDetails.saveEmail ? _this.wizardData.contactDetails.Email : _this.wizardData.customerDetails.Email;
                    var phoneNo = _this.wizardData.contactDetails.savePhone ? _this.wizardData.contactDetails.PhoneNo : _this.wizardData.customerDetails.PhoneNo;
                    return _this.myDetailsService.updateContactDetails(_this.wizardData.customerDetails, email, phoneNo).then(function (response) {
                        if (response.success) {
                            _this.contractService.refreshCustomerDetails();
                        }
                        _this.updateCustomerDetailsFailed = !response.success;
                        return response;
                    });
                };
                this.formContainer = new newRepairment.models.requestSubmissionDetails();
                this.imageItems = {};
            }
            controller.prototype.$onInit = function () {
                this.activate();
            };
            controller.prototype.activate = function () {
                this.wizardData.requestSubmission = this.formContainer;
                this.customerDetails = this.wizardData.customerDetails;
                this.formContainer.selectedContract = this.wizardData.objectSelection.selectedContract;
                this.formContainer.selectedCommonArea = this.wizardData.objectSelection.selectedCommonArea;
                this.formContainer.selectedRoom = this.wizardData.defectSelection.selectedRoom;
                this.formContainer.selectedElement = this.wizardData.defectSelection.selectedElement;
                this.formContainer.selectedPart = this.wizardData.defectSelection.selectedPart;
                this.formContainer.selectedDefect = this.wizardData.defectSelection.selectedDefect;
                this.formContainer.selectedSpecification = this.wizardData.defectSelection.selectedSpecification;
                this.formContainer.selectedCause = this.wizardData.defectSelection.selectedCause;
                this.formContainer.repairTemplate = this.wizardData.defectSelection.repairTemplate;
                if (this.wizardData.costConfirmation) {
                    this.formContainer.customerChargedAmount = this.wizardData.costConfirmation.customerChargedAmount;
                    this.formContainer.customerChargedMessage = this.wizardData.costConfirmation.customerChargedMessage;
                }
                if (this.wizardData.defectDescription) {
                    this.formContainer.defectDescription = this.wizardData.defectDescription.DefectDescription;
                    this.imageCount = this.wizardData.defectDescription.Images.length;
                }
                if (this.wizardData.contactDetails) {
                    this.formContainer.PhoneNo = this.wizardData.contactDetails.PhoneNo;
                    this.formContainer.Email = this.wizardData.contactDetails.Email;
                }
                this.failedUploadedImages = [];
                this.updateCustomerDetailsFailed = false;
                var images = this.wizardData.defectDescription ? this.wizardData.defectDescription.Images : {};
                this.imageItems[this.getResourceString("Label_Photos")] = new core.models.keyValues.keyValue(this.generateImageItemsData(images));
            };
            controller.prototype.generateImageItemsData = function (images) {
                var _this = this;
                var content = "";
                angular.forEach(images, function (image) {
                    content += _this.getImageMarkup(image.name, image.data);
                });
                if (content === "")
                    content = this.getResourceString("Text_NoPhotosFound");
                return content;
            };
            controller.prototype.getImageMarkup = function (title, base64Content) {
                var img = $("<img>");
                img.attr("title", title);
                img.attr("src", base64Content);
                img.addClass("img-thumbnail img-thumbnail-fixed-size");
                return $("<div>").append(img).html();
            };
            controller.prototype.uploadImage = function (image, maintenanceReqNo, companyName) {
                var _this = this;
                return function () {
                    var maintenanceRequestAttachment = _this.createMaintenanceRequestAttachmentObject(image, maintenanceReqNo);
                    return _this.repairmentsService
                        .submitMaintenanceRequestAttachment(companyName, maintenanceRequestAttachment)
                        .then(function (result) {
                        if (result.success === false) {
                            _this.failedUploadedImages.push(result.data);
                        }
                    });
                };
            };
            controller.prototype.saveRepairment = function () {
                var _this = this;
                var maintenanceRequest = this.createMaintenanceRequestObject();
                var progressModel = {};
                if (this.wizardData.defectDescription && this.wizardData.defectDescription.Images) {
                    progressModel.ImageCount = this.wizardData.defectDescription.Images.length;
                }
                progressModel.UpdateCustomerDetails = this.wizardData.contactDetails.savePhone || this.wizardData.contactDetails.saveEmail;
                var dialogInstance = this.progressDialogService.show(progressModel).then(function (e) {
                    if (!e.error) {
                        _this.$state.transitionTo('newRepairment.appointmentPlanner');
                    }
                    else {
                        _this.$state.transitionTo('repairments');
                    }
                });
                this.requestSubmitting = true;
                this.repairmentsService.submitMaintenanceRequest(maintenanceRequest).then(function (data) {
                    _this.requestSubmitting = false;
                    if (data.success === true) {
                        _this.wizardData.requestSubmission.maintenanceRequestNo = data.data;
                        _this.$rootScope.$broadcast('maintenanceRequest.progress.request', { error: false, message: _this.localize.getLocalizedString('Message_MaintenanceRequestSubmitted', 'NewRepairments') });
                        var images = [];
                        if (_this.wizardData.defectDescription) {
                            images = _this.wizardData.defectDescription.Images;
                        }
                        var chain = _this.$q.when({});
                        images.forEach(function (elem, i) {
                            chain = chain.then(_this.uploadImage(elem, _this.wizardData.requestSubmission.maintenanceRequestNo, _this.wizardData.objectSelection.selectedContract.CompanyName));
                        });
                        chain = chain.then(_this.updateCustomerDetails);
                        chain.then(function () {
                            var message = _this.localize.getLocalizedString('Message_Images_Uploaded', 'NewRepairments');
                            var error = false;
                            if (_this.failedUploadedImages.length > 0) {
                                error = true;
                                message = " " + _this.localize.getLocalizedString('Message_UploadMaintenanceImageFailed', 'NewRepairments', [_this.failedUploadedImages.length.toString(), _this.imageCount]);
                            }
                            _this.$rootScope.$broadcast('maintenanceRequest.progress.image', { error: error, message: message });
                            message = _this.localize.getLocalizedString('Message_CustomerDetails_Updated', 'NewRepairments');
                            if (_this.updateCustomerDetailsFailed) {
                                error = true;
                                message = _this.localize.getLocalizedString("Message_PersonSaveFailed", "MyDetails");
                            }
                            _this.$rootScope.$broadcast('maintenanceRequest.progress.updateCustomerDetails', { error: error, message: message });
                        });
                    }
                    else {
                        var message = _this.localize.getLocalizedString('Message_GenericError', 'NewRepairments');
                        _this.$rootScope.$broadcast('maintenanceRequest.progress.request', { error: true, message: message });
                    }
                }, function () {
                    _this.requestSubmitting = false;
                });
            };
            controller.prototype.createMaintenanceRequestObject = function () {
                return {
                    CompanyName: this.wizardData.objectSelection.selectedContract.CompanyName,
                    RealtyObjectNo: this.wizardData.objectSelection.realtyObjectNo,
                    OriginatingRealtyObject: this.wizardData.objectSelection.selectedContract.RentalUnit.No,
                    CauseCode: (this.wizardData.defectSelection.selectedCause ? this.wizardData.defectSelection.selectedCause.Code : ''),
                    TemplateCode: this.wizardData.defectSelection.selectedSpecification.EntryNo,
                    TenantAgreesToCosts: (this.wizardData.costConfirmation ? this.wizardData.costConfirmation.agreedCheck : false),
                    DescriptionOrder: (this.wizardData.defectDescription ? this.wizardData.defectDescription.DefectDescription : ''),
                    CallerEmail: (this.wizardData.contactDetails ? this.wizardData.contactDetails.Email : ''),
                    CallerDaytimePhoneNo: (this.wizardData.contactDetails ? this.wizardData.contactDetails.PhoneNo : '')
                };
            };
            controller.prototype.createMaintenanceRequestAttachmentObject = function (image, maintenanceRequestNo) {
                return {
                    MaintenanceRequestNo: maintenanceRequestNo,
                    Attachment: {
                        AttachmentNo: '',
                        AttachmentTitle: image.name,
                        AttachmentDescription: image.name,
                        AttachmentFileName: image.name,
                        AttachmentExtension: image.ext,
                        AttachmentBase64: image.data.substring(this.wizardData.defectDescription.Images[0].data.indexOf(",") + 1)
                    }
                };
            };
            controller.prototype.getResourceString = function (resourceString) {
                return this.localize.getLocalizedString(resourceString, 'NewRepairments');
            };
            return controller;
        }());
        angular
            .module('customer.newRepairment')
            .component('requestSubmission', {
            bindings: {
                wizardData: '='
            },
            controller: controller,
            templateUrl: '/App/newRepairment/wizardPages/requestSubmission.html'
        });
    })(newRepairment = customer.newRepairment || (customer.newRepairment = {}));
})(customer || (customer = {}));
//# sourceMappingURL=requestSubmission.component.js.map
var customer;
(function (customer) {
    var newTimelineAction;
    (function (newTimelineAction) {
        var models;
        (function (models) {
            var newInteraction = (function () {
                function newInteraction() {
                }
                return newInteraction;
            }());
            models.newInteraction = newInteraction;
        })(models = newTimelineAction.models || (newTimelineAction.models = {}));
    })(newTimelineAction = customer.newTimelineAction || (customer.newTimelineAction = {}));
})(customer || (customer = {}));
//# sourceMappingURL=newInteraction.js.map
var customer;
(function (customer) {
    var news;
    (function (news) {
        var models;
        (function (models) {
            var newsItem = (function () {
                function newsItem() {
                }
                return newsItem;
            }());
            models.newsItem = newsItem;
        })(models = news.models || (news.models = {}));
    })(news = customer.news || (customer.news = {}));
})(customer || (customer = {}));
//# sourceMappingURL=newsItem.js.map
var customer;
(function (customer) {
    var paymentArrangement;
    (function (paymentArrangement) {
        var models;
        (function (models) {
            var PaymentSchemeTemplate = (function () {
                function PaymentSchemeTemplate() {
                }
                return PaymentSchemeTemplate;
            }());
            models.PaymentSchemeTemplate = PaymentSchemeTemplate;
        })(models = paymentArrangement.models || (paymentArrangement.models = {}));
    })(paymentArrangement = customer.paymentArrangement || (customer.paymentArrangement = {}));
})(customer || (customer = {}));
//# sourceMappingURL=PaymentSchemeTemplate.js.map
var customer;
(function (customer) {
    var resourcesManagement;
    (function (resourcesManagement) {
        var controller = (function () {
            function controller($state, $stateParams, resourcesManagementService, localize) {
                this.$state = $state;
                this.$stateParams = $stateParams;
                this.resourcesManagementService = resourcesManagementService;
                this.localize = localize;
                this.$inject = ['$state', '$stateParams', 'resourcesManagementService', 'localize', 'alerting'];
                this.activate();
            }
            controller.prototype.activate = function () {
                this.viewNameLabel = this.getResource("Column_ViewName") + ":";
                this.resourceNameLabel = this.getResource("Column_ResourceName") + ":";
                this.resourceValueLabel = this.getResource("Column_ResourceValue") + ":";
            };
            controller.prototype.save = function (resourceDetailsForm) {
                var _this = this;
                if (resourceDetailsForm.$invalid) {
                    return;
                }
                this.resourcesManagementService.saveResource(this.resource).then(function (data) {
                    if (data == true) {
                        _this.goBackToResourcesManagement();
                    }
                });
            };
            controller.prototype.goBackToResourcesManagement = function () {
                this.$state.go('resourcesManagement', { searchState: this.$stateParams.searchState }, { location: 'replace' });
            };
            controller.prototype.getResource = function (key) {
                return this.localize.getLocalizedString(key, "ResourcesManagement");
            };
            return controller;
        }());
        angular.module('customer.resourcesManagement')
            .component('resourceDetails', {
            controller: controller,
            bindings: {
                resource: '=',
            },
            templateUrl: '/App/resourcesManagement/details/resourceDetails.html'
        });
    })(resourcesManagement = customer.resourcesManagement || (customer.resourcesManagement = {}));
})(customer || (customer = {}));
//# sourceMappingURL=resourceDetails.component.js.map
var customer;
(function (customer) {
    var resourcesManagement;
    (function (resourcesManagement) {
        var resource = (function () {
            function resource() {
            }
            return resource;
        }());
        resourcesManagement.resource = resource;
    })(resourcesManagement = customer.resourcesManagement || (customer.resourcesManagement = {}));
})(customer || (customer = {}));
//# sourceMappingURL=resource.js.map
var customer;
(function (customer) {
    var resourcesManagement;
    (function (resourcesManagement) {
        var searchState = (function () {
            function searchState() {
                this.searchText = '';
                this.viewName = '';
            }
            return searchState;
        }());
        resourcesManagement.searchState = searchState;
    })(resourcesManagement = customer.resourcesManagement || (customer.resourcesManagement = {}));
})(customer || (customer = {}));
//# sourceMappingURL=searchState.js.map
var customer;
(function (customer) {
    var styleManagement;
    (function (styleManagement) {
        var compileConfirmationAlert = (function () {
            function compileConfirmationAlert($uibModal) {
                var _this = this;
                this.$uibModal = $uibModal;
                this.showDialog = function () {
                    var options = {
                        templateUrl: '/App/styleManagement/compileConfirmation/compileConfirmation.html',
                        size: "lg",
                        controller: function () {
                        },
                        controllerAs: 'vm'
                    };
                    return _this.$uibModal.open(options).result;
                };
            }
            compileConfirmationAlert.factory = function () {
                var dialog = function ($uibModal) { return new compileConfirmationAlert($uibModal); };
                dialog.$inject = ['$uibModal'];
                return dialog;
            };
            return compileConfirmationAlert;
        }());
        styleManagement.compileConfirmationAlert = compileConfirmationAlert;
        ;
        angular.module('customer.styleManagement').factory('compileConfirmationAlert', compileConfirmationAlert.factory());
    })(styleManagement = customer.styleManagement || (customer.styleManagement = {}));
})(customer || (customer = {}));
//# sourceMappingURL=compileConfirmation.service.js.map
var customer;
(function (customer) {
    var userManagement;
    (function (userManagement) {
        var blockUserDialog = (function () {
            function blockUserDialog($uibModal) {
                this.$uibModal = $uibModal;
            }
            blockUserDialog.prototype.showDialog = function () {
                var ctrl = function ($scope, $uibModalInstance) {
                    var _this = this;
                    this.blockReason = "";
                    this.maxTextSize = 1000;
                    $scope.block = function () {
                        $uibModalInstance.close({ res: 'block', blockReason: _this.blockReason });
                    };
                    $scope.cancel = function () {
                        $uibModalInstance.close({ res: 'close', blockReason: '' });
                    };
                    $scope.getLeftCharacters = function () {
                        return _this.maxTextSize - _this.blockReason.length;
                    };
                };
                ctrl.$inject = ['$scope', '$uibModalInstance'];
                var options = {
                    templateUrl: '/App/userManagement/blockUserDialog/blockUserDialog.html',
                    size: "lg",
                    controller: ctrl,
                    controllerAs: '$ctrl'
                };
                return this.$uibModal.open(options).result;
            };
            blockUserDialog.factory = function () {
                var dialog = function ($uibModal) { return new blockUserDialog($uibModal); };
                dialog.$inject = ['$uibModal'];
                return dialog;
            };
            return blockUserDialog;
        }());
        userManagement.blockUserDialog = blockUserDialog;
        ;
        angular.module('customer.userManagement').factory('blockUserDialog', blockUserDialog.factory());
    })(userManagement = customer.userManagement || (customer.userManagement = {}));
})(customer || (customer = {}));
//# sourceMappingURL=blockUserDialog.service.js.map
var customer;
(function (customer) {
    var userManagement;
    (function (userManagement) {
        var models;
        (function (models) {
            var SearchState = (function () {
                function SearchState() {
                }
                return SearchState;
            }());
            models.SearchState = SearchState;
        })(models = userManagement.models || (userManagement.models = {}));
    })(userManagement = customer.userManagement || (customer.userManagement = {}));
})(customer || (customer = {}));
//# sourceMappingURL=SearchState.js.map
angular.module("customer.core").run(["$templateCache", function($templateCache) {$templateCache.put("/App/accountRequests/accountRequestDetails.html","<div data-viewname=\"AccountRequests\">\r\n    <div panel id=\"accountRequestDetails\" data-i18n-attr=\"Panel_AccountRequestDetails|heading\">\r\n        <div ng-show=\"$ctrl.accountRequest\">\r\n            <div panel id=\"general\" data-i18n-attr=\"Panel_General|heading\">\r\n                <div class=\"form-group\">\r\n                    <label for=\"customerNumber\" data-i18n=\"Label_CustomerNumber\"/>\r\n                    <input name=\"customerNumber\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.accountRequest.CustomerNumber\" ng-readonly=\"true\"/>\r\n                </div>\r\n\r\n                <div class=\"form-group\">\r\n                    <label for=\"username\" data-i18n=\"Label_UserName\"></label>\r\n                    <input name=\"username\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.accountRequest.Username\" ng-readonly=\"true\"/>\r\n                </div>\r\n\r\n                <div class=\"form-group\">\r\n                    <label for=\"email\" data-i18n=\"Label_Email\"></label>\r\n                    <input name=\"email\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.accountRequest.Email\" ng-readonly=\"true\"/>\r\n                </div>\r\n            </div>\r\n\r\n            <div panel id=\"accountRequestStatus\" data-i18n-attr=\"Panel_AccountRequestStatus|heading\">\r\n                <div class=\"form-group\">\r\n                    <label for=\"customerCodeEntered\" data-i18n=\"Label_CustomerCodeEntered\"/>\r\n                    <input name=\"customerCodeEntered\" type=\"text\" class=\"form-control\" ng-readonly=\"true\"\r\n                           ng-value=\"$ctrl.accountRequest.CustomerCodeEnteredUtc  | utcToLocal : \'EEEE, dd-MM-yyyy HH:mm:ss\' | capitalize\"/>\r\n                </div>\r\n\r\n                <div class=\"form-group\">\r\n                    <label for=\"identifiedWithVerificationCode\" data-i18n=\"Label_IdentifiedWithVerificationCode\"/>\r\n                    <input name=\"identifiedWithVerificationCode\" type=\"text\" class=\"form-control\" ng-readonly=\"true\"\r\n                           ng-value=\"$ctrl.accountRequest.IdentifiedUtc  | utcToLocal : \'EEEE, dd-MM-yyyy HH:mm:ss\' | capitalize\"/>\r\n                </div>\r\n\r\n                <div class=\"form-group\">\r\n                    <label for=\"accountDetailsEntered\" data-i18n=\"Label_AccountDetailsEntered\"/>\r\n                    <input name=\"accountDetailsEntered\" type=\"text\" class=\"form-control\" ng-readonly=\"true\"\r\n                           ng-value=\"$ctrl.accountRequest.AccountDetailsFilledInUtc  | utcToLocal : \'EEEE, dd-MM-yyyy HH:mm:ss\' | capitalize\"/>\r\n                </div>\r\n\r\n                <div class=\"form-group\">\r\n                    <label for=\"emailSent\" data-i18n=\"Label_EmailSent\"/>\r\n                    <input name=\"emailSent\" type=\"text\" class=\"form-control\" ng-readonly=\"true\"\r\n                           ng-value=\"$ctrl.accountRequest.EmailSentUtc  | utcToLocal : \'EEEE, dd-MM-yyyy HH:mm:ss\' | capitalize\"/>\r\n                </div>\r\n\r\n            </div>\r\n\r\n            <div class=\"form-group\">\r\n                <button name=\"sendEmail\" data-i18n-attr=\"Tooltip_SendConfirmationEmail|title\" class=\"btn btn-primary\" ng-disabled=\"!$ctrl.accountRequest.Email\" ng-click=\"$ctrl.sendConfirmationEmail($ctrl.accountRequest.CustomerNumber)\">\r\n                    <span data-i18n=\"Button_SendEmail\"></span><span class=\"glyphicon glyphicon-menu-right\"></span>\r\n                </button>\r\n\r\n                <button name=\"delete\" data-i18n-attr=\"Tooltip_DeleteAccountRequest|title\" class=\"btn btn-danger\" ng-click=\"$ctrl.removeAccountRequest($ctrl.accountRequest.CustomerNumber)\"\r\n                        ng-show=\"$ctrl.rights.RemoveAccountRequest\">\r\n                    <span data-i18n=\"Button_Delete\"></span>\r\n                </button>\r\n\r\n                <button name=\"cancel\" data-i18n-attr=\"Tooltip_Cancel|title\" class=\"btn btn-cancel pull-right\" ng-click=\"$ctrl.goBackToAccountRequestsOverview()\" ng-show=\"$ctrl.rights.CancelDetailPages\">\r\n                    <span data-i18n=\"Button_Cancel\"></span>\r\n                </button>\r\n            </div>\r\n        </div>\r\n\r\n        <div ng-hide=\"$ctrl.accountRequest\">\r\n            <span data-i18n=\"Message_AccountRequestNotFound\"></span>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("/App/accountRequests/accountRequests.html","<div data-viewname=\"AccountRequests\" ng-cloak>\r\n    <div class=\"panel-group\" role=\"tablist\" aria-multiselectable=\"false\">\r\n        <div collapsible-panel id=\"filters\" class=\"panel-default\" data-i18n-attr=\"Panel_FilterTitle|heading\" expanded=\"true\">\r\n            <form novalidate name=\"searchForm\">\r\n                <div class=\"form-group\">\r\n\r\n                    <div class=\"form-group\">\r\n                        <input name=\"searchText\" data-i18n-attr=\"Placeholder_Search|placeholder\" class=\"form-control\" ng-model=\"$ctrl.searchModel.Text\" maxlength=\"256\" />\r\n                    </div>\r\n                    <div class=\"form-group\">\r\n\r\n                        <div class=\"radio\">\r\n                            <span data-i18n=\"Label_Search\"></span>\r\n                            <label>\r\n                                <input type=\"checkbox\" name=\"filter\" ng-model=\"$ctrl.searchModel.ShowNotIdentified\"> <span data-i18n=\"Label_NotIdentified\"></span>\r\n                            </label>\r\n                            <label>\r\n                                <input type=\"checkbox\" name=\"filter\" ng-model=\"$ctrl.searchModel.ShowAccountDetailsNotFilledIn\"> <span data-i18n=\"Label_AccountDetailsNotFilledIn\"></span>\r\n                            </label>\r\n                            <label>\r\n                                <input type=\"checkbox\" name=\"filter\" ng-model=\"$ctrl.searchModel.ShowEmailNotSent\"> <span data-i18n=\"Label_EmailNotSent\"></span>\r\n                            </label>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"form-group\">\r\n                        <button class=\"btn btn-primary\" ng-click=\"$ctrl.search()\"><span data-i18n=\"Button_Search\"></span></button>\r\n                    </div>\r\n\r\n                </div>\r\n            </form>\r\n        </div>\r\n        <div collapsible-panel id=\"results\" class=\"panel-default\" data-i18n-attr=\"Panel_AccountRequestsTitle|heading|{{($ctrl.paging.currentPage - 1)*$ctrl.paging.count+1}}|{{($ctrl.paging.currentPage)*$ctrl.paging.count > $ctrl.paging.totalItems ? $ctrl.paging.totalItems :($ctrl.paging.currentPage)*$ctrl.paging.count }}|{{$ctrl.getTotalItems()}}\" expanded=\"true\">\r\n            <div ng-hide=\"$ctrl.accountRequests\">\r\n                <center>\r\n                    <i class=\"fa fa-spinner fa-spin fa-2x fa-fw\"></i>\r\n                </center>\r\n            </div>\r\n            <div ng-show=\"$ctrl.accountRequests\">\r\n                <table class=\"table table-condensed-admin table-responsive checkable-small col-xs-12\">\r\n                    <thead>\r\n                        <tr>\r\n                            <th></th>\r\n                            <th data-i18n=\"Column_CustomerNumber\"></th>\r\n                            <th data-i18n=\"Column_Email\"></th>\r\n                            <th data-i18n=\"Column_Username\"></th>\r\n                            <th data-i18n=\"Column_Identified\"></th>\r\n                            <th data-i18n=\"Column_AccountDetailsFilledIn\"></th>\r\n                            <th data-i18n=\"Column_EmailSent\"></th>\r\n                        </tr>\r\n                    </thead>\r\n                    <tbody>\r\n                        <tr ng-repeat=\"accountRequest in $ctrl.accountRequests\">\r\n                            <td align=\"center\">\r\n                                <input type=\"checkbox\" class=\"checkbox\"\r\n                                       ng-model=\"accountRequest.selected\"\r\n                                       ng-change=\"$ctrl.onCheckChange(accountRequest)\" stop-propagation />\r\n                            </td>\r\n                            <td>\r\n                                {{accountRequest.EmpireId}}\r\n                            </td>\r\n                            <td style=\"-ms-word-break: break-all; word-break:break-all\">\r\n                                {{accountRequest.Email }}\r\n                            </td>\r\n                            <td>\r\n                                {{accountRequest.UserName}}\r\n                            </td>\r\n                            <td class=\"text-center\">\r\n                                <span ng-class=\"{ \'icon_check_dark text-main\': accountRequest.IdentifiedUtc, \'icon_stop_dark text-danger\': !accountRequest.IdentifiedUtc }\"></span>\r\n                            </td>\r\n                            <td class=\"text-center\">\r\n                                <span ng-class=\"{ \'icon_stop_dark text-danger\': !accountRequest.AccountDetailsFilledInUtc, \'icon_check_dark text-main\': accountRequest.AccountDetailsFilledInUtc }\"></span>\r\n                            </td>\r\n                            <td class=\"text-center\">\r\n                                <span ng-class=\"{ \'icon_stop_dark text-danger\': !accountRequest.EmailSentUtc, \'icon_check_dark text-main\': accountRequest.EmailSentUtc }\"></span>\r\n                            </td>\r\n                        </tr>\r\n                        <tr>\r\n                            <td colspan=\"7\">\r\n                                <div>\r\n                                    <button class=\"btn btn-primary\" ng-disabled=\"!$ctrl.gridSelection.selected\" ng-click=\"$ctrl.viewDetails($ctrl.gridSelection)\" >\r\n                                        <span data-i18n=\"Button_Details\"></span><span class=\"glyphicon glyphicon-chevron-right\"></span>\r\n                                    </button>\r\n                                    <button class=\"btn btn-danger\" ng-disabled=\"!$ctrl.gridSelection.selected\" ng-click=\"$ctrl.removeAccountRequest($ctrl.gridSelection)\" >\r\n                                        <span data-i18n=\"Button_Delete\"></span>\r\n                                    </button>\r\n\r\n                                </div>\r\n                            </td>\r\n                        </tr>\r\n                    </tbody>\r\n                </table>\r\n                <div uib-pagination\r\n                     total-items=\"$ctrl.paging.totalItems\"\r\n                     items-per-page=\"$ctrl.paging.count\"\r\n                     ng-model=\"$ctrl.paging.currentPage\"\r\n                     max-size=\"$ctrl.paging.maxSize\"\r\n                     boundary-links=\"true\"\r\n                     rotate=\"true\"\r\n                     num-pages=\"numPages\"\r\n                     first-text=\"{{$ctrl.paging.firstText}}\"\r\n                     last-text=\"{{$ctrl.paging.lastText}}\"\r\n                     next-text=\"{{$ctrl.paging.nextText}}\"\r\n                     previous-text=\"{{$ctrl.paging.previousText}}\"\r\n                     ng-change=\"$ctrl.search()\">\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("/App/changePassword/changePassword.html","<div data-viewname=\"ChangePassword\">\r\n    <div ng-hide=\"$ctrl.user.IsExternalIdentity\">\r\n        <p data-i18n=\"Label_Introduction\"></p>\r\n\r\n        <form novalidate name=\"changePasswordForm\" ng-submit=\"$ctrl.savePassword(changePasswordForm)\">\r\n            <div class=\"input-group input-group-unstyled\">\r\n                <div class=\"form-group has-feedback\">\r\n                    <label for=\"input_password_current\" data-i18n=\"Label_CurrentPassword\"></label>\r\n                    <input type=\"password\" validate-hash\r\n                           name=\"oldPassword\"\r\n                           ng-model=\"$ctrl.user.OldPassword\"\r\n                           ng-model-options=\"{updateOn: \'blur\'}\"\r\n                           ng-required=\"true\"\r\n                           class=\"form-control\" id=\"input_password_current\"\r\n                           data-i18n-attr=\"Placeholder_TypeCurrentPassword|placeholder\"\r\n                           maxlength=\"{{$ctrl.maxPasswordLength}}\"\r\n                           required>\r\n                    <span class=\"icon_ form-control-feedback\"></span>\r\n                    <div class=\"text-danger\" ng-show=\"changePasswordForm.oldPassword.$touched||changePasswordForm.$submitted\" ng-messages=\"changePasswordForm.oldPassword.$error\">\r\n                        <p ng-message=\"required\">\r\n                        <span  data-i18n=\"Validation_RequiredField\"></span></p>\r\n                        <p ng-message=\"validateHash\"><span data-i18n=\"Message_IncorrectPassword\"></span></p>\r\n                    </div>\r\n                </div>\r\n\r\n                <tooltip class=\"input-group-addon no-horizontal-padding\" data-i18n-attr=\"Tooltip_OldPassword|content\" placement=\"bottom\" />\r\n            </div>\r\n\r\n            <!--<password-strength>-->\r\n            <div class=\"input-group input-group-unstyled\">\r\n                <div class=\"form-group has-feedback\">\r\n                    <label for=\"input_password_new\" data-i18n=\"Label_NewPassword\"></label>\r\n                    <input type=\"password\" password\r\n                           name=\"newPassword\"\r\n                           ng-model=\"$ctrl.user.Password\"\r\n                           ng-model-options=\"{updateOn: \'blur\'}\"\r\n                           class=\"form-control\"\r\n                           id=\"input_password_new\"\r\n                           data-i18n-attr=\"Placeholder_TypeNewPassword|placeholder\"\r\n                           maxlength=\"{{$ctrl.maxPasswordLength}}\"\r\n                           required\r\n                           validate-new-hash userName=\"{{$ctrl.user.UserName}}\" />\r\n                    <span class=\"icon_ form-control-feedback\"></span>\r\n                    <div class=\"text-danger\"  ng-show=\"changePasswordForm.newPassword.$touched||changePasswordForm.$submitted\" ng-messages=\"changePasswordForm.newPassword.$error\">\r\n                        <p ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></p>\r\n                        <p ng-message=\"password\"><span data-i18n=\"Message_PasswordFormat\"></span></p>\r\n                        <p ng-message=\"validateNewHash\"><span data-i18n=\"Message_ValidateNewHash\"></span></p>\r\n                    </div>\r\n                </div>\r\n\r\n                <tooltip class=\"input-group-addon no-horizontal-padding\" data-i18n-attr=\"Message_PasswordValidationCriteria|content\" placement=\"bottom\" />\r\n            </div>\r\n            <!--</password-strength>-->\r\n\r\n            <div class=\"input-group input-group-unstyled\">\r\n                <div class=\"form-group has-feedback\">\r\n                    <label for=\"input_password_repeat\" data-i18n=\"Label_RetypePassword\"></label>\r\n                    <input type=\"password\" name=\"confirmPassword\" ng-model=\"$ctrl.user.ConfirmPassword\" class=\"form-control\" id=\"input_password_repeat\"\r\n                           data-i18n-attr=\"Placeholder_TypeNewPasswordAgain|placeholder\" same-as=\"changePasswordForm.newPassword\" maxlength=\"{{$ctrl.maxPasswordLength}}\" required>\r\n                    <span class=\"icon_ form-control-feedback\"></span>\r\n\r\n                    <div class=\"text-danger\" ng-show=\"changePasswordForm.confirmPassword.$touched||changePasswordForm.$submitted\" ng-messages=\"changePasswordForm.confirmPassword.$error\">\r\n                        <p ng-message=\"required\"><span  data-i18n=\"Validation_RequiredField\"></span></p>\r\n                        <p ng-message=\"sameAs\"><span data-i18n=\"Message_PasswordsDoNotMatch\"></span></p>\r\n                    </div>\r\n                </div>\r\n                <tooltip class=\"input-group-addon no-horizontal-padding\" data-i18n-attr=\"Tooltip_ConfirmPassword|content\" placement=\"bottom\" />\r\n            </div>\r\n            <button type=\"submit\" class=\"btn btn-primary\"  ng-disabled=\"!changePasswordForm.$dirty\"><span data-i18n=\"Button_SavePassword\"></span><span class=\"glyphicon glyphicon-menu-right\"></span></button>\r\n        </form>\r\n\r\n    </div>\r\n    <div ng-show=\"$ctrl.user.IsExternalIdentity\">\r\n        <span ng-show=\"$ctrl.user.RoleName != \'KCC-medewerker\'\" data-i18n=\"Message_FeatureNotAvailableFacebook\"></span>\r\n        <span ng-show=\"$ctrl.user.RoleName == \'KCC-medewerker\'\" data-i18n=\"Message_FeatureNotAvailableKccEmployee\"></span>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("/App/chatWrapper/chatWrapper.component.html","");
$templateCache.put("/App/contact/contact.html","<div class=\"overlay-container contacts\" data-viewname=\"Contact\">\r\n    <h1 data-i18n=\"Panel_Title\"><span class=\"icon_stop_light pull-right\" type=\"button\" data-toggle=\"collapse\" data-target=\"#contacts_overlay\"></span></h1>\r\n    <div class=\"row contact-methods\">\r\n        <div class=\"col-xs-12\" key-values=\"$ctrl.contactInformation\"></div>\r\n    </div>\r\n</div>");
$templateCache.put("/App/contractTermination/contractTermination.html","<div data-viewname=\"ContractTermination\">\r\n    <form name=\"terminationForm\" ng-submit=\"$ctrl.terminateContract(terminationForm)\" novalidate>\r\n        <div panel class=\"panel-default\" data-i18n-attr=\"Panel_ContractTermination|heading\">\r\n            <div class=\"panel-group\">\r\n                <div class=\"panel-group\" role=\"tablist\" aria-multiselectable=\"false\">\r\n                    <div collapsible-panel id=\"terminationPanel\" data-i18n-attr=\"Panel_ContractTerminationDetails|heading\" expanded=\"true\">\r\n                        <div class=\"label-group\">\r\n                            <tooltip class=\"pull-right no-horizontal-padding\" content=\"\" placement=\"top\" data-i18n-attr=\"Tooltip_Contract|content\" />\r\n                            <div><label data-i18n=\"Label_Contract\"></label></div>\r\n                            <div class=\"labelValue\">{{$ctrl.formContainer.selectedContract.Address}}, {{$ctrl.formContainer.selectedContract.RentalUnit.City}}</div>\r\n                        </div>\r\n\r\n                        <div class=\"input-group input-group-unstyled\">\r\n                            <div class=\"form-group has-feedback\">\r\n                                <label for=\"terminationDate\" data-i18n=\"Input_Label_Termination_Date\"></label>\r\n                                <input name=\"terminationDate\" type=\'text\' class=\"form-control\" ng-required=\"true\" ng-model=\"$ctrl.formContainer.terminationDate\" ng-change=\"$ctrl.terminationDateChanged();\" working-day datetime-picker config=\"$ctrl.terminationDatePickerConfig\" />\r\n                                <span class=\"icon_ form-control-feedback\"></span>\r\n                                <span class=\"icon_calendar_light cal-icon\"></span>\r\n\r\n                                <div class=\"text-danger\" ng-messages=\"terminationForm.terminationDate.$error\" ng-show=\"terminationForm.terminationDate.$touched||terminationForm.$submitted\">\r\n                                    <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></div>\r\n                                    <div ng-message=\"workingDay\"><span data-i18n=\"Message_NotAWorkingDay\"></span></div>\r\n                                </div>\r\n                            </div>\r\n\r\n                            <tooltip class=\"input-group-addon no-horizontal-padding\" data-i18n-attr=\"Tooltip_ContractTerminationDate|content\" placement=\"bottom\" />\r\n                        </div>\r\n\r\n                        <div class=\"input-group input-group-unstyled\">\r\n                            <div class=\"form-group has-feedback\">\r\n                                <label class=\"control-label\" data-i18n=\"Input_Label_Contract_Termination_Reason\"></label>\r\n                                <div class=\"select-container\">\r\n                                    <select name=\"terminationReason\" ng-options=\"option.Code as option.Description for option in $ctrl.terminationReasons\" ng-model=\"$ctrl.formContainer.selectedTerminationReason\" ng-required=\"true\" class=\"form-control\"></select>\r\n                                    <span class=\"icon_ form-control-feedback\"></span>\r\n                                    <span class=\"glyphicon glyphicon-chevron-down dropdown_icon\"></span>\r\n\r\n                                    <div class=\"text-danger\" ng-messages=\"terminationForm.terminationReason.$error\" ng-show=\"terminationForm.terminationReason.$touched||terminationForm.$submitted\">\r\n                                        <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></div>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n\r\n                            <tooltip class=\"input-group-addon no-horizontal-padding\" data-i18n-attr=\"Tooltip_ContractTerminationReason|content\" placement=\"bottom\" />\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div collapsible-panel id=\"inspectionPanel\" ng-if=\"($ctrl.inspectionsData.ExchangeEnabled || $ctrl.inspectionsData.ConnectItEnabled) && ($ctrl.inspectionsData.InitialInspections > 0 || $ctrl.inspectionsData.FinalInspections > 0)\" data-i18n-attr=\"Panel_InspectionDetails|heading\" expanded=\"true\">\r\n                        <div time-slot-controller max-date=\"$ctrl.formContainer.terminationDate\">\r\n                            <div ng-if=\"$ctrl.inspectionsData.InitialInspections >= 1\">\r\n                                <div time-slot-planner time-slot-required name=\"initialInspection1\"\r\n                                                   ng-model=\"$ctrl.formContainer.initialInspection1\"\r\n                                                   min-date =\"$ctrl.minDate\"\r\n                                                   max-date=\"$ctrl.firstInitialInspectionOnDate\"\r\n                                                   time-slots=\"$ctrl.availableFirstInitialInspectionTimeSlots\"\r\n                                                   time-slots-loading=\"$ctrl.firstInitialTimeSlotsLoading\"\r\n                                                   time-slot-loader=\"$ctrl.loadAvailableFirstInitialInspectionTimeSlots\"\r\n                                                   title-resource=\"Label_InitialInspection1\"\r\n                                                   required-message=\"{{$ctrl.initialInspection1RequiredMessage}}\"\r\n                                                   time-slot-duration=\"{{$ctrl.inspectionsData.InitialDurationString}}\"\r\n                                                   initialize=\"$ctrl.inspectionsData.InitialInspections == 1 && $ctrl.inspectionsData.FinalInspections == 0\"></div>\r\n                                <div class=\"text-danger\" ng-messages=\"terminationForm.initialInspection1.$error\" ng-show=\"terminationForm.initialInspection1.$touched||terminationForm.$submitted\">\r\n                                    <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></div>\r\n                                </div>\r\n                            </div>\r\n\r\n                            <div ng-if=\"$ctrl.inspectionsData.InitialInspections >= 2\">\r\n                                <div time-slot-planner time-slot-required name=\"initialInspection2\"\r\n                                                   ng-model=\"$ctrl.formContainer.initialInspection2\"\r\n                                                   time-slots=\"$ctrl.availableInitialInspectionTimeSlots\"\r\n                                                   time-slots-loading=\"$ctrl.initialTimeSlotsLoading\"\r\n                                                   time-slot-loader=\"$ctrl.loadAvailableInitialInspectionTimeSlots\"\r\n                                                   title-resource=\"Label_InitialInspection2\"\r\n                                                   required-message=\"{{$ctrl.initialInspection2RequiredMessage}}\"\r\n                                                   time-slot-duration=\"{{$ctrl.inspectionsData.InitialDurationString}}\"></div>\r\n                                <div class=\"text-danger\" ng-messages=\"terminationForm.initialInspection2.$error\" ng-show=\"terminationForm.initialInspection2.$touched||terminationForm.$submitted\">\r\n                                    <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></div>\r\n                                </div>\r\n                            </div>\r\n\r\n                            <div ng-if=\"$ctrl.inspectionsData.FinalInspections >= 1\">\r\n                                <div time-slot-planner time-slot-required name=\"finalInspection1\"\r\n                                                   ng-model=\"$ctrl.formContainer.finalInspection1\"\r\n                                                   time-slots=\"$ctrl.availableFinalInspectionTimeSlots\"\r\n                                                   time-slots-loading=\"$ctrl.finalTimeSlotsLoading\"\r\n                                                   time-slot-loader=\"$ctrl.loadAvailableFinalInspectionTimeSlots\"\r\n                                                   title-resource=\"Label_FinalInspection1\"\r\n                                                   required-message=\"{{$ctrl.finalInspection1RequiredMessage}}\"\r\n                                                   time-slot-duration=\"{{$ctrl.inspectionsData.FinalDurationString}}\"\r\n                                                   initialize=\"$ctrl.inspectionsData.InitialInspections == 0 && $ctrl.inspectionsData.FinalInspections == 1\"></div>\r\n                                <div class=\"text-danger\" ng-messages=\"terminationForm.finalInspection1.$error\" ng-show=\"terminationForm.finalInspection1.$touched||terminationForm.$submitted\">\r\n                                    <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></div>\r\n                                </div>\r\n                            </div>\r\n\r\n                            <div ng-if=\"$ctrl.inspectionsData.FinalInspections >= 2\">\r\n                                <div time-slot-planner time-slot-required name=\"finalInspection2\"\r\n                                                   ng-model=\"$ctrl.formContainer.finalInspection2\"\r\n                                                   time-slots=\"$ctrl.availableFinalInspectionTimeSlots\"\r\n                                                   time-slots-loading=\"$ctrl.finalTimeSlotsLoading\"\r\n                                                   time-slot-loader=\"$ctrl.loadAvailableFinalInspectionTimeSlots\"\r\n                                                   title-resource=\"Label_FinalInspection2\"\r\n                                                   required-message=\"{{$ctrl.finalInspection2RequiredMessage}}\"\r\n                                                   time-slot-duration=\"{{$ctrl.inspectionsData.FinalDurationString}}\"></div>\r\n                                <div class=\"text-danger\" ng-messages=\"terminationForm.finalInspection2.$error\" ng-show=\"terminationForm.finalInspection2.$touched||terminationForm.$submitted\">\r\n                                    <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></div>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n\r\n                    </div>\r\n\r\n                    <div collapsible-panel id=\"contactInfoPanel\" data-i18n-attr=\"Panel_ContactDetails|heading\" expanded=\"true\">\r\n                        <div class=\"input-group input-group-unstyled\">\r\n\r\n                            <div class=\"form-group has-feedback\">\r\n                                <label for=\"inputPhone\" data-i18n=\"Input_Label_Phone\"></label>\r\n                                <input type=\"tel\" phonenumber ng-model=\"$ctrl.customerDetails.PhoneNo\" class=\"form-control\" name=\"inputPhone\" ng-required=\"$ctrl.phoneNumberRequired\" ng-change=\"$ctrl.contactDetailsChanged()\" data-i18n-attr=\"Input_Placeholder_Phone|placeholder\">\r\n                                <span class=\"icon_ form-control-feedback\"></span>\r\n\r\n                                <div class=\"text-danger\" ng-messages=\"terminationForm.inputPhone.$error\" ng-show=\"terminationForm.inputPhone.$touched||terminationForm.$submitted\">\r\n                                    <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></div>\r\n                                    <div ng-message=\"$ctrl.customerDetails.PhoneNo\"><span data-i18n=\"Message_InvalidPhoneNumber\" /></div>\r\n                                </div>\r\n                            </div>\r\n\r\n                            <tooltip class=\"input-group-addon no-horizontal-padding\" placement=\"bottom\" data-i18n-attr=\"Tooltip_Phone|content\" />\r\n                        </div>\r\n                        <div class=\"input-group input-group-unstyled\">\r\n\r\n                            <div class=\"form-group has-feedback\">\r\n                                <label for=\"inputMail\" data-i18n=\"Input_Label_Email\"></label>\r\n                                <input type=\"email\" email ng-model=\"$ctrl.customerDetails.Email\" class=\"form-control\" name=\"inputMail\" ng-required=\"$ctrl.emailRequired\" ng-change=\"$ctrl.contactDetailsChanged()\" data-i18n-attr=\"Input_Placeholder_Email|placeholder\">\r\n                                <span class=\"icon_ form-control-feedback\"></span>\r\n\r\n                                <div class=\"text-danger\" ng-messages=\"terminationForm.inputMail.$error\" ng-show=\"terminationForm.inputMail.$touched||terminationForm.$submitted\">\r\n                                    <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></div>\r\n                                    <div ng-message=\"email\"><span data-i18n=\"Message_InvalidEmail\" /></div>\r\n                                </div>\r\n                            </div>\r\n\r\n                            <tooltip class=\"input-group-addon no-horizontal-padding\" placement=\"bottom\" data-i18n-attr=\"Tooltip_Email|content\" />\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div collapsible-panel id=\"addressPanel\" data-i18n-attr=\"Panel_CorrespondenceAddress|heading\" expanded=\"true\">\r\n                        <div class=\"input-group input-group-unstyled\">\r\n                            <div class=\"form-group has-feedback\">\r\n                                <label for=\"country\" data-i18n=\"Label_Country\"></label>\r\n                                <div class=\"select-container\">\r\n                                    <select id=\"country\" ng-model=\"$ctrl.formContainer.CountryCode\" ng-change=\"$ctrl.determineForeignCountry();$ctrl.updateStreetAndCity(terminationForm)\" class=\"form-control\" focus-on=\"focusAddress\"\r\n                                            ng-options=\"country.Code as country.Code + (country.Name ? \' - \' + country.Name : \'\') for country in $ctrl.countries\">\r\n                                        <option value=\'\' disabled selected style=\'display:none;\' data-i18n=\"Placeholder_Country|placeholder\"></option>\r\n                                    </select>\r\n                                    <span class=\"icon_ form-control-feedback\"></span>\r\n                                    <span class=\"glyphicon glyphicon-chevron-down dropdown_icon\"></span>\r\n                                </div>\r\n                            </div>\r\n\r\n                            <tooltip class=\"input-group-addon no-horizontal-padding\" placement=\"bottom\" data-i18n-attr=\"Tooltip_Country|content\" />\r\n                        </div>\r\n\r\n                        <div class=\"input-group input-group-unstyled\">\r\n                            <div class=\"form-group has-feedback\">\r\n                                <label for=\"postcode\" data-i18n=\"Label_Postal_Code\"></label>\r\n                                <input id=\"postcode\" name=\"postcode\" ng-model-options=\"{ debounce: 100 }\" type=\"text\" ng-maxlength=\"10\" ng-required=\"true\" style=\"text-transform: uppercase\" ng-change=\"$ctrl.updateStreetAndCity(terminationForm)\" ng-model=\"$ctrl.formContainer.Postcode\" class=\"form-control\" data-i18n-attr=\"Placeholder_Postal_Code|placeholder\">\r\n                                <span class=\"icon_ form-control-feedback\"></span>\r\n\r\n                                <div class=\"text-danger\" ng-messages=\"terminationForm.postcode.$error\" ng-show=\"terminationForm.postcode.$touched||terminationForm.$submitted\">\r\n                                    <div ng-message=\"maxlength\"><span data-i18n=\"Message_MaxLength\" /></div>\r\n                                    <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></div>\r\n                                    <div ng-message=\"validaddress\"><span data-i18n=\"Message_InvalidPostcode\" /></div>\r\n                                </div>\r\n                            </div>\r\n\r\n                            <tooltip class=\"input-group-addon no-horizontal-padding\" placement=\"bottom\" data-i18n-attr=\"Tooltip_Postal_Code|content\" />\r\n                        </div>\r\n\r\n                        <div class=\"input-group input-group-unstyled\">\r\n                            <div class=\"form-group has-feedback\">\r\n                                <label for=\"HouseNumber\" data-i18n=\"Label_Number\"></label>\r\n                                <input id=\"HouseNumber\" name=\"HouseNumber\" ng-model-options=\"{ debounce: 100 }\" type=\"number\" ng-model=\"$ctrl.formContainer.HouseNo\" ng-required=\"true\" ng-maxlength=\"5\" ng-change=\"$ctrl.updateStreetAndCity(terminationForm)\" class=\"form-control\" data-i18n-attr=\"Placeholder_Number|placeholder\">\r\n                                <span class=\"icon_ form-control-feedback\"></span>\r\n                                <div class=\"text-danger\" ng-messages=\"terminationForm.HouseNumber.$error\" ng-show=\"terminationForm.HouseNumber.$touched||terminationForm.$submitted\">\r\n                                    <div ng-message=\"maxlength\"><span data-i18n=\"Message_MaxLength\" /></div>\r\n                                    <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\" /></div>\r\n                                    <div ng-message=\"validaddress\"><span data-i18n=\"Message_InvalidPostcode\" /></div>\r\n                                </div>\r\n                            </div>\r\n\r\n                            <tooltip class=\"input-group-addon no-horizontal-padding\" placement=\"bottom\" data-i18n-attr=\"Tooltip_Number|content\" />\r\n                        </div>\r\n\r\n                        <div class=\"input-group input-group-unstyled\">\r\n                            <div class=\"form-group has-feedback\">\r\n                                <label for=\"HouseNumberAddition\" data-i18n=\"Label_Number_Addition\"></label>\r\n                                <input name=\"HouseNumberAddition\" type=\"text\" ng-maxlength=\"20\" ng-model=\"$ctrl.formContainer.HouseNoAddition\" class=\"form-control\" data-i18n-attr=\"Placeholder_Number_Addition|placeholder\">\r\n                                <span class=\"icon_ form-control-feedback\"></span>\r\n                                <div ng-messages=\"terminationForm.HouseNumberAddition.$error\" class=\"text-danger field-validation-error\">\r\n                                    <div ng-message=\"maxlength\"><span data-i18n=\"Message_MaxLength\" /></div>\r\n                                </div>\r\n                            </div>\r\n\r\n                            <tooltip class=\"input-group-addon no-horizontal-padding\" placement=\"bottom\" data-i18n-attr=\"Tooltip_Number_Addition|content\" />\r\n                        </div>\r\n\r\n                        <div class=\"input-group input-group-unstyled\">\r\n                            <div class=\"form-group has-feedback\">\r\n                                <label for=\"Street\" data-i18n=\"Label_Street\"></label>\r\n                                <input name=\"Street\" type=\"text\" ng-model=\"$ctrl.formContainer.Street\" ng-required=\"!$ctrl.isNL\" ng-maxlength=\"50\" class=\"form-control\" ng-readonly=\"$ctrl.isNL\">\r\n                                <span class=\"icon_ form-control-feedback\"></span>\r\n                                <div class=\"text-danger\" ng-messages=\"terminationForm.Street.$error\" ng-show=\"terminationForm.Street.$touched||terminationForm.$submitted\">\r\n                                    <div ng-message=\"maxlength\"><span data-i18n=\"Message_MaxLength\" /></div>\r\n                                    <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\" /></div>\r\n                                </div>\r\n                            </div>\r\n\r\n                            <tooltip class=\"input-group-addon no-horizontal-padding\" placement=\"bottom\" data-i18n-attr=\"Tooltip_Street|content\" />\r\n                        </div>\r\n\r\n                        <div class=\"input-group input-group-unstyled\">\r\n                            <div class=\"form-group has-feedback\">\r\n                                <label for=\"City\" data-i18n=\"Label_City\"></label>\r\n                                <input name=\"City\" type=\"text\" ng-model=\"$ctrl.formContainer.City\" ng-maxlength=\"30\" ng-required=\"!$ctrl.isNL\" class=\"form-control\" ng-readonly=\"$ctrl.isNL\">\r\n                                <span class=\"icon_ form-control-feedback\"></span>\r\n                                <div class=\"text-danger\" ng-messages=\"terminationForm.City.$error\" ng-show=\"terminationForm.City.$touched||terminationForm.$submitted\">\r\n                                    <div ng-message=\"maxlength\"><span data-i18n=\"Message_MaxLength\" /></div>\r\n                                    <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\" /></div>\r\n                                </div>\r\n                            </div>\r\n\r\n                            <tooltip class=\"input-group-addon no-horizontal-padding\" placement=\"bottom\" data-i18n-attr=\"Tooltip_City|content\" />\r\n                        </div>\r\n\r\n                        <div class=\"input-group input-group-unstyled\">\r\n                            <div class=\"form-group has-feedback\">\r\n                                <label for=\"ChangeContactDataFrom\" data-i18n=\"Label_Change_Contact_Data_From\"></label>\r\n                                <input name=\"ChangeContactDataFrom\" type=\'text\' class=\"form-control\" ng-required=\"true\" ng-model=\"$ctrl.formContainer.changeContactDataFrom\" datetime-picker config=\"$ctrl.changeContactDataFromDatePickerConfig\" />\r\n                                <span class=\"icon_ form-control-feedback\"></span>\r\n                                <span class=\"icon_calendar_light cal-icon\"></span>\r\n\r\n                                <div class=\"text-danger\" ng-messages=\"terminationForm.changeContactDataFrom.$error\" ng-show=\"terminationForm.changeContactDataFrom.$touched||terminationForm.$submitted\">\r\n                                    <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></div>\r\n                                </div>\r\n                            </div>\r\n\r\n                            <tooltip class=\"input-group-addon no-horizontal-padding\" data-i18n-attr=\"Tooltip_Change_Contact_Data_From|content\" placement=\"bottom\" />\r\n                        </div>\r\n\r\n                        <button id=\"saveBtn\" type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"!terminationForm.$dirty || $ctrl.processing\">\r\n                            <span data-i18n=\"Button_Save\"></span><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span>\r\n                        </button>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</div>");
$templateCache.put("/App/customerQuestion/customerQuestion.html","<div data-viewname=\"CustomerQuestion\">\r\n    <h3>{{$ctrl.initialQuestion}}</h3>\r\n    <ul class=\"list-group\" ng-show=\"$ctrl.customerDetails\">\r\n        <li class=\"list-group-item\" ng-class=\"{\'knowledge-base-active\': !$ctrl.baseQuestion}\">\r\n            <span class=\"knowledge-base-badge\">1</span>\r\n            <div class=\"knowledge-base-label-group\">\r\n                <label class=\"knowledge-base\" data-i18n=\"Label_Contract_Question\"></label>\r\n\r\n                <a class=\"btn btn-primary pull-right\"\r\n                   ui-sref=\"knowledgebase({knowledgeQuery: $ctrl.query, knowledgeItems: $ctrl.items, openSubject: $ctrl.defaultOpenSubject, searchID: $ctrl.searchID})\">\r\n                    <span data-i18n=\"Button_Back\"></span>\r\n                </a>\r\n\r\n                <ul ng-show=\"!$ctrl.selectedContract\">\r\n                    <li ng-repeat=\"contract in $ctrl.customerDetails.ActiveContracts\">\r\n                        <input type=\"radio\" name=\"{{contract.EntryNo}}Radios\" ng-model=\"$ctrl.selectedContract\" id=\"{{contract.EntryNo}}Radio{{$index}}\" value=\"{{contract.EntryNo}}\" ng-change=\"$ctrl.selectContract({{contract}})\">\r\n                        <label class=\"labelValue\" for=\"{{contract.EntryNo}}Radio{{$index}}\">{{contract.Address}}</label>\r\n                    </li>\r\n                </ul>\r\n                <div class=\"labelValue knowledge-base\" ng-show=\"$ctrl.selectedContract\">\r\n                    <span class=\"knowledge-base-prefix\" data-i18n=\"Label_Answer{{$ctrl.contractSelection ? \'_Automatic\' : \'\'}}\"></span>\r\n                    <a ng-click=\"$ctrl.resetUntil(-1)\" ng-show=\"$ctrl.contractSelection\">{{$ctrl.selectedContract.Address}}</a>\r\n                    {{$ctrl.contractSelection === false ? $ctrl.selectedContract.Address : \'\'}}\r\n                </div>\r\n            </div>\r\n        </li>\r\n        <li class=\"list-group-item\" ng-repeat=\"answer in $ctrl.baseQuestion.AnsweredQuestions\">\r\n            <span class=\"knowledge-base-badge\">{{$index + 2}}</span>\r\n            <div class=\"knowledge-base-label-group\">\r\n                <label class=\"knowledge-base\">{{answer.Question.Description}}</label>\r\n                <div class=\"labelValue knowledge-base\">\r\n                    <!-- TODO: only execute click if not automatic -->\r\n                    <span class=\"knowledge-base-prefix\" data-i18n=\"Label_Answer{{answer.Automatic ? \'_Automatic\' : \'\'}}\"></span>\r\n                    <!-- TODO properly style automatic stuff -->\r\n                    <a ng-click=\"$ctrl.resetUntil($index)\" ng-hide=\"answer.Automatic\">{{answer.Answer.Description}}</a>\r\n                    {{answer.Automatic ? answer.Answer.Description : \'\'}}\r\n                </div>\r\n            </div>\r\n        </li>\r\n        <li class=\"list-group-item knowledge-base-active\" ng-show=\"$ctrl.baseQuestion.CurrentQuestion && !$ctrl.baseQuestion.Advice\">\r\n            <span class=\"knowledge-base-badge\">{{$ctrl.baseQuestion.AnsweredQuestions.length + 2}}</span>\r\n            <div class=\"knowledge-base-label-group\">\r\n                <label class=\"knowledge-base\">{{$ctrl.baseQuestion.CurrentQuestion.Description}}</label>\r\n                <ul>\r\n                    <li ng-repeat=\"answer in $ctrl.baseQuestion.CurrentQuestion.PossibleAnswers\">\r\n                        <input type=\"radio\" name=\"{{answer.ID}}Radios\" ng-model=\"$ctrl.tmpAnswer\" id=\"{{answer.ID}}Radio{{$index}}\" value=\"{{$index}}\" ng-change=\"$ctrl.submitAnswer(answer)\">\r\n                        <label class=\"labelValue\" for=\"{{answer.ID}}Radio{{$index}}\">{{answer.Description}}</label>\r\n                    </li>\r\n                </ul>\r\n            </div>\r\n        </li>\r\n        <li class=\"list-group-item knowledge-base-active\" ng-show=\"$ctrl.baseQuestion.Advice\">\r\n            <span class=\"knowledge-base-badge\">{{$ctrl.baseQuestion.AnsweredQuestions.length + 2}}</span>\r\n            <div class=\"knowledge-base-label-group\">\r\n                <label class=\"knowledge-base\" data-i18n=\"Label_Advice_Title\"></label>\r\n                <div class=\"labelValue knowledge-base\">\r\n                    <p markdown=\"$ctrl.baseQuestion.Advice.Description\"></p>\r\n                    <a class=\"btn btn-primary\" ng-show=\"$ctrl.baseQuestion.Advice.Link && $ctrl.baseQuestion.Advice.Link.length > 0\"\r\n                       ng-href=\"{{$ctrl.formatLink($ctrl.baseQuestion.Advice.Link)}}\"\r\n                       target=\"{{$ctrl.isAbsoluteURL($ctrl.baseQuestion.Advice.Link) ? \'_blank\' : \'_self\'}}\">\r\n                        <span>{{$ctrl.baseQuestion.Advice.LinkText}}</span>\r\n                        <span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span>\r\n                    </a>\r\n                </div>\r\n            </div>\r\n        </li>\r\n    </ul>\r\n</div>");
$templateCache.put("/App/emailTemplatesManagement/emailTemplatesManagement.html","<div data-viewname=\"EmailTemplatesManagement\" ng-cloak>\r\n  <div class=\"panel-group\" role=\"tablist\" aria-multiselectable=\"false\">\r\n    <div collapsible-panel id=\"importExport\" class=\"panel-default\" data-i18n-attr=\"Panel_ImportExportTitle|heading\" expanded=\"true\">\r\n      <form name=\"emailTemplatesForm\">\r\n        <div class=\"input-group input-group-unstyled\">\r\n          <div class=\"form-group has-feedback\">\r\n            <label class=\"control-label\" data-i18n=\"Label_Dropdown\" for=\"emailTemplate\"></label>\r\n            <div class=\"select-container\">\r\n              <select ng-required=\"true\" class=\"form-control\" name=\"emailTemplate\" id=\"emailTemplate\"\r\n                      ng-options=\"option.Name for option in $ctrl.availableOptions track by option.Id\"\r\n                      ng-model=\"$ctrl.selectedOption\"></select>\r\n              <span class=\"icon_ form-control-feedback\"></span>\r\n              <span class=\"glyphicon glyphicon-chevron-down dropdown_icon\"></span>\r\n            </div>\r\n          </div>\r\n\r\n          <hr />\r\n          <br />\r\n\r\n          <div class=\"form-group\">\r\n            <button type=\"button\" class=\"btn btn-primary\"\r\n                    ng-disabled=\"!emailTemplatesForm.$dirty\"\r\n                    file-download download-url=\"$ctrl.getExportUrl()\"\r\n                    download-finished-message=\"Message_DownloadDocumentFinished\"\r\n                    download-failed-message=\"Message_DownloadDocumentFailed\">\r\n              <span data-i18n=\"Button_Export\"></span>\r\n            </button>\r\n\r\n            <file-picker-button max-size=\"$ctrl.maxFileSize\"\r\n                                file-type=\"$ctrl.fileType\"\r\n                                btn-title=\"btnTitle\"\r\n                                is-disabled=\"!emailTemplatesForm.$dirty\"\r\n                                btn-class=\"btnClass\" btn-icon=\"btnIcon\"\r\n                                file-too-large-message=\"Message_FileTooLarge\"\r\n                                modal-title=\"Title_Upload_Files\"\r\n                                info-text=\"Text_MaxFileSize\"\r\n                                view-name=\"FilePicker\"\r\n                                file-model=\"$ctrl.selectedFiles\"\r\n                                file-selected=\"$ctrl.onFileSelected()\"\r\n                                invalid-file-extension=\"Message_Invalid_Extension\"\r\n                                auto-close=\"true\"></file-picker-button>\r\n\r\n            <a ng-href=\"/emailTemplatePreview/{{$ctrl.selectedOption.Id}}\"\r\n               class=\"btn btn-primary\"\r\n               ng-disabled=\"!emailTemplatesForm.$dirty\"\r\n               target=\"_blank\">\r\n              <span data-i18n=\"Button_Preview\"></span><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span>\r\n            </a>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("/App/footer/footer.html","<footer class=\"footer\" data-viewname=\"Generic\">\r\n    <div class=\"container-fluid-max\">\r\n        <div class=\"row\">\r\n            <div class=\"col-md-8 col-sm-6 col-xs-6 row contact-icons\">\r\n                <div class=\"col-md-6 col-sm-12 row\">\r\n                    <a class=\"col-md-1 col-xs-12\" data-i18n-visible-if=\"Hyperlink_Facebook_Url\" data-i18n-attr=\"Hyperlink_Facebook_Url|href\" title=\"Facebook\" target=\"_blank\" rel=\"noopener noreferrer\"><i class=\"fa fa-facebook-official\"></i></a>\r\n                    <a class=\"col-md-1 col-xs-12\" data-i18n-visible-if=\"Hyperlink_Linkedin_Url\" data-i18n-attr=\"Hyperlink_Linkedin_Url|href\" title=\"LinkedIn\" target=\"_blank\" rel=\"noopener noreferrer\"><i class=\"fa fa-linkedin-square\"></i></a>\r\n                    <a class=\"col-md-1 col-xs-12\" data-i18n-visible-if=\"Hyperlink_Instagram_Url\" data-i18n-attr=\"Hyperlink_Instagram_Url|href\" title=\"Instagram\" target=\"_blank\" rel=\"noopener noreferrer\"><i class=\"fa fa-instagram\"></i></a>\r\n                    <a class=\"col-md-1 col-xs-12\" data-i18n-visible-if=\"Hyperlink_Twitter_Url\" data-i18n-attr=\"Hyperlink_Twitter_Url|href\" title=\"Twitter\" target=\"_blank\" rel=\"noopener noreferrer\"><i class=\"fa fa-twitter-square\"></i></a>\r\n                </div>\r\n                <!--<div class=\"col-md-6 col-sm-12 social\">\r\n                    <span data-role=\"button\" class=\"icon_facebook\"></span>\r\n                    <span data-role=\"button\" class=\"icon_twitter_light\"></span>\r\n                </div>-->\r\n            </div>\r\n            <div class=\"col-md-4 col-sm-6 col-xs-6 copyright\">\r\n                <div class=\"copyright-container\">\r\n                    <div class=\"copyright-image\"></div>\r\n                    <div class=\"copyright-text\" data-i18n=\"Text_Copyright\"></div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</footer>");
$templateCache.put("/App/home/home.html","<div data-viewname=\"Home\">\r\n    <div class=\"row\">\r\n        <!-- I\'ve also added the welcome message, this should be removed or hidden, can\'t quite remember -->\r\n        <div class=\"col-sm-12 welcome-message\" ng-show=\"$ctrl.firstTimeLogon\">\r\n            <h1 data-i18n=\"Label_Welcome_Title\"></h1>\r\n            <p data-i18n=\"Label_Welcome_Message\"></p>\r\n        </div>\r\n        <!-- The top 5 direct -->\r\n        <div class=\"col-sm-6\" portal-module=\"OR:Repairs,HouseholdData,InspectBalance,Rescission,OtherActions\">\r\n            <div panel heading=\"Direct regelen top {{portalModule.modulesFound}}\">\r\n                <!-- The content of this ol should probably be generated using an ng-repeat -->\r\n                <ol>\r\n                    <li ui-sref=\"repairments\" portal-module=\"Repairs\"><span data-i18n=\"Link_Request_Repairment\"></span></li>\r\n                    <li ui-sref=\"myDetails\" portal-module=\"HouseholdData\"><span data-i18n=\"Link_My_Details\"></span></li>\r\n                    <li ui-sref=\"myPayments\" portal-module=\"InspectBalance\"><span data-i18n=\"Link_Online_Payment\"></span></li>\r\n                    <li ng-show=\"$ctrl.customerDetails.ActiveContracts.length != 1\" ui-sref=\"myContracts\" portal-module=\"Rescission\"><span data-i18n=\"Link_TerminateContract\"></span></li>\r\n                    <li ng-show=\"$ctrl.customerDetails.ActiveContracts && $ctrl.customerDetails.ActiveContracts.length == 1\"\r\n                        ui-sref=\"contractTermination({companyName: $ctrl.customerDetails.ActiveContracts[0].CompanyName, realtyObjectNo: $ctrl.customerDetails.ActiveContracts[0].RentalUnit.No})\"\r\n                        portal-module=\"Rescission\">\r\n                        <span data-i18n=\"Link_TerminateContract\"></span>\r\n                    </li>\r\n                    <li ui-sref=\"newTimelineAction\" portal-module=\"OtherActions\"><span data-i18n=\"Link_New_Timeline_Action\"></span></li>\r\n                </ol>\r\n            </div>\r\n        </div>\r\n\r\n        <!-- The top 5 FAQ -->\r\n        <div class=\"col-md-6 col-sm-6 col-xs-12\" ng-show=\"$ctrl.questionsGroupedBySubject != null\">\r\n            <div panel data-i18n-attr=\"Title_FAQ|heading\">\r\n                <!-- The content of this ol should probably be generated using an ng-repeat -->\r\n                <ol>\r\n                    <li ng-repeat=\"(subject, questions) in $ctrl.questionsGroupedBySubject\" ui-sref=\"knowledgebase({knowledgeQuery: \'_faq\', knowledgeItems: $ctrl.questionsGroupedBySubject, openSubject: subject})\">{{subject}}</li>                    \r\n                </ol>\r\n                <a id=\"linkOpenAllSubjects\" ui-sref=\"knowledgebase({knowledgeQuery: \'_all\'})\">Toon alle onderwerpen</a>\r\n            </div>\r\n        </div>\r\n        \r\n        <!-- The news carousel -->\r\n        <div class=\"col-md-12 col-sm-12 col-xs-12\" ng-show=\"$ctrl.news.length > 0\" portal-module=\"News\">\r\n            <div uib-carousel interval=\"$ctrl.slideInterval\" class=\"carousel\" active=\"item.active\">\r\n                <div uib-slide ng-repeat=\"item in $ctrl.news\" index=\"$index\">\r\n                    <div class=\"text-left\">\r\n                        <div panel heading=\"&#9679; {{item.Title}}\" subtitle=\"{{item.PublicationDate | date : \'EEEE,  dd-MM-yyyy\'}}\">\r\n                            <div class=\"hide-text-overflow preformatted-text\" ng-bind-html=\"item.ContentValue\"></div>\r\n                            <button type=\"button\" class=\"btn btn-primary\" ui-sref=\"newsDetails({newsItem: item, itemId: item.Id})\">\r\n                                <span data-i18n=\"Button_Navigate\"></span>\r\n                                <span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span>\r\n                            </button>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>");
$templateCache.put("/App/knowledgebase/knowledgebase.html","<div data-viewname=\"KnowledgeBase\">\r\n    <div class=\"panel-group\" role=\"tablist\" id=\"knowledgebaseResults\" aria-multiselectable=\"false\">                \r\n        <div panel heading=\"{{$ctrl.viewTitle}}\">\r\n            <p data-i18n=\"HelpText_KnowledgeBase\" ng-show=\"{{$ctrl.showHelperText}}\"></p>\r\n            <div class=\"panel-group\" role=\"tablist\" id=\"searchSubjectsContainer\" aria-multiselectable=\"false\"\r\n                 infinite-scroll=\"$ctrl.loadMore()\" infinite-scroll-distance=\"3\">\r\n                <div collapsible-panel ng-repeat=\"(identifier, results) in $ctrl.items\"\r\n                                   id=\"subject_{{$index}}\"\r\n                                   heading=\"\"\r\n                                   data-i18n-attr=\"{{results.length == 1 ? \'Subject_Heading_Single\' : \'Subject_Heading_Multiple\'}}|heading|{{identifier}}|{{results.length}}\"\r\n                                   expanded=\"{{identifier == $ctrl.defaultOpenSubject}}\">\r\n                    <ul>\r\n                        <li ng-repeat=\"item in results\"><a ui-sref=\"customerQuestion({questionId: item.ID, initialQuestion: item.Description, knowledgeQuery: $ctrl.query, knowledgeItems: $ctrl.items, openSubject: identifier, searchID: $ctrl.searchID})\">{{item.Description}}</a></li>\r\n                    </ul>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>");
$templateCache.put("/App/menu/menu.html","<p ng-if=\"$ctrl.environment != null && $ctrl.environment != \'\'\" class=\"environment\">Environment: {{$ctrl.environment}}</p>\r\n<div class=\"sidebar nav-collapse collapse width\" data-viewname=\"Menu\">\r\n    <ul class=\"nav nav-sidebar-attention\">\r\n        <li ng-hide=\"true\">\r\n            <span class=\"nav-sidebar-title\" data-i18n=\"Menu_Item_Important_Appointments|2\"></span>\r\n        </li>\r\n    </ul>\r\n    <ul class=\"nav nav-sidebar\" ng-style=\"{\'overflow-y\': \'auto\'}\">\r\n        <li ng-repeat=\"menuItem in $ctrl.menuItems\" ui-sref=\"{{$ctrl.getStateReference(menuItem)}}\" ui-sref-active=\"active\" portal-module=\"{{menuItem.CustomerPortalModule}}\">\r\n            <span class=\"icon {{menuItem.Icon}}\"></span>\r\n            <span class=\"nav-sidebar-title\" data-i18n=\"{{menuItem.Title}}\"></span>\r\n            <span ng-if=\"$index == 0\" class=\"sr-only\">(current)</span>\r\n        </li>\r\n\r\n        <li ng-click=\"$ctrl.logout()\">\r\n            <span class=\"icon icon_action\"></span>\r\n            <span class=\"nav-sidebar-title\" data-i18n=\"Menu_Item_Log_Out\"></span>\r\n        </li>\r\n    </ul>\r\n</div>\r\n\r\n<style>\r\n    @media (min-width: 991px) {\r\n        .sidebar {\r\n            display: flex;\r\n            flex-direction: column;\r\n            overflow: hidden;\r\n            padding-bottom: 0;\r\n        }\r\n    }\r\n</style>");
$templateCache.put("/App/myContracts/myContracts.html","<div class=\"row\" data-viewname=\"MyContracts\">\r\n    <h3 class=\"text-primary\" data-i18n=\"Text_NoContract\" ng-show=\"$ctrl.customerDetails.ActiveContracts.length == 0\"></h3>\r\n    <div class=\"panel-group\" role=\"tablist\" id=\"collapsiblePanelsDirective\" aria-multiselectable=\"false\">\r\n        <div class=\"col-xs-12 col-sm-6 col-md-12 col-lg-12 contract\" ng-repeat=\"contract in $ctrl.customerDetails.ActiveContracts\">\r\n            <div panel heading=\"{{contract.Address}}\">\r\n                <div ng-show=\"contract.RentalUnitImage\">\r\n                    <div>\r\n                        <img ng-src=\"{{contract.RentalUnitImage}}\" style=\"width:100%; height:100%;\" />\r\n                    </div>\r\n                    <br />\r\n                </div>\r\n\r\n                <div class=\"panel-group\" role=\"tablist\" id=\"collapsiblePanelsDirective\" aria-multiselectable=\"false\">\r\n                    <div class=\"panel transparent\">\r\n                        <div collapsible-panel id=\"contract_{{$index}}\" data-i18n-attr=\"Label_Contract|heading\" expanded=\"true\">\r\n                            <div class=\"label-group\">\r\n                                <label data-i18n=\"Label_StartDate\"></label>\r\n                                <div class=\"labelValue\">{{contract.StartDate | date : \'d MMMM yyyy\'}}</div>\r\n                            </div>\r\n                            <div class=\"label-group\">\r\n                                <div ng-show=\"contract.EndDate\">\r\n                                    <label data-i18n=\"Label_EndDate\"></label>\r\n                                    <div class=\"labelValue\">{{contract.EndDate | date : \'d MMMM yyyy\'}}</div>\r\n                                </div>\r\n\r\n                                <div ng-hide=\"contract.EndDate\" portal-module=\"Rescission\">\r\n                                    <label data-i18n=\"Label_EndDate\"></label>\r\n                                    <div class=\"labelValue\"><a href=\"\" data-i18n=\"Link_TerminateContract\" ui-sref=\"contractTermination({companyName: contract.CompanyName, realtyObjectNo: contract.RentalUnit.No})\"></a></div>\r\n                                </div>\r\n                            </div>\r\n                            <div ng-show=\"contract.EndDate && contract.InitialAppointment1\" class=\"label-group\">\r\n                                <label data-i18n=\"Label_InitialInspection1\"></label>\r\n                                <div class=\"labelValue\">{{contract.InitialAppointment1 | inspectionAppointment : \'d MMMM yyyy\'}}</div>\r\n                            </div>\r\n                            <div ng-show=\"contract.EndDate && contract.InitialAppointment2\" class=\"label-group\">\r\n                                <label data-i18n=\"Label_InitialInspection2\"></label>\r\n                                <div class=\"labelValue\">{{contract.InitialAppointment2 | inspectionAppointment : \'d MMMM yyyy\'}}</div>\r\n                            </div>\r\n                            <div ng-show=\"contract.EndDate && contract.FinalAppointment1\" class=\"label-group\">\r\n                                <label data-i18n=\"Label_FinalInspection1\"></label>\r\n                                <div class=\"labelValue\">{{contract.FinalAppointment1 | inspectionAppointment : \'d MMMM yyyy\'}}</div>\r\n                            </div>\r\n                            <div ng-show=\"contract.EndDate && contract.FinalAppointment2\" class=\"label-group\">\r\n                                <label data-i18n=\"Label_FinalInspection2\"></label>\r\n                                <div class=\"labelValue\">{{contract.FinalAppointment2 | inspectionAppointment : \'d MMMM yyyy\'}}</div>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div class=\"panel transparent\" portal-module=\"PropertyDetails\">\r\n                        <div collapsible-panel id=\"property_{{$index}}\" data-i18n-attr=\"Panel_RealtyObjectDetails|heading\" expanded=\"false\">\r\n                            <div class=\"label-group\">\r\n                                <tooltip class=\"pull-right no-horizontal-padding\" content=\"\" placement=\"bottom\" data-i18n-attr=\"Tooltip_RealtyObjectType|content\" />\r\n                                <label data-i18n=\"Label_RealtyObjectType\"></label>\r\n                                <div class=\"labelValue\">{{contract.RentalUnit.UnitType.Description}}</div>\r\n                            </div>\r\n\r\n                            <div class=\"label-group\" ng-show=\"contract.RentalUnit.NumberOfRooms\">\r\n                                <tooltip class=\"pull-right no-horizontal-padding\" content=\"\" placement=\"top\" data-i18n-attr=\"Tooltip_NumberOfRooms|content\" />\r\n                                <div><label data-i18n=\"Label_NumberOfRooms\"></label></div>\r\n                                <div class=\"labelValue\">{{contract.RentalUnit.NumberOfRooms}}</div>\r\n                            </div>\r\n\r\n                            <div class=\"label-group\">\r\n                                <tooltip class=\"pull-right no-horizontal-padding\" content=\"\" placement=\"top\" data-i18n-attr=\"Tooltip_ConstructionYear|content\" />\r\n                                <label data-i18n=\"Label_ConstructionYear\"></label>\r\n                                <div class=\"labelValue\">{{contract.RentalUnit.ConstructionYear}}</div>\r\n                            </div>\r\n\r\n                            <div class=\"label-group\" ng-show=\"contract.RentalUnit.EnergyLabel\">\r\n                                <tooltip class=\"pull-right no-horizontal-padding\" content=\"\" placement=\"top\" data-i18n-attr=\"Tooltip_EpaLabel|content\" />\r\n                                <label data-i18n=\"Label_EpaLabel\"></label>\r\n                                <div class=\"energy-labels\">\r\n                                    <img ng-src=\"{{$ctrl.getEnergyLabelImage(contract.RentalUnit.EnergyLabel)}}\" />\r\n                                </div>\r\n                            </div>\r\n\r\n                            <div class=\"label-group\" ng-show=\"contract.RentalUnit.EnergyLabelNTA8800\">\r\n                                <tooltip class=\"pull-right no-horizontal-padding\" content=\"\" placement=\"top\" data-i18n-attr=\"Tooltip_EnergyLabelNTA8800|content\" />\r\n                                <label data-i18n=\"Label_EnergyLabelNTA8800\"></label>\r\n                                <div class=\"energy-labels\">\r\n                                    <img ng-src=\"{{$ctrl.getEnergyLabelImage(contract.RentalUnit.EnergyLabelNTA8800)}}\" />\r\n                                </div>\r\n                            </div>\r\n\r\n                            <div class=\"label-group\" ng-show=\"contract.RentalUnit.EnergyIndex\">\r\n                                <tooltip class=\"pull-right no-horizontal-padding\" content=\"\" placement=\"top\" data-i18n-attr=\"Tooltip_EnergyIndex|content\" />\r\n                                <label data-i18n=\"Label_EnergyIndex\"></label>\r\n                                <div class=\"labelValue\">\r\n                                    {{contract.RentalUnit.EnergyIndex | number}}\r\n                                </div>\r\n                            </div>\r\n\r\n                            <div class=\"label-group\">\r\n                                <tooltip class=\"pull-right no-horizontal-padding\" content=\"\" placement=\"top\" data-i18n-attr=\"Tooltip_WozValue|content\" />\r\n                                <label data-i18n=\"Label_WozValue\"></label>\r\n                                <div class=\"labelValue currency\"> {{contract.RentalUnit.WozValue | number : 2}}</div>\r\n                            </div>\r\n\r\n                        </div>\r\n\r\n                        <div class=\"panel transparent\" portal-module=\"PropertyValuation\">\r\n                            <div collapsible-panel id=\"valuation_{{$index}}\" data-i18n-attr=\"Panel_PropertyValuation|heading\" expanded=\"false\">\r\n                                <div ng-hide=\"contract.RentalUnit.PropertyValuation.length > 0\" data-i18n=\"Label_NoPropertyValuation\"></div>\r\n                                <div ng-show=\"contract.RentalUnit.PropertyValuation.length > 0\">\r\n                                    <div class=\"label-group\" data-i18n=\"Label_PropertyValuationInformation\"></div>\r\n                                    <table class=\"table\">\r\n                                        <tbody>\r\n                                            <tr ng-repeat=\"item in contract.RentalUnit.PropertyValuation\">\r\n                                                <td>\r\n                                                    <span ng-if=\"$index < contract.RentalUnit.PropertyValuation.length - 2\">\r\n                                                        {{item.Description}}\r\n                                                    </span>\r\n                                                    <span ng-if=\"$index >= contract.RentalUnit.PropertyValuation.length - 2\">\r\n                                                        <b>{{item.Description}}</b>\r\n                                                    </span>\r\n                                                </td>\r\n                                                <td>\r\n                                                    <span class=\"pull-right\" ng-if=\"$index < contract.RentalUnit.PropertyValuation.length - 2\">\r\n                                                        {{item.Points | number : 2}}\r\n                                                    </span>\r\n                                                    <span class=\"pull-right\" ng-if=\"$index >= contract.RentalUnit.PropertyValuation.length - 2\">\r\n                                                        <b>{{item.Points | number : 2}}</b>\r\n                                                    </span>\r\n                                                </td>\r\n                                            </tr>\r\n                                        </tbody>\r\n                                    </table>\r\n\r\n                                    <button class=\"btn btn-link\" role=\"link\" file-download download-url=\"$ctrl.getPropertyValuationUrl(contract)\" download-finished-message=\"Message_PropertyValuationReportDownloadReady\" download-failed-message=\"Message_DownloadPropertyValuationFailed\">\r\n                                        <span data-i18n=\"Hyperlink_DownloadPropertyValuationReport\"></span>\r\n                                    </button>\r\n\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n\r\n                        <div class=\"panel transparent\">\r\n                            <div collapsible-panel id=\"rentprice_{{$index}}\" data-i18n-attr=\"Panel_Rentprice|heading\" expanded=\"false\">\r\n                                <div>\r\n                                    <div class=\"label-group\" data-i18n=\"Label_RentpriceInformation\"></div>\r\n                                    <table class=\"table\">\r\n                                        <tbody>\r\n                                            <tr ng-repeat=\"item in contract.RentedItems\">\r\n                                                <td>{{item.Description}}</td>\r\n                                                <td class=\"currency\">{{item.Amount | number : 2}}</td>\r\n                                            </tr>\r\n                                            <tr>\r\n                                                <td><b data-i18n=\"Label_RentpriceTotal\"></b></td>\r\n                                                <td class=\"currency\"><b>{{$ctrl.getTotalRentprice(contract) | number : 2}}</b></td>\r\n                                            </tr>\r\n                                            <tr>\r\n                                                <td data-i18n=\"Label_subsidiabele_huur\"></td>\r\n                                                <td class=\"currency\" style=\"display: flex; flex-direction: row\">\r\n                                                    <span>{{contract.SubsidyRentAmount | number : 2}}</span>\r\n                                                    <tooltip class=\"table-tooltip\" placement=\"bottom\" data-i18n-attr=\"Toelichting_subsidiabele_huur|content\" />\r\n                                                </td>\r\n                                            </tr>\r\n                                        </tbody>\r\n                                    </table>\r\n                                    <button class=\"btn btn-link\" role=\"link\" file-download download-url=\"$ctrl.getRentCompositionUrl(contract)\" download-finished-message=\"Message_RentPriceReportDownloadReady\" download-failed-message=\"Message_DownloadRentPriceFailed\">\r\n                                        <span data-i18n=\"Hyperlink_DownloadRentPriceReport\"></span>\r\n                                    </button>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n\r\n                        <div class=\"panel transparent\">\r\n                            <div collapsible-panel id=\"payment_details_{{$index}}\" data-i18n-attr=\"Panel_PaymentDetails|heading\" expanded=\"false\">\r\n                                <div ng-show=\"!$ctrl.isEdittingContract[$index]\">\r\n                                    <label data-i18n=\"Label_PaymentMethodTitle\"></label>\r\n                                    <ul>\r\n                                        <li>\r\n                                            <tooltip class=\"pull-right\" data-i18n-attr=\"Label_DirectDebitInfo|content\" content=\"\" placement=\"bottom\"></tooltip>\r\n                                            <span data-i18n=\"Label_DirectDebitLabel\"></span>\r\n                                        </li>\r\n                                        <li ng-show=\"$ctrl.generalSettings.ChangePaymentMetAcceptgiro\">\r\n                                            <tooltip class=\"pull-right\" data-i18n-attr=\"Label_AcceptGiroInfo|content\" content=\"\" placement=\"bottom\"></tooltip>\r\n                                            <span data-i18n=\"Label_AcceptGiroLabel\"></span>\r\n                                        </li>\r\n                                        <li>\r\n                                            <tooltip class=\"pull-right\" data-i18n-attr=\"Label_PayYourselfInfo|content\" content=\"\" placement=\"bottom\"></tooltip>\r\n                                            <span data-i18n=\"Label_PayYourself\"></span>\r\n                                        </li>\r\n                                    </ul>\r\n\r\n                                </div>\r\n\r\n                                <form name=\"form\" novalidate ng-class=\"{readonly: !$ctrl.isEdittingContract[$index]}\">\r\n\r\n                                    <div class=\"label-group\">\r\n                                        <label data-i18n=\"Label_CurrentPaymentMethod\" ng-hide=\"contract.BankAccount.PaymentMethodNew\"></label>\r\n                                        <label data-i18n=\"Label_NewPaymentMethod\" ng-show=\"contract.BankAccount.PaymentMethodNew\"></label>\r\n                                        <div name=\"paymentMethodValue\" class=\"labelValue\">{{$ctrl.getPaymentMethodName(contract)}}</div>\r\n                                    </div>\r\n\r\n                                    <div ng-show=\"$ctrl.isDirectDebit(contract)\" class=\"form-group\">\r\n\r\n                                        <div class=\"input-group input-group-unstyled\">\r\n                                            <div class=\"form-group has-feedback\">\r\n                                                <label for=\"accountHolderName\" data-i18n=\"Label_AccountHolderName\"></label>\r\n                                                <input type=\"text\" name=\"accountHolderName\" ng-required=\"$ctrl.isDirectDebit(contract)\" ng-model=\"contract.BankAccount.AccountHolderName\" class=\"form-control\" ng-readonly=\"!$ctrl.isEdittingContract[$index]\">\r\n                                                <span class=\"icon_ form-control-feedback\"></span>\r\n                                            </div>\r\n\r\n                                            <tooltip class=\"input-group-addon no-horizontal-padding\" content=\"\" placement=\"bottom\" data-i18n-attr=\"Tooltip_AccountHolderName|content\" />\r\n                                        </div>\r\n\r\n                                        <div class=\"input-group input-group-unstyled\">\r\n                                            <div class=\"form-group\">\r\n                                                <label for=\"iban\" data-i18n=\"Label_IBAN\"></label>\r\n                                                <input type=\"text\" ng-required=\"$ctrl.isDirectDebit(contract)\" ng-model=\"contract.BankAccount.IBAN\" class=\"form-control\" name=\"ibanDirectDebit\" ng-readonly=\"!$ctrl.isEdittingContract[$index]\">\r\n                                            </div>\r\n\r\n                                            <tooltip class=\"input-group-addon no-horizontal-padding\" content=\"\" placement=\"top\" data-i18n-attr=\"Tooltip_IBAN|content\" />\r\n                                        </div>\r\n\r\n                                        <div ng-show=\"$ctrl.isEdittingContract[$index]\">\r\n                                            <div class=\"input-group input-group-unstyled\" ng-show=\"form.ibanDirectDebit.$dirty || !$ctrl.originalIsDirectDebit($index)\">\r\n                                                <div class=\"form-group-checkbox\">\r\n                                                    <label data-i18n=\"Checkbox_AutomaticPayment\"></label>\r\n                                                    <input type=\"checkbox\" ng-required=\"$ctrl.isDirectDebit(contract)\" ng-model=\"contract.BankAccount.CheckBoxAutomaticPayment\" name=\"checkBoxAutomaticPayment\" data-toggle=\"toggle\">\r\n                                                </div>\r\n\r\n                                                <tooltip class=\"input-group-addon no-horizontal-padding\" content=\"\" placement=\"top\" data-i18n-attr=\"Tooltip_AutomaticPayment|content\" />\r\n                                            </div>\r\n\r\n                                            <div data-i18n=\"Label_DirectDebitChangeText\" ng-show=\"$ctrl.showDirectDebitMessage(contract)\" class=\"form-group\"></div>\r\n\r\n                                            <div ng-hide=\"$ctrl.showDirectDebitMessage(contract) || contract.BankAccount.PaymentMethodNew\" class=\"form-group\">\r\n                                                <div data-i18n=\"Label_AllsoPayVia\"></div>\r\n                                                <a href=\"javascript:void(0)\" ng-click=\"$ctrl.setPaymentToBankTransfer(contract)\" data-i18n=\"Label_Acceptgiro\"></a>\r\n                                            </div>\r\n                                        </div>\r\n                                    </div>\r\n\r\n                                    <div ng-show=\"$ctrl.isBankTransfer(contract)\" class=\"form-group\">\r\n                                        <div class=\"input-group input-group-unstyled\">\r\n                                            <div class=\"form-group has-feedback\">\r\n                                                <label for=\"accountHolderName\" data-i18n=\"Label_AccountHolderName\"></label>\r\n                                                <input type=\"text\" ng-required=\"$ctrl.isDirectDebit(contract)\" ng-model=\"contract.BankAccount.AccountHolderName\" class=\"form-control\" name=\"accountHolderName\" ng-readonly=\"!$ctrl.isEdittingContract[$index]\">\r\n                                                <span class=\"icon_ form-control-feedback\"></span>\r\n                                            </div>\r\n\r\n                                            <tooltip class=\"input-group-addon no-horizontal-padding\" content=\"\" placement=\"bottom\" data-i18n-attr=\"Tooltip_AccountHolderName|content\" />\r\n                                        </div>\r\n\r\n                                        <div class=\"input-group input-group-unstyled\">\r\n                                            <div class=\"form-group has-feedback\">\r\n                                                <label for=\"iban\" data-i18n=\"Label_IBAN\"></label>\r\n                                                <input type=\"text\" ng-required=\"$ctrl.isDirectDebit(contract)\" ng-model=\"contract.BankAccount.IBAN\" class=\"form-control\" name=\"ibanBankTransfer\" ng-readonly=\"!$ctrl.isEdittingContract[$index]\">\r\n                                                <span class=\"icon_ form-control-feedback\"></span>\r\n                                            </div>\r\n\r\n                                            <tooltip class=\"input-group-addon no-horizontal-padding\" content=\"\" placement=\"top\" data-i18n-attr=\"Tooltip_IBAN|content\" />\r\n                                        </div>\r\n\r\n                                        <div class=\"form-group\" ng-show=\"$ctrl.isEdittingContract[$index] &&  !contract.BankAccount.PaymentMethodNew\">\r\n                                            <div data-i18n=\"Label_AllsoPayVia\"></div>\r\n\r\n                                            <a href=\"javascript:void(0)\" ng-click=\"$ctrl.setPaymentToDirectDebit(contract)\" data-i18n=\"Label_DirectDebitLabel\"></a>\r\n                                        </div>\r\n                                    </div>\r\n\r\n                                    <div ng-show=\"($ctrl.isPayYourself(contract) || $ctrl.isPaymentMethodNotSet(contract)) && $ctrl.isEdittingContract[$index]\" class=\"form-group\">\r\n                                        <div class=\"form-group\">\r\n                                            <div data-i18n=\"Label_AllsoPayVia\"></div>\r\n                                            <div>\r\n                                                <a href=\"javascript:void(0)\" ng-show=\"!$ctrl.isPayYourself(contract) || $ctrl.generalSettings.ChangePaymentMetAcceptgiro\"\r\n                                                   ng-click=\"$ctrl.setPaymentToBankTransfer(contract)\" data-i18n=\"Label_Acceptgiro\"></a>\r\n                                            </div>\r\n                                            <div>\r\n                                                <a href=\"javascript:void(0)\" ng-click=\"$ctrl.setPaymentToDirectDebit(contract)\" data-i18n=\"Label_DirectDebitLabel\"></a>\r\n                                            </div>\r\n                                        </div>\r\n                                    </div>\r\n\r\n                                    <div class=\"form-group\">\r\n                                        <!-- The buttons that are shown when editing -->\r\n                                        <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"form.$invalid\" ng-click=\"$ctrl.updateCurrentBankAccountInformation(form, contract, $index);\" ng-show=\"$ctrl.isEdittingContract[$index] && !$ctrl.isPayYourself(contract)\">\r\n                                            <span data-i18n=\"Button_Save\"></span><span class=\"glyphicon glyphicon-menu-right\"></span>\r\n                                        </button>\r\n                                        <button type=\"button\" class=\"btn btn-cancel pull-right\" ng-show=\"$ctrl.isEdittingContract[$index]\" ng-click=\"$ctrl.cancelEdittingPaymentDetails(form, $index)\" data-i18n=\"Button_Cancel\"></button>\r\n                                    </div>\r\n                                </form>\r\n\r\n                                <!-- The button that enables the edit mode -->\r\n                                <button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.startEdittingPaymentDetails($index);\" ng-show=\"!$ctrl.isEdittingContract[$index]\" portal-module=\"ChangePaymentMethod\">\r\n                                    <span data-i18n=\"Button_ChangePaymentSettings\"></span><span class=\"glyphicon glyphicon-menu-right\"></span>\r\n                                </button>\r\n\r\n                            </div>\r\n                        </div>\r\n\r\n                        <div class=\"panel transparent\" portal-module=\"PlannedMaintenance\">\r\n                            <div collapsible-panel id=\"planned_maintenance_{{$index}}\" data-i18n-attr=\"Panel_PlannedMaintenance|heading\" expanded=\"false\">\r\n                                <div ng-hide=\"contract.RentalUnit.PlannedMaintenance.length > 0\" data-i18n=\"Label_NoPlannedMaintenance\"></div>\r\n                                <div ng-show=\"contract.RentalUnit.PlannedMaintenance.length > 0\">\r\n                                    <div class=\"label-group\" data-i18n=\"Label_PlannedMaintenanceInformation\"></div>\r\n                                    <table class=\"table table-condensed table-responsive\">\r\n                                        <thead>\r\n                                            <tr>\r\n                                                <th data-i18n=\"Column_Project\"></th>\r\n                                                <th data-i18n=\"Column_StartDate\"></th>\r\n                                            </tr>\r\n                                        </thead>\r\n                                        <tbody>\r\n                                            <tr data-toggle=\"collapse\" data-target=\"#maintenance_details_{{contract.EntryNo}}_{{$index}}\" class=\"accordion-toggle collapsed\" ng-repeat-start=\"item in contract.RentalUnit.PlannedMaintenance\">\r\n                                                <td>{{item.ProjectName}}</td>\r\n                                                <td>{{item.StartDate | date: \'dd-MM-yyyy\'}}</td>\r\n                                            </tr>\r\n                                            <tr ng-repeat-end>\r\n                                                <td colspan=\"2\" class=\"table-hidden-row\">\r\n                                                    <div class=\"collapse\" id=\"maintenance_details_{{contract.EntryNo}}_{{$index}}\">\r\n                                                        <div class=\"accordion-body\">\r\n                                                            <div class=\"label-group\">\r\n                                                                <label data-i18n=\"Label_ProjectDescription\"></label>\r\n                                                                <div class=\"labelValue\">{{item.Description}}</div>\r\n                                                            </div>\r\n\r\n                                                            <div class=\"label-group\">\r\n                                                                <label data-i18n=\"Label_DeliveryDate\"></label>\r\n                                                                <div class=\"labelValue\">{{item.DeliveryDate | date: \'dd-MM-yyyy\'}}</div>\r\n                                                            </div>\r\n                                                        </div>\r\n                                                    </div>\r\n                                                </td>\r\n                                            </tr>\r\n                                        </tbody>\r\n                                    </table>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n\r\n                        <div class=\"panel transparent\" portal-module=\"ContractDocuments\">\r\n                            <div collapsible-panel id=\"documents_{{$index}}\" data-i18n-attr=\"Panel_Documents|heading\" expanded=\"false\" on-expand=\"$ctrl.loadDocuments(contract);\">\r\n                                <div ng-show=\"contract.Documents.data.length === 0\" data-i18n=\"Label_NoDocuments\"></div>\r\n                                <div ng-show=\"contract.Documents.data.length > 0\">\r\n                                    <div class=\"label-group\" data-i18n=\"Label_DocumentsInformation\"></div>\r\n                                    <table class=\"table\" style=\"table-layout:fixed\">\r\n                                        <tbody>\r\n                                            <tr ng-repeat=\"document in contract.Documents.data\">\r\n                                                <td>\r\n\r\n                                                    <button style=\"width: 100%; max-width: 100% \" class=\"btn btn-link\" role=\"link\" file-download download-url=\"$ctrl.getDownloadDocumentUrl(contract, document)\"\r\n                                                            download-finished-message=\"Message_DownloadDocumentFinished\"\r\n                                                            download-failed-message=\"Message_DownloadDocumentFailed\">\r\n                                                        <span style=\"display:inline-block; width:100%; text-overflow:ellipsis; overflow:hidden; text-align:justify \"\r\n                                                              title=\"{{document.Name}}\">{{document.Name}}</span>\r\n                                                    </button>\r\n\r\n                                                </td>\r\n                                            </tr>\r\n                                        </tbody>\r\n                                    </table>\r\n\r\n\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <style>\r\n        .table-tooltip a {\r\n            padding: 0;\r\n            padding-left: 10px;\r\n            border: 0;\r\n        }\r\n    </style>\r\n\r\n");
$templateCache.put("/App/myDetails/myDetails.html","<div data-viewname=\"MyDetails\">\r\n    <div class=\"panel-group\" role=\"tablist\" id=\"myDetailsPanels\" aria-multiselectable=\"false\">\r\n\r\n        <div class=\"panel transparent\">\r\n            <div collapsible-panel id=\"myHousehold\" heading=\"Mijn Huishouden\" expanded=\"true\">\r\n                <my-household></my-household>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"panel transparent\">\r\n            <div collapsible-panel id=\"myContactDetailsPanel\" data-i18n-attr=\"Title_My_Contact_Details|heading\" expanded=\"true\">\r\n                <form name=\"myDetailsForm\" novalidate ng-class=\"{readonly: !$ctrl.isEdittingMyDetails}\">\r\n                    <div class=\"input-group input-group-unstyled col-xs-12\">\r\n                        <div class=\"form-group\">\r\n                            <label for=\"TenantNumber\" data-i18n=\"Label_Tenant_Number\"></label>\r\n                            <input id=\"TenantNumber\" type=\"text\" ng-model=\"$ctrl.customerDetails.CustomerNo\" class=\"form-control\" data-i18n-attr=\"Placeholder_Tenant_Number|placeholder\" ng-readonly=\"true\">\r\n                            <span class=\"icon_ form-control-feedback\"></span>\r\n                        </div>\r\n\r\n                        <tooltip class=\"input-group-addon no-horizontal-padding\" placement=\"bottom\" data-i18n-attr=\"Tooltip_Tenant_Number|content\" />\r\n                    </div>\r\n\r\n                    <div class=\"input-group input-group-unstyled col-xs-12\">\r\n                        <div class=\"form-group has-feedback\">\r\n                            <label for=\"PhoneNumber\" data-i18n=\"Label_PhoneNumber\"></label>\r\n                            <input name=\"PhoneNumber\" type=\"tel\" phonenumber ng-maxlength=\"30\" ng-model=\"$ctrl.customerDetails.PhoneNo\" class=\"form-control\" focus-on=\"focusContactDetails\" data-i18n-attr=\"Placeholder_PhoneNumber|placeholder\" ng-readonly=\"!$ctrl.isEdittingMyDetails\">\r\n                            <span class=\"icon_ form-control-feedback\"></span>\r\n                            <div ng-messages=\"myDetailsForm.PhoneNumber.$error\" class=\"text-danger\" ng-show=\"myDetailsForm.PhoneNumber.$dirty||myDetailsForm.$submitted\">\r\n                                <div ng-message=\"maxlength\"><span data-i18n=\"Message_MaxLength\" /></div>\r\n                                <div ng-message=\"$ctrl.customerDetails.PhoneNo\"><span data-i18n=\"Message_InvalidPhoneNumber\" /></div>\r\n                                <div ng-message=\"phonenumber\"><span data-i18n=\"Message_InvalidPhoneNumber\" /></div>\r\n                            </div>\r\n                        </div>\r\n\r\n                        <tooltip class=\"input-group-addon no-horizontal-padding\" placement=\"bottom\" data-i18n-attr=\"Tooltip_PhoneNumber|content\" />\r\n                    </div>\r\n\r\n                    <!-- The button that enables the edit mode -->\r\n                    <button id=\"btnMyDataEdit\" type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.startEdittingContactDetails();\" ng-show=\"!$ctrl.isEdittingMyDetails\"><span data-i18n=\"Button_Edit\"></span><span class=\"glyphicon glyphicon-menu-right\"></span></button>\r\n                    <!-- The buttons that are shown when editting -->\r\n                    <button id=\"btnMyDataSubmit\" type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"!myDetailsForm.$dirty || myDetailsForm.input_mail.$pending\" ng-show=\"$ctrl.isEdittingMyDetails\" ng-click=\"$ctrl.saveContactDetails(myDetailsForm)\"><span data-i18n=\"Button_Save\"></span><span class=\"glyphicon glyphicon-menu-right\"></span></button>\r\n                    <button id=\"btnMyDataCancel\" type=\"button\" class=\"btn btn-cancel pull-right\" ng-show=\"$ctrl.isEdittingMyDetails\" ng-click=\"$ctrl.cancelEdittingContactDetails(myDetailsForm)\" data-i18n=\"Button_Cancel\"></button>\r\n                </form>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"panel transparent\">\r\n            <div collapsible-panel id=\"myEmailAddressPanel\" data-i18n-attr=\"Title_My_EmailAddress|heading\" expanded=\"true\">\r\n                <form name=\"myEmailAddressForm\" novalidate ng-class=\"{readonly: !$ctrl.isEdittingMyEmailAddress}\">\r\n                    <div class=\"input-group input-group-unstyled col-xs-12\">\r\n                        <div class=\"form-group has-feedback\">\r\n                            <label for=\"input_mail\" data-i18n=\"Label_EmailAddress\"></label>\r\n                            <input name=\"input_mail\" type=\"email\" email unique required ng-maxlength=\"80\" ng-model=\"$ctrl.customerDetails.Email\" class=\"form-control\" data-i18n-attr=\"Placeholder_EmailAddress|placeholder\" ng-readonly=\"!$ctrl.isEdittingMyEmailAddress\">\r\n                            <span class=\"icon_ form-control-feedback\"></span>\r\n                            <div>\r\n                                <span ng-show=\"$ctrl.isEdittingMyEmailAddress\" ng-if=\"myEmailAddressForm.input_mail.$pending\" data-i18n=\"Message_CheckingEmail\">\r\n                                </span>\r\n                            </div>\r\n                            <div ng-messages=\"myEmailAddressForm.input_mail.$error\" class=\"text-danger\" ng-show=\"myEmailAddressForm.input_mail.$dirty||myEmailAddressForm.$submitted\">\r\n                                <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></div>\r\n                                <div ng-message=\"maxlength\"><span data-i18n=\"Message_MaxLength\" /></div>\r\n                                <div ng-message=\"email\"><span data-i18n=\"Message_InvalidEmail\" /></div>\r\n                                <div ng-message=\"$ctrl.customerDetails.Email\"><span data-i18n=\"Message_EmailTaken\" /></div>\r\n                            </div>\r\n                        </div>\r\n\r\n                        <tooltip class=\"input-group-addon no-horizontal-padding\" placement=\"bottom\" data-i18n-attr=\"Tooltip_EmailAddress|content\" />\r\n                    </div>\r\n                    <!-- The button that enables the edit mode -->\r\n                    <button id=\"btnMyDataEdit\" type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.startEdittingEmailAddress();\" ng-disabled=\"$ctrl.user.RoleName == \'KCC-medewerker\'\" ng-show=\"!$ctrl.isEdittingMyEmailAddress\"><span data-i18n=\"Button_Edit\"></span><span class=\"glyphicon glyphicon-menu-right\"></span></button>\r\n                    <!-- The buttons that are shown when editting -->\r\n                    <button id=\"btnMyDataSubmit\" type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"!myEmailAddressForm.$dirty || myEmailAddressForm.input_mail.$pending\" ng-show=\"$ctrl.isEdittingMyEmailAddress\" ng-click=\"$ctrl.saveEmailAddress(myEmailAddressForm)\"><span data-i18n=\"Button_Save\"></span><span class=\"glyphicon glyphicon-menu-right\"></span></button>\r\n                    <button id=\"btnMyDataCancel\" type=\"button\" class=\"btn btn-cancel pull-right\" ng-show=\"$ctrl.isEdittingMyEmailAddress\" ng-click=\"$ctrl.cancelEdittingEmailAddress(myEmailAddressForm)\" data-i18n=\"Button_Cancel\"></button>\r\n\r\n                </form>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"panel transparent\">\r\n            <div collapsible-panel id=\"myAddressPanel\" data-i18n-attr=\"Title_My_Contact_Address|heading\" expanded=\"false\">\r\n                <form name=\"myAddressForm\" id=\"myAddressForm\" novalidate ng-class=\"{readonly: !$ctrl.isEdittingMyAddress}\">\r\n\r\n                    <div class=\"input-group input-group-unstyled col-xs-12\" ng-show=\"!$ctrl.isEdittingMyAddress\" style=\"margin-bottom: 10px\">\r\n                        <div class=\"form-group\">\r\n                            <label for=\"addressLine1\" data-i18n=\"Label_AddressLine1\"></label>\r\n                            <input id=\"addressLine1\" type=\"tel\" class=\"form-control\" ng-readonly=\"true\" value=\"{{$ctrl.customerAddressLine1()}}\">\r\n                            <span class=\"icon_ form-control-feedback\"></span>\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div class=\"input-group input-group-unstyled col-xs-12\" ng-show=\"!$ctrl.isEdittingMyAddress\">\r\n                        <div class=\"form-group\">\r\n                            <label for=\"addressLine2\" data-i18n=\"Label_AddressLine2\"></label>\r\n                            <input id=\"addressLine2\" type=\"tel\" class=\"form-control\" ng-readonly=\"true\" value=\"{{$ctrl.customerAddressLine2()}}\">\r\n                            <span class=\"icon_ form-control-feedback\"></span>\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div class=\"input-group input-group-unstyled\" ng-show=\"$ctrl.isEdittingMyAddress\">\r\n                        <div class=\"form-group has-feedback\">\r\n                            <label for=\"country\" data-i18n=\"Label_Country\"></label>\r\n                            <div class=\"select-container\">\r\n                                <select id=\"country\" ng-model=\"$ctrl.customerDetails.CountryCode\" ng-change=\"$ctrl.determineForeignCountry();$ctrl.updateStreetAndCity(myAddressForm)\" class=\"form-control\" focus-on=\"focusAddress\"\r\n                                        ng-options=\"country.Code as country.Code + (country.Name ? \' - \' + country.Name : \'\') for country in $ctrl.countries\">\r\n                                    <option value=\'\' disabled selected style=\'display:none;\' data-i18n=\"Placeholder_Country|placeholder\"></option>\r\n                                </select>\r\n                                <span class=\"icon_ form-control-feedback\"></span>\r\n                                <span class=\"glyphicon glyphicon-chevron-down dropdown_icon\"></span>\r\n                            </div>\r\n                        </div>\r\n\r\n                        <tooltip class=\"input-group-addon no-horizontal-padding\" placement=\"bottom\" data-i18n-attr=\"Tooltip_Country|content\" />\r\n                    </div>\r\n\r\n                    <div class=\"input-group input-group-unstyled\" ng-show=\"$ctrl.isEdittingMyAddress\">\r\n                        <div class=\"form-group has-feedback\">\r\n                            <label for=\"postcode\" data-i18n=\"Label_Postal_Code\"></label>\r\n                            <input id=\"postcode\" name=\"postcode\" ng-model-options=\"{ debounce: 100 }\" type=\"text\" ng-maxlength=\"10\" ng-required=\"true\" style=\"text-transform: uppercase\" ng-change=\"$ctrl.updateStreetAndCity(myAddressForm)\" ng-model=\"$ctrl.customerDetails.Postcode\" class=\"form-control\" data-i18n-attr=\"Placeholder_Postal_Code|placeholder\" ng-readonly=\"!$ctrl.isEdittingMyAddress\">\r\n                            <span class=\"icon_ form-control-feedback\"></span>\r\n\r\n                            <div ng-messages=\"myAddressForm.postcode.$error\" class=\"text-danger\" ng-show=\"myAddressForm.postcode.$touched||myAddressForm.$submitted\">\r\n                                <div ng-message=\"maxlength\"><span data-i18n=\"Message_MaxLength\" /></div>\r\n                                <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></div>\r\n                                <div ng-message=\"validaddress\"><span data-i18n=\"Message_InvalidPostcode\" /></div>\r\n                            </div>\r\n                        </div>\r\n\r\n                        <tooltip class=\"input-group-addon no-horizontal-padding\" placement=\"bottom\" data-i18n-attr=\"Tooltip_Postal_Code|content\" />\r\n                    </div>\r\n\r\n                    <div class=\"input-group input-group-unstyled\" ng-show=\"$ctrl.isEdittingMyAddress\">\r\n                        <div class=\"form-group has-feedback\">\r\n                            <label for=\"HouseNumber\" data-i18n=\"Label_Number\"></label>\r\n                            <input id=\"HouseNumber\" name=\"HouseNumber\" ng-model-options=\"{ debounce: 100 }\" type=\"number\" ng-model=\"$ctrl.customerDetails.HouseNo\" ng-required=\"true\" ng-maxlength=\"5\" ng-change=\"$ctrl.updateStreetAndCity(myAddressForm)\" class=\"form-control\" data-i18n-attr=\"Placeholder_Number|placeholder\" ng-readonly=\"!$ctrl.isEdittingMyAddress\">\r\n                            <span class=\"icon_ form-control-feedback\"></span>\r\n                            <div ng-messages=\"myAddressForm.HouseNumber.$error\" class=\"text-danger\" ng-show=\"myAddressForm.HouseNumber.$touched||myAddressForm.$submitted\">\r\n                                <div ng-message=\"maxlength\"><span data-i18n=\"Message_MaxLength\" /></div>\r\n                                <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\" /></div>\r\n                                <div ng-message=\"validaddress\"><span data-i18n=\"Message_InvalidPostcode\" /></div>\r\n                            </div>\r\n                        </div>\r\n\r\n                        <tooltip class=\"input-group-addon no-horizontal-padding\" placement=\"bottom\" data-i18n-attr=\"Tooltip_Number|content\" />\r\n                    </div>\r\n\r\n                    <div class=\"input-group input-group-unstyled\" ng-show=\"$ctrl.isEdittingMyAddress\">\r\n                        <div class=\"form-group has-feedback\">\r\n                            <label for=\"HouseNumberAddition\" data-i18n=\"Label_Number_Addition\"></label>\r\n                            <input name=\"HouseNumberAddition\" type=\"text\" ng-maxlength=\"20\" ng-model=\"$ctrl.customerDetails.HouseNoAddition\" class=\"form-control\" data-i18n-attr=\"Placeholder_Number_Addition|placeholder\" ng-readonly=\"!$ctrl.isEdittingMyAddress\">\r\n                            <span class=\"icon_ form-control-feedback\"></span>\r\n                            <div ng-messages=\"myAddressForm.HouseNumberAddition.$error\" class=\"text-danger\" ng-show=\"myAddressForm.HouseNumberAddition.$touched||myAddressForm.$submitted\">\r\n                                <div ng-message=\"maxlength\"><span data-i18n=\"Message_MaxLength\" /></div>\r\n                            </div>\r\n                        </div>\r\n\r\n                        <tooltip class=\"input-group-addon no-horizontal-padding\" placement=\"bottom\" data-i18n-attr=\"Tooltip_Number_Addition|content\" />\r\n                    </div>\r\n\r\n                    <div class=\"input-group input-group-unstyled\" ng-show=\"$ctrl.isEdittingMyAddress\">\r\n                        <div class=\"form-group has-feedback\">\r\n                            <label for=\"Street\" data-i18n=\"Label_Street\"></label>\r\n                            <input name=\"Street\" type=\"text\" ng-model=\"$ctrl.customerDetails.Street\" ng-required=\"!$ctrl.isNL\" ng-maxlength=\"50\" class=\"form-control\" ng-readonly=\"$ctrl.isNL\">\r\n                            <span class=\"icon_ form-control-feedback\"></span>\r\n                            <div ng-messages=\"myAddressForm.Street.$error\" class=\"text-danger\" ng-show=\"myAddressForm.Street.$touched||myAddressForm.$submitted\">\r\n                                <div ng-message=\"maxlength\"><span data-i18n=\"Message_MaxLength\" /></div>\r\n                                <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\" /></div>\r\n                            </div>\r\n                        </div>\r\n\r\n                        <tooltip class=\"input-group-addon no-horizontal-padding\" placement=\"bottom\" data-i18n-attr=\"Tooltip_Street|content\" />\r\n                    </div>\r\n\r\n                    <div class=\"input-group input-group-unstyled\" ng-show=\"$ctrl.isEdittingMyAddress\">\r\n                        <div class=\"form-group has-feedback\">\r\n                            <label for=\"City\" data-i18n=\"Label_City\"></label>\r\n                            <input name=\"City\" type=\"text\" ng-model=\"$ctrl.customerDetails.City\" ng-maxlength=\"30\" ng-required=\"!$ctrl.isNL\" class=\"form-control\" ng-readonly=\"$ctrl.isNL\">\r\n                            <span class=\"icon_ form-control-feedback\"></span>\r\n                            <div ng-messages=\"myAddressForm.City.$error\" class=\"text-danger\" ng-show=\"myAddressForm.City.$touched||myAddressForm.$submitted\">\r\n                                <div ng-message=\"maxlength\"><span data-i18n=\"Message_MaxLength\" /></div>\r\n                                <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\" /></div>\r\n                            </div>\r\n                        </div>\r\n\r\n                        <tooltip class=\"input-group-addon no-horizontal-padding\" placement=\"bottom\" data-i18n-attr=\"Tooltip_City|content\" />\r\n                    </div>\r\n\r\n                    <!-- The button that enables the edit mode -->\r\n                    <button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.startEdittingAddress()\" ng-show=\"!$ctrl.isEdittingMyAddress\"><span data-i18n=\"Button_Edit\"></span><span class=\"glyphicon glyphicon-menu-right\"></span></button>\r\n                    <!-- The buttons that are shown when editting -->\r\n                    <button type=\"submit\" class=\"btn btn-primary\" ng-show=\"$ctrl.isEdittingMyAddress\" ng-disabled=\"!myAddressForm.$dirty\" ng-click=\"$ctrl.saveAddress(myAddressForm)\"><span data-i18n=\"Button_Save\"></span><span class=\"glyphicon glyphicon-menu-right\"></span></button>\r\n                    <button type=\"button\" class=\"btn btn-cancel pull-right\" ng-show=\"$ctrl.isEdittingMyAddress\" ng-click=\"$ctrl.cancelEdittingAddress(myAddressForm)\" data-i18n=\"Button_Cancel\"></button>\r\n\r\n                </form>\r\n\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"panel transparent\" portal-module=\"ChangePassword\">\r\n            <div collapsible-panel id=\"changePassword\" data-i18n-attr=\"Panel_ChangePassword|heading\" expanded=\"false\">\r\n                <change-password></change-password>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"panel transparent\">\r\n            <div collapsible-panel id=\"twoFactorAuthentication\" data-i18n-attr=\"2FA_Default_Title_Text|heading\" expanded=\"true\">\r\n                <form name=\"twoFactorAuthenticationForm\" novalidate ng-class=\"{readonly: !$ctrl.isEditingTwoFactorAuthentication}\">\r\n                    <div class=\"input-group input-group-unstyled col-xs-12\">\r\n                        <div class=\"form-group has-feedback\">\r\n                            <div class=\"d-flex flex-row form-item\" style=\"display: flex;\">\r\n                                <div style=\"padding: initial \">\r\n                                    <label for=\"twoFactorEnabled\">Enabled:</label>\r\n                                </div>\r\n                                <div style=\"padding-left: 10px\">\r\n                                    <input name=\"twoFactorEnabled\" style=\"height: 14px; width:14px\" type=\"checkbox\" ng-model=\"$ctrl.twoFactorAuth.Enabled\" class=\"form-control\" ng-disabled=\"!$ctrl.isEditingTwoFactorAuthentication\">\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    <!-- The button that enables the edit mode -->\r\n                    <button id=\"btn2FaEdit\" type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.startEditingTwoFactorAuthSettings();\" ng-show=\"!$ctrl.isEditingTwoFactorAuthentication\"><span data-i18n=\"Button_Edit\"></span><span class=\"glyphicon glyphicon-menu-right\"></span></button>\r\n                    <!-- The buttons that are shown when editting -->\r\n                    <button id=\"btn2FaSubmit\" type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"!twoFactorAuthenticationForm.$dirty\" ng-show=\"$ctrl.isEditingTwoFactorAuthentication\" ng-click=\"$ctrl.saveTwoFactorAuthSettings(twoFactorAuthenticationForm)\"><span data-i18n=\"Button_Save\"></span><span class=\"glyphicon glyphicon-menu-right\"></span></button>\r\n                    <button id=\"btn2FaCancel\" type=\"button\" class=\"btn btn-cancel pull-right\" ng-show=\"$ctrl.isEditingTwoFactorAuthentication\" ng-click=\"$ctrl.cancelEditingTwoFactorAuthSettings(twoFactorAuthenticationForm)\" data-i18n=\"Button_Cancel\"></button>\r\n\r\n                </form>\r\n            </div>\r\n        </div>\r\n       \r\n        <div class=\"panel transparent\" ng-show=\"$ctrl.canEditPreferredCommunicationChannel\">\r\n            <div collapsible-panel id=\"myPreferredChannel\" data-i18n-attr=\"Title_My_Preferred_Communication_Channel|heading\" >\r\n                <form name=\"prefferedChannelForm\" novalidate ng-class=\"{readonly: !$ctrl.isEditingCorrespondenceType}\">\r\n                    <div class=\"input-group input-group-unstyled col-xs-12\">\r\n                        <div class=\"form-group has-feedback\">\r\n                            <label for=\"country\" data-i18n=\"Label_PreferredChannel\"></label>\r\n\r\n                            <div class=\"input-group input-group-unstyled col-xs-12\" ng-show=\"!$ctrl.isEditingCorrespondenceType\">\r\n                                <div class=\"form-group\">\r\n                                    <input id=\"prefChannel\" type=\"tel\" class=\"form-control\" ng-readonly=\"true\" value=\"{{$ctrl.preferredCommunicationChannel}}\">\r\n                                    <span class=\"icon_ form-control-feedback\"></span>\r\n                                </div>\r\n                            </div>\r\n                            <div class=\"select-container\" ng-show=\"$ctrl.isEditingCorrespondenceType\">\r\n                                <select id=\"chanel\" ng-init=\"$ctrl.preferredCommunicationChannel\" ng-model=\"$ctrl.preferredCommunicationChannel\" ng-change=\"$ctrl.updatePrefferedCommunicationChanel(prefferedChannelForm)\" class=\"form-control\"\r\n                                        ng-options=\"chanel for chanel in $ctrl.correspondenceType\">\r\n                                    <option value=\"\" disabled selected style=\'display:none;\'></option>\r\n                                </select>\r\n                                <span class=\"icon_ form-control-feedback\"></span>\r\n                                <span class=\"glyphicon glyphicon-chevron-down dropdown_icon\"></span>\r\n                            </div>\r\n                        </div>\r\n                        <tooltip class=\"input-group-addon no-horizontal-padding\" placement=\"bottom\" data-i18n-attr=\"Tooltip_PreferredChannel|content\" />\r\n                    </div>\r\n                    <!-- The button that enables the edit mode -->\r\n                    <button id=\"btnPrefferedChanelEdit\" type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.startEdittingPrefferedCommunicationChanel();\" ng-show=\"!$ctrl.isEditingCorrespondenceType\"><span data-i18n=\"Button_Edit\"></span><span class=\"glyphicon glyphicon-menu-right\"></span></button>\r\n                    <!-- The buttons that are shown when editting -->\r\n                    <button id=\"btnPrefferedChanelSubmit\" type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"!prefferedChannelForm.$dirty\" ng-show=\"$ctrl.isEditingCorrespondenceType\" ng-click=\"$ctrl.savePrefferedCommunicationChanel(prefferedChannelForm)\"><span data-i18n=\"Button_Save\"></span><span class=\"glyphicon glyphicon-menu-right\"></span></button>\r\n                    <button id=\"btnPrefferedChanelCancel\" type=\"button\" class=\"btn btn-cancel pull-right\" ng-show=\"$ctrl.isEditingCorrespondenceType\" ng-click=\"$ctrl.cancelEdittingPrefferedCommunicationChanel(prefferedChannelForm)\" data-i18n=\"Button_Cancel\"></button>\r\n                </form>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("/App/myDocuments/myDocuments.html","<div data-viewname=\"MyDocuments\">\r\n    <div panel class=\"panel-default\" data-i18n-attr=\"Panel_Title|heading\">\r\n        <div data-i18n=\"Page_Info_Text\" ng-show=\"$ctrl.hasDocuments\"></div>\r\n        <div data-i18n=\"No_Documents_Text\" ng-show=\"$ctrl.hasDocuments == false\"></div>\r\n        <table ng-show=\"$ctrl.hasDocuments\" class=\"table table-condensed table-responsive\">\r\n            <thead>\r\n                <tr>\r\n                    <th data-i18n=\"Column_Date\"></th>\r\n                    <th data-i18n=\"Column_Subject\"></th>\r\n                    <th></th>\r\n                    <th></th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr ng-repeat-start=\"document in $ctrl.documents | orderBy: [\'-sortDate\', \'Subject\', \'-Id\']\"\r\n                    ng-attr-data-toggle=\"{{document.WorkingFolderPDFCount > 0 && document.PublishWorkingFolderDocuments == \'1\' ? \'collapse\' : \'\'}}\" aria-expanded=\"false\"\r\n                    data-target=\"#document_details_{{$index}}\"\r\n                    ng-class=\"{\'collapsed\':document.WorkingFolderPDFCount > 0 && document.PublishWorkingFolderDocuments == \'1\'}\"\r\n                    ng-click=\"$ctrl.loadAttachments(document)\">\r\n\r\n                    <td class=\"valign-middle\">\r\n                        {{document.Date | date : \'dd-MM-yyyy\'}}\r\n                    </td>\r\n                    <td>\r\n                        {{document.Subject}}<br/>{{document.SubSubject}}\r\n                    </td>\r\n                    <td class=\"text-right\">\r\n\r\n                            <button class=\"btn btn-link\" role=\"link\"\r\n                                    tabindex=\"-1\"\r\n                                    data-placement=\"top\"\r\n                                    data-type=\"default\"\r\n                                    data-toggle=\"custompopover\"\r\n                                    data-trigger=\"hover\"\r\n                                    data-i18n-attr=\"Tooltip_DownloadDocument|data-content\"\r\n                                    tooltip-initializer\r\n                                    ng-click=\"$ctrl.expandDetails($index);\"\r\n                                    file-download download-url=\"$ctrl.getDownloadDocumentUrl(document)\"\r\n                                    download-finished-message=\"Message_DownloadDocumentFinished\"\r\n                                    download-failed-message=\"Message_DownloadDocumentFailed\">\r\n                                <span class=\"glyphicon glyphicon-save-file glyphicon-large\"\r\n>\r\n\r\n                                </span>\r\n                            </button>\r\n\r\n                        <button class=\"btn btn-link\" role=\"link\" ng-style=\"{visibility: document.WorkingFolderPDFCount > 0 && document.PublishWorkingFolderDocuments == \'1\' ? \'visible\' : \'hidden\'}\">\r\n                            <span class=\"glyphicon glyphicon-paperclip glyphicon-large\"></span>\r\n                        </button>\r\n                    </td>\r\n                </tr>\r\n                <tr ng-repeat-end>\r\n                    <td colspan=\"3\" class=\"table-hidden-row\">\r\n                        <div class=\"collapse\" id=\"document_details_{{$index}}\">\r\n                                <table class=\"table table-condensed table-responsive\">\r\n                                    <thead>\r\n                                        <tr>\r\n                                            <th data-i18n=\"Column_Attachments\"></th>\r\n                                            <th></th>\r\n                                        </tr>\r\n                                    </thead>\r\n                                    <tbody>\r\n                                        <tr ng-repeat=\"attachment in document.attachments\">\r\n                                            <td class=\"valign-middle\">\r\n                                                {{attachment.Name}}\r\n                                            </td>\r\n                                            <td class=\"text-right\">\r\n                                                <button class=\"btn btn-link\" role=\"link\"\r\n                                                        tabindex=\"-1\"\r\n                                                        data-placement=\"top\"\r\n                                                        data-type=\"default\"\r\n                                                        data-toggle=\"custompopover\"\r\n                                                        data-trigger=\"hover\"\r\n                                                        data-i18n-attr=\"Tooltip_DownloadDocument|data-content\"\r\n                                                        tooltip-initializer\r\n                                                        file-download download-url=\"$ctrl.getDownloadDocumentAttachmentUrl(document, attachment)\" \r\n                                                        download-finished-message=\"Message_DownloadDocumentFinished\" \r\n                                                        download-failed-message=\"Message_DownloadDocumentFailed\">\r\n                                                    <span class=\"glyphicon glyphicon-save-file glyphicon-large\" ></span>\r\n                                                </button>\r\n                                            </td>\r\n                                        </tr>\r\n                                    </tbody>\r\n                                </table>\r\n                        </div>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n        <div uib-pagination ng-show=\"$ctrl.hasDocuments\"\r\n                    total-items=\"$ctrl.paging.totalItems\"\r\n                    items-per-page=\"$ctrl.paging.count\"\r\n                    ng-model=\"$ctrl.paging.currentPage\"\r\n                    max-size=\"$ctrl.paging.maxSize\"\r\n                    boundary-links=\"true\"\r\n                    rotate=\"true\"\r\n                    num-pages=\"numPages\"\r\n                    first-text=\"{{$ctrl.paging.firstText}}\"\r\n                    last-text=\"{{$ctrl.paging.lastText}}\"\r\n                    next-text=\"{{$ctrl.paging.nextText}}\"\r\n                    previous-text=\"{{$ctrl.paging.previousText}}\"\r\n                    ng-change=\"$ctrl.search()\">\r\n        </div>\r\n    </div>\r\n\r\n    \r\n</div>");
$templateCache.put("/App/myHousehold/myHousehold.html","<div data-viewname=\"MyHousehold\" >\r\n    <p><a tabindex=\"-1\" role=\"button\" data-placement=\"top\" data-type=\"default\" data-toggle=\"custompopover\" data-trigger=\"focus\" data-i18n-attr=\"Label_Introduction_Reason|data-content\" data-content=\"\"><span data-i18n=\"Label_Introduction\"></span></a></p>\r\n    <p data-i18n=\"Label_Persons_In_HouseHold\" ng-show=\"$ctrl.customerDetails.RelatedContacts.length>0\"></p>\r\n\r\n    <div class=\"panel-group\" role=\"tablist\" id=\"collapsiblePanelsDirective\" aria-multiselectable=\"false\">\r\n        <div collapsible-panel ng-repeat=\"person in $ctrl.customerDetails.RelatedContacts | orderBy: [$ctrl.getPersonOrderByShowFirstFlag, $ctrl.getPersonOrderByRole, \'Surname\', \'Initials\']\"\r\n                           heading=\"{{person.DisplayName}} {{person.IsContractant ? \'(\' + person.Role.CurrentDescription + \')\' : \'\'}}\" id=\"person_{{person.No}}\" expanded=\"false\">\r\n            <form name=\"editPersonForm\" novalidate ng-class=\"{readonly: $ctrl.isReadOnly(person.No)}\">\r\n                <ng-include src=\"\'/App/myHousehold/myHouseholdDetails.html\'\"></ng-include>\r\n\r\n                <button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.startEditing(person.No)\" ng-show=\"$ctrl.isReadOnly(person.No) && $ctrl.canEdit(person)\"><span data-i18n=\"Button_Edit\"></span><span class=\"glyphicon glyphicon-menu-right\"></span></button>\r\n                <button type=\"button\" class=\"btn btn-danger\" ng-show=\"$ctrl.isReadOnly(person.No) && $ctrl.canEdit(person)\" data-i18n=\"Button_Delete\" ng-disabled=\"person.processing\" ng-click=\"$ctrl.deletePerson(person, editPersonForm)\"></button>\r\n\r\n                <button type=\"submit\" class=\"btn btn-primary\" ng-show=\"!$ctrl.isReadOnly(person.No) && $ctrl.canEdit(person)\" ng-disabled=\"!editPersonForm.$dirty || person.processing\" ng-click=\"$ctrl.updatePerson(person, editPersonForm)\"><span data-i18n=\"Button_Save\"></span><span class=\"glyphicon glyphicon-menu-right\"></span></button>\r\n                <button type=\"button\" class=\"btn btn-cancel pull-right\" ng-show=\"!$ctrl.isReadOnly(person.No) && $ctrl.canEdit(person)\" ng-disabled=\"person.processing\" ng-click=\"$ctrl.cancelEditing(person.No, editPersonForm)\" data-i18n=\"Button_Cancel\"></button>\r\n            </form>\r\n        </div>\r\n\r\n        <div collapsible-panel data-i18n-attr=\"Panel_Title_New|heading\" id=\"new_person\" expanded=\"true\" disable-interaction=\"true\" ng-show=\"$ctrl.isAddingPerson\" ng-repeat=\"person in $ctrl.addingPersons\">\r\n            <form name=\"newPersonForm\" novalidate>\r\n                <ng-include src=\"\'/App/myHousehold/myHouseholdDetails.html\'\"></ng-include>\r\n\r\n                <button type=\"submit\" class=\"btn btn-primary\" ng-show=\"$ctrl.isAddingPerson\" ng-click=\"$ctrl.saveNewPerson(newPersonForm);\" ng-disabled=\"!newPersonForm.$dirty || person.processing\"><span data-i18n=\"Button_Save\"></span><span class=\"glyphicon glyphicon-menu-right\"></span></button>\r\n                <button type=\"button\" class=\"btn btn-cancel pull-right\" ng-show=\"$ctrl.isAddingPerson\" ng-click=\"$ctrl.isAddingPerson = false\" ng-disabled=\"person.processing\" data-i18n=\"Button_Cancel\"></button>\r\n            </form>\r\n\r\n        </div>\r\n    </div>\r\n\r\n    <button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.addPerson();\" ng-show=\"$ctrl.canAddPerson()\" style=\"margin-top: 15px;\"><span data-i18n=\"Button_Add_Member\"></span><span class=\"glyphicon glyphicon-menu-right\"></span></button>\r\n\r\n</div>\r\n");
$templateCache.put("/App/myHousehold/myHouseholdDetails.html","<div class=\"input-group input-group-unstyled\">\r\n    <div class=\"form-group\">\r\n        <label class=\"control-label\" data-i18n=\"Label_Gender\"></label>\r\n        <div class=\"radio\" ng-show=\"!$ctrl.isReadOnly(person.No)\">\r\n            <label>\r\n                <input type=\"radio\" name=\"sex\" ng-model=\"person.Gender\" value=\"1\" ng-required=\"true\" focus-on=\"focusAddPerson\"> <span data-i18n=\"Value_Gender_Male\"></span>\r\n            </label>\r\n            <label>\r\n                <input type=\"radio\" name=\"sex\" ng-model=\"person.Gender\" value=\"2\" ng-required=\"true\"> <span data-i18n=\"Value_Gender_Female\"></span>\r\n            </label>\r\n        </div>\r\n        <div class=\"labelValue\" ng-show=\"$ctrl.isReadOnly(person.No)\" data-i18n=\"{{$ctrl.getGenderLabel(person.Gender)}}\"></div>\r\n    </div>\r\n\r\n    <tooltip class=\"input-group-addon no-horizontal-padding\" data-i18n-attr=\"Tooltip_Gender|content\" placement=\"bottom\"></tooltip>\r\n</div>\r\n\r\n<div class=\"input-group input-group-unstyled\">\r\n    <div class=\"form-group has-feedback\">\r\n        <label for=\"input_initials\" data-i18n=\"Label_Initials\"></label>\r\n        <input type=\"text\" id=\"input_initials\" class=\"form-control\" name=\"input_initials\" ng-maxlength=\"30\" ng-required=\"true\" capitalize data-i18n-attr=\"Placeholder_Initials|placeholder\" ng-model=\"person.Initials\" ng-readonly=\"$ctrl.isReadOnly(person.No)\" focus-on=\"focusEditPerson\">\r\n        <span class=\"icon_ form-control-feedback\"></span>\r\n        <div ng-messages=\"newPersonForm.input_initials.$error\" class=\"text-danger\">\r\n            <div ng-message=\"maxlength\">\r\n                <span data-viewname=\"MyHousehold\" data-i18n=\"Message_MaxLength\"></span>\r\n            </div>\r\n            <div ng-message=\"required\">\r\n                <span ng-if=\"newPersonForm.input_initials.$touched||newPersonForm.$submitted\" data-viewname=\"MyHousehold\" data-i18n=\"Validation_RequiredField\"></span>\r\n            </div>\r\n        </div>\r\n        <div ng-messages=\"editPersonForm.input_initials.$error\" class=\"text-danger\">\r\n            <div ng-message=\"maxlength\">\r\n                <span data-i18n=\"Message_MaxLength\"></span></div>\r\n            <div ng-message=\"required\">\r\n                <span ng-if=\"editPersonForm.input_initials.$touched||editPersonForm.$submitted\" data-i18n=\"Validation_RequiredField\"></span></div>\r\n        </div>\r\n    </div>\r\n\r\n    <tooltip class=\"input-group-addon no-horizontal-padding\" data-i18n-attr=\"Tooltip_Initials|content\" placement=\"top\"></tooltip>\r\n</div>\r\n\r\n<div class=\"input-group input-group-unstyled\">\r\n    <div class=\"form-group has-feedback\">\r\n        <label for=\"input_insertion\" data-i18n=\"Label_Insertion\"></label>\r\n        <input type=\"text\" class=\"form-control\" name=\"input_insertion\" id=\"input_insertion\" ng-maxlength=\"10\" data-i18n-attr=\"Placeholder_Insertion|placeholder\" ng-model=\"person.MiddleName\" ng-readonly=\"$ctrl.isReadOnly(person.No)\">\r\n        <span class=\"icon_ form-control-feedback\"></span>\r\n        <div ng-messages=\"newPersonForm.input_insertion.$error\" class=\"text-danger\">\r\n            <div ng-message=\"maxlength\">\r\n                <span data-i18n=\"Message_MaxLength\"></span></div>\r\n        </div>\r\n        <div ng-messages=\"editPersonForm.input_insertion.$error\" class=\"text-danger\">\r\n            <div ng-message=\"maxlength\">\r\n                <span data-i18n=\"Message_MaxLength\"></span></div>\r\n        </div>\r\n    </div>\r\n\r\n    <tooltip class=\"input-group-addon no-horizontal-padding\" data-i18n-attr=\"Tooltip_Insertion|content\" placement=\"top\"></tooltip>\r\n</div>\r\n\r\n<div class=\"input-group input-group-unstyled\">\r\n    <div class=\"form-group has-feedback\">\r\n        <label for=\"input_lastname\" data-i18n=\"Label_Surname\"></label>\r\n        <input type=\"text\" class=\"form-control\" name=\"input_lastname\" id=\"input_lastname\" ng-maxlength=\"30\" ng-required=\"true\" data-i18n-attr=\"Placeholder_Surname|placeholder\" ng-model=\"person.Surname\" ng-readonly=\"$ctrl.isReadOnly(person.No)\">\r\n        <span class=\"icon_ form-control-feedback\"></span>\r\n        <div ng-messages=\"newPersonForm.input_lastname.$error\" class=\"text-danger\">\r\n            <div ng-message=\"maxlength\">\r\n                <span data-i18n=\"Message_MaxLength\"></span></div>\r\n            <div ng-message=\"required\">\r\n                <span ng-if=\"newPersonForm.input_lastname.$touched||newPersonForm.$submitted\" data-viewname=\"MyHousehold\" data-i18n=\"Validation_RequiredField\"></span></div>\r\n        </div>\r\n        <div ng-messages=\"editPersonForm.input_lastname.$error\" class=\"text-danger\">\r\n            <div ng-message=\"maxlength\">\r\n                <span data-i18n=\"Message_MaxLength\"></span></div>\r\n            <div ng-message=\"required\">\r\n                <span ng-if=\"editPersonForm.input_lastname.$touched||editPersonForm.$submitted\" data-viewname=\"MyHousehold\" data-i18n=\"Validation_RequiredField\"></span></div>\r\n        </div>\r\n    </div>\r\n\r\n    <tooltip class=\"input-group-addon no-horizontal-padding\" data-i18n-attr=\"Tooltip_Surname|content\" placement=\"top\"></tooltip>\r\n</div>\r\n\r\n<div class=\"input-group input-group-unstyled\">\r\n    <div class=\"form-group has-feedback\">\r\n        <label for=\"input_birth\" data-i18n=\"Label_Birthdate\"></label>\r\n        <div class=\"labelValue\" ng-show=\"$ctrl.isReadOnly(person.No)\">{{$ctrl.formattedDate(person.BirthDate)}}</div>\r\n\r\n        <input name=\"input_birth\" id=\"input_birth\" type=\"text\" class=\"form-control\" data-toggle=\"datepicker\" ng-required=\"true\" data-i18n-attr=\"Placeholder_Birthdate|placeholder\" ng-model=\"person.BirthDate\" ng-show=\"!$ctrl.isReadOnly(person.No)\" ng-readonly=\"$ctrl.isReadOnly(person.No)\" datetime-picker config=\"$ctrl.preferredDatePickerConfig\"/>\r\n        <span class=\"icon_ form-control-feedback\"></span>\r\n        <span class=\"icon_calendar_light cal-icon\"></span>\r\n        <div ng-messages=\"newPersonForm.input_birth.$error\" class=\"text-danger\" ng-show=\"newPersonForm.input_birth.$touched||newPersonForm.$submitted\">\r\n            <div ng-message=\"required\"><span  data-viewname=\"MyHousehold\" data-i18n=\"Validation_RequiredField\"></span></div>\r\n            <div ng-message=\"validDate\"><span data-viewname=\"MyHousehold\" data-i18n=\"Validation_InvalidDate\"></span></div>\r\n        </div>\r\n        <div ng-messages=\"editPersonForm.input_birth.$error\" class=\"text-danger\" ng-show=\"editPersonForm.input_birth.$touched||editPersonForm.$submitted\">\r\n            <div ng-message=\"required\"><span data-viewname=\"MyHousehold\" data-i18n=\"Validation_RequiredField\"></span></div>\r\n            <div ng-message=\"validDate\"><span data-viewname=\"MyHousehold\" data-i18n=\"Validation_InvalidDate\"></span></div>\r\n        </div>\r\n    </div>\r\n\r\n    <tooltip class=\"input-group-addon no-horizontal-padding\" data-i18n-attr=\"Tooltip_Birthdate|content\" placement=\"top\"></tooltip>\r\n</div>\r\n\r\n    <div class=\"input-group input-group-unstyled\">\r\n        <div class=\"form-group\">\r\n            <label class=\"control-label\" data-i18n=\"Label_Role\"></label>\r\n            <div class=\"select-container\" ng-show=\"!$ctrl.isReadOnly(person.No)\">\r\n                <select name=\"input_role\" ng-model=\"person.Role.Current\" ng-required=\"true\" class=\"form-control\" focus-on=\"focusAddress\"\r\n                        ng-options=\"role.Code as role.Description for role in $ctrl.rolesToShow\">\r\n                    <option value=\"\" disabled selected style=\"display: none;\" data-i18n=\"Placeholder_Role|placeholder\"></option>\r\n                </select>\r\n                <span class=\"icon_ form-control-feedback\"></span>\r\n                <span class=\"glyphicon glyphicon-chevron-down dropdown_icon\"></span>\r\n            </div>\r\n            <div class=\"labelValue\" ng-show=\"$ctrl.isReadOnly(person.No)\">{{$ctrl.roleForCode(person.Role.Current)}}</div>\r\n\r\n            <div ng-messages=\"newPersonForm.input_role.$error\" class=\"text-danger\" ng-show=\"newPersonForm.input_role.$touched||newPersonForm.$submitted\">\r\n                <div ng-message=\"required\">\r\n                    <span data-viewname=\"MyHousehold\" data-i18n=\"Validation_RequiredField\"></span>\r\n                </div>\r\n            </div>\r\n            <div ng-messages=\"editPersonForm.input_role.$error\" class=\"text-danger\" ng-show=\"editPersonForm.input_role.$touched||editPersonForm.$submitted\">\r\n                <div ng-message=\"required\">\r\n                    <span data-viewname=\"MyHousehold\" data-i18n=\"Validation_RequiredField\"></span>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <tooltip class=\"input-group-addon no-horizontal-padding\" data-i18n-attr=\"Tooltip_Role|content\" placement=\"top\"></tooltip>\r\n    </div>\r\n");
$templateCache.put("/App/myPayments/myPayments.html","<div data-viewname=\"MyPayments\" ng-cloak>\r\n    <div class=\"panel-group\" role=\"tablist\" aria-multiselectable=\"false\">\r\n\r\n        <div class=\"panel transparent\" ng-show=\"$ctrl.hasBailiffFile === true\" data-i18n=\"Message_BailiffFile\">\r\n        </div>\r\n\r\n        <div class=\"panel transparent\" ng-show=\"$ctrl.hasBailiffFile === false\" data-viewname=\"MyPayments_OpenBalance\">\r\n            <div collapsible-panel id=\"invoices_id\" class=\"panel-default\"\r\n                 expanded=\"true\"\r\n                 data-i18n-attr=\"Panel_Title_Open|heading|&euro;{{$ctrl.outstandingBalance.Amount | number : 2}}\">\r\n                <p data-i18n=\"HelpText_OpenBalance\"></p>\r\n                <table class=\"table table-condensed table-responsive\">\r\n                    <thead>\r\n                        <tr>\r\n                            <th data-i18n=\"Column_Regarding\"></th>\r\n                            <th data-i18n=\"Column_Amount\"></th>\r\n                            <th data-i18n=\"Column_Due\"></th>\r\n                            <th><span class=\"hidden-xs\" data-i18n=\"Column_Underway\"></span></th>\r\n                        </tr>\r\n                    </thead>\r\n                    <tbody>\r\n                        <tr data-toggle=\"collapse\" data-target=\"#invoice_details_{{$index}}\" class=\"accordion-toggle collapsed\" ng-repeat-start=\"invoice in $ctrl.outstandingBalance.Invoices | filter:{ Open: true} | orderBy: [\'DueDate\', $ctrl.getDescriptionSortValue] \">\r\n                            <td>{{$ctrl.regardingColumnValues[invoice.EntryNo]}}</td>\r\n                            <td class=\"currency\">{{invoice.OutstandingAmount | number : 2}}</td>\r\n                            <td>\r\n                                <span due-date ng-disabled=\"item.disabled\" value=\"invoice.DueDate\"></span>\r\n                            </td>\r\n                            <td><span class=\"hidden-xs currency\">{{invoice.PaymentUnderwayAmount | number : 2}}</span></td>\r\n                        </tr>\r\n                        <tr ng-repeat-end>\r\n                            <td colspan=\"4\" class=\"table-hidden-row\">\r\n                                <div class=\"collapse\" id=\"invoice_details_{{$index}}\">\r\n                                    <div class=\"accordion-body\" key-values=\"$ctrl.extendedInfoItems[invoice.EntryNo]\" />\r\n                                </div>\r\n                            </td>\r\n                        </tr>\r\n                    </tbody>\r\n                </table>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"panel transparent\" ng-show=\"$ctrl.hasBailiffFile === false\" portal-module=\"OnlinePayments\" data-viewname=\"MyPayments_OnlinePayment\">\r\n            <div collapsible-panel id=\"onlinePayment\" class=\"panel-default\"\r\n                 data-i18n-attr=\"Panel_Title_Online_Payment|heading\"\r\n                 expanded=\"true\">\r\n                <p data-i18n=\"HelpText_OnlinePayments\"></p>\r\n                <table class=\"table table-condensed table-responsive checkable\">\r\n                    <thead>\r\n                        <tr>\r\n                            <th data-i18n=\"Column_Pay\"></th>\r\n                            <th data-i18n=\"Column_Amount\"></th>\r\n                            <th data-i18n=\"Column_Due\"></th>\r\n                        </tr>\r\n                    </thead>\r\n                    <tbody>\r\n                        <tr ng-repeat-start=\"item in $ctrl.payments.Invoices | filter: {CanPayOnline: true}\"\r\n                            data-toggle=\"collapse\" aria-expanded=\"false\"\r\n                            data-target=\"#onlinePayment_details_{{$index}}\"\r\n                            class=\"accordion-toggle collapsed\">\r\n                            <td class=\"text-center\">\r\n                                <input type=\"checkbox\" class=\"checkbox\" ng-disabled=\"item.disabled\"\r\n                                       ng-model=\"item.selected\"\r\n                                       ng-change=\"$ctrl.onCheckChange(item)\" stop-propagation />\r\n                            </td>\r\n                            <td class=\"currency currency-wide\">\r\n                                <span amount-display ng-disabled=\"item.disabled\" amount=\"item.AmountToBePaid\" total=\"item.OnlinePaymentMaximumAmount\"></span>\r\n                            </td>\r\n                            <td>\r\n                                <span due-date ng-disabled=\"item.disabled\" value=\"item.DueDate\"></span>\r\n                            </td>\r\n                        </tr>\r\n                        <tr ng-repeat-end>\r\n                            <td colspan=\"4\" class=\"table-hidden-row\">\r\n                                <div class=\"collapse\" id=\"onlinePayment_details_{{$index}}\">\r\n                                    <div class=\"accordion-body\" key-values=\"$ctrl.extendedInfoItems[item.EntryNo]\" />\r\n                                </div>\r\n                            </td>\r\n                        </tr>\r\n                    </tbody>\r\n                </table>\r\n\r\n                <br />\r\n                <div class=\"clearfix\">\r\n                    <label style=\"margin: 0; margin-right: 15px; line-height: 44px;\" class=\"pull-left\" data-i18n=\"Label_IPay\"></label>\r\n                    <form novalidate name=\"paymentForm\">\r\n                        <div class=\"input-group input-group-unstyled no-label col-sm-4 col-xs-9 pull-left\">\r\n                            <div class=\"form-group has-feedback\">\r\n                                <div class=\"left-inner-addon\">\r\n                                    <span class=\"currency-symbol\">&euro;</span>\r\n\r\n                                    <input name=\"amount\" type=\"text\"\r\n                                           numeric min=\"0\" decimals=\"2\"\r\n                                           max-amount max-value=\"$ctrl.totalAmount\"\r\n                                           required\r\n                                           class=\"form-control\" ng-disabled=\"!$ctrl.isAnyInvoiceSelected()\"\r\n                                           ng-model=\"$ctrl.amountToBePaid\"\r\n                                           ng-change=\"$ctrl.onAmountChanged()\" />\r\n\r\n                                    <span class=\"icon_ form-control-feedback\"></span>\r\n\r\n                                    <div class=\"text-danger field-validation-error\" ng-messages=\"paymentForm.$error\">\r\n                                        <span ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></span>\r\n                                        <span ng-message=\"maxAmount\"><span data-i18n=\"ValidationMessage_AmountIsTooLarge\"></span></span>\r\n                                    </div>\r\n\r\n                                </div>\r\n                            </div>\r\n                            <tooltip class=\"input-group-addon\" placement=\"top\" data-i18n-attr=\"Tooltip_AmountField|content\" />\r\n                        </div>\r\n                        <button id=\"btnPay\" name=\"buttonPay\" class=\"btn btn-primary\" ng-disabled=\"$ctrl.amountToBePaid == 0 || paymentForm.$invalid || $ctrl.processing\"\r\n                                ng-click=\"$ctrl.pay()\">\r\n                            <span data-i18n=\"Button_Pay\"></span>\r\n                            <span class=\"glyphicon glyphicon-menu-right\"></span>\r\n                        </button>\r\n                    </form>\r\n                </div>\r\n\r\n                <br />\r\n                <div>\r\n                    <span data-i18n=\"Problems_Text\"></span><br />\r\n                    <a ui-sref=\"paymentArrangementStart\" class=\"underlined\" data-i18n=\"Problems_Link\" ng-click=\"$ctrl.goToAgreement();\"></a>\r\n                </div>\r\n                <br />\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"panel transparent\" ng-show=\"$ctrl.hasBailiffFile === false\" data-viewname=\"MyPayments_ClosedInvoices\">\r\n            <div collapsible-panel id=\"paid_invoices_id\" class=\"panel-default\" expanded=\"true\" data-i18n-attr=\"Panel_Title_Closed|heading\">\r\n                <p ng-hide=\"($ctrl.outstandingBalance.Invoices | filter:{ Open: false}).length > 0\" data-i18n=\"Label_No_Closed_Invoices\"></p>\r\n\r\n                <div ng-show=\"($ctrl.outstandingBalance.Invoices | filter:{ Open: false}).length > 0\">\r\n                    <p data-i18n=\"HelpText_ClosedInvoices\"></p>\r\n                    <table class=\"table table-condensed table-responsive\">\r\n                        <thead>\r\n                            <tr>\r\n                                <th data-i18n=\"Column_Regarding\"></th>\r\n                                <th data-i18n=\"Column_Amount\"></th>\r\n                                <th data-i18n=\"Column_Due_Date\"></th>\r\n                            </tr>\r\n                        </thead>\r\n                        <tbody>\r\n                            <tr data-toggle=\"collapse\" data-target=\"#paid_invoice_details_{{$index}}\" class=\"accordion-toggle collapsed\" ng-repeat-start=\"invoice in $ctrl.outstandingBalance.Invoices | filter:{ Open: false} | limitTo: $ctrl.numberOfInvoicesShown\">\r\n                                <td>{{$ctrl.regardingColumnValues[invoice.EntryNo]}}</td>\r\n                                <td class=\"currency\">{{invoice.Amount | number : 2}}</td>\r\n                                <td class=\"date\">{{invoice.Date | date: \'dd-MM-yyyy\'}}</td>\r\n                            </tr>\r\n                            <tr ng-repeat-end data-viewname=\"MyPayments_InvoicePanel\">\r\n                                <td colspan=\"3\" class=\"table-hidden-row\">\r\n                                    <div class=\"collapse\" id=\"paid_invoice_details_{{$index}}\">\r\n                                        <p ng-hide=\"invoice.AppliedEntries.length > 0\" data-i18n=\"Label_No_Applied_Entries\"></p>\r\n                                        <table class=\"table table-condensed table-responsive last-col-indented-sm\" ng-show=\"invoice.AppliedEntries.length > 0\">\r\n                                            <thead>\r\n                                                <tr>\r\n                                                    <th data-i18n=\"Column_SettledWith\"></th>\r\n                                                    <th data-i18n=\"Column_OnDate\"></th>\r\n                                                    <th data-i18n=\"Column_AppliedAmount\"></th>\r\n                                                </tr>\r\n                                            </thead>\r\n                                            <tbody>\r\n                                                <tr ng-repeat=\"appliedEntry in invoice.AppliedEntries | orderBy: \'PostingDate\'\">\r\n                                                    <td >{{$ctrl.getDocumentTypeLabel(appliedEntry.DocumentType.Code)}}</td>\r\n                                                    <td >{{appliedEntry.PostingDate | date : \'dd-MM-yyyy\'}}</td>\r\n                                                    <td class=\"currency currency-wide\">{{appliedEntry.AppliedAmount | number : 2}}</td>\r\n                                                </tr>\r\n                                            </tbody>\r\n                                        </table>\r\n                                    </div>\r\n                                </td>\r\n                            </tr>\r\n                        </tbody>\r\n                    </table>\r\n                </div>\r\n                <div>\r\n                    <a class=\"pull-right\" href=\"#\" data-i18n=\"Link_ShowMore\" ng-click=\"$ctrl.showMore();\" ng-show=\"$ctrl.canShowMore();\"></a>\r\n                    <a class=\"pull-right\" href=\"#\" data-i18n=\"Link_ShowLess\" ng-click=\"$ctrl.showLess();\" ng-show=\"$ctrl.canShowLess();\"></a>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"panel transparent\" ng-show=\"$ctrl.hasBailiffFile === false\" data-viewname=\"MyPayments_Payments\" portal-module=\"Payments\">\r\n            <div collapsible-panel id=\"payments_id\" class=\"panel-default\" expanded=\"false\" data-i18n-attr=\"Panel_Title_Payments|heading\">\r\n                <p ng-hide=\"($ctrl.outstandingBalance.Payments).length > 0\" data-i18n=\"Label_No_Payments\"></p>\r\n\r\n                <div ng-show=\"($ctrl.outstandingBalance.Payments).length > 0\">\r\n                    <p data-i18n=\"HelpText_Payments\"></p>\r\n                    <table class=\"table table-condensed table-responsive\">\r\n                        <thead>\r\n                            <tr>\r\n                                <th data-i18n=\"Column_Paid_On\"></th>\r\n                                <th data-i18n=\"Column_Amount\"></th>\r\n                                <th data-i18n=\"Column_Status\"></th>\r\n                            </tr>\r\n                        </thead>\r\n                        <tbody>\r\n                            <tr data-toggle=\"collapse\" data-target=\"#payments_details_{{$index}}\" class=\"accordion-toggle collapsed\" ng-repeat-start=\"payment in $ctrl.outstandingBalance.Payments | limitTo: $ctrl.numberOfPaymentsShown\">\r\n                                <td>{{payment.DueDate | date: \'dd-MM-yyyy\'}}</td>\r\n                                <td class=\"currency\">{{payment.Amount | number : 2}}</td>\r\n                                <td>\r\n                                    <span ng-show=\"payment.Open\" data-i18n=\"Label_Open\"></span>\r\n                                    <span ng-hide=\"payment.Open\" data-i18n=\"Label_Applied\"></span>\r\n                                </td>\r\n                            </tr>\r\n                            <tr ng-repeat-end>\r\n                                <td colspan=\"3\" class=\"table-hidden-row\">\r\n                                    <div class=\"collapse\" id=\"payments_details_{{$index}}\">\r\n                                        <p ng-hide=\"payment.AppliedEntries.length > 0\" data-i18n=\"Label_No_Applied_Invoices\"></p>\r\n                                        <table class=\"table table-condensed table-responsive last-col-indented-sm\" ng-show=\"payment.AppliedEntries.length > 0\">\r\n                                            <thead>\r\n                                                <tr>\r\n                                                    <th data-i18n=\"Column_Paid\"></th>\r\n                                                    <th data-i18n=\"Column_SettledWith\"></th>\r\n                                                </tr>\r\n                                            </thead>\r\n                                            <tbody>\r\n                                                <tr data-toggle=\"collapse\" data-target=\"#payments_{{payment.EntryNo}}_applied_invoice_details_{{$index}}\" class=\"accordion-toggle collapsed\" ng-repeat-start=\"invoice in payment.AppliedEntries\">\r\n                                                    <td class=\"currency\">{{invoice.AppliedAmount | number : 2}}</td>\r\n                                                    <td>{{$ctrl.regardingColumnValues[invoice.CustomerLedgerEntryNo]}}</td>\r\n                                                </tr>\r\n                                                <tr ng-repeat-end>\r\n                                                    <td colspan=\"2\" class=\"table-hidden-row\">\r\n                                                        <div class=\"collapse\" id=\"payments_{{payment.EntryNo}}_applied_invoice_details_{{$index}}\">\r\n                                                            <div class=\"accordion-body\" key-values=\"$ctrl.extendedInfoItems[invoice.CustomerLedgerEntryNo]\" />\r\n                                                        </div>\r\n                                                    </td>\r\n                                                </tr>\r\n                                            </tbody>\r\n                                        </table>\r\n                                    </div>\r\n                                </td>\r\n                            </tr>\r\n                        </tbody>\r\n                    </table>\r\n                    <div>\r\n                        <a class=\"pull-right\" href=\"#\" data-i18n=\"Link_ShowMore\" ng-click=\"$ctrl.showMorePayments();\" ng-show=\"$ctrl.canShowMorePayments();\"></a>\r\n                        <a class=\"pull-right\" href=\"#\" data-i18n=\"Link_ShowLess\" ng-click=\"$ctrl.showLessPayments();\" ng-show=\"$ctrl.canShowLessPayments();\"></a>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"panel transparent\" data-viewname=\"MyPayments_Agreement\" ng-show=\"$ctrl.hasBailiffFile === false\" portal-module=\"PaymentSchemes\">\r\n            <div collapsible-panel id=\"agreement_id\" title=\"\" expanded=\"false\" data-i18n-attr=\"Panel_Title|heading\">\r\n                <div ng-show=\"$ctrl.paymentArrangements != null && $ctrl.paymentArrangements.length != 0\">\r\n                    <div data-i18n=\"Text_PanelDescription\"></div>\r\n                    <table class=\"table table-condensed table-responsive\">\r\n                        <thead>\r\n                            <tr>\r\n                                <th data-i18n=\"Column_Reference\" class=\"hidden-xs\"></th>\r\n                                <th data-i18n=\"Column_StartDate\"></th>\r\n                                <th data-i18n=\"Column_TotalAmount\"></th>\r\n                                <th data-i18n=\"Column_Status\"></th>\r\n                            </tr>\r\n                        </thead>\r\n                        <tbody>\r\n                            <tr ng-repeat-start=\"paymentArrangement in $ctrl.paymentArrangements\"\r\n                                aria-expanded=\"false\"\r\n                                class=\"collapsed accordion-toggle arrow-visible-xs\" data-toggle=\"collapse\" , data-target=\"#payment_arrangement_details_{{$index}}\">\r\n                                <td class=\"hidden-xs\">\r\n                                    {{paymentArrangement.Code}}\r\n                                </td>\r\n                                <td>\r\n                                    {{paymentArrangement.StartDate | date : \'dd-MM-yyyy\'}}\r\n                                </td>\r\n                                <td class=\"currency\">\r\n                                    <span amount-display amount=\"paymentArrangement.Amount\" total=\"paymentArrangement.Amount\"></span>\r\n                                </td>\r\n                                <td data-i18n=\"Text_PaymentArrangement_Status_{{paymentArrangement.Status}}\"></td>\r\n                            </tr>\r\n\r\n                            <tr ng-repeat-end>\r\n                                <td colspan=\"4\" class=\"table-hidden-row\">\r\n                                    <div class=\"collapse\" id=\"payment_arrangement_details_{{$index}}\">\r\n                                        <div class=\"accordion-body visible-xs\">\r\n                                            <span><span data-i18n=\"Column_Reference\"></span>: {{paymentArrangement.Code}}</span>\r\n\r\n                                            <!--TODO: Uncomment this code in order to display the installments\r\n                                                <table class=\"table-condensed-horizontally\">\r\n                                                        <tr ng-repeat=\"installment in paymentArrangement.installments\">\r\n                                                            <td>\r\n                                                                Termijn {{installment.number}}\r\n                                                            </td>\r\n                                                            <td>\r\n                                                                {{installment.startDate}}\r\n                                                            </td>\r\n                                                            <td class=\"currency\">\r\n                                                                <span amount-display amount=\"installment.amount\" total=\"installment.amount\"></span>\r\n                                                            </td>\r\n                                                            <td>\r\n                                                                {{installment.status}}\r\n                                                            </td>\r\n                                                        </tr>\r\n                                                </table>\r\n                                            -->\r\n                                        </div>\r\n                                    </div>\r\n                                </td>\r\n                            </tr>\r\n                        </tbody>\r\n                    </table>\r\n                </div>\r\n\r\n                <div data-i18n=\"Text_NoPaymentArrangement\" ng-show=\"$ctrl.paymentArrangements != null && $ctrl.paymentArrangements.length == 0\"></div>\r\n\r\n                <button id=\"btnNewPaymentArrangement\" name=\"buttonNewPaymentArrangement\" class=\"btn btn-primary\"\r\n                        ng-click=\"$ctrl.newPaymentArrangement()\">\r\n                    <span data-i18n=\"Button_NewPaymentArrangement\"></span>\r\n                    <span class=\"glyphicon glyphicon-menu-right\"></span>\r\n                </button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("/App/myRepairments/cancelRepairment.html","<form name=\"cancelRepairmentForm\" novalidate>\r\n    <div data-viewname=\"CancelRepairment\" ng-cloak>\r\n        <div class=\"panel-group\" role=\"tablist\" aria-multiselectable=\"false\">\r\n            <div collapsible-panel expanded=\"true\" Id=\"RepairRequestInfo\" data-i18n-attr=\"Title_RepairRequestInfo|heading\">\r\n                <div panel>\r\n                    <div key-values=\"$ctrl.repairRequestDescription\"></div>\r\n                </div>\r\n            </div>\r\n\r\n            <div collapsible-panel expanded=\"true\" Id=\"CancellationReason\" data-i18n-attr=\"Title_CancelationReason|heading\">\r\n                <div class=\"input-group input-group-unstyled\">\r\n                    <div class=\"form-group has-feedback\">\r\n                        <label class=\"control-label\" data-i18n=\"Label_TerminationReason\"></label>\r\n                        <div class=\"select-container\">\r\n                            <select name=\"terminationReason\" ng-options=\"option.Code as option.Description for option in $ctrl.requestCancelReasons\" ng-model=\"$ctrl.selectedReason.Code\" ng-required=\"true\" class=\"form-control\"></select>\r\n                            <span class=\"icon_ form-control-feedback\"></span>\r\n                            <span class=\"glyphicon glyphicon-chevron-down dropdown_icon\"></span>\r\n                            <div class=\"text-danger\" ng-messages=\"cancelRepairmentForm.terminationReason.$error\" ng-show=\"cancelRepairmentForm.terminationReason.$touched||cancelRepairmentForm.$submitted\">\r\n                                <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></div>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    <tooltip class=\"input-group-addon\" data-i18n-attr=\"Tooltip_RequestTerminationReason|content\" placement=\"bottom\" />\r\n                </div>\r\n           \r\n\r\n                <div class=\"input-group input-group-unstyled\">\r\n                    <div class=\"form-group has-feedback\">\r\n                        <label class=\"control-label\" data-i18n=\"Input_Label_Comments\"></label>\r\n                        <textarea rows=\"4\" class=\"form-control\" name=\"userComment\" ng-model=\"$ctrl.selectedReason.Description\" maxlength=\"250\"></textarea>\r\n                        <span class=\"icon_ form-control-feedback\"></span>\r\n                    </div>\r\n\r\n                    <tooltip class=\"input-group-addon\" data-i18n-attr=\"Tooltip_Comments|content\" placement=\"bottom\" />\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div data-viewname=\"Generic\">\r\n            <button class=\"btn btn-primary\" ng-click=\"$ctrl.cancelRequest(cancelRepairmentForm)\">\r\n                <span data-i18n=\"Button_Save\"></span>\r\n                <span class=\"glyphicon glyphicon-menu-right\"></span>\r\n            </button>\r\n\r\n            <button class=\"btn btn-cancel pull-right\" ng-click=\"$ctrl.cancel()\">\r\n                <span data-i18n=\"Button_Cancel\"></span>\r\n            </button>\r\n        </div>\r\n    </div>\r\n</form>\r\n");
$templateCache.put("/App/myRepairments/editRepairment.html","<form name=\"editRepairmentForm\" novalidate>\r\n    <div data-viewname=\"EditRepairment\" ng-cloak>\r\n        <div class=\"panel-group\" role=\"tablist\" id=\"editRepairmentPanel\" aria-multiselectable=\"false\">\r\n            <div class=\"panel transparent\">\r\n                <div panel Id=\"EditPhotosAndDefectDescription\" data-i18n-attr=\"Title_Edit_Photos_And_DefectDescription|heading\">\r\n                    <repairment-photos-and-defect-description images=\"$ctrl.requestData.images\" defect-description=\"$ctrl.requestData.defectDescription.DescriptionBigText\"\r\n                                                              description-required=\"$ctrl.requestData.defectRequired\"\r\n                                                              readonly=\"!$ctrl.repairment.CanChangeDescriptionOrPhoto\"></repairment-photos-and-defect-description>\r\n                </div>\r\n\r\n                <div panel id=\"appointmentPanel\" data-i18n-attr=\"Panel_Appointment_Planner|heading\">\r\n                    <div ng-if=\"$ctrl.repairment.CanBeChangedOrWithdrawn && $ctrl.planningData && $ctrl.planningData.AppointmentNecessary\">\r\n                        <span ng-show=\"$ctrl.planningData.Periods.length > 0\" data-i18n=\"Label_SpecifyPreference\"></span>\r\n                        <span ng-show=\"$ctrl.planningData.ConnectItProposals.length > 0\" data-i18n=\"Label_PlanAppointment\"></span>\r\n                        <span ng-show=\"$ctrl.planningData.InspectionAppointments.length > 0\" data-i18n=\"Label_PlanInspection\"></span>\r\n\r\n                        <div time-slot-controller min-date=\"$ctrl.minimumDate\" expand-to-plan=\"true\">\r\n                            <div time-slot-planner time-slot-required\r\n                                 name=\"planningTimeSlot\"\r\n                                 initialize=\"$ctrl.minimumDate != null\"\r\n                                 ng-model=\"$ctrl.formContainer.selectedTimeSlot\"\r\n                                 time-slots=\"$ctrl.formContainer.TimeSlots\"\r\n                                 time-slot-loader=\"$ctrl.loadTimeSlots\"></div>\r\n                        </div>\r\n                        <div class=\"text-danger\" ng-messages=\"editRepairmentForm.planningTimeSlot.$error\" ng-show=\"editRepairmentForm.planningTimeSlot.$touched||editRepairmentForm.$submitted\">\r\n                            <div ng-message=\"required\"><span data-i18n=\"Validation_NoTimeslotSelected\"></span></div>\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div ng-if=\"$ctrl.repairment.CanBeChangedOrWithdrawn && $ctrl.planningData && !$ctrl.planningData.AppointmentNecessary\">\r\n                        <span data-i18n=\"Message_AppointmentNotNecessary\"></span>\r\n                    </div>\r\n\r\n                    <div ng-if=\"!$ctrl.repairment.CanBeChangedOrWithdrawn\">\r\n                        <span data-i18n=\"Message_PlanningCannotBeChanged\"></span>\r\n                    </div>\r\n                </div>\r\n\r\n                <div panel id=\"EditContactInformation\" data-i18n-attr=\"Title_ChangeContactInformation|heading\">\r\n                    <div data-viewname=\"NewRepairments\">\r\n                        <label data-i18n=\"Label_Contact\"></label>\r\n\r\n                        <div class=\"input-group input-group-unstyled\">\r\n                            <div class=\"form-group has-feedback\">\r\n                                <label for=\"inputPhone\" data-i18n=\"Input_Label_Phone\"></label>\r\n                                <input type=\"tel\" phonenumber ng-required=\"true\" ng-model=\"$ctrl.repairment.CallerDaytimePhoneNo\" class=\"form-control\" name=\"inputPhone\" data-i18n-attr=\"Input_Placeholder_Phone|placeholder\" ng-readonly=\"!$ctrl.repairment.CanChangeDescriptionOrPhoto\">\r\n                                <span class=\"icon_ form-control-feedback\"></span>\r\n\r\n                                <div ng-messages=\"editRepairmentForm.inputPhone.$error\" class=\"text-danger\" ng-show=\"editRepairmentForm.inputPhone.$dirty || editRepairmentForm.$submitted\">\r\n                                    <div ng-message=\"maxlength\"><span data-i18n=\"Message_MaxLength\" /></div>\r\n                                    <div ng-message=\"$ctrl.repairment.CallerDaytimePhoneNo\"><span data-i18n=\"Message_InvalidPhoneNumber\" /></div>\r\n                                    <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></div>\r\n                                </div>\r\n                            </div>\r\n\r\n                            <tooltip class=\"input-group-addon no-horizontal-padding\" placement=\"bottom\" data-i18n-attr=\"Tooltip_PhoneNumber|content\" />\r\n                        </div>\r\n\r\n                        <div class=\"input-group input-group-unstyled\">\r\n                            <div class=\"form-group has-feedback\">\r\n                                <label for=\"inputMail\" data-i18n=\"Input_Label_Email\"></label>\r\n                                <input type=\"email\" email ng-required=\"true\" ng-model=\"$ctrl.repairment.CallerEmail\" class=\"form-control\" name=\"inputMail\" data-i18n-attr=\"Input_Placeholder_Email|placeholder\" ng-readonly=\"!$ctrl.repairment.CanChangeDescriptionOrPhoto\">\r\n                                <span class=\"icon_ form-control-feedback\"></span>\r\n\r\n                                <div ng-messages=\"editRepairmentForm.inputMail.$error\" class=\"text-danger\" ng-show=\"editRepairmentForm.inputMail.$dirty||editRepairmentForm.$submitted\">\r\n                                    <div ng-message=\"maxlength\"><span data-i18n=\"Message_MaxLength\" /></div>\r\n                                    <div ng-message=\"email\"><span data-i18n=\"Message_InvalidEmail\" /></div>\r\n                                    <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></div>\r\n                                </div>\r\n                            </div>\r\n\r\n                            <tooltip class=\"input-group-addon no-horizontal-padding\" placement=\"bottom\" data-i18n-attr=\"Tooltip_EmailAddress|content\" />\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n\r\n            </div>\r\n        </div>\r\n        <div data-viewname=\"Generic\">\r\n            <button class=\"btn btn-primary\" ng-click=\"$ctrl.saveRepairmentChanges(editRepairmentForm)\">\r\n                <span data-i18n=\"Button_Save\"></span>\r\n                <span class=\"glyphicon glyphicon-menu-right\"></span>\r\n            </button>\r\n\r\n            <button class=\"btn btn-cancel pull-right\" ng-click=\"$ctrl.cancelEdit()\">\r\n                <span data-i18n=\"Button_Cancel\"></span>\r\n            </button>\r\n        </div>\r\n    </div>\r\n</form>");
$templateCache.put("/App/myRepairments/myRepairments.html","<div data-viewname=\"MyRepairments\">\r\n  <div class=\"panel-group\" role=\"tablist\" id=\"repairmentHistoryPanels\" aria-multiselectable=\"false\">\r\n    <div collapsible-panel class=\"panel-default\" id=\"openRepairments\" data-i18n-attr=\"Title_Repairments|heading\" expanded=\"true\">\r\n      <table class=\"table table-fixed table-condensed table-responsive\">\r\n        <thead>\r\n          <tr>\r\n            <th class=\"col-xs-3\" data-i18n=\"Column_Contract\"></th>\r\n            <th class=\"col-xs-3\" data-i18n=\"Column_Object\"></th>\r\n            <th data-i18n=\"Column_Defect\"></th>\r\n            <th data-i18n=\"Column_Status\"></th>\r\n          </tr>\r\n        </thead>\r\n\r\n        <tr data-toggle=\"collapse\" data-target=\"#repairment_{{$index}}\" aria-expanded=\"false\" class=\"accordion-toggle collapsed\"\r\n            ng-repeat-start=\"item in $ctrl.repairments | filter: $ctrl.isHandledRepairRequest | orderBy: [$ctrl.getContractSortValue, -item.Date]\"\r\n            ng-click=\"$ctrl.downloadAttachments(item)\">\r\n          <td colspan=\"1\">\r\n            <span ng-show=\"item.Address\">{{item.Address}}</span>\r\n            <span ng-show=\"item.ClusterName\">{{item.ClusterName}}</span>\r\n          </td>\r\n          <td colspan=\"1\">\r\n            <span ng-show=\"item.ClusterName\" data-i18n=\"Label_CommonArea\"></span>\r\n            <span ng-show=\"item.CommonArea\">{{item.CommonAreaDescription}}</span>\r\n            <span ng-show=\"!item.CommonArea && !item.ClusterName\" data-i18n=\"Label_RentedProperty\"></span>\r\n          </td>\r\n          <td colspan=\"1\">{{item.Description}}</td>\r\n          <td colspan=\"1\">{{item.StatusDescription}}</td>\r\n        </tr>\r\n        <tr ng-repeat-end>\r\n          <td colspan=\"4\" class=\"table-hidden-row\">\r\n            <div class=\"collapse\" id=\"repairment_{{$index}}\">\r\n              <div class=\"accordion-body\">\r\n                <div panel>\r\n                  <div key-values=\"$ctrl.firstExtendedInfoItems[item.No]\"></div>\r\n                </div>\r\n                <div panel>\r\n                  <div key-values=\"$ctrl.secondExtendedInfoItems[item.No]\"></div>\r\n                  <br />\r\n                  <div ng-if=\"!item.CanBeChangedOrWithdrawn\" data-i18n=\"Label_CantBeChangedOrWithdrawn\" portal-module=\"MaintenanceOrders\"></div>\r\n                  <div data-viewname=\"Generic\">\r\n                    <button id=\"Edit_Repairment\" data-i18n=\"Button_Edit\" class=\"btn btn-primary col-sm-5\" ng-disabled=\"!item.CanBeChangedOrWithdrawn && !item.CanChangeDescriptionOrPhoto\" ng-click=\"$ctrl.editRepairment(item)\" portal-module=\"MaintenanceOrders\"></button>\r\n                  </div>\r\n                  <div style=\"width: 10%\"></div>\r\n                  <div>\r\n                    <button data-i18n=\"Cancel_Order\" class=\"btn btn-danger col-sm-5 pull-right\" ng-click=\"$ctrl.cancelRepairment(item)\" ng-disabled=\"!item.CanBeChangedOrWithdrawn\" portal-module=\"MaintenanceOrders\"></button>\r\n                  </div>\r\n                </div>\r\n\r\n                <div panel ng-show=\"item.MaintenanceOrders && item.MaintenanceOrders.length > 0\" data-i18n-attr=\"Title_Orders|heading\">\r\n                  <table class=\"table table-condensed\">\r\n                    <thead>\r\n                      <tr>\r\n                        <th data-i18n=\"Column_Vendor\"></th>\r\n                        <th data-i18n=\"Column_Status\"></th>\r\n                        <th data-i18n=\"Column_Appointment\"></th>\r\n                      </tr>\r\n                    </thead>\r\n\r\n                    <tr ng-repeat=\"order in item.MaintenanceOrders\">\r\n                      <td>{{order.VendorName}}</td>\r\n                      <td>{{order.Status}}</td>\r\n                      <td>\r\n                        <span class=\"date\" ng-show=\"order.AppointmentDate\">\r\n                          {{order.AppointmentDate + \'T\' + order.TimeFrom | date: \'EEEE dd-MM-yyyy HH:mm\'}} -\r\n                          {{order.AppointmentDate + \'T\' + order.TimeTo | date: \'HH:mm\'}}\r\n                        </span>\r\n                      </td>\r\n                    </tr>\r\n                  </table>\r\n                </div>\r\n\r\n                <div panel ng-show=\"item.Inspections && item.Inspections.length > 0\" data-i18n-attr=\"Title_Inspections|heading\">\r\n                  <table class=\"table table-condensed\">\r\n                    <thead>\r\n                      <tr>\r\n                        <th data-i18n=\"Column_InspectionDayAndTime\"></th>\r\n                        <th data-i18n=\"Column_Status\"></th>\r\n                      </tr>\r\n                    </thead>\r\n\r\n                    <tr ng-repeat=\"inspection in item.Inspections\">\r\n                      <td ng-show=\"inspection.EndTime == null\">{{inspection.Date + \'T\' + inspection.StartTime | date: \'EEEE dd-MM-yyyy HH:mm\'}}</td>\r\n                      <td ng-show=\"inspection.EndTime != null\">{{inspection.Date + \'T\' + inspection.StartTime | date: \'EEEE dd-MM-yyyy HH:mm\'}} - {{inspection.Date + \'T\' + inspection.EndTime | date: \'HH:mm\'}}</td>\r\n                      <td>{{inspection.Status}}</td>\r\n                    </tr>\r\n                  </table>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </td>\r\n        </tr>\r\n      </table>\r\n      <button type=\"button\" class=\"btn btn-primary col-sm-5\" ui-sref=\"newRepairment.objectSelection\" portal-module=\"MaintenanceOrders\">\r\n        <span data-i18n=\"Button_New\"></span> <span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span>\r\n      </button>\r\n    </div>\r\n\r\n    <div collapsible-panel id=\"repairmentHistoryPanel\" data-i18n-attr=\"Title_Repairments_History|heading\" expanded=\"false\">\r\n      <table class=\"table table-fixed table-condensed table-responsive\">\r\n        <thead>\r\n          <tr>\r\n            <th class=\"col-xs-3\" data-i18n=\"Column_Contract\"></th>\r\n            <th class=\"col-xs-3\" data-i18n=\"Column_Object\"></th>\r\n            <th data-i18n=\"Column_Defect\"></th>\r\n            <th data-i18n=\"Column_Status\"></th>\r\n          </tr>\r\n        </thead>\r\n\r\n        <tr data-toggle=\"collapse\" data-target=\"#repairmentOld_{{$index}}\" aria-expanded=\"false\" class=\"accordion-toggle collapsed\"\r\n            ng-repeat-start=\"item in $ctrl.repairments | filter: $ctrl.isUnhandledRepairRequest | orderBy: [$ctrl.getContractSortValue, -item.Date]\"\r\n            ng-click=\"$ctrl.downloadAttachments(item)\">\r\n          <td colspan=\"1\">\r\n            <span ng-show=\"item.Address\">{{item.Address}}</span>\r\n            <span ng-show=\"item.ClusterName\">{{item.ClusterName}}</span>\r\n          </td>\r\n          <td colspan=\"1\">\r\n            <span ng-show=\"item.ClusterName\" data-i18n=\"Label_CommonArea\"></span>\r\n            <span ng-show=\"item.CommonArea\">{{item.CommonAreaDescription}}</span>\r\n            <span ng-show=\"!item.CommonArea && !item.ClusterName\" data-i18n=\"Label_RentedProperty\"></span>\r\n          </td>\r\n          <td colspan=\"1\">{{item.Description}}</td>\r\n          <td colspan=\"1\">{{item.StatusDescription}}</td>\r\n        </tr>\r\n        <tr ng-repeat-end>\r\n          <td colspan=\"4\" class=\"table-hidden-row\">\r\n            <div class=\"collapse\" id=\"repairmentOld_{{$index}}\">\r\n              <div panel>\r\n                <div key-values=\"$ctrl.firstExtendedInfoItems[item.No]\"></div>\r\n              </div>\r\n              <div panel>\r\n                <div key-values=\"$ctrl.secondExtendedInfoItems[item.No]\"></div>\r\n              </div>\r\n              <div panel ng-show=\"item.MaintenanceOrders && item.MaintenanceOrders.length > 0\">\r\n                <table class=\"table table-condensed\">\r\n                  <thead>\r\n                    <tr>\r\n                      <th data-i18n=\"Column_Vendor\"></th>\r\n                      <th data-i18n=\"Column_Status\"></th>\r\n                      <th data-i18n=\"Column_Appointment\"></th>\r\n                    </tr>\r\n                  </thead>\r\n\r\n                  <tr ng-repeat=\"order in item.MaintenanceOrders\">\r\n                    <td>{{order.VendorName}}</td>\r\n                    <td>{{order.Status}}</td>\r\n                    <td><span class=\"date\" ng-show=\"order.AppointmentDate\">{{order.AppointmentDate + \'T\' + order.TimeFrom | date: \'EEEE dd-MM-yyyy HH:mm\'}}</span></td>\r\n                  </tr>\r\n                </table>\r\n              </div>\r\n              <div panel ng-show=\"item.Inspections && item.Inspections.length > 0\" data-i18n-attr=\"Title_Inspections|heading\">\r\n                <table class=\"table table-condensed\">\r\n                  <thead>\r\n                    <tr>\r\n                      <th data-i18n=\"Column_InspectionDayAndTime\"></th>\r\n                      <th data-i18n=\"Column_Status\"></th>\r\n                    </tr>\r\n                  </thead>\r\n\r\n                  <tr ng-repeat=\"inspection in item.Inspections\">\r\n                    <td>{{inspection.Date + \'T\' + inspection.StartTime | date: \'EEEE dd-MM-yyyy HH:mm\'}}</td>\r\n                    <td>{{inspection.Status}}</td>\r\n                  </tr>\r\n                </table>\r\n              </div>\r\n            </div>\r\n          </td>\r\n        </tr>\r\n      </table>\r\n    </div>\r\n  </div>\r\n</div>");
$templateCache.put("/App/myTimeline/myTimeline.html","<div data-viewname=\"MyTimeline\">\r\n    <div class=\"panel transparent\" uib-collapse=\"!$ctrl.addNewInteraction\" portal-module=\"OtherActions\">\r\n        <new-timeline-action></new-timeline-action>\r\n    </div>\r\n\r\n    <div class=\"col-xs-12\">\r\n        <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.addNewInteraction = true;\" ng-disabled=\"$ctrl.addNewInteraction\" portal-module=\"OtherActions\">\r\n            <span data-i18n=\"Button_New\"></span><span class=\"glyphicon glyphicon-menu-right\"></span>\r\n        </button>\r\n        <button type=\"submit\" class=\"btn btn-primary pull-right-sm\" ng-click=\"$ctrl.refreshTimeline();\">\r\n            <span data-i18n=\"Button_Refresh\"></span>\r\n        </button>\r\n    </div>\r\n    <div class=\"col-xs-12\">\r\n    <ul class=\"timeline\" infinite-scroll=\"$ctrl.loadMore()\" infinite-scroll-distance=\"3\" ng-show=\"$ctrl.actions.length > 0\">\r\n        <li ng-repeat=\"(key, value) in $ctrl.filteredItems\">\r\n            <div class=\"day\">\r\n                <span>{{key}}</span>\r\n            </div>\r\n            <div class=\"timelineItem\" ng-repeat=\"item in value\" ng-class-odd=\"\'right\'\" ng-class-even=\"\'left\'\" ng-class=\"{\'completed\': item.Status == \'Voltooid\'}\">\r\n                <div class=\"pointer\"></div>\r\n                <div class=\"heading\">\r\n                    <div class=\"icon\">\r\n                        <span ng-class=\"$ctrl.iconForInteraction(item)\"></span>\r\n                    </div>\r\n                    <div class=\"info\">\r\n                        <div class=\"address\">{{item.Address}}</div>\r\n                        <div class=\"time\">{{item.ClientDateTime | date : \'HH:mm\'}} <span class=\"pull-right\">{{item.Status}}</span></div>\r\n                    </div>\r\n                </div>\r\n                <p>{{$ctrl.descriptionForInteraction(item)}}</p>\r\n                <div ng-show=\"item.CustomerRemarks\">\r\n                    <div uib-collapse=\"!$ctrl.showRemarks[item.EntryNo]\">{{item.CustomerRemarks}}</div>\r\n                    <a href=\"#\" ng-click=\"$ctrl.showRemarks[item.EntryNo] = true;\" ng-show=\"!$ctrl.showRemarks[item.EntryNo]\" data-i18n=\"Link_ShowMore\"></a>\r\n                    <a href=\"#\" ng-click=\"$ctrl.showRemarks[item.EntryNo] = false;\" ng-show=\"$ctrl.showRemarks[item.EntryNo]\" data-i18n=\"Link_ShowLess\"></a>\r\n                </div>\r\n            </div>\r\n        </li>\r\n    </ul>\r\n    </div>\r\n    <div class=\"emptyMessage\" data-i18n=\"Message_Empty\" ng-show=\"$ctrl.actions.length == 0 && $ctrl.page == 2\"></div>\r\n</div>");
$templateCache.put("/App/network/editIpRange.html","<div data-viewname=\"Network\">\r\n    <div panel id=\"ipRangeDetails\" class=\"panel-default\" heading=\"{{$ctrl.panelHeading}}\">\r\n        <form name=\"ipRangeDetailsForm\" novalidate ng-submit=\"$ctrl.saveIpRange(ipRangeDetailsForm)\">\r\n            <div class=\"form-group has-feedback\">\r\n                <label for=\"ipRange\" data-i18n=\"Label_IpRange\" />\r\n                <input name=\"ipRange\" type=\"text\" ng-model=\"$ctrl.ipRange.IpRange\" class=\"form-control\" data-i18n-attr=\"Placeholder_IpRange|placeholder\" ng-pattern=\"$ctrl.ipv4v6CIDR\" maxlength=\"100\" required />\r\n                <span class=\"icon_ form-control-feedback\"></span>\r\n\r\n                <div class=\"text-danger field-validation-error\" ng-messages=\"ipRangeDetailsForm.ipRange.$error\">\r\n                    <div ng-if=\"ipRangeDetailsForm.ipRange.$touched||ipRangeDetailsForm.$submitted\" ng-message=\"pattern\"><span data-i18n=\"Message_InvalidIpRange\"></span></div>\r\n                    <span ng-if=\"ipRangeDetailsForm.ipRange.$touched||ipRangeDetailsForm.$submitted\" ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></span>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"input-group input-group-unstyled\">\r\n                <div class=\"form-group-checkbox\">\r\n                    <input type=\"checkbox\" ng-model=\"$ctrl.ipRange.Administrator\" name=\"checkBoxAdministrator\" data-toggle=\"toggle\">\r\n                    <label data-i18n=\"Checkbox_Administrator\"></label>\r\n                </div>\r\n\r\n                <div class=\"form-group-checkbox\">\r\n                    <input type=\"checkbox\" ng-model=\"$ctrl.ipRange.KccEmployee\" name=\"checkBoxKccEmployee\" data-toggle=\"toggle\">\r\n                    <label data-i18n=\"Checkbox_KccEmployee\"></label>\r\n\r\n                    <div ng-show=\"ipRangeDetailsForm.checkBoxAdministrator.$touched || ipRangeDetailsForm.checkBoxKccEmployee.$touched || ipRangeDetailsForm.$submitted\">\r\n                        <span ng-show=\"!$ctrl.ipRange.Administrator && !$ctrl.ipRange.KccEmployee\" class=\"text-danger\" data-i18n=\"Message_RoleSelection\"></span>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\">\r\n                <button type=\"submit\" name=\"save\" class=\"btn btn-primary\">\r\n                    <span data-i18n=\"Button_Save\"></span><span class=\"glyphicon glyphicon-menu-right\"></span>\r\n                </button>\r\n                <button name=\"cancel\" class=\"btn btn-cancel pull-right\" ng-click=\"$ctrl.goBackToIpRanges()\">\r\n                    <span data-i18n=\"Button_Cancel\"></span>\r\n                </button>\r\n            </div>\r\n\r\n        </form>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("/App/network/network.html","<div data-viewname=\"Network\">\r\n    <div panel id=\"networkSecurity\" class=\"panel-default\" data-i18n-attr=\"Panel_NetworkSecurity|heading\">\r\n        <table class=\"table table-condensed table-responsive checkable-small col-xs-12\">\r\n            <thead>\r\n                <tr>\r\n                    <th></th>\r\n                    <th data-i18n=\"Column_IpRange\"></th>\r\n                    <th class=\"text-center\" data-i18n=\"Column_Administrator\"></th>\r\n                    <th class=\"text-center\" data-i18n=\"Column_KCC_Employee\"></th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr ng-show=\"$ctrl.ipRanges.length == 0\">\r\n                    <td colspan=\"4\">\r\n                        <span data-i18n=\"Text_NoIpRanges\"></span>\r\n                    </td>\r\n                </tr>\r\n                <tr ng-repeat=\"range in $ctrl.ipRanges\">\r\n                    <td align=\"center\">\r\n                        <input type=\"checkbox\" class=\"checkbox\"\r\n                               ng-model=\"range.selected\"\r\n                               ng-change=\"$ctrl.onCheckChange(range)\" stop-propagation />\r\n                    </td>\r\n                    <td>\r\n                        {{range.IpRange}}\r\n                    </td>\r\n                    <td class=\"text-center\">\r\n                        <span ng-class=\"{ \'icon_check_dark text-main\': range.Administrator, \'icon_stop_dark text-danger\': !range.Administrator}\"></span>\r\n                    </td>                    \r\n                    <td class=\"text-center\">\r\n                        <span ng-class=\"{ \'icon_check_dark text-main\': range.KccEmployee, \'icon_stop_dark text-danger\': !range.KccEmployee}\"></span>\r\n                    </td>\r\n                </tr>\r\n                <tr>\r\n                    <td colspan=\"4\">\r\n                        <div>\r\n                            <button class=\"btn btn-primary\" ng-click=\"$ctrl.newIpRange()\">\r\n                                <span data-i18n=\"Button_NewIpRange\"></span><span class=\"glyphicon glyphicon-chevron-right\"></span>\r\n                            </button>\r\n                            <button class=\"btn btn-primary\" ng-disabled=\"!$ctrl.gridSelection.selected\" ng-click=\"$ctrl.editIpRange($ctrl.gridSelection)\">\r\n                                <span data-i18n=\"Button_Edit\"></span><span class=\"glyphicon glyphicon-chevron-right\"></span>\r\n                            </button>\r\n                            <button class=\"btn btn-danger\" ng-disabled=\"!$ctrl.gridSelection.selected\" ng-click=\"$ctrl.removeIpRange($ctrl.gridSelection)\">\r\n                                <span data-i18n=\"Button_Delete\"></span>\r\n                            </button>\r\n\r\n                        </div>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n</div>");
$templateCache.put("/App/newRepairment/newRepairmentWizard.html","<div data-viewname=\"NewRepairments\">\r\n    <div panel data-i18n-attr=\"Panel_Repairments|heading\">\r\n\r\n        <div class=\"label-group\" ng-show=\"$ctrl.currentState == \'newRepairment.objectSelection\'\" data-i18n=\"Label_WizardStepsDescription\"></div>\r\n\r\n        <div class=\"label-group\" ng-show=\"$ctrl.currentState == \'newRepairment.objectSelection\'\" data-i18n=\"Label_GeneralInformation\"></div>\r\n\r\n        <div class=\"clearfix\">\r\n            <div class=\"pull-left\">\r\n                <button class=\"btn progress-button\" ui-sref=\"newRepairment.objectSelection\" ng-disabled=\"!$ctrl.states[\'newRepairment.objectSelection\'].isClickable()\" ui-sref-active=\"progress-button-active\">\r\n                    <span>1</span>\r\n                </button>\r\n            </div>\r\n            <div class=\"pull-left\">\r\n                <button class=\"btn progress-button\" ui-sref=\"newRepairment.defectSelection\" ng-disabled=\"!$ctrl.states[\'newRepairment.defectSelection\'].isClickable()\" ui-sref-active=\"progress-button-active\">\r\n                    <span>2</span>\r\n                </button>\r\n            </div>\r\n            <div class=\"pull-left\">\r\n                <button class=\"btn progress-button\" ui-sref=\"newRepairment.costConfirmation\" ng-disabled=\"!$ctrl.states[\'newRepairment.costConfirmation\'].isClickable()\" ui-sref-active=\"progress-button-active\">\r\n                    <span>3</span>\r\n                </button>\r\n            </div>\r\n            <div class=\"pull-left\">\r\n                <button class=\"btn progress-button\" ui-sref=\"newRepairment.defectDescription\" ng-disabled=\"!$ctrl.states[\'newRepairment.defectDescription\'].isClickable()\" ui-sref-active=\"progress-button-active\">\r\n                    <span>4</span>\r\n                </button>\r\n            </div>\r\n            <div class=\"pull-left\">\r\n                <button class=\"btn progress-button\" ui-sref=\"newRepairment.contactDetails\" ng-disabled=\"!$ctrl.states[\'newRepairment.contactDetails\'].isClickable()\" ui-sref-active=\"progress-button-active\">\r\n                    <span>5</span>\r\n                </button>\r\n            </div>\r\n            <div class=\"pull-left\">\r\n                <button class=\"btn progress-button\" ui-sref=\"newRepairment.requestSubmission\" ng-disabled=\"!$ctrl.states[\'newRepairment.requestSubmission\'].isClickable()\" ui-sref-active=\"progress-button-active\">\r\n                    <span>6</span>\r\n                </button>\r\n            </div>\r\n            <div class=\"pull-left\">\r\n                <button class=\"btn progress-button\" ui-sref=\"newRepairment.appointmentPlanner\" ng-disabled=\"!$ctrl.states[\'newRepairment.appointmentPlanner\'].isClickable()\" ui-sref-active=\"progress-button-active\">\r\n                    <span>7</span>\r\n                </button>\r\n            </div>\r\n        </div>\r\n\r\n\r\n\r\n        <div id=\"wizardPages\" ui-view></div>\r\n    </div>\r\n</div>");
$templateCache.put("/App/newRepairment/progressDialog.html","<div data-viewname=\"NewRepairments\" ng-cloak>\r\n    <div class=\"modal-header\">\r\n        <h3 class=\"modal-title\" data-i18n=\"Title_ProgressDialog_Dialog\"></h3>\r\n    </div>\r\n    <div class=\"modal-body\">\r\n        <div class=\"form-group\" >\r\n            <span name=\"maintenanceRequestStatus\" id=\"maintenanceRequestStatus\" data-i18n=\"Message_MaintenanceRequest_Submitting\" ng-hide=\"$ctrl.requestSubmitted()\"></span>\r\n            <span ng-hide=\"$ctrl.requestSubmitted()\"><i class=\"fa fa-spinner fa-spin fa-1x fa-fw\"></i></span>\r\n            <span ng-show=\"$ctrl.requestSubmitted()\" class=\"show-newlines\">{{$ctrl.model.MaintenanceRequestMessage}}</span>\r\n        </div>\r\n        <div class=\"form-group\" ng-show=\"$ctrl.hasImages()\">\r\n            <span name=\"imageUploadStatus\" id=\"imageUploadStatus\" data-i18n=\"Message_Images_Uploading\" ng-hide=\"$ctrl.imagesUploaded()\"></span>\r\n            <span  ng-hide=\"$ctrl.imagesUploaded()\"><i class=\"fa fa-spinner fa-spin fa-1x fa-fw\"></i></span>\r\n            <span ng-show=\"$ctrl.imagesUploaded()\" class=\"show-newlines\">{{$ctrl.model.ImageUploadMessage}}</span>\r\n        </div>\r\n        <div class=\"form-group\" ng-show=\"$ctrl.updatesCustomerDetails()\">\r\n            <span class=\"show-newlines\">{{$ctrl.model.UpdateCustomerDetailsMessage}}</span>\r\n        </div>\r\n    </div>\r\n    <div class=\"modal-footer\" ng-show=\"$ctrl.showFooter\">\r\n        <button id=\"close\" class=\"btn btn-primary pull-right\" ng-click=\"$ctrl.close()\">\r\n            <span data-i18n=\"Button_Close\"></span>\r\n        </button>\r\n    </div>\r\n</div>");
$templateCache.put("/App/newTimelineAction/newTimelineAction.html","<div data-viewname=\"MyTimeline\">\r\n    <div panel id=\"newInteractionPanel\" data-i18n-attr=\"Panel_Title_New|heading\">\r\n        <form name=\"newForm\" novalidate>\r\n            <div class=\"input-group input-group-unstyled\">\r\n                <div class=\"form-group has-feedback\">\r\n                    <label class=\"control-label\" data-i18n=\"Input_Label_Contract\"></label>\r\n                    <div class=\"select-container\">\r\n                        <select name=\"contract\" ng-model=\"$ctrl.newInteraction.RealtyObjectNo\" required ng-change=\"$ctrl.contractChanged();\" class=\"form-control\">\r\n                            <option value=\'\' disabled ng-selected=\"{{!$ctrl.customerDetails.ActiveContracts || $ctrl.customerDetails.ActiveContracts.length > 1}}\" style=\'display:none;\' data-i18n=\"Placeholder_Contract|placeholder\"></option>\r\n\r\n                            <option ng-repeat=\"option in $ctrl.customerDetails.ActiveContracts\"\r\n                                    ng-selected=\"{{$ctrl.customerDetails.ActiveContracts.length == 1}}\"\r\n                                    value=\"{{option.RentalUnit.No}}\">\r\n                                {{option.Address}}\r\n                            </option>\r\n                        </select>\r\n                        <span class=\"icon_ form-control-feedback\"></span>\r\n                        <span class=\"glyphicon glyphicon-chevron-down dropdown_icon\"></span>\r\n\r\n                        <div class=\"text-danger\" ng-messages=\"newForm.contract.$error\" ng-show=\"newForm.contract.$touched||newForm.$submitted\">\r\n                            <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n\r\n                <tooltip class=\"input-group-addon\" data-i18n-attr=\"Tooltip_Contract|content\" placement=\"bottom\" />\r\n            </div>\r\n\r\n            <div class=\"input-group input-group-unstyled\">\r\n                <div class=\"form-group has-feedback\">\r\n                    <label class=\"control-label\" data-i18n=\"Input_Label_Subject\"></label>\r\n                    <div class=\"select-container\">\r\n                        <select name=\"actionCode\" ng-model=\"$ctrl.newInteraction.ActionCode\" required class=\"form-control\" ng-options=\'option.Code as option.Description for option in $ctrl.interactionSubjects\'>\r\n                            <option value=\'\' disabled selected style=\'display:none;\' data-i18n=\"Placeholder_Subject|placeholder\"></option>\r\n                        </select>\r\n                        <span class=\"icon_ form-control-feedback\"></span>\r\n                        <span class=\"glyphicon glyphicon-chevron-down dropdown_icon\"></span>\r\n\r\n                        <div class=\"text-danger\" ng-messages=\"newForm.actionCode.$error\" ng-show=\"newForm.actionCode.$touched||newForm.$submitted\">\r\n                            <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n\r\n                <tooltip class=\"input-group-addon\" data-i18n-attr=\"Tooltip_Subject|content\" placement=\"bottom\" />\r\n            </div>\r\n\r\n            <div class=\"input-group input-group-unstyled\">\r\n                <div class=\"form-group has-feedback\">\r\n                    <label class=\"control-label\" data-i18n=\"Input_Label_Comments\"></label>\r\n                    <textarea rows=\"4\" class=\"form-control\" name=\"userComment\" ng-model=\"$ctrl.newInteraction.Comments\" required maxlength=\"250\"></textarea>\r\n                    <span class=\"icon_ form-control-feedback\"></span>\r\n\r\n                    <div class=\"text-danger\" ng-messages=\"newForm.userComment.$error\" ng-show=\"newForm.userComment.$touched||newForm.$submitted\">\r\n                        <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></div>\r\n                    </div>\r\n                </div>\r\n\r\n                <tooltip class=\"input-group-addon\" data-i18n-attr=\"Tooltip_Comments|content\" placement=\"bottom\" />\r\n            </div>\r\n\r\n            <div>\r\n                <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.saveNewInteraction(newForm);\" ng-disabled=\"!newForm.$dirty || $ctrl.processing\">\r\n                    <span data-i18n=\"Button_Save\"></span><span class=\"glyphicon glyphicon-menu-right\"></span>\r\n                </button>\r\n                <button type=\"button\" class=\"btn btn-cancel pull-right\" ng-click=\"$ctrl.cancelNewInteraction(newForm);\" ng-hide=\"$ctrl.hideCancelButton\" ng-disabled=\"$ctrl.processing\">\r\n                    <span data-i18n=\"Button_Cancel\"></span>\r\n                </button>\r\n            </div>\r\n        </form>\r\n    </div>\r\n</div>");
$templateCache.put("/App/news/news.html","<div data-viewname=\"News\">\r\n    <h3 class=\"text-primary\" data-i18n=\"Text_NoNews\" ng-show=\"$ctrl.newsLoaded && $ctrl.news.length == 0\"></h3>\r\n    <div class=\"row\" infinite-scroll=\"$ctrl.loadMore()\" infinite-scroll-distance=\"3\">\r\n        <div class=\"col-md-6 col-sm-6 col-xs-12\" ng-repeat=\"item in $ctrl.news\">\r\n            <div panel class=\"news\" heading=\"&#9679; {{item.Title}}\" subtitle=\"{{item.PublicationDate | date : \'EEEE,  dd-MM-yyyy\'}}\">\r\n                <div class=\"hide-text-overflow preformatted-text\" ng-bind-html=\"item.ContentValue\"></div>\r\n                <button type=\"button\" class=\"btn btn-primary\" ui-sref=\"newsDetails({newsItem: item, itemId: item.Id})\">\r\n                    <span data-i18n=\"Button_Navigate\"></span>\r\n                    <span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span>\r\n                </button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>");
$templateCache.put("/App/newsDetails/newsDetails.html","<div data-viewname=\"News\">\r\n    <div panel class=\"col-xs-12 panel-default\" heading=\"&#9679; {{$ctrl.newsItem.Title}}\" subtitle=\"{{$ctrl.newsItem.PublicationDate | date : \'EEEE,  dd-MM-yyyy\'}}\">\r\n        <div class=\"preformatted-text\" ng-bind-html=\"$ctrl.newsItem.ContentValue\"></div>\r\n        <a class=\"btn btn-primary\" ng-show=\"$ctrl.newsItem.Url && $ctrl.newsItem.Url.length > 0\" ng-href=\"{{$ctrl.parseUrl($ctrl.newsItem.Url)}}\" target=\"_blank\">\r\n            <span data-i18n=\"Button_Open_Link\"></span>\r\n            <span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span>\r\n        </a>\r\n    </div>\r\n    <div class=\"button-container clearfix\">\r\n        <button type=\"button\" class=\"btn btn-primary col-xs-12 col-sm-2\" ng-click=\"$ctrl.goBack();\">\r\n            <span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span>\r\n            <span data-i18n=\"Button_Navigate_Back\"></span>\r\n        </button>\r\n        <button type=\"button\" class=\"btn btn-primary col-xs-12 col-sm-4\" ui-sref=\"news\">\r\n            <span data-i18n=\"Button_Navigate_Overview\"></span>\r\n            <span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span>\r\n        </button>\r\n    </div>\r\n</div>");
$templateCache.put("/App/pageNotFound/pageNotFound.html","<div data-viewname=\"PageNotFound\">\r\n    <div panel id=\"pageNotFoundPanel\" data-i18n-attr=\"Title_PageNotFound|heading\">\r\n        <h3 data-i18n=\"Message_PageNotFound\"></h3>\r\n    </div>\r\n</div>");
$templateCache.put("/App/paymentArrangement/paymentArrangementWizardFinish.html","<div data-viewname=\"PaymentArrangement\">\r\n    <div panel data-i18n-attr=\"Title_NewPaymentArrangement|heading\">\r\n        <div data-i18n=\"Message_NewPaymentArrangementInfo_SecondPage\"></div>\r\n        <br />\r\n        <form class=\"readonly\" novalidate name=\"templateForm\">\r\n            <div panel data-i18n-attr=\"Panel_SelectTypeAndNumberOfTerms|heading\">\r\n                <div class=\"form-group\">\r\n                    <label for=\"template\" data-i18n=\"Label_Type\"></label>\r\n                    <select name=\"template\" ng-model=\"$ctrl.selectedTemplateCode\" required ng-change=\"$ctrl.onTemplateChange(templateForm)\" class=\"form-control\">\r\n                        <option value=\'\' disabled ng-selected=\"{{!$ctrl.templates || $ctrl.templates.length > 1}}\" style=\'display:none;\'></option>\r\n                        <option ng-repeat=\"option in $ctrl.templates\" value=\"{{option.Code}}\"\r\n                                ng-selected=\"{{$ctrl.templates.length == 1}}\">\r\n                            {{option.Description}}\r\n                        </option>\r\n                    </select>\r\n                    <div class=\"text-danger field-validation-error\" ng-show=\"(templateForm.template.$touched || templateForm.$submitted)\" ng-messages=\"templateForm.template.$error\">\r\n                        <span ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></span>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"form-group\">\r\n                    <label for=\"paymentMethod\" data-i18n=\"Label_PaymentMethod\"></label>\r\n                    <input type=\"text\" class=\"form-control\" ng-disabled=\"true\"\r\n                           ng-value=\"$ctrl.translateTransactionCode($ctrl.selectedTemplate.TransactionModeCode)\" ng-readonly=\"true\">\r\n                </div>\r\n\r\n                <div class=\"form-group\">\r\n                    <label for=\"installmentFrequency\" data-i18n=\"Label_InstallmentFrequency\"></label>\r\n                    <input type=\"text\" class=\"form-control\" ng-disabled=\"true\" ng-model=\"$ctrl.selectedTemplate.Frequency\" ng-readonly=\"true\"\r\n                           duration duration-prefix=\"Text_Prefix_InstallmentFrequency\">\r\n                </div>\r\n\r\n                <div class=\"form-group\">\r\n                    <label for=\"dueDateFirstInstallment\" data-i18n=\"Label_DueDateFirstInstallment\"></label>\r\n                    <input type=\"text\" class=\"form-control\" ng-disabled=\"true\" ng-model=\"$ctrl.selectedTemplate.DueDateFirstPayment\" ng-readonly=\"true\"\r\n                           duration duration-prefix=\"Text_Prefix_DueDateFirstInstallment\" duration-include-value-for-singular-case=\"true\">\r\n                </div>\r\n\r\n                <div class=\"form-group\">\r\n                    <label for=\"remainingAmount\" data-i18n=\"Label_RemainingAmount\"></label>\r\n                    <input type=\"text\" class=\"form-control\" ng-disabled=\"true\"\r\n                           ng-value=\"$ctrl.translateRemainingAmountOption($ctrl.selectedTemplate.RemainingAmountOption)\" ng-readonly=\"true\">\r\n                </div>\r\n\r\n                <div class=\"form-group\">\r\n                    <label for=\"numberOfInstallments\" data-i18n=\"Label_NumberOfInstallments\"></label>\r\n                    <select class=\"form-control\" ng-model=\"$ctrl.numberOfInstallments\" ng-change=\"$ctrl.onNumberOfInstallmentsChange()\" name=\"numberOfInstallments\" required>\r\n                        <option ng-repeat=\"value in [] | range:1:$ctrl.selectedTemplate.MaxNoOfTerms | filter:$ctrl.filterNumberOfInstallments($ctrl.selectedTemplate.RemainingAmountOption)\">\r\n                            {{value}}\r\n                        </option>\r\n                    </select>\r\n                    <div class=\"text-danger field-validation-error\" ng-show=\"(templateForm.numberOfInstallments.$touched || templateForm.$submitted)\"\r\n                         ng-messages=\"templateForm.numberOfInstallments.$error\">\r\n                        <span ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></span>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"form-group\">\r\n                    <label for=\"installmentAmount\" data-i18n=\"Label_InstallmentAmount\"></label>\r\n                    <div class=\"left-inner-addon\">\r\n                        <div class=\"input-group input-group-unstyled no-label col-sm-3 col-xs-9 pull-left\">\r\n                            <span class=\"currency-symbol\">&euro;</span>\r\n                            <input name=\"installmentAmount\" type=\"text\"\r\n                                   numeric min=\"0\" decimals=\"2\"\r\n                                   max-amount max-value=\"$ctrl.totalAmount\"\r\n                                   required\r\n                                   class=\"form-control\"\r\n                                   ng-disabled=\"true\"\r\n                                   ng-model=\"$ctrl.installmentAmount\" />\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n        </div>\r\n\r\n        <button id=\"btnPrevious\" name=\"btnPrevious\" class=\"btn btn-primary\" ng-click=\"$ctrl.onPreviousClick()\" type=\"button\">\r\n            <span class=\"glyphicon glyphicon-menu-left\"></span>\r\n            <span data-i18n=\"Button_Previous\"></span>\r\n        </button>\r\n\r\n        <button id=\"btnSend\" name=\"btnSend\" class=\"btn btn-primary btn-vert-sm\"\r\n                ng-click=\"$ctrl.onCreateClick(templateForm)\">\r\n            <span data-i18n=\"Button_Send\"></span>\r\n            <span class=\"glyphicon glyphicon-menu-right\"></span>\r\n        </button>\r\n\r\n        <button id=\"btnCancel\" name=\"btnCancel\" class=\"btn btn-cancel pull-right-md btn-vert-sm\"\r\n                ng-click=\"$ctrl.onCancelClick()\"\r\n                type=\"button\">\r\n            <span data-i18n=\"Button_Cancel\"></span>\r\n        </button>\r\n\r\n        </form>\r\n    </div>\r\n</div>");
$templateCache.put("/App/paymentArrangement/paymentArrangementWizardStart.html","<div data-viewname=\"PaymentArrangement\">\r\n    <div panel data-i18n-attr=\"Title_NewPaymentArrangement|heading\">\r\n        <div data-i18n=\"Message_NewPaymentArrangementInfo\"></div>\r\n        <br />\r\n        <div panel id=\"invoicesPanel\" data-i18n-attr=\"Panel_SelectOpenInvoices|heading\">\r\n            <table class=\"table table-condensed table-responsive checkable-small\">\r\n                <thead>\r\n                    <tr>\r\n                        <th class=\"col-xs-1\"></th>\r\n                        <th data-i18n=\"Column_OpenAmount\"></th>\r\n                        <th data-i18n=\"Column_Due\"></th>\r\n                    </tr>\r\n                </thead>\r\n                <tbody>\r\n                    <tr ng-repeat-start=\"item in $ctrl.openInvoices | filter: {CanPayOnline: true, CanIncludeInPaymentScheme: true}\"\r\n                        data-toggle=\"collapse\" aria-expanded=\"false\"\r\n                        data-target=\"#invoice_details_{{$index}}\"\r\n                        class=\"accordion-toggle collapsed\">\r\n                        <td class=\"text-center col-xs-1\">\r\n                            <input type=\"checkbox\" class=\"checkbox\" ng-disabled=\"item.disabled\"\r\n                                   ng-model=\"item.selected\"\r\n                                   ng-change=\"$ctrl.onCheckChange(item)\" stop-propagation />\r\n                        </td>\r\n                        <td class=\"currency currency-wide\">\r\n                            <span amount-display ng-disabled=\"item.disabled\" amount=\"item.OnlinePaymentMaximumAmount\" total=\"item.OnlinePaymentMaximumAmount\"></span>\r\n                        </td>\r\n                        <td>\r\n                            <span due-date ng-disabled=\"item.disabled\" value=\"item.DueDate\"></span>\r\n                        </td>\r\n                    </tr>\r\n                    <tr ng-repeat-end>\r\n                        <td colspan=\"4\" class=\"table-hidden-row\">\r\n                            <div class=\"collapse\" id=\"invoice_details_{{$index}}\">\r\n                                <div class=\"accordion-body\" key-values=\"$ctrl.extendedInfoItems[item.EntryNo]\" />\r\n                            </div>\r\n                        </td>\r\n                    </tr>\r\n                </tbody>\r\n            </table>\r\n\r\n            <br />\r\n            <div class=\"clearfix\">\r\n                <label style=\"margin: 0; margin-right: 15px; line-height: 44px;\" class=\"pull-left\" data-i18n=\"Label_TotalAmount\"></label>\r\n                <div class=\"input-group input-group-unstyled no-label col-sm-3 col-xs-9 pull-left\">\r\n                    <div class=\"form-group\">\r\n                        <div class=\"left-inner-addon\">\r\n                            <span class=\"currency-symbol\">&euro;</span>\r\n\r\n                            <input name=\"amount\" type=\"text\"\r\n                                   numeric min=\"0\" decimals=\"2\"\r\n                                   max-amount max-value=\"$ctrl.totalAmount\"\r\n                                   required\r\n                                   class=\"form-control\"\r\n                                   ng-disabled=\"true\"\r\n                                   ng-model=\"$ctrl.totalAmount\" />\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <button id=\"btnNext\" name=\"btnNext\" class=\"btn btn-primary\"\r\n                ng-click=\"$ctrl.onNextClick()\"\r\n                ng-disabled=\"$ctrl.totalAmount <= 0\">\r\n            <span data-i18n=\"Button_Next\"></span>\r\n            <span class=\"glyphicon glyphicon-menu-right\"></span>\r\n        </button>\r\n\r\n        <button id=\"btnCancel\" name=\"btnCancel\" class=\"btn btn-cancel pull-right-sm\"\r\n                ng-click=\"$ctrl.onCancelClick()\">\r\n            <span data-i18n=\"Button_Cancel\"></span>\r\n        </button>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("/App/portalDown/portalDown.html","<div data-viewname=\"PortalDown\">\r\n    <div panel id=\"portalDownPanel\" data-i18n-attr=\"Title_PortalDown|heading\">\r\n        <span data-i18n=\"Message_PortalDown\"></span>\r\n    </div>\r\n</div>");
$templateCache.put("/App/portalSettings/portalSettings.html","<div data-viewname=\"PortalSettings\" ng-cloak>\r\n    <form name=\"portalSettingsForm\" ng-submit=\"$ctrl.savePortalSettings(portalSettingsForm)\" novalidate>\r\n        <div panel data-i18n-attr=\"Title_Google_Analytics|heading\">\r\n            <div class=\"input-group\">\r\n                <label data-i18n=\"Label_Google_Analytics_Enabled\" ng-show=\"$ctrl.analyticsEnabled\" class=\"info\"></label>\r\n                <label data-i18n=\"Label_Google_Analytics_Disabled\" ng-show=\"!$ctrl.analyticsEnabled\"\r\n                    class=\"info\"></label>\r\n\r\n                <div class=\"form-group has-feedback\">\r\n                    <label for=\"trackId\" data-i18n=\"Label_Google_Analytics_TrackId\"></label>\r\n                    <input type=\"text\" id=\"trackId\" name=\"trackId\" class=\"form-control clearInputX\"\r\n                        ng-pattern=\"$ctrl.googleAnalyticsPattern\" ng-model=\"$ctrl.googleAnalyticsTrackigId\" />\r\n\r\n                    <div class=\"text-danger\" ng-messages=\"portalSettingsForm.trackId.$error\"\r\n                        ng-show=\"portalSettingsForm.trackId.$touched||portalSettingsForm.$submitted\">\r\n                        <div ng-message=\"pattern\"><span data-i18n=\"Message_Google_TrackId_Not_Valid\"></span></div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <div panel data-i18n-attr=\"Title_SessionTimeout|heading\">\r\n            <div class=\"input-group row\">\r\n                <div class=\"form-group has-feedback col-md-6\">\r\n                    <label for=\"sessionTimeout\" data-i18n=\"Label_SessionTimeout\"></label>\r\n                    <div class=\"row\">\r\n                        <div class=\"col-md-6\"><input type=\"number\" ng-min=\"5\" ng-max=\"30\" ng-required=\"true\"\r\n                                id=\"sessionTimeout\" name=\"sessionTimeout\" class=\"form-control clearInputX\"\r\n                                ng-model=\"$ctrl.sessionTimeout\" /></div>\r\n                        <div class=\"col-md-6\">\r\n                            <p class=\"form-control-static\" data-i18n=\"Label_Minutes\"></p>\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div class=\"text-danger\" ng-messages=\"portalSettingsForm.sessionTimeout.$error\"\r\n                        ng-show=\"portalSettingsForm.sessionTimeout.$touched||portalSettingsForm.$submitted\">\r\n                        <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></div>\r\n                        <div ng-message=\"min\"><span data-i18n=\"Validation_SessionTimeout_Minimum\"></span></div>\r\n                        <div ng-message=\"max\"><span data-i18n=\"Validation_SessionTimeout_Maximum\"></span></div>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"form-group has-feedback col-md-6\">\r\n                    <label for=\"persistentSessionTimeout\" data-i18n=\"Label_PersistentTimeout\"></label>\r\n                    <div class=\"row\">\r\n                        <div class=\"col-md-6\"><input type=\"number\" ng-min=\"1\" ng-max=\"30\" ng-required=\"true\"\r\n                                id=\"persistentTimeout\" name=\"persistentTimeout\" class=\"form-control clearInputX\"\r\n                                ng-model=\"$ctrl.persistentTimeout\" /></div>\r\n                        <div class=\"col-md-6\">\r\n                            <p class=\"form-control-static\" data-i18n=\"Label_Days\"></p>\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div class=\"text-danger\" ng-messages=\"portalSettingsForm.persistentTimeout.$error\"\r\n                        ng-show=\"portalSettingsForm.persistentTimeout.$touched||portalSettingsForm.$submitted\">\r\n                        <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></div>\r\n                        <div ng-message=\"min\"><span data-i18n=\"Validation_PersistentTimeout_Minimum\"></span></div>\r\n                        <div ng-message=\"max\"><span data-i18n=\"Validation_PersistentTimeout_Maximum\"></span></div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <div panel data-i18n-attr=\"Title_Anonymous_Maintenance|heading\">\r\n            <div class=\"input-group\">\r\n                <label>\r\n                    <input type=\"checkbox\" name=\"filter\" ng-model=\"$ctrl.allowAnonymousMR\"> <span\r\n                        data-i18n=\"Label_Anonymous_Maintenance_Description\"></span>\r\n                </label>\r\n            </div>\r\n        </div>\r\n        <div panel data-i18n-attr=\"Title_ServiceToService_Authentication|heading\">\r\n            <div class=\"input-group\">\r\n                <label>\r\n                    <input type=\"checkbox\" name=\"filter\" ng-model=\"$ctrl.UseS2SAuthentication\"> <span\r\n                        data-i18n=\"Label_ServiceToService_Authentication_Description\"></span>\r\n                </label>\r\n            </div>\r\n        </div>\r\n        <div panel data-i18n-attr=\"Title_Oauth_For_Sending_Mails|heading\">\r\n            <div class=\"input-group\">\r\n                <label>\r\n                    <input type=\"checkbox\" name=\"filter\" ng-model=\"$ctrl.useOauthForSendingMails\"\r\n                        ng-disabled=\"$ctrl.isConsentRequired\">\r\n                    <span data-i18n=\"Label_Use_Oauth_For_Sending_Mails\" ng-hide=\"$ctrl.isConsentRequired\"></span>\r\n                    <span data-i18n=\"Label_Before_Enable_Oauth_For_Sending_Mails\"\r\n                        ng-hide=\"!$ctrl.isConsentRequired\"></span>\r\n                </label>\r\n            </div>\r\n            <div class=\"input-group\">\r\n                <button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.grantConsent()\"\r\n                    ng-disabled=\"!$ctrl.isConsentRequired\">\r\n                    <span data-i18n=\"Button_Grant_Consent\"></span>\r\n                </button>\r\n            </div>\r\n        </div>\r\n\r\n        <div panel data-i18n-attr=\"Title_Simova_DMS|heading\" ng-show=\"$ctrl.isOnPremise\">\r\n            <div class=\"input-group\">\r\n                <label>\r\n                    <input type=\"checkbox\" name=\"filter\" ng-model=\"$ctrl.getDocsFromDmsOnline\"> <span\r\n                        data-i18n=\"Label_GetDocsFromDmsOnline\"></span>\r\n                </label>\r\n            </div>\r\n        </div>\r\n\r\n        <div panel data-i18n-attr=\"Title_Facebook_Config|heading\">\r\n            <div class=\"form-group has-feedback\">\r\n                <label for=\"fbAppSecret\" data-i18n=\"Label_Facebook_App_Secret\"></label>\r\n                <input type=\"text\" id=\"fbAppSecret\" name=\"fbAppSecret\" class=\"form-control clearInputX\"\r\n                    ng-pattern=\"$ctrl.facebookPattern\" ng-model=\"$ctrl.facebookAppSecret\" />\r\n\r\n                <div class=\"text-danger\" ng-messages=\"portalSettingsForm.fbAppSecret.$error\"\r\n                    ng-show=\"portalSettingsForm.fbAppSecret.$touched||portalSettingsForm.$submitted\">\r\n                    <div ng-message=\"pattern\"><span data-i18n=\"Message_Facebook_App_Secret_Not_Valid\"></span></div>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"form-group has-feedback\">\r\n                <label for=\"fbAppId\" data-i18n=\"Label_Facebook_App_Id\"></label>\r\n                <input type=\"text\" id=\"fbAppId\" name=\"fbAppId\" class=\"form-control clearInputX\"\r\n                    ng-pattern=\"$ctrl.facebookPattern\" ng-model=\"$ctrl.facebookAppId\" />\r\n\r\n                <div class=\"text-danger\" ng-messages=\"portalSettingsForm.fbAppId.$error\"\r\n                    ng-show=\"portalSettingsForm.fbAppId.$touched||portalSettingsForm.$submitted\">\r\n                    <div ng-message=\"pattern\"><span data-i18n=\"Message_Facebook_App_Id_Not_Valid\"></span></div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <div panel data-i18n-attr=\"Webchat_Title_Config|heading\">\r\n            <div class=\"form-group has-feedback\">\r\n                <label>\r\n                    <input type=\"checkbox\" name=\"webChatEnabled\" ng-model=\"$ctrl.webChatEnabled\"> <span\r\n                        data-i18n=\"Label_WebChat_Enabled\"></span>\r\n                </label>\r\n                <div ng-if=\"$ctrl.webChatEnabled\">\r\n                    <label for=\"webChatIntegrationId\" data-i18n=\"Label_WebChat_IntegrationId\"></label>\r\n                    <input type=\"text\" id=\"webChatIntegrationId\" name=\"webChatIntegrationId\"\r\n                        class=\"form-control clearInputX\" ng-model=\"$ctrl.webChatIntegrationId\" />\r\n\r\n                    <div class=\"text-danger\" ng-messages=\"portalSettingsForm.webChatIntegrationId.$error\"\r\n                        ng-show=\"portalSettingsForm.webChatIntegrationId.$touched||portalSettingsForm.$submitted\">\r\n                        <div ng-message=\"pattern\"><span data-i18n=\"Message_Webchat_Not_Valid\"></span></div>\r\n                    </div>\r\n\r\n                    <div class=\"form-group has-feedback\">\r\n                        <label for=\"fbAppId\" data-i18n=\"Label_WebChat_BusinessName\"></label>\r\n                        <input type=\"text\" id=\"webChatBusinessName\" name=\"webChatBusinessName\"\r\n                            class=\"form-control clearInputX\" ng-model=\"$ctrl.webChatBusinessName\" />\r\n\r\n                        <div class=\"text-danger\" ng-messages=\"portalSettingsForm.webChatBusinessName.$error\"\r\n                            ng-show=\"portalSettingsForm.webChatBusinessName.$touched||portalSettingsForm.$submitted\">\r\n                            <div ng-message=\"pattern\"><span data-i18n=\"Message_Webchat_Not_Valid\"></span></div>\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div class=\"form-group\">\r\n                        <div class=\"col-md-4\">\r\n                            <label data-i18n=\"Label_WebChat_BrandColor\"></label>\r\n                            <color-picker ng-model=\"$ctrl.webChatBrandColor\" color-picker-format=\"\'hex\'\"\r\n                                color-picker-swatch-pos=\"\'right\'\" color-picker-pos=\"\'top right\'\"\r\n                                color-picker-case=\"\'lower\'\"></color-picker>\r\n                        </div>\r\n                        <div class=\"col-md-4\">\r\n                            <label data-i18n=\"Label_WebChat_ConversationColor\"></label>\r\n                            <color-picker ng-model=\"$ctrl.webChatConversationColor\" color-picker-format=\"\'hex\'\"\r\n                                color-picker-swatch-pos=\"\'right\'\" color-picker-pos=\"\'top right\'\"\r\n                                color-picker-case=\"\'lower\'\"></color-picker>\r\n                        </div>\r\n                        <div class=\"col-md-4\">\r\n                            <label data-i18n=\"Label_WebChat_ActionColor\"></label>\r\n                            <color-picker ng-model=\"$ctrl.webChatActionColor\" color-picker-format=\"\'hex\'\"\r\n                                color-picker-swatch-pos=\"\'left\'\" color-picker-pos=\"\'top left\'\"\r\n                                color-picker-case=\"\'lower\'\"></color-picker>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <button class=\"btn btn-primary\" type=\"submit\" ng-disabled=\"!portalSettingsForm.$dirty || $ctrl.processing\">\r\n            <span data-i18n=\"Button_Save\"></span>\r\n        </button>\r\n\r\n        <button class=\"btn btn-primary\" ng-click=\"$ctrl.cancel(portalSettingsForm)\"\r\n            ng-disabled=\"!portalSettingsForm.$dirty || $ctrl.processing\">\r\n            <span data-i18n=\"Button_Cancel\"></span>\r\n        </button>\r\n\r\n    </form>\r\n</div>");
$templateCache.put("/App/resourcesManagement/resourcesManagement.html","<div data-viewname=\"ResourcesManagement\" ng-cloak>\r\n    <div class=\"panel-group\" role=\"tablist\" aria-multiselectable=\"false\">\r\n        <div collapsible-panel id=\"filters\" class=\"panel-default\" data-i18n-attr=\"Panel_FilterTitle|heading\" expanded=\"true\">\r\n            <form novalidate name=\"searchForm\">\r\n                <div class=\"form-group\">\r\n                    <label class=\"control-label\" data-i18n=\"Search_Page_Name\"></label>\r\n                    <div class=\"select-container\">\r\n                        <select name=\"viewName\" ng-options=\"option as option for option in $ctrl.viewNames\" ng-model=\"$ctrl.searchState.viewName\" class=\"form-control\">\r\n                        </select>\r\n                        <span class=\"glyphicon glyphicon-chevron-down dropdown_icon\"></span>\r\n                    </div>\r\n                </div>\r\n                <div class=\"form-group\">\r\n                    <label class=\"control-label\" data-i18n=\"Search_Label_Value\"></label>\r\n                    <input name=\"searchText\" class=\"form-control\" ng-model=\"$ctrl.searchState.searchText\" maxlength=\"256\" />\r\n                </div>\r\n                <div class=\"form-group\">\r\n                    <button class=\"btn btn-primary\" ng-click=\"$ctrl.search()\"><span data-i18n=\"Button_Search\"></span></button>\r\n                </div>\r\n            </form>\r\n        </div>\r\n        <div collapsible-panel id=\"results\" class=\"panel-default\" data-i18n-attr=\"Panel_ResourcesTitle|heading|{{($ctrl.paging.currentPage - 1)*$ctrl.paging.count+1}}|{{($ctrl.paging.currentPage)*$ctrl.paging.count > $ctrl.paging.totalItems ? $ctrl.paging.totalItems :($ctrl.paging.currentPage)*$ctrl.paging.count }}|{{$ctrl.getTotalItems()}}\" expanded=\"true\">\r\n            <div ng-hide=\"$ctrl.resources\">\r\n                <center>\r\n                    <i class=\"fa fa-spinner fa-spin fa-2x fa-fw\"></i>\r\n                </center>\r\n            </div>\r\n            <div ng-show=\"$ctrl.resources\">\r\n                <table class=\"table table-condensed table-responsive checkable-small col-xs-12\">\r\n                    <thead>\r\n                        <tr>\r\n                            <th></th>\r\n                            <th data-i18n=\"Column_ViewName\"></th>\r\n                            <th data-i18n=\"Column_ResourceName\"></th>\r\n                            <th data-i18n=\"Column_ResourceValue\"></th>\r\n                        </tr>\r\n                    </thead>\r\n                    <tbody>\r\n                        <tr ng-repeat=\"resource in $ctrl.resources\">\r\n                            <td align=\"center\">\r\n                                <input type=\"checkbox\" class=\"checkbox\"\r\n                                       ng-model=\"resource.Selected\"\r\n                                       ng-change=\"$ctrl.onCheckChange(resource)\" stop-propagation />\r\n                            </td>\r\n                            <td>\r\n                                {{resource.ViewName}}\r\n                            </td>\r\n                            <td>\r\n                                {{resource.ResourceName }}\r\n                            </td>\r\n                            <td>\r\n                                {{resource.ResourceValue}}\r\n                            </td>\r\n                        </tr>\r\n                        <tr>\r\n                            <td colspan=\"4\">\r\n                                <div>\r\n                                    <button class=\"btn btn-primary\" ng-disabled=\"!$ctrl.gridSelection.Selected\" ng-click=\"$ctrl.edit($ctrl.gridSelection)\">\r\n                                        <span data-i18n=\"Button_Edit\"></span><span class=\"glyphicon glyphicon-chevron-right\"></span>\r\n                                    </button>\r\n                                </div>\r\n                            </td>\r\n                        </tr>\r\n                    </tbody>\r\n                </table>\r\n                <div uib-pagination\r\n                     total-items=\"$ctrl.paging.totalItems\"\r\n                     items-per-page=\"$ctrl.paging.count\"\r\n                     ng-model=\"$ctrl.paging.currentPage\"\r\n                     max-size=\"$ctrl.paging.maxSize\"\r\n                     boundary-links=\"true\"\r\n                     rotate=\"true\"\r\n                     num-pages=\"numPages\"\r\n                     first-text=\"{{$ctrl.paging.firstText}}\"\r\n                     last-text=\"{{$ctrl.paging.lastText}}\"\r\n                     next-text=\"{{$ctrl.paging.nextText}}\"\r\n                     previous-text=\"{{$ctrl.paging.previousText}}\"\r\n                     ng-change=\"$ctrl.search()\">\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div collapsible-panel id=\"importExport\" class=\"panel-default\" data-i18n-attr=\"Panel_ImportExportTitle|heading\" expanded=\"true\">\r\n            <div>\r\n                <button class=\"btn btn-primary\" role=\"link\"\r\n                        tabindex=\"-1\"\r\n                        data-placement=\"top\"\r\n                        data-type=\"default\"\r\n                        data-toggle=\"custompopover\"\r\n                        data-trigger=\"hover\"\r\n                        file-download download-url=\"$ctrl.getExportResourcesUrl()\"\r\n                        download-finished-message=\"Message_DownloadDocumentFinished\"\r\n                        download-failed-message=\"Message_DownloadDocumentFailed\">\r\n                    <span data-i18n=\"Button_Export\"></span>\r\n                </button>\r\n\r\n                <file-picker-button max-size=\"$ctrl.resourcesFileMaxSize\"\r\n                                    file-type=\"$ctrl.fileType\"\r\n                                    btn-title=\"btnTitle\"\r\n                                    is-disabled=\"false\"\r\n                                    btn-class=\"btnClass\" \r\n                                    btn-icon=\"btnIcon\"\r\n                                    file-too-large-message=\"Message_FileTooLarge\"\r\n                                    modal-title=\"Title_Upload_Flexible_Labels\"\r\n                                    info-text=\"Text_MaxFileSize\"\r\n                                    view-name=\"FilePicker\"\r\n                                    file-model=\"$ctrl.resourcesFiles\"\r\n                                    file-selected=\"$ctrl.fileSelected()\"\r\n                                    invalid-file-extension=\"Message_Invalid_Extension\"\r\n                                    auto-close=\"true\"></file-picker-button>\r\n\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("/App/search/navbarSearch.html","<div class=\"navbar-search-container\" data-viewname=\"KnowledgeBase\">\r\n    <form role=\"search\" novalidate class=\"search\">\r\n        <div class=\"input-group input-group-unstyled\">\r\n            <div class=\"form-group\">\r\n                <input type=\"search\" class=\"form-control\" ng-model=\"$ctrl.searchValue\" ng-model-options=\"{ debounce: 500 }\" data-i18n-attr=\"Placeholder_Search|placeholder\" ng-change=\"$ctrl.doSearch();\">\r\n                <span class=\"icon_search_light search-icon\"></span>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</div>");
$templateCache.put("/App/search/search.html","<div class=\"overlay-container\" data-viewname=\"KnowledgeBase\">\r\n    <form role=\"search\" novalidate class=\"search visible-xs\">\r\n        <div class=\"input-group input-group-unstyled\">\r\n            <div class=\"form-group\">\r\n                <span class=\"icon_search_light search-icon\"></span>\r\n                <input type=\"search\" class=\"form-control\" ng-model=\"$ctrl.searchValue\" ng-model-options=\"{ debounce: 500 }\" data-i18n-attr=\"Placeholder_Search|placeholder\" ng-change=\"$ctrl.doSearch();\">\r\n            </div>\r\n            <div class=\"input-group-addon\">\r\n                <span class=\"icon_stop_light\" type=\"button\" data-toggle=\"collapse\" data-target=\"#search_overlay\" ng-click=\"$ctrl.clearSearch()\"></span>\r\n            </div>\r\n        </div>\r\n    </form>\r\n    <div id=\"searchResultsPanel\" uib-collapse=\"!$ctrl.searchValue || $ctrl.searchValue.length == 0\" class=\"collapse\">\r\n        <div class=\"row\">\r\n            <h1 data-i18n=\"Title_Search_Results_{{$ctrl.searchResultCount == 1 ? \'Single\' : \'Multiple\'}}|{{$ctrl.searchResultCount}}\" i18n-html></h1>\r\n            <div class=\"search-result-header-addon hidden-xs\">\r\n                <span class=\"icon_stop_light\" type=\"button\" data-toggle=\"collapse\" data-target=\"#search_overlay\" ng-click=\"$ctrl.clearSearch()\"></span>\r\n            </div>\r\n        </div>\r\n        <ul>\r\n            <li ng-repeat=\"(identifier, results) in $ctrl.searchResults\" ui-sref=\"knowledgebase({knowledgeQuery: $ctrl.searchValue, knowledgeItems: $ctrl.searchResults, openSubject: identifier, searchID: $ctrl.searchID})\" ng-click=\"$ctrl.hideSearchPanel()\">\r\n                <span ng-bind-html=\"$ctrl.highlightQuery(identifier)\"></span> <span data-i18n=\"Label_Search_Result_{{results.length == 1 ? \'Single\' : \'Multiple\'}}|{{results.length}}\"></span>\r\n            </li>\r\n        </ul>\r\n    </div>\r\n</div>");
$templateCache.put("/App/styleManagement/styleManagement.html","<div data-viewname=\"StyleManagement\" ng-cloak>\r\n    <div class=\"panel-group panel-group-sm\">\r\n        <div class=\"panel transparent\">\r\n            <a href=\"/styling/printscreens\"\r\n               target=\"_blank\"\r\n               data-i18n-attr=\"Tooltip_OpenPrintScreensPage|title\"\r\n               data-i18n=\"Button_OpenPrintScreensPage\">\r\n            </a>\r\n            <tooltip data-i18n-attr=\"Tooltip_OpenPrintScreensPage|content\" placement=\"top\" />\r\n        </div>\r\n    </div>\r\n\r\n    <form>\r\n        <div class=\"panel-group\" role=\"tablist\" aria-multiselectable=\"false\">\r\n            <div panel id=\"images\" data-i18n-attr=\"Panel_ImagesTitle|heading\">\r\n                <div class=\"form-group\">\r\n                    <label for=\"logoShape\" data-i18n=\"Label_LogoShape\"></label>\r\n                    <div class=\"radio\">\r\n                        <label>\r\n                            <input type=\"radio\" name=\"logoShape\" ng-model=\"$ctrl.styles[\'Configuration\'][\'$use_square_logo\']\" ng-value=\"false\"> <span data-i18n=\"Radio_LogoShape_Round\"></span>\r\n                        </label>\r\n                        <label>\r\n                            <input type=\"radio\" name=\"logoShape\" ng-model=\"$ctrl.styles[\'Configuration\'][\'$use_square_logo\']\" ng-value=\"true\"> <span data-i18n=\"Radio_LogoShape_Rectangle\"></span>\r\n                        </label>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-6\">\r\n                        <label data-i18n=\"Label_BrandingLogo\"></label>\r\n                        <file-picker-preview file-model=\"$ctrl.logo\"\r\n                                             max-size=\"$ctrl.logoMaxSizeBytes\"\r\n                                             view-name=\"FilePicker\"\r\n                                             modal-title=\"Title_UploadLogoImage\"\r\n                                             info-text=\"Text_MaxFileSize\"\r\n                                             file-too-large-message=\"Message_FileTooLarge\"\r\n                                             invalid-file-extension=\"Error_NotAnImage\"\r\n                                             file-type=\"image/*\"\r\n                                             auto-close=\"true\"\r\n                                             default-img-src=\"\'/styling/latest/logo\'\">\r\n                        </file-picker-preview>\r\n                    </div>\r\n\r\n                    <div class=\"col-md-6\">\r\n                        <label data-i18n=\"Label_BrandingLogoFooter\"></label>\r\n                        <file-picker-preview file-model=\"$ctrl.logoFooter\"\r\n                                             max-size=\"$ctrl.logoMaxSizeBytes\"\r\n                                             view-name=\"FilePicker\"\r\n                                             modal-title=\"Title_UploadLogoFooterImage\"\r\n                                             info-text=\"Text_MaxFileSize\"\r\n                                             file-too-large-message=\"Message_FileTooLarge\"\r\n                                             file-type=\"image/*\"\r\n                                             auto-close=\"true\"\r\n                                             invalid-file-extension=\"Error_NotAnImage\"\r\n                                             default-img-src=\"\'/styling/latest/footerlogo\'\">\r\n                        </file-picker-preview>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-6\">\r\n                        <label data-i18n=\"Label_BrandingBanner\"></label>\r\n                        <file-picker-preview file-model=\"$ctrl.banner\"\r\n                                             max-size=\"$ctrl.bannerMaxSizeBytes\"\r\n                                             view-name=\"FilePicker\"\r\n                                             modal-title=\"Title_UploadHeroImage\"\r\n                                             info-text=\"Text_MaxFileSize\"\r\n                                             file-too-large-message=\"Message_FileTooLarge\"\r\n                                             file-type=\"image/*\"\r\n                                             auto-close=\"true\"\r\n                                             invalid-file-extension=\"Error_NotAnImage\"\r\n                                             default-img-src=\"\'/styling/latest/banner\'\">\r\n                        </file-picker-preview>\r\n                    </div>\r\n\r\n                    <div class=\"col-md-6\">\r\n                        <label for=\"logoShape\" data-i18n=\"Label_ShowCopyrightInFooter\"></label>\r\n                        <div class=\"radio\">\r\n                            <label>\r\n                                <input type=\"radio\" name=\"showCopyrightInFooter\" ng-model=\"$ctrl.styles[\'Configuration\'][\'$show_copyright_in_footer\']\" ng-value=\"true\"> <span data-i18n=\"Radio_ShowCopyrightInFooter_Yes\"></span>\r\n                            </label>\r\n                            <label>\r\n                                <input type=\"radio\" name=\"showCopyrightInFooter\" ng-model=\"$ctrl.styles[\'Configuration\'][\'$show_copyright_in_footer\']\" ng-value=\"false\"> <span data-i18n=\"Radio_ShowCopyrightInFooter_No\"></span>\r\n                            </label>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n            <div panel id=\"colors\" data-i18n-attr=\"Panel_ColorsTitle|heading\">\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-6\">\r\n                        <label data-i18n=\"Label_Primary_Maincolor\"></label>\r\n                        <color-picker ng-model=\"$ctrl.styles[\'Background colors\'][\'$primary-maincolor\']\" color-picker-format=\"\'hex\'\" color-picker-swatch-pos=\"\'right\'\" color-picker-pos=\"\'bottom right\'\" color-picker-case=\"\'lower\'\"></color-picker>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n                        <label data-i18n=\"Label_Primary_Interactive\"></label>\r\n                        <color-picker ng-model=\"$ctrl.styles[\'Background colors\'][\'$primary-interactive\']\" color-picker-format=\"\'hex\'\" color-picker-swatch-pos=\"\'right\'\" color-picker-pos=\"\'bottom right\'\" color-picker-case=\"\'lower\'\"></color-picker>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-6\">\r\n                        <label data-i18n=\"Label_Body_Background_Color\"></label>\r\n                        <color-picker ng-model=\"$ctrl.styles[\'Background colors\'][\'$body-background-color\']\" color-picker-format=\"\'hex\'\" color-picker-swatch-pos=\"\'right\'\" color-picker-pos=\"\'bottom right\'\" color-picker-case=\"\'lower\'\"></color-picker>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n                        <label data-i18n=\"Label_Sidebar_Header_Color\"></label>\r\n                        <color-picker ng-model=\"$ctrl.styles[\'Background colors\'][\'$sidebar-header-color\']\" color-picker-format=\"\'hex\'\" color-picker-swatch-pos=\"\'right\'\" color-picker-pos=\"\'bottom right\'\" color-picker-case=\"\'lower\'\"></color-picker>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-6\">\r\n                        <label data-i18n=\"Label_Sidebar_Background_Color\"></label>\r\n                        <color-picker ng-model=\"$ctrl.styles[\'Background colors\'][\'$sidebar-background-color\']\" color-picker-format=\"\'hex\'\" color-picker-swatch-pos=\"\'right\'\" color-picker-pos=\"\'bottom right\'\" color-picker-case=\"\'lower\'\"></color-picker>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n                        <label data-i18n=\"Label_Sidebar_Divider_Color\"></label>\r\n                        <color-picker ng-model=\"$ctrl.styles[\'Background colors\'][\'$sidebar-divider-color\']\" color-picker-format=\"\'hex\'\" color-picker-swatch-pos=\"\'right\'\" color-picker-pos=\"\'bottom right\'\" color-picker-case=\"\'lower\'\"></color-picker>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-6\">\r\n                        <label data-i18n=\"Label_Footer_Background_Color\"></label>\r\n                        <color-picker ng-model=\"$ctrl.styles[\'Background colors\'][\'$footer-background-color\']\" color-picker-format=\"\'hex\'\" color-picker-swatch-pos=\"\'right\'\" color-picker-pos=\"\'bottom right\'\" color-picker-case=\"\'lower\'\"></color-picker>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n                        <label data-i18n=\"Label_Logo_Background_Color\"></label>\r\n                        <color-picker ng-model=\"$ctrl.styles[\'Background colors\'][\'$logo-background-color\']\" color-picker-format=\"\'hex\'\" color-picker-swatch-pos=\"\'right\'\" color-picker-pos=\"\'bottom right\'\" color-picker-case=\"\'lower\'\"></color-picker>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-6\">\r\n                        <label data-i18n=\"Label_Loading_Background_Color\"></label>\r\n                        <color-picker ng-model=\"$ctrl.styles[\'Background colors\'][\'$loading-background-color\']\" color-picker-format=\"\'hex\'\" color-picker-swatch-pos=\"\'right\'\" color-picker-pos=\"\'bottom right\'\" color-picker-case=\"\'lower\'\"></color-picker>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n                        <label data-i18n=\"Label_Header_Text_Color\"></label>\r\n                        <color-picker ng-model=\"$ctrl.styles[\'Text colors\'][\'$header-text-color\']\" color-picker-format=\"\'hex\'\" color-picker-swatch-pos=\"\'right\'\" color-picker-pos=\"\'bottom right\'\" color-picker-case=\"\'lower\'\"></color-picker>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-6\">\r\n                        <label data-i18n=\"Label_Header_Icon_Color\"></label>\r\n                        <color-picker ng-model=\"$ctrl.styles[\'Text colors\'][\'$header-icon-color\']\" color-picker-format=\"\'hex\'\" color-picker-swatch-pos=\"\'right\'\" color-picker-pos=\"\'bottom right\'\" color-picker-case=\"\'lower\'\"></color-picker>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n                        <label data-i18n=\"Label_Footer_Text_Color\"></label>\r\n                        <color-picker ng-model=\"$ctrl.styles[\'Text colors\'][\'$footer-text-color\']\" color-picker-format=\"\'hex\'\" color-picker-swatch-pos=\"\'right\'\" color-picker-pos=\"\'bottom right\'\" color-picker-case=\"\'lower\'\"></color-picker>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-6\">\r\n                        <label data-i18n=\"Label_Panel_Title_Color\"></label>\r\n                        <color-picker ng-model=\"$ctrl.styles[\'Text colors\'][\'$panel-title-color\']\" color-picker-format=\"\'hex\'\" color-picker-swatch-pos=\"\'right\'\" color-picker-pos=\"\'bottom right\'\" color-picker-case=\"\'lower\'\"></color-picker>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n                        <label data-i18n=\"Label_Sidebar_Text_Color\"></label>\r\n                        <color-picker ng-model=\"$ctrl.styles[\'Text colors\'][\'$sidebar-text-color\']\" color-picker-format=\"\'hex\'\" color-picker-swatch-pos=\"\'right\'\" color-picker-pos=\"\'bottom right\'\" color-picker-case=\"\'lower\'\"></color-picker>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-6\">\r\n                        <label data-i18n=\"Label_Sidebar_Selected_Text_Color\"></label>\r\n                        <color-picker ng-model=\"$ctrl.styles[\'Text colors\'][\'$sidebar-selected-text-color\']\" color-picker-format=\"\'hex\'\" color-picker-swatch-pos=\"\'right\'\" color-picker-pos=\"\'bottom right\'\" color-picker-case=\"\'lower\'\"></color-picker>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n                        <label data-i18n=\"Label_Sidebar_Header_Text_Color\"></label>\r\n                        <color-picker ng-model=\"$ctrl.styles[\'Text colors\'][\'$sidebar-header-text-color\']\" color-picker-format=\"\'hex\'\" color-picker-swatch-pos=\"\'right\'\" color-picker-pos=\"\'bottom right\'\" color-picker-case=\"\'lower\'\"></color-picker>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-6\">\r\n                        <label data-i18n=\"Label_Sidebar_Header_Selected_Text_Color\"></label>\r\n                        <color-picker ng-model=\"$ctrl.styles[\'Text colors\'][\'$sidebar-header-selected-text-color\']\" color-picker-format=\"\'hex\'\" color-picker-swatch-pos=\"\'right\'\" color-picker-pos=\"\'bottom right\'\" color-picker-case=\"\'lower\'\"></color-picker>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <button class=\"btn btn-primary\" ng-click=\"$ctrl.save()\">\r\n            <span data-i18n=\"Button_Save\"></span>\r\n        </button>\r\n\r\n        <button class=\"btn btn-primary\" ng-click=\"$ctrl.compileCss()\">\r\n            <span data-i18n=\"Button_CompileCSS\"></span>\r\n        </button>\r\n    </form>\r\n</div>\r\n");
$templateCache.put("/App/userManagement/editUser.html","<div data-viewname=\"UserManagement\">\r\n    <div panel id=\"userDetails\" data-i18n-attr=\"Panel_UserDetailsTitle|heading\">\r\n        <div ng-hide=\"$ctrl.userNotFound\">\r\n            <form novalidate name=\"userDetailsForm\">\r\n                <div panel id=\"general\" data-i18n-attr=\"Panel_General|heading\">\r\n                    <div class=\"form-group has-feedback\">\r\n                        <label for=\"userName\" data-i18n=\"Label_UserName\" />\r\n                        <input name=\"userName\" type=\"text\" ng-model=\"$ctrl.account.UserName\" class=\"form-control\" data-i18n-attr=\"Placeholder_UserName|placeholder\" maxlength=\"64\" ng-readonly=\"true\" />\r\n                    </div>\r\n                    <div class=\"form-group has-feedback\">\r\n                        <label for=\"email\" data-i18n=\"Label_Email\" />\r\n                        <input name=\"email\" type=\"text\" ng-model=\"$ctrl.account.EmailAddress\" class=\"form-control\" data-i18n-attr=\"Placeholder_Email|placeholder\" maxlength=\"255\" required email\r\n                               ng-readonly=\"!$ctrl.rights.EditAccount\" />\r\n                        <span class=\"icon_ form-control-feedback\"></span>\r\n\r\n                        <div class=\"text-danger field-validation-error\" ng-messages=\"userDetailsForm.email.$error\">\r\n                            <span ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></span>\r\n                            <span ng-message=\"email\"><span data-i18n=\"Message_InvalidEmail\"></span></span>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"form-group has-feedback\">\r\n                        <label for=\"role\" data-i18n=\"Label_Role\" />\r\n                        <div class=\"select-container\">\r\n                            <select id=\"contract\"\r\n                                    ng-model=\"$ctrl.account.RoleName\"\r\n                                    required\r\n                                    name=\"roleName\"\r\n                                    class=\"form-control\"\r\n                                    ng-change=\"$ctrl.isAdminRoleSelected()\"\r\n                                    ng-options=\'role.Name as role.Name for role in $ctrl.getRoles()\'\r\n                                    data-i18n-attr=\"Placeholder_Role|placeholder\"\r\n                                    ng-disabled=\"!$ctrl.rights.EditAccount || $ctrl.account.role.IsKCCEmployeeRole\">\r\n                                <option value=\'\' disabled selected style=\'display:none;\'></option>\r\n                            </select>\r\n                            <span class=\"icon_ form-control-feedback\"></span>\r\n                            <span class=\"glyphicon glyphicon-chevron-down dropdown_icon\"></span>\r\n                            <div class=\"text-danger field-validation-error\" ng-messages=\"userDetailsForm.roleName.$error\">\r\n                                <span ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></span>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"form-group has-feedback\">\r\n                        <label for=\"customerNo\" data-i18n=\"Label_CustomerNumber\"/>\r\n                        <input name=\"customerNo\" type=\"text\"\r\n                               ng-model=\"$ctrl.account.EmpireId\"\r\n                               ng-model-options=\"{ debounce: { \'default\': 500, \'blur\': 0 } }\"\r\n                               ng-required=\"!$ctrl.account.isAdminRoleSelected && !$ctrl.account.role.IsKCCEmployeeRole\" class=\"form-control\" data-i18n-attr=\"Placeholder_CustomerNumber|placeholder\"\r\n                               customer-number=\"checkingCustomerNumber\"\r\n                               start-validation=\"{{$ctrl.rights.EditAccount ? \'checkingCustomerNumber\' : false}}\"\r\n                               ng-readonly=\"!$ctrl.rights.EditAccount\"/>\r\n                        <span class=\"icon_ form-control-feedback\"></span>\r\n                        <div class=\"text-danger field-validation-error\" ng-messages=\"userDetailsForm.customerNo.$error\">\r\n                            <span ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></span>\r\n                            <span ng-message=\"checkingCustomerNumber\">\r\n                                <span data-i18n=\"Message_CheckingCustomerNumber\"></span>\r\n                            </span>\r\n                            <span ng-message=\"customerNumber\">\r\n                                <span data-i18n=\"Message_InvalidCustomerNumber\"></span>\r\n                            </span>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n\r\n                <div panel id=\"accountStatus\" data-i18n-attr=\"Panel_AccountStatus|heading\">\r\n                    <div class=\"form-group\" ng-show=\"$ctrl.account.IsUser\">\r\n                        <label for=\"confirmed\" data-i18n=\"Checkbox_Confirmed\" />\r\n                        <input name=\"confirmed\" type=\"text\" ng-value=\"$ctrl.getLocalDate($ctrl.account.EmailConfirmationDateUtc) | capitalize\" class=\"form-control\" ng-readonly=\"true\" />\r\n                    </div>\r\n                    <div class=\"checkbox\">\r\n                        <label>\r\n                            <input class=\"checkbox\" name=\"blocked\" type=\"checkbox\" ng-checked=\"$ctrl.account.IsAutomaticallyBlocked\" ng-disabled=\"true\" />\r\n                            <span data-i18n=\"Checkbox_AutomaticallyBlocked\"></span>\r\n                        </label>\r\n                    </div>\r\n                    <div class=\"checkbox\">\r\n                        <label>\r\n                            <input class=\"checkbox\" name=\"manuallyBlocked\" type=\"checkbox\" ng-checked=\"$ctrl.account.IsManuallyBlocked\" ng-disabled=\"true\" />\r\n                            <span data-i18n=\"Checkbox_ManuallyBlocked\"></span>\r\n                        </label>\r\n                    </div>\r\n                    <div class=\"form-group has-feedback\" ng-show=\"$ctrl.account.IsManuallyBlocked\">\r\n                        <label for=\"blockReason\" data-i18n=\"Label_BlockReason\"></label>\r\n                        <textarea rows=\"4\" name=\"blockReason\" id=\"blockReason\" class=\"form-control\" ng-model=\"$ctrl.account.BlockReason\" ng-disabled=\"true\"></textarea>\r\n                    </div>\r\n                </div>\r\n\r\n                <div panel id=\"loginInformation\" data-i18n-attr=\"Panel_LoginInformation|heading\">\r\n                    <div class=\"form-group has-feedback\">\r\n                        <label for=\"consecutiveFailedLogins\" data-i18n=\"Label_ConsecutiveFailedLogins\"></label>\r\n                        <input name=\"consecutiveFailedLogins\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.account.ConsecutiveUnsuccessfulLoginAttempts\" disabled=\"disabled\"/>\r\n                    </div>\r\n                    <div class=\"form-group has-feedback\">\r\n                        <label for=\"lastSuccessfulLogin\" data-i18n=\"Label_LastSuccessfulLogin\"></label>\r\n                        <input name=\"lastSuccessfulLogin\" type=\"text\" class=\"form-control\" ng-value=\"$ctrl.account.LastLogonTime  | utcToLocal : \'EEEE, dd-MM-yyyy HH:mm:ss\' | capitalize\" disabled=\"disabled\" />\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"form-group\">\r\n                    <button name=\"save\" class=\"btn btn-primary\" ng-disabled=\"userDetailsForm.$invalid || !userDetailsForm.$dirty\" ng-click=\"$ctrl.saveAccount(userDetailsForm)\" ng-show=\"$ctrl.rights.EditAccount\">\r\n                        <span data-i18n=\"Button_Save\"></span><span class=\"glyphicon glyphicon-menu-right\"></span>\r\n                    </button>\r\n                    <button class=\"btn btn-primary\" ng-show=\"$ctrl.account.IsAutomaticallyBlocked && $ctrl.rights.UnblockUser\" ng-click=\"$ctrl.activateAccount($ctrl.account)\">\r\n                        <span data-i18n=\"Button_Activate\"></span>\r\n                    </button>\r\n                    <button name=\"block\" class=\"btn btn-primary\" ng-show=\"!$ctrl.account.IsManuallyBlocked && !$ctrl.account.IsAutomaticallyBlocked && $ctrl.rights.BlockUser\" ng-click=\"$ctrl.blockAccount($ctrl.account)\">\r\n                        <span data-i18n=\"Button_Block\"></span>\r\n                    </button>\r\n                    <button name=\"unblock\" class=\"btn btn-primary\" ng-show=\"$ctrl.account.IsManuallyBlocked && $ctrl.rights.UnblockUser\" ng-click=\"$ctrl.unblockAccount($ctrl.account)\">\r\n                        <span data-i18n=\"Button_Unblock\"></span>\r\n                    </button>\r\n                    <button name=\"delete\" class=\"btn btn-danger\" ng-click=\"$ctrl.removeAccount($ctrl.account)\" ng-show=\"$ctrl.rights.RemoveAccount\">\r\n                        <span data-i18n=\"Button_Delete\"></span>\r\n                    </button>\r\n                    <button name=\"cancel\" class=\"btn btn-cancel pull-right\" ng-click=\"$ctrl.goBackToUserManagement()\" ng-show=\"$ctrl.rights.CancelDetailPages\"><span data-i18n=\"Button_Cancel\"></span></button>\r\n                </div>\r\n            </form>\r\n        </div>\r\n\r\n        <div ng-show=\"$ctrl.userNotFound\">\r\n            <span data-i18n=\"Message_AcountNotCreatedYet\"></span>\r\n        </div>\r\n    </div>\r\n</div>");
$templateCache.put("/App/userManagement/newKcc.html","<div data-viewname=\"NewKcc\">\r\n    <div panel id=\"newKcc\" data-i18n-attr=\"Panel_NewKcc|heading\">\r\n        <form novalidate name=\"newKccUser\" ng-submit=\"$ctrl.createKcc(newKccUser)\">\r\n\r\n            <div class=\"form-group has-feedback input-padding\">\r\n                <label for=\"domainName\" data-i18n=\"Label_DomainName\" />\r\n                <input name=\"domainName\" type=\"text\" ng-model=\"$ctrl.account.DomainName\" class=\"form-control\" data-i18n-attr=\"Label_DomainName|placeholder\" maxlength=\"20\" required />\r\n                <span class=\"icon_ form-control-feedback\"></span>\r\n\r\n                <div class=\"text-danger field-validation-error\" ng-show=\"(newKccUser.domainName.$touched || newKccUser.$submitted)\" ng-messages=\"newKccUser.domainName.$error\">\r\n                    <span ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></span>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"form-group has-feedback input-padding\">\r\n                <label for=\"userName\" data-i18n=\"Label_UserName\"/>\r\n                <input name=\"userName\" type=\"text\" ng-model=\"$ctrl.account.UserName\" class=\"form-control\" data-i18n-attr=\"Label_Username|placeholder\" maxlength=\"20\" required/>\r\n                <span class=\"icon_ form-control-feedback\"></span>\r\n\r\n                <div class=\"text-danger field-validation-error\" ng-show=\"(newKccUser.userName.$touched || newKccUser.$submitted)\" ng-messages=\"newKccUser.userName.$error\">\r\n                    <span ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></span>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"form-group has-feedback input-padding\">\r\n                <label for=\"email\" data-i18n=\"Label_Email\" />\r\n                <input name=\"email\" type=\"email\" email ng-model=\"$ctrl.account.Email\" class=\"form-control\" data-i18n-attr=\"Label_Email|placeholder\" maxlength=\"256\" required />\r\n                <span class=\"icon_ form-control-feedback\"></span>\r\n\r\n                <div class=\"text-danger field-validation-error\" ng-show=\"(newKccUser.email.$touched || newKccUser.$submitted)\" ng-messages=\"newKccUser.email.$error\">\r\n                    <span ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></span>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\" data-viewname=\"Generic\">\r\n                <button type=\"submit\" name=\"save\" class=\"btn btn-primary\" ng-disabled=\"!newKccUser.$dirty\"><span data-i18n=\"Button_Save\"></span><span class=\"glyphicon glyphicon-menu-right\"></span></button>\r\n                <button type=\"reset\" name=\"cancel\" class=\"btn btn-cancel pull-right\" ng-click=\"$ctrl.goBackToUserManagement()\"><span data-i18n=\"Button_Cancel\"></span></button>\r\n            </div>\r\n        </form>\r\n    </div>\r\n</div>");
$templateCache.put("/App/userManagement/newUser.html","<div data-viewname=\"UserManagement\">\r\n    <div panel id=\"userDetails\" data-i18n-attr=\"Panel_UserDetailsTitle|heading\">\r\n        <form  novalidate name=\"userDetailsForm\" ng-submit=\"$ctrl.saveAccount(userDetailsForm)\">\r\n            <div class=\"form-group has-feedback input-padding\">\r\n                <label for=\"userName\" data-i18n=\"Label_UserName\" />\r\n                <input name=\"userName\" type=\"text\" ng-model=\"$ctrl.account.UserName\" class=\"form-control\" data-i18n-attr=\"Placeholder_UserName|placeholder\" maxlength=\"20\" required />\r\n                <span class=\"icon_ form-control-feedback\"></span>\r\n\r\n                <div class=\"text-danger field-validation-error\" ng-show=\"(userDetailsForm.userName.$touched || userDetailsForm.$submitted)\" ng-messages=\"userDetailsForm.userName.$error\">\r\n                    <span ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></span>\r\n                </div>\r\n            </div>\r\n            <div class=\"form-group has-feedback input-padding\">\r\n                <label for=\"email\" data-i18n=\"Label_Email\" />\r\n                <input name=\"email\" type=\"text\" ng-model=\"$ctrl.account.EmailAddress\" class=\"form-control\" data-i18n-attr=\"Placeholder_Email|placeholder\" maxlength=\"255\" required email />\r\n                <span class=\"icon_ form-control-feedback\"></span>\r\n\r\n                <div class=\"text-danger field-validation-error\" ng-show=\"(userDetailsForm.email.$touched || userDetailsForm.$submitted)\" ng-messages=\"userDetailsForm.email.$error\">\r\n                    <span ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></span>\r\n                    <span ng-message=\"email\"><span data-i18n=\"Message_InvalidEmail\"></span></span>\r\n                </div>\r\n            </div>\r\n            <div class=\"input-group input-group-unstyled\">\r\n                <div class=\"form-group has-feedback\">\r\n                    <label for=\"password\" data-i18n=\"Label_Password\" />\r\n                    <input name=\"password\" type=\"text\" ng-model=\"$ctrl.account.Password\" ng-focus=\"$ctrl.turnOnPasswordStyle($event)\" class=\"form-control\" data-i18n-attr=\"Placeholder_TypeNewPassword|placeholder\" maxlength=\"64\" required password />\r\n                    <span class=\"icon_ form-control-feedback\"></span>\r\n\r\n                    <div class=\"text-danger field-validation-error\" ng-show=\"(userDetailsForm.password.$touched || userDetailsForm.$submitted)\" ng-messages=\"userDetailsForm.password.$error\">\r\n                        <span ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></span>\r\n                        <span ng-message=\"password\"><span data-i18n=\"Message_PasswordFormat\"></span></span>\r\n                    </div>\r\n                </div>\r\n\r\n                <tooltip class=\"input-group-addon no-horizontal-padding\" data-i18n-attr=\"Message_PasswordValidationCriteria|content\" placement=\"bottom\" />\r\n            </div>\r\n\r\n            <div class=\"input-group input-group-unstyled\">\r\n                <div class=\"form-group has-feedback\">\r\n                    <label for=\"confirmPassword\" data-i18n=\"Label_ConfirmPassword\" />\r\n                    <input name=\"confirmPassword\" type=\"text\" ng-model=\"confirmPassword\" ng-focus=\"$ctrl.turnOnPasswordStyle($event)\" class=\"form-control\" data-i18n-attr=\"Placeholder_TypeNewPasswordAgain|placeholder\" maxlength=\"64\" required same-as=\"userDetailsForm.password\" />\r\n                    <span class=\"icon_ form-control-feedback\"></span>\r\n                    <div class=\"text-danger field-validation-error\" ng-show=\"(userDetailsForm.confirmPassword.$touched || userDetailsForm.$submitted)\" ng-messages=\"userDetailsForm.confirmPassword.$error\">\r\n                        <span ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></span>\r\n                        <span ng-message=\"sameAs\"><span data-i18n=\"Message_PasswordsDoNotMatch\"></span></span>\r\n                    </div>\r\n                </div>\r\n\r\n                <tooltip class=\"input-group-addon no-horizontal-padding\" data-i18n-attr=\"Tooltip_ConfirmPassword|content\" placement=\"bottom\" />\r\n            </div>\r\n\r\n            <div class=\"form-group has-feedback input-padding\">\r\n                <label for=\"role\" data-i18n=\"Label_Role\" />\r\n                <div class=\"select-container\">\r\n                    <select id=\"contract\" ng-model=\"$ctrl.account.RoleName\" required name=\"roleName\"\r\n                            ng-change=\"$ctrl.isAdminRoleSelected()\"\r\n                            class=\"form-control\" ng-options=\'role.Name as role.Name for role in $ctrl.getRoles()\'>\r\n                    </select>\r\n                    <span class=\"icon_ form-control-feedback\"></span>\r\n                    <span class=\"glyphicon glyphicon-chevron-down dropdown_icon\"></span>\r\n                    <div class=\"text-danger field-validation-error\" ng-show=\"(userDetailsForm.roleName.$touched || userDetailsForm.$submitted)\" ng-messages=\"userDetailsForm.roleName.$error\">\r\n                        <span ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></span>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\"form-group has-feedback input-padding\">\r\n                <label for=\"customerNo\" data-i18n=\"Label_CustomerNumber\" />\r\n                <input name=\"customerNo\" type=\"text\"\r\n                       ng-model=\"$ctrl.account.EmpireId\"\r\n                       ng-model-options=\"{ debounce: { \'default\': 500, \'blur\': 0 } }\"\r\n                       ng-required=\"$ctrl.account.isAdminRoleSelected !== true\"\r\n                       class=\"form-control\" data-i18n-attr=\"Placeholder_CustomerNumber|placeholder\"\r\n                       customer-number=\"checkingCustomerNumber\"\r\n                       start-validation=\"checkingCustomerNumber\"\r\n                       maxlength=\"20\" />\r\n                <span class=\"icon_ form-control-feedback\"></span>\r\n                <div class=\"text-danger field-validation-error\" ng-show=\"(userDetailsForm.customerNo.$touched || userDetailsForm.$submitted)\" ng-messages=\"userDetailsForm.customerNo.$error\">\r\n                    <span ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></span>\r\n                    <span ng-message=\"checkingCustomerNumber\">\r\n                        <span data-i18n=\"Message_CheckingCustomerNumber\"></span>\r\n                    </span>\r\n                    <span ng-message=\"customerNumber\">\r\n                        <span data-i18n=\"Message_InvalidCustomerNumber\"></span>\r\n                    </span>\r\n                </div>\r\n            </div>\r\n            <div class=\"form-group\">\r\n                <button type=\"submit\" name=\"save\" class=\"btn btn-primary\" ng-disabled=\"!userDetailsForm.$dirty\"><span data-i18n=\"Button_Save\"></span><span class=\"glyphicon glyphicon-menu-right\"></span></button>\r\n                <button type=\"reset\" name=\"cancel\" class=\"btn btn-cancel pull-right\" ng-click=\"$ctrl.goBackToUserManagement()\"><span data-i18n=\"Button_Cancel\"></span></button>\r\n            </div>\r\n        </form>\r\n    </div>\r\n</div>");
$templateCache.put("/App/userManagement/usermanagement.html","<div data-viewname=\"UserManagement\" ng-cloak>\r\n  <div class=\"panel-group\" role=\"tablist\" aria-multiselectable=\"false\">\r\n    <div collapsible-panel id=\"filters\" class=\"panel-default\" data-i18n-attr=\"Panel_FilterTitle|heading\" expanded=\"true\">\r\n      <form novalidate name=\"searchForm\">\r\n        <div class=\"form-group\">\r\n\r\n          <div class=\"form-group\">\r\n            <input name=\"searchText\" data-i18n-attr=\"Placeholder_Search|placeholder\" class=\"form-control\" ng-model=\"$ctrl.searchModel.Text\" maxlength=\"256\" />\r\n          </div>\r\n          <div class=\"form-group\">\r\n\r\n            <div class=\"radio\">\r\n              <span data-i18n=\"Label_Search\"></span>\r\n              <label>\r\n                <input type=\"checkbox\" name=\"filter\" ng-model=\"$ctrl.searchModel.ShowUnconfirmed\"> <span data-i18n=\"Label_ShowUnconfirmedAccounts\"></span>\r\n              </label>\r\n              <label>\r\n                <input type=\"checkbox\" name=\"filter\" ng-model=\"$ctrl.searchModel.ShowBlocked\"> <span data-i18n=\"Label_AutomaticallyBlockedAccounts\"></span>\r\n              </label>\r\n              <label>\r\n                <input type=\"checkbox\" name=\"filter\" ng-model=\"$ctrl.searchModel.ShowManuallyBlocked\"> <span data-i18n=\"Label_ManuallyBlockedAccounts\"></span>\r\n              </label>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-group\">\r\n            <button class=\"btn btn-primary\" ng-click=\"$ctrl.search(searchForm)\"><span data-i18n=\"Button_Search\"></span></button>\r\n          </div>\r\n\r\n        </div>\r\n      </form>\r\n    </div>\r\n    <div collapsible-panel id=\"results\" class=\"panel-default\" data-i18n-attr=\"Panel_UsersTitle|heading|{{($ctrl.paging.currentPage - 1)*$ctrl.paging.count+1}}|{{($ctrl.paging.currentPage)*$ctrl.paging.count > $ctrl.paging.totalItems ? $ctrl.paging.totalItems :($ctrl.paging.currentPage)*$ctrl.paging.count }}|{{$ctrl.getTotalItems()}}\" expanded=\"true\">\r\n      <div ng-hide=\"$ctrl.accounts\">\r\n        <center>\r\n          <i class=\"fa fa-spinner fa-spin fa-2x fa-fw\"></i>\r\n        </center>\r\n      </div>\r\n      <div ng-show=\"$ctrl.accounts\">\r\n        <table class=\"table table-condensed table-responsive checkable-small col-xs-12\">\r\n          <thead>\r\n            <tr>\r\n              <th></th>\r\n              <th data-i18n=\"Column_CustomerNumber\"></th>\r\n              <th data-i18n=\"Column_Email\"></th>\r\n              <th data-i18n=\"Column_Username\"></th>\r\n              <th data-i18n=\"Column_AccountConfirmed\"></th>\r\n              <th data-i18n=\"Column_NotBlocked\"></th>\r\n            </tr>\r\n          </thead>\r\n          <tbody>\r\n            <tr ng-repeat=\"account in $ctrl.accounts\">\r\n              <td align=\"center\">\r\n                <input type=\"checkbox\" class=\"checkbox\"\r\n                       ng-model=\"account.selected\"\r\n                       ng-change=\"$ctrl.onCheckChange(account)\" stop-propagation />\r\n              </td>\r\n              <td>\r\n                {{account.EmpireId}}\r\n              </td>\r\n              <td style=\"-ms-word-break: break-all; word-break:break-all\">\r\n                {{account.EmailAddress }}\r\n              </td>\r\n              <td>\r\n                {{account.UserName}}\r\n              </td>\r\n              <td class=\"text-center\">\r\n                <span ng-class=\"{ \'icon_check_dark text-main\': account.IsConfirmed, \'icon_stop_dark text-danger\': !account.IsConfirmed,}\"></span>\r\n              </td>\r\n              <td class=\"text-center\">\r\n                <span ng-class=\"{ \'icon_stop_dark text-danger\': (account.IsManuallyBlocked || account.IsAutomaticallyBlocked), \'icon_check_dark text-main\': !(account.IsManuallyBlocked || account.IsAutomaticallyBlocked),}\"></span>\r\n              </td>\r\n            </tr>\r\n            <tr>\r\n              <td colspan=\"6\">\r\n                <div>\r\n\r\n                  <button class=\"btn btn-primary\" ng-click=\"$ctrl.newAccount()\" ng-show=\"$ctrl.rights.AddNewAccount\">\r\n                    <span data-i18n=\"Button_NewUser\"></span><span class=\"glyphicon glyphicon-chevron-right\"></span>\r\n                  </button>\r\n                  <button class=\"btn btn-primary\" ng-click=\"$ctrl.newKccAccount()\" ng-show=\"$ctrl.rights.AddNewKCCAccount\">\r\n                    <span data-i18n=\"Button_NewKccUser\"></span><span class=\"glyphicon glyphicon-chevron-right\"></span>\r\n                  </button>\r\n                  <button class=\"btn btn-primary\" ng-disabled=\"!$ctrl.gridSelection.selected\" ng-click=\"$ctrl.editAccount($ctrl.gridSelection)\" ng-show=\"$ctrl.rights.ReadAccountDetails\">\r\n                    <span data-i18n=\"Button_Edit\"></span><span class=\"glyphicon glyphicon-chevron-right\"></span>\r\n                  </button>\r\n                  <button class=\"btn btn-primary\" ng-show=\"$ctrl.gridSelection.IsAutomaticallyBlocked && $ctrl.rights.UnblockUser\" ng-click=\"$ctrl.activateAccount($ctrl.gridSelection)\">\r\n                    <span data-i18n=\"Button_Activate\"></span>\r\n                  </button>\r\n                  <p></p>\r\n                  <button class=\"btn btn-danger\" ng-disabled=\"!$ctrl.gridSelection.selected\" ng-click=\"$ctrl.removeAccount($ctrl.gridSelection)\" ng-show=\"$ctrl.rights.RemoveAccount\">\r\n                    <span data-i18n=\"Button_Delete\"></span>\r\n                  </button>\r\n                </div>\r\n              </td>\r\n            </tr>\r\n          </tbody>\r\n        </table>\r\n        <div uib-pagination\r\n             total-items=\"$ctrl.paging.totalItems\"\r\n             items-per-page=\"$ctrl.paging.count\"\r\n             ng-model=\"$ctrl.paging.currentPage\"\r\n             max-size=\"$ctrl.paging.maxSize\"\r\n             boundary-links=\"true\"\r\n             rotate=\"true\"\r\n             num-pages=\"numPages\"\r\n             first-text=\"{{$ctrl.paging.firstText}}\"\r\n             last-text=\"{{$ctrl.paging.lastText}}\"\r\n             next-text=\"{{$ctrl.paging.nextText}}\"\r\n             previous-text=\"{{$ctrl.paging.previousText}}\"\r\n             ng-change=\"$ctrl.search()\">\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div collapsible-panel id=\"sync\" class=\"panel-default\" data-i18n-attr=\"Panel_Account_Sync_Title|heading\" expanded=\"true\">\r\n      <div>\r\n        <div class=\"form-group\">\r\n          <label data-i18n=\"Last_Account_Sync_Date\" data-i18n-attr=\"Last_Account_Sync_Date_Tooltip|title\"></label>\r\n          <label>{{$ctrl.lastSyncDate | date:\'short\'}}</label>\r\n        </div>\r\n        <button class=\"btn  btn-primary\" ng-click=\"$ctrl.syncAccounts()\" data-i18n-attr=\"Button_Sync_Tooltip|title\">\r\n          <span data-i18n=\"Button_Sync\"></span>\r\n        </button>\r\n      </div>\r\n  </div></div>\r\n");
$templateCache.put("/App/core/alerting/confirm.html","<div class=\"modal-header\">\r\n    <h3 class=\"modal-title\">{{model.title}}</h3>\r\n</div>\r\n<div class=\"modal-body show-newlines\">\r\n    {{model.message}}\r\n</div>\r\n<div class=\"modal-footer\" data-viewname=\"Generic\">\r\n    <button id=\"btnYes\" class=\"btn btn-primary\" ng-class=\"{\'btn-vert-xs\': model.buttonsOnDifferentLinesXs}\" ng-click=\"$close(true)\">{{model.buttonYes}}</button>\r\n    <button id=\"btnNo\" class=\"btn btn-primary\" ng-class=\"{\'btn-vert-xs\': model.buttonsOnDifferentLinesXs}\" ng-click=\"$close(false)\">{{model.buttonNo}}</button>\r\n</div>");
$templateCache.put("/App/core/alerting/error.html","<div class=\"modal-header\">\r\n    <h3 class=\"modal-title\">{{model.title}}</h3>\r\n</div>\r\n<div class=\"modal-body show-newlines\">\r\n    {{model.message}}\r\n</div>\r\n<div class=\"modal-footer\" data-viewname=\"Generic\">\r\n    <button id=\"btnClose\" class=\"btn btn-primary\" ng-click=\"$close()\" data-i18n=\"Button_Close\"></button>\r\n</div>\r\n");
$templateCache.put("/App/core/alerting/info.html","<div class=\"modal-header\">\r\n    <h3 class=\"modal-title\">{{model.title}}</h3>\r\n</div>\r\n<div id=\"infoModal\" class=\"modal-body show-newlines\">\r\n    {{model.message}}\r\n</div>\r\n<div class=\"modal-footer\" data-viewname=\"Generic\">\r\n    <button id=\"btnClose\" class=\"btn btn-primary\" ng-click=\"$close()\" data-i18n=\"Button_Close\"></button>\r\n</div>\r\n");
$templateCache.put("/App/core/alerting/infoMarkdown.html","<div class=\"modal-header\">\r\n    <h3 class=\"modal-title\">{{model.title}}</h3>\r\n</div>\r\n<div id=\"infoModal\" class=\"modal-body\">\r\n    <p markdown=\"model.message\"></p>\r\n</div>\r\n<div class=\"modal-footer\" data-viewname=\"Generic\">\r\n    <button id=\"btnClose\" class=\"btn btn-primary\" ng-click=\"$close()\" data-i18n=\"Button_Close\"></button>\r\n</div>\r\n");
$templateCache.put("/App/myDetails/emailChangeDialog/emailChangeDialog.html","<div data-viewname=\"MyDetails\">\r\n    <form novalidate name=\"passwordForm\" ng-submit=\"$ctrl.submitForm(passwordForm)\">\r\n        <div class=\"modal-header\">\r\n            <h3 class=\"modal-title\" data-i18n=\"Title_EmailChangedPopup\"></h3>\r\n        </div>\r\n        <div class=\"modal-body\">\r\n            <p data-i18n=\"Message_EmailChangeRequiresPassword\"></p>\r\n            <p data-i18n=\"Message_EmailChangeActivationLink\"></p>\r\n\r\n            <div class=\"form-group has-feedback\">\r\n                <label for=\"password\" data-i18n=\"Text_Password\" />\r\n                <input name=\"password\" type=\"password\" ng-model=\"$ctrl.password\" class=\"form-control\" data-i18n-attr=\"Text_Password|placeholder\" maxlength=\"64\" required validate-hash\r\n                       ng-model-options=\"{ debounce: { \'default\': 500, \'blur\': 0 } }\" />\r\n                <span class=\"icon_ form-control-feedback\"></span>\r\n\r\n                <div class=\"text-danger field-validation-error\" ng-show=\"(passwordForm.password.$touched || passwordForm.$submitted)\" ng-messages=\"passwordForm.password.$error\">\r\n                    <span ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></span>\r\n                    <span ng-message=\"validateHash\"><span data-i18n=\"Message_IncorrectPassword\"></span></span>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"modal-footer\">\r\n            <div class=\"row\">\r\n                <div class=\"col-md-6\">\r\n                    <button id=\"btnEmailChangeDialogSend\" type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"passwordForm.$invalid || passwordForm.password.$pending\">\r\n                        <span data-i18n=\"Button_Send\"></span>\r\n                        <span class=\"glyphicon glyphicon-menu-right\"></span>\r\n                    </button>\r\n                </div>\r\n                <div id=\"btnEmailChangeDialogCancel\" class=\"col-md-6\">\r\n                    <button id=\"btnCancel\" class=\"btn btn-cancel pull-right-md\" ng-click=\"$dismiss(\'cancel\')\" data-i18n=\"Button_Cancel\"></button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</div>\r\n");
$templateCache.put("/App/newRepairment/wizardPages/appointmentPlanner.html","<form name=\"planDetailsForm\" id=\"planDetailsForm\" ng-submit=\"$ctrl.planMaintenanceRequest(planDetailsForm)\" novalidate>\r\n    <div panel id=\"appointmentPanel\" data-i18n-attr=\"Panel_Appointment_Planner|heading\" class=\"wizard-panel\">\r\n        <div ng-show=\"$ctrl.appointmentNeeded\">\r\n            <span ng-show=\"$ctrl.planningData.Periods.length > 0\" data-i18n=\"Label_SpecifyPreference\"></span>\r\n            <span ng-show=\"$ctrl.planningData.ConnectItProposals.length > 0\" data-i18n=\"Label_PlanAppointment\"></span>\r\n            <span ng-show=\"$ctrl.planningData.InspectionAppointments.length > 0\" data-i18n=\"Label_PlanInspection\"></span>\r\n\r\n            <div time-slot-controller min-date=\"$ctrl.minimumDate\" ng-hide=\"!$ctrl.appointmentNeeded\">\r\n                <div time-slot-planner time-slot-required\r\n                                    name=\"planningTimeSlot\"\r\n                                    initialize=\"$ctrl.minimumDate != null\"\r\n                                    ng-model=\"$ctrl.formContainer.selectedTimeSlot\"\r\n                                    time-slots=\"$ctrl.formContainer.TimeSlots\"\r\n                                    time-slot-loader=\"$ctrl.loadTimeSlots\"></div>\r\n            </div>\r\n            <div class=\"text-danger\" ng-messages=\"planDetailsForm.planningTimeSlot.$error\" ng-show=\"planDetailsForm.planningTimeSlot.$touched||planDetailsForm.$submitted\">\r\n                <div ng-message=\"required\"><span data-i18n=\"Validation_NoTimeslotSelected\"></span></div>\r\n            </div>\r\n        </div>\r\n\r\n        <div ng-hide=\"$ctrl.appointmentNeeded\">\r\n            <span data-i18n=\"Message_AppointmentNotNecessary\"></span>\r\n        </div>\r\n    </div>\r\n\r\n    <button ng-show=\"$ctrl.appointmentNeeded\" ng-disabled=\"$ctrl.planningSubmitting\" id=\"btnPlanMaintenanceRequest\" type=\"submit\" class=\"btn btn-primary pull-right\"><span data-i18n=\"Button_Save\"></span><span class=\"glyphicon glyphicon-menu-right\"></span></button>\r\n    <button ng-hide=\"$ctrl.appointmentNeeded\" id=\"btnClose\" type=\"button\" class=\"btn btn-primary pull-right\" ui-sref=\"repairments\"><span data-i18n=\"Button_Close\"></span><span class=\"glyphicon glyphicon-menu-right\"></span></button>\r\n</form>\r\n");
$templateCache.put("/App/newRepairment/wizardPages/contactDetails.html","<form name=\"contactInfoForm\" id=\"contactInfoForm\" novalidate>\r\n\r\n    <div panel id=\"contactInfoPanel\" data-i18n-attr=\"Panel_Contact_Details|heading\" class=\"wizard-panel\">\r\n        <label data-i18n=\"Label_Contact\"></label>\r\n\r\n        <div class=\"input-group input-group-unstyled\">\r\n\r\n            <div class=\"form-group has-feedback\">\r\n                <label for=\"inputPhone\" data-i18n=\"Input_Label_Phone\"></label>\r\n                <input type=\"tel\" phonenumber ng-required=\"true\" ng-model=\"$ctrl.formContainer.PhoneNo\" class=\"form-control\" name=\"inputPhone\" data-i18n-attr=\"Input_Placeholder_Phone|placeholder\">\r\n                <span class=\"icon_ form-control-feedback\"></span>\r\n\r\n                <div ng-messages=\"contactInfoForm.inputPhone.$error\" class=\"text-danger\"  ng-show=\"contactInfoForm.inputPhone.$dirty||contactInfoForm.$submitted\">\r\n                    <div ng-message=\"maxlength\"><span data-i18n=\"Message_MaxLength\" /></div>\r\n                    <div ng-message=\"$ctrl.formContainer.PhoneNo\"><span data-i18n=\"Message_InvalidPhoneNumber\" /></div>\r\n                    <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></div>\r\n                </div>\r\n            </div>\r\n\r\n            <tooltip class=\"input-group-addon no-horizontal-padding\" placement=\"bottom\" data-i18n-attr=\"Tooltip_PhoneNumber|content\" />\r\n        </div>\r\n\r\n        <div class=\"input-group input-group-unstyled\">\r\n            <div class=\"form-group has-feedback\">\r\n                <label for=\"inputMail\" data-i18n=\"Input_Label_Email\"></label>\r\n                <input type=\"email\" email ng-required=\"true\" ng-model=\"$ctrl.formContainer.Email\" class=\"form-control\" name=\"inputMail\" data-i18n-attr=\"Input_Placeholder_Email|placeholder\">\r\n                <span class=\"icon_ form-control-feedback\"></span>\r\n\r\n                <div ng-messages=\"contactInfoForm.inputMail.$error\" class=\"text-danger\"  ng-show=\"contactInfoForm.inputMail.$dirty||contactInfoForm.$submitted\">\r\n                    <div ng-message=\"maxlength\"><span data-i18n=\"Message_MaxLength\" /></div>\r\n                    <div ng-message=\"email\"><span data-i18n=\"Message_InvalidEmail\" /></div>\r\n                    <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></div>\r\n                </div>\r\n            </div>\r\n\r\n            <tooltip class=\"input-group-addon no-horizontal-padding\" placement=\"bottom\" data-i18n-attr=\"Tooltip_EmailAddress|content\" />\r\n        </div>\r\n    </div>\r\n\r\n    <button id=\"btnNextStep\" type=\"submit\" class=\"btn btn-primary pull-right\" ng-click=\"$ctrl.moveToRequestSubmission(contactInfoForm)\"><span data-i18n=\"Button_Next\"></span><span class=\"glyphicon glyphicon-menu-right\"></span></button>\r\n</form>\r\n\r\n");
$templateCache.put("/App/newRepairment/wizardPages/costConfirmation.html","<form name=\"costConfirmationForm\" novalidate>\r\n\r\n    <div panel id=\"objectPanel\" data-i18n-attr=\"Panel_Cost_Confirmation|heading\" class=\"wizard-panel\">\r\n        <label>{{$ctrl.formContainer.costsInfoMessage}}</label>\r\n        <div ng-if=\"$ctrl.formContainer.customerCharged\">\r\n            <label ng-bind-html=\"$ctrl.formContainer.customerChargedMessage\"></label>\r\n            <div class=\"form-group has-feedback\">\r\n                <input type=\"checkbox\" name=\"agreeCheckbox\" ng-required=\"true\" ng-model=\"$ctrl.formContainer.agreedCheck\" />\r\n                <label for=\"agreeCheckbox\" data-i18n=\"Label_CostsAgree\"></label>\r\n\r\n                <div ng-messages=\"costConfirmationForm.agreeCheckbox.$error\" class=\"text-danger\" ng-show=\"costConfirmationForm.agreeCheckbox.$dirty||costConfirmationForm.$submitted\">\r\n                    <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <button id=\"btnNextStep\" type=\"submit\" class=\"btn btn-primary pull-right\" ng-click=\"$ctrl.moveToDefectDescription(costConfirmationForm)\"><span data-i18n=\"Button_Next\"></span><span class=\"glyphicon glyphicon-menu-right\"></span></button>\r\n\r\n</form>\r\n\r\n");
$templateCache.put("/App/newRepairment/wizardPages/defectDescription.html","<form name=\"defectDescriptionForm\" novalidate>\r\n\r\n    <div panel id=\"requestSubmissionPanel\" data-i18n-attr=\"Panel_Defect_Description|heading\" class=\"wizard-panel\">\r\n\r\n        <repairment-photos-and-defect-description images=\"$ctrl.formContainer.Images\" defect-description=\"$ctrl.formContainer.DefectDescription\"\r\n                                                  description-required=\"$ctrl.descriptionRequired\"></repairment-photos-and-defect-description>\r\n    </div>\r\n\r\n    <button id=\"btnNextStep\" type=\"submit\" class=\"btn btn-primary pull-right\" ng-click=\"$ctrl.moveToContactDetails(defectDescriptionForm)\"><span data-i18n=\"Button_Next\"></span><span class=\"glyphicon glyphicon-menu-right\"></span></button>\r\n\r\n</form>\r\n");
$templateCache.put("/App/newRepairment/wizardPages/defectSelection.html","<form name=\"defectSelectionForm\" novalidate>\r\n\r\n    <div panel id=\"defectPanel\" data-i18n-attr=\"Panel_Defect_Selection|heading\" class=\"wizard-panel\">\r\n        <div class=\"input-group\" data-i18n=\"Label_SelectDefectInformation\"></div>\r\n\r\n        <div class=\"input-group input-group-unstyled\">\r\n            <div class=\"form-group\">\r\n                <label for=\"searchValue\" data-i18n=\"Input_Label_Search\"></label>\r\n                <input type=\"search\" ng-model=\"$ctrl.formContainer.searchValue\" class=\"form-control\" name=\"searchValue\" \r\n                       ng-model-options=\"{ debounce: 500 }\" data-i18n-attr=\"Input_Placeholder_Search|placeholder\" ng-change=\"$ctrl.doSearch();\">\r\n            </div>\r\n\r\n            <tooltip class=\"input-group-addon no-horizontal-padding\" placement=\"bottom\" data-i18n-attr=\"Tooltip_Search|content\" />\r\n        </div>\r\n\r\n        <div class=\"clearfix\">\r\n            <div class=\"col-sm-15 col-xs-12\">\r\n                <button type=\"button\" class=\"btn select-button\" ng-class=\"{\'select-active\' : !$ctrl.formContainer.selectedRoom, \'btn-primary\' : $ctrl.formContainer.selectedRoom}\" ng-click=\"$ctrl.toRoomTypeSelection(defectSelectionForm);\">\r\n                    <div class=\"visible-xs\">\r\n                        <div ng-show=\"!$ctrl.formContainer.selectedRoom\" data-i18n=\"Button_Mobile_Step_1\"></div>\r\n                        <div ng-show=\"$ctrl.formContainer.selectedRoom\">\r\n                            <div class=\"select-label\"><img ng-src=\"{{$ctrl.getImagePath($ctrl.formContainer.selectedRoom.PictureFileName)}}\" class=\"select-image\" />{{$ctrl.formContainer.selectedRoom.Description}}</div>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"hidden-xs\">\r\n                        <div class=\"select-number\">1</div>\r\n                        <div ng-show=\"!$ctrl.formContainer.selectedRoom\" class=\"select-step\" data-i18n=\"Button_Step_1\" data-i18n-html></div>\r\n                        <div ng-show=\"$ctrl.formContainer.selectedRoom\">\r\n                            <img ng-src=\"{{$ctrl.getImagePath($ctrl.formContainer.selectedRoom.PictureFileName)}}\" class=\"select-image\" />\r\n                            <div class=\"select-label\">{{$ctrl.formContainer.selectedRoom.Description}}</div>\r\n                        </div>\r\n                    </div>\r\n                </button>\r\n            </div>\r\n            <div class=\"col-sm-15 col-xs-12\">\r\n                <button type=\"button\" class=\"btn select-button\" ng-class=\"{\'select-active\' : $ctrl.formContainer.selectedRoom && !$ctrl.formContainer.selectedElement, \'btn-cancel\' : !$ctrl.formContainer.selectedRoom, \'btn-primary\' : $ctrl.formContainer.selectedRoom}\" ng-click=\"$ctrl.toElementSelection(defectSelectionForm);\" ng-disabled=\"!$ctrl.formContainer.selectedRoom\">\r\n                    <div class=\"visible-xs\">\r\n                        <div ng-show=\"!$ctrl.formContainer.selectedElement\" data-i18n=\"Button_Mobile_Step_2\"></div>\r\n                        <div ng-show=\"$ctrl.formContainer.selectedElement\">\r\n                            <div class=\"select-label\"><img ng-src=\"{{$ctrl.getImagePath($ctrl.formContainer.selectedElement.PictureFileName)}}\" class=\"select-image\" />{{$ctrl.formContainer.selectedElement.Description}}</div>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"hidden-xs\">\r\n                        <div class=\"select-number\">2</div>\r\n                        <div ng-show=\"!$ctrl.formContainer.selectedElement\" class=\"select-step\" data-i18n=\"Button_Step_2\" data-i18n-html></div>\r\n                        <div ng-show=\"$ctrl.formContainer.selectedElement\">\r\n                            <img ng-src=\"{{$ctrl.getImagePath($ctrl.formContainer.selectedElement.PictureFileName)}}\" class=\"select-image\" />\r\n                            <div class=\"select-label\">{{$ctrl.formContainer.selectedElement.Description}}</div>\r\n                        </div>\r\n                    </div>\r\n                </button>\r\n            </div>\r\n            <div class=\"col-sm-15 col-xs-12\">\r\n                <button type=\"button\" class=\"btn select-button\" ng-class=\"{\'select-active\' : $ctrl.formContainer.selectedElement && !$ctrl.formContainer.selectedPart, \'btn-cancel\' : !$ctrl.formContainer.selectedElement, \'btn-primary\' : $ctrl.formContainer.selectedElement}\" ng-click=\"$ctrl.toPartSelection(defectSelectionForm);\" ng-disabled=\"!$ctrl.formContainer.selectedElement\">\r\n                    <div class=\"visible-xs\">\r\n                        <div ng-show=\"!$ctrl.formContainer.selectedPart\" data-i18n=\"Button_Mobile_Step_3\"></div>\r\n                        <div ng-show=\"$ctrl.formContainer.selectedPart\">\r\n                            <div class=\"select-label\"><img ng-src=\"{{$ctrl.getImagePath($ctrl.formContainer.selectedPart.PictureFileName)}}\" class=\"select-image\" />{{$ctrl.formContainer.selectedPart.Description}}</div>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"hidden-xs\">\r\n                        <div class=\"select-number\">3</div>\r\n                        <div ng-show=\"!$ctrl.formContainer.selectedPart\" class=\"select-step\" data-i18n=\"Button_Step_3\" data-i18n-html></div>\r\n                        <div ng-show=\"$ctrl.formContainer.selectedPart\">\r\n                            <img ng-src=\"{{$ctrl.getImagePath($ctrl.formContainer.selectedPart.PictureFileName)}}\" class=\"select-image\" />\r\n                            <div class=\"select-label\">{{$ctrl.formContainer.selectedPart.Description}}</div>\r\n                        </div>\r\n                    </div>\r\n                </button>\r\n            </div>\r\n            <div class=\"col-sm-15 col-xs-12\">\r\n                <button type=\"button\" class=\"btn select-button\" ng-class=\"{\'select-active\' : $ctrl.formContainer.selectedPart && !$ctrl.formContainer.selectedDefect, \'btn-cancel\' : !$ctrl.formContainer.selectedPart, \'btn-primary\' : $ctrl.formContainer.selectedPart}\" ng-click=\"$ctrl.toDefectSelection(defectSelectionForm);\" ng-disabled=\"!$ctrl.formContainer.selectedPart\">\r\n                    <div class=\"visible-xs\">\r\n                        <div ng-show=\"!$ctrl.formContainer.selectedDefect\" data-i18n=\"Button_Mobile_Step_4\"></div>\r\n                        <div ng-show=\"$ctrl.formContainer.selectedDefect\">\r\n                            <div class=\"select-label\"><img ng-src=\"{{$ctrl.getImagePath($ctrl.formContainer.selectedDefect.PictureFileName)}}\" class=\"select-image\" />{{$ctrl.formContainer.selectedDefect.Description}}</div>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"hidden-xs\">\r\n                        <div class=\"select-number\">4</div>\r\n                        <div ng-show=\"!$ctrl.formContainer.selectedDefect\" class=\"select-step\" data-i18n=\"Button_Step_4\" data-i18n-html></div>\r\n                        <div ng-show=\"$ctrl.formContainer.selectedDefect\">\r\n                            <img ng-src=\"{{$ctrl.getImagePath($ctrl.formContainer.selectedDefect.PictureFileName)}}\" class=\"select-image\" />\r\n                            <div class=\"select-label\">{{$ctrl.formContainer.selectedDefect.Description}}</div>\r\n                        </div>\r\n                    </div>\r\n                </button>\r\n            </div>\r\n            <div class=\"col-sm-15 col-xs-12\">\r\n                <button type=\"button\" class=\"btn select-button\" ng-class=\"{\'select-active\' : $ctrl.formContainer.selectedDefect, \'btn-cancel\' : !$ctrl.formContainer.selectedDefect, \'btn-primary\' : $ctrl.formContainer.selectedDefect}\" ng-click=\"$ctrl.resetStates();\" ng-disabled=\"!$ctrl.formContainer.selectedDefect\">\r\n                    <div class=\"visible-xs\" data-i18n=\"Button_Mobile_Step_5\"></div>\r\n                    <div class=\"hidden-xs\">\r\n                        <div class=\"select-number\">5</div>\r\n                        <div  class=\"select-step\" data-i18n=\"Button_Step_5\" data-i18n-html></div>\r\n                    </div>\r\n                </button>\r\n            </div>\r\n        </div>\r\n        <div panel uib-collapse=\"$ctrl.formContainer.selectedRoom\" class=\"wizard-panel\">\r\n            <div class=\"col-md-3 col-sm-3 col-xs-6 wizard-button\" ng-repeat=\"option in $ctrl.formContainer.rooms | orderBy: \'Description\'\">\r\n                <button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.selectRoom(option)\">\r\n                    <img ng-src=\"{{$ctrl.getImagePath(option.PictureFileName)}}\" class=\"wizard-image\" />\r\n                    <div class=\"wizard-label\">{{option.Description}}</div>\r\n                </button>\r\n            </div>\r\n        </div>\r\n        <div panel uib-collapse=\"!$ctrl.formContainer.selectedRoom || $ctrl.formContainer.selectedElement\" class=\"wizard-panel\">\r\n            <div class=\"col-md-3 col-sm-3 col-xs-6 wizard-button\" ng-repeat=\"option in $ctrl.formContainer.elements | orderBy: \'Description\'\">\r\n                <button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.selectElement(option)\">\r\n                    <img ng-src=\"{{$ctrl.getImagePath(option.PictureFileName)}}\" class=\"wizard-image\" />\r\n                    <div class=\"wizard-label\">{{option.Description}}</div>\r\n                </button>\r\n            </div>\r\n        </div>\r\n        <div panel uib-collapse=\"!$ctrl.formContainer.selectedElement || $ctrl.formContainer.selectedPart\" class=\"wizard-panel\">\r\n            <div class=\"col-md-3 col-sm-3 col-xs-6 wizard-button\" ng-repeat=\"option in $ctrl.formContainer.parts | orderBy: \'Description\'\">\r\n                <button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.selectPart(option)\">\r\n                    <img ng-src=\"{{$ctrl.getImagePath(option.PictureFileName)}}\" class=\"wizard-image\" />\r\n                    <div class=\"wizard-label\">{{option.Description}}</div>\r\n                </button>\r\n            </div>\r\n        </div>\r\n        <div panel uib-collapse=\"!$ctrl.formContainer.selectedPart || $ctrl.formContainer.selectedDefect\" class=\"wizard-panel\">\r\n            <div class=\"col-md-3 col-sm-3 col-xs-6 wizard-button\" ng-repeat=\"option in $ctrl.formContainer.defects | orderBy: \'Description\'\">\r\n                <button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.selectDefect(option, null, defectSelectionForm)\">\r\n                    <img ng-src=\"{{$ctrl.getImagePath(option.PictureFileName)}}\" class=\"wizard-image\" />\r\n                    <div class=\"wizard-label\">{{option.Description}}</div>\r\n                </button>\r\n            </div>\r\n        </div>\r\n\r\n        <div panel uib-collapse=\"!$ctrl.formContainer.selectedDefect\" class=\"wizard-panel clearfix\">\r\n\r\n            <div class=\"input-group input-group-unstyled\" ng-hide=\"$ctrl.formContainer.specifications.length == 1 && !$ctrl.formContainer.specifications[0].Specification\">\r\n                <div class=\"form-group has-feedback\">\r\n                    <label class=\"control-label\" data-i18n=\"Input_Label_Specification\"></label>\r\n                    <div class=\"select-container\">\r\n                        <select name=\"specification\" ng-required=\"true\" ng-options=\"option as option.Specification for option in $ctrl.formContainer.specifications\" ng-model=\"$ctrl.formContainer.selectedSpecification\" class=\"form-control\" ng-change=\"$ctrl.selectSpecification()\"></select>\r\n                        <span class=\"glyphicon glyphicon-chevron-down dropdown_icon\"></span>\r\n                    </div>\r\n\r\n                    <div ng-messages=\"defectSelectionForm.specification.$error\" class=\"text-danger\" ng-show=\"defectSelectionForm.specification.$dirty||defectSelectionForm.$submitted\">\r\n                        <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></div>\r\n                    </div>\r\n                </div>\r\n\r\n                <tooltip class=\"input-group-addon\" data-i18n-attr=\"Tooltip_Specification|content\" placement=\"bottom\" />\r\n            </div>\r\n\r\n            <div class=\"label-group\" ng-show=\"$ctrl.formContainer.selectedSpecification && $ctrl.formContainer.selectedSpecification.RepairTemplateCode == \'\' && $ctrl.formContainer.selectedSpecification.ActionCode != \'\'\">\r\n                <span>{{$ctrl.formContainer.selectedSpecification.MaintenanceMessage}}</span>\r\n            </div>\r\n\r\n\r\n            <div class=\"label-group\" ng-show=\"$ctrl.formContainer.repairTemplate\">\r\n                <label data-i18n=\"Label_Repair_Template_Description\"></label>\r\n                <div class=\"labelValue\">{{$ctrl.formContainer.repairTemplate.ExternalDescription}}</div>\r\n            </div>\r\n\r\n            <div class=\"label-group\" ng-show=\"$ctrl.formContainer.repairTemplate.SolutionTips.length >= 1\">\r\n                <table class=\"table table-condensed table-responsive\">\r\n                    <thead>\r\n                        <tr>\r\n                            <th data-i18n=\"Column_SolutionTip\"></th>\r\n                        </tr>\r\n                    </thead>\r\n\r\n                    <tr data-toggle=\"collapse\" data-target=\"#solutiontip_{{$index}}\" aria-expanded=\"false\" class=\"accordion-toggle collapsed\" ng-repeat-start=\"item in $ctrl.formContainer.repairTemplate.SolutionTips\">\r\n                        <td>\r\n                            <span>{{item.Title}}</span>\r\n                        </td>\r\n                    </tr>\r\n                    <tr ng-repeat-end>\r\n                        <td class=\"table-hidden-row\">\r\n                            <div class=\"collapse\" id=\"solutiontip_{{$index}}\">\r\n                                <div class=\"accordion-body\"><p markdown=\"item.Text\"></p></div>\r\n                            </div>\r\n                        </td>\r\n                    </tr>\r\n                </table>\r\n            </div>\r\n\r\n            <div class=\"form-group\" ng-show=\"$ctrl.formContainer.repairTemplate.SolutionTips.length >= 1\">\r\n                <label class=\"control-label\" data-i18n=\"Label_SolutionTips_Solve_Issue\"></label>\r\n                <div class=\"radio\">\r\n                    <label>\r\n                        <input type=\"radio\" name=\"solutionTipsSolveIssue\" ng-model=\"$ctrl.formContainer.solutionTipsSolveIssue\" value=\"true\" ng-required=\"true\" focus-on=\"focusAddPerson\"> <span data-i18n=\"Button_Yes\"></span>\r\n                    </label>\r\n                    <label>\r\n                        <input type=\"radio\" name=\"solutionTipsSolveIssue\" ng-model=\"$ctrl.formContainer.solutionTipsSolveIssue\" value=\"false\" ng-required=\"true\"> <span data-i18n=\"Button_No\"></span>\r\n                    </label>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"label-group\" ng-show=\"$ctrl.formContainer.solutionTipsSolveIssue == \'true\'\">\r\n                <span data-i18n=\"Label_Solution_Tips_Solve_Issue_Information\" />\r\n            </div>\r\n\r\n            <div class=\"input-group input-group-unstyled\" ng-show=\"$ctrl.formContainer.solutionTipsSolveIssue == \'true\'\">\r\n                <div class=\"form-group has-feedback\">\r\n                    <label class=\"control-label\" data-i18n=\"Input_Label_Solution_Tip\"></label>\r\n                    <div class=\"select-container\">\r\n                        <select name=\"solutionTip\" ng-options=\"item as item.Title for item in $ctrl.formContainer.repairTemplate.SolutionTips\" \r\n                                ng-model=\"$ctrl.formContainer.selectedSolutionTip\" class=\"form-control\"\r\n                                ng-required=\"$ctrl.formContainer.solutionTipsSolveIssue == \'true\'\"></select>\r\n                        <span class=\"glyphicon glyphicon-chevron-down dropdown_icon\"></span>\r\n                    </div>\r\n\r\n                    <div ng-messages=\"defectSelectionForm.solutionTip.$error\" class=\"text-danger\" ng-show=\"defectSelectionForm.solutionTip.$dirty||defectSelectionForm.$submitted\">\r\n                        <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></div>\r\n                    </div>\r\n                </div>\r\n\r\n                <tooltip class=\"input-group-addon\" data-i18n-attr=\"Tooltip_SolutionTip|content\" placement=\"bottom\" />\r\n            </div>\r\n\r\n            <div class=\"input-group input-group-unstyled\" ng-show=\"$ctrl.causeSelectionRequired()\">\r\n                <div class=\"form-group has-feedback\">\r\n                    <label class=\"control-label\" data-i18n=\"Input_Label_Cause\"></label>\r\n                    <div class=\"select-container\">\r\n                        <select name=\"cause\" ng-options=\"option as option.Description for option in $ctrl.formContainer.causes\" \r\n                                ng-model=\"$ctrl.formContainer.selectedCause\" class=\"form-control\"\r\n                                ng-required=\"$ctrl.causeSelectionRequired()\"></select>\r\n                        <span class=\"glyphicon glyphicon-chevron-down dropdown_icon\"></span>\r\n                    </div>\r\n\r\n                    <div ng-messages=\"defectSelectionForm.cause.$error\" class=\"text-danger\" ng-show=\"defectSelectionForm.cause.$dirty||defectSelectionForm.$submitted\">\r\n                        <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></div>\r\n                    </div>\r\n                </div>\r\n\r\n                <tooltip class=\"input-group-addon\" data-i18n-attr=\"Tooltip_Cause|content\" placement=\"bottom\" />\r\n            </div>\r\n        </div>\r\n        \r\n        <div class=\"text-danger\" ng-show=\"defectSelectionForm.$submitted && !$ctrl.formContainer.selectedDefect\">\r\n            <span data-i18n=\"Label_NoDefectSelected\"></span>\r\n        </div>\r\n    </div>\r\n\r\n    <button id=\"btnNextStep\" type=\"submit\" class=\"btn btn-primary pull-right\" ng-click=\"$ctrl.moveToCostConfirmation(defectSelectionForm)\" ng-show=\"$ctrl.canCreateMaintenanceRequest()\"><span data-i18n=\"Button_Next\"></span><span class=\"glyphicon glyphicon-menu-right\"></span></button>\r\n    <button id=\"btnReportDefectSolved\" type=\"submit\" class=\"btn btn-primary pull-right\" ng-click=\"$ctrl.reportDefectSolved(defectSelectionForm)\" ng-show=\"$ctrl.formContainer.solutionTipsSolveIssue == \'true\'\"><span data-i18n=\"Button_ReportDefectSolved\"></span><span class=\"glyphicon glyphicon-menu-right\"></span></button>\r\n\r\n</form>");
$templateCache.put("/App/newRepairment/wizardPages/objectSelection.html","<form name=\"objectSelectionForm\" novalidate>\r\n    <div panel id=\"objectPanel\" data-i18n-attr=\"Panel_Object_Selection|heading\" class=\"wizard-panel\">\r\n        <div class=\"input-group\" data-i18n=\"Label_ObjectSelectionInformation\"></div>\r\n        <div class=\"input-group input-group-unstyled\">\r\n            <div class=\"form-group has-feedback\">\r\n                <label class=\"control-label\" data-i18n=\"Input_Label_Contract\"></label>\r\n                <div class=\"select-container\">\r\n                    <select name=\"contract\" ng-required=\"true\" ng-model=\"$ctrl.formContainer.selectedContract\" ng-change=\"$ctrl.selectContract(objectSelectionForm)\"\r\n                            class=\"form-control\" ng-options=\'contract as $ctrl.contractOption(contract) for contract in $ctrl.customerDetails.ActiveContracts | notAfterToday:\"StartDate\"\'>\r\n                        <option value=\'\' disabled selected style=\'display:none;\' data-i18n-attr=\"Input_Placeholder_Contract|placeholder\"></option>\r\n                    </select>\r\n                    <span class=\"glyphicon glyphicon-chevron-down dropdown_icon\"></span>\r\n                </div>\r\n\r\n                <div ng-messages=\"objectSelectionForm.contract.$error\" class=\"text-danger\" ng-show=\"objectSelectionForm.contract.$dirty||objectSelectionForm.$submitted\">\r\n                    <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></div>\r\n                </div>\r\n            </div>\r\n\r\n            <tooltip class=\"input-group-addon\" data-i18n-attr=\"Tooltip_Contract|content\" placement=\"bottom\" />\r\n        </div>\r\n\r\n        <div class=\"input-group input-group-unstyled\" ng-show=\"$ctrl.formContainer.selectedContract.RentalUnit.CommonAreas.length > 0\">\r\n            <div class=\"form-group has-feedback\">\r\n                <label class=\"control-label\" data-i18n=\"Input_Label_Where\"></label>\r\n                <br />\r\n                <div class=\"row\">\r\n                    <div class=\"col-xs-12 col-sm-6\">\r\n                        <label class=\"radio-inline\">\r\n                            <input type=\"radio\" name=\"inlineRadioOptions\" value=\"0\" ng-required=\"$ctrl.formContainer.selectedContract.RentalUnit.CommonAreas.length > 0\" \r\n                                   ng-model=\"$ctrl.formContainer.selectedObject\" ng-change=\"$ctrl.changeSelectedObject(objectSelectionForm);\"><strong data-i18n=\"Radio_Where_Own\"></strong>\r\n                        </label>\r\n                    </div>\r\n                    <div class=\"col-xs-12 col-sm-6\">\r\n                        <label class=\"radio-inline\">\r\n                            <input type=\"radio\" name=\"inlineRadioOptions\" value=\"1\" ng-required=\"$ctrl.formContainer.selectedContract.RentalUnit.CommonAreas.length > 0\" \r\n                                   ng-model=\"$ctrl.formContainer.selectedObject\" ng-change=\"$ctrl.changeSelectedObject(objectSelectionForm);\"><strong data-i18n=\"Radio_Where_Common\"></strong>\r\n                        </label>\r\n                    </div>\r\n                </div>\r\n\r\n                <div ng-messages=\"objectSelectionForm.inlineRadioOptions.$error\" class=\"text-danger\" ng-show=\"objectSelectionForm.inlineRadioOptions.$dirty||objectSelectionForm.$submitted\">\r\n                    <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></div>\r\n                </div>\r\n            </div>\r\n\r\n            <tooltip class=\"input-group-addon\" data-i18n-attr=\"Tooltip_Where|content\" placement=\"bottom\" />\r\n        </div>\r\n\r\n        <div class=\"input-group input-group-unstyled\" ng-show=\"$ctrl.formContainer.selectedObject == 1\">\r\n            <div class=\"form-group has-feedback\">\r\n                <label class=\"control-label\" data-i18n=\"Input_Label_Where_Common\"></label>\r\n                <div class=\"select-container\">\r\n                    <select name=\"commonArea\" ng-required=\"$ctrl.formContainer.selectedObject == 1\" \r\n                            ng-model=\"$ctrl.formContainer.selectedCommonArea\" ng-change=\"$ctrl.selectCommonArea()\"\r\n                            class=\"form-control\" ng-options=\'area as area.CommonAreaDescription for area in $ctrl.formContainer.selectedContract.RentalUnit.CommonAreas | filter: $ctrl.filterCommonArea()\'>\r\n                        <option value=\'\' disabled selected style=\'display:none;\' data-i18n-attr=\"Input_Placeholder_Where_Common|placeholder\"></option>\r\n                    </select>\r\n                    <span class=\"glyphicon glyphicon-chevron-down dropdown_icon\"></span>\r\n                </div>\r\n\r\n                <div ng-messages=\"objectSelectionForm.commonArea.$error\" class=\"text-danger\" ng-show=\"objectSelectionForm.commonArea.$dirty||objectSelectionForm.$submitted\">\r\n                    <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></div>\r\n                </div>\r\n            </div>\r\n\r\n            <tooltip class=\"input-group-addon\" data-i18n-attr=\"Tooltip_Where_Common|content\" placement=\"bottom\" />\r\n        </div>\r\n\r\n        <div class=\"input-group input-group-unstyled\" ng-show=\"$ctrl.formContainer.selectedObject == 1 && $ctrl.formContainer.showCommonAreaFilter === true\">\r\n            <div class=\"form-group has-feedback\">\r\n                <input type=\"checkbox\" name=\"showAllCommonAreas\" ng-model=\"$ctrl.formContainer.showAllCommonAreas\" />\r\n                <label for=\"agreeCheckbox\" data-i18n=\"Input_Label_showAllCommonAreas\"></label>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <button id=\"btnNextStep\" type=\"submit\" class=\"btn btn-primary pull-right\" ng-click=\"$ctrl.moveToDefectSelection(objectSelectionForm)\"><span data-i18n=\"Button_Next\"></span><span class=\"glyphicon glyphicon-menu-right\"></span></button>\r\n\r\n</form>\r\n\r\n");
$templateCache.put("/App/newRepairment/wizardPages/requestSubmission.html","<div panel id=\"requestSubmissionPanel\" data-i18n-attr=\"Panel_Request_Submission|heading\" class=\"wizard-panel\">\r\n    <label data-i18n=\"Panel_Request_Submission_Description\"></label>\r\n    <div class=\"label-group\">\r\n        <label data-i18n=\"Label_Object\"></label>\r\n        <div class=\"labelValue\">{{$ctrl.formContainer.selectedContract.Address}}</div>\r\n        <div class=\"labelValue\" ng-show=\"$ctrl.formContainer.selectedCommonArea.CommonAreaDescription\">{{$ctrl.formContainer.selectedCommonArea.CommonAreaDescription}}</div>\r\n    </div>\r\n\r\n    <div class=\"label-group\">\r\n        <label data-i18n=\"Label_Defect\"></label>\r\n        <div class=\"labelValue\"><span data-i18n=\"Label_Room\"></span>: {{$ctrl.formContainer.selectedRoom.Description}}</div>\r\n        <div class=\"labelValue\"><span data-i18n=\"Label_ConstructionPart\"></span>: {{$ctrl.formContainer.selectedElement.Description}}</div>\r\n        <div class=\"labelValue\"><span data-i18n=\"Label_Part\"></span>: {{$ctrl.formContainer.selectedPart.Description}}</div>\r\n        <div class=\"labelValue\"><span data-i18n=\"Label_Issue\"></span>: {{$ctrl.formContainer.selectedDefect.Description}}</div>\r\n        <div class=\"labelValue\"><span data-i18n=\"Label_Specification\"></span>: {{$ctrl.formContainer.selectedSpecification.Specification}}</div>\r\n    </div>\r\n\r\n    <div class=\"label-group\" ng-show=\"$ctrl.formContainer.selectedCause\">\r\n        <label data-i18n=\"Label_Cause\"></label>\r\n        <div class=\"labelValue\">{{$ctrl.formContainer.selectedCause.Description}}</div>\r\n    </div>\r\n\r\n    <div class=\"label-group\">\r\n        <label data-i18n=\"Label_RequestDescription\"></label>\r\n        <div class=\"labelValue\">{{$ctrl.formContainer.repairTemplate.ExternalDescription}}</div>\r\n    </div>\r\n\r\n    <div class=\"label-group\">\r\n        <div key-values=\"$ctrl.imageItems\"></div>\r\n    </div>\r\n\r\n    <div class=\"label-group\" ng-show=\"$ctrl.formContainer.defectDescription\">\r\n        <label data-i18n=\"Label_AdditionalDescription\"></label>\r\n        <div class=\"labelValue labelValueBreakWord\" ng-bind-html=\"$ctrl.formContainer.defectDescription\"></div>\r\n    </div>\r\n\r\n    <div class=\"label-group\" ng-show=\"$ctrl.formContainer.customerChargedMessage || $ctrl.formContainer.customerChargedAmount\">\r\n        <label data-i18n=\"Label_Costs\"></label>\r\n        <div class=\"labelValue\" ng-bind-html=\"$ctrl.formContainer.customerChargedMessage\"></div>\r\n    </div>\r\n\r\n    <div class=\"label-group\">\r\n        <label data-i18n=\"Label_Contact_Details\"></label>\r\n        <div class=\"labelValue\">{{$ctrl.formContainer.PhoneNo}}</div>\r\n        <div class=\"labelValue\">{{$ctrl.formContainer.Email}}</div>\r\n    </div>\r\n</div>\r\n\r\n<button type=\"button\" class=\"btn btn-primary pull-right\" ng-disabled=\"requestSubmitting\" ng-click=\"$ctrl.saveRepairment()\" >\r\n    <span data-i18n=\"Button_Save\" ng-hide=\"$ctrl.formContainer.selectedSpecification.AppointmentNeeded\"></span>\r\n    <span data-i18n=\"Button_SaveAndPlan\" ng-show=\"$ctrl.formContainer.selectedSpecification.AppointmentNeeded\">\r\n    </span><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span>\r\n</button>");
$templateCache.put("/App/resourcesManagement/details/resourceDetails.html","<div data-viewname=\"ResourcesManagement\">\r\n    <div panel id=\"resourceDetails\" class=\"panel-default\" data-i18n-attr=\"Panel_EditResource|heading\">\r\n        <form name=\"resourceDetailsForm\" novalidate ng-submit=\"$ctrl.save(resourceDetailsForm)\">\r\n\r\n            <div class=\"form-group\">\r\n                <label for=\"viewName\">{{$ctrl.viewNameLabel}}</label>\r\n                <input name=\"viewName\" type=\"text\" ng-model=\"$ctrl.resource.ViewName\" class=\"form-control\" required readonly />\r\n            </div>\r\n\r\n            <div class=\"form-group\">\r\n                <label for=\"resourceName\">{{$ctrl.resourceNameLabel}}</label>\r\n                <input name=\"resourceName\" type=\"text\" ng-model=\"$ctrl.resource.ResourceName\" class=\"form-control\" required readonly />\r\n            </div>\r\n\r\n            <div class=\"form-group has-feedback\">\r\n                <label for=\"resourceValue\">{{$ctrl.resourceValueLabel}}</label>\r\n                <textarea name=\"resourceValue\" ng-model=\"$ctrl.resource.ResourceValue\" class=\"form-control\" maxlength=\"512\" rows=\"3\" required></textarea>\r\n                <span class=\"icon_ form-control-feedback\"></span>\r\n\r\n                <div class=\"text-danger field-validation-error\" ng-messages=\"resourceDetailsForm.resourceValue.$error\">\r\n                    <span ng-if=\"resourceDetailsForm.resourceValue.$touched||resourceDetailsForm.$submitted\" ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></span>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\">\r\n                <button type=\"submit\" name=\"save\" ng-disabled=\"resourceDetailsForm.$invalid || !resourceDetailsForm.$dirty\" class=\"btn btn-primary\">\r\n                    <span data-i18n=\"Button_Save_And_Close\"></span>\r\n                </button>\r\n                <button name=\"cancel\" class=\"btn btn-cancel pull-right\" ng-click=\"$ctrl.goBackToResourcesManagement()\">\r\n                    <span data-i18n=\"Button_Cancel\"></span>\r\n                </button>\r\n            </div>\r\n\r\n        </form>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("/App/styleManagement/compileConfirmation/compileConfirmation.html","<div data-viewname=\"StyleManagement\" ng-cloak>\r\n    <div class=\"modal-header\">\r\n        <h3 class=\"modal-title\" data-i18n=\"Text_Confirmation_Title\"></h3>\r\n    </div>\r\n    <div class=\"modal-body\" data-i18n=\"Text_Confirmation_Body\">\r\n    </div>\r\n    <div class=\"modal-footer\">\r\n        <button id=\"compile\" class=\"btn btn-primary\" ng-click=\"$close(\'compile\')\">\r\n            <span data-i18n=\"Button_Compile\"></span>\r\n        </button>\r\n        <button id=\"saveAndCompile\" class=\"btn btn-primary\" ng-click=\"$close(\'saveCompile\')\">\r\n            <span data-i18n=\"Button_Save_And_Compile\"></span>\r\n        </button>\r\n        <button id=\"cancel\" class=\"btn btn-cancel pull-right\" ng-click=\"$close(\'close\')\">\r\n            <span data-i18n=\"Button_Cancel\"></span>\r\n        </button>\r\n    </div>\r\n</div>\r\n\r\n");
$templateCache.put("/App/userManagement/blockUserDialog/blockUserDialog.html","<div data-viewname=\"UserManagement\" ng-cloak>\r\n    <div class=\"modal-header\">\r\n        <h3 class=\"modal-title\" data-i18n=\"Title_BlockUser_Dialog\"></h3>\r\n    </div>\r\n    <div class=\"modal-body\">\r\n        <label for=\"blockReason\" data-i18n=\"Label_BlockReason\"></label>\r\n        <textarea rows=\"4\" name=\"blockReason\" id=\"blockReason\" class=\"form-control\" ng-model=\"$ctrl.blockReason\" data-i18n-attr=\"Placeholder_BlockAccount_Reason|placeholder\" maxlength=\"1000\"></textarea>\r\n        <label data-i18n=\"Label_RemaningChararters|{{getLeftCharacters()}}\"></label>\r\n    </div>\r\n    <div class=\"modal-footer\">\r\n        <button id=\"compile\" class=\"btn btn-primary\" ng-click=\"block()\" ng-disabled=\"$ctrl.blockReason.length===0\">\r\n            <span data-i18n=\"Button_Block\"></span>\r\n        </button>\r\n        <button id=\"cancel\" class=\"btn btn-cancel pull-right\" ng-click=\"cancel()\">\r\n            <span data-i18n=\"Button_Cancel\"></span>\r\n        </button>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("/App/core/directives/collapsiblePanel/collapsiblePanel.html","<div class=\"panel panel-default\" role=\"tablist\">\r\n    <div class=\"panel-heading\" id=\"{{panelId}}Heading\">\r\n        <h4 class=\"panel-title\">\r\n            <a class=\"{{collapsedClass}}\" role=\"button\" data-toggle=\"collapse\" href=\"#collapse{{panelId}}\" ng-click=\"headerClick($event);\">{{panelTitle}}</a>\r\n        </h4>\r\n    </div>\r\n\r\n    <div id=\"collapse{{panelId}}\" class=\"panel-collapse collapse {{bodyClass}}\" aria-labelledby=\"{{panelId}}Heading\">\r\n        <div class=\"panel-body\" ng-transclude>\r\n\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n");
$templateCache.put("/App/core/directives/fileDownload/fileDownload.html","<div class=\"modal-header\">\r\n    <h3 class=\"modal-title\">{{model.title}}</h3>\r\n</div>\r\n<div class=\"modal-body\" >\r\n    {{model.message}}\r\n    <br />\r\n    <button class=\"btn btn-link\" role=\"link\" ng-click=\"model.download()\">\r\n        <span data-i18n=\"Hyperlink_ClickHereToDownload\"></span>\r\n    </button>\r\n</div>\r\n\r\n<div class=\"modal-footer\">\r\n    <button id=\"btnClose\" class=\"btn btn-primary\" ng-click=\"$close()\" data-i18n=\"Button_Close\"></button>\r\n</div>");
$templateCache.put("/App/core/directives/filePicker/filePicker.html","<div class=\"input-group\" data-viewname=\"Generic\">\r\n    <input type=\"text\" class=\"form-control file-picker\" readonly>\r\n    <span class=\"input-group-btn\">\r\n        <span class=\"btn btn-primary btn-file file-picker\">\r\n            <input type=\"file\" multiple=\"multiple\" [accept]=\"fileType\"> <span data-i18n=\"Button_Browse\"></span>\r\n        </span>\r\n    </span>\r\n</div>");
$templateCache.put("/App/core/directives/filePicker/filePickerButton.html","<button type=\"button\" ng-disabled=\"isDisabled\" ng-class=\"btnClass\" ng-click=\"onClick()\">\r\n  <span>{{btnTitle}}</span><span ng-class=\"btnIcon\" aria-hidden=\"true\"></span>\r\n</button>");
$templateCache.put("/App/core/directives/filePicker/filePickerModal.html","<div data-viewname=\"Generic\">\r\n  <div class=\"modal-header\">\r\n    <h3 class=\"modal-title\">{{$ctrl.title}}</h3>\r\n  </div>\r\n  <div class=\"modal-body\">\r\n    <div class=\"file-picker-modal-text\">{{$ctrl.infoText}}</div>\r\n    <file-picker file-model=\"$ctrl.file\" max-size=\"$ctrl.maxSize\" onerror=\"$ctrl.onerror(file, errorMessageCode)\" onsuccess=\"$ctrl.onsuccess(files)\" file-type=\"$ctrl.fileType\"></file-picker>\r\n    <span class=\"text-danger field-validation-error\" ng-show=\"$ctrl.fileTooLarge\">\r\n      <span>{{$ctrl.fileTooLargeMessage}}</span>\r\n    </span>\r\n  </div>\r\n  <div class=\"modal-footer\">\r\n    <button class=\"btn btn-cancel\" type=\"button\" ng-click=\"$ctrl.cancel()\" data-i18n=\"Button_Cancel\"></button>\r\n  </div>\r\n</div>");
$templateCache.put("/App/core/directives/filePicker/filePickerPreview.html","<div class=\"file-picker-img\">\r\n    <div class=\"image-wrapper\">\r\n        <a href=\"#\" ng-click=\"onClick()\">\r\n            <img width=\"150\" height=\"100\" title=\"{{title}}\" />\r\n        </a>\r\n\r\n        <button type=\"button\" class=\"btn btn-primary btn-clear-image\" ng-click=\"clear()\" ng-show=\"newImageSelected\">\r\n            <span class=\"glyphicon glyphicon-remove\"></span>\r\n        </button>\r\n    </div>\r\n</div>");
$templateCache.put("/App/core/directives/imagePicker/imagePicker.html","<div class=\"input-group\" data-viewname=\"Generic\">\r\n    <div style=\"position: relative;\" class=\"container-fluid-max\">\r\n        <div ng-repeat=\"img in images track by $index\" class=\"image-wrapper\" style=\"float: left; position: relative; margin: 5px;\">\r\n            <div style=\"position: absolute; top: 0; right: 0;\" ng-if=\"readonly !== true\">\r\n                <button type=\"button\" ng-class=\"getDeleteButtonClass($index)\" ng-click=\"clearImages($index)\" ng-disabled=\"!img.canDelete\">\r\n                    <span ng-class=\"getImageClass($index)\"></span>\r\n                </button>   \r\n            </div>\r\n            <img src=\"{{img.data}}\" width=\"150\" height=\"100\"/>\r\n        </div>\r\n\r\n        <div class=\"image-wrapper\" id=\"imgAdd\" style=\"float: left; position: relative; margin: 5px;\" ng-if=\"readonly !== true\">\r\n            <a href=\"#\" ng-click=\"onClick()\">\r\n                <img width=\"150\" height=\"100\" title=\"{{images.length}}\" src=\"/content/images/Add_Pencil_Green.ico\" class=\"img-responsive\"/>\r\n            </a>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("/App/core/directives/keyValue/keyValue.html","<div class=\"label-group\" ng-repeat=\"(key, value)  in keyValuePairs\">\r\n    <label>{{key}}</label>\r\n    <div class=\"labelValue \" ng-class=\"value.extraClass\" ng-bind-html=\"value.content\"></div>\r\n</div>\r\n");
$templateCache.put("/App/core/directives/panel/panel.html","<div class=\"panel panel-default {{panelClass}}\">\r\n    <img class=\"panel-hero\" ng-show=\"panelHeroImg && panelHeroImg.length > 0\" ng-src=\"{{panelHeroImg}}\" />\r\n    <div class=\"panel-heading\">\r\n        <h3 class=\"panel-title\">{{panelTitle}}</h3>\r\n        <div ng-if=\"panelSubTitle.length > 0\" class=\"panel-sub-title\">{{panelSubTitle}}</div>\r\n    </div>\r\n    <div class=\"panel-body\" ng-transclude>\r\n\r\n    </div>\r\n</div>\r\n");
$templateCache.put("/App/core/directives/passwordStrength/passwordStrength.html","<div>\r\n    <!-- This little line of yuk is required for Chrome and it\'s autofill shenanigans -->\r\n    <!-- You see, Chrome tries to suggest passwords in the password field which covers the strength indicator. A hidden password field is a disgusting workaround, but it works -->\r\n    <input type=\"password\" name=\"password\" class=\"hidden\">\r\n    <div ng-transclude></div>\r\n    <div class=\"password-strength-container\">\r\n        <div class=\"password-strength text-capitalize {{strengthClass}}\">{{currLabel}}</div>\r\n        <span class=\"sub-text\">{{infoLabel}}</span>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("/App/core/directives/timeSlotPlanner/timeSlotPlanner.html","<div>\r\n    <div ng-if=\"expandToPlan\">\r\n        <div class=\"label-group\">\r\n            <label data-i18n=\"{{titleResource}}\"></label>\r\n            <div ng-hide=\"planMode\" class=\"labelValue\">\r\n                <a href=\"\" ng-click=\"expandPlanner()\">\r\n                    <span ng-hide=\"ngModel\" data-i18n=\"Link_PlanAppointment\"></span>\r\n                    <span ng-show=\"ngModel && ngModel.Date.isValid()\">{{ngModel.Date.toDate() | date : \'d MMMM yyyy\'}} {{ngModel.Description}}</span>\r\n                    <span ng-show=\"ngModel && !ngModel.Date.isValid()\">{{ngModel.Description}}</span>\r\n                </a>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"modal fade\" id=\"inspectionModal{{$id}}\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"inspectionModalLabel\">\r\n        <div class=\"modal-dialog inspection-dialog\" role=\"document\">\r\n            <div class=\"modal-content\">\r\n                <div class=\"modal-header\">\r\n                    <h4 class=\"modal-title\" id=\"inspectionModalLabel\" ng-hide=\"!calendarShown\">Kies een tijd</h4>\r\n                    <h4 class=\"modal-title\" id=\"inspectionModalLabel\" ng-hide=\"calendarShown\">Kies een dag</h4>\r\n                </div>\r\n                <div class=\"modal-body\">\r\n                    <div ng-hide=\"calendarShown\">\r\n                        <div ng-model=\"selectedDate\" ng-change=\"dateChanged()\" datetime-picker config=\"datePickerConfig\" />\r\n                        <button type=\"button\" class=\"btn btn-primary\" ng-click=\"calendarShown = true;\">Kies tijd</button>\r\n                    </div>\r\n                    <div ng-hide=\"!calendarShown\">\r\n                        <div ng-show=\"timeSlots != null\" class=\"list-group\">\r\n                            <a class=\"list-group-item\" ng-repeat=\"slot in timeSlots\" ng-class=\"{selected: ngModel.TimeSlot == slot.Item}\" href=\"\" ng-click=\"selectTimeSlot(slot)\">{{slot.Description}}</a>\r\n                        </div>\r\n                        <div ng-show=\"timeSlots == null && !timeSlotsLoading\" class=\"list-group\">\r\n                            <span data-i18n=\"Label_NoAvailableTimeSlots\"></span>\r\n                        </div>\r\n                        <div ng-show=\"timeSlotsLoading\" class=\"list-group\">\r\n                            <span data-i18n=\"Label_TimeSlotsLoading\"></span>\r\n                        </div>\r\n                        <button type=\"button\" class=\"btn btn-primary\" ng-click=\"calendarShown = false;\">Verander dag</button>\r\n                    </div>\r\n                </div>\r\n                <div class=\"modal-footer\">\r\n                    <button type=\"button\" data-dismiss=\"modal\" class=\"btn btn-primary\" data-i18n=\"Button_Cancel\"></button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <div ng-show=\"!usePopup && (!expandToPlan || planMode)\" class=\"visible-xs-inline\">\r\n        <div class=\"embedded-planner\">\r\n            <div class=\"modal-header\">\r\n                <h4 class=\"modal-title\" id=\"inspectionModalLabel\" ng-hide=\"!calendarShown\">Kies een tijd</h4>\r\n                <h4 class=\"modal-title\" id=\"inspectionModalLabel\" ng-hide=\"calendarShown\">Kies een dag</h4>\r\n            </div>\r\n            <div>\r\n                <div ng-hide=\"calendarShown\">\r\n                    <div ng-model=\"selectedDate\" ng-change=\"dateChanged()\" datetime-picker config=\"datePickerConfig\" />\r\n                    <button type=\"button\" class=\"btn btn-primary\" ng-click=\"calendarShown = true;\">Kies tijd</button>\r\n                </div>\r\n                <div ng-hide=\"!calendarShown\">\r\n                    <div ng-show=\"timeSlots != null\" class=\"list-group\">\r\n                        <a class=\"list-group-item\" ng-repeat=\"slot in timeSlots\" ng-class=\"{selected: ngModel.TimeSlot == slot.Item}\" href=\"\" ng-click=\"selectTimeSlot(slot)\">{{slot.Description}}</a>\r\n                    </div>\r\n                    <div ng-show=\"timeSlots == null && !timeSlotsLoading\" class=\"list-group\">\r\n                        <span data-i18n=\"Label_NoAvailableTimeSlots\"></span>\r\n                    </div>\r\n                    <div ng-show=\"timeSlotsLoading\" class=\"list-group\">\r\n                        <span data-i18n=\"Label_TimeSlotsLoading\"></span>\r\n                    </div>\r\n                    <button type=\"button\" class=\"btn btn-primary\" ng-click=\"calendarShown = false;\">Verander dag</button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <div ng-show=\"!expandToPlan || planMode\" class=\"hidden-xs\">\r\n        <div class=\"form-group\">\r\n            <div ng-show=\"timeSlotDuration\" class=\"row col-xs-12 clearfix\">\r\n                <span>{{timeSlotDuration}}</span>\r\n            </div>\r\n            <div class=\"row\">\r\n                <div class=\"col-xs-12 col-sm-6 clearfix\" ng-model=\"selectedDate\" ng-change=\"dateChanged()\" datetime-picker config=\"datePickerConfig\" />\r\n\r\n                <div class=\"col-xs-12 col-sm-6\">\r\n                    <div ng-show=\"timeSlots != null\" class=\"list-group\">\r\n                        <a class=\"list-group-item\" ng-repeat=\"slot in timeSlots\" ng-class=\"{selected: ngModel.TimeSlot == slot.Item}\" href=\"\" ng-click=\"selectTimeSlot(slot)\">{{slot.Description}}</a>\r\n                    </div>\r\n                    <div ng-show=\"timeSlots == null && !timeSlotsLoading\" class=\"list-group\">\r\n                        <span data-i18n=\"Label_NoAvailableTimeSlots\"></span>\r\n                    </div>\r\n                    <div ng-show=\"timeSlotsLoading\" class=\"list-group\">\r\n                        <span data-i18n=\"Label_TimeSlotsLoading\"></span>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div ng-show=\"expandToPlan\" class=\"row\">\r\n                <div class=\"col-xs-12\">\r\n                    <button type=\"button\" ng-click=\"collapsePlanner()\" class=\"btn btn-primary\" data-i18n=\"Button_Cancel\"></button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n");
$templateCache.put("/App/core/directives/tooltip/tooltip.html","<a tabindex=\"-1\" ng-show=\"tooltipContent\" class=\"btn btn-icon icon_info_light\" role=\"button\" data-placement=\"{{tooltipPlacement}}\" data-type=\"{{tooltipType}}\" data-toggle=\"custompopover\" data-trigger=\"focus\" data-content=\"{{tooltipContent}}\"></a>");
$templateCache.put("/App/core/components/common/repairmentPhotosAndDefectDescription/repairmentPhotosAndDefectDescription.html","<div data-viewname=\"RepairmentPhotosAndDefectDescription\" ng-cloak>\r\n    <div class=\"input-group\">\r\n        <label data-i18n=\"Details_UploadPhotos\"></label>\r\n        <image-picker images=\"images\" max-number-of-images=\"12\"\r\n                      file-too-large-message=\"Message_FileTooLarge\"\r\n                      invalid-file-extension=\"Error_NotAnImage\"\r\n                      modal-title=\"Title_Upload_Images\"\r\n                      info-text=\"Text_MaxFileSize\"\r\n                      view-name=\"FilePicker\"\r\n                      file-type=\"image/*\"\r\n                      auto-close=\"true\"\r\n                      readonly=\"readonly === true\">\r\n        </image-picker>\r\n    </div>\r\n\r\n    <div class=\"input-group input-group-unstyled\">\r\n        <div class=\"form-group has-feedback\">\r\n            <label for=\"extraDescription\" data-i18n=\"Details_AdditionalDescription\"></label>\r\n            <textarea rows=\"4\" class=\"form-control\" name=\"extraDescription\" ng-model=\"defectDescription\" ng-required=\"descriptionRequired\" ng-maxlength=\"400\" data-i18n-attr=\"Input_Placeholder_Description|placeholder\" ng-readonly=\"readonly === true\"></textarea>\r\n            <span class=\"icon_ form-control-feedback\" style=\"right: 10px !important\"></span>\r\n\r\n            <div ng-messages=\"form.extraDescription.$error\" class=\"text-danger\" ng-show=\"form.extraDescription.$dirty||form.$submitted\">\r\n                <div ng-message=\"required\"><span data-i18n=\"Validation_RequiredField\"></span></div>\r\n                <div ng-message=\"maxlength\"><span data-i18n=\"Validation_MaxLengthExtraDescription\"></span></div>\r\n            </div>\r\n        </div>\r\n\r\n        <tooltip class=\"input-group-addon no-horizontal-padding\" placement=\"bottom\" data-i18n-attr=\"Tooltip_ExtraDescription|content\" />\r\n    </div>\r\n</div>\r\n");}]);